var fr = Object.defineProperty;
var dr = (o, s, u) => s in o ? fr(o, s, { enumerable: !0, configurable: !0, writable: !0, value: u }) : o[s] = u;
var ir = (o, s, u) => (dr(o, typeof s != "symbol" ? s + "" : s, u), u);
import { jsx, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
import React$1, { useState, useMemo, useCallback, useEffect, createContext, useRef, useLayoutEffect, useContext, memo, forwardRef, Component, createElement as createElement$1, Fragment, cloneElement, Children as Children$1, isValidElement, useDebugValue } from "react";
import ReactDOM from "react-dom";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject$6(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function isPlainObject$2(o) {
  var s, u;
  return isObject$6(o) === !1 ? !1 : (s = o.constructor, s === void 0 ? !0 : (u = s.prototype, !(isObject$6(u) === !1 || u.hasOwnProperty("isPrototypeOf") === !1)));
}
var NOTHING = Symbol.for("immer-nothing"), DRAFTABLE = Symbol.for("immer-draftable"), DRAFT_STATE = Symbol.for("immer-state"), errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(o) {
    return `The plugin for '${o}' has not been loaded into Immer. To enable the plugin, import and call \`enable${o}()\` when initializing your application.`;
  },
  function(o) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${o}'`;
  },
  "This object has been frozen and should not be mutated",
  function(o) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + o;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(o) {
    return `'current' expects a draft, got: ${o}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(o) {
    return `'original' expects a draft, got: ${o}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(o, ...s) {
  if (process.env.NODE_ENV !== "production") {
    const u = errors[o], l = typeof u == "function" ? u.apply(null, s) : u;
    throw new Error(`[Immer] ${l}`);
  }
  throw new Error(`[Immer] minified error nr: ${o}. Full error at: https://bit.ly/3cXEKWf`);
}
var getPrototypeOf$1 = Object.getPrototypeOf;
function isDraft(o) {
  return !!o && !!o[DRAFT_STATE];
}
function isDraftable(o) {
  var s;
  return o ? isPlainObject$1(o) || Array.isArray(o) || !!o[DRAFTABLE] || !!((s = o.constructor) != null && s[DRAFTABLE]) || isMap(o) || isSet(o) : !1;
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject$1(o) {
  if (!o || typeof o != "object")
    return !1;
  const s = getPrototypeOf$1(o);
  if (s === null)
    return !0;
  const u = Object.hasOwnProperty.call(s, "constructor") && s.constructor;
  return u === Object ? !0 : typeof u == "function" && Function.toString.call(u) === objectCtorString;
}
function each(o, s) {
  getArchtype(o) === 0 ? Reflect.ownKeys(o).forEach((u) => {
    s(u, o[u], o);
  }) : o.forEach((u, l) => s(l, u, o));
}
function getArchtype(o) {
  const s = o[DRAFT_STATE];
  return s ? s.type_ : Array.isArray(o) ? 1 : isMap(o) ? 2 : isSet(o) ? 3 : 0;
}
function has$1(o, s) {
  return getArchtype(o) === 2 ? o.has(s) : Object.prototype.hasOwnProperty.call(o, s);
}
function set(o, s, u) {
  const l = getArchtype(o);
  l === 2 ? o.set(s, u) : l === 3 ? o.add(u) : o[s] = u;
}
function is(o, s) {
  return o === s ? o !== 0 || 1 / o === 1 / s : o !== o && s !== s;
}
function isMap(o) {
  return o instanceof Map;
}
function isSet(o) {
  return o instanceof Set;
}
function latest(o) {
  return o.copy_ || o.base_;
}
function shallowCopy(o, s) {
  if (isMap(o))
    return new Map(o);
  if (isSet(o))
    return new Set(o);
  if (Array.isArray(o))
    return Array.prototype.slice.call(o);
  const u = isPlainObject$1(o);
  if (s === !0 || s === "class_only" && !u) {
    const l = Object.getOwnPropertyDescriptors(o);
    delete l[DRAFT_STATE];
    let h = Reflect.ownKeys(l);
    for (let m = 0; m < h.length; m++) {
      const C = h[m], O = l[C];
      O.writable === !1 && (O.writable = !0, O.configurable = !0), (O.get || O.set) && (l[C] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: O.enumerable,
        value: o[C]
      });
    }
    return Object.create(getPrototypeOf$1(o), l);
  } else {
    const l = getPrototypeOf$1(o);
    if (l !== null && u)
      return {
        ...o
      };
    const h = Object.create(l);
    return Object.assign(h, o);
  }
}
function freeze(o, s = !1) {
  return isFrozen(o) || isDraft(o) || !isDraftable(o) || (getArchtype(o) > 1 && (o.set = o.add = o.clear = o.delete = dontMutateFrozenCollections), Object.freeze(o), s && Object.entries(o).forEach(([u, l]) => freeze(l, !0))), o;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(o) {
  return Object.isFrozen(o);
}
var plugins$1 = {};
function getPlugin(o) {
  const s = plugins$1[o];
  return s || die(0, o), s;
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(o, s) {
  return {
    drafts_: [],
    parent_: o,
    immer_: s,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(o, s) {
  s && (getPlugin("Patches"), o.patches_ = [], o.inversePatches_ = [], o.patchListener_ = s);
}
function revokeScope(o) {
  leaveScope(o), o.drafts_.forEach(revokeDraft), o.drafts_ = null;
}
function leaveScope(o) {
  o === currentScope && (currentScope = o.parent_);
}
function enterScope(o) {
  return currentScope = createScope(currentScope, o);
}
function revokeDraft(o) {
  const s = o[DRAFT_STATE];
  s.type_ === 0 || s.type_ === 1 ? s.revoke_() : s.revoked_ = !0;
}
function processResult(o, s) {
  s.unfinalizedDrafts_ = s.drafts_.length;
  const u = s.drafts_[0];
  return o !== void 0 && o !== u ? (u[DRAFT_STATE].modified_ && (revokeScope(s), die(4)), isDraftable(o) && (o = finalize(s, o), s.parent_ || maybeFreeze(s, o)), s.patches_ && getPlugin("Patches").generateReplacementPatches_(u[DRAFT_STATE].base_, o, s.patches_, s.inversePatches_)) : o = finalize(s, u, []), revokeScope(s), s.patches_ && s.patchListener_(s.patches_, s.inversePatches_), o !== NOTHING ? o : void 0;
}
function finalize(o, s, u) {
  if (isFrozen(s))
    return s;
  const l = s[DRAFT_STATE];
  if (!l)
    return each(s, (h, m) => finalizeProperty(o, l, s, h, m, u)), s;
  if (l.scope_ !== o)
    return s;
  if (!l.modified_)
    return maybeFreeze(o, l.base_, !0), l.base_;
  if (!l.finalized_) {
    l.finalized_ = !0, l.scope_.unfinalizedDrafts_--;
    const h = l.copy_;
    let m = h, C = !1;
    l.type_ === 3 && (m = new Set(h), h.clear(), C = !0), each(m, (O, le) => finalizeProperty(o, l, h, O, le, u, C)), maybeFreeze(o, h, !1), u && o.patches_ && getPlugin("Patches").generatePatches_(l, u, o.patches_, o.inversePatches_);
  }
  return l.copy_;
}
function finalizeProperty(o, s, u, l, h, m, C) {
  if (process.env.NODE_ENV !== "production" && h === u && die(5), isDraft(h)) {
    const O = m && s && s.type_ !== 3 && // Set objects are atomic since they have no keys.
    !has$1(s.assigned_, l) ? m.concat(l) : void 0, le = finalize(o, h, O);
    if (set(u, l, le), isDraft(le))
      o.canAutoFreeze_ = !1;
    else
      return;
  } else
    C && u.add(h);
  if (isDraftable(h) && !isFrozen(h)) {
    if (!o.immer_.autoFreeze_ && o.unfinalizedDrafts_ < 1)
      return;
    finalize(o, h), (!s || !s.scope_.parent_) && typeof l != "symbol" && Object.prototype.propertyIsEnumerable.call(u, l) && maybeFreeze(o, h);
  }
}
function maybeFreeze(o, s, u = !1) {
  !o.parent_ && o.immer_.autoFreeze_ && o.canAutoFreeze_ && freeze(s, u);
}
function createProxyProxy(o, s) {
  const u = Array.isArray(o), l = {
    type_: u ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: s ? s.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: s,
    // The base state.
    base_: o,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let h = l, m = objectTraps;
  u && (h = [l], m = arrayTraps);
  const {
    revoke: C,
    proxy: O
  } = Proxy.revocable(h, m);
  return l.draft_ = O, l.revoke_ = C, O;
}
var objectTraps = {
  get(o, s) {
    if (s === DRAFT_STATE)
      return o;
    const u = latest(o);
    if (!has$1(u, s))
      return readPropFromProto(o, u, s);
    const l = u[s];
    return o.finalized_ || !isDraftable(l) ? l : l === peek(o.base_, s) ? (prepareCopy(o), o.copy_[s] = createProxy(l, o)) : l;
  },
  has(o, s) {
    return s in latest(o);
  },
  ownKeys(o) {
    return Reflect.ownKeys(latest(o));
  },
  set(o, s, u) {
    const l = getDescriptorFromProto(latest(o), s);
    if (l != null && l.set)
      return l.set.call(o.draft_, u), !0;
    if (!o.modified_) {
      const h = peek(latest(o), s), m = h == null ? void 0 : h[DRAFT_STATE];
      if (m && m.base_ === u)
        return o.copy_[s] = u, o.assigned_[s] = !1, !0;
      if (is(u, h) && (u !== void 0 || has$1(o.base_, s)))
        return !0;
      prepareCopy(o), markChanged(o);
    }
    return o.copy_[s] === u && // special case: handle new props with value 'undefined'
    (u !== void 0 || s in o.copy_) || // special case: NaN
    Number.isNaN(u) && Number.isNaN(o.copy_[s]) || (o.copy_[s] = u, o.assigned_[s] = !0), !0;
  },
  deleteProperty(o, s) {
    return peek(o.base_, s) !== void 0 || s in o.base_ ? (o.assigned_[s] = !1, prepareCopy(o), markChanged(o)) : delete o.assigned_[s], o.copy_ && delete o.copy_[s], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(o, s) {
    const u = latest(o), l = Reflect.getOwnPropertyDescriptor(u, s);
    return l && {
      writable: !0,
      configurable: o.type_ !== 1 || s !== "length",
      enumerable: l.enumerable,
      value: u[s]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(o) {
    return getPrototypeOf$1(o.base_);
  },
  setPrototypeOf() {
    die(12);
  }
}, arrayTraps = {};
each(objectTraps, (o, s) => {
  arrayTraps[o] = function() {
    return arguments[0] = arguments[0][0], s.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(o, s) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(s)) && die(13), arrayTraps.set.call(this, o, s, void 0);
};
arrayTraps.set = function(o, s, u) {
  return process.env.NODE_ENV !== "production" && s !== "length" && isNaN(parseInt(s)) && die(14), objectTraps.set.call(this, o[0], s, u, o[0]);
};
function peek(o, s) {
  const u = o[DRAFT_STATE];
  return (u ? latest(u) : o)[s];
}
function readPropFromProto(o, s, u) {
  var h;
  const l = getDescriptorFromProto(s, u);
  return l ? "value" in l ? l.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (h = l.get) == null ? void 0 : h.call(o.draft_)
  ) : void 0;
}
function getDescriptorFromProto(o, s) {
  if (!(s in o))
    return;
  let u = getPrototypeOf$1(o);
  for (; u; ) {
    const l = Object.getOwnPropertyDescriptor(u, s);
    if (l)
      return l;
    u = getPrototypeOf$1(u);
  }
}
function markChanged(o) {
  o.modified_ || (o.modified_ = !0, o.parent_ && markChanged(o.parent_));
}
function prepareCopy(o) {
  o.copy_ || (o.copy_ = shallowCopy(o.base_, o.scope_.immer_.useStrictShallowCopy_));
}
var Immer2 = class {
  constructor(o) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (s, u, l) => {
      if (typeof s == "function" && typeof u != "function") {
        const m = u;
        u = s;
        const C = this;
        return function(le = m, ...We) {
          return C.produce(le, (ye) => u.call(this, ye, ...We));
        };
      }
      typeof u != "function" && die(6), l !== void 0 && typeof l != "function" && die(7);
      let h;
      if (isDraftable(s)) {
        const m = enterScope(this), C = createProxy(s, void 0);
        let O = !0;
        try {
          h = u(C), O = !1;
        } finally {
          O ? revokeScope(m) : leaveScope(m);
        }
        return usePatchesInScope(m, l), processResult(h, m);
      } else if (!s || typeof s != "object") {
        if (h = u(s), h === void 0 && (h = s), h === NOTHING && (h = void 0), this.autoFreeze_ && freeze(h, !0), l) {
          const m = [], C = [];
          getPlugin("Patches").generateReplacementPatches_(s, h, m, C), l(m, C);
        }
        return h;
      } else
        die(1, s);
    }, this.produceWithPatches = (s, u) => {
      if (typeof s == "function")
        return (C, ...O) => this.produceWithPatches(C, (le) => s(le, ...O));
      let l, h;
      return [this.produce(s, u, (C, O) => {
        l = C, h = O;
      }), l, h];
    }, typeof (o == null ? void 0 : o.autoFreeze) == "boolean" && this.setAutoFreeze(o.autoFreeze), typeof (o == null ? void 0 : o.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(o.useStrictShallowCopy);
  }
  createDraft(o) {
    isDraftable(o) || die(8), isDraft(o) && (o = current(o));
    const s = enterScope(this), u = createProxy(o, void 0);
    return u[DRAFT_STATE].isManual_ = !0, leaveScope(s), u;
  }
  finishDraft(o, s) {
    const u = o && o[DRAFT_STATE];
    (!u || !u.isManual_) && die(9);
    const {
      scope_: l
    } = u;
    return usePatchesInScope(l, s), processResult(void 0, l);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(o) {
    this.autoFreeze_ = o;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(o) {
    this.useStrictShallowCopy_ = o;
  }
  applyPatches(o, s) {
    let u;
    for (u = s.length - 1; u >= 0; u--) {
      const h = s[u];
      if (h.path.length === 0 && h.op === "replace") {
        o = h.value;
        break;
      }
    }
    u > -1 && (s = s.slice(u + 1));
    const l = getPlugin("Patches").applyPatches_;
    return isDraft(o) ? l(o, s) : this.produce(o, (h) => l(h, s));
  }
};
function createProxy(o, s) {
  const u = isMap(o) ? getPlugin("MapSet").proxyMap_(o, s) : isSet(o) ? getPlugin("MapSet").proxySet_(o, s) : createProxyProxy(o, s);
  return (s ? s.scope_ : getCurrentScope()).drafts_.push(u), u;
}
function current(o) {
  return isDraft(o) || die(10, o), currentImpl(o);
}
function currentImpl(o) {
  if (!isDraftable(o) || isFrozen(o))
    return o;
  const s = o[DRAFT_STATE];
  let u;
  if (s) {
    if (!s.modified_)
      return s.base_;
    s.finalized_ = !0, u = shallowCopy(o, s.scope_.immer_.useStrictShallowCopy_);
  } else
    u = shallowCopy(o, !0);
  return each(u, (l, h) => {
    set(u, l, currentImpl(h));
  }), s && (s.finalized_ = !1), u;
}
var immer = new Immer2(), produce = immer.produce;
immer.produceWithPatches.bind(immer);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer), finishDraft = immer.finishDraft.bind(immer), PathRef = {
  transform(o, s) {
    var {
      current: u,
      affinity: l
    } = o;
    if (u != null) {
      var h = Path.transform(u, s, {
        affinity: l
      });
      o.current = h, h == null && o.unref();
    }
  }
}, PointRef = {
  transform(o, s) {
    var {
      current: u,
      affinity: l
    } = o;
    if (u != null) {
      var h = Point$1.transform(u, s, {
        affinity: l
      });
      o.current = h, h == null && o.unref();
    }
  }
}, RangeRef = {
  transform(o, s) {
    var {
      current: u,
      affinity: l
    } = o;
    if (u != null) {
      var h = Range.transform(u, s, {
        affinity: l
      });
      o.current = h, h == null && o.unref();
    }
  }
}, DIRTY_PATHS = /* @__PURE__ */ new WeakMap(), DIRTY_PATH_KEYS = /* @__PURE__ */ new WeakMap(), FLUSHING = /* @__PURE__ */ new WeakMap(), NORMALIZING = /* @__PURE__ */ new WeakMap(), PATH_REFS = /* @__PURE__ */ new WeakMap(), POINT_REFS = /* @__PURE__ */ new WeakMap(), RANGE_REFS = /* @__PURE__ */ new WeakMap(), Path = {
  ancestors(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: u = !1
    } = s, l = Path.levels(o, s);
    return u ? l = l.slice(1) : l = l.slice(0, -1), l;
  },
  common(o, s) {
    for (var u = [], l = 0; l < o.length && l < s.length; l++) {
      var h = o[l], m = s[l];
      if (h !== m)
        break;
      u.push(h);
    }
    return u;
  },
  compare(o, s) {
    for (var u = Math.min(o.length, s.length), l = 0; l < u; l++) {
      if (o[l] < s[l])
        return -1;
      if (o[l] > s[l])
        return 1;
    }
    return 0;
  },
  endsAfter(o, s) {
    var u = o.length - 1, l = o.slice(0, u), h = s.slice(0, u), m = o[u], C = s[u];
    return Path.equals(l, h) && m > C;
  },
  endsAt(o, s) {
    var u = o.length, l = o.slice(0, u), h = s.slice(0, u);
    return Path.equals(l, h);
  },
  endsBefore(o, s) {
    var u = o.length - 1, l = o.slice(0, u), h = s.slice(0, u), m = o[u], C = s[u];
    return Path.equals(l, h) && m < C;
  },
  equals(o, s) {
    return o.length === s.length && o.every((u, l) => u === s[l]);
  },
  hasPrevious(o) {
    return o[o.length - 1] > 0;
  },
  isAfter(o, s) {
    return Path.compare(o, s) === 1;
  },
  isAncestor(o, s) {
    return o.length < s.length && Path.compare(o, s) === 0;
  },
  isBefore(o, s) {
    return Path.compare(o, s) === -1;
  },
  isChild(o, s) {
    return o.length === s.length + 1 && Path.compare(o, s) === 0;
  },
  isCommon(o, s) {
    return o.length <= s.length && Path.compare(o, s) === 0;
  },
  isDescendant(o, s) {
    return o.length > s.length && Path.compare(o, s) === 0;
  },
  isParent(o, s) {
    return o.length + 1 === s.length && Path.compare(o, s) === 0;
  },
  isPath(o) {
    return Array.isArray(o) && (o.length === 0 || typeof o[0] == "number");
  },
  isSibling(o, s) {
    if (o.length !== s.length)
      return !1;
    var u = o.slice(0, -1), l = s.slice(0, -1), h = o[o.length - 1], m = s[s.length - 1];
    return h !== m && Path.equals(u, l);
  },
  levels(o) {
    for (var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: u = !1
    } = s, l = [], h = 0; h <= o.length; h++)
      l.push(o.slice(0, h));
    return u && l.reverse(), l;
  },
  next(o) {
    if (o.length === 0)
      throw new Error("Cannot get the next path of a root path [".concat(o, "], because it has no next index."));
    var s = o[o.length - 1];
    return o.slice(0, -1).concat(s + 1);
  },
  operationCanTransformPath(o) {
    switch (o.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return !0;
      default:
        return !1;
    }
  },
  parent(o) {
    if (o.length === 0)
      throw new Error("Cannot get the parent path of the root path [".concat(o, "]."));
    return o.slice(0, -1);
  },
  previous(o) {
    if (o.length === 0)
      throw new Error("Cannot get the previous path of a root path [".concat(o, "], because it has no previous index."));
    var s = o[o.length - 1];
    if (s <= 0)
      throw new Error("Cannot get the previous path of a first child path [".concat(o, "] because it would result in a negative index."));
    return o.slice(0, -1).concat(s - 1);
  },
  relative(o, s) {
    if (!Path.isAncestor(s, o) && !Path.equals(o, s))
      throw new Error("Cannot get the relative path of [".concat(o, "] inside ancestor [").concat(s, "], because it is not above or equal to the path."));
    return o.slice(s.length);
  },
  transform(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!o)
      return null;
    var l = [...o], {
      affinity: h = "forward"
    } = u;
    if (o.length === 0)
      return l;
    switch (s.type) {
      case "insert_node": {
        var {
          path: m
        } = s;
        (Path.equals(m, l) || Path.endsBefore(m, l) || Path.isAncestor(m, l)) && (l[m.length - 1] += 1);
        break;
      }
      case "remove_node": {
        var {
          path: C
        } = s;
        if (Path.equals(C, l) || Path.isAncestor(C, l))
          return null;
        Path.endsBefore(C, l) && (l[C.length - 1] -= 1);
        break;
      }
      case "merge_node": {
        var {
          path: O,
          position: le
        } = s;
        Path.equals(O, l) || Path.endsBefore(O, l) ? l[O.length - 1] -= 1 : Path.isAncestor(O, l) && (l[O.length - 1] -= 1, l[O.length] += le);
        break;
      }
      case "split_node": {
        var {
          path: We,
          position: ye
        } = s;
        if (Path.equals(We, l)) {
          if (h === "forward")
            l[l.length - 1] += 1;
          else if (h !== "backward")
            return null;
        } else
          Path.endsBefore(We, l) ? l[We.length - 1] += 1 : Path.isAncestor(We, l) && o[We.length] >= ye && (l[We.length - 1] += 1, l[We.length] -= ye);
        break;
      }
      case "move_node": {
        var {
          path: Fe,
          newPath: Ue
        } = s;
        if (Path.equals(Fe, Ue))
          return l;
        if (Path.isAncestor(Fe, l) || Path.equals(Fe, l)) {
          var Le = Ue.slice();
          return Path.endsBefore(Fe, Ue) && Fe.length < Ue.length && (Le[Fe.length - 1] -= 1), Le.concat(l.slice(Fe.length));
        } else
          Path.isSibling(Fe, Ue) && (Path.isAncestor(Ue, l) || Path.equals(Ue, l)) ? Path.endsBefore(Fe, l) ? l[Fe.length - 1] -= 1 : l[Fe.length - 1] += 1 : Path.endsBefore(Ue, l) || Path.equals(Ue, l) || Path.isAncestor(Ue, l) ? (Path.endsBefore(Fe, l) && (l[Fe.length - 1] -= 1), l[Ue.length - 1] += 1) : Path.endsBefore(Fe, l) && (Path.equals(Ue, l) && (l[Ue.length - 1] += 1), l[Fe.length - 1] -= 1);
        break;
      }
    }
    return l;
  }
};
function _typeof$3(o) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$3(o);
}
function _toPrimitive(o, s) {
  if (_typeof$3(o) !== "object" || o === null)
    return o;
  var u = o[Symbol.toPrimitive];
  if (u !== void 0) {
    var l = u.call(o, s || "default");
    if (_typeof$3(l) !== "object")
      return l;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (s === "string" ? String : Number)(o);
}
function _toPropertyKey(o) {
  var s = _toPrimitive(o, "string");
  return _typeof$3(s) === "symbol" ? s : String(s);
}
function _defineProperty$4(o, s, u) {
  return s = _toPropertyKey(s), s in o ? Object.defineProperty(o, s, {
    value: u,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[s] = u, o;
}
function ownKeys$e(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$e(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$e(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$e(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var applyToDraft = (o, s, u) => {
  switch (u.type) {
    case "insert_node": {
      var {
        path: l,
        node: h
      } = u, m = Node.parent(o, l), C = l[l.length - 1];
      if (C > m.children.length)
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(l, "] because the destination is past the end of the node."));
      if (m.children.splice(C, 0, h), s)
        for (var [O, le] of Range.points(s))
          s[le] = Point$1.transform(O, u);
      break;
    }
    case "insert_text": {
      var {
        path: We,
        offset: ye,
        text: Fe
      } = u;
      if (Fe.length === 0)
        break;
      var Ue = Node.leaf(o, We), Le = Ue.text.slice(0, ye), Ze = Ue.text.slice(ye);
      if (Ue.text = Le + Fe + Ze, s)
        for (var [Xe, Je] of Range.points(s))
          s[Je] = Point$1.transform(Xe, u);
      break;
    }
    case "merge_node": {
      var {
        path: it
      } = u, et = Node.get(o, it), at = Path.previous(it), $e = Node.get(o, at), Ke = Node.parent(o, it), tt = it[it.length - 1];
      if (Text$1.isText(et) && Text$1.isText($e))
        $e.text += et.text;
      else if (!Text$1.isText(et) && !Text$1.isText($e))
        $e.children.push(...et.children);
      else
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(it, "] to nodes of different interfaces: ").concat(Scrubber.stringify(et), " ").concat(Scrubber.stringify($e)));
      if (Ke.children.splice(tt, 1), s)
        for (var [ut, st] of Range.points(s))
          s[st] = Point$1.transform(ut, u);
      break;
    }
    case "move_node": {
      var {
        path: ot,
        newPath: ht
      } = u;
      if (Path.isAncestor(ot, ht))
        throw new Error("Cannot move a path [".concat(ot, "] to new path [").concat(ht, "] because the destination is inside itself."));
      var vt = Node.get(o, ot), At = Node.parent(o, ot), gt = ot[ot.length - 1];
      At.children.splice(gt, 1);
      var bt = Path.transform(ot, u), wt = Node.get(o, Path.parent(bt)), Ot = bt[bt.length - 1];
      if (wt.children.splice(Ot, 0, vt), s)
        for (var [yt, Qe] of Range.points(s))
          s[Qe] = Point$1.transform(yt, u);
      break;
    }
    case "remove_node": {
      var {
        path: nt
      } = u, rt = nt[nt.length - 1], lt = Node.parent(o, nt);
      if (lt.children.splice(rt, 1), s)
        for (var [ct, ft] of Range.points(s)) {
          var pt = Point$1.transform(ct, u);
          if (s != null && pt != null)
            s[ft] = pt;
          else {
            var mt = void 0, dt = void 0;
            for (var [Et, Ct] of Node.texts(o))
              if (Path.compare(Ct, nt) === -1)
                mt = [Et, Ct];
              else {
                dt = [Et, Ct];
                break;
              }
            var Tt = !1;
            mt && dt && (Path.equals(dt[1], nt) ? Tt = !Path.hasPrevious(dt[1]) : Tt = Path.common(mt[1], nt).length < Path.common(dt[1], nt).length), mt && !Tt ? (ct.path = mt[1], ct.offset = mt[0].text.length) : dt ? (ct.path = dt[1], ct.offset = 0) : s = null;
          }
        }
      break;
    }
    case "remove_text": {
      var {
        path: qt,
        offset: jt,
        text: St
      } = u;
      if (St.length === 0)
        break;
      var Mt = Node.leaf(o, qt), Dt = Mt.text.slice(0, jt), Nt = Mt.text.slice(jt + St.length);
      if (Mt.text = Dt + Nt, s)
        for (var [Kt, Ft] of Range.points(s))
          s[Ft] = Point$1.transform(Kt, u);
      break;
    }
    case "set_node": {
      var {
        path: Bt,
        properties: $t,
        newProperties: Gt
      } = u;
      if (Bt.length === 0)
        throw new Error("Cannot set properties on the root node!");
      var Jt = Node.get(o, Bt);
      for (var er in Gt) {
        if (er === "children" || er === "text")
          throw new Error('Cannot set the "'.concat(er, '" property of nodes!'));
        var Ht = Gt[er];
        Ht == null ? delete Jt[er] : Jt[er] = Ht;
      }
      for (var zt in $t)
        Gt.hasOwnProperty(zt) || delete Jt[zt];
      break;
    }
    case "set_selection": {
      var {
        newProperties: Xt
      } = u;
      if (Xt == null)
        s = Xt;
      else {
        if (s == null) {
          if (!Range.isRange(Xt))
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(Scrubber.stringify(Xt), " when there is no current selection."));
          s = _objectSpread$e({}, Xt);
        }
        for (var Vt in Xt) {
          var Yt = Xt[Vt];
          if (Yt == null) {
            if (Vt === "anchor" || Vt === "focus")
              throw new Error('Cannot remove the "'.concat(Vt, '" selection property'));
            delete s[Vt];
          } else
            s[Vt] = Yt;
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: Rt,
        position: kt,
        properties: Zt
      } = u;
      if (Rt.length === 0)
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(Rt, "] because the root node cannot be split."));
      var Wt = Node.get(o, Rt), xt = Node.parent(o, Rt), It = Rt[Rt.length - 1], Pt;
      if (Text$1.isText(Wt)) {
        var Lt = Wt.text.slice(0, kt), Ut = Wt.text.slice(kt);
        Wt.text = Lt, Pt = _objectSpread$e(_objectSpread$e({}, Zt), {}, {
          text: Ut
        });
      } else {
        var Qt = Wt.children.slice(0, kt), _t = Wt.children.slice(kt);
        Wt.children = Qt, Pt = _objectSpread$e(_objectSpread$e({}, Zt), {}, {
          children: _t
        });
      }
      if (xt.children.splice(It + 1, 0, Pt), s)
        for (var [tr, rr] of Range.points(s))
          s[rr] = Point$1.transform(tr, u);
      break;
    }
  }
  return s;
}, GeneralTransforms = {
  transform(o, s) {
    o.children = createDraft(o.children);
    var u = o.selection && createDraft(o.selection);
    try {
      u = applyToDraft(o, u, s);
    } finally {
      o.children = finishDraft(o.children), u ? o.selection = isDraft(u) ? finishDraft(u) : u : o.selection = null;
    }
  }
}, NodeTransforms = {
  insertNodes(o, s, u) {
    o.insertNodes(s, u);
  },
  liftNodes(o, s) {
    o.liftNodes(s);
  },
  mergeNodes(o, s) {
    o.mergeNodes(s);
  },
  moveNodes(o, s) {
    o.moveNodes(s);
  },
  removeNodes(o, s) {
    o.removeNodes(s);
  },
  setNodes(o, s, u) {
    o.setNodes(s, u);
  },
  splitNodes(o, s) {
    o.splitNodes(s);
  },
  unsetNodes(o, s, u) {
    o.unsetNodes(s, u);
  },
  unwrapNodes(o, s) {
    o.unwrapNodes(s);
  },
  wrapNodes(o, s, u) {
    o.wrapNodes(s, u);
  }
}, SelectionTransforms = {
  collapse(o, s) {
    o.collapse(s);
  },
  deselect(o) {
    o.deselect();
  },
  move(o, s) {
    o.move(s);
  },
  select(o, s) {
    o.select(s);
  },
  setPoint(o, s, u) {
    o.setPoint(s, u);
  },
  setSelection(o, s) {
    o.setSelection(s);
  }
}, isDeepEqual = (o, s) => {
  for (var u in o) {
    var l = o[u], h = s[u];
    if (isPlainObject$2(l) && isPlainObject$2(h)) {
      if (!isDeepEqual(l, h))
        return !1;
    } else if (Array.isArray(l) && Array.isArray(h)) {
      if (l.length !== h.length)
        return !1;
      for (var m = 0; m < l.length; m++)
        if (l[m] !== h[m])
          return !1;
    } else if (l !== h)
      return !1;
  }
  for (var C in s)
    if (o[C] === void 0 && s[C] !== void 0)
      return !1;
  return !0;
};
function _objectWithoutPropertiesLoose$3(o, s) {
  if (o == null)
    return {};
  var u = {}, l = Object.keys(o), h, m;
  for (m = 0; m < l.length; m++)
    h = l[m], !(s.indexOf(h) >= 0) && (u[h] = o[h]);
  return u;
}
function _objectWithoutProperties$3(o, s) {
  if (o == null)
    return {};
  var u = _objectWithoutPropertiesLoose$3(o, s), l, h;
  if (Object.getOwnPropertySymbols) {
    var m = Object.getOwnPropertySymbols(o);
    for (h = 0; h < m.length; h++)
      l = m[h], !(s.indexOf(l) >= 0) && Object.prototype.propertyIsEnumerable.call(o, l) && (u[l] = o[l]);
  }
  return u;
}
var _excluded$4 = ["anchor", "focus"];
function ownKeys$d(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$d(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$d(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$d(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var Range = {
  edges(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: u = !1
    } = s, {
      anchor: l,
      focus: h
    } = o;
    return Range.isBackward(o) === u ? [l, h] : [h, l];
  },
  end(o) {
    var [, s] = Range.edges(o);
    return s;
  },
  equals(o, s) {
    return Point$1.equals(o.anchor, s.anchor) && Point$1.equals(o.focus, s.focus);
  },
  includes(o, s) {
    if (Range.isRange(s)) {
      if (Range.includes(o, s.anchor) || Range.includes(o, s.focus))
        return !0;
      var [u, l] = Range.edges(o), [h, m] = Range.edges(s);
      return Point$1.isBefore(u, h) && Point$1.isAfter(l, m);
    }
    var [C, O] = Range.edges(o), le = !1, We = !1;
    return Point$1.isPoint(s) ? (le = Point$1.compare(s, C) >= 0, We = Point$1.compare(s, O) <= 0) : (le = Path.compare(s, C.path) >= 0, We = Path.compare(s, O.path) <= 0), le && We;
  },
  intersection(o, s) {
    var u = _objectWithoutProperties$3(o, _excluded$4), [l, h] = Range.edges(o), [m, C] = Range.edges(s), O = Point$1.isBefore(l, m) ? m : l, le = Point$1.isBefore(h, C) ? h : C;
    return Point$1.isBefore(le, O) ? null : _objectSpread$d({
      anchor: O,
      focus: le
    }, u);
  },
  isBackward(o) {
    var {
      anchor: s,
      focus: u
    } = o;
    return Point$1.isAfter(s, u);
  },
  isCollapsed(o) {
    var {
      anchor: s,
      focus: u
    } = o;
    return Point$1.equals(s, u);
  },
  isExpanded(o) {
    return !Range.isCollapsed(o);
  },
  isForward(o) {
    return !Range.isBackward(o);
  },
  isRange(o) {
    return isPlainObject$2(o) && Point$1.isPoint(o.anchor) && Point$1.isPoint(o.focus);
  },
  *points(o) {
    yield [o.anchor, "anchor"], yield [o.focus, "focus"];
  },
  start(o) {
    var [s] = Range.edges(o);
    return s;
  },
  transform(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return produce(o, (l) => {
      if (l === null)
        return null;
      var {
        affinity: h = "inward"
      } = u, m, C;
      if (h === "inward") {
        var O = Range.isCollapsed(l);
        Range.isForward(l) ? (m = "forward", C = O ? m : "backward") : (m = "backward", C = O ? m : "forward");
      } else
        h === "outward" ? Range.isForward(l) ? (m = "backward", C = "forward") : (m = "forward", C = "backward") : (m = h, C = h);
      var le = Point$1.transform(l.anchor, s, {
        affinity: m
      }), We = Point$1.transform(l.focus, s, {
        affinity: C
      });
      if (!le || !We)
        return null;
      l.anchor = le, l.focus = We;
    });
  }
}, isElement = (o) => isPlainObject$2(o) && Node.isNodeList(o.children) && !Editor.isEditor(o), Element$3 = {
  isAncestor(o) {
    return isPlainObject$2(o) && Node.isNodeList(o.children);
  },
  isElement,
  isElementList(o) {
    return Array.isArray(o) && o.every((s) => Element$3.isElement(s));
  },
  isElementProps(o) {
    return o.children !== void 0;
  },
  isElementType: function(s, u) {
    var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return isElement(s) && s[l] === u;
  },
  matches(o, s) {
    for (var u in s)
      if (u !== "children" && o[u] !== s[u])
        return !1;
    return !0;
  }
}, _excluded$3 = ["children"], _excluded2$3 = ["text"], IS_NODE_LIST_CACHE = /* @__PURE__ */ new WeakMap(), Node = {
  ancestor(o, s) {
    var u = Node.get(o, s);
    if (Text$1.isText(u))
      throw new Error("Cannot get the ancestor node at path [".concat(s, "] because it refers to a text node instead: ").concat(Scrubber.stringify(u)));
    return u;
  },
  ancestors(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var l of Path.ancestors(s, u)) {
        var h = Node.ancestor(o, l), m = [h, l];
        yield m;
      }
    }();
  },
  child(o, s) {
    if (Text$1.isText(o))
      throw new Error("Cannot get the child of a text node: ".concat(Scrubber.stringify(o)));
    var u = o.children[s];
    if (u == null)
      throw new Error("Cannot get child at index `".concat(s, "` in node: ").concat(Scrubber.stringify(o)));
    return u;
  },
  children(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var {
        reverse: l = !1
      } = u, h = Node.ancestor(o, s), {
        children: m
      } = h, C = l ? m.length - 1 : 0; l ? C >= 0 : C < m.length; ) {
        var O = Node.child(h, C), le = s.concat(C);
        yield [O, le], C = l ? C - 1 : C + 1;
      }
    }();
  },
  common(o, s, u) {
    var l = Path.common(s, u), h = Node.get(o, l);
    return [h, l];
  },
  descendant(o, s) {
    var u = Node.get(o, s);
    if (Editor.isEditor(u))
      throw new Error("Cannot get the descendant node at path [".concat(s, "] because it refers to the root editor node instead: ").concat(Scrubber.stringify(u)));
    return u;
  },
  descendants(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [u, l] of Node.nodes(o, s))
        l.length !== 0 && (yield [u, l]);
    }();
  },
  elements(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [u, l] of Node.nodes(o, s))
        Element$3.isElement(u) && (yield [u, l]);
    }();
  },
  extractProps(o) {
    if (Element$3.isAncestor(o)) {
      var s = _objectWithoutProperties$3(o, _excluded$3);
      return s;
    } else {
      var s = _objectWithoutProperties$3(o, _excluded2$3);
      return s;
    }
  },
  first(o, s) {
    for (var u = s.slice(), l = Node.get(o, u); l && !(Text$1.isText(l) || l.children.length === 0); )
      l = l.children[0], u.push(0);
    return [l, u];
  },
  fragment(o, s) {
    if (Text$1.isText(o))
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(Scrubber.stringify(o)));
    var u = produce({
      children: o.children
    }, (l) => {
      var [h, m] = Range.edges(s), C = Node.nodes(l, {
        reverse: !0,
        pass: (Ue) => {
          var [, Le] = Ue;
          return !Range.includes(s, Le);
        }
      });
      for (var [, O] of C) {
        if (!Range.includes(s, O)) {
          var le = Node.parent(l, O), We = O[O.length - 1];
          le.children.splice(We, 1);
        }
        if (Path.equals(O, m.path)) {
          var ye = Node.leaf(l, O);
          ye.text = ye.text.slice(0, m.offset);
        }
        if (Path.equals(O, h.path)) {
          var Fe = Node.leaf(l, O);
          Fe.text = Fe.text.slice(h.offset);
        }
      }
      Editor.isEditor(l) && (l.selection = null);
    });
    return u.children;
  },
  get(o, s) {
    for (var u = o, l = 0; l < s.length; l++) {
      var h = s[l];
      if (Text$1.isText(u) || !u.children[h])
        throw new Error("Cannot find a descendant at path [".concat(s, "] in node: ").concat(Scrubber.stringify(o)));
      u = u.children[h];
    }
    return u;
  },
  has(o, s) {
    for (var u = o, l = 0; l < s.length; l++) {
      var h = s[l];
      if (Text$1.isText(u) || !u.children[h])
        return !1;
      u = u.children[h];
    }
    return !0;
  },
  isNode(o) {
    return Text$1.isText(o) || Element$3.isElement(o) || Editor.isEditor(o);
  },
  isNodeList(o) {
    if (!Array.isArray(o))
      return !1;
    var s = IS_NODE_LIST_CACHE.get(o);
    if (s !== void 0)
      return s;
    var u = o.every((l) => Node.isNode(l));
    return IS_NODE_LIST_CACHE.set(o, u), u;
  },
  last(o, s) {
    for (var u = s.slice(), l = Node.get(o, u); l && !(Text$1.isText(l) || l.children.length === 0); ) {
      var h = l.children.length - 1;
      l = l.children[h], u.push(h);
    }
    return [l, u];
  },
  leaf(o, s) {
    var u = Node.get(o, s);
    if (!Text$1.isText(u))
      throw new Error("Cannot get the leaf node at path [".concat(s, "] because it refers to a non-leaf node: ").concat(Scrubber.stringify(u)));
    return u;
  },
  levels(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var l of Path.levels(s, u)) {
        var h = Node.get(o, l);
        yield [h, l];
      }
    }();
  },
  matches(o, s) {
    return Element$3.isElement(o) && Element$3.isElementProps(s) && Element$3.matches(o, s) || Text$1.isText(o) && Text$1.isTextProps(s) && Text$1.matches(o, s);
  },
  nodes(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var {
        pass: u,
        reverse: l = !1
      } = s, {
        from: h = [],
        to: m
      } = s, C = /* @__PURE__ */ new Set(), O = [], le = o; !(m && (l ? Path.isBefore(O, m) : Path.isAfter(O, m))); ) {
        if (C.has(le) || (yield [le, O]), !C.has(le) && !Text$1.isText(le) && le.children.length !== 0 && (u == null || u([le, O]) === !1)) {
          C.add(le);
          var We = l ? le.children.length - 1 : 0;
          Path.isAncestor(O, h) && (We = h[O.length]), O = O.concat(We), le = Node.get(o, O);
          continue;
        }
        if (O.length === 0)
          break;
        if (!l) {
          var ye = Path.next(O);
          if (Node.has(o, ye)) {
            O = ye, le = Node.get(o, O);
            continue;
          }
        }
        if (l && O[O.length - 1] !== 0) {
          var Fe = Path.previous(O);
          O = Fe, le = Node.get(o, O);
          continue;
        }
        O = Path.parent(O), le = Node.get(o, O), C.add(le);
      }
    }();
  },
  parent(o, s) {
    var u = Path.parent(s), l = Node.get(o, u);
    if (Text$1.isText(l))
      throw new Error("Cannot get the parent of path [".concat(s, "] because it does not exist in the root."));
    return l;
  },
  string(o) {
    return Text$1.isText(o) ? o.text : o.children.map(Node.string).join("");
  },
  texts(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [u, l] of Node.nodes(o, s))
        Text$1.isText(u) && (yield [u, l]);
    }();
  }
};
function ownKeys$c(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$c(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$c(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$c(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var Operation = {
  isNodeOperation(o) {
    return Operation.isOperation(o) && o.type.endsWith("_node");
  },
  isOperation(o) {
    if (!isPlainObject$2(o))
      return !1;
    switch (o.type) {
      case "insert_node":
        return Path.isPath(o.path) && Node.isNode(o.node);
      case "insert_text":
        return typeof o.offset == "number" && typeof o.text == "string" && Path.isPath(o.path);
      case "merge_node":
        return typeof o.position == "number" && Path.isPath(o.path) && isPlainObject$2(o.properties);
      case "move_node":
        return Path.isPath(o.path) && Path.isPath(o.newPath);
      case "remove_node":
        return Path.isPath(o.path) && Node.isNode(o.node);
      case "remove_text":
        return typeof o.offset == "number" && typeof o.text == "string" && Path.isPath(o.path);
      case "set_node":
        return Path.isPath(o.path) && isPlainObject$2(o.properties) && isPlainObject$2(o.newProperties);
      case "set_selection":
        return o.properties === null && Range.isRange(o.newProperties) || o.newProperties === null && Range.isRange(o.properties) || isPlainObject$2(o.properties) && isPlainObject$2(o.newProperties);
      case "split_node":
        return Path.isPath(o.path) && typeof o.position == "number" && isPlainObject$2(o.properties);
      default:
        return !1;
    }
  },
  isOperationList(o) {
    return Array.isArray(o) && o.every((s) => Operation.isOperation(s));
  },
  isSelectionOperation(o) {
    return Operation.isOperation(o) && o.type.endsWith("_selection");
  },
  isTextOperation(o) {
    return Operation.isOperation(o) && o.type.endsWith("_text");
  },
  inverse(o) {
    switch (o.type) {
      case "insert_node":
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          type: "remove_node"
        });
      case "insert_text":
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          type: "remove_text"
        });
      case "merge_node":
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          type: "split_node",
          path: Path.previous(o.path)
        });
      case "move_node": {
        var {
          newPath: s,
          path: u
        } = o;
        if (Path.equals(s, u))
          return o;
        if (Path.isSibling(u, s))
          return _objectSpread$c(_objectSpread$c({}, o), {}, {
            path: s,
            newPath: u
          });
        var l = Path.transform(u, o), h = Path.transform(Path.next(u), o);
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          path: l,
          newPath: h
        });
      }
      case "remove_node":
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          type: "insert_node"
        });
      case "remove_text":
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          type: "insert_text"
        });
      case "set_node": {
        var {
          properties: m,
          newProperties: C
        } = o;
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          properties: C,
          newProperties: m
        });
      }
      case "set_selection": {
        var {
          properties: O,
          newProperties: le
        } = o;
        return O == null ? _objectSpread$c(_objectSpread$c({}, o), {}, {
          properties: le,
          newProperties: null
        }) : le == null ? _objectSpread$c(_objectSpread$c({}, o), {}, {
          properties: null,
          newProperties: O
        }) : _objectSpread$c(_objectSpread$c({}, o), {}, {
          properties: le,
          newProperties: O
        });
      }
      case "split_node":
        return _objectSpread$c(_objectSpread$c({}, o), {}, {
          type: "merge_node",
          path: Path.next(o.path)
        });
    }
  }
}, IS_EDITOR_CACHE = /* @__PURE__ */ new WeakMap(), isEditor = (o) => {
  var s = IS_EDITOR_CACHE.get(o);
  if (s !== void 0)
    return s;
  if (!isPlainObject$2(o))
    return !1;
  var u = typeof o.addMark == "function" && typeof o.apply == "function" && typeof o.deleteFragment == "function" && typeof o.insertBreak == "function" && typeof o.insertSoftBreak == "function" && typeof o.insertFragment == "function" && typeof o.insertNode == "function" && typeof o.insertText == "function" && typeof o.isElementReadOnly == "function" && typeof o.isInline == "function" && typeof o.isSelectable == "function" && typeof o.isVoid == "function" && typeof o.normalizeNode == "function" && typeof o.onChange == "function" && typeof o.removeMark == "function" && typeof o.getDirtyPaths == "function" && (o.marks === null || isPlainObject$2(o.marks)) && (o.selection === null || Range.isRange(o.selection)) && Node.isNodeList(o.children) && Operation.isOperationList(o.operations);
  return IS_EDITOR_CACHE.set(o, u), u;
}, Editor = {
  above(o, s) {
    return o.above(s);
  },
  addMark(o, s, u) {
    o.addMark(s, u);
  },
  after(o, s, u) {
    return o.after(s, u);
  },
  before(o, s, u) {
    return o.before(s, u);
  },
  deleteBackward(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: u = "character"
    } = s;
    o.deleteBackward(u);
  },
  deleteForward(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: u = "character"
    } = s;
    o.deleteForward(u);
  },
  deleteFragment(o, s) {
    o.deleteFragment(s);
  },
  edges(o, s) {
    return o.edges(s);
  },
  elementReadOnly(o) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return o.elementReadOnly(s);
  },
  end(o, s) {
    return o.end(s);
  },
  first(o, s) {
    return o.first(s);
  },
  fragment(o, s) {
    return o.fragment(s);
  },
  hasBlocks(o, s) {
    return o.hasBlocks(s);
  },
  hasInlines(o, s) {
    return o.hasInlines(s);
  },
  hasPath(o, s) {
    return o.hasPath(s);
  },
  hasTexts(o, s) {
    return o.hasTexts(s);
  },
  insertBreak(o) {
    o.insertBreak();
  },
  insertFragment(o, s, u) {
    o.insertFragment(s, u);
  },
  insertNode(o, s) {
    o.insertNode(s);
  },
  insertSoftBreak(o) {
    o.insertSoftBreak();
  },
  insertText(o, s) {
    o.insertText(s);
  },
  isBlock(o, s) {
    return o.isBlock(s);
  },
  isEdge(o, s, u) {
    return o.isEdge(s, u);
  },
  isEditor(o) {
    return isEditor(o);
  },
  isElementReadOnly(o, s) {
    return o.isElementReadOnly(s);
  },
  isEmpty(o, s) {
    return o.isEmpty(s);
  },
  isEnd(o, s, u) {
    return o.isEnd(s, u);
  },
  isInline(o, s) {
    return o.isInline(s);
  },
  isNormalizing(o) {
    return o.isNormalizing();
  },
  isSelectable(o, s) {
    return o.isSelectable(s);
  },
  isStart(o, s, u) {
    return o.isStart(s, u);
  },
  isVoid(o, s) {
    return o.isVoid(s);
  },
  last(o, s) {
    return o.last(s);
  },
  leaf(o, s, u) {
    return o.leaf(s, u);
  },
  levels(o, s) {
    return o.levels(s);
  },
  marks(o) {
    return o.getMarks();
  },
  next(o, s) {
    return o.next(s);
  },
  node(o, s, u) {
    return o.node(s, u);
  },
  nodes(o, s) {
    return o.nodes(s);
  },
  normalize(o, s) {
    o.normalize(s);
  },
  parent(o, s, u) {
    return o.parent(s, u);
  },
  path(o, s, u) {
    return o.path(s, u);
  },
  pathRef(o, s, u) {
    return o.pathRef(s, u);
  },
  pathRefs(o) {
    return o.pathRefs();
  },
  point(o, s, u) {
    return o.point(s, u);
  },
  pointRef(o, s, u) {
    return o.pointRef(s, u);
  },
  pointRefs(o) {
    return o.pointRefs();
  },
  positions(o, s) {
    return o.positions(s);
  },
  previous(o, s) {
    return o.previous(s);
  },
  range(o, s, u) {
    return o.range(s, u);
  },
  rangeRef(o, s, u) {
    return o.rangeRef(s, u);
  },
  rangeRefs(o) {
    return o.rangeRefs();
  },
  removeMark(o, s) {
    o.removeMark(s);
  },
  setNormalizing(o, s) {
    o.setNormalizing(s);
  },
  start(o, s) {
    return o.start(s);
  },
  string(o, s, u) {
    return o.string(s, u);
  },
  unhangRange(o, s, u) {
    return o.unhangRange(s, u);
  },
  void(o, s) {
    return o.void(s);
  },
  withoutNormalizing(o, s) {
    o.withoutNormalizing(s);
  }
}, Span = {
  isSpan(o) {
    return Array.isArray(o) && o.length === 2 && o.every(Path.isPath);
  }
};
function ownKeys$b(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$b(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$b(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$b(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var Point$1 = {
  compare(o, s) {
    var u = Path.compare(o.path, s.path);
    return u === 0 ? o.offset < s.offset ? -1 : o.offset > s.offset ? 1 : 0 : u;
  },
  isAfter(o, s) {
    return Point$1.compare(o, s) === 1;
  },
  isBefore(o, s) {
    return Point$1.compare(o, s) === -1;
  },
  equals(o, s) {
    return o.offset === s.offset && Path.equals(o.path, s.path);
  },
  isPoint(o) {
    return isPlainObject$2(o) && typeof o.offset == "number" && Path.isPath(o.path);
  },
  transform(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return produce(o, (l) => {
      if (l === null)
        return null;
      var {
        affinity: h = "forward"
      } = u, {
        path: m,
        offset: C
      } = l;
      switch (s.type) {
        case "insert_node":
        case "move_node": {
          l.path = Path.transform(m, s, u);
          break;
        }
        case "insert_text": {
          Path.equals(s.path, m) && (s.offset < C || s.offset === C && h === "forward") && (l.offset += s.text.length);
          break;
        }
        case "merge_node": {
          Path.equals(s.path, m) && (l.offset += s.position), l.path = Path.transform(m, s, u);
          break;
        }
        case "remove_text": {
          Path.equals(s.path, m) && s.offset <= C && (l.offset -= Math.min(C - s.offset, s.text.length));
          break;
        }
        case "remove_node": {
          if (Path.equals(s.path, m) || Path.isAncestor(s.path, m))
            return null;
          l.path = Path.transform(m, s, u);
          break;
        }
        case "split_node": {
          if (Path.equals(s.path, m)) {
            if (s.position === C && h == null)
              return null;
            (s.position < C || s.position === C && h === "forward") && (l.offset -= s.position, l.path = Path.transform(m, s, _objectSpread$b(_objectSpread$b({}, u), {}, {
              affinity: "forward"
            })));
          } else
            l.path = Path.transform(m, s, u);
          break;
        }
      }
    });
  }
}, _scrubber = void 0, Scrubber = {
  setScrubber(o) {
    _scrubber = o;
  },
  stringify(o) {
    return JSON.stringify(o, _scrubber);
  }
}, _excluded$2 = ["text"], _excluded2$2 = ["anchor", "focus"];
function ownKeys$a(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$a(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$a(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$a(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var Text$1 = {
  equals(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      loose: l = !1
    } = u;
    function h(m) {
      var C = _objectWithoutProperties$3(m, _excluded$2);
      return C;
    }
    return isDeepEqual(l ? h(o) : o, l ? h(s) : s);
  },
  isText(o) {
    return isPlainObject$2(o) && typeof o.text == "string";
  },
  isTextList(o) {
    return Array.isArray(o) && o.every((s) => Text$1.isText(s));
  },
  isTextProps(o) {
    return o.text !== void 0;
  },
  matches(o, s) {
    for (var u in s)
      if (u !== "text" && (!o.hasOwnProperty(u) || o[u] !== s[u]))
        return !1;
    return !0;
  },
  decorations(o, s) {
    var u = [_objectSpread$a({}, o)];
    for (var l of s) {
      var h = _objectWithoutProperties$3(l, _excluded2$2), [m, C] = Range.edges(l), O = [], le = 0, We = m.offset, ye = C.offset;
      for (var Fe of u) {
        var {
          length: Ue
        } = Fe.text, Le = le;
        if (le += Ue, We <= Le && le <= ye) {
          Object.assign(Fe, h), O.push(Fe);
          continue;
        }
        if (We !== ye && (We === le || ye === Le) || We > le || ye < Le || ye === Le && Le !== 0) {
          O.push(Fe);
          continue;
        }
        var Ze = Fe, Xe = void 0, Je = void 0;
        if (ye < le) {
          var it = ye - Le;
          Je = _objectSpread$a(_objectSpread$a({}, Ze), {}, {
            text: Ze.text.slice(it)
          }), Ze = _objectSpread$a(_objectSpread$a({}, Ze), {}, {
            text: Ze.text.slice(0, it)
          });
        }
        if (We > Le) {
          var et = We - Le;
          Xe = _objectSpread$a(_objectSpread$a({}, Ze), {}, {
            text: Ze.text.slice(0, et)
          }), Ze = _objectSpread$a(_objectSpread$a({}, Ze), {}, {
            text: Ze.text.slice(et)
          });
        }
        Object.assign(Ze, h), Xe && O.push(Xe), O.push(Ze), Je && O.push(Je);
      }
      u = O;
    }
    return u;
  }
}, getDefaultInsertLocation = (o) => o.selection ? o.selection : o.children.length > 0 ? Editor.end(o, []) : [0], matchPath = (o, s) => {
  var [u] = Editor.node(o, s);
  return (l) => l === u;
}, getCharacterDistance = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, l = !u, h = u ? codepointsIteratorRTL(s) : s, m = CodepointType.None, C = CodepointType.None, O = 0, le = null, We = null;
  for (var ye of h) {
    var Fe = ye.codePointAt(0);
    if (!Fe)
      break;
    var Ue = getCodepointType(ye, Fe);
    if ([m, C] = l ? [C, Ue] : [Ue, m], intersects(m, CodepointType.ZWJ) && intersects(C, CodepointType.ExtPict) && (l ? le = endsWithEmojiZWJ(s.substring(0, O)) : le = endsWithEmojiZWJ(s.substring(0, s.length - O)), !le) || intersects(m, CodepointType.RI) && intersects(C, CodepointType.RI) && (We !== null ? We = !We : l ? We = !0 : We = endsWithOddNumberOfRIs(s.substring(0, s.length - O)), !We) || m !== CodepointType.None && C !== CodepointType.None && isBoundaryPair(m, C))
      break;
    O += ye.length;
  }
  return O || 1;
}, SPACE = /\s/, PUNCTUATION = /[\u002B\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, CHAMELEON = /['\u2018\u2019]/, getWordDistance = function(s) {
  for (var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, l = 0, h = !1; s.length > 0; ) {
    var m = getCharacterDistance(s, u), [C, O] = splitByCharacterDistance(s, m, u);
    if (isWordCharacter(C, O, u))
      h = !0, l += m;
    else if (!h)
      l += m;
    else
      break;
    s = O;
  }
  return l;
}, splitByCharacterDistance = (o, s, u) => {
  if (u) {
    var l = o.length - s;
    return [o.slice(l, o.length), o.slice(0, l)];
  }
  return [o.slice(0, s), o.slice(s)];
}, isWordCharacter = function o(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (SPACE.test(s))
    return !1;
  if (CHAMELEON.test(s)) {
    var h = getCharacterDistance(u, l), [m, C] = splitByCharacterDistance(u, h, l);
    if (o(m, C, l))
      return !0;
  }
  return !PUNCTUATION.test(s);
}, codepointsIteratorRTL = function* (s) {
  for (var u = s.length - 1, l = 0; l < s.length; l++) {
    var h = s.charAt(u - l);
    if (isLowSurrogate(h.charCodeAt(0))) {
      var m = s.charAt(u - l - 1);
      if (isHighSurrogate(m.charCodeAt(0))) {
        yield m + h, l++;
        continue;
      }
    }
    yield h;
  }
}, isHighSurrogate = (o) => o >= 55296 && o <= 56319, isLowSurrogate = (o) => o >= 56320 && o <= 57343, CodepointType;
(function(o) {
  o[o.None = 0] = "None", o[o.Extend = 1] = "Extend", o[o.ZWJ = 2] = "ZWJ", o[o.RI = 4] = "RI", o[o.Prepend = 8] = "Prepend", o[o.SpacingMark = 16] = "SpacingMark", o[o.L = 32] = "L", o[o.V = 64] = "V", o[o.T = 128] = "T", o[o.LV = 256] = "LV", o[o.LVT = 512] = "LVT", o[o.ExtPict = 1024] = "ExtPict", o[o.Any = 2048] = "Any";
})(CodepointType || (CodepointType = {}));
var reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, reL = /^[\u1100-\u115F\uA960-\uA97C]$/, reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, getCodepointType = (o, s) => {
  var u = CodepointType.Any;
  return o.search(reExtend) !== -1 && (u |= CodepointType.Extend), s === 8205 && (u |= CodepointType.ZWJ), s >= 127462 && s <= 127487 && (u |= CodepointType.RI), o.search(rePrepend) !== -1 && (u |= CodepointType.Prepend), o.search(reSpacingMark) !== -1 && (u |= CodepointType.SpacingMark), o.search(reL) !== -1 && (u |= CodepointType.L), o.search(reV) !== -1 && (u |= CodepointType.V), o.search(reT) !== -1 && (u |= CodepointType.T), o.search(reLV) !== -1 && (u |= CodepointType.LV), o.search(reLVT) !== -1 && (u |= CodepointType.LVT), o.search(reExtPict) !== -1 && (u |= CodepointType.ExtPict), u;
};
function intersects(o, s) {
  return (o & s) !== 0;
}
var NonBoundaryPairs = [
  // GB6
  [CodepointType.L, CodepointType.L | CodepointType.V | CodepointType.LV | CodepointType.LVT],
  // GB7
  [CodepointType.LV | CodepointType.V, CodepointType.V | CodepointType.T],
  // GB8
  [CodepointType.LVT | CodepointType.T, CodepointType.T],
  // GB9
  [CodepointType.Any, CodepointType.Extend | CodepointType.ZWJ],
  // GB9a
  [CodepointType.Any, CodepointType.SpacingMark],
  // GB9b
  [CodepointType.Prepend, CodepointType.Any],
  // GB11
  [CodepointType.ZWJ, CodepointType.ExtPict],
  // GB12 and GB13
  [CodepointType.RI, CodepointType.RI]
];
function isBoundaryPair(o, s) {
  return NonBoundaryPairs.findIndex((u) => intersects(o, u[0]) && intersects(s, u[1])) === -1;
}
var endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, endsWithEmojiZWJ = (o) => o.search(endingEmojiZWJ) !== -1, endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, endsWithOddNumberOfRIs = (o) => {
  var s = o.match(endingRIs);
  if (s === null)
    return !1;
  var u = s[0].length / 2;
  return u % 2 === 1;
}, TextTransforms = {
  delete(o, s) {
    o.delete(s);
  },
  insertFragment(o, s, u) {
    o.insertFragment(s, u);
  },
  insertText(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Editor.withoutNormalizing(o, () => {
      var {
        voids: l = !1
      } = u, {
        at: h = getDefaultInsertLocation(o)
      } = u;
      if (Path.isPath(h) && (h = Editor.range(o, h)), Range.isRange(h))
        if (Range.isCollapsed(h))
          h = h.anchor;
        else {
          var m = Range.end(h);
          if (!l && Editor.void(o, {
            at: m
          }))
            return;
          var C = Range.start(h), O = Editor.pointRef(o, C), le = Editor.pointRef(o, m);
          Transforms.delete(o, {
            at: h,
            voids: l
          });
          var We = O.unref(), ye = le.unref();
          h = We || ye, Transforms.setSelection(o, {
            anchor: h,
            focus: h
          });
        }
      if (!(!l && Editor.void(o, {
        at: h
      }) || Editor.elementReadOnly(o, {
        at: h
      }))) {
        var {
          path: Fe,
          offset: Ue
        } = h;
        s.length > 0 && o.apply({
          type: "insert_text",
          path: Fe,
          offset: Ue,
          text: s
        });
      }
    });
  }
};
function ownKeys$9(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$9(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$9(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$9(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var Transforms = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, GeneralTransforms), NodeTransforms), SelectionTransforms), TextTransforms), BATCHING_DIRTY_PATHS = /* @__PURE__ */ new WeakMap(), isBatchingDirtyPaths = (o) => BATCHING_DIRTY_PATHS.get(o) || !1, batchDirtyPaths = (o, s, u) => {
  var l = BATCHING_DIRTY_PATHS.get(o) || !1;
  BATCHING_DIRTY_PATHS.set(o, !0);
  try {
    s(), u();
  } finally {
    BATCHING_DIRTY_PATHS.set(o, l);
  }
};
function updateDirtyPaths(o, s, u) {
  var l = DIRTY_PATHS.get(o) || [], h = DIRTY_PATH_KEYS.get(o) || /* @__PURE__ */ new Set(), m, C, O = (Fe) => {
    if (Fe) {
      var Ue = Fe.join(",");
      C.has(Ue) || (C.add(Ue), m.push(Fe));
    }
  };
  if (u) {
    m = [], C = /* @__PURE__ */ new Set();
    for (var le of l) {
      var We = u(le);
      O(We);
    }
  } else
    m = l, C = h;
  for (var ye of s)
    O(ye);
  DIRTY_PATHS.set(o, m), DIRTY_PATH_KEYS.set(o, C);
}
var apply = (o, s) => {
  for (var u of Editor.pathRefs(o))
    PathRef.transform(u, s);
  for (var l of Editor.pointRefs(o))
    PointRef.transform(l, s);
  for (var h of Editor.rangeRefs(o))
    RangeRef.transform(h, s);
  if (!isBatchingDirtyPaths(o)) {
    var m = Path.operationCanTransformPath(s) ? (C) => Path.transform(C, s) : void 0;
    updateDirtyPaths(o, o.getDirtyPaths(s), m);
  }
  Transforms.transform(o, s), o.operations.push(s), Editor.normalize(o, {
    operation: s
  }), s.type === "set_selection" && (o.marks = null), FLUSHING.get(o) || (FLUSHING.set(o, !0), Promise.resolve().then(() => {
    FLUSHING.set(o, !1), o.onChange({
      operation: s
    }), o.operations = [];
  }));
}, getDirtyPaths = (o, s) => {
  switch (s.type) {
    case "insert_text":
    case "remove_text":
    case "set_node": {
      var {
        path: u
      } = s;
      return Path.levels(u);
    }
    case "insert_node": {
      var {
        node: l,
        path: h
      } = s, m = Path.levels(h), C = Text$1.isText(l) ? [] : Array.from(Node.nodes(l), (ht) => {
        var [, vt] = ht;
        return h.concat(vt);
      });
      return [...m, ...C];
    }
    case "merge_node": {
      var {
        path: O
      } = s, le = Path.ancestors(O), We = Path.previous(O);
      return [...le, We];
    }
    case "move_node": {
      var {
        path: ye,
        newPath: Fe
      } = s;
      if (Path.equals(ye, Fe))
        return [];
      var Ue = [], Le = [];
      for (var Ze of Path.ancestors(ye)) {
        var Xe = Path.transform(Ze, s);
        Ue.push(Xe);
      }
      for (var Je of Path.ancestors(Fe)) {
        var it = Path.transform(Je, s);
        Le.push(it);
      }
      var et = Le[Le.length - 1], at = Fe[Fe.length - 1], $e = et.concat(at);
      return [...Ue, ...Le, $e];
    }
    case "remove_node": {
      var {
        path: Ke
      } = s, tt = Path.ancestors(Ke);
      return [...tt];
    }
    case "split_node": {
      var {
        path: ut
      } = s, st = Path.levels(ut), ot = Path.next(ut);
      return [...st, ot];
    }
    default:
      return [];
  }
}, getFragment = (o) => {
  var {
    selection: s
  } = o;
  return s ? Node.fragment(o, s) : [];
}, normalizeNode = (o, s) => {
  var [u, l] = s;
  if (!Text$1.isText(u)) {
    if (Element$3.isElement(u) && u.children.length === 0) {
      var h = {
        text: ""
      };
      Transforms.insertNodes(o, h, {
        at: l.concat(0),
        voids: !0
      });
      return;
    }
    for (var m = Editor.isEditor(u) ? !1 : Element$3.isElement(u) && (o.isInline(u) || u.children.length === 0 || Text$1.isText(u.children[0]) || o.isInline(u.children[0])), C = 0, O = 0; O < u.children.length; O++, C++) {
      var le = Node.get(o, l);
      if (!Text$1.isText(le)) {
        var We = le.children[C], ye = le.children[C - 1], Fe = O === u.children.length - 1, Ue = Text$1.isText(We) || Element$3.isElement(We) && o.isInline(We);
        if (Ue !== m)
          Transforms.removeNodes(o, {
            at: l.concat(C),
            voids: !0
          }), C--;
        else if (Element$3.isElement(We)) {
          if (o.isInline(We)) {
            if (ye == null || !Text$1.isText(ye)) {
              var Le = {
                text: ""
              };
              Transforms.insertNodes(o, Le, {
                at: l.concat(C),
                voids: !0
              }), C++;
            } else if (Fe) {
              var Ze = {
                text: ""
              };
              Transforms.insertNodes(o, Ze, {
                at: l.concat(C + 1),
                voids: !0
              }), C++;
            }
          }
        } else
          ye != null && Text$1.isText(ye) && (Text$1.equals(We, ye, {
            loose: !0
          }) ? (Transforms.mergeNodes(o, {
            at: l.concat(C),
            voids: !0
          }), C--) : ye.text === "" ? (Transforms.removeNodes(o, {
            at: l.concat(C - 1),
            voids: !0
          }), C--) : We.text === "" && (Transforms.removeNodes(o, {
            at: l.concat(C),
            voids: !0
          }), C--));
      }
    }
  }
}, shouldNormalize = (o, s) => {
  var {
    iteration: u,
    initialDirtyPathsLength: l
  } = s, h = l * 42;
  if (u > h)
    throw new Error("Could not completely normalize the editor after ".concat(h, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
  return !0;
}, above = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    voids: l = !1,
    mode: h = "lowest",
    at: m = s.selection,
    match: C
  } = u;
  if (m) {
    var O = Editor.path(s, m), le = h === "lowest";
    for (var [We, ye] of Editor.levels(s, {
      at: O,
      voids: l,
      match: C,
      reverse: le
    }))
      if (!Text$1.isText(We)) {
        if (Range.isRange(m)) {
          if (Path.isAncestor(ye, m.anchor.path) && Path.isAncestor(ye, m.focus.path))
            return [We, ye];
        } else if (!Path.equals(O, ye))
          return [We, ye];
      }
  }
};
function ownKeys$8(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$8(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$8(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$8(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var addMark = (o, s, u) => {
  var {
    selection: l
  } = o;
  if (l) {
    var h = (Fe, Ue) => {
      if (!Text$1.isText(Fe))
        return !1;
      var [Le, Ze] = Editor.parent(o, Ue);
      return !o.isVoid(Le) || o.markableVoid(Le);
    }, m = Range.isExpanded(l), C = !1;
    if (!m) {
      var [O, le] = Editor.node(o, l);
      if (O && h(O, le)) {
        var [We] = Editor.parent(o, le);
        C = We && o.markableVoid(We);
      }
    }
    if (m || C)
      Transforms.setNodes(o, {
        [s]: u
      }, {
        match: h,
        split: !0,
        voids: !0
      });
    else {
      var ye = _objectSpread$8(_objectSpread$8({}, Editor.marks(o) || {}), {}, {
        [s]: u
      });
      o.marks = ye, FLUSHING.get(o) || o.onChange();
    }
  }
};
function ownKeys$7(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$7(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$7(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$7(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var after = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = Editor.point(s, u, {
    edge: "end"
  }), m = Editor.end(s, []), C = {
    anchor: h,
    focus: m
  }, {
    distance: O = 1
  } = l, le = 0, We;
  for (var ye of Editor.positions(s, _objectSpread$7(_objectSpread$7({}, l), {}, {
    at: C
  }))) {
    if (le > O)
      break;
    le !== 0 && (We = ye), le++;
  }
  return We;
};
function ownKeys$6(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$6(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$6(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$6(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var before = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = Editor.start(s, []), m = Editor.point(s, u, {
    edge: "start"
  }), C = {
    anchor: h,
    focus: m
  }, {
    distance: O = 1
  } = l, le = 0, We;
  for (var ye of Editor.positions(s, _objectSpread$6(_objectSpread$6({}, l), {}, {
    at: C,
    reverse: !0
  }))) {
    if (le > O)
      break;
    le !== 0 && (We = ye), le++;
  }
  return We;
}, deleteBackward = (o, s) => {
  var {
    selection: u
  } = o;
  u && Range.isCollapsed(u) && Transforms.delete(o, {
    unit: s,
    reverse: !0
  });
}, deleteForward = (o, s) => {
  var {
    selection: u
  } = o;
  u && Range.isCollapsed(u) && Transforms.delete(o, {
    unit: s
  });
}, deleteFragment = function(s) {
  var {
    direction: u = "forward"
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: l
  } = s;
  l && Range.isExpanded(l) && Transforms.delete(s, {
    reverse: u === "backward"
  });
}, edges = (o, s) => [Editor.start(o, s), Editor.end(o, s)];
function ownKeys$5(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$5(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$5(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$5(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var elementReadOnly = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Editor.above(s, _objectSpread$5(_objectSpread$5({}, u), {}, {
    match: (l) => Element$3.isElement(l) && Editor.isElementReadOnly(s, l)
  }));
}, end$1 = (o, s) => Editor.point(o, s, {
  edge: "end"
}), first = (o, s) => {
  var u = Editor.path(o, s, {
    edge: "start"
  });
  return Editor.node(o, u);
}, fragment = (o, s) => {
  var u = Editor.range(o, s);
  return Node.fragment(o, u);
};
function ownKeys$4(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$4(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$4(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$4(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var getVoid = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Editor.above(s, _objectSpread$4(_objectSpread$4({}, u), {}, {
    match: (l) => Element$3.isElement(l) && Editor.isVoid(s, l)
  }));
}, hasBlocks = (o, s) => s.children.some((u) => Element$3.isElement(u) && Editor.isBlock(o, u)), hasInlines = (o, s) => s.children.some((u) => Text$1.isText(u) || Editor.isInline(o, u)), hasPath = (o, s) => Node.has(o, s), hasTexts = (o, s) => s.children.every((u) => Text$1.isText(u)), insertBreak = (o) => {
  Transforms.splitNodes(o, {
    always: !0
  });
}, insertNode = (o, s, u) => {
  Transforms.insertNodes(o, s, u);
}, insertSoftBreak = (o) => {
  Transforms.splitNodes(o, {
    always: !0
  });
};
function ownKeys$3$1(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$3(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$3$1(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$3$1(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var insertText = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: h,
    marks: m
  } = s;
  if (h) {
    if (m) {
      var C = _objectSpread$3({
        text: u
      }, m);
      Transforms.insertNodes(s, C, {
        at: l.at,
        voids: l.voids
      });
    } else
      Transforms.insertText(s, u, l);
    s.marks = null;
  }
}, isBlock = (o, s) => !o.isInline(s), isEdge$1 = (o, s, u) => Editor.isStart(o, s, u) || Editor.isEnd(o, s, u), isEmpty = (o, s) => {
  var {
    children: u
  } = s, [l] = u;
  return u.length === 0 || u.length === 1 && Text$1.isText(l) && l.text === "" && !o.isVoid(s);
}, isEnd = (o, s, u) => {
  var l = Editor.end(o, u);
  return Point$1.equals(s, l);
}, isNormalizing = (o) => {
  var s = NORMALIZING.get(o);
  return s === void 0 ? !0 : s;
}, isStart = (o, s, u) => {
  if (s.offset !== 0)
    return !1;
  var l = Editor.start(o, u);
  return Point$1.equals(s, l);
}, last = (o, s) => {
  var u = Editor.path(o, s, {
    edge: "end"
  });
  return Editor.node(o, u);
}, leaf = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = Editor.path(s, u, l), m = Node.leaf(s, h);
  return [m, h];
};
function levels(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: u = o.selection,
      reverse: l = !1,
      voids: h = !1
    } = s, {
      match: m
    } = s;
    if (m == null && (m = () => !0), !!u) {
      var C = [], O = Editor.path(o, u);
      for (var [le, We] of Node.levels(o, O))
        if (m(le, We) && (C.push([le, We]), !h && Element$3.isElement(le) && Editor.isVoid(o, le)))
          break;
      l && C.reverse(), yield* C;
    }
  }();
}
var _excluded$1 = ["text"], _excluded2$1 = ["text"], marks = function(s) {
  var {
    marks: u,
    selection: l
  } = s;
  if (!l)
    return null;
  var {
    anchor: h,
    focus: m
  } = l;
  if (u)
    return u;
  if (Range.isExpanded(l)) {
    var C = Editor.isEnd(s, h, h.path);
    if (C) {
      var O = Editor.after(s, h);
      O && (h = O);
    }
    var [le] = Editor.nodes(s, {
      match: Text$1.isText,
      at: {
        anchor: h,
        focus: m
      }
    });
    if (le) {
      var [We] = le, ye = _objectWithoutProperties$3(We, _excluded$1);
      return ye;
    } else
      return {};
  }
  var {
    path: Fe
  } = h, [Ue] = Editor.leaf(s, Fe);
  if (h.offset === 0) {
    var Le = Editor.previous(s, {
      at: Fe,
      match: Text$1.isText
    }), Ze = Editor.above(s, {
      match: ($e) => Element$3.isElement($e) && Editor.isVoid(s, $e) && s.markableVoid($e)
    });
    if (!Ze) {
      var Xe = Editor.above(s, {
        match: ($e) => Element$3.isElement($e) && Editor.isBlock(s, $e)
      });
      if (Le && Xe) {
        var [Je, it] = Le, [, et] = Xe;
        Path.isAncestor(et, it) && (Ue = Je);
      }
    }
  }
  var at = _objectWithoutProperties$3(Ue, _excluded2$1);
  return at;
}, next = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: l = "lowest",
    voids: h = !1
  } = u, {
    match: m,
    at: C = s.selection
  } = u;
  if (C) {
    var O = Editor.after(s, C, {
      voids: h
    });
    if (O) {
      var [, le] = Editor.last(s, []), We = [O.path, le];
      if (Path.isPath(C) && C.length === 0)
        throw new Error("Cannot get the next node from the root node!");
      if (m == null)
        if (Path.isPath(C)) {
          var [ye] = Editor.parent(s, C);
          m = (Ue) => ye.children.includes(Ue);
        } else
          m = () => !0;
      var [Fe] = Editor.nodes(s, {
        at: We,
        match: m,
        mode: l,
        voids: h
      });
      return Fe;
    }
  }
}, node = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = Editor.path(s, u, l), m = Node.get(s, h);
  return [m, h];
};
function nodes(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: u = o.selection,
      mode: l = "all",
      universal: h = !1,
      reverse: m = !1,
      voids: C = !1,
      ignoreNonSelectable: O = !1
    } = s, {
      match: le
    } = s;
    if (le || (le = () => !0), !!u) {
      var We, ye;
      if (Span.isSpan(u))
        We = u[0], ye = u[1];
      else {
        var Fe = Editor.path(o, u, {
          edge: "start"
        }), Ue = Editor.path(o, u, {
          edge: "end"
        });
        We = m ? Ue : Fe, ye = m ? Fe : Ue;
      }
      var Le = Node.nodes(o, {
        reverse: m,
        from: We,
        to: ye,
        pass: ($e) => {
          var [Ke] = $e;
          return Element$3.isElement(Ke) ? !!(!C && (Editor.isVoid(o, Ke) || Editor.isElementReadOnly(o, Ke)) || O && !Editor.isSelectable(o, Ke)) : !1;
        }
      }), Ze = [], Xe;
      for (var [Je, it] of Le)
        if (!(O && Element$3.isElement(Je) && !Editor.isSelectable(o, Je))) {
          var et = Xe && Path.compare(it, Xe[1]) === 0;
          if (!(l === "highest" && et)) {
            if (!le(Je, it)) {
              if (h && !et && Text$1.isText(Je))
                return;
              continue;
            }
            if (l === "lowest" && et) {
              Xe = [Je, it];
              continue;
            }
            var at = l === "lowest" ? Xe : [Je, it];
            at && (h ? Ze.push(at) : yield at), Xe = [Je, it];
          }
        }
      l === "lowest" && Xe && (h ? Ze.push(Xe) : yield Xe), h && (yield* Ze);
    }
  }();
}
var normalize = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    force: l = !1,
    operation: h
  } = u, m = (ye) => DIRTY_PATHS.get(ye) || [], C = (ye) => DIRTY_PATH_KEYS.get(ye) || /* @__PURE__ */ new Set(), O = (ye) => {
    var Fe = m(ye).pop(), Ue = Fe.join(",");
    return C(ye).delete(Ue), Fe;
  };
  if (Editor.isNormalizing(s)) {
    if (l) {
      var le = Array.from(Node.nodes(s), (ye) => {
        var [, Fe] = ye;
        return Fe;
      }), We = new Set(le.map((ye) => ye.join(",")));
      DIRTY_PATHS.set(s, le), DIRTY_PATH_KEYS.set(s, We);
    }
    m(s).length !== 0 && Editor.withoutNormalizing(s, () => {
      for (var ye of m(s))
        if (Node.has(s, ye)) {
          var Fe = Editor.node(s, ye), [Ue, Le] = Fe;
          Element$3.isElement(Ue) && Ue.children.length === 0 && s.normalizeNode(Fe, {
            operation: h
          });
        }
      for (var Ze = m(s), Xe = Ze.length, Je = 0; Ze.length !== 0; ) {
        if (!s.shouldNormalize({
          dirtyPaths: Ze,
          iteration: Je,
          initialDirtyPathsLength: Xe,
          operation: h
        }))
          return;
        var it = O(s);
        if (Node.has(s, it)) {
          var et = Editor.node(s, it);
          s.normalizeNode(et, {
            operation: h
          });
        }
        Je++, Ze = m(s);
      }
    });
  }
}, parent = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, h = Editor.path(s, u, l), m = Path.parent(h), C = Editor.node(s, m);
  return C;
}, pathRef = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: h = "forward"
  } = l, m = {
    current: u,
    affinity: h,
    unref() {
      var {
        current: O
      } = m, le = Editor.pathRefs(s);
      return le.delete(m), m.current = null, O;
    }
  }, C = Editor.pathRefs(s);
  return C.add(m), m;
}, pathRefs = (o) => {
  var s = PATH_REFS.get(o);
  return s || (s = /* @__PURE__ */ new Set(), PATH_REFS.set(o, s)), s;
}, path = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    depth: h,
    edge: m
  } = l;
  if (Path.isPath(u)) {
    if (m === "start") {
      var [, C] = Node.first(s, u);
      u = C;
    } else if (m === "end") {
      var [, O] = Node.last(s, u);
      u = O;
    }
  }
  return Range.isRange(u) && (m === "start" ? u = Range.start(u) : m === "end" ? u = Range.end(u) : u = Path.common(u.anchor.path, u.focus.path)), Point$1.isPoint(u) && (u = u.path), h != null && (u = u.slice(0, h)), u;
}, pointRef = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: h = "forward"
  } = l, m = {
    current: u,
    affinity: h,
    unref() {
      var {
        current: O
      } = m, le = Editor.pointRefs(s);
      return le.delete(m), m.current = null, O;
    }
  }, C = Editor.pointRefs(s);
  return C.add(m), m;
}, pointRefs = (o) => {
  var s = POINT_REFS.get(o);
  return s || (s = /* @__PURE__ */ new Set(), POINT_REFS.set(o, s)), s;
}, point$1 = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    edge: h = "start"
  } = l;
  if (Path.isPath(u)) {
    var m;
    if (h === "end") {
      var [, C] = Node.last(s, u);
      m = C;
    } else {
      var [, O] = Node.first(s, u);
      m = O;
    }
    var le = Node.get(s, m);
    if (!Text$1.isText(le))
      throw new Error("Cannot get the ".concat(h, " point in the node at path [").concat(u, "] because it has no ").concat(h, " text node."));
    return {
      path: m,
      offset: h === "end" ? le.text.length : 0
    };
  }
  if (Range.isRange(u)) {
    var [We, ye] = Range.edges(u);
    return h === "start" ? We : ye;
  }
  return u;
};
function positions(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: u = o.selection,
      unit: l = "offset",
      reverse: h = !1,
      voids: m = !1,
      ignoreNonSelectable: C = !1
    } = s;
    if (!u)
      return;
    var O = Editor.range(o, u), [le, We] = Range.edges(O), ye = h ? We : le, Fe = !1, Ue = "", Le = 0, Ze = 0, Xe = 0;
    for (var [Je, it] of Editor.nodes(o, {
      at: u,
      reverse: h,
      voids: m,
      ignoreNonSelectable: C
    })) {
      if (Element$3.isElement(Je)) {
        if (!m && (o.isVoid(Je) || o.isElementReadOnly(Je))) {
          yield Editor.start(o, it);
          continue;
        }
        if (o.isInline(Je))
          continue;
        if (Editor.hasInlines(o, Je)) {
          var et = Path.isAncestor(it, We.path) ? We : Editor.end(o, it), at = Path.isAncestor(it, le.path) ? le : Editor.start(o, it);
          Ue = Editor.string(o, {
            anchor: at,
            focus: et
          }, {
            voids: m
          }), Fe = !0;
        }
      }
      if (Text$1.isText(Je)) {
        var $e = Path.equals(it, ye.path);
        for ($e ? (Ze = h ? ye.offset : Je.text.length - ye.offset, Xe = ye.offset) : (Ze = Je.text.length, Xe = h ? Ze : 0), ($e || Fe || l === "offset") && (yield {
          path: it,
          offset: Xe
        }, Fe = !1); ; ) {
          if (Le === 0) {
            if (Ue === "")
              break;
            Le = Ke(Ue, l, h), Ue = splitByCharacterDistance(Ue, Le, h)[1];
          }
          if (Xe = h ? Xe - Le : Xe + Le, Ze = Ze - Le, Ze < 0) {
            Le = -Ze;
            break;
          }
          Le = 0, yield {
            path: it,
            offset: Xe
          };
        }
      }
    }
    function Ke(tt, ut, st) {
      return ut === "character" ? getCharacterDistance(tt, st) : ut === "word" ? getWordDistance(tt, st) : ut === "line" || ut === "block" ? tt.length : 1;
    }
  }();
}
var previous = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: l = "lowest",
    voids: h = !1
  } = u, {
    match: m,
    at: C = s.selection
  } = u;
  if (C) {
    var O = Editor.before(s, C, {
      voids: h
    });
    if (O) {
      var [, le] = Editor.first(s, []), We = [O.path, le];
      if (Path.isPath(C) && C.length === 0)
        throw new Error("Cannot get the previous node from the root node!");
      if (m == null)
        if (Path.isPath(C)) {
          var [ye] = Editor.parent(s, C);
          m = (Ue) => ye.children.includes(Ue);
        } else
          m = () => !0;
      var [Fe] = Editor.nodes(s, {
        reverse: !0,
        at: We,
        match: m,
        mode: l,
        voids: h
      });
      return Fe;
    }
  }
}, rangeRef = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: h = "forward"
  } = l, m = {
    current: u,
    affinity: h,
    unref() {
      var {
        current: O
      } = m, le = Editor.rangeRefs(s);
      return le.delete(m), m.current = null, O;
    }
  }, C = Editor.rangeRefs(s);
  return C.add(m), m;
}, rangeRefs = (o) => {
  var s = RANGE_REFS.get(o);
  return s || (s = /* @__PURE__ */ new Set(), RANGE_REFS.set(o, s)), s;
}, range = (o, s, u) => {
  if (Range.isRange(s) && !u)
    return s;
  var l = Editor.start(o, s), h = Editor.end(o, u || s);
  return {
    anchor: l,
    focus: h
  };
};
function ownKeys$2$1(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$2(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$2$1(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$2$1(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var removeMark = (o, s) => {
  var {
    selection: u
  } = o;
  if (u) {
    var l = (ye, Fe) => {
      if (!Text$1.isText(ye))
        return !1;
      var [Ue, Le] = Editor.parent(o, Fe);
      return !o.isVoid(Ue) || o.markableVoid(Ue);
    }, h = Range.isExpanded(u), m = !1;
    if (!h) {
      var [C, O] = Editor.node(o, u);
      if (C && l(C, O)) {
        var [le] = Editor.parent(o, O);
        m = le && o.markableVoid(le);
      }
    }
    if (h || m)
      Transforms.unsetNodes(o, s, {
        match: l,
        split: !0,
        voids: !0
      });
    else {
      var We = _objectSpread$2({}, Editor.marks(o) || {});
      delete We[s], o.marks = We, FLUSHING.get(o) || o.onChange();
    }
  }
}, setNormalizing = (o, s) => {
  NORMALIZING.set(o, s);
}, start = (o, s) => Editor.point(o, s, {
  edge: "start"
}), string = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: h = !1
  } = l, m = Editor.range(s, u), [C, O] = Range.edges(m), le = "";
  for (var [We, ye] of Editor.nodes(s, {
    at: m,
    match: Text$1.isText,
    voids: h
  })) {
    var Fe = We.text;
    Path.equals(ye, O.path) && (Fe = Fe.slice(0, O.offset)), Path.equals(ye, C.path) && (Fe = Fe.slice(C.offset)), le += Fe;
  }
  return le;
}, unhangRange = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: h = !1
  } = l, [m, C] = Range.edges(u);
  if (m.offset !== 0 || C.offset !== 0 || Range.isCollapsed(u) || Path.hasPrevious(C.path))
    return u;
  var O = Editor.above(s, {
    at: C,
    match: (Ze) => Element$3.isElement(Ze) && Editor.isBlock(s, Ze),
    voids: h
  }), le = O ? O[1] : [], We = Editor.start(s, m), ye = {
    anchor: We,
    focus: C
  }, Fe = !0;
  for (var [Ue, Le] of Editor.nodes(s, {
    at: ye,
    match: Text$1.isText,
    reverse: !0,
    voids: h
  })) {
    if (Fe) {
      Fe = !1;
      continue;
    }
    if (Ue.text !== "" || Path.isBefore(Le, le)) {
      C = {
        path: Le,
        offset: Ue.text.length
      };
      break;
    }
  }
  return {
    anchor: m,
    focus: C
  };
}, withoutNormalizing = (o, s) => {
  var u = Editor.isNormalizing(o);
  Editor.setNormalizing(o, !1);
  try {
    s();
  } finally {
    Editor.setNormalizing(o, u);
  }
  Editor.normalize(o);
}, deleteText = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(s, () => {
    var l, h, {
      reverse: m = !1,
      unit: C = "character",
      distance: O = 1,
      voids: le = !1
    } = u, {
      at: We = s.selection,
      hanging: ye = !1
    } = u;
    if (We) {
      var Fe = !1;
      if (Range.isRange(We) && Range.isCollapsed(We) && (Fe = !0, We = We.anchor), Point$1.isPoint(We)) {
        var Ue = Editor.void(s, {
          at: We,
          mode: "highest"
        });
        if (!le && Ue) {
          var [, Le] = Ue;
          We = Le;
        } else {
          var Ze = {
            unit: C,
            distance: O
          }, Xe = m ? Editor.before(s, We, Ze) || Editor.start(s, []) : Editor.after(s, We, Ze) || Editor.end(s, []);
          We = {
            anchor: We,
            focus: Xe
          }, ye = !0;
        }
      }
      if (Path.isPath(We)) {
        Transforms.removeNodes(s, {
          at: We,
          voids: le
        });
        return;
      }
      if (!Range.isCollapsed(We)) {
        if (!ye) {
          var [, Je] = Range.edges(We), it = Editor.end(s, []);
          Point$1.equals(Je, it) || (We = Editor.unhangRange(s, We, {
            voids: le
          }));
        }
        var [et, at] = Range.edges(We), $e = Editor.above(s, {
          match: (Dt) => Element$3.isElement(Dt) && Editor.isBlock(s, Dt),
          at: et,
          voids: le
        }), Ke = Editor.above(s, {
          match: (Dt) => Element$3.isElement(Dt) && Editor.isBlock(s, Dt),
          at,
          voids: le
        }), tt = $e && Ke && !Path.equals($e[1], Ke[1]), ut = Path.equals(et.path, at.path), st = le ? null : (l = Editor.void(s, {
          at: et,
          mode: "highest"
        })) !== null && l !== void 0 ? l : Editor.elementReadOnly(s, {
          at: et,
          mode: "highest"
        }), ot = le ? null : (h = Editor.void(s, {
          at,
          mode: "highest"
        })) !== null && h !== void 0 ? h : Editor.elementReadOnly(s, {
          at,
          mode: "highest"
        });
        if (st) {
          var ht = Editor.before(s, et);
          ht && $e && Path.isAncestor($e[1], ht.path) && (et = ht);
        }
        if (ot) {
          var vt = Editor.after(s, at);
          vt && Ke && Path.isAncestor(Ke[1], vt.path) && (at = vt);
        }
        var At = [], gt;
        for (var bt of Editor.nodes(s, {
          at: We,
          voids: le
        })) {
          var [wt, Ot] = bt;
          gt && Path.compare(Ot, gt) === 0 || (!le && Element$3.isElement(wt) && (Editor.isVoid(s, wt) || Editor.isElementReadOnly(s, wt)) || !Path.isCommon(Ot, et.path) && !Path.isCommon(Ot, at.path)) && (At.push(bt), gt = Ot);
        }
        var yt = Array.from(At, (Dt) => {
          var [, Nt] = Dt;
          return Editor.pathRef(s, Nt);
        }), Qe = Editor.pointRef(s, et), nt = Editor.pointRef(s, at), rt = "";
        if (!ut && !st) {
          var lt = Qe.current, [ct] = Editor.leaf(s, lt), {
            path: ft
          } = lt, {
            offset: pt
          } = et, mt = ct.text.slice(pt);
          mt.length > 0 && (s.apply({
            type: "remove_text",
            path: ft,
            offset: pt,
            text: mt
          }), rt = mt);
        }
        if (yt.reverse().map((Dt) => Dt.unref()).filter((Dt) => Dt !== null).forEach((Dt) => Transforms.removeNodes(s, {
          at: Dt,
          voids: le
        })), !ot) {
          var dt = nt.current, [Et] = Editor.leaf(s, dt), {
            path: Ct
          } = dt, Tt = ut ? et.offset : 0, qt = Et.text.slice(Tt, at.offset);
          qt.length > 0 && (s.apply({
            type: "remove_text",
            path: Ct,
            offset: Tt,
            text: qt
          }), rt = qt);
        }
        !ut && tt && nt.current && Qe.current && Transforms.mergeNodes(s, {
          at: nt.current,
          hanging: !0,
          voids: le
        }), Fe && m && C === "character" && rt.length > 1 && rt.match(/[\u0E00-\u0E7F]+/) && Transforms.insertText(s, rt.slice(0, rt.length - O));
        var jt = Qe.unref(), St = nt.unref(), Mt = m ? jt || St : St || jt;
        u.at == null && Mt && Transforms.select(s, Mt);
      }
    }
  });
}, insertFragment = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      hanging: h = !1,
      voids: m = !1
    } = l, {
      at: C = getDefaultInsertLocation(s),
      batchDirty: O = !0
    } = l;
    if (u.length) {
      if (Range.isRange(C))
        if (h || (C = Editor.unhangRange(s, C, {
          voids: m
        })), Range.isCollapsed(C))
          C = C.anchor;
        else {
          var [, le] = Range.edges(C);
          if (!m && Editor.void(s, {
            at: le
          }))
            return;
          var We = Editor.pointRef(s, le);
          Transforms.delete(s, {
            at: C
          }), C = We.unref();
        }
      else
        Path.isPath(C) && (C = Editor.start(s, C));
      if (!(!m && Editor.void(s, {
        at: C
      }))) {
        var ye = Editor.above(s, {
          at: C,
          match: (mt) => Element$3.isElement(mt) && Editor.isInline(s, mt),
          mode: "highest",
          voids: m
        });
        if (ye) {
          var [, Fe] = ye;
          if (Editor.isEnd(s, C, Fe)) {
            var Ue = Editor.after(s, Fe);
            C = Ue;
          } else if (Editor.isStart(s, C, Fe)) {
            var Le = Editor.before(s, Fe);
            C = Le;
          }
        }
        var Ze = Editor.above(s, {
          match: (mt) => Element$3.isElement(mt) && Editor.isBlock(s, mt),
          at: C,
          voids: m
        }), [, Xe] = Ze, Je = Editor.isStart(s, C, Xe), it = Editor.isEnd(s, C, Xe), et = Je && it, at = !Je || Je && it, $e = !it, [, Ke] = Node.first({
          children: u
        }, []), [, tt] = Node.last({
          children: u
        }, []), ut = [], st = (mt) => {
          var [dt, Et] = mt, Ct = Et.length === 0;
          return Ct ? !1 : et ? !0 : !(at && Path.isAncestor(Et, Ke) && Element$3.isElement(dt) && !s.isVoid(dt) && !s.isInline(dt) || $e && Path.isAncestor(Et, tt) && Element$3.isElement(dt) && !s.isVoid(dt) && !s.isInline(dt));
        };
        for (var ot of Node.nodes({
          children: u
        }, {
          pass: st
        }))
          st(ot) && ut.push(ot);
        var ht = [], vt = [], At = [], gt = !0, bt = !1;
        for (var [wt] of ut)
          Element$3.isElement(wt) && !s.isInline(wt) ? (gt = !1, bt = !0, vt.push(wt)) : gt ? ht.push(wt) : At.push(wt);
        var [Ot] = Editor.nodes(s, {
          at: C,
          match: (mt) => Text$1.isText(mt) || Editor.isInline(s, mt),
          mode: "highest",
          voids: m
        }), [, yt] = Ot, Qe = Editor.isStart(s, C, yt), nt = Editor.isEnd(s, C, yt), rt = Editor.pathRef(s, it && !At.length ? Path.next(Xe) : Xe), lt = Editor.pathRef(s, nt ? Path.next(yt) : yt);
        Transforms.splitNodes(s, {
          at: C,
          match: (mt) => bt ? Element$3.isElement(mt) && Editor.isBlock(s, mt) : Text$1.isText(mt) || Editor.isInline(s, mt),
          mode: bt ? "lowest" : "highest",
          always: bt && (!Je || ht.length > 0) && (!it || At.length > 0),
          voids: m
        });
        var ct = Editor.pathRef(s, !Qe || Qe && nt ? Path.next(yt) : yt);
        if (Transforms.insertNodes(s, ht, {
          at: ct.current,
          match: (mt) => Text$1.isText(mt) || Editor.isInline(s, mt),
          mode: "highest",
          voids: m,
          batchDirty: O
        }), et && !ht.length && vt.length && !At.length && Transforms.delete(s, {
          at: Xe,
          voids: m
        }), Transforms.insertNodes(s, vt, {
          at: rt.current,
          match: (mt) => Element$3.isElement(mt) && Editor.isBlock(s, mt),
          mode: "lowest",
          voids: m,
          batchDirty: O
        }), Transforms.insertNodes(s, At, {
          at: lt.current,
          match: (mt) => Text$1.isText(mt) || Editor.isInline(s, mt),
          mode: "highest",
          voids: m,
          batchDirty: O
        }), !l.at) {
          var ft;
          if (At.length > 0 && lt.current ? ft = Path.previous(lt.current) : vt.length > 0 && rt.current ? ft = Path.previous(rt.current) : ct.current && (ft = Path.previous(ct.current)), ft) {
            var pt = Editor.end(s, ft);
            Transforms.select(s, pt);
          }
        }
        ct.unref(), rt.unref(), lt.unref();
      }
    }
  });
}, collapse = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    edge: l = "anchor"
  } = u, {
    selection: h
  } = s;
  if (h) {
    if (l === "anchor")
      Transforms.select(s, h.anchor);
    else if (l === "focus")
      Transforms.select(s, h.focus);
    else if (l === "start") {
      var [m] = Range.edges(h);
      Transforms.select(s, m);
    } else if (l === "end") {
      var [, C] = Range.edges(h);
      Transforms.select(s, C);
    }
  } else
    return;
}, deselect = (o) => {
  var {
    selection: s
  } = o;
  s && o.apply({
    type: "set_selection",
    properties: s,
    newProperties: null
  });
}, move = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: l
  } = s, {
    distance: h = 1,
    unit: m = "character",
    reverse: C = !1
  } = u, {
    edge: O = null
  } = u;
  if (l) {
    O === "start" && (O = Range.isBackward(l) ? "focus" : "anchor"), O === "end" && (O = Range.isBackward(l) ? "anchor" : "focus");
    var {
      anchor: le,
      focus: We
    } = l, ye = {
      distance: h,
      unit: m,
      ignoreNonSelectable: !0
    }, Fe = {};
    if (O == null || O === "anchor") {
      var Ue = C ? Editor.before(s, le, ye) : Editor.after(s, le, ye);
      Ue && (Fe.anchor = Ue);
    }
    if (O == null || O === "focus") {
      var Le = C ? Editor.before(s, We, ye) : Editor.after(s, We, ye);
      Le && (Fe.focus = Le);
    }
    Transforms.setSelection(s, Fe);
  }
}, select = (o, s) => {
  var {
    selection: u
  } = o;
  if (s = Editor.range(o, s), u) {
    Transforms.setSelection(o, s);
    return;
  }
  if (!Range.isRange(s))
    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(Scrubber.stringify(s)));
  o.apply({
    type: "set_selection",
    properties: u,
    newProperties: s
  });
};
function ownKeys$1$1(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$1(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$1$1(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$1$1(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var setPoint = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: h
  } = s, {
    edge: m = "both"
  } = l;
  if (h) {
    m === "start" && (m = Range.isBackward(h) ? "focus" : "anchor"), m === "end" && (m = Range.isBackward(h) ? "anchor" : "focus");
    var {
      anchor: C,
      focus: O
    } = h, le = m === "anchor" ? C : O;
    Transforms.setSelection(s, {
      [m === "anchor" ? "anchor" : "focus"]: _objectSpread$1(_objectSpread$1({}, le), u)
    });
  }
}, setSelection = (o, s) => {
  var {
    selection: u
  } = o, l = {}, h = {};
  if (u) {
    for (var m in s)
      (m === "anchor" && s.anchor != null && !Point$1.equals(s.anchor, u.anchor) || m === "focus" && s.focus != null && !Point$1.equals(s.focus, u.focus) || m !== "anchor" && m !== "focus" && s[m] !== u[m]) && (l[m] = u[m], h[m] = s[m]);
    Object.keys(l).length > 0 && o.apply({
      type: "set_selection",
      properties: l,
      newProperties: h
    });
  }
}, insertNodes = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      hanging: h = !1,
      voids: m = !1,
      mode: C = "lowest",
      batchDirty: O = !0
    } = l, {
      at: le,
      match: We,
      select: ye
    } = l;
    if (Node.isNode(u) && (u = [u]), u.length !== 0) {
      var [Fe] = u;
      if (le || (le = getDefaultInsertLocation(s), ye !== !1 && (ye = !0)), ye == null && (ye = !1), Range.isRange(le))
        if (h || (le = Editor.unhangRange(s, le, {
          voids: m
        })), Range.isCollapsed(le))
          le = le.anchor;
        else {
          var [, Ue] = Range.edges(le), Le = Editor.pointRef(s, Ue);
          Transforms.delete(s, {
            at: le
          }), le = Le.unref();
        }
      if (Point$1.isPoint(le)) {
        We == null && (Text$1.isText(Fe) ? We = (ht) => Text$1.isText(ht) : s.isInline(Fe) ? We = (ht) => Text$1.isText(ht) || Editor.isInline(s, ht) : We = (ht) => Element$3.isElement(ht) && Editor.isBlock(s, ht));
        var [Ze] = Editor.nodes(s, {
          at: le.path,
          match: We,
          mode: C,
          voids: m
        });
        if (Ze) {
          var [, Xe] = Ze, Je = Editor.pathRef(s, Xe), it = Editor.isEnd(s, le, Xe);
          Transforms.splitNodes(s, {
            at: le,
            match: We,
            mode: C,
            voids: m
          });
          var et = Je.unref();
          le = it ? Path.next(et) : et;
        } else
          return;
      }
      var at = Path.parent(le), $e = le[le.length - 1];
      if (!(!m && Editor.void(s, {
        at
      }))) {
        if (O) {
          var Ke = [], tt = Path.levels(at);
          batchDirtyPaths(s, () => {
            var ht = function() {
              var gt = at.concat($e);
              $e++;
              var bt = {
                type: "insert_node",
                path: gt,
                node: vt
              };
              s.apply(bt), le = Path.next(le), Ke.push(bt), Text$1.isText ? tt.push(...Array.from(Node.nodes(vt), (wt) => {
                var [, Ot] = wt;
                return gt.concat(Ot);
              })) : tt.push(gt);
            };
            for (var vt of u)
              ht();
          }, () => {
            updateDirtyPaths(s, tt, (ht) => {
              var vt = ht;
              for (var At of Ke)
                if (Path.operationCanTransformPath(At) && (vt = Path.transform(vt, At), !vt))
                  return null;
              return vt;
            });
          });
        } else
          for (var ut of u) {
            var st = at.concat($e);
            $e++, s.apply({
              type: "insert_node",
              path: st,
              node: ut
            }), le = Path.next(le);
          }
        if (le = Path.previous(le), ye) {
          var ot = Editor.end(s, le);
          ot && Transforms.select(s, ot);
        }
      }
    }
  });
}, liftNodes = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      at: l = s.selection,
      mode: h = "lowest",
      voids: m = !1
    } = u, {
      match: C
    } = u;
    if (C == null && (C = Path.isPath(l) ? matchPath(s, l) : ($e) => Element$3.isElement($e) && Editor.isBlock(s, $e)), !!l) {
      var O = Editor.nodes(s, {
        at: l,
        match: C,
        mode: h,
        voids: m
      }), le = Array.from(O, ($e) => {
        var [, Ke] = $e;
        return Editor.pathRef(s, Ke);
      });
      for (var We of le) {
        var ye = We.unref();
        if (ye.length < 2)
          throw new Error("Cannot lift node at a path [".concat(ye, "] because it has a depth of less than `2`."));
        var Fe = Editor.node(s, Path.parent(ye)), [Ue, Le] = Fe, Ze = ye[ye.length - 1], {
          length: Xe
        } = Ue.children;
        if (Xe === 1) {
          var Je = Path.next(Le);
          Transforms.moveNodes(s, {
            at: ye,
            to: Je,
            voids: m
          }), Transforms.removeNodes(s, {
            at: Le,
            voids: m
          });
        } else if (Ze === 0)
          Transforms.moveNodes(s, {
            at: ye,
            to: Le,
            voids: m
          });
        else if (Ze === Xe - 1) {
          var it = Path.next(Le);
          Transforms.moveNodes(s, {
            at: ye,
            to: it,
            voids: m
          });
        } else {
          var et = Path.next(ye), at = Path.next(Le);
          Transforms.splitNodes(s, {
            at: et,
            voids: m
          }), Transforms.moveNodes(s, {
            at: ye,
            to: at,
            voids: m
          });
        }
      }
    }
  });
}, _excluded$5 = ["text"], _excluded2 = ["children"], hasSingleChildNest = (o, s) => {
  if (Element$3.isElement(s)) {
    var u = s;
    return Editor.isVoid(o, s) ? !0 : u.children.length === 1 ? hasSingleChildNest(o, u.children[0]) : !1;
  } else
    return !Editor.isEditor(s);
}, mergeNodes = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      match: l,
      at: h = s.selection
    } = u, {
      hanging: m = !1,
      voids: C = !1,
      mode: O = "lowest"
    } = u;
    if (h) {
      if (l == null)
        if (Path.isPath(h)) {
          var [le] = Editor.parent(s, h);
          l = (ht) => le.children.includes(ht);
        } else
          l = (ht) => Element$3.isElement(ht) && Editor.isBlock(s, ht);
      if (!m && Range.isRange(h) && (h = Editor.unhangRange(s, h, {
        voids: C
      })), Range.isRange(h))
        if (Range.isCollapsed(h))
          h = h.anchor;
        else {
          var [, We] = Range.edges(h), ye = Editor.pointRef(s, We);
          Transforms.delete(s, {
            at: h
          }), h = ye.unref(), u.at == null && Transforms.select(s, h);
        }
      var [Fe] = Editor.nodes(s, {
        at: h,
        match: l,
        voids: C,
        mode: O
      }), Ue = Editor.previous(s, {
        at: h,
        match: l,
        voids: C,
        mode: O
      });
      if (!(!Fe || !Ue)) {
        var [Le, Ze] = Fe, [Xe, Je] = Ue;
        if (!(Ze.length === 0 || Je.length === 0)) {
          var it = Path.next(Je), et = Path.common(Ze, Je), at = Path.isSibling(Ze, Je), $e = Array.from(Editor.levels(s, {
            at: Ze
          }), (ht) => {
            var [vt] = ht;
            return vt;
          }).slice(et.length).slice(0, -1), Ke = Editor.above(s, {
            at: Ze,
            mode: "highest",
            match: (ht) => $e.includes(ht) && hasSingleChildNest(s, ht)
          }), tt = Ke && Editor.pathRef(s, Ke[1]), ut, st;
          if (Text$1.isText(Le) && Text$1.isText(Xe)) {
            var ot = _objectWithoutProperties$3(Le, _excluded$5);
            st = Xe.text.length, ut = ot;
          } else if (Element$3.isElement(Le) && Element$3.isElement(Xe)) {
            var ot = _objectWithoutProperties$3(Le, _excluded2);
            st = Xe.children.length, ut = ot;
          } else
            throw new Error("Cannot merge the node at path [".concat(Ze, "] with the previous sibling because it is not the same kind: ").concat(Scrubber.stringify(Le), " ").concat(Scrubber.stringify(Xe)));
          at || Transforms.moveNodes(s, {
            at: Ze,
            to: it,
            voids: C
          }), tt && Transforms.removeNodes(s, {
            at: tt.current,
            voids: C
          }), Element$3.isElement(Xe) && Editor.isEmpty(s, Xe) || Text$1.isText(Xe) && Xe.text === "" && Je[Je.length - 1] !== 0 ? Transforms.removeNodes(s, {
            at: Je,
            voids: C
          }) : s.apply({
            type: "merge_node",
            path: it,
            position: st,
            properties: ut
          }), tt && tt.unref();
        }
      }
    }
  });
}, moveNodes = (o, s) => {
  Editor.withoutNormalizing(o, () => {
    var {
      to: u,
      at: l = o.selection,
      mode: h = "lowest",
      voids: m = !1
    } = s, {
      match: C
    } = s;
    if (l) {
      C == null && (C = Path.isPath(l) ? matchPath(o, l) : (Le) => Element$3.isElement(Le) && Editor.isBlock(o, Le));
      var O = Editor.pathRef(o, u), le = Editor.nodes(o, {
        at: l,
        match: C,
        mode: h,
        voids: m
      }), We = Array.from(le, (Le) => {
        var [, Ze] = Le;
        return Editor.pathRef(o, Ze);
      });
      for (var ye of We) {
        var Fe = ye.unref(), Ue = O.current;
        Fe.length !== 0 && o.apply({
          type: "move_node",
          path: Fe,
          newPath: Ue
        }), O.current && Path.isSibling(Ue, Fe) && Path.isAfter(Ue, Fe) && (O.current = Path.next(O.current));
      }
      O.unref();
    }
  });
}, removeNodes = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      hanging: l = !1,
      voids: h = !1,
      mode: m = "lowest"
    } = u, {
      at: C = s.selection,
      match: O
    } = u;
    if (C) {
      O == null && (O = Path.isPath(C) ? matchPath(s, C) : (Le) => Element$3.isElement(Le) && Editor.isBlock(s, Le)), !l && Range.isRange(C) && (C = Editor.unhangRange(s, C, {
        voids: h
      }));
      var le = Editor.nodes(s, {
        at: C,
        match: O,
        mode: m,
        voids: h
      }), We = Array.from(le, (Le) => {
        var [, Ze] = Le;
        return Editor.pathRef(s, Ze);
      });
      for (var ye of We) {
        var Fe = ye.unref();
        if (Fe) {
          var [Ue] = Editor.node(s, Fe);
          s.apply({
            type: "remove_node",
            path: Fe,
            node: Ue
          });
        }
      }
    }
  });
}, setNodes = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      match: h,
      at: m = s.selection,
      compare: C,
      merge: O
    } = l, {
      hanging: le = !1,
      mode: We = "lowest",
      split: ye = !1,
      voids: Fe = !1
    } = l;
    if (m) {
      if (h == null && (h = Path.isPath(m) ? matchPath(s, m) : (st) => Element$3.isElement(st) && Editor.isBlock(s, st)), !le && Range.isRange(m) && (m = Editor.unhangRange(s, m, {
        voids: Fe
      })), ye && Range.isRange(m)) {
        if (Range.isCollapsed(m) && Editor.leaf(s, m.anchor)[0].text.length > 0)
          return;
        var Ue = Editor.rangeRef(s, m, {
          affinity: "inward"
        }), [Le, Ze] = Range.edges(m), Xe = We === "lowest" ? "lowest" : "highest", Je = Editor.isEnd(s, Ze, Ze.path);
        Transforms.splitNodes(s, {
          at: Ze,
          match: h,
          mode: Xe,
          voids: Fe,
          always: !Je
        });
        var it = Editor.isStart(s, Le, Le.path);
        Transforms.splitNodes(s, {
          at: Le,
          match: h,
          mode: Xe,
          voids: Fe,
          always: !it
        }), m = Ue.unref(), l.at == null && Transforms.select(s, m);
      }
      C || (C = (st, ot) => st !== ot);
      for (var [et, at] of Editor.nodes(s, {
        at: m,
        match: h,
        mode: We,
        voids: Fe
      })) {
        var $e = {}, Ke = {};
        if (at.length !== 0) {
          var tt = !1;
          for (var ut in u)
            ut === "children" || ut === "text" || C(u[ut], et[ut]) && (tt = !0, et.hasOwnProperty(ut) && ($e[ut] = et[ut]), O ? u[ut] != null && (Ke[ut] = O(et[ut], u[ut])) : u[ut] != null && (Ke[ut] = u[ut]));
          tt && s.apply({
            type: "set_node",
            path: at,
            properties: $e,
            newProperties: Ke
          });
        }
      }
    }
  });
}, deleteRange = (o, s) => {
  if (Range.isCollapsed(s))
    return s.anchor;
  var [, u] = Range.edges(s), l = Editor.pointRef(o, u);
  return Transforms.delete(o, {
    at: s
  }), l.unref();
}, splitNodes = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      mode: l = "lowest",
      voids: h = !1
    } = u, {
      match: m,
      at: C = s.selection,
      height: O = 0,
      always: le = !1
    } = u;
    if (m == null && (m = (nt) => Element$3.isElement(nt) && Editor.isBlock(s, nt)), Range.isRange(C) && (C = deleteRange(s, C)), Path.isPath(C)) {
      var We = C, ye = Editor.point(s, We), [Fe] = Editor.parent(s, We);
      m = (nt) => nt === Fe, O = ye.path.length - We.length + 1, C = ye, le = !0;
    }
    if (C) {
      var Ue = Editor.pointRef(s, C, {
        affinity: "backward"
      }), Le;
      try {
        var [Ze] = Editor.nodes(s, {
          at: C,
          match: m,
          mode: l,
          voids: h
        });
        if (!Ze)
          return;
        var Xe = Editor.void(s, {
          at: C,
          mode: "highest"
        }), Je = 0;
        if (!h && Xe) {
          var [it, et] = Xe;
          if (Element$3.isElement(it) && s.isInline(it)) {
            var at = Editor.after(s, et);
            if (!at) {
              var $e = {
                text: ""
              }, Ke = Path.next(et);
              Transforms.insertNodes(s, $e, {
                at: Ke,
                voids: h
              }), at = Editor.point(s, Ke);
            }
            C = at, le = !0;
          }
          var tt = C.path.length - et.length;
          O = tt + 1, le = !0;
        }
        Le = Editor.pointRef(s, C);
        var ut = C.path.length - O, [, st] = Ze, ot = C.path.slice(0, ut), ht = O === 0 ? C.offset : C.path[ut] + Je;
        for (var [vt, At] of Editor.levels(s, {
          at: ot,
          reverse: !0,
          voids: h
        })) {
          var gt = !1;
          if (At.length < st.length || At.length === 0 || !h && Element$3.isElement(vt) && Editor.isVoid(s, vt))
            break;
          var bt = Ue.current, wt = Editor.isEnd(s, bt, At);
          if (le || !Ue || !Editor.isEdge(s, bt, At)) {
            gt = !0;
            var Ot = Node.extractProps(vt);
            s.apply({
              type: "split_node",
              path: At,
              position: ht,
              properties: Ot
            });
          }
          ht = At[At.length - 1] + (gt || wt ? 1 : 0);
        }
        if (u.at == null) {
          var yt = Le.current || Editor.end(s, []);
          Transforms.select(s, yt);
        }
      } finally {
        var Qe;
        Ue.unref(), (Qe = Le) === null || Qe === void 0 || Qe.unref();
      }
    }
  });
}, unsetNodes = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Array.isArray(u) || (u = [u]);
  var h = {};
  for (var m of u)
    h[m] = null;
  Transforms.setNodes(s, h, l);
}, unwrapNodes = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      mode: l = "lowest",
      split: h = !1,
      voids: m = !1
    } = u, {
      at: C = s.selection,
      match: O
    } = u;
    if (C) {
      O == null && (O = Path.isPath(C) ? matchPath(s, C) : (Le) => Element$3.isElement(Le) && Editor.isBlock(s, Le)), Path.isPath(C) && (C = Editor.range(s, C));
      var le = Range.isRange(C) ? Editor.rangeRef(s, C) : null, We = Editor.nodes(s, {
        at: C,
        match: O,
        mode: l,
        voids: m
      }), ye = Array.from(
        We,
        (Le) => {
          var [, Ze] = Le;
          return Editor.pathRef(s, Ze);
        }
        // unwrapNode will call liftNode which does not support splitting the node when nested.
        // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
        // that wrap target node. So we reverse the order.
      ).reverse(), Fe = function() {
        var Ze = Ue.unref(), [Xe] = Editor.node(s, Ze), Je = Editor.range(s, Ze);
        h && le && (Je = Range.intersection(le.current, Je)), Transforms.liftNodes(s, {
          at: Je,
          match: (it) => Element$3.isAncestor(Xe) && Xe.children.includes(it),
          voids: m
        });
      };
      for (var Ue of ye)
        Fe();
      le && le.unref();
    }
  });
};
function ownKeys$f(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread$f(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$f(Object(u), !0).forEach(function(l) {
      _defineProperty$4(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$f(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var wrapNodes = function(s, u) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Editor.withoutNormalizing(s, () => {
    var {
      mode: h = "lowest",
      split: m = !1,
      voids: C = !1
    } = l, {
      match: O,
      at: le = s.selection
    } = l;
    if (le) {
      if (O == null && (Path.isPath(le) ? O = matchPath(s, le) : s.isInline(u) ? O = (Je) => Element$3.isElement(Je) && Editor.isInline(s, Je) || Text$1.isText(Je) : O = (Je) => Element$3.isElement(Je) && Editor.isBlock(s, Je)), m && Range.isRange(le)) {
        var [We, ye] = Range.edges(le), Fe = Editor.rangeRef(s, le, {
          affinity: "inward"
        });
        Transforms.splitNodes(s, {
          at: ye,
          match: O,
          voids: C
        }), Transforms.splitNodes(s, {
          at: We,
          match: O,
          voids: C
        }), le = Fe.unref(), l.at == null && Transforms.select(s, le);
      }
      var Ue = Array.from(Editor.nodes(s, {
        at: le,
        match: s.isInline(u) ? (Je) => Element$3.isElement(Je) && Editor.isBlock(s, Je) : (Je) => Editor.isEditor(Je),
        mode: "lowest",
        voids: C
      })), Le = function() {
        var it = Range.isRange(le) ? Range.intersection(le, Editor.range(s, Xe)) : le;
        if (!it)
          return 0;
        var et = Array.from(Editor.nodes(s, {
          at: it,
          match: O,
          mode: h,
          voids: C
        }));
        if (et.length > 0) {
          var [at] = et, $e = et[et.length - 1], [, Ke] = at, [, tt] = $e;
          if (Ke.length === 0 && tt.length === 0)
            return 0;
          var ut = Path.equals(Ke, tt) ? Path.parent(Ke) : Path.common(Ke, tt), st = Editor.range(s, Ke, tt), ot = Editor.node(s, ut), [ht] = ot, vt = ut.length + 1, At = Path.next(tt.slice(0, vt)), gt = _objectSpread$f(_objectSpread$f({}, u), {}, {
            children: []
          });
          Transforms.insertNodes(s, gt, {
            at: At,
            voids: C
          }), Transforms.moveNodes(s, {
            at: st,
            match: (bt) => Element$3.isAncestor(ht) && ht.children.includes(bt),
            to: At.concat(0),
            voids: C
          });
        }
      }, Ze;
      for (var [, Xe] of Ue)
        Ze = Le();
    }
  });
}, createEditor = () => {
  var o = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isElementReadOnly: () => !1,
    isInline: () => !1,
    isSelectable: () => !0,
    isVoid: () => !1,
    markableVoid: () => !1,
    onChange: () => {
    },
    // Core
    apply: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return apply(o, ...l);
    },
    // Editor
    addMark: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return addMark(o, ...l);
    },
    deleteBackward: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return deleteBackward(o, ...l);
    },
    deleteForward: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return deleteForward(o, ...l);
    },
    deleteFragment: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return deleteFragment(o, ...l);
    },
    getFragment: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return getFragment(o, ...l);
    },
    insertBreak: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return insertBreak(o, ...l);
    },
    insertSoftBreak: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return insertSoftBreak(o, ...l);
    },
    insertFragment: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return insertFragment(o, ...l);
    },
    insertNode: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return insertNode(o, ...l);
    },
    insertText: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return insertText(o, ...l);
    },
    normalizeNode: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return normalizeNode(o, ...l);
    },
    removeMark: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return removeMark(o, ...l);
    },
    getDirtyPaths: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return getDirtyPaths(o, ...l);
    },
    shouldNormalize: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return shouldNormalize(o, ...l);
    },
    // Editor interface
    above: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return above(o, ...l);
    },
    after: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return after(o, ...l);
    },
    before: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return before(o, ...l);
    },
    collapse: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return collapse(o, ...l);
    },
    delete: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return deleteText(o, ...l);
    },
    deselect: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return deselect(o, ...l);
    },
    edges: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return edges(o, ...l);
    },
    elementReadOnly: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return elementReadOnly(o, ...l);
    },
    end: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return end$1(o, ...l);
    },
    first: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return first(o, ...l);
    },
    fragment: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return fragment(o, ...l);
    },
    getMarks: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return marks(o, ...l);
    },
    hasBlocks: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return hasBlocks(o, ...l);
    },
    hasInlines: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return hasInlines(o, ...l);
    },
    hasPath: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return hasPath(o, ...l);
    },
    hasTexts: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return hasTexts(o, ...l);
    },
    insertNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return insertNodes(o, ...l);
    },
    isBlock: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return isBlock(o, ...l);
    },
    isEdge: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return isEdge$1(o, ...l);
    },
    isEmpty: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return isEmpty(o, ...l);
    },
    isEnd: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return isEnd(o, ...l);
    },
    isNormalizing: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return isNormalizing(o, ...l);
    },
    isStart: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return isStart(o, ...l);
    },
    last: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return last(o, ...l);
    },
    leaf: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return leaf(o, ...l);
    },
    levels: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return levels(o, ...l);
    },
    liftNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return liftNodes(o, ...l);
    },
    mergeNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return mergeNodes(o, ...l);
    },
    move: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return move(o, ...l);
    },
    moveNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return moveNodes(o, ...l);
    },
    next: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return next(o, ...l);
    },
    node: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return node(o, ...l);
    },
    nodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return nodes(o, ...l);
    },
    normalize: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return normalize(o, ...l);
    },
    parent: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return parent(o, ...l);
    },
    path: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return path(o, ...l);
    },
    pathRef: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return pathRef(o, ...l);
    },
    pathRefs: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return pathRefs(o, ...l);
    },
    point: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return point$1(o, ...l);
    },
    pointRef: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return pointRef(o, ...l);
    },
    pointRefs: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return pointRefs(o, ...l);
    },
    positions: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return positions(o, ...l);
    },
    previous: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return previous(o, ...l);
    },
    range: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return range(o, ...l);
    },
    rangeRef: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return rangeRef(o, ...l);
    },
    rangeRefs: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return rangeRefs(o, ...l);
    },
    removeNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return removeNodes(o, ...l);
    },
    select: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return select(o, ...l);
    },
    setNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return setNodes(o, ...l);
    },
    setNormalizing: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return setNormalizing(o, ...l);
    },
    setPoint: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return setPoint(o, ...l);
    },
    setSelection: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return setSelection(o, ...l);
    },
    splitNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return splitNodes(o, ...l);
    },
    start: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return start(o, ...l);
    },
    string: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return string(o, ...l);
    },
    unhangRange: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return unhangRange(o, ...l);
    },
    unsetNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return unsetNodes(o, ...l);
    },
    unwrapNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return unwrapNodes(o, ...l);
    },
    void: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return getVoid(o, ...l);
    },
    withoutNormalizing: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return withoutNormalizing(o, ...l);
    },
    wrapNodes: function() {
      for (var u = arguments.length, l = new Array(u), h = 0; h < u; h++)
        l[h] = arguments[h];
      return wrapNodes(o, ...l);
    }
  };
  return o;
};
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObject$5(o) {
  return o != null && typeof o == "object" && Array.isArray(o) === !1;
}
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function isObjectObject(o) {
  return isObject$5(o) === !0 && Object.prototype.toString.call(o) === "[object Object]";
}
function isPlainObject(o) {
  var s, u;
  return !(isObjectObject(o) === !1 || (s = o.constructor, typeof s != "function") || (u = s.prototype, isObjectObject(u) === !1) || u.hasOwnProperty("isPrototypeOf") === !1);
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
function getAugmentedNamespace(o) {
  if (o.__esModule)
    return o;
  var s = o.default;
  if (typeof s == "function") {
    var u = function l() {
      return this instanceof l ? Reflect.construct(s, arguments, this.constructor) : s.apply(this, arguments);
    };
    u.prototype = s.prototype;
  } else
    u = {};
  return Object.defineProperty(u, "__esModule", {
    value: !0
  }), Object.keys(o).forEach(function(l) {
    var h = Object.getOwnPropertyDescriptor(o, l);
    Object.defineProperty(u, l, h.get ? h : {
      enumerable: !0,
      get: function() {
        return o[l];
      }
    });
  }), u;
}
function isObject$4(o) {
  var s = typeof o;
  return o != null && (s == "object" || s == "function");
}
var isObject_1 = isObject$4, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$2 = freeGlobal || freeSelf || Function("return this")(), _root = root$2, root$1 = _root, now$2 = function() {
  return root$1.Date.now();
}, now_1 = now$2, reWhitespace = /\s/;
function trimmedEndIndex$1(o) {
  for (var s = o.length; s-- && reWhitespace.test(o.charAt(s)); )
    ;
  return s;
}
var _trimmedEndIndex = trimmedEndIndex$1, trimmedEndIndex = _trimmedEndIndex, reTrimStart = /^\s+/;
function baseTrim$1(o) {
  return o && o.slice(0, trimmedEndIndex(o) + 1).replace(reTrimStart, "");
}
var _baseTrim = baseTrim$1, root = _root, Symbol$3 = root.Symbol, _Symbol = Symbol$3, Symbol$2 = _Symbol, objectProto$1 = Object.prototype, hasOwnProperty = objectProto$1.hasOwnProperty, nativeObjectToString$1 = objectProto$1.toString, symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(o) {
  var s = hasOwnProperty.call(o, symToStringTag$1), u = o[symToStringTag$1];
  try {
    o[symToStringTag$1] = void 0;
    var l = !0;
  } catch {
  }
  var h = nativeObjectToString$1.call(o);
  return l && (s ? o[symToStringTag$1] = u : delete o[symToStringTag$1]), h;
}
var _getRawTag = getRawTag$1, objectProto = Object.prototype, nativeObjectToString = objectProto.toString;
function objectToString$1(o) {
  return nativeObjectToString.call(o);
}
var _objectToString = objectToString$1, Symbol$1 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag$1(o) {
  return o == null ? o === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(o) ? getRawTag(o) : objectToString(o);
}
var _baseGetTag = baseGetTag$1;
function isObjectLike$1(o) {
  return o != null && typeof o == "object";
}
var isObjectLike_1 = isObjectLike$1, baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1, symbolTag = "[object Symbol]";
function isSymbol$1(o) {
  return typeof o == "symbol" || isObjectLike(o) && baseGetTag(o) == symbolTag;
}
var isSymbol_1 = isSymbol$1, baseTrim = _baseTrim, isObject$3 = isObject_1, isSymbol = isSymbol_1, NAN = 0 / 0, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber$1(o) {
  if (typeof o == "number")
    return o;
  if (isSymbol(o))
    return NAN;
  if (isObject$3(o)) {
    var s = typeof o.valueOf == "function" ? o.valueOf() : o;
    o = isObject$3(s) ? s + "" : s;
  }
  if (typeof o != "string")
    return o === 0 ? o : +o;
  o = baseTrim(o);
  var u = reIsBinary.test(o);
  return u || reIsOctal.test(o) ? freeParseInt(o.slice(2), u ? 2 : 8) : reIsBadHex.test(o) ? NAN : +o;
}
var toNumber_1 = toNumber$1, isObject$2 = isObject_1, now$1 = now_1, toNumber = toNumber_1, FUNC_ERROR_TEXT$1 = "Expected a function", nativeMax = Math.max, nativeMin = Math.min;
function debounce$1(o, s, u) {
  var l, h, m, C, O, le, We = 0, ye = !1, Fe = !1, Ue = !0;
  if (typeof o != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  s = toNumber(s) || 0, isObject$2(u) && (ye = !!u.leading, Fe = "maxWait" in u, m = Fe ? nativeMax(toNumber(u.maxWait) || 0, s) : m, Ue = "trailing" in u ? !!u.trailing : Ue);
  function Le(tt) {
    var ut = l, st = h;
    return l = h = void 0, We = tt, C = o.apply(st, ut), C;
  }
  function Ze(tt) {
    return We = tt, O = setTimeout(it, s), ye ? Le(tt) : C;
  }
  function Xe(tt) {
    var ut = tt - le, st = tt - We, ot = s - ut;
    return Fe ? nativeMin(ot, m - st) : ot;
  }
  function Je(tt) {
    var ut = tt - le, st = tt - We;
    return le === void 0 || ut >= s || ut < 0 || Fe && st >= m;
  }
  function it() {
    var tt = now$1();
    if (Je(tt))
      return et(tt);
    O = setTimeout(it, Xe(tt));
  }
  function et(tt) {
    return O = void 0, Ue && l ? Le(tt) : (l = h = void 0, C);
  }
  function at() {
    O !== void 0 && clearTimeout(O), We = 0, l = le = h = O = void 0;
  }
  function $e() {
    return O === void 0 ? C : et(now$1());
  }
  function Ke() {
    var tt = now$1(), ut = Je(tt);
    if (l = arguments, h = this, le = tt, ut) {
      if (O === void 0)
        return Ze(le);
      if (Fe)
        return clearTimeout(O), O = setTimeout(it, s), Le(le);
    }
    return O === void 0 && (O = setTimeout(it, s)), C;
  }
  return Ke.cancel = at, Ke.flush = $e, Ke;
}
var debounce_1 = debounce$1, debounce = debounce_1, isObject$1 = isObject_1, FUNC_ERROR_TEXT = "Expected a function";
function throttle(o, s, u) {
  var l = !0, h = !0;
  if (typeof o != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return isObject$1(u) && (l = "leading" in u ? !!u.leading : l, h = "trailing" in u ? !!u.trailing : h), debounce(o, s, {
    leading: l,
    maxWait: s,
    trailing: h
  });
}
var throttle_1 = throttle;
const throttle$1 = /* @__PURE__ */ getDefaultExportFromCjs(throttle_1);
function t(o) {
  return typeof o == "object" && o != null && o.nodeType === 1;
}
function e(o, s) {
  return (!s || o !== "hidden") && o !== "visible" && o !== "clip";
}
function n$1(o, s) {
  if (o.clientHeight < o.scrollHeight || o.clientWidth < o.scrollWidth) {
    var u = getComputedStyle(o, null);
    return e(u.overflowY, s) || e(u.overflowX, s) || function(l) {
      var h = function(m) {
        if (!m.ownerDocument || !m.ownerDocument.defaultView)
          return null;
        try {
          return m.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(l);
      return !!h && (h.clientHeight < l.scrollHeight || h.clientWidth < l.scrollWidth);
    }(o);
  }
  return !1;
}
function r(o, s, u, l, h, m, C, O) {
  return m < o && C > s || m > o && C < s ? 0 : m <= o && O <= u || C >= s && O >= u ? m - o - l : C > s && O < u || m < o && O > u ? C - s + h : 0;
}
var i$1 = function(o, s) {
  var u = window, l = s.scrollMode, h = s.block, m = s.inline, C = s.boundary, O = s.skipOverflowHiddenElements, le = typeof C == "function" ? C : function(Dt) {
    return Dt !== C;
  };
  if (!t(o))
    throw new TypeError("Invalid target");
  for (var We, ye, Fe = document.scrollingElement || document.documentElement, Ue = [], Le = o; t(Le) && le(Le); ) {
    if ((Le = (ye = (We = Le).parentElement) == null ? We.getRootNode().host || null : ye) === Fe) {
      Ue.push(Le);
      break;
    }
    Le != null && Le === document.body && n$1(Le) && !n$1(document.documentElement) || Le != null && n$1(Le, O) && Ue.push(Le);
  }
  for (var Ze = u.visualViewport ? u.visualViewport.width : innerWidth, Xe = u.visualViewport ? u.visualViewport.height : innerHeight, Je = window.scrollX || pageXOffset, it = window.scrollY || pageYOffset, et = o.getBoundingClientRect(), at = et.height, $e = et.width, Ke = et.top, tt = et.right, ut = et.bottom, st = et.left, ot = h === "start" || h === "nearest" ? Ke : h === "end" ? ut : Ke + at / 2, ht = m === "center" ? st + $e / 2 : m === "end" ? tt : st, vt = [], At = 0; At < Ue.length; At++) {
    var gt = Ue[At], bt = gt.getBoundingClientRect(), wt = bt.height, Ot = bt.width, yt = bt.top, Qe = bt.right, nt = bt.bottom, rt = bt.left;
    if (l === "if-needed" && Ke >= 0 && st >= 0 && ut <= Xe && tt <= Ze && Ke >= yt && ut <= nt && st >= rt && tt <= Qe)
      return vt;
    var lt = getComputedStyle(gt), ct = parseInt(lt.borderLeftWidth, 10), ft = parseInt(lt.borderTopWidth, 10), pt = parseInt(lt.borderRightWidth, 10), mt = parseInt(lt.borderBottomWidth, 10), dt = 0, Et = 0, Ct = "offsetWidth" in gt ? gt.offsetWidth - gt.clientWidth - ct - pt : 0, Tt = "offsetHeight" in gt ? gt.offsetHeight - gt.clientHeight - ft - mt : 0, qt = "offsetWidth" in gt ? gt.offsetWidth === 0 ? 0 : Ot / gt.offsetWidth : 0, jt = "offsetHeight" in gt ? gt.offsetHeight === 0 ? 0 : wt / gt.offsetHeight : 0;
    if (Fe === gt)
      dt = h === "start" ? ot : h === "end" ? ot - Xe : h === "nearest" ? r(it, it + Xe, Xe, ft, mt, it + ot, it + ot + at, at) : ot - Xe / 2, Et = m === "start" ? ht : m === "center" ? ht - Ze / 2 : m === "end" ? ht - Ze : r(Je, Je + Ze, Ze, ct, pt, Je + ht, Je + ht + $e, $e), dt = Math.max(0, dt + it), Et = Math.max(0, Et + Je);
    else {
      dt = h === "start" ? ot - yt - ft : h === "end" ? ot - nt + mt + Tt : h === "nearest" ? r(yt, nt, wt, ft, mt + Tt, ot, ot + at, at) : ot - (yt + wt / 2) + Tt / 2, Et = m === "start" ? ht - rt - ct : m === "center" ? ht - (rt + Ot / 2) + Ct / 2 : m === "end" ? ht - Qe + pt + Ct : r(rt, Qe, Ot, ct, pt + Ct, ht, ht + $e, $e);
      var St = gt.scrollLeft, Mt = gt.scrollTop;
      ot += Mt - (dt = Math.max(0, Math.min(Mt + dt / jt, gt.scrollHeight - wt / jt + Tt))), ht += St - (Et = Math.max(0, Math.min(St + Et / qt, gt.scrollWidth - Ot / qt + Ct)));
    }
    vt.push({
      el: gt,
      top: dt,
      left: Et
    });
  }
  return vt;
};
function isOptionsObject(o) {
  return o === Object(o) && Object.keys(o).length !== 0;
}
function defaultBehavior(o, s) {
  s === void 0 && (s = "auto");
  var u = "scrollBehavior" in document.body.style;
  o.forEach(function(l) {
    var h = l.el, m = l.top, C = l.left;
    h.scroll && u ? h.scroll({
      top: m,
      left: C,
      behavior: s
    }) : (h.scrollTop = m, h.scrollLeft = C);
  });
}
function getOptions(o) {
  return o === !1 ? {
    block: "end",
    inline: "nearest"
  } : isOptionsObject(o) ? o : {
    block: "start",
    inline: "nearest"
  };
}
function scrollIntoView(o, s) {
  var u = o.isConnected || o.ownerDocument.documentElement.contains(o);
  if (isOptionsObject(s) && typeof s.behavior == "function")
    return s.behavior(u ? i$1(o, s) : []);
  if (u) {
    var l = getOptions(s);
    return defaultBehavior(i$1(o, l), l.behavior);
  }
}
var direction_1 = direction, RTL = "֑-߿יִ-﷽ﹰ-ﻼ", LTR = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", rtl = new RegExp("^[^" + LTR + "]*[" + RTL + "]"), ltr = new RegExp("^[^" + RTL + "]*[" + LTR + "]");
function direction(o) {
  return o = String(o || ""), rtl.test(o) ? "rtl" : ltr.test(o) ? "ltr" : "neutral";
}
const getDirection = /* @__PURE__ */ getDefaultExportFromCjs(direction_1);
var lib$1 = {};
Object.defineProperty(lib$1, "__esModule", {
  value: !0
});
var IS_MAC = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), MODIFIERS = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, ALIASES = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: IS_MAC ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var f = 1; f < 20; f++)
  CODES["f" + f] = 111 + f;
function isHotkey(o, s, u) {
  s && !("byKey" in s) && (u = s, s = null), Array.isArray(o) || (o = [o]);
  var l = o.map(function(C) {
    return parseHotkey(C, s);
  }), h = function(O) {
    return l.some(function(le) {
      return compareHotkey(le, O);
    });
  }, m = u == null ? h : h(u);
  return m;
}
function isCodeHotkey(o, s) {
  return isHotkey(o, s);
}
function isKeyHotkey(o, s) {
  return isHotkey(o, {
    byKey: !0
  }, s);
}
function parseHotkey(o, s) {
  var u = s && s.byKey, l = {};
  o = o.replace("++", "+add");
  var h = o.split("+"), m = h.length;
  for (var C in MODIFIERS)
    l[MODIFIERS[C]] = !1;
  var O = !0, le = !1, We = void 0;
  try {
    for (var ye = h[Symbol.iterator](), Fe; !(O = (Fe = ye.next()).done); O = !0) {
      var Ue = Fe.value, Le = Ue.endsWith("?") && Ue.length > 1;
      Le && (Ue = Ue.slice(0, -1));
      var Ze = toKeyName(Ue), Xe = MODIFIERS[Ze];
      (m === 1 || !Xe) && (u ? l.key = Ze : l.which = toKeyCode(Ue)), Xe && (l[Xe] = Le ? null : !0);
    }
  } catch (Je) {
    le = !0, We = Je;
  } finally {
    try {
      !O && ye.return && ye.return();
    } finally {
      if (le)
        throw We;
    }
  }
  return l;
}
function compareHotkey(o, s) {
  for (var u in o) {
    var l = o[u], h = void 0;
    if (l != null && (u === "key" && s.key != null ? h = s.key.toLowerCase() : u === "which" ? h = l === 91 && s.which === 93 ? 91 : s.which : h = s[u], !(h == null && l === !1) && h !== l))
      return !1;
  }
  return !0;
}
function toKeyCode(o) {
  o = toKeyName(o);
  var s = CODES[o] || o.toUpperCase().charCodeAt(0);
  return s;
}
function toKeyName(o) {
  return o = o.toLowerCase(), o = ALIASES[o] || o, o;
}
lib$1.default = isHotkey;
lib$1.isHotkey = isHotkey;
lib$1.isCodeHotkey = isCodeHotkey;
var isKeyHotkey_1 = lib$1.isKeyHotkey = isKeyHotkey;
lib$1.parseHotkey = parseHotkey;
lib$1.compareHotkey = compareHotkey;
lib$1.toKeyCode = toKeyCode;
lib$1.toKeyName = toKeyName;
function _defineProperty$3(o, s, u) {
  return s in o ? Object.defineProperty(o, s, {
    value: u,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[s] = u, o;
}
function _objectWithoutPropertiesLoose$2(o, s) {
  if (o == null)
    return {};
  var u = {}, l = Object.keys(o), h, m;
  for (m = 0; m < l.length; m++)
    h = l[m], !(s.indexOf(h) >= 0) && (u[h] = o[h]);
  return u;
}
function _objectWithoutProperties$2(o, s) {
  if (o == null)
    return {};
  var u = _objectWithoutPropertiesLoose$2(o, s), l, h;
  if (Object.getOwnPropertySymbols) {
    var m = Object.getOwnPropertySymbols(o);
    for (h = 0; h < m.length; h++)
      l = m[h], !(s.indexOf(l) >= 0) && Object.prototype.propertyIsEnumerable.call(o, l) && (u[l] = o[l]);
  }
  return u;
}
var History$1 = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(o) {
    return isPlainObject(o) && Array.isArray(o.redos) && Array.isArray(o.undos) && (o.redos.length === 0 || Operation.isOperationList(o.redos[0])) && (o.undos.length === 0 || Operation.isOperationList(o.undos[0]));
  }
}, SAVING$1 = /* @__PURE__ */ new WeakMap(), MERGING$1 = /* @__PURE__ */ new WeakMap(), HistoryEditor$1 = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(o) {
    return History$1.isHistory(o.history) && Editor.isEditor(o);
  },
  /**
   * Get the merge flag's current value.
   */
  isMerging(o) {
    return MERGING$1.get(o);
  },
  /**
   * Get the saving flag's current value.
   */
  isSaving(o) {
    return SAVING$1.get(o);
  },
  /**
   * Redo to the previous saved state.
   */
  redo(o) {
    o.redo();
  },
  /**
   * Undo to the previous saved state.
   */
  undo(o) {
    o.undo();
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(o, s) {
    var u = HistoryEditor$1.isMerging(o);
    MERGING$1.set(o, !1), s(), MERGING$1.set(o, u);
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(o, s) {
    var u = HistoryEditor$1.isSaving(o);
    SAVING$1.set(o, !1), s(), SAVING$1.set(o, u);
  }
}, String$1 = (o) => {
  var {
    isLast: s,
    leaf: u,
    parent: l,
    text: h
  } = o, m = useSlateStatic(), C = ReactEditor.findPath(m, h), O = Path.parent(C);
  return m.isVoid(l) ? /* @__PURE__ */ React$1.createElement(ZeroWidthString, {
    length: Node.string(l).length
  }) : u.text === "" && l.children[l.children.length - 1] === h && !m.isInline(l) && Editor.string(m, O) === "" ? /* @__PURE__ */ React$1.createElement(ZeroWidthString, {
    isLineBreak: !0
  }) : u.text === "" ? /* @__PURE__ */ React$1.createElement(ZeroWidthString, null) : s && u.text.slice(-1) === `
` ? /* @__PURE__ */ React$1.createElement(TextString, {
    isTrailing: !0,
    text: u.text
  }) : /* @__PURE__ */ React$1.createElement(TextString, {
    text: u.text
  });
}, TextString = (o) => {
  var {
    text: s,
    isTrailing: u = !1
  } = o;
  return /* @__PURE__ */ React$1.createElement("span", {
    "data-slate-string": !0
  }, s, u ? `
` : null);
}, ZeroWidthString = (o) => {
  var {
    length: s = 0,
    isLineBreak: u = !1
  } = o;
  return /* @__PURE__ */ React$1.createElement("span", {
    "data-slate-zero-width": u ? "n" : "z",
    "data-slate-length": s
  }, "\uFEFF", u ? /* @__PURE__ */ React$1.createElement("br", null) : null);
}, NODE_TO_INDEX = /* @__PURE__ */ new WeakMap(), NODE_TO_PARENT = /* @__PURE__ */ new WeakMap(), EDITOR_TO_WINDOW = /* @__PURE__ */ new WeakMap(), EDITOR_TO_ELEMENT = /* @__PURE__ */ new WeakMap(), ELEMENT_TO_NODE = /* @__PURE__ */ new WeakMap(), KEY_TO_ELEMENT = /* @__PURE__ */ new WeakMap(), NODE_TO_ELEMENT = /* @__PURE__ */ new WeakMap(), NODE_TO_KEY = /* @__PURE__ */ new WeakMap(), IS_READ_ONLY = /* @__PURE__ */ new WeakMap(), IS_FOCUSED = /* @__PURE__ */ new WeakMap(), EDITOR_TO_ON_CHANGE = /* @__PURE__ */ new WeakMap(), PLACEHOLDER_SYMBOL = Symbol("placeholder"), Leaf$1 = (o) => {
  var {
    leaf: s,
    isLast: u,
    text: l,
    parent: h,
    renderLeaf: m = (le) => /* @__PURE__ */ React$1.createElement(DefaultLeaf, Object.assign({}, le))
  } = o, C = /* @__PURE__ */ React$1.createElement(String$1, {
    isLast: u,
    leaf: s,
    parent: h,
    text: l
  });
  s[PLACEHOLDER_SYMBOL] && (C = /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, /* @__PURE__ */ React$1.createElement("span", {
    contentEditable: !1,
    style: {
      pointerEvents: "none",
      display: "inline-block",
      width: "0",
      maxWidth: "100%",
      whiteSpace: "nowrap",
      opacity: "0.333",
      userSelect: "none",
      fontStyle: "normal",
      fontWeight: "normal",
      textDecoration: "none"
    }
  }, s.placeholder), C));
  var O = {
    "data-slate-leaf": !0
  };
  return m({
    attributes: O,
    children: C,
    leaf: s,
    text: l
  });
}, MemoizedLeaf = /* @__PURE__ */ React$1.memo(Leaf$1, (o, s) => s.parent === o.parent && s.isLast === o.isLast && s.renderLeaf === o.renderLeaf && s.text === o.text && Text$1.matches(s.leaf, o.leaf)), DefaultLeaf = (o) => {
  var {
    attributes: s,
    children: u
  } = o;
  return /* @__PURE__ */ React$1.createElement("span", Object.assign({}, s), u);
}, useIsomorphicLayoutEffect = typeof window < "u" ? useLayoutEffect : useEffect, Text = (o) => {
  for (var {
    decorations: s,
    isLast: u,
    parent: l,
    renderLeaf: h,
    text: m
  } = o, C = useSlateStatic(), O = useRef(null), le = Text$1.decorations(m, s), We = ReactEditor.findKey(C, m), ye = [], Fe = 0; Fe < le.length; Fe++) {
    var Ue = le[Fe];
    ye.push(/* @__PURE__ */ React$1.createElement(MemoizedLeaf, {
      isLast: u && Fe === le.length - 1,
      key: "".concat(We.id, "-").concat(Fe),
      leaf: Ue,
      text: m,
      parent: l,
      renderLeaf: h
    }));
  }
  return useIsomorphicLayoutEffect(() => {
    O.current ? (KEY_TO_ELEMENT.set(We, O.current), NODE_TO_ELEMENT.set(m, O.current), ELEMENT_TO_NODE.set(O.current, m)) : (KEY_TO_ELEMENT.delete(We), NODE_TO_ELEMENT.delete(m));
  }), /* @__PURE__ */ React$1.createElement("span", {
    "data-slate-node": "text",
    ref: O
  }, ye);
}, MemoizedText = /* @__PURE__ */ React$1.memo(Text, (o, s) => s.parent === o.parent && s.isLast === o.isLast && s.renderLeaf === o.renderLeaf && s.text === o.text), SelectedContext = /* @__PURE__ */ createContext(!1), Element$2 = (o) => {
  var {
    decorate: s,
    decorations: u,
    element: l,
    renderElement: h = (et) => /* @__PURE__ */ React$1.createElement(DefaultElement, Object.assign({}, et)),
    renderLeaf: m,
    selection: C
  } = o, O = useRef(null), le = useSlateStatic(), We = useReadOnly(), ye = le.isInline(l), Fe = ReactEditor.findKey(le, l), Ue = /* @__PURE__ */ React$1.createElement(Children, {
    decorate: s,
    decorations: u,
    node: l,
    renderElement: h,
    renderLeaf: m,
    selection: C
  }), Le = {
    "data-slate-node": "element",
    ref: O
  };
  if (ye && (Le["data-slate-inline"] = !0), !ye && Editor.hasInlines(le, l)) {
    var Ze = Node.string(l), Xe = getDirection(Ze);
    Xe === "rtl" && (Le.dir = Xe);
  }
  if (Editor.isVoid(le, l)) {
    Le["data-slate-void"] = !0, !We && ye && (Le.contentEditable = !1);
    var Je = ye ? "span" : "div", [[it]] = Node.texts(l);
    Ue = We ? null : /* @__PURE__ */ React$1.createElement(Je, {
      "data-slate-spacer": !0,
      style: {
        height: "0",
        color: "transparent",
        outline: "none",
        position: "absolute"
      }
    }, /* @__PURE__ */ React$1.createElement(MemoizedText, {
      decorations: [],
      isLast: !1,
      parent: l,
      text: it
    })), NODE_TO_INDEX.set(it, 0), NODE_TO_PARENT.set(it, l);
  }
  return useIsomorphicLayoutEffect(() => {
    O.current ? (KEY_TO_ELEMENT.set(Fe, O.current), NODE_TO_ELEMENT.set(l, O.current), ELEMENT_TO_NODE.set(O.current, l)) : (KEY_TO_ELEMENT.delete(Fe), NODE_TO_ELEMENT.delete(l));
  }), /* @__PURE__ */ React$1.createElement(SelectedContext.Provider, {
    value: !!C
  }, h({
    attributes: Le,
    children: Ue,
    element: l
  }));
}, MemoizedElement = /* @__PURE__ */ React$1.memo(Element$2, (o, s) => o.decorate === s.decorate && o.element === s.element && o.renderElement === s.renderElement && o.renderLeaf === s.renderLeaf && isRangeListEqual(o.decorations, s.decorations) && (o.selection === s.selection || !!o.selection && !!s.selection && Range.equals(o.selection, s.selection))), DefaultElement = (o) => {
  var {
    attributes: s,
    children: u,
    element: l
  } = o, h = useSlateStatic(), m = h.isInline(l) ? "span" : "div";
  return /* @__PURE__ */ React$1.createElement(m, Object.assign({}, s, {
    style: {
      position: "relative"
    }
  }), u);
}, isRangeListEqual = (o, s) => {
  if (o.length !== s.length)
    return !1;
  for (var u = 0; u < o.length; u++) {
    var l = o[u], h = s[u];
    if (!Range.equals(l, h))
      return !1;
  }
  return !0;
}, EditorContext = /* @__PURE__ */ createContext(null), useSlateStatic = () => {
  var o = useContext(EditorContext);
  if (!o)
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  return o;
}, Children = (o) => {
  for (var {
    decorate: s,
    decorations: u,
    node: l,
    renderElement: h,
    renderLeaf: m,
    selection: C
  } = o, O = useSlateStatic(), le = ReactEditor.findPath(O, l), We = [], ye = Element$3.isElement(l) && !O.isInline(l) && Editor.hasInlines(O, l), Fe = 0; Fe < l.children.length; Fe++) {
    var Ue = le.concat(Fe), Le = l.children[Fe], Ze = ReactEditor.findKey(O, Le), Xe = Editor.range(O, Ue), Je = C && Range.intersection(Xe, C), it = s([Le, Ue]);
    for (var et of u) {
      var at = Range.intersection(et, Xe);
      at && it.push(at);
    }
    Element$3.isElement(Le) ? We.push(/* @__PURE__ */ React$1.createElement(MemoizedElement, {
      decorate: s,
      decorations: it,
      element: Le,
      key: Ze.id,
      renderElement: h,
      renderLeaf: m,
      selection: Je
    })) : We.push(/* @__PURE__ */ React$1.createElement(MemoizedText, {
      decorations: it,
      key: Ze.id,
      isLast: ye && Fe === l.children.length - 1,
      parent: l,
      renderLeaf: m,
      text: Le
    })), NODE_TO_INDEX.set(Le, Fe), NODE_TO_PARENT.set(Le, l);
  }
  return /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, We);
}, IS_APPLE = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), IS_FIREFOX = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), IS_SAFARI = typeof navigator < "u" && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent), IS_EDGE_LEGACY = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])/i.test(navigator.userAgent), IS_CHROME_LEGACY = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])/i.test(navigator.userAgent), HOTKEYS = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  italic: "mod+i",
  splitBlock: "shift?+enter",
  undo: "mod+z"
}, APPLE_HOTKEYS = {
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
}, WINDOWS_HOTKEYS = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
}, create$1 = (o) => {
  var s = HOTKEYS[o], u = APPLE_HOTKEYS[o], l = WINDOWS_HOTKEYS[o], h = s && isKeyHotkey_1(s), m = u && isKeyHotkey_1(u), C = l && isKeyHotkey_1(l);
  return (O) => !!(h && h(O) || IS_APPLE && m && m(O) || !IS_APPLE && C && C(O));
}, Hotkeys = {
  isBold: create$1("bold"),
  isCompose: create$1("compose"),
  isMoveBackward: create$1("moveBackward"),
  isMoveForward: create$1("moveForward"),
  isDeleteBackward: create$1("deleteBackward"),
  isDeleteForward: create$1("deleteForward"),
  isDeleteLineBackward: create$1("deleteLineBackward"),
  isDeleteLineForward: create$1("deleteLineForward"),
  isDeleteWordBackward: create$1("deleteWordBackward"),
  isDeleteWordForward: create$1("deleteWordForward"),
  isExtendBackward: create$1("extendBackward"),
  isExtendForward: create$1("extendForward"),
  isExtendLineBackward: create$1("extendLineBackward"),
  isExtendLineForward: create$1("extendLineForward"),
  isItalic: create$1("italic"),
  isMoveLineBackward: create$1("moveLineBackward"),
  isMoveLineForward: create$1("moveLineForward"),
  isMoveWordBackward: create$1("moveWordBackward"),
  isMoveWordForward: create$1("moveWordForward"),
  isRedo: create$1("redo"),
  isSplitBlock: create$1("splitBlock"),
  isTransposeCharacter: create$1("transposeCharacter"),
  isUndo: create$1("undo")
}, ReadOnlyContext = /* @__PURE__ */ createContext(!1), useReadOnly = () => useContext(ReadOnlyContext), SlateContext = /* @__PURE__ */ createContext(null), useSlate = () => {
  var o = useContext(SlateContext);
  if (!o)
    throw new Error("The `useSlate` hook must be used inside the <SlateProvider> component's context.");
  var [s] = o;
  return s;
}, getDefaultView = (o) => o && o.ownerDocument && o.ownerDocument.defaultView || null, isDOMComment = (o) => isDOMNode(o) && o.nodeType === 8, isDOMElement = (o) => isDOMNode(o) && o.nodeType === 1, isDOMNode = (o) => {
  var s = getDefaultView(o);
  return !!s && o instanceof s.Node;
}, isDOMSelection = (o) => {
  var s = o && o.anchorNode && getDefaultView(o.anchorNode);
  return !!s && o instanceof s.Selection;
}, isDOMText = (o) => isDOMNode(o) && o.nodeType === 3, isPlainTextOnlyPaste = (o) => o.clipboardData && o.clipboardData.getData("text/plain") !== "" && o.clipboardData.types.length === 1, normalizeDOMPoint = (o) => {
  var [s, u] = o;
  if (isDOMElement(s) && s.childNodes.length) {
    var l = u === s.childNodes.length, h = l ? "backward" : "forward", m = l ? u - 1 : u;
    for (s = getEditableChild(s, m, h); isDOMElement(s) && s.childNodes.length; ) {
      var C = l ? s.childNodes.length - 1 : 0;
      s = getEditableChild(s, C, h);
    }
    u = l && s.textContent != null ? s.textContent.length : 0;
  }
  return [s, u];
}, getEditableChild = (o, s, u) => {
  for (var {
    childNodes: l
  } = o, h = l[s], m = s, C = !1, O = !1; (isDOMComment(h) || isDOMElement(h) && h.childNodes.length === 0 || isDOMElement(h) && h.getAttribute("contenteditable") === "false") && !(C && O); ) {
    if (m >= l.length) {
      C = !0, m = s - 1, u = "backward";
      continue;
    }
    if (m < 0) {
      O = !0, m = s + 1, u = "forward";
      continue;
    }
    h = l[m], m += u === "forward" ? 1 : -1;
  }
  return h;
}, getPlainText = (o) => {
  var s = "";
  if (isDOMText(o) && o.nodeValue)
    return o.nodeValue;
  if (isDOMElement(o)) {
    for (var u of Array.from(o.childNodes))
      s += getPlainText(u);
    var l = getComputedStyle(o).getPropertyValue("display");
    (l === "block" || l === "list" || o.tagName === "BR") && (s += `
`);
  }
  return s;
};
function ownKeys$3(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$3(Object(u), !0).forEach(function(l) {
      _defineProperty$3(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$3(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
var HAS_BEFORE_INPUT_SUPPORT = !(IS_FIREFOX || IS_EDGE_LEGACY || IS_CHROME_LEGACY), Editable = (o) => {
  var {
    autoFocus: s,
    decorate: u = defaultDecorate,
    onDOMBeforeInput: l,
    placeholder: h,
    readOnly: m = !1,
    renderElement: C,
    renderLeaf: O,
    style: le = {},
    as: We = "div"
  } = o, ye = _objectWithoutProperties$2(o, ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "style", "as"]), Fe = useSlate(), Ue = useRef(null);
  IS_READ_ONLY.set(Fe, m);
  var Le = useMemo(() => ({
    isComposing: !1,
    isUpdatingSelection: !1,
    latestElement: null
  }), []);
  useIsomorphicLayoutEffect(() => {
    var et;
    Ue.current && (et = getDefaultView(Ue.current)) ? (EDITOR_TO_WINDOW.set(Fe, et), EDITOR_TO_ELEMENT.set(Fe, Ue.current), NODE_TO_ELEMENT.set(Fe, Ue.current), ELEMENT_TO_NODE.set(Ue.current, Fe)) : NODE_TO_ELEMENT.delete(Fe);
  }), useIsomorphicLayoutEffect(() => {
    var {
      selection: et
    } = Fe, at = ReactEditor.getWindow(Fe), $e = at.getSelection();
    if (!(Le.isComposing || !$e || !ReactEditor.isFocused(Fe))) {
      var Ke = $e.type !== "None";
      if (!(!et && !Ke)) {
        var tt = EDITOR_TO_ELEMENT.get(Fe), ut = !1;
        if (tt.contains($e.anchorNode) && tt.contains($e.focusNode) && (ut = !0), !(Ke && ut && et && Range.equals(ReactEditor.toSlateRange(Fe, $e), et))) {
          var st = ReactEditor.toDOMNode(Fe, Fe);
          Le.isUpdatingSelection = !0;
          var ot = et && ReactEditor.toDOMRange(Fe, et);
          if (ot) {
            Range.isBackward(et) ? $e.setBaseAndExtent(ot.endContainer, ot.endOffset, ot.startContainer, ot.startOffset) : $e.setBaseAndExtent(ot.startContainer, ot.startOffset, ot.endContainer, ot.endOffset);
            var ht = ot.startContainer.parentElement;
            scrollIntoView(ht, {
              scrollMode: "if-needed",
              boundary: st
            });
          } else
            $e.removeAllRanges();
          setTimeout(() => {
            ot && IS_FIREFOX && st.focus(), Le.isUpdatingSelection = !1;
          });
        }
      }
    }
  }), useEffect(() => {
    Ue.current && s && Ue.current.focus();
  }, [s]);
  var Ze = useCallback((et) => {
    if (!m && hasEditableTarget(Fe, et.target) && !isDOMEventHandled(et, l)) {
      var {
        selection: at
      } = Fe, {
        inputType: $e
      } = et, Ke = et.dataTransfer || et.data || void 0;
      if ($e === "insertCompositionText" || $e === "deleteCompositionText")
        return;
      if (et.preventDefault(), !$e.startsWith("delete") || $e.startsWith("deleteBy")) {
        var [tt] = et.getTargetRanges();
        if (tt) {
          var ut = ReactEditor.toSlateRange(Fe, tt);
          (!at || !Range.equals(at, ut)) && Transforms.select(Fe, ut);
        }
      }
      if (at && Range.isExpanded(at) && $e.startsWith("delete")) {
        Editor.deleteFragment(Fe);
        return;
      }
      switch ($e) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag": {
          Editor.deleteFragment(Fe);
          break;
        }
        case "deleteContent":
        case "deleteContentForward": {
          Editor.deleteForward(Fe);
          break;
        }
        case "deleteContentBackward": {
          Editor.deleteBackward(Fe);
          break;
        }
        case "deleteEntireSoftLine": {
          Editor.deleteBackward(Fe, {
            unit: "line"
          }), Editor.deleteForward(Fe, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineBackward": {
          Editor.deleteBackward(Fe, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineBackward": {
          Editor.deleteBackward(Fe, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineForward": {
          Editor.deleteForward(Fe, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineForward": {
          Editor.deleteForward(Fe, {
            unit: "line"
          });
          break;
        }
        case "deleteWordBackward": {
          Editor.deleteBackward(Fe, {
            unit: "word"
          });
          break;
        }
        case "deleteWordForward": {
          Editor.deleteForward(Fe, {
            unit: "word"
          });
          break;
        }
        case "insertLineBreak":
        case "insertParagraph": {
          Editor.insertBreak(Fe);
          break;
        }
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          var st = ReactEditor.getWindow(Fe);
          Ke instanceof st.DataTransfer ? ReactEditor.insertData(Fe, Ke) : typeof Ke == "string" && Editor.insertText(Fe, Ke);
          break;
        }
      }
    }
  }, [m, l]);
  useIsomorphicLayoutEffect(() => (Ue.current && HAS_BEFORE_INPUT_SUPPORT && Ue.current.addEventListener("beforeinput", Ze), () => {
    Ue.current && HAS_BEFORE_INPUT_SUPPORT && Ue.current.removeEventListener("beforeinput", Ze);
  }), [Ze]);
  var Xe = useCallback(throttle$1(() => {
    if (!m && !Le.isComposing && !Le.isUpdatingSelection) {
      var et = ReactEditor.getWindow(Fe), {
        activeElement: at
      } = et.document, $e = ReactEditor.toDOMNode(Fe, Fe), Ke = et.getSelection();
      if (at === $e ? (Le.latestElement = at, IS_FOCUSED.set(Fe, !0)) : IS_FOCUSED.delete(Fe), !Ke)
        return Transforms.deselect(Fe);
      var {
        anchorNode: tt,
        focusNode: ut
      } = Ke, st = hasEditableTarget(Fe, tt) || isTargetInsideVoid(Fe, tt), ot = hasEditableTarget(Fe, ut) || isTargetInsideVoid(Fe, ut);
      if (st && ot) {
        var ht = ReactEditor.toSlateRange(Fe, Ke);
        Transforms.select(Fe, ht);
      } else
        Transforms.deselect(Fe);
    }
  }, 100), [m]);
  useIsomorphicLayoutEffect(() => {
    var et = ReactEditor.getWindow(Fe);
    return et.document.addEventListener("selectionchange", Xe), () => {
      et.document.removeEventListener("selectionchange", Xe);
    };
  }, [Xe]);
  var Je = u([Fe, []]);
  if (h && Fe.children.length === 1 && Array.from(Node.texts(Fe)).length === 1 && Node.string(Fe) === "") {
    var it = Editor.start(Fe, []);
    Je.push({
      [PLACEHOLDER_SYMBOL]: !0,
      placeholder: h,
      anchor: it,
      focus: it
    });
  }
  return /* @__PURE__ */ React$1.createElement(ReadOnlyContext.Provider, {
    value: m
  }, /* @__PURE__ */ React$1.createElement(
    We,
    Object.assign({
      "data-gramm": !1,
      role: m ? void 0 : "textbox"
    }, ye, {
      // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
      // have to use hacks to make these replacement-based features work.
      spellCheck: HAS_BEFORE_INPUT_SUPPORT ? ye.spellCheck : void 0,
      autoCorrect: HAS_BEFORE_INPUT_SUPPORT ? ye.autoCorrect : void 0,
      autoCapitalize: HAS_BEFORE_INPUT_SUPPORT ? ye.autoCapitalize : void 0,
      "data-slate-editor": !0,
      "data-slate-node": "value",
      contentEditable: m ? void 0 : !0,
      suppressContentEditableWarning: !0,
      ref: Ue,
      style: _objectSpread({
        // Prevent the default outline styles.
        outline: "none",
        // Preserve adjacent whitespace and new lines.
        whiteSpace: "pre-wrap",
        // Allow words to break if they are too long.
        wordWrap: "break-word"
      }, le),
      onBeforeInput: useCallback((et) => {
        if (!HAS_BEFORE_INPUT_SUPPORT && !m && !isEventHandled(et, ye.onBeforeInput) && hasEditableTarget(Fe, et.target)) {
          et.preventDefault();
          var at = et.data;
          Editor.insertText(Fe, at);
        }
      }, [m]),
      onBlur: useCallback((et) => {
        if (!(m || Le.isUpdatingSelection || !hasEditableTarget(Fe, et.target) || isEventHandled(et, ye.onBlur))) {
          var at = ReactEditor.getWindow(Fe);
          if (Le.latestElement !== at.document.activeElement) {
            var {
              relatedTarget: $e
            } = et, Ke = ReactEditor.toDOMNode(Fe, Fe);
            if ($e !== Ke && !(isDOMElement($e) && $e.hasAttribute("data-slate-spacer"))) {
              if ($e != null && isDOMNode($e) && ReactEditor.hasDOMNode(Fe, $e)) {
                var tt = ReactEditor.toSlateNode(Fe, $e);
                if (Element$3.isElement(tt) && !Fe.isVoid(tt))
                  return;
              }
              IS_FOCUSED.delete(Fe);
            }
          }
        }
      }, [m, ye.onBlur]),
      onClick: useCallback((et) => {
        if (!m && hasTarget(Fe, et.target) && !isEventHandled(et, ye.onClick) && isDOMNode(et.target)) {
          var at = ReactEditor.toSlateNode(Fe, et.target), $e = ReactEditor.findPath(Fe, at), Ke = Editor.start(Fe, $e), tt = Editor.end(Fe, $e), ut = Editor.void(Fe, {
            at: Ke
          }), st = Editor.void(Fe, {
            at: tt
          });
          if (ut && st && Path.equals(ut[1], st[1])) {
            var ot = Editor.range(Fe, Ke);
            Transforms.select(Fe, ot);
          }
        }
      }, [m, ye.onClick]),
      onCompositionEnd: useCallback((et) => {
        hasEditableTarget(Fe, et.target) && !isEventHandled(et, ye.onCompositionEnd) && (Le.isComposing = !1, !IS_SAFARI && !IS_FIREFOX && et.data && Editor.insertText(Fe, et.data));
      }, [ye.onCompositionEnd]),
      onCompositionStart: useCallback((et) => {
        hasEditableTarget(Fe, et.target) && !isEventHandled(et, ye.onCompositionStart) && (Le.isComposing = !0);
      }, [ye.onCompositionStart]),
      onCopy: useCallback((et) => {
        hasEditableTarget(Fe, et.target) && !isEventHandled(et, ye.onCopy) && (et.preventDefault(), ReactEditor.setFragmentData(Fe, et.clipboardData));
      }, [ye.onCopy]),
      onCut: useCallback((et) => {
        if (!m && hasEditableTarget(Fe, et.target) && !isEventHandled(et, ye.onCut)) {
          et.preventDefault(), ReactEditor.setFragmentData(Fe, et.clipboardData);
          var {
            selection: at
          } = Fe;
          at && Range.isExpanded(at) && Editor.deleteFragment(Fe);
        }
      }, [m, ye.onCut]),
      onDragOver: useCallback((et) => {
        if (hasTarget(Fe, et.target) && !isEventHandled(et, ye.onDragOver)) {
          var at = ReactEditor.toSlateNode(Fe, et.target);
          Editor.isVoid(Fe, at) && et.preventDefault();
        }
      }, [ye.onDragOver]),
      onDragStart: useCallback((et) => {
        if (hasTarget(Fe, et.target) && !isEventHandled(et, ye.onDragStart)) {
          var at = ReactEditor.toSlateNode(Fe, et.target), $e = ReactEditor.findPath(Fe, at), Ke = Editor.void(Fe, {
            at: $e
          });
          if (Ke) {
            var tt = Editor.range(Fe, $e);
            Transforms.select(Fe, tt);
          }
          ReactEditor.setFragmentData(Fe, et.dataTransfer);
        }
      }, [ye.onDragStart]),
      onDrop: useCallback((et) => {
        if (hasTarget(Fe, et.target) && !m && !isEventHandled(et, ye.onDrop) && (!HAS_BEFORE_INPUT_SUPPORT || !IS_SAFARI && et.dataTransfer.files.length > 0)) {
          et.preventDefault();
          var at = ReactEditor.findEventRange(Fe, et), $e = et.dataTransfer;
          Transforms.select(Fe, at), ReactEditor.insertData(Fe, $e);
        }
      }, [m, ye.onDrop]),
      onFocus: useCallback((et) => {
        if (!m && !Le.isUpdatingSelection && hasEditableTarget(Fe, et.target) && !isEventHandled(et, ye.onFocus)) {
          var at = ReactEditor.toDOMNode(Fe, Fe), $e = ReactEditor.getWindow(Fe);
          if (Le.latestElement = $e.document.activeElement, IS_FIREFOX && et.target !== at) {
            at.focus();
            return;
          }
          IS_FOCUSED.set(Fe, !0);
        }
      }, [m, ye.onFocus]),
      onKeyDown: useCallback((et) => {
        if (!m && hasEditableTarget(Fe, et.target) && !isEventHandled(et, ye.onKeyDown)) {
          var {
            nativeEvent: at
          } = et, {
            selection: $e
          } = Fe;
          if (Hotkeys.isRedo(at)) {
            et.preventDefault(), HistoryEditor$1.isHistoryEditor(Fe) && Fe.redo();
            return;
          }
          if (Hotkeys.isUndo(at)) {
            et.preventDefault(), HistoryEditor$1.isHistoryEditor(Fe) && Fe.undo();
            return;
          }
          if (Hotkeys.isMoveLineBackward(at)) {
            et.preventDefault(), Transforms.move(Fe, {
              unit: "line",
              reverse: !0
            });
            return;
          }
          if (Hotkeys.isMoveLineForward(at)) {
            et.preventDefault(), Transforms.move(Fe, {
              unit: "line"
            });
            return;
          }
          if (Hotkeys.isExtendLineBackward(at)) {
            et.preventDefault(), Transforms.move(Fe, {
              unit: "line",
              edge: "focus",
              reverse: !0
            });
            return;
          }
          if (Hotkeys.isExtendLineForward(at)) {
            et.preventDefault(), Transforms.move(Fe, {
              unit: "line",
              edge: "focus"
            });
            return;
          }
          if (Hotkeys.isMoveBackward(at)) {
            et.preventDefault(), $e && Range.isCollapsed($e) ? Transforms.move(Fe, {
              reverse: !0
            }) : Transforms.collapse(Fe, {
              edge: "start"
            });
            return;
          }
          if (Hotkeys.isMoveForward(at)) {
            et.preventDefault(), $e && Range.isCollapsed($e) ? Transforms.move(Fe) : Transforms.collapse(Fe, {
              edge: "end"
            });
            return;
          }
          if (Hotkeys.isMoveWordBackward(at)) {
            et.preventDefault(), Transforms.move(Fe, {
              unit: "word",
              reverse: !0
            });
            return;
          }
          if (Hotkeys.isMoveWordForward(at)) {
            et.preventDefault(), Transforms.move(Fe, {
              unit: "word"
            });
            return;
          }
          if (!HAS_BEFORE_INPUT_SUPPORT) {
            if (Hotkeys.isBold(at) || Hotkeys.isItalic(at) || Hotkeys.isTransposeCharacter(at)) {
              et.preventDefault();
              return;
            }
            if (Hotkeys.isSplitBlock(at)) {
              et.preventDefault(), Editor.insertBreak(Fe);
              return;
            }
            if (Hotkeys.isDeleteBackward(at)) {
              et.preventDefault(), $e && Range.isExpanded($e) ? Editor.deleteFragment(Fe) : Editor.deleteBackward(Fe);
              return;
            }
            if (Hotkeys.isDeleteForward(at)) {
              et.preventDefault(), $e && Range.isExpanded($e) ? Editor.deleteFragment(Fe) : Editor.deleteForward(Fe);
              return;
            }
            if (Hotkeys.isDeleteLineBackward(at)) {
              et.preventDefault(), $e && Range.isExpanded($e) ? Editor.deleteFragment(Fe) : Editor.deleteBackward(Fe, {
                unit: "line"
              });
              return;
            }
            if (Hotkeys.isDeleteLineForward(at)) {
              et.preventDefault(), $e && Range.isExpanded($e) ? Editor.deleteFragment(Fe) : Editor.deleteForward(Fe, {
                unit: "line"
              });
              return;
            }
            if (Hotkeys.isDeleteWordBackward(at)) {
              et.preventDefault(), $e && Range.isExpanded($e) ? Editor.deleteFragment(Fe) : Editor.deleteBackward(Fe, {
                unit: "word"
              });
              return;
            }
            if (Hotkeys.isDeleteWordForward(at)) {
              et.preventDefault(), $e && Range.isExpanded($e) ? Editor.deleteFragment(Fe) : Editor.deleteForward(Fe, {
                unit: "word"
              });
              return;
            }
          }
        }
      }, [m, ye.onKeyDown]),
      onPaste: useCallback((et) => {
        hasEditableTarget(Fe, et.target) && !isEventHandled(et, ye.onPaste) && (!HAS_BEFORE_INPUT_SUPPORT || isPlainTextOnlyPaste(et.nativeEvent)) && !m && (et.preventDefault(), ReactEditor.insertData(Fe, et.clipboardData));
      }, [m, ye.onPaste])
    }),
    /* @__PURE__ */ React$1.createElement(Children, {
      decorate: u,
      decorations: Je,
      node: Fe,
      renderElement: C,
      renderLeaf: O,
      selection: Fe.selection
    })
  ));
}, defaultDecorate = () => [], hasTarget = (o, s) => isDOMNode(s) && ReactEditor.hasDOMNode(o, s), hasEditableTarget = (o, s) => isDOMNode(s) && ReactEditor.hasDOMNode(o, s, {
  editable: !0
}), isTargetInsideVoid = (o, s) => {
  var u = hasTarget(o, s) && ReactEditor.toSlateNode(o, s);
  return Editor.isVoid(o, u);
}, isEventHandled = (o, s) => s ? (s(o), o.isDefaultPrevented() || o.isPropagationStopped()) : !1, isDOMEventHandled = (o, s) => s ? (s(o), o.defaultPrevented) : !1, n = 0;
class Key {
  constructor() {
    this.id = "".concat(n++);
  }
}
var ReactEditor = {
  /**
   * Return the host window of the current editor.
   */
  getWindow(o) {
    var s = EDITOR_TO_WINDOW.get(o);
    if (!s)
      throw new Error("Unable to find a host window element for this editor");
    return s;
  },
  /**
   * Find a key for a Slate node.
   */
  findKey(o, s) {
    var u = NODE_TO_KEY.get(s);
    return u || (u = new Key(), NODE_TO_KEY.set(s, u)), u;
  },
  /**
   * Find the path of Slate node.
   */
  findPath(o, s) {
    for (var u = [], l = s; ; ) {
      var h = NODE_TO_PARENT.get(l);
      if (h == null) {
        if (Editor.isEditor(l))
          return u;
        break;
      }
      var m = NODE_TO_INDEX.get(l);
      if (m == null)
        break;
      u.unshift(m), l = h;
    }
    throw new Error("Unable to find the path for Slate node: ".concat(JSON.stringify(s)));
  },
  /**
   * Check if the editor is focused.
   */
  isFocused(o) {
    return !!IS_FOCUSED.get(o);
  },
  /**
   * Check if the editor is in read-only mode.
   */
  isReadOnly(o) {
    return !!IS_READ_ONLY.get(o);
  },
  /**
   * Blur the editor.
   */
  blur(o) {
    var s = ReactEditor.toDOMNode(o, o);
    IS_FOCUSED.set(o, !1);
    var u = ReactEditor.getWindow(o);
    u.document.activeElement === s && s.blur();
  },
  /**
   * Focus the editor.
   */
  focus(o) {
    var s = ReactEditor.toDOMNode(o, o);
    IS_FOCUSED.set(o, !0);
    var u = ReactEditor.getWindow(o);
    u.document.activeElement !== s && s.focus({
      preventScroll: !0
    });
  },
  /**
   * Deselect the editor.
   */
  deselect(o) {
    var {
      selection: s
    } = o, u = ReactEditor.getWindow(o), l = u.getSelection();
    l && l.rangeCount > 0 && l.removeAllRanges(), s && Transforms.deselect(o);
  },
  /**
   * Check if a DOM node is within the editor.
   */
  hasDOMNode(o, s) {
    var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      editable: l = !1
    } = u, h = ReactEditor.toDOMNode(o, o), m;
    try {
      m = isDOMElement(s) ? s : s.parentElement;
    } catch (C) {
      if (!C.message.includes('Permission denied to access property "nodeType"'))
        throw C;
    }
    return m ? m.closest("[data-slate-editor]") === h && (!l || m.isContentEditable || !!m.getAttribute("data-slate-zero-width")) : !1;
  },
  /**
   * Insert data from a `DataTransfer` into the editor.
   */
  insertData(o, s) {
    o.insertData(s);
  },
  /**
   * Sets data from the currently selected fragment on a `DataTransfer`.
   */
  setFragmentData(o, s) {
    o.setFragmentData(s);
  },
  /**
   * Find the native DOM element from a Slate node.
   */
  toDOMNode(o, s) {
    var u = Editor.isEditor(s) ? EDITOR_TO_ELEMENT.get(o) : KEY_TO_ELEMENT.get(ReactEditor.findKey(o, s));
    if (!u)
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(JSON.stringify(s)));
    return u;
  },
  /**
   * Find a native DOM selection point from a Slate point.
   */
  toDOMPoint(o, s) {
    var [u] = Editor.node(o, s.path), l = ReactEditor.toDOMNode(o, u), h;
    Editor.void(o, {
      at: s
    }) && (s = {
      path: s.path,
      offset: 0
    });
    var m = "[data-slate-string], [data-slate-zero-width]", C = Array.from(l.querySelectorAll(m)), O = 0;
    for (var le of C) {
      var We = le.childNodes[0];
      if (!(We == null || We.textContent == null)) {
        var {
          length: ye
        } = We.textContent, Fe = le.getAttribute("data-slate-length"), Ue = Fe == null ? ye : parseInt(Fe, 10), Le = O + Ue;
        if (s.offset <= Le) {
          var Ze = Math.min(ye, Math.max(0, s.offset - O));
          h = [We, Ze];
          break;
        }
        O = Le;
      }
    }
    if (!h)
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(JSON.stringify(s)));
    return h;
  },
  /**
   * Find a native DOM range from a Slate `range`.
   *
   * Notice: the returned range will always be ordinal regardless of the direction of Slate `range` due to DOM API limit.
   *
   * there is no way to create a reverse DOM Range using Range.setStart/setEnd
   * according to https://dom.spec.whatwg.org/#concept-range-bp-set.
   */
  toDOMRange(o, s) {
    var {
      anchor: u,
      focus: l
    } = s, h = Range.isBackward(s), m = ReactEditor.toDOMPoint(o, u), C = Range.isCollapsed(s) ? m : ReactEditor.toDOMPoint(o, l), O = ReactEditor.getWindow(o), le = O.document.createRange(), [We, ye] = h ? C : m, [Fe, Ue] = h ? m : C, Le = isDOMElement(We) ? We : We.parentElement, Ze = !!Le.getAttribute("data-slate-zero-width"), Xe = isDOMElement(Fe) ? Fe : Fe.parentElement, Je = !!Xe.getAttribute("data-slate-zero-width");
    return le.setStart(We, Ze ? 1 : ye), le.setEnd(Fe, Je ? 1 : Ue), le;
  },
  /**
   * Find a Slate node from a native DOM `element`.
   */
  toSlateNode(o, s) {
    var u = isDOMElement(s) ? s : s.parentElement;
    u && !u.hasAttribute("data-slate-node") && (u = u.closest("[data-slate-node]"));
    var l = u ? ELEMENT_TO_NODE.get(u) : null;
    if (!l)
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(u));
    return l;
  },
  /**
   * Get the target range from a DOM `event`.
   */
  findEventRange(o, s) {
    "nativeEvent" in s && (s = s.nativeEvent);
    var {
      clientX: u,
      clientY: l,
      target: h
    } = s;
    if (u == null || l == null)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(s));
    var m = ReactEditor.toSlateNode(o, s.target), C = ReactEditor.findPath(o, m);
    if (Editor.isVoid(o, m)) {
      var O = h.getBoundingClientRect(), le = o.isInline(m) ? u - O.left < O.left + O.width - u : l - O.top < O.top + O.height - l, We = Editor.point(o, C, {
        edge: le ? "start" : "end"
      }), ye = le ? Editor.before(o, We) : Editor.after(o, We);
      if (ye) {
        var Fe = Editor.range(o, ye);
        return Fe;
      }
    }
    var Ue, {
      document: Le
    } = window;
    if (Le.caretRangeFromPoint)
      Ue = Le.caretRangeFromPoint(u, l);
    else {
      var Ze = Le.caretPositionFromPoint(u, l);
      Ze && (Ue = Le.createRange(), Ue.setStart(Ze.offsetNode, Ze.offset), Ue.setEnd(Ze.offsetNode, Ze.offset));
    }
    if (!Ue)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(s));
    var Xe = ReactEditor.toSlateRange(o, Ue);
    return Xe;
  },
  /**
   * Find a Slate point from a DOM selection's `domNode` and `domOffset`.
   */
  toSlatePoint(o, s) {
    var [u, l] = normalizeDOMPoint(s), h = u.parentNode, m = null, C = 0;
    if (h) {
      var O = h.closest('[data-slate-void="true"]'), le = h.closest("[data-slate-leaf]"), We = null;
      if (le) {
        m = le.closest('[data-slate-node="text"]');
        var ye = ReactEditor.getWindow(o), Fe = ye.document.createRange();
        Fe.setStart(m, 0), Fe.setEnd(u, l);
        var Ue = Fe.cloneContents(), Le = [...Ue.querySelectorAll("[data-slate-zero-width]"), ...Ue.querySelectorAll("[contenteditable=false]")];
        Le.forEach((Je) => {
          Je.parentNode.removeChild(Je);
        }), C = Ue.textContent.length, We = m;
      } else
        O && (le = O.querySelector("[data-slate-leaf]"), m = le.closest('[data-slate-node="text"]'), We = le, C = We.textContent.length);
      We && C === We.textContent.length && h.hasAttribute("data-slate-zero-width") && C--;
    }
    if (!m)
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(s));
    var Ze = ReactEditor.toSlateNode(o, m), Xe = ReactEditor.findPath(o, Ze);
    return {
      path: Xe,
      offset: C
    };
  },
  /**
   * Find a Slate range from a DOM range or selection.
   */
  toSlateRange(o, s) {
    var u = isDOMSelection(s) ? s.anchorNode : s.startContainer, l, h, m, C, O;
    if (u && (isDOMSelection(s) ? (l = s.anchorNode, h = s.anchorOffset, m = s.focusNode, C = s.focusOffset, O = s.isCollapsed) : (l = s.startContainer, h = s.startOffset, m = s.endContainer, C = s.endOffset, O = s.collapsed)), l == null || m == null || h == null || C == null)
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(s));
    var le = ReactEditor.toSlatePoint(o, [l, h]), We = O ? le : ReactEditor.toSlatePoint(o, [m, C]);
    return {
      anchor: le,
      focus: We
    };
  }
}, FocusedContext = /* @__PURE__ */ createContext(!1), Slate = (o) => {
  var {
    editor: s,
    children: u,
    onChange: l,
    value: h
  } = o, m = _objectWithoutProperties$2(o, ["editor", "children", "onChange", "value"]), [C, O] = useState(0), le = useMemo(() => (s.children = h, Object.assign(s, m), [s]), [C, h, ...Object.values(m)]), We = useCallback(() => {
    l(s.children), O(C + 1);
  }, [C, l]);
  return EDITOR_TO_ON_CHANGE.set(s, We), useEffect(() => () => {
    EDITOR_TO_ON_CHANGE.set(s, () => {
    });
  }, []), /* @__PURE__ */ React$1.createElement(SlateContext.Provider, {
    value: le
  }, /* @__PURE__ */ React$1.createElement(EditorContext.Provider, {
    value: s
  }, /* @__PURE__ */ React$1.createElement(FocusedContext.Provider, {
    value: ReactEditor.isFocused(s)
  }, u)));
}, withReact = (o) => {
  var s = o, {
    apply: u,
    onChange: l
  } = s;
  return s.apply = (h) => {
    var m = [];
    switch (h.type) {
      case "insert_text":
      case "remove_text":
      case "set_node": {
        for (var [C, O] of Editor.levels(s, {
          at: h.path
        })) {
          var le = ReactEditor.findKey(s, C);
          m.push([O, le]);
        }
        break;
      }
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node": {
        for (var [We, ye] of Editor.levels(s, {
          at: Path.parent(h.path)
        })) {
          var Fe = ReactEditor.findKey(s, We);
          m.push([ye, Fe]);
        }
        break;
      }
    }
    u(h);
    for (var [Ue, Le] of m) {
      var [Ze] = Editor.node(s, Ue);
      NODE_TO_KEY.set(Ze, Le);
    }
  }, s.setFragmentData = (h) => {
    var {
      selection: m
    } = s;
    if (m) {
      var [C, O] = Range.edges(m), le = Editor.void(s, {
        at: C.path
      }), We = Editor.void(s, {
        at: O.path
      });
      if (!(Range.isCollapsed(m) && !le)) {
        var ye = ReactEditor.toDOMRange(s, m), Fe = ye.cloneContents(), Ue = Fe.childNodes[0];
        if (Fe.childNodes.forEach((Ke) => {
          Ke.textContent && Ke.textContent.trim() !== "" && (Ue = Ke);
        }), We) {
          var [Le] = We, Ze = ye.cloneRange(), Xe = ReactEditor.toDOMNode(s, Le);
          Ze.setEndAfter(Xe), Fe = Ze.cloneContents();
        }
        if (le && (Ue = Fe.querySelector("[data-slate-spacer]")), Array.from(Fe.querySelectorAll("[data-slate-zero-width]")).forEach((Ke) => {
          var tt = Ke.getAttribute("data-slate-zero-width") === "n";
          Ke.textContent = tt ? `
` : "";
        }), isDOMText(Ue)) {
          var Je = document.createElement("span");
          Je.style.whiteSpace = "pre", Je.appendChild(Ue), Fe.appendChild(Je), Ue = Je;
        }
        var it = s.getFragment(), et = JSON.stringify(it), at = window.btoa(encodeURIComponent(et));
        Ue.setAttribute("data-slate-fragment", at), h.setData("application/x-slate-fragment", at);
        var $e = document.createElement("div");
        $e.appendChild(Fe), $e.setAttribute("hidden", "true"), document.body.appendChild($e), h.setData("text/html", $e.innerHTML), h.setData("text/plain", getPlainText($e)), document.body.removeChild($e);
      }
    }
  }, s.insertData = (h) => {
    var m = h.getData("application/x-slate-fragment");
    if (m) {
      var C = decodeURIComponent(window.atob(m)), O = JSON.parse(C);
      s.insertFragment(O);
      return;
    }
    var le = h.getData("text/plain");
    if (le) {
      var We = le.split(/\r\n|\r|\n/), ye = !1;
      for (var Fe of We)
        ye && Transforms.splitNodes(s, {
          always: !0
        }), s.insertText(Fe), ye = !0;
    }
  }, s.onChange = () => {
    ReactDOM.unstable_batchedUpdates(() => {
      var h = EDITOR_TO_ON_CHANGE.get(s);
      h && h(), l();
    });
  }, s;
}, History = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(o) {
    return isPlainObject$2(o) && Array.isArray(o.redos) && Array.isArray(o.undos) && (o.redos.length === 0 || Operation.isOperationList(o.redos[0].operations)) && (o.undos.length === 0 || Operation.isOperationList(o.undos[0].operations));
  }
}, SAVING = /* @__PURE__ */ new WeakMap(), MERGING = /* @__PURE__ */ new WeakMap(), HistoryEditor = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(o) {
    return History.isHistory(o.history) && Editor.isEditor(o);
  },
  /**
   * Get the merge flag's current value.
   */
  isMerging(o) {
    return MERGING.get(o);
  },
  /**
   * Get the saving flag's current value.
   */
  isSaving(o) {
    return SAVING.get(o);
  },
  /**
   * Redo to the previous saved state.
   */
  redo(o) {
    o.redo();
  },
  /**
   * Undo to the previous saved state.
   */
  undo(o) {
    o.undo();
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(o, s) {
    var u = HistoryEditor.isMerging(o);
    MERGING.set(o, !1), s(), MERGING.set(o, u);
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(o, s) {
    var u = HistoryEditor.isSaving(o);
    SAVING.set(o, !1), s(), SAVING.set(o, u);
  }
}, withHistory = (o) => {
  var s = o, {
    apply: u
  } = s;
  return s.history = {
    undos: [],
    redos: []
  }, s.redo = () => {
    var {
      history: l
    } = s, {
      redos: h
    } = l;
    if (h.length > 0) {
      var m = h[h.length - 1];
      m.selectionBefore && Transforms.setSelection(s, m.selectionBefore), HistoryEditor.withoutSaving(s, () => {
        Editor.withoutNormalizing(s, () => {
          for (var C of m.operations)
            s.apply(C);
        });
      }), l.redos.pop(), s.writeHistory("undos", m);
    }
  }, s.undo = () => {
    var {
      history: l
    } = s, {
      undos: h
    } = l;
    if (h.length > 0) {
      var m = h[h.length - 1];
      HistoryEditor.withoutSaving(s, () => {
        Editor.withoutNormalizing(s, () => {
          var C = m.operations.map(Operation.inverse).reverse();
          for (var O of C)
            s.apply(O);
          m.selectionBefore && Transforms.setSelection(s, m.selectionBefore);
        });
      }), s.writeHistory("redos", m), l.undos.pop();
    }
  }, s.apply = (l) => {
    var {
      operations: h,
      history: m
    } = s, {
      undos: C
    } = m, O = C[C.length - 1], le = O && O.operations[O.operations.length - 1], We = HistoryEditor.isSaving(s), ye = HistoryEditor.isMerging(s);
    if (We == null && (We = shouldSave(l)), We) {
      if (ye == null && (O == null ? ye = !1 : h.length !== 0 ? ye = !0 : ye = shouldMerge(l, le)), O && ye)
        O.operations.push(l);
      else {
        var Fe = {
          operations: [l],
          selectionBefore: s.selection
        };
        s.writeHistory("undos", Fe);
      }
      for (; C.length > 100; )
        C.shift();
      m.redos = [];
    }
    u(l);
  }, s.writeHistory = (l, h) => {
    s.history[l].push(h);
  }, s;
}, shouldMerge = (o, s) => !!(s && o.type === "insert_text" && s.type === "insert_text" && o.offset === s.offset + s.text.length && Path.equals(o.path, s.path) || s && o.type === "remove_text" && s.type === "remove_text" && o.offset + o.text.length === s.offset && Path.equals(o.path, s.path)), shouldSave = (o, s) => o.type !== "set_selection", stylex = {}, stylexInject = {}, StyleXSheet$1 = {}, invariant$1 = function(o, s, u, l, h, m, C, O) {
  if (process.env.NODE_ENV !== "production" && s === void 0)
    throw new Error("invariant requires an error message argument");
  if (!o) {
    var le;
    if (s === void 0)
      le = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var We = [u, l, h, m, C, O], ye = 0;
      le = new Error(s.replace(/%s/g, function() {
        return We[ye++];
      })), le.name = "Invariant Violation";
    }
    throw le.framesToPop = 1, le;
  }
}, browser$1 = invariant$1;
Object.defineProperty(StyleXSheet$1, "__esModule", {
  value: !0
});
StyleXSheet$1.styleSheet = StyleXSheet$1.StyleXSheet = void 0;
var _invariant = _interopRequireDefault$1(browser$1);
function _interopRequireDefault$1(o) {
  return o && o.__esModule ? o : {
    default: o
  };
}
const LIGHT_MODE_CLASS_NAME = "__fb-light-mode", DARK_MODE_CLASS_NAME = "__fb-dark-mode";
function buildTheme(o, s) {
  const u = [];
  u.push(`${o} {`);
  for (const l in s) {
    const h = s[l];
    u.push(`  --${l}: ${h};`);
  }
  return u.push("}"), u.join(`
`);
}
function makeStyleTag() {
  const o = document.createElement("style");
  o.setAttribute("type", "text/css"), o.setAttribute("data-stylex", "true");
  const s = document.head || document.getElementsByTagName("head")[0];
  return (0, _invariant.default)(s, "expected head"), s.appendChild(o), o;
}
function doesSupportCSSVariables() {
  return globalThis.CSS != null && globalThis.CSS.supports != null && globalThis.CSS.supports("--fake-var:0");
}
const VARIABLE_MATCH = /var\(--(.*?)\)/g;
class StyleXSheet {
  constructor(s) {
    this.tag = null, this.injected = !1, this.ruleForPriority = /* @__PURE__ */ new Map(), this.rules = [], this.rootTheme = s.rootTheme, this.rootDarkTheme = s.rootDarkTheme, this.supportsVariables = s.supportsVariables ?? doesSupportCSSVariables();
  }
  getVariableMatch() {
    return VARIABLE_MATCH;
  }
  isHeadless() {
    var s;
    return this.tag == null || ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body) == null;
  }
  getTag() {
    const {
      tag: s
    } = this;
    return (0, _invariant.default)(s != null, "expected tag"), s;
  }
  getCSS() {
    return this.rules.join(`
`);
  }
  getRulePosition(s) {
    return this.rules.indexOf(s);
  }
  getRuleCount() {
    return this.rules.length;
  }
  inject() {
    var s;
    if (!this.injected) {
      if (this.injected = !0, ((s = globalThis.document) == null ? void 0 : s.body) == null) {
        this.injectTheme();
        return;
      }
      this.tag = makeStyleTag(), this.injectTheme();
    }
  }
  injectTheme() {
    this.rootTheme != null && this.insert(buildTheme(`:root, .${LIGHT_MODE_CLASS_NAME}`, this.rootTheme), 0), this.rootDarkTheme != null && this.insert(buildTheme(`.${DARK_MODE_CLASS_NAME}:root, .${DARK_MODE_CLASS_NAME}`, this.rootDarkTheme), 0);
  }
  __injectCustomThemeForTesting(s, u) {
    u != null && this.insert(buildTheme(s, u), 0);
  }
  delete(s) {
    const u = this.rules.indexOf(s);
    if ((0, _invariant.default)(u >= 0, "Couldn't find the index for rule %s", s), this.rules.splice(u, 1), this.isHeadless())
      return;
    const h = this.getTag().sheet;
    (0, _invariant.default)(h, "expected sheet"), h.deleteRule(u);
  }
  normalizeRule(s) {
    const {
      rootTheme: u
    } = this;
    return this.supportsVariables || u == null ? s : s.replace(VARIABLE_MATCH, (l, h) => u[h]);
  }
  getInsertPositionForPriority(s) {
    const u = this.ruleForPriority.get(s);
    if (u != null)
      return this.rules.indexOf(u) + 1;
    const l = Array.from(this.ruleForPriority.keys()).sort((m, C) => C - m).filter((m) => m > s ? 1 : 0);
    if (l.length === 0)
      return this.getRuleCount();
    const h = l.pop();
    return this.rules.indexOf(this.ruleForPriority.get(h));
  }
  insert(s, u, l) {
    if (this.injected === !1 && this.inject(), l != null) {
      this.insert(addAncestorSelector(s, "html:not([dir='rtl'])"), u), this.insert(addAncestorSelector(l, "html[dir='rtl']"), u);
      return;
    }
    const h = s;
    if (this.rules.includes(h))
      return;
    const m = this.normalizeRule(h), C = this.getInsertPositionForPriority(u);
    if (this.rules.splice(C, 0, m), this.ruleForPriority.set(u, m), this.isHeadless())
      return;
    const le = this.getTag().sheet;
    if (le != null)
      try {
        le.insertRule(m, C);
      } catch {
      }
  }
}
ir(StyleXSheet, "LIGHT_MODE_CLASS_NAME", LIGHT_MODE_CLASS_NAME), ir(StyleXSheet, "DARK_MODE_CLASS_NAME", DARK_MODE_CLASS_NAME);
StyleXSheet$1.StyleXSheet = StyleXSheet;
function addAncestorSelector(o, s) {
  if (!o.startsWith("@"))
    return `${s} ${o}`;
  const u = o.indexOf("{"), l = o.slice(0, u + 1), h = o.slice(u + 1);
  return `${l}${s} ${h}`;
}
StyleXSheet$1.styleSheet = new StyleXSheet({
  supportsVariables: !0,
  rootTheme: {},
  rootDarkTheme: {}
});
Object.defineProperty(stylexInject, "__esModule", {
  value: !0
});
stylexInject.default = inject$1;
var _StyleXSheet = StyleXSheet$1;
function inject$1(o, s) {
  let u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
  _StyleXSheet.styleSheet.insert(o, s, u);
}
var styleq$1 = {};
Object.defineProperty(styleq$1, "__esModule", {
  value: !0
});
styleq$1.styleq = void 0;
var cache$1 = /* @__PURE__ */ new WeakMap(), compiledKey = "$$css";
function createStyleq(o) {
  var s, u, l;
  return o != null && (s = o.disableCache === !0, u = o.disableMix === !0, l = o.transform), function() {
    for (var m = [], C = "", O = null, le = s ? null : cache$1, We = new Array(arguments.length), ye = 0; ye < arguments.length; ye++)
      We[ye] = arguments[ye];
    for (; We.length > 0; ) {
      var Fe = We.pop();
      if (!(Fe == null || Fe === !1)) {
        if (Array.isArray(Fe)) {
          for (var Ue = 0; Ue < Fe.length; Ue++)
            We.push(Fe[Ue]);
          continue;
        }
        var Le = l != null ? l(Fe) : Fe;
        if (Le.$$css) {
          var Ze = "";
          if (le != null && le.has(Le)) {
            var Xe = le.get(Le);
            Xe != null && (Ze = Xe[0], m.push.apply(m, Xe[1]), le = Xe[2]);
          } else {
            var Je = [];
            for (var it in Le) {
              var et = Le[it];
              it !== compiledKey && (typeof et == "string" || et === null ? m.includes(it) || (m.push(it), le != null && Je.push(it), typeof et == "string" && (Ze += Ze ? " " + et : et)) : console.error("styleq: ".concat(it, " typeof ").concat(String(et), ' is not "string" or "null".')));
            }
            if (le != null) {
              var at = /* @__PURE__ */ new WeakMap();
              le.set(Le, [Ze, Je, at]), le = at;
            }
          }
          Ze && (C = C ? Ze + " " + C : Ze);
        } else if (u)
          O == null && (O = {}), O = Object.assign({}, Le, O);
        else {
          var $e = null;
          for (var Ke in Le) {
            var tt = Le[Ke];
            tt !== void 0 && (m.includes(Ke) || (tt != null && (O == null && (O = {}), $e == null && ($e = {}), $e[Ke] = tt), m.push(Ke), le = null));
          }
          $e != null && (O = Object.assign($e, O));
        }
      }
    }
    var ut = [C, O];
    return ut;
  };
}
var styleq = createStyleq();
styleq$1.styleq = styleq;
styleq.factory = createStyleq;
var inject_1;
Object.defineProperty(stylex, "__esModule", {
  value: !0
});
stylex.__monkey_patch__ = __monkey_patch__;
stylex.keyframes = inject_1 = stylex.inject = stylex.include = stylex.firstThatWorks = stylex.defineVars = stylex.default = stylex.createTheme = stylex.create = void 0;
var props_1 = stylex.props = props;
stylex.types = stylex.stylex = void 0;
var _stylexInject = _interopRequireDefault(stylexInject), _styleq = styleq$1;
function _interopRequireDefault(o) {
  return o && o.__esModule ? o : {
    default: o
  };
}
function props() {
  const o = this;
  for (var s = arguments.length, u = new Array(s), l = 0; l < s; l++)
    u[l] = arguments[l];
  if (__implementations.props)
    return __implementations.props.call(o, u);
  const [h, m] = (0, _styleq.styleq)(u), C = {};
  return h != null && h !== "" && (C.className = h), m != null && Object.keys(m).length > 0 && (C.style = m), C;
}
function stylexCreate(o) {
  if (__implementations.create != null) {
    const s = __implementations.create;
    return s(o);
  }
  throw new Error("stylex.create should never be called. It should be compiled away.");
}
function stylexDefineVars(o) {
  if (__implementations.defineVars)
    return __implementations.defineVars(o);
  throw new Error("stylex.defineVars should never be called. It should be compiled away.");
}
const stylexCreateTheme = (o, s) => {
  if (__implementations.createTheme)
    return __implementations.createTheme(o, s);
  throw new Error("stylex.createTheme should never be called. It should be compiled away.");
}, stylexInclude = (o) => {
  if (__implementations.include)
    return __implementations.include(o);
  throw new Error("stylex.extends should never be called. It should be compiled away.");
}, create = stylex.create = stylexCreate, defineVars = stylex.defineVars = stylexDefineVars, createTheme = stylex.createTheme = stylexCreateTheme, include = stylex.include = stylexInclude, types = stylex.types = {
  angle: (o) => {
    throw new Error(errorForType("angle"));
  },
  color: (o) => {
    throw new Error(errorForType("color"));
  },
  url: (o) => {
    throw new Error(errorForType("url"));
  },
  image: (o) => {
    throw new Error(errorForType("image"));
  },
  integer: (o) => {
    throw new Error(errorForType("integer"));
  },
  lengthPercentage: (o) => {
    throw new Error(errorForType("lengthPercentage"));
  },
  length: (o) => {
    throw new Error(errorForType("length"));
  },
  percentage: (o) => {
    throw new Error(errorForType("percentage"));
  },
  number: (o) => {
    throw new Error(errorForType("number"));
  },
  resolution: (o) => {
    throw new Error(errorForType("resolution"));
  },
  time: (o) => {
    throw new Error(errorForType("time"));
  },
  transformFunction: (o) => {
    throw new Error(errorForType("transformFunction"));
  },
  transformList: (o) => {
    throw new Error(errorForType("transformList"));
  }
}, errorForType = (o) => `stylex.types.${o} should be compiled away by @stylexjs/babel-plugin`, keyframes$2 = (o) => {
  if (__implementations.keyframes)
    return __implementations.keyframes(o);
  throw new Error("stylex.keyframes should never be called");
};
stylex.keyframes = keyframes$2;
const firstThatWorks = function() {
  if (__implementations.firstThatWorks)
    return __implementations.firstThatWorks(...arguments);
  throw new Error("stylex.firstThatWorks should never be called.");
};
stylex.firstThatWorks = firstThatWorks;
const inject = inject_1 = stylex.inject = _stylexInject.default;
function _stylex() {
  for (var o = arguments.length, s = new Array(o), u = 0; u < o; u++)
    s[u] = arguments[u];
  const [l] = (0, _styleq.styleq)(s);
  return l;
}
_stylex.props = props;
_stylex.create = create;
_stylex.defineVars = defineVars;
_stylex.createTheme = createTheme;
_stylex.include = include;
_stylex.keyframes = keyframes$2;
_stylex.firstThatWorks = firstThatWorks;
_stylex.inject = inject;
_stylex.types = types;
const __implementations = {};
function __monkey_patch__(o, s) {
  o === "types" ? Object.assign(types, s) : __implementations[o] = s;
}
stylex.stylex = _stylex;
stylex.default = _stylex;
inject_1(":root{--x1ox9m9h:#9f9caa;--x9hxy4i:#706a81;--x5ebjfl:#574f6b;--xthetwg:#403957;--x137thfa:#1c1636;--x1dekte2:#11082d;--x1j1nddv:#635cf7;--x1a9tjcs:#6f67b7;--x1k49hn0:#4D4D4D;--x1ccw7rc:#f3f2f4;--xknxykk:#e4e3e8;--x1tmm7eb:#edecf0;--xq2qqxw:#e7e6ea;--x8yki5p:#c3c2ca;--x4krusp:#adaaf8;--x13tgmcg:#635cf7;--x1o8j7kq:#6f67b7;--xxf3qxz:#584dab;--x1xx8sgf:#4236a1;}", 0);
inject_1(".xkpwil5{font-size:.875rem}", 3e3);
inject_1(".x1hl2dhg{text-decoration:none}", 2e3);
inject_1(".x1ypdohk{cursor:pointer}", 3e3);
inject_1(".x1ykie8n{color:var(--xxf3qxz)}", 3e3);
inject_1(".x1jchvi3{font-size:1rem}", 3e3);
inject_1(".x1s688f{font-weight:600}", 3e3);
inject_1(".x89z23a{line-height:1.88}", 3e3);
inject_1(".x1i21sxh{letter-spacing:normal}", 3e3);
inject_1(".x1ghz6dp{margin:0}", 1e3);
inject_1(".xu06os2{margin-bottom:5px}", 4e3);
inject_1(".xexx8yu{padding-top:0}", 4e3);
inject_1(".xdpxx8g{text-align:left}", 3e3);
inject_1(".x1e7rc0z{color:var(--x137thfa)}", 3e3);
inject_1(".x1u5lrna{line-height:2}", 3e3);
inject_1(".x76ihet{border-top:none}", 2e3);
inject_1(".x1uxkiu0{color:var(--xthetwg)}", 3e3);
inject_1(".xtaz4m5{list-style-type:disc}", 3e3);
inject_1(".x400o59{margin-left:20px}", 4e3);
inject_1(".x5tiur9{padding-left:20px}", 4e3);
inject_1(".x3yw8vx{list-style-type:decimal}", 3e3);
const styles$3 = {
  styledLink: {
    fontSize: "xkpwil5",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    cursor: "x1ypdohk",
    color: "x1ykie8n",
    $$css: !0
  },
  link: {
    fontSize: "xkpwil5",
    $$css: !0
  },
  headerOne: {
    fontSize: "x1jchvi3",
    fontWeight: "x1s688f",
    lineHeight: "x89z23a",
    letterSpacing: "x1i21sxh",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: "xu06os2",
    paddingTop: "xexx8yu",
    textAlign: "xdpxx8g",
    color: "x1e7rc0z",
    $$css: !0
  },
  headerTwo: {
    fontSize: "xkpwil5",
    fontWeight: "x1s688f",
    lineHeight: "x1u5lrna",
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: "xu06os2",
    paddingTop: "xexx8yu",
    borderTop: "x76ihet",
    borderTopWidth: null,
    borderTopStyle: null,
    borderTopColor: null,
    textAlign: "xdpxx8g",
    color: "x1uxkiu0",
    $$css: !0
  },
  bulletedList: {
    listStyleType: "xtaz4m5",
    marginLeft: "x400o59",
    marginInlineStart: null,
    marginInlineEnd: null,
    paddingLeft: "x5tiur9",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: !0
  },
  numberedList: {
    listStyleType: "x3yw8vx",
    marginLeft: "x400o59",
    marginInlineStart: null,
    marginInlineEnd: null,
    paddingLeft: "x5tiur9",
    paddingInlineStart: null,
    paddingInlineEnd: null,
    $$css: !0
  },
  listItem: {
    marginBottom: "xu06os2",
    $$css: !0
  }
}, getDescriptionDefaultValue = (o) => [{
  type: "paragraph",
  children: [{
    text: o ?? ""
  }]
}], Element$1 = ({
  attributes: o,
  children: s,
  element: u,
  defaultFormatting: l
}) => {
  const h = {
    textAlign: u.align
  };
  if (l)
    switch (u.type) {
      case "link":
        return /* @__PURE__ */ jsx("a", {
          className: "xkpwil5",
          ...o,
          children: s
        });
      default:
        return /* @__PURE__ */ jsx("div", {
          ...o,
          children: s
        });
    }
  else
    switch (u.type) {
      case "heading-one":
        return /* @__PURE__ */ jsx("h1", {
          ...o,
          ...props_1(styles$3.headerOne, h),
          children: s
        });
      case "heading-two":
        return /* @__PURE__ */ jsx("h2", {
          ...o,
          ...props_1(styles$3.headerTwo, h),
          children: s
        });
      case "bulleted-list":
        return /* @__PURE__ */ jsx("ul", {
          ...o,
          className: "xtaz4m5 x400o59 x5tiur9",
          children: s
        });
      case "numbered-list":
        return /* @__PURE__ */ jsx("ol", {
          ...o,
          className: "x3yw8vx x400o59 x5tiur9",
          children: s
        });
      case "list-item":
        return /* @__PURE__ */ jsx("li", {
          ...o,
          className: "xu06os2",
          children: s
        });
      case "link": {
        let C = u.url;
        var m = /^((http|https|ftp):\/\/)/;
        return m.test(C) || (C = "https://" + C), /* @__PURE__ */ jsx("a", {
          ...o,
          href: C,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "xkpwil5 x1hl2dhg x1ypdohk x1ykie8n",
          children: s
        });
      }
      default:
        return /* @__PURE__ */ jsx("div", {
          ...o,
          ...props_1(h),
          children: s
        });
    }
}, Leaf = ({
  attributes: o,
  children: s,
  leaf: u,
  defaultFormatting: l
}) => (l || (u.bold && (s = /* @__PURE__ */ jsx("strong", {
  children: s
})), u.italic && (s = /* @__PURE__ */ jsx("em", {
  children: s
})), u.underline && (s = /* @__PURE__ */ jsx("u", {
  children: s
}))), /* @__PURE__ */ jsx("span", {
  ...o,
  children: s
})), mapFormat = {
  h1: "heading-one",
  h2: "heading-two",
  "bulleted-list": "bulleted-list",
  "numbered-list": "numbered-list",
  "list-item": "list-item"
}, mapAlignment = {
  "align-left": "left",
  "align-center": "center",
  "align-right": "right",
  "align-justify": "justify"
}, processMarks = (o, s, u, l) => {
  o == null || o.forEach((h) => {
    const {
      type: m
    } = h;
    (m === "h1" || m === "h2") && u(mapFormat[m]), (m === "align-left" || m === "align-center" || m === "align-right" || m === "align-justify") && l(mapAlignment[m]), (m === "bold" || m === "italic" || m === "underline") && (s[m] = !0);
  });
}, processTextNode = (o, s, u) => {
  const {
    text: l,
    marks: h
  } = o, m = {
    text: l
  };
  return processMarks(h ?? [], m, s, u), m;
}, transformData$2 = (o) => o != null && o.document ? o.document.nodes.map((s) => {
  const {
    nodes: u,
    type: l
  } = s;
  let h, m = "paragraph";
  const C = (ye) => m = ye, O = (ye) => h = ye;
  if (l === "bulleted-list" || l === "numbered-list") {
    m = mapFormat[l];
    const ye = s.nodes.map((Fe) => ({
      type: "list-item",
      children: Fe.nodes.map((Le) => processTextNode(Le, C, O))
    }));
    return {
      type: m,
      children: ye
    };
  }
  const le = u.map((ye) => {
    var Ue, Le;
    const {
      object: Fe
    } = ye;
    if (Fe === "text")
      return processTextNode(ye, C, O);
    if (Fe === "inline") {
      const Ze = (Ue = ye == null ? void 0 : ye.data) == null ? void 0 : Ue.link;
      return {
        children: (Le = ye.nodes) == null ? void 0 : Le.map((Je) => processTextNode(Je, C, O)),
        url: Ze,
        type: "link"
      };
    }
    return null;
  }).filter(Boolean), We = {
    type: m,
    children: le
  };
  return h && (We.align = h), We;
}) : o, RichTextRenderer = ({
  richText: o,
  fallbackValue: s,
  fontSize: u = "0.875rem",
  defaultFormatting: l
}) => {
  const [h, m] = useState(getDescriptionDefaultValue("")), [C, O] = useState([]), le = useCallback((Le) => /* @__PURE__ */ jsx(Element$1, {
    ...Le,
    defaultFormatting: l
  }), []), We = useCallback((Le) => /* @__PURE__ */ jsx(Leaf, {
    ...Le,
    defaultFormatting: l
  }), []), ye = useMemo(() => withHistory(withReact(createEditor())), []);
  useEffect(() => {
    if (o) {
      let Ze = o.replace(/\\"/g, '"').replace(/\uFEFF/g, "");
      try {
        Ze = JSON.parse(o);
      } catch {
        Ze = getDescriptionDefaultValue(Ze);
      }
      m(Ze);
    } else if (s) {
      const Le = getDescriptionDefaultValue(s);
      m(Le);
    }
  }, [o, s]), useEffect(() => {
    const Le = transformData$2(h);
    O(Le);
  }, [h]);
  const Fe = [{
    type: "bulleted-list",
    children: [{
      type: "list-item",
      children: [{
        text: "Item 1"
      }]
    }, {
      type: "list-item",
      children: [{
        text: "Item 2"
      }]
    }]
  }];
  return useEffect(() => {
    O(Fe);
  }, []), /* @__PURE__ */ jsx(Slate, {
    editor: ye,
    value: C,
    onChange: () => {
    },
    children: /* @__PURE__ */ jsx(Editable, {
      readOnly: !0,
      renderElement: le,
      renderLeaf: We,
      spellCheck: !1,
      style: {
        fontSize: u,
        padding: "0 10px 0 0",
        whiteSpace: "break-spaces",
        lineHeight: "20px"
      },
      placeholder: ""
    })
  });
};
function memoize$1(o) {
  var s = {};
  return function(u) {
    return s[u] === void 0 && (s[u] = o(u)), s[u];
  };
}
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, index$2 = memoize$1(
  function(o) {
    return reactPropsRegex$1.test(o) || o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
const isPropValid_browser_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: index$2
}, Symbol.toStringTag, { value: "Module" })), require$$0 = /* @__PURE__ */ getAugmentedNamespace(isPropValid_browser_esm);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(o, s) {
  return extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(u, l) {
    u.__proto__ = l;
  } || function(u, l) {
    for (var h in l)
      l.hasOwnProperty(h) && (u[h] = l[h]);
  }, extendStatics(o, s);
};
function __extends(o, s) {
  extendStatics(o, s);
  function u() {
    this.constructor = o;
  }
  o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
}
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(s) {
    for (var u, l = 1, h = arguments.length; l < h; l++) {
      u = arguments[l];
      for (var m in u)
        Object.prototype.hasOwnProperty.call(u, m) && (s[m] = u[m]);
    }
    return s;
  }, __assign$1.apply(this, arguments);
};
function __rest(o, s) {
  var u = {};
  for (var l in o)
    Object.prototype.hasOwnProperty.call(o, l) && s.indexOf(l) < 0 && (u[l] = o[l]);
  if (o != null && typeof Object.getOwnPropertySymbols == "function")
    for (var h = 0, l = Object.getOwnPropertySymbols(o); h < l.length; h++)
      s.indexOf(l[h]) < 0 && Object.prototype.propertyIsEnumerable.call(o, l[h]) && (u[l[h]] = o[l[h]]);
  return u;
}
function __spreadArrays() {
  for (var o = 0, s = 0, u = arguments.length; s < u; s++)
    o += arguments[s].length;
  for (var l = Array(o), h = 0, s = 0; s < u; s++)
    for (var m = arguments[s], C = 0, O = m.length; C < O; C++, h++)
      l[h] = m[C];
  return l;
}
var warning = function() {
}, invariant = function() {
};
process.env.NODE_ENV !== "production" && (warning = function(o, s) {
  !o && typeof console < "u" && console.warn(s);
}, invariant = function(o, s) {
  if (!o)
    throw new Error(s);
});
var prevTime = 0, onNextFrame = typeof window < "u" && window.requestAnimationFrame !== void 0 ? function(o) {
  return window.requestAnimationFrame(o);
} : function(o) {
  var s = Date.now(), u = Math.max(0, 16.7 - (s - prevTime));
  prevTime = s + u, setTimeout(function() {
    return o(prevTime);
  }, u);
}, createStep = function(o) {
  var s = [], u = [], l = 0, h = !1, m = 0, C = /* @__PURE__ */ new WeakSet(), O = /* @__PURE__ */ new WeakSet(), le = {
    cancel: function(We) {
      var ye = u.indexOf(We);
      C.add(We), ye !== -1 && u.splice(ye, 1);
    },
    process: function(We) {
      var ye;
      if (h = !0, ye = [u, s], s = ye[0], u = ye[1], u.length = 0, l = s.length, l) {
        var Fe;
        for (m = 0; m < l; m++)
          Fe = s[m], Fe(We), O.has(Fe) === !0 && !C.has(Fe) && (le.schedule(Fe), o(!0));
      }
      h = !1;
    },
    schedule: function(We, ye, Fe) {
      ye === void 0 && (ye = !1), Fe === void 0 && (Fe = !1), invariant(typeof We == "function", "Argument must be a function");
      var Ue = Fe && h, Le = Ue ? s : u;
      C.delete(We), ye && O.add(We), Le.indexOf(We) === -1 && (Le.push(We), Ue && (l = s.length));
    }
  };
  return le;
}, maxElapsed = 40, defaultElapsed = 1 / 60 * 1e3, useDefaultElapsed = !0, willRunNextFrame = !1, isProcessing = !1, frame = {
  delta: 0,
  timestamp: 0
}, stepsOrder = ["read", "update", "preRender", "render", "postRender"], setWillRunNextFrame = function(o) {
  return willRunNextFrame = o;
}, steps = /* @__PURE__ */ stepsOrder.reduce(function(o, s) {
  return o[s] = createStep(setWillRunNextFrame), o;
}, {}), sync = /* @__PURE__ */ stepsOrder.reduce(function(o, s) {
  var u = steps[s];
  return o[s] = function(l, h, m) {
    return h === void 0 && (h = !1), m === void 0 && (m = !1), willRunNextFrame || startLoop(), u.schedule(l, h, m), l;
  }, o;
}, {}), cancelSync = /* @__PURE__ */ stepsOrder.reduce(function(o, s) {
  return o[s] = steps[s].cancel, o;
}, {}), processStep = function(o) {
  return steps[o].process(frame);
}, processFrame = function(o) {
  willRunNextFrame = !1, frame.delta = useDefaultElapsed ? defaultElapsed : Math.max(Math.min(o - frame.timestamp, maxElapsed), 1), useDefaultElapsed || (defaultElapsed = frame.delta), frame.timestamp = o, isProcessing = !0, stepsOrder.forEach(processStep), isProcessing = !1, willRunNextFrame && (useDefaultElapsed = !1, onNextFrame(processFrame));
}, startLoop = function() {
  willRunNextFrame = !0, useDefaultElapsed = !0, isProcessing || onNextFrame(processFrame);
}, getFrameData = function() {
  return frame;
}, clamp$2 = function(o, s) {
  return function(u) {
    return Math.max(Math.min(u, s), o);
  };
}, sanitize = function(o) {
  return o % 1 ? Number(o.toFixed(5)) : o;
}, floatRegex = /(-)?(\d[\d\.]*)/g, colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i, number = {
  test: function(o) {
    return typeof o == "number";
  },
  parse: parseFloat,
  transform: function(o) {
    return o;
  }
}, alpha = __assign$1(__assign$1({}, number), {
  transform: clamp$2(0, 1)
}), scale = __assign$1(__assign$1({}, number), {
  default: 1
}), createUnitType = function(o) {
  return {
    test: function(s) {
      return typeof s == "string" && s.endsWith(o) && s.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function(s) {
      return "" + s + o;
    }
  };
}, degrees = createUnitType("deg"), percent = createUnitType("%"), px = createUnitType("px"), vh = createUnitType("vh"), vw = createUnitType("vw"), progressPercentage = __assign$1(__assign$1({}, percent), {
  parse: function(o) {
    return percent.parse(o) / 100;
  },
  transform: function(o) {
    return percent.transform(o * 100);
  }
}), getValueFromFunctionString = function(o) {
  return o.substring(o.indexOf("(") + 1, o.lastIndexOf(")"));
}, clampRgbUnit = clamp$2(0, 255), isRgba = function(o) {
  return o.red !== void 0;
}, isHsla = function(o) {
  return o.hue !== void 0;
};
function getValuesAsArray(o) {
  return getValueFromFunctionString(o).replace(/(,|\/)/g, " ").split(/ \s*/);
}
var splitColorValues = function(o) {
  return function(s) {
    if (typeof s != "string")
      return s;
    for (var u = {}, l = getValuesAsArray(s), h = 0; h < 4; h++)
      u[o[h]] = l[h] !== void 0 ? parseFloat(l[h]) : 1;
    return u;
  };
}, rgbaTemplate = function(o) {
  var s = o.red, u = o.green, l = o.blue, h = o.alpha, m = h === void 0 ? 1 : h;
  return "rgba(" + s + ", " + u + ", " + l + ", " + m + ")";
}, hslaTemplate = function(o) {
  var s = o.hue, u = o.saturation, l = o.lightness, h = o.alpha, m = h === void 0 ? 1 : h;
  return "hsla(" + s + ", " + u + ", " + l + ", " + m + ")";
}, rgbUnit = __assign$1(__assign$1({}, number), {
  transform: function(o) {
    return Math.round(clampRgbUnit(o));
  }
});
function isColorString(o, s) {
  return o.startsWith(s) && singleColorRegex.test(o);
}
var rgba = {
  test: function(o) {
    return typeof o == "string" ? isColorString(o, "rgb") : isRgba(o);
  },
  parse: splitColorValues(["red", "green", "blue", "alpha"]),
  transform: function(o) {
    var s = o.red, u = o.green, l = o.blue, h = o.alpha, m = h === void 0 ? 1 : h;
    return rgbaTemplate({
      red: rgbUnit.transform(s),
      green: rgbUnit.transform(u),
      blue: rgbUnit.transform(l),
      alpha: sanitize(alpha.transform(m))
    });
  }
}, hsla = {
  test: function(o) {
    return typeof o == "string" ? isColorString(o, "hsl") : isHsla(o);
  },
  parse: splitColorValues(["hue", "saturation", "lightness", "alpha"]),
  transform: function(o) {
    var s = o.hue, u = o.saturation, l = o.lightness, h = o.alpha, m = h === void 0 ? 1 : h;
    return hslaTemplate({
      hue: Math.round(s),
      saturation: percent.transform(sanitize(u)),
      lightness: percent.transform(sanitize(l)),
      alpha: sanitize(alpha.transform(m))
    });
  }
}, hex = __assign$1(__assign$1({}, rgba), {
  test: function(o) {
    return typeof o == "string" && isColorString(o, "#");
  },
  parse: function(o) {
    var s = "", u = "", l = "";
    return o.length > 4 ? (s = o.substr(1, 2), u = o.substr(3, 2), l = o.substr(5, 2)) : (s = o.substr(1, 1), u = o.substr(2, 1), l = o.substr(3, 1), s += s, u += u, l += l), {
      red: parseInt(s, 16),
      green: parseInt(u, 16),
      blue: parseInt(l, 16),
      alpha: 1
    };
  }
}), color = {
  test: function(o) {
    return typeof o == "string" && singleColorRegex.test(o) || isRgba(o) || isHsla(o);
  },
  parse: function(o) {
    return rgba.test(o) ? rgba.parse(o) : hsla.test(o) ? hsla.parse(o) : hex.test(o) ? hex.parse(o) : o;
  },
  transform: function(o) {
    return isRgba(o) ? rgba.transform(o) : isHsla(o) ? hsla.transform(o) : o;
  }
}, COLOR_TOKEN = "${c}", NUMBER_TOKEN = "${n}", convertNumbersToZero = function(o) {
  return typeof o == "number" ? 0 : o;
}, complex = {
  test: function(o) {
    if (typeof o != "string" || !isNaN(o))
      return !1;
    var s = 0, u = o.match(floatRegex), l = o.match(colorRegex);
    return u && (s += u.length), l && (s += l.length), s > 0;
  },
  parse: function(o) {
    var s = o, u = [], l = s.match(colorRegex);
    l && (s = s.replace(colorRegex, COLOR_TOKEN), u.push.apply(u, l.map(color.parse)));
    var h = s.match(floatRegex);
    return h && u.push.apply(u, h.map(number.parse)), u;
  },
  createTransformer: function(o) {
    var s = o, u = 0, l = o.match(colorRegex), h = l ? l.length : 0;
    if (l)
      for (var m = 0; m < h; m++)
        s = s.replace(l[m], COLOR_TOKEN), u++;
    var C = s.match(floatRegex), O = C ? C.length : 0;
    if (C)
      for (var m = 0; m < O; m++)
        s = s.replace(C[m], NUMBER_TOKEN), u++;
    return function(le) {
      for (var We = s, ye = 0; ye < u; ye++)
        We = We.replace(ye < h ? COLOR_TOKEN : NUMBER_TOKEN, ye < h ? color.transform(le[ye]) : sanitize(le[ye]));
      return We;
    };
  },
  getAnimatableNone: function(o) {
    var s = complex.parse(o), u = complex.createTransformer(o);
    return u(s.map(convertNumbersToZero));
  }
}, DEFAULT_OVERSHOOT_STRENGTH = 1.525, reversed = function(o) {
  return function(s) {
    return 1 - o(1 - s);
  };
}, mirrored = function(o) {
  return function(s) {
    return s <= 0.5 ? o(2 * s) / 2 : (2 - o(2 * (1 - s))) / 2;
  };
}, createReversedEasing = reversed, createMirroredEasing = mirrored, createExpoIn = function(o) {
  return function(s) {
    return Math.pow(s, o);
  };
}, createBackIn = function(o) {
  return function(s) {
    return s * s * ((o + 1) * s - o);
  };
}, createAnticipateEasing = function(o) {
  var s = createBackIn(o);
  return function(u) {
    return (u *= 2) < 1 ? 0.5 * s(u) : 0.5 * (2 - Math.pow(2, -10 * (u - 1)));
  };
}, linear = function(o) {
  return o;
}, easeIn = /* @__PURE__ */ createExpoIn(2), easeOut = /* @__PURE__ */ reversed(easeIn), easeInOut = /* @__PURE__ */ mirrored(easeIn), circIn = function(o) {
  return 1 - Math.sin(Math.acos(o));
}, circOut = /* @__PURE__ */ reversed(circIn), circInOut = /* @__PURE__ */ mirrored(circOut), backIn = /* @__PURE__ */ createBackIn(DEFAULT_OVERSHOOT_STRENGTH), backOut = /* @__PURE__ */ reversed(backIn), backInOut = /* @__PURE__ */ mirrored(backIn), anticipate = /* @__PURE__ */ createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH), BOUNCE_FIRST_THRESHOLD = 4 / 11, BOUNCE_SECOND_THRESHOLD = 8 / 11, BOUNCE_THIRD_THRESHOLD = 9 / 10, ca = 4356 / 361, cb = 35442 / 1805, cc = 16061 / 1805, bounceOut = function(o) {
  var s = o * o;
  return o < BOUNCE_FIRST_THRESHOLD ? 7.5625 * s : o < BOUNCE_SECOND_THRESHOLD ? 9.075 * s - 9.9 * o + 3.4 : o < BOUNCE_THIRD_THRESHOLD ? ca * s - cb * o + cc : 10.8 * o * o - 20.52 * o + 10.72;
}, bounceIn = function(o) {
  return 1 - bounceOut(1 - o);
}, bounceInOut = function(o) {
  return o < 0.5 ? 0.5 * (1 - bounceOut(1 - o * 2)) : 0.5 * bounceOut(o * 2 - 1) + 0.5;
}, NEWTON_ITERATIONS = 8, NEWTON_MIN_SLOPE = 1e-3, SUBDIVISION_PRECISION = 1e-7, SUBDIVISION_MAX_ITERATIONS = 10, K_SPLINE_TABLE_SIZE = 11, K_SAMPLE_STEP_SIZE = 1 / (K_SPLINE_TABLE_SIZE - 1), FLOAT_32_SUPPORTED = typeof Float32Array < "u", a = function(o, s) {
  return 1 - 3 * s + 3 * o;
}, b$1 = function(o, s) {
  return 3 * s - 6 * o;
}, c = function(o) {
  return 3 * o;
}, getSlope = function(o, s, u) {
  return 3 * a(s, u) * o * o + 2 * b$1(s, u) * o + c(s);
}, calcBezier = function(o, s, u) {
  return ((a(s, u) * o + b$1(s, u)) * o + c(s)) * o;
};
function cubicBezier(o, s, u, l) {
  var h = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE), m = function(ye, Fe, Ue) {
    var Le = 0, Ze, Xe;
    do
      Xe = Fe + (Ue - Fe) / 2, Ze = calcBezier(Xe, o, u) - ye, Ze > 0 ? Ue = Xe : Fe = Xe;
    while (Math.abs(Ze) > SUBDIVISION_PRECISION && ++Le < SUBDIVISION_MAX_ITERATIONS);
    return Xe;
  }, C = function(ye, Fe) {
    for (var Ue = 0, Le = 0, Ze; Ue < NEWTON_ITERATIONS; ++Ue) {
      if (Le = getSlope(Fe, o, u), Le === 0)
        return Fe;
      Ze = calcBezier(Fe, o, u) - ye, Fe -= Ze / Le;
    }
    return Fe;
  }, O = function() {
    for (var ye = 0; ye < K_SPLINE_TABLE_SIZE; ++ye)
      h[ye] = calcBezier(ye * K_SAMPLE_STEP_SIZE, o, u);
  }, le = function(ye) {
    for (var Fe = 0, Ue = 1, Le = K_SPLINE_TABLE_SIZE - 1, Ze = 0, Xe = 0, Je = 0; Ue !== Le && h[Ue] <= ye; ++Ue)
      Fe += K_SAMPLE_STEP_SIZE;
    return --Ue, Ze = (ye - h[Ue]) / (h[Ue + 1] - h[Ue]), Xe = Fe + Ze * K_SAMPLE_STEP_SIZE, Je = getSlope(Xe, o, u), Je >= NEWTON_MIN_SLOPE ? C(ye, Xe) : Je === 0 ? Xe : m(ye, Fe, Fe + K_SAMPLE_STEP_SIZE);
  };
  O();
  var We = function(ye) {
    var Fe;
    return o === s && u === l ? Fe = ye : ye === 0 ? Fe = 0 : ye === 1 ? Fe = 1 : Fe = calcBezier(le(ye), s, l), Fe;
  };
  return We;
}
const easingLookup = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  anticipate,
  backIn,
  backInOut,
  backOut,
  bounceIn,
  bounceInOut,
  bounceOut,
  circIn,
  circInOut,
  circOut,
  createAnticipateEasing,
  createBackIn,
  createExpoIn,
  createMirroredEasing,
  createReversedEasing,
  cubicBezier,
  easeIn,
  easeInOut,
  easeOut,
  linear,
  mirrored,
  reversed
}, Symbol.toStringTag, { value: "Module" }));
var zeroPoint = {
  x: 0,
  y: 0,
  z: 0
}, isNum = function(o) {
  return typeof o == "number";
}, curryRange = function(o) {
  return function(s, u, l) {
    return l !== void 0 ? o(s, u, l) : function(h) {
      return o(s, u, h);
    };
  };
}, clamp$1 = function(o, s, u) {
  return Math.min(Math.max(u, o), s);
}, clamp$1$1 = curryRange(clamp$1), isPoint = function(o) {
  return o.hasOwnProperty("x") && o.hasOwnProperty("y");
}, isPoint3D = function(o) {
  return isPoint(o) && o.hasOwnProperty("z");
}, distance1D = function(o, s) {
  return Math.abs(o - s);
}, distance = function(o, s) {
  if (s === void 0 && (s = zeroPoint), isNum(o) && isNum(s))
    return distance1D(o, s);
  if (isPoint(o) && isPoint(s)) {
    var u = distance1D(o.x, s.x), l = distance1D(o.y, s.y), h = isPoint3D(o) && isPoint3D(s) ? distance1D(o.z, s.z) : 0;
    return Math.sqrt(Math.pow(u, 2) + Math.pow(l, 2) + Math.pow(h, 2));
  }
  return 0;
}, progress = function(o, s, u) {
  var l = s - o;
  return l === 0 ? 1 : (u - o) / l;
}, mix = function(o, s, u) {
  return -u * o + u * s + o;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
  return __assign = Object.assign || function(s) {
    for (var u, l = 1, h = arguments.length; l < h; l++) {
      u = arguments[l];
      for (var m in u)
        Object.prototype.hasOwnProperty.call(u, m) && (s[m] = u[m]);
    }
    return s;
  }, __assign.apply(this, arguments);
}, mixLinearColor = function(o, s, u) {
  var l = o * o, h = s * s;
  return Math.sqrt(Math.max(0, u * (h - l) + l));
}, colorTypes = [hex, rgba, hsla], getColorType = function(o) {
  return colorTypes.find(function(s) {
    return s.test(o);
  });
}, notAnimatable = function(o) {
  return "'" + o + "' is not an animatable color. Use the equivalent color code instead.";
}, mixColor = function(o, s) {
  var u = getColorType(o), l = getColorType(s);
  invariant(!!u, notAnimatable(o)), invariant(!!l, notAnimatable(s)), invariant(u.transform === l.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
  var h = u.parse(o), m = l.parse(s), C = __assign({}, h), O = u === hsla ? mix : mixLinearColor;
  return function(le) {
    for (var We in C)
      We !== "alpha" && (C[We] = O(h[We], m[We], le));
    return C.alpha = mix(h.alpha, m.alpha, le), u.transform(C);
  };
}, combineFunctions = function(o, s) {
  return function(u) {
    return s(o(u));
  };
}, pipe = function() {
  for (var o = [], s = 0; s < arguments.length; s++)
    o[s] = arguments[s];
  return o.reduce(combineFunctions);
};
function getMixer(o, s) {
  return isNum(o) ? function(u) {
    return mix(o, s, u);
  } : color.test(o) ? mixColor(o, s) : mixComplex(o, s);
}
var mixArray = function(o, s) {
  var u = o.slice(), l = u.length, h = o.map(function(m, C) {
    return getMixer(m, s[C]);
  });
  return function(m) {
    for (var C = 0; C < l; C++)
      u[C] = h[C](m);
    return u;
  };
};
function analyse(o) {
  for (var s = complex.parse(o), u = s.length, l = 0, h = 0, m = 0, C = 0; C < u; C++)
    l || typeof s[C] == "number" ? l++ : s[C].hue !== void 0 ? m++ : h++;
  return {
    parsed: s,
    numNumbers: l,
    numRGB: h,
    numHSL: m
  };
}
var mixComplex = function(o, s) {
  var u = complex.createTransformer(s), l = analyse(o), h = analyse(s);
  return invariant(l.numHSL === h.numHSL && l.numRGB === h.numRGB && l.numNumbers >= h.numNumbers, "Complex values '" + o + "' and '" + s + "' too different to mix. Ensure all colors are of the same type."), pipe(mixArray(l.parsed, h.parsed), u);
}, velocityPerFrame = function(o, s) {
  return isNum(o) ? o / (1e3 / s) : 0;
}, velocityPerSecond = function(o, s) {
  return s ? o * (1e3 / s) : 0;
};
clamp$1$1(0, 1);
var createStyler = function(o) {
  var s = o.onRead, u = o.onRender, l = o.uncachedValues, h = l === void 0 ? /* @__PURE__ */ new Set() : l, m = o.useCache, C = m === void 0 ? !0 : m;
  return function(O) {
    O === void 0 && (O = {});
    var le = __rest(O, []), We = {}, ye = [], Fe = !1;
    function Ue(Ze, Xe) {
      Ze.startsWith("--") && (le.hasCSSVariable = !0);
      var Je = We[Ze];
      We[Ze] = Xe, We[Ze] !== Je && (ye.indexOf(Ze) === -1 && ye.push(Ze), Fe || (Fe = !0, sync.render(Le.render)));
    }
    var Le = {
      get: function(Ze, Xe) {
        Xe === void 0 && (Xe = !1);
        var Je = !Xe && C && !h.has(Ze) && We[Ze] !== void 0;
        return Je ? We[Ze] : s(Ze, le);
      },
      set: function(Ze, Xe) {
        if (typeof Ze == "string")
          Ue(Ze, Xe);
        else
          for (var Je in Ze)
            Ue(Je, Ze[Je]);
        return this;
      },
      render: function(Ze) {
        return Ze === void 0 && (Ze = !1), (Fe || Ze === !0) && (u(We, le, ye), Fe = !1, ye.length = 0), this;
      }
    };
    return Le;
  };
}, CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g, REPLACE_TEMPLATE = "$1-$2", camelToDash = function(o) {
  return o.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
}, camelCache = /* @__PURE__ */ new Map(), dashCache = /* @__PURE__ */ new Map(), prefixes = ["Webkit", "Moz", "O", "ms", ""], numPrefixes = prefixes.length, isBrowser$2 = typeof document < "u", testElement, setDashPrefix = function(o, s) {
  return dashCache.set(o, camelToDash(s));
}, testPrefix = function(o) {
  testElement = testElement || document.createElement("div");
  for (var s = 0; s < numPrefixes; s++) {
    var u = prefixes[s], l = u === "", h = l ? o : u + o.charAt(0).toUpperCase() + o.slice(1);
    if (h in testElement.style || l) {
      if (l && o === "clipPath" && dashCache.has(o))
        return;
      camelCache.set(o, h), setDashPrefix(o, (l ? "" : "-") + camelToDash(h));
    }
  }
}, setServerProperty = function(o) {
  return setDashPrefix(o, o);
}, prefixer = function(o, s) {
  s === void 0 && (s = !1);
  var u = s ? dashCache : camelCache;
  return u.has(o) || (isBrowser$2 ? testPrefix(o) : setServerProperty(o)), u.get(o) || o;
}, axes = ["", "X", "Y", "Z"], order$1 = ["translate", "scale", "rotate", "skew", "transformPerspective"], transformProps = /* @__PURE__ */ order$1.reduce(function(o, s) {
  return axes.reduce(function(u, l) {
    return u.push(s + l), u;
  }, o);
}, ["x", "y", "z"]), transformPropDictionary = /* @__PURE__ */ transformProps.reduce(function(o, s) {
  return o[s] = !0, o;
}, {});
function isTransformProp(o) {
  return transformPropDictionary[o] === !0;
}
function sortTransformProps(o, s) {
  return transformProps.indexOf(o) - transformProps.indexOf(s);
}
var transformOriginProps$1 = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp$1(o) {
  return transformOriginProps$1.has(o);
}
var int = /* @__PURE__ */ __assign$1(/* @__PURE__ */ __assign$1({}, number), {
  transform: Math.round
}), valueTypes$1 = {
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  zIndex: int,
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
}, getValueType$1 = function(o) {
  return valueTypes$1[o];
}, getValueAsType = function(o, s) {
  return s && typeof o == "number" ? s.transform(o) : o;
}, SCROLL_LEFT = "scrollLeft", SCROLL_TOP = "scrollTop", scrollKeys = /* @__PURE__ */ new Set([SCROLL_LEFT, SCROLL_TOP]), blacklist = /* @__PURE__ */ new Set([SCROLL_LEFT, SCROLL_TOP, "transform"]), translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
};
function isCustomTemplate(o) {
  return typeof o == "function";
}
function buildTransform(o, s, u, l, h, m) {
  m === void 0 && (m = !0);
  var C = "", O = !1;
  u.sort(sortTransformProps);
  for (var le = u.length, We = 0; We < le; We++) {
    var ye = u[We];
    C += (translateAlias[ye] || ye) + "(" + s[ye] + ") ", O = ye === "z" ? !0 : O;
  }
  return !O && h ? C += "translateZ(0)" : C = C.trim(), isCustomTemplate(o.transform) ? C = o.transform(s, l ? "" : C) : m && l && (C = "none"), C;
}
function buildStyleProperty(o, s, u, l, h, m, C, O) {
  s === void 0 && (s = !0), u === void 0 && (u = {}), l === void 0 && (l = {}), h === void 0 && (h = {}), m === void 0 && (m = []), C === void 0 && (C = !1), O === void 0 && (O = !0);
  var le = !0, We = !1, ye = !1;
  for (var Fe in o) {
    var Ue = o[Fe], Le = getValueType$1(Fe), Ze = getValueAsType(Ue, Le);
    isTransformProp(Fe) ? (We = !0, l[Fe] = Ze, m.push(Fe), le && (Le.default && Ue !== Le.default || !Le.default && Ue !== 0) && (le = !1)) : isTransformOriginProp$1(Fe) ? (h[Fe] = Ze, ye = !0) : (!blacklist.has(Fe) || !isCustomTemplate(Ze)) && (u[prefixer(Fe, C)] = Ze);
  }
  return (We || typeof o.transform == "function") && (u.transform = buildTransform(o, l, m, le, s, O)), ye && (u.transformOrigin = (h.originX || "50%") + " " + (h.originY || "50%") + " " + (h.originZ || 0)), u;
}
function createStyleBuilder(o) {
  var s = o === void 0 ? {} : o, u = s.enableHardwareAcceleration, l = u === void 0 ? !0 : u, h = s.isDashCase, m = h === void 0 ? !0 : h, C = s.allowTransformNone, O = C === void 0 ? !0 : C, le = {}, We = {}, ye = {}, Fe = [];
  return function(Ue) {
    return Fe.length = 0, buildStyleProperty(Ue, l, le, We, ye, Fe, m, O), le;
  };
}
function onRead(o, s) {
  var u = s.element, l = s.preparseOutput, h = getValueType$1(o);
  if (isTransformProp(o))
    return h && h.default || 0;
  if (scrollKeys.has(o))
    return u[o];
  var m = window.getComputedStyle(u, null).getPropertyValue(prefixer(o, !0)) || 0;
  return l && h && h.test(m) && h.parse ? h.parse(m) : m;
}
function onRender(o, s, u) {
  var l = s.element, h = s.buildStyles, m = s.hasCSSVariable;
  if (Object.assign(l.style, h(o)), m)
    for (var C = u.length, O = 0; O < C; O++) {
      var le = u[O];
      le.startsWith("--") && l.style.setProperty(le, o[le]);
    }
  u.indexOf(SCROLL_LEFT) !== -1 && (l[SCROLL_LEFT] = o[SCROLL_LEFT]), u.indexOf(SCROLL_TOP) !== -1 && (l[SCROLL_TOP] = o[SCROLL_TOP]);
}
var cssStyler = /* @__PURE__ */ createStyler({
  onRead,
  onRender,
  uncachedValues: scrollKeys
});
function createCssStyler(o, s) {
  s === void 0 && (s = {});
  var u = s.enableHardwareAcceleration, l = s.allowTransformNone, h = __rest(s, ["enableHardwareAcceleration", "allowTransformNone"]);
  return cssStyler(__assign$1({
    element: o,
    buildStyles: createStyleBuilder({
      enableHardwareAcceleration: u,
      allowTransformNone: l
    }),
    preparseOutput: !0
  }, h));
}
var camelCaseAttributes = /* @__PURE__ */ new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues"]), defaultOrigin = 0.5, svgAttrsTemplate = function() {
  return {
    style: {}
  };
}, progressToPixels = function(o, s) {
  return px.transform(o * s);
}, unmeasured = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};
function calcOrigin(o, s, u) {
  return typeof o == "string" ? o : px.transform(s + u * o);
}
function calculateSVGTransformOrigin(o, s, u) {
  return calcOrigin(s, o.x, o.width) + " " + calcOrigin(u, o.y, o.height);
}
var svgStyleConfig = {
  enableHardwareAcceleration: !1,
  isDashCase: !1
};
function buildSVGAttrs(o, s, u, l, h, m) {
  s === void 0 && (s = unmeasured), l === void 0 && (l = createStyleBuilder(svgStyleConfig)), h === void 0 && (h = svgAttrsTemplate()), m === void 0 && (m = !0);
  var C = o.attrX, O = o.attrY, le = o.originX, We = o.originY, ye = o.pathLength, Fe = o.pathSpacing, Ue = Fe === void 0 ? 1 : Fe, Le = o.pathOffset, Ze = Le === void 0 ? 0 : Le, Xe = __rest(o, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]), Je = l(Xe);
  for (var it in Je)
    if (it === "transform")
      h.style.transform = Je[it];
    else {
      var et = m && !camelCaseAttributes.has(it) ? camelToDash(it) : it;
      h[et] = Je[it];
    }
  return (le !== void 0 || We !== void 0 || Je.transform) && (h.style.transformOrigin = calculateSVGTransformOrigin(s, le !== void 0 ? le : defaultOrigin, We !== void 0 ? We : defaultOrigin)), C !== void 0 && (h.x = C), O !== void 0 && (h.y = O), u !== void 0 && ye !== void 0 && (h[m ? "stroke-dashoffset" : "strokeDashoffset"] = progressToPixels(-Ze, u), h[m ? "stroke-dasharray" : "strokeDasharray"] = progressToPixels(ye, u) + " " + progressToPixels(Ue, u)), h;
}
function createAttrBuilder(o, s, u) {
  u === void 0 && (u = !0);
  var l = svgAttrsTemplate(), h = createStyleBuilder(svgStyleConfig);
  return function(m) {
    return buildSVGAttrs(m, o, s, h, l, u);
  };
}
var getDimensions = function(o) {
  return typeof o.getBBox == "function" ? o.getBBox() : o.getBoundingClientRect();
}, getSVGElementDimensions = function(o) {
  try {
    return getDimensions(o);
  } catch {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}, isPath = function(o) {
  return o.tagName === "path";
}, svgStyler = /* @__PURE__ */ createStyler({
  onRead: function(o, s) {
    var u = s.element;
    if (o = camelCaseAttributes.has(o) ? o : camelToDash(o), isTransformProp(o)) {
      var l = getValueType$1(o);
      return l && l.default || 0;
    } else
      return u.getAttribute(o);
  },
  onRender: function(o, s) {
    var u = s.element, l = s.buildAttrs, h = l(o);
    for (var m in h)
      m === "style" ? Object.assign(u.style, h.style) : u.setAttribute(m, h[m]);
  }
}), svg = function(o) {
  var s = getSVGElementDimensions(o), u = isPath(o) && o.getTotalLength ? o.getTotalLength() : void 0;
  return svgStyler({
    element: o,
    buildAttrs: createAttrBuilder(s, u)
  });
}, viewport = /* @__PURE__ */ createStyler({
  useCache: !1,
  onRead: function(o) {
    return o === "scrollTop" ? window.pageYOffset : window.pageXOffset;
  },
  onRender: function(o) {
    var s = o.scrollTop, u = s === void 0 ? 0 : s, l = o.scrollLeft, h = l === void 0 ? 0 : l;
    return window.scrollTo(h, u);
  }
}), cache = /* @__PURE__ */ new WeakMap(), isHTMLElement$1 = function(o) {
  return o instanceof HTMLElement || typeof o.click == "function";
}, isSVGElement = function(o) {
  return o instanceof SVGElement || "ownerSVGElement" in o;
}, createDOMStyler = function(o, s) {
  var u;
  return o === window ? u = viewport(o) : isHTMLElement$1(o) ? u = createCssStyler(o, s) : isSVGElement(o) && (u = svg(o)), invariant(u !== void 0, "No valid node provided. Node must be HTMLElement, SVGElement or window."), cache.set(o, u), u;
}, getStyler = function(o, s) {
  return cache.has(o) ? cache.get(o) : createDOMStyler(o, s);
};
function index$1(o, s) {
  var u = typeof o == "string" ? document.querySelector(o) : o;
  return getStyler(u, s);
}
var Observer = /* @__PURE__ */ function() {
  function o(s, u) {
    var l = this, h = s.middleware, m = s.onComplete;
    this.isActive = !0, this.update = function(C) {
      l.observer.update && l.updateObserver(C);
    }, this.complete = function() {
      l.observer.complete && l.isActive && l.observer.complete(), l.onComplete && l.onComplete(), l.isActive = !1;
    }, this.error = function(C) {
      l.observer.error && l.isActive && l.observer.error(C), l.isActive = !1;
    }, this.observer = u, this.updateObserver = function(C) {
      return u.update(C);
    }, this.onComplete = m, u.update && h && h.length && h.forEach(function(C) {
      return l.updateObserver = C(l.updateObserver, l.complete);
    });
  }
  return o;
}(), createObserver = function(o, s, u) {
  var l = s.middleware;
  return typeof o == "function" ? new Observer({
    middleware: l,
    onComplete: u
  }, {
    update: o
  }) : new Observer({
    middleware: l,
    onComplete: u
  }, o);
}, Action = /* @__PURE__ */ function() {
  function o(s) {
    s === void 0 && (s = {}), this.props = s;
  }
  return o.prototype.create = function(s) {
    return new o(s);
  }, o.prototype.start = function(s) {
    s === void 0 && (s = {});
    var u = !1, l = {
      stop: function() {
      }
    }, h = this.props, m = h.init, C = __rest(h, ["init"]), O = createObserver(s, C, function() {
      u = !0, l.stop();
    }), le = m(O);
    return l = le ? __assign$1({}, l, le) : l, u && l.stop(), l;
  }, o.prototype.applyMiddleware = function(s) {
    return this.create(__assign$1({}, this.props, {
      middleware: this.props.middleware ? [s].concat(this.props.middleware) : [s]
    }));
  }, o.prototype.pipe = function() {
    for (var s = [], u = 0; u < arguments.length; u++)
      s[u] = arguments[u];
    var l = s.length === 1 ? s[0] : pipe.apply(void 0, s);
    return this.applyMiddleware(function(h) {
      return function(m) {
        return h(l(m));
      };
    });
  }, o;
}(), action = function(o) {
  return new Action({
    init: o
  });
}, createVectorTests = function(o) {
  var s = Object.keys(o), u = function(m, C) {
    return m !== void 0 && !o[C](m);
  }, l = function(m) {
    return s.reduce(function(C, O) {
      return u(m[O], O) && C.push(O), C;
    }, []);
  }, h = function(m) {
    return m && s.some(function(C) {
      return u(m[C], C);
    });
  };
  return {
    getVectorKeys: l,
    testVectorProps: h
  };
}, unitTypes = [px, percent, degrees, vh, vw], findUnitType = function(o) {
  return unitTypes.find(function(s) {
    return s.test(o);
  });
}, isUnitProp = function(o) {
  return !!findUnitType(o);
}, createAction = function(o, s) {
  return o(s);
}, createUnitAction = function(o, s) {
  var u = s.from, l = s.to, h = __rest(s, ["from", "to"]), m = findUnitType(u) || findUnitType(l), C = m.transform, O = m.parse;
  return o(__assign$1({}, h, {
    from: typeof u == "string" ? O(u) : u,
    to: typeof l == "string" ? O(l) : l
  })).pipe(C);
}, createMixerAction = function(o) {
  return function(s, u) {
    var l = u.from, h = u.to, m = __rest(u, ["from", "to"]);
    return s(__assign$1({}, m, {
      from: 0,
      to: 1
    })).pipe(o(l, h));
  };
}, createColorAction = /* @__PURE__ */ createMixerAction(mixColor), createComplexAction = /* @__PURE__ */ createMixerAction(mixComplex), createVectorAction = function(o, s) {
  var u = createVectorTests(s), l = u.testVectorProps, h = u.getVectorKeys, m = function(C) {
    var O = l(C);
    if (!O)
      return o(C);
    var le = h(C), We = le[0], ye = C[We];
    return getActionCreator(ye)(o, C, le);
  };
  return m;
}, getActionCreator = function(o) {
  return typeof o == "number" ? createAction : isUnitProp(o) ? createUnitAction : color.test(o) ? createColorAction : complex.test(o) ? createComplexAction : createAction;
}, decay = function(o) {
  return o === void 0 && (o = {}), action(function(s) {
    var u = s.complete, l = s.update, h = o.velocity, m = h === void 0 ? 0 : h, C = o.from, O = C === void 0 ? 0 : C, le = o.power, We = le === void 0 ? 0.8 : le, ye = o.timeConstant, Fe = ye === void 0 ? 350 : ye, Ue = o.restDelta, Le = Ue === void 0 ? 0.5 : Ue, Ze = o.modifyTarget, Xe = 0, Je = We * m, it = Math.round(O + Je), et = typeof Ze > "u" ? it : Ze(it), at = sync.update(function($e) {
      var Ke = $e.delta;
      Xe += Ke;
      var tt = -Je * Math.exp(-Xe / Fe), ut = tt > Le || tt < -Le, st = ut ? et + tt : et;
      l(st), ut || (cancelSync.update(at), u());
    }, !0);
    return {
      stop: function() {
        return cancelSync.update(at);
      }
    };
  });
}, vectorDecay = /* @__PURE__ */ createVectorAction(decay, {
  from: number.test,
  modifyTarget: function(o) {
    return typeof o == "function";
  },
  velocity: number.test
}), spring = function(o) {
  return o === void 0 && (o = {}), action(function(s) {
    var u = s.update, l = s.complete, h = o.velocity, m = h === void 0 ? 0 : h, C = o.from, O = C === void 0 ? 0 : C, le = o.to, We = le === void 0 ? 0 : le, ye = o.stiffness, Fe = ye === void 0 ? 100 : ye, Ue = o.damping, Le = Ue === void 0 ? 10 : Ue, Ze = o.mass, Xe = Ze === void 0 ? 1 : Ze, Je = o.restSpeed, it = Je === void 0 ? 0.01 : Je, et = o.restDelta, at = et === void 0 ? 0.01 : et, $e = m ? -(m / 1e3) : 0, Ke = 0, tt = We - O, ut = O, st = ut, ot = sync.update(function(ht) {
      var vt = ht.delta;
      Ke += vt;
      var At = Le / (2 * Math.sqrt(Fe * Xe)), gt = Math.sqrt(Fe / Xe) / 1e3;
      if (st = ut, At < 1) {
        var bt = Math.exp(-At * gt * Ke), wt = gt * Math.sqrt(1 - At * At);
        ut = We - bt * (($e + At * gt * tt) / wt * Math.sin(wt * Ke) + tt * Math.cos(wt * Ke));
      } else {
        var bt = Math.exp(-gt * Ke);
        ut = We - bt * (tt + ($e + gt * tt) * Ke);
      }
      m = velocityPerSecond(ut - st, vt);
      var Ot = Math.abs(m) <= it, yt = Math.abs(We - ut) <= at;
      Ot && yt ? (ut = We, u(ut), cancelSync.update(ot), l()) : u(ut);
    }, !0);
    return {
      stop: function() {
        return cancelSync.update(ot);
      }
    };
  });
}, vectorSpring = /* @__PURE__ */ createVectorAction(spring, {
  from: number.test,
  to: number.test,
  stiffness: number.test,
  damping: number.test,
  mass: number.test,
  velocity: number.test
}), inertia = function(o) {
  var s = o.from, u = s === void 0 ? 0 : s, l = o.velocity, h = l === void 0 ? 0 : l, m = o.min, C = o.max, O = o.power, le = O === void 0 ? 0.8 : O, We = o.timeConstant, ye = We === void 0 ? 700 : We, Fe = o.bounceStiffness, Ue = Fe === void 0 ? 500 : Fe, Le = o.bounceDamping, Ze = Le === void 0 ? 10 : Le, Xe = o.restDelta, Je = Xe === void 0 ? 1 : Xe, it = o.modifyTarget;
  return action(function(et) {
    var at = et.update, $e = et.complete, Ke = u, tt = u, ut, st = !1, ot = function(yt) {
      return m !== void 0 && yt <= m;
    }, ht = function(yt) {
      return C !== void 0 && yt >= C;
    }, vt = function(yt) {
      return ot(yt) || ht(yt);
    }, At = function(yt, Qe) {
      return ot(yt) && Qe < 0 || ht(yt) && Qe > 0;
    }, gt = function(yt) {
      at(yt), Ke = tt, tt = yt, h = velocityPerSecond(tt - Ke, getFrameData().delta), ut && !st && At(yt, h) && wt({
        from: yt,
        velocity: h
      });
    }, bt = function(yt, Qe) {
      ut && ut.stop(), ut = yt.start({
        update: gt,
        complete: function() {
          if (Qe) {
            Qe();
            return;
          }
          $e();
        }
      });
    }, wt = function(yt) {
      st = !0, bt(vectorSpring(__assign$1({}, yt, {
        to: ot(yt.from) ? m : C,
        stiffness: Ue,
        damping: Ze,
        restDelta: Je
      })));
    };
    if (vt(u))
      wt({
        from: u,
        velocity: h
      });
    else if (h !== 0) {
      var Ot = vectorDecay({
        from: u,
        velocity: h,
        timeConstant: ye,
        power: le,
        restDelta: vt(u) ? 20 : Je,
        modifyTarget: it
      });
      bt(Ot, function() {
        vt(tt) ? wt({
          from: tt,
          velocity: h
        }) : $e();
      });
    } else
      $e();
    return {
      stop: function() {
        return ut && ut.stop();
      }
    };
  });
}, index = /* @__PURE__ */ createVectorAction(inertia, {
  from: number.test,
  velocity: number.test,
  min: number.test,
  max: number.test,
  damping: number.test,
  stiffness: number.test,
  modifyTarget: function(o) {
    return typeof o == "function";
  }
}), scrubber = function(o) {
  var s = o.from, u = s === void 0 ? 0 : s, l = o.to, h = l === void 0 ? 1 : l, m = o.ease, C = m === void 0 ? linear : m, O = o.reverseEase, le = O === void 0 ? !1 : O;
  return le && (C = createReversedEasing(C)), action(function(We) {
    var ye = We.update;
    return {
      seek: function(Fe) {
        return ye(Fe);
      }
    };
  }).pipe(C, function(We) {
    return mix(u, h, We);
  });
}, vectorScrubber = /* @__PURE__ */ createVectorAction(scrubber, {
  ease: function(o) {
    return typeof o == "function";
  },
  from: number.test,
  to: number.test
}), clampProgress = /* @__PURE__ */ clamp$1$1(0, 1), tween = function(o) {
  return o === void 0 && (o = {}), action(function(s) {
    var u = s.update, l = s.complete, h = o.duration, m = h === void 0 ? 300 : h, C = o.ease, O = C === void 0 ? easeOut : C, le = o.flip, We = le === void 0 ? 0 : le, ye = o.loop, Fe = ye === void 0 ? 0 : ye, Ue = o.yoyo, Le = Ue === void 0 ? 0 : Ue, Ze = o.repeatDelay, Xe = Ze === void 0 ? 0 : Ze, Je = o.from, it = Je === void 0 ? 0 : Je, et = o.to, at = et === void 0 ? 1 : et, $e = o.elapsed, Ke = $e === void 0 ? 0 : $e, tt = o.flipCount, ut = tt === void 0 ? 0 : tt, st = o.yoyoCount, ot = st === void 0 ? 0 : st, ht = o.loopCount, vt = ht === void 0 ? 0 : ht, At = vectorScrubber({
      from: it,
      to: at,
      ease: O
    }).start(u), gt = 0, bt, wt = !1, Ot = function(lt) {
      var ct;
      lt === void 0 && (lt = !1), ct = [at, it], it = ct[0], at = ct[1], At = vectorScrubber({
        from: it,
        to: at,
        ease: O,
        reverseEase: lt
      }).start(u);
    }, yt = function() {
      var lt = wt && Ke > m + Xe;
      if (!lt)
        return !1;
      if (lt && !Fe && !We && !Le)
        return !0;
      var ct = Ke - m;
      return Ke = ct - Xe, Fe && vt < Fe ? (vt++, !1) : We && ut < We ? (ut++, Ot(), !1) : Le && ot < Le ? (ot++, Ot(ot % 2 !== 0), !1) : !0;
    }, Qe = function() {
      gt = clampProgress(progress(0, m, Ke)), At.seek(gt);
    }, nt = function() {
      wt = !0, bt = sync.update(function(lt) {
        var ct = lt.delta;
        Ke += ct, Qe(), yt() && (cancelSync.update(bt), l && sync.update(l, !1, !0));
      }, !0);
    }, rt = function() {
      wt = !1, bt && cancelSync.update(bt);
    };
    return nt(), {
      isActive: function() {
        return wt;
      },
      getElapsed: function() {
        return clamp$1$1(0, m, Ke);
      },
      getProgress: function() {
        return gt;
      },
      stop: function() {
        rt();
      },
      pause: function() {
        return rt(), this;
      },
      resume: function() {
        return wt || nt(), this;
      },
      seek: function(lt) {
        return Ke = mix(0, m, lt), sync.update(Qe, !1, !0), this;
      },
      reverse: function() {
        return Ot(), this;
      }
    };
  });
}, clampProgress$1 = /* @__PURE__ */ clamp$1$1(0, 1), defaultEasings = function(o, s) {
  return o.map(function() {
    return s || easeOut;
  }).splice(0, o.length - 1);
}, defaultTimings = function(o) {
  var s = o.length;
  return o.map(function(u, l) {
    return l !== 0 ? l / (s - 1) : 0;
  });
}, interpolateScrubbers = function(o, s, u) {
  var l = o.length, h = l - 1, m = h - 1, C = s.map(function(O) {
    return O.start(u);
  });
  return function(O) {
    O <= o[0] && C[0].seek(0), O >= o[h] && C[m].seek(1);
    for (var le = 1; le < l && !(o[le] > O || le === h); le++)
      ;
    var We = progress(o[le - 1], o[le], O);
    C[le - 1].seek(clampProgress$1(We));
  };
}, keyframes$1 = function(o) {
  var s = o.easings, u = o.ease, l = u === void 0 ? linear : u, h = o.times, m = o.values, C = __rest(o, ["easings", "ease", "times", "values"]);
  s = Array.isArray(s) ? s : defaultEasings(m, s), h = h || defaultTimings(m);
  var O = s.map(function(le, We) {
    return vectorScrubber({
      from: m[We],
      to: m[We + 1],
      ease: le
    });
  });
  return tween(__assign$1({}, C, {
    ease: l
  })).applyMiddleware(function(le) {
    return interpolateScrubbers(h, O, le);
  });
}, physics = function(o) {
  return o === void 0 && (o = {}), action(function(s) {
    var u = s.complete, l = s.update, h = o.acceleration, m = h === void 0 ? 0 : h, C = o.friction, O = C === void 0 ? 0 : C, le = o.velocity, We = le === void 0 ? 0 : le, ye = o.springStrength, Fe = o.to, Ue = o.restSpeed, Le = Ue === void 0 ? 1e-3 : Ue, Ze = o.from, Xe = Ze === void 0 ? 0 : Ze, Je = Xe, it = sync.update(function(et) {
      var at = et.delta, $e = Math.max(at, 16);
      if (m && (We += velocityPerFrame(m, $e)), O && (We *= Math.pow(1 - O, $e / 100)), ye !== void 0 && Fe !== void 0) {
        var Ke = Fe - Je;
        We += Ke * velocityPerFrame(ye, $e);
      }
      Je += velocityPerFrame(We, $e), l(Je);
      var tt = Le !== !1 && (!We || Math.abs(We) <= Le);
      tt && (cancelSync.update(it), u());
    }, !0);
    return {
      set: function(et) {
        return Je = et, this;
      },
      setAcceleration: function(et) {
        return m = et, this;
      },
      setFriction: function(et) {
        return O = et, this;
      },
      setSpringStrength: function(et) {
        return ye = et, this;
      },
      setSpringTarget: function(et) {
        return Fe = et, this;
      },
      setVelocity: function(et) {
        return We = et, this;
      },
      stop: function() {
        return cancelSync.update(it);
      }
    };
  });
};
number.test, number.test, number.test, number.test, number.test, number.test;
var listen = function(o, s, u) {
  return action(function(l) {
    var h = l.update, m = s.split(" ").map(function(C) {
      return o.addEventListener(C, h, u), C;
    });
    return {
      stop: function() {
        return m.forEach(function(C) {
          return o.removeEventListener(C, h, u);
        });
      }
    };
  });
}, defaultPointerPos = function() {
  return {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    x: 0,
    y: 0
  };
}, eventToPoint = function(o, s) {
  return s === void 0 && (s = defaultPointerPos()), s.clientX = s.x = o.clientX, s.clientY = s.y = o.clientY, s.pageX = o.pageX, s.pageY = o.pageY, s;
}, points = [/* @__PURE__ */ defaultPointerPos()];
if (typeof document < "u") {
  var updatePointsLocation = function(o) {
    var s = o.touches, u = s.length;
    points.length = 0;
    for (var l = 0; l < u; l++) {
      var h = s[l];
      points.push(eventToPoint(h));
    }
  };
  listen(document, "touchstart touchmove", {
    passive: !0,
    capture: !0
  }).start(updatePointsLocation);
}
var point = /* @__PURE__ */ defaultPointerPos();
if (typeof document < "u") {
  var updatePointLocation = function(o) {
    eventToPoint(o, point);
  };
  listen(document, "mousedown mousemove", !0).start(updatePointLocation);
}
var delay = function(o) {
  return action(function(s) {
    var u = s.complete, l = setTimeout(u, o);
    return {
      stop: function() {
        return clearTimeout(l);
      }
    };
  });
}, isFloat = function(o) {
  return !isNaN(parseFloat(o));
}, MotionValue = (
  /** @class */
  function() {
    function o(s, u) {
      var l = this, h = u === void 0 ? {} : u, m = h.transformer, C = h.parent;
      this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.updateAndNotify = function(O, le) {
        le === void 0 && (le = !0), l.prev = l.current, l.current = l.transformer ? l.transformer(O) : O, l.updateSubscribers && l.prev !== l.current && l.updateSubscribers.forEach(l.notifySubscriber), l.children && l.children.forEach(l.setChild), le && l.renderSubscribers && l.renderSubscribers.forEach(l.notifySubscriber);
        var We = getFrameData(), ye = We.delta, Fe = We.timestamp;
        l.lastUpdated !== Fe && (l.timeDelta = ye, l.lastUpdated = Fe, sync.postRender(l.scheduleVelocityCheck));
      }, this.notifySubscriber = function(O) {
        O(l.current);
      }, this.scheduleVelocityCheck = function() {
        return sync.postRender(l.velocityCheck);
      }, this.velocityCheck = function(O) {
        var le = O.timestamp;
        le !== l.lastUpdated && (l.prev = l.current);
      }, this.setChild = function(O) {
        return O.set(l.current);
      }, this.parent = C, this.transformer = m, this.set(s, !1), this.canTrackVelocity = isFloat(this.current);
    }
    return o.prototype.addChild = function(s) {
      s === void 0 && (s = {});
      var u = new o(this.current, __assign$1({
        parent: this
      }, s));
      return this.children || (this.children = /* @__PURE__ */ new Set()), this.children.add(u), u;
    }, o.prototype.removeChild = function(s) {
      this.children && this.children.delete(s);
    }, o.prototype.subscribeTo = function(s, u) {
      var l = this, h = function() {
        return u(l.current);
      };
      return s.add(h), function() {
        return s.delete(h);
      };
    }, o.prototype.onChange = function(s) {
      return this.updateSubscribers || (this.updateSubscribers = /* @__PURE__ */ new Set()), this.subscribeTo(this.updateSubscribers, s);
    }, o.prototype.onRenderRequest = function(s) {
      return this.renderSubscribers || (this.renderSubscribers = /* @__PURE__ */ new Set()), this.notifySubscriber(s), this.subscribeTo(this.renderSubscribers, s);
    }, o.prototype.attach = function(s) {
      this.passiveEffect = s;
    }, o.prototype.set = function(s, u) {
      u === void 0 && (u = !0), !u || !this.passiveEffect ? this.updateAndNotify(s, u) : this.passiveEffect(s, this.updateAndNotify);
    }, o.prototype.get = function() {
      return this.current;
    }, o.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, o.prototype.start = function(s) {
      var u = this;
      return this.stop(), new Promise(function(l) {
        u.stopAnimation = s(l);
      }).then(function() {
        return u.clearAnimation();
      });
    }, o.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, o.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, o.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, o.prototype.destroy = function() {
      this.updateSubscribers && this.updateSubscribers.clear(), this.renderSubscribers && this.renderSubscribers.clear(), this.parent && this.parent.removeChild(this), this.stop();
    }, o;
  }()
);
function motionValue(o, s) {
  return new MotionValue(o, s);
}
function useConstant(o) {
  var s = useRef(null);
  return s.current === null && (s.current = o()), s.current;
}
var isMotionValue = function(o) {
  return o instanceof MotionValue;
}, updateStyler = createStyler({
  onRead: function() {
    return null;
  },
  onRender: function(o, s) {
    var u = s.onUpdate;
    return u(o);
  }
}), MotionValuesMap = (
  /** @class */
  function() {
    function o() {
      this.hasMounted = !1, this.values = /* @__PURE__ */ new Map(), this.unsubscribers = /* @__PURE__ */ new Map();
    }
    return o.prototype.has = function(s) {
      return this.values.has(s);
    }, o.prototype.set = function(s, u) {
      this.values.set(s, u), this.hasMounted && this.bindValueToOutput(s, u);
    }, o.prototype.get = function(s, u) {
      var l = this.values.get(s);
      return l === void 0 && u !== void 0 && (l = new MotionValue(u), this.set(s, l)), l;
    }, o.prototype.forEach = function(s) {
      return this.values.forEach(s);
    }, o.prototype.bindValueToOutput = function(s, u) {
      var l = this, h = function(le) {
        return l.output && l.output(s, le);
      }, m = u.onRenderRequest(h), C = function(le) {
        l.onUpdate && l.onUpdate.set(s, le);
      }, O = u.onChange(C);
      this.unsubscribers.has(s) && this.unsubscribers.get(s)(), this.unsubscribers.set(s, function() {
        m(), O();
      });
    }, o.prototype.setOnUpdate = function(s) {
      this.onUpdate = void 0, s && (this.onUpdate = updateStyler({
        onUpdate: s
      }));
    }, o.prototype.setTransformTemplate = function(s) {
      this.transformTemplate !== s && (this.transformTemplate = s, this.updateTransformTemplate());
    }, o.prototype.getTransformTemplate = function() {
      return this.transformTemplate;
    }, o.prototype.updateTransformTemplate = function() {
      this.output && this.output("transform", this.transformTemplate);
    }, o.prototype.mount = function(s) {
      var u = this;
      this.hasMounted = !0, s && (this.output = s), this.values.forEach(function(l, h) {
        return u.bindValueToOutput(h, l);
      }), this.updateTransformTemplate();
    }, o.prototype.unmount = function() {
      var s = this;
      this.values.forEach(function(u, l) {
        var h = s.unsubscribers.get(l);
        h && h();
      });
    }, o;
  }()
), specialMotionValueProps = /* @__PURE__ */ new Set(["dragOriginX", "dragOriginY"]), useMotionValues = function(o) {
  var s = useConstant(function() {
    var u = new MotionValuesMap();
    for (var l in o)
      isMotionValue(o[l]) && !specialMotionValueProps.has(l) && u.set(l, o[l]);
    return u;
  });
  return s.setOnUpdate(o.onUpdate), s.setTransformTemplate(o.transformTemplate), s;
}, session = null, syncRenderSession = {
  isOpen: function() {
    return session !== null;
  },
  open: function() {
    invariant(!session, "Sync render session already open"), session = [];
  },
  flush: function() {
    invariant(session !== null, "No sync render session found"), session && session.forEach(function(o) {
      return o.render();
    }), session = null;
  },
  push: function(o) {
    invariant(session !== null, "No sync render session found"), session && session.push(o);
  }
}, MountComponent = function(o) {
  var s = o.innerRef, u = o.values, l = o.isStatic;
  return useEffect(function() {
    invariant(s.current instanceof Element, "No `ref` found. Ensure components created with `motion.custom` forward refs using `React.forwardRef`");
    var h = index$1(s.current, {
      preparseOutput: !1,
      enableHardwareAcceleration: !l
    });
    return u.mount(function(m, C) {
      h.set(m, C), syncRenderSession.isOpen() && syncRenderSession.push(h);
    }), function() {
      return u.unmount();
    };
  }, []), null;
}, Mount = memo(MountComponent), createValueResolver = function(o) {
  return function(s) {
    var u = {};
    return s.forEach(function(l, h) {
      return u[h] = o(l);
    }), u;
  };
}, resolveCurrent = createValueResolver(function(o) {
  return o.get();
}), transformOriginProps = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]), isTransformOriginProp = function(o) {
  return transformOriginProps.has(o);
}, buildStyleAttr = function(o, s, u) {
  var l = resolveCurrent(o), h = o.getTransformTemplate();
  return h && (l.transform = s.transform ? h({}, s.transform) : h), buildStyleProperty(__assign$1(__assign$1({}, s), l), !u);
}, useMotionStyles = function(o, s, u, l) {
  s === void 0 && (s = {});
  var h = {}, m = useRef({}).current;
  for (var C in s) {
    var O = s[C];
    if (isMotionValue(O))
      o.set(C, O);
    else if (!u && (isTransformProp(C) || isTransformOriginProp(C))) {
      if (!o.has(C))
        o.set(C, motionValue(O));
      else if (O !== m[C]) {
        var le = o.get(C);
        le.set(O);
      }
      m[C] = O;
    } else
      h[C] = O;
  }
  return l ? l(h) : h;
}, isKeyframesTarget = function(o) {
  return Array.isArray(o);
}, resolveFinalValueInKeyframes = function(o) {
  return isKeyframesTarget(o) ? o[o.length - 1] || 0 : o;
}, auto = {
  test: function(o) {
    return o === "auto";
  },
  parse: function(o) {
    return o;
  }
}, dimensionTypes = [number, px, percent, degrees, vw, vh, auto], valueTypes = __spreadArrays(dimensionTypes, [color, complex]), testValueType = function(o) {
  return function(s) {
    return s.test(o);
  };
}, getDimensionValueType = function(o) {
  return dimensionTypes.find(testValueType(o));
}, getValueType = function(o) {
  return valueTypes.find(testValueType(o));
}, underDampedSpring = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10
  };
}, overDampedSpring = function(o) {
  return {
    type: "spring",
    stiffness: 700,
    damping: o === 0 ? 100 : 35
  };
}, linearTween = function() {
  return {
    ease: "linear",
    duration: 0.3
  };
}, keyframes = function(o) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: o
  };
}, defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: overDampedSpring,
  scaleY: overDampedSpring,
  scale: overDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: overDampedSpring
}, getDefaultTransition = function(o, s) {
  var u;
  return isKeyframesTarget(s) ? u = keyframes : u = defaultTransitions[o] || defaultTransitions.default, __assign$1({
    to: s
  }, u(s));
}, just = function(o) {
  var s = o.to, u = o.duration;
  return action(function(l) {
    var h = l.update, m = l.complete;
    h(s), u ? delay(u).start({
      complete: m
    }) : m();
  });
}, easingDefinitionToFunction = function(o) {
  if (Array.isArray(o)) {
    invariant(o.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var s = o[0], u = o[1], l = o[2], h = o[3];
    return cubicBezier(s, u, l, h);
  } else if (typeof o == "string")
    return invariant(easingLookup[o] !== void 0, "Invalid easing type '" + o + "'"), easingLookup[o];
  return o;
}, isEasingArray = function(o) {
  return Array.isArray(o) && typeof o[0] != "number";
}, isDurationAnimation = function(o) {
  return o.hasOwnProperty("duration") || o.hasOwnProperty("repeatDelay");
}, isAnimatable = function(o, s) {
  return o === "zIndex" ? !1 : !!(typeof s == "number" || Array.isArray(s) || typeof s == "string" && // It's animatable if we have a string
  complex.test(s) && // And it contains numbers and/or colors
  !s.startsWith("url("));
}, secondsToMilliseconds = function(o) {
  return o * 1e3;
}, transitions = {
  tween,
  spring: vectorSpring,
  keyframes: keyframes$1,
  inertia: index,
  just
}, transitionOptionParser = {
  tween: function(o) {
    if (o.ease) {
      var s = isEasingArray(o.ease) ? o.ease[0] : o.ease;
      o.ease = easingDefinitionToFunction(s);
    }
    return o;
  },
  keyframes: function(o) {
    var s = o.from;
    o.to, o.velocity;
    var u = __rest(o, ["from", "to", "velocity"]);
    if (u.values && u.values[0] === null) {
      var l = __spreadArrays(u.values);
      l[0] = s, u.values = l;
    }
    return u.ease && (u.easings = isEasingArray(u.ease) ? u.ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(u.ease)), u.ease = linear, u;
  }
}, isTransitionDefined = function(o) {
  o.when, o.delay, o.delayChildren, o.staggerChildren, o.staggerDirection;
  var s = __rest(o, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection"]);
  return Object.keys(s).length;
}, getTransitionDefinition = function(o, s, u) {
  var l = u ? u.delay : 0;
  if (u === void 0 || !isTransitionDefined(u))
    return __assign$1({
      delay: l
    }, getDefaultTransition(o, s));
  var h = u[o] || u.default || u;
  return h.type === !1 ? {
    delay: h.hasOwnProperty("delay") ? h.delay : l,
    to: isKeyframesTarget(s) ? s[s.length - 1] : s,
    type: "just"
  } : isKeyframesTarget(s) ? __assign$1(__assign$1({
    values: s,
    duration: 0.8,
    delay: l,
    ease: "linear"
  }, h), {
    // This animation must be keyframes if we're animating through an array
    type: "keyframes"
  }) : __assign$1({
    type: "tween",
    to: s,
    delay: l
  }, h);
}, preprocessOptions = function(o, s) {
  return transitionOptionParser[o] ? transitionOptionParser[o](s) : s;
}, getAnimation = function(o, s, u, l) {
  var h = s.get(), m = isAnimatable(o, h), C = isAnimatable(o, u);
  warning(m === C, "You are trying to animate " + o + ' from "' + h + '" to ' + u + '. "' + h + '" is not an animatable value - to enable this animation set ' + h + " to a value animatable to " + u + " via the `style` property.");
  var O = getTransitionDefinition(o, u, l), le = O.type, We = le === void 0 ? "tween" : le, ye = __rest(O, ["type"]), Fe = m && C ? transitions[We] : just, Ue = preprocessOptions(We, __assign$1({
    from: h,
    velocity: s.getVelocity()
  }, ye));
  return isDurationAnimation(Ue) && (Ue.duration && (Ue.duration = secondsToMilliseconds(Ue.duration)), Ue.repeatDelay && (Ue.repeatDelay = secondsToMilliseconds(Ue.repeatDelay))), [Fe, Ue];
};
function startAnimation(o, s, u, l) {
  var h = l.delay, m = h === void 0 ? 0 : h, C = __rest(l, ["delay"]);
  return s.start(function(O) {
    var le, We = getAnimation(o, s, u, C), ye = We[0], Fe = We[1], Ue = Fe.delay, Le = __rest(Fe, ["delay"]);
    Ue !== void 0 && (m = Ue);
    var Ze = function() {
      var Xe = ye(Le);
      le = Xe.start({
        update: function(Je) {
          return s.set(Je);
        },
        complete: O
      });
    };
    return m ? le = delay(secondsToMilliseconds(m)).start({
      complete: Ze
    }) : Ze(), function() {
      le && le.stop();
    };
  });
}
var getCurrent = function(o) {
  var s = {};
  return o.forEach(function(u, l) {
    return s[l] = u.get();
  }), s;
}, getVelocity = function(o) {
  var s = {};
  return o.forEach(function(u, l) {
    return s[l] = u.getVelocity();
  }), s;
}, isTargetResolver = function(o) {
  return typeof o == "function";
}, isVariantLabels = function(o) {
  return Array.isArray(o);
}, isNumericalString = function(o) {
  return /^\d*\.?\d+$/.test(o);
}, ValueAnimationControls = (
  /** @class */
  function() {
    function o(s) {
      var u = this, l = s.values, h = s.readValueFromSource, m = s.makeTargetAnimatable;
      this.props = {}, this.variants = {}, this.baseTarget = {}, this.overrides = [], this.resolvedOverrides = [], this.activeOverrides = /* @__PURE__ */ new Set(), this.isAnimating = /* @__PURE__ */ new Set(), this.hasValue = function(C) {
        return !u.values.has(C);
      }, this.values = l, this.readValueFromSource = h, this.makeTargetAnimatable = m, this.values.forEach(function(C, O) {
        return u.baseTarget[O] = C.get();
      });
    }
    return o.prototype.setProps = function(s) {
      this.props = s;
    }, o.prototype.setVariants = function(s) {
      s && (this.variants = s);
    }, o.prototype.setDefaultTransition = function(s) {
      s && (this.defaultTransition = s);
    }, o.prototype.setValues = function(s, u) {
      var l = this, h = u === void 0 ? {} : u, m = h.isActive, C = m === void 0 ? /* @__PURE__ */ new Set() : m, O = h.priority, le = this.resolveVariant(s), We = le.target, ye = le.transitionEnd;
      return We = this.transformValues(__assign$1(__assign$1({}, We), ye)), Object.keys(We).forEach(function(Fe) {
        if (!C.has(Fe) && (C.add(Fe), We)) {
          var Ue = resolveFinalValueInKeyframes(We[Fe]);
          if (l.values.has(Fe)) {
            var Le = l.values.get(Fe);
            Le && Le.set(Ue);
          } else
            l.values.set(Fe, motionValue(Ue));
          O || (l.baseTarget[Fe] = Ue);
        }
      });
    }, o.prototype.transformValues = function(s) {
      var u = this.props.transformValues;
      return u ? u(s) : s;
    }, o.prototype.checkForNewValues = function(s) {
      var u = Object.keys(s).filter(this.hasValue), l = u.length;
      if (l)
        for (var h = 0; h < l; h++) {
          var m = u[h], C = s[m], O = null;
          Array.isArray(C) && (O = C[0]), O === null && (O = this.readValueFromSource(m), invariant(O !== null, 'No initial value for "' + m + '" can be inferred. Ensure an initial value for "' + m + '" is defined on the component.')), typeof O == "string" && isNumericalString(O) ? O = parseFloat(O) : !getValueType(O) && complex.test(C) && (O = complex.getAnimatableNone(C)), this.values.set(m, motionValue(O)), this.baseTarget[m] = O;
        }
    }, o.prototype.resolveVariant = function(s) {
      if (!s)
        return {
          target: void 0,
          transition: void 0,
          transitionEnd: void 0
        };
      isTargetResolver(s) && (s = s(this.props.custom, getCurrent(this.values), getVelocity(this.values)));
      var u = s.transition, l = u === void 0 ? this.defaultTransition : u, h = s.transitionEnd, m = __rest(s, ["transition", "transitionEnd"]);
      return {
        transition: l,
        transitionEnd: h,
        target: m
      };
    }, o.prototype.getHighestPriority = function() {
      return this.activeOverrides.size ? Math.max.apply(Math, Array.from(this.activeOverrides)) : 0;
    }, o.prototype.setOverride = function(s, u) {
      this.overrides[u] = s, this.children && this.children.forEach(function(l) {
        return l.setOverride(s, u);
      });
    }, o.prototype.startOverride = function(s) {
      var u = this.overrides[s];
      if (u)
        return this.start(u, {
          priority: s
        });
    }, o.prototype.clearOverride = function(s) {
      var u = this;
      this.children && this.children.forEach(function(We) {
        return We.clearOverride(s);
      });
      var l = this.overrides[s];
      if (l) {
        this.activeOverrides.delete(s);
        var h = this.getHighestPriority();
        if (this.resetIsAnimating(), h) {
          var m = this.overrides[h];
          m && this.startOverride(h);
        }
        var C = this.resolvedOverrides[s];
        if (C) {
          var O = {};
          for (var le in this.baseTarget)
            C[le] !== void 0 && (O[le] = this.baseTarget[le]);
          this.onStart(), this.animate(O).then(function() {
            return u.onComplete();
          });
        }
      }
    }, o.prototype.apply = function(s) {
      if (Array.isArray(s))
        return this.applyVariantLabels(s);
      if (typeof s == "string")
        return this.applyVariantLabels([s]);
      this.setValues(s);
    }, o.prototype.applyVariantLabels = function(s) {
      var u = this, l = /* @__PURE__ */ new Set(), h = __spreadArrays(s).reverse();
      h.forEach(function(m) {
        var C = u.resolveVariant(u.variants[m]), O = C.target, le = C.transitionEnd;
        le && u.setValues(le, {
          isActive: l
        }), O && u.setValues(O, {
          isActive: l
        }), u.children && u.children.size && u.children.forEach(function(We) {
          return We.applyVariantLabels(s);
        });
      });
    }, o.prototype.start = function(s, u) {
      var l = this;
      u === void 0 && (u = {}), u.priority && this.activeOverrides.add(u.priority), this.resetIsAnimating(u.priority);
      var h;
      return isVariantLabels(s) ? h = this.animateVariantLabels(s, u) : typeof s == "string" ? h = this.animateVariant(s, u) : h = this.animate(s, u), this.onStart(), h.then(function() {
        return l.onComplete();
      });
    }, o.prototype.animate = function(s, u) {
      var l = this, h = u === void 0 ? {} : u, m = h.delay, C = m === void 0 ? 0 : m, O = h.priority, le = O === void 0 ? 0 : O, We = h.transitionOverride, ye = this.resolveVariant(s), Fe = ye.target, Ue = ye.transition, Le = ye.transitionEnd;
      if (We && (Ue = We), !Fe)
        return Promise.resolve();
      if (Fe = this.transformValues(Fe), Le && (Le = this.transformValues(Le)), this.checkForNewValues(Fe), this.makeTargetAnimatable) {
        var Ze = this.makeTargetAnimatable(Fe, Le);
        Fe = Ze.target, Le = Ze.transitionEnd;
      }
      le && (this.resolvedOverrides[le] = Fe), this.checkForNewValues(Fe);
      var Xe = [];
      for (var Je in Fe) {
        var it = this.values.get(Je);
        if (!(!it || !Fe || Fe[Je] === void 0)) {
          var et = Fe[Je];
          le || (this.baseTarget[Je] = resolveFinalValueInKeyframes(et)), !this.isAnimating.has(Je) && (this.isAnimating.add(Je), Xe.push(startAnimation(Je, it, et, __assign$1({
            delay: C
          }, Ue))));
        }
      }
      var at = Promise.all(Xe);
      return Le ? at.then(function() {
        l.setValues(Le, {
          priority: le
        });
      }) : at;
    }, o.prototype.animateVariantLabels = function(s, u) {
      var l = this, h = __spreadArrays(s).reverse().map(function(m) {
        return l.animateVariant(m, u);
      });
      return Promise.all(h);
    }, o.prototype.animateVariant = function(s, u) {
      var l = this, h = !1, m = 0, C = 0, O = 1, le = u && u.priority || 0, We = this.variants[s], ye = We ? function() {
        return l.animate(We, u);
      } : function() {
        return Promise.resolve();
      }, Fe = this.children ? function() {
        return l.animateChildren(s, m, C, O, le);
      } : function() {
        return Promise.resolve();
      };
      if (We && this.children) {
        var Ue = this.resolveVariant(We).transition;
        Ue && (h = Ue.when || h, m = Ue.delayChildren || m, C = Ue.staggerChildren || C, O = Ue.staggerDirection || O);
      }
      if (h) {
        var Le = h === "beforeChildren" ? [ye, Fe] : [Fe, ye], Ze = Le[0], Xe = Le[1];
        return Ze().then(Xe);
      } else
        return Promise.all([ye(), Fe()]);
    }, o.prototype.animateChildren = function(s, u, l, h, m) {
      if (u === void 0 && (u = 0), l === void 0 && (l = 0), h === void 0 && (h = 1), m === void 0 && (m = 0), !this.children)
        return Promise.resolve();
      var C = [], O = (this.children.size - 1) * l, le = h === 1 ? function(We) {
        return We * l;
      } : function(We) {
        return O - We * l;
      };
      return Array.from(this.children).forEach(function(We, ye) {
        var Fe = We.animateVariant(s, {
          priority: m,
          delay: u + le(ye)
        });
        C.push(Fe);
      }), Promise.all(C);
    }, o.prototype.onStart = function() {
      var s = this.props.onAnimationStart;
      s && s();
    }, o.prototype.onComplete = function() {
      var s = this.props.onAnimationComplete;
      s && s();
    }, o.prototype.checkOverrideIsAnimating = function(s) {
      for (var u = this.overrides.length, l = s + 1; l < u; l++) {
        var h = this.resolvedOverrides[l];
        if (h)
          for (var m in h)
            this.isAnimating.add(m);
      }
    }, o.prototype.resetIsAnimating = function(s) {
      s === void 0 && (s = 0), this.isAnimating.clear(), s < this.getHighestPriority() && this.checkOverrideIsAnimating(s), this.children && this.children.forEach(function(u) {
        return u.resetIsAnimating(s);
      });
    }, o.prototype.stop = function() {
      this.values.forEach(function(s) {
        return s.stop();
      });
    }, o.prototype.addChild = function(s) {
      this.children || (this.children = /* @__PURE__ */ new Set()), this.children.add(s), this.overrides.forEach(function(u, l) {
        u && s.setOverride(u, l);
      });
    }, o.prototype.removeChild = function(s) {
      this.children && this.children.delete(s);
    }, o.prototype.resetChildren = function() {
      this.children && this.children.clear();
    }, o;
  }()
);
function useInitialOrEveryRender(o, s) {
  s === void 0 && (s = !1);
  var u = useRef(!0);
  (!s || s && u.current) && o(), u.current = !1;
}
var AnimationControls = (
  /** @class */
  function() {
    function o() {
      this.hasMounted = !1, this.pendingAnimations = [], this.componentControls = /* @__PURE__ */ new Set();
    }
    return o.prototype.setVariants = function(s) {
      this.variants = s, this.componentControls.forEach(function(u) {
        return u.setVariants(s);
      });
    }, o.prototype.setDefaultTransition = function(s) {
      this.defaultTransition = s, this.componentControls.forEach(function(u) {
        return u.setDefaultTransition(s);
      });
    }, o.prototype.subscribe = function(s) {
      var u = this;
      return this.componentControls.add(s), this.variants && s.setVariants(this.variants), this.defaultTransition && s.setDefaultTransition(this.defaultTransition), function() {
        return u.componentControls.delete(s);
      };
    }, o.prototype.start = function(s, u) {
      var l = this;
      if (this.hasMounted) {
        var h = [];
        return this.componentControls.forEach(function(m) {
          var C = m.start(s, {
            transitionOverride: u
          });
          h.push(C);
        }), Promise.all(h);
      } else
        return new Promise(function(m) {
          l.pendingAnimations.push({
            animation: [s, u],
            resolve: m
          });
        });
    }, o.prototype.set = function(s) {
      return invariant(this.hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook."), this.componentControls.forEach(function(u) {
        return u.apply(s);
      });
    }, o.prototype.stop = function() {
      this.componentControls.forEach(function(s) {
        return s.stop();
      });
    }, o.prototype.mount = function() {
      var s = this;
      this.hasMounted = !0, this.pendingAnimations.forEach(function(u) {
        var l = u.animation, h = u.resolve;
        return s.start.apply(s, l).then(h);
      });
    }, o.prototype.unmount = function() {
      this.hasMounted = !1, this.stop();
    }, o;
  }()
), PresenceContext = createContext(null), MotionContext = createContext({
  static: !1
}), isVariantLabel = function(o) {
  return typeof o == "string" || Array.isArray(o);
}, isAnimationControls = function(o) {
  return o instanceof AnimationControls;
}, useMotionContext = function(o, s, u, l, h) {
  l === void 0 && (l = !1);
  var m = h.initial, C = h.animate, O = h.variants, le = h.whileTap, We = h.whileHover, ye, Fe = useContext(PresenceContext);
  ((ye = Fe) === null || ye === void 0 ? void 0 : ye.initial) !== void 0 && (m = Fe.initial);
  var Ue;
  m === !1 && !isAnimationControls(C) ? Ue = C : typeof m != "boolean" && (Ue = m);
  var Le = useRef(!1), Ze = O || isVariantLabel(C) || isVariantLabel(le) || isVariantLabel(We) || isAnimationControls(C), Xe = isVariantLabel(Ue) ? Ue : o.initial, Je = isVariantLabel(C) ? C : o.animate, it = l ? Xe : null, et = Ze && isVariantLabel(Je) ? Je : null, at = useMemo(function() {
    return {
      controls: Ze ? s : o.controls,
      initial: Xe,
      animate: Je,
      values: u,
      hasMounted: Le,
      isReducedMotion: o.isReducedMotion
    };
  }, [it, et, o.isReducedMotion]);
  return at.static = l, useInitialOrEveryRender(function() {
    var $e = Ue || o.initial;
    $e && s.apply($e);
  }, !l), useEffect(function() {
    Le.current = !0;
  }, []), at;
};
function useValueAnimationControls(o, s, u) {
  var l = s.variants, h = s.transition, m = useContext(MotionContext).controls, C = useContext(PresenceContext), O = useConstant(function() {
    return new ValueAnimationControls(o);
  });
  return (!C || C.isPresent) && (O.resetChildren(), O.setProps(s), O.setVariants(l), O.setDefaultTransition(h)), useEffect(function() {
    u && m && m.addChild(O);
  }), useEffect(function() {
    return function() {
      s.onAnimationComplete;
      var le = __rest(s, ["onAnimationComplete"]);
      O.setProps(le), m && m.removeChild(O);
    };
  }, []), O;
}
var checkShouldInheritVariant = function(o) {
  var s = o.animate, u = o.variants, l = o.inherit, h = l === void 0 ? !0 : l;
  return h && !!u && (!s || s instanceof AnimationControls);
};
function useExternalRef(o) {
  var s = !o || typeof o == "function" ? useRef(null) : o;
  return o && typeof o == "function" && useEffect(function() {
    return o(s.current), function() {
      return o(null);
    };
  }, []), s;
}
var createMotionComponent = function(o) {
  var s = o.getValueControlsConfig, u = o.loadFunctionalityComponents, l = o.renderComponent;
  function h(m, C) {
    var O = useExternalRef(C), le = useContext(MotionContext), We = le.static || m.static || !1, ye = useMotionValues(m), Fe = useMotionStyles(ye, m.style, We, m.transformValues), Ue = checkShouldInheritVariant(m), Le = useConstant(function() {
      return s(O, ye);
    }), Ze = useValueAnimationControls(Le, m, Ue), Xe = useMotionContext(le, Ze, ye, We, m), Je = We ? null : u(O, ye, m, le, Ze, Ue), it = l(O, Fe, ye, m, We);
    return createElement$1(Fragment, null, createElement$1(MotionContext.Provider, {
      value: Xe
    }, it), createElement$1(Fragment, null, createElement$1(Mount, {
      innerRef: O,
      values: ye,
      isStatic: We
    }), Je));
  }
  return forwardRef(h);
}, htmlElements = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "webview"], svgElements = ["animate", "circle", "clipPath", "defs", "desc", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use", "view"], MotionPluginContext = createContext({
  transformPagePoint: function(o) {
    return o;
  }
});
function useUnmountEffect(o) {
  return useEffect(function() {
    return function() {
      return o();
    };
  }, []);
}
function addDomEvent(o, s, u, l) {
  if (u)
    return o.addEventListener(s, u, l), function() {
      return o.removeEventListener(s, u, l);
    };
}
function useDomEvent(o, s, u, l) {
  useEffect(function() {
    var h = o.current;
    if (u && h)
      return addDomEvent(h, s, u, l);
  }, [o, s, u, l]);
}
function isMouseEvent(o) {
  return typeof PointerEvent < "u" && o instanceof PointerEvent ? o.pointerType === "mouse" : o instanceof MouseEvent;
}
function isTouchEvent(o) {
  var s = !!o.touches;
  return s;
}
function filterPrimaryPointer(o) {
  if (o)
    return function(s) {
      var u = s instanceof MouseEvent, l = !u || u && s.button === 0;
      l && o(s);
    };
}
var defaultPagePoint = {
  pageX: 0,
  pageY: 0
};
function pointFromTouch(o) {
  var s = o.touches[0] || o.changedTouches[0], u = s || defaultPagePoint, l = u.pageX, h = u.pageY;
  return {
    x: l,
    y: h
  };
}
function pointFromMouse(o) {
  var s = o.pageX, u = s === void 0 ? 0 : s, l = o.pageY, h = l === void 0 ? 0 : l;
  return {
    x: u,
    y: h
  };
}
function extractEventInfo(o) {
  return {
    point: isTouchEvent(o) ? pointFromTouch(o) : pointFromMouse(o)
  };
}
var wrapHandler = function(o, s) {
  if (s === void 0 && (s = !1), !!o) {
    var u = function(l) {
      return o(l, extractEventInfo(l));
    };
    return s ? filterPrimaryPointer(u) : u;
  }
}, isBrowser$1 = typeof window < "u", supportsPointerEvents = function() {
  return isBrowser$1 && window.onpointerdown === null;
}, supportsTouchEvents = function() {
  return isBrowser$1 && window.ontouchstart === null;
}, supportsMouseEvents = function() {
  return isBrowser$1 && window.onmousedown === null;
}, mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(o) {
  return supportsPointerEvents() ? o : supportsTouchEvents() ? touchEventNames[o] : supportsMouseEvents() ? mouseEventNames[o] : o;
}
function addPointerEvent(o, s, u, l) {
  return addDomEvent(o, getPointerEventName(s), wrapHandler(u, s === "pointerdown"), l);
}
function usePointerEvent(o, s, u, l) {
  return useDomEvent(o, getPointerEventName(s), wrapHandler(u, s === "pointerdown"), l);
}
var Point;
(function(o) {
  o.subtract = function(s, u) {
    return {
      x: s.x - u.x,
      y: s.y - u.y
    };
  }, o.relativeTo = function(s) {
    var u, l = function() {
      return u !== void 0 || (typeof s == "string" ? u = document.getElementById(s) : u = s), u;
    };
    return function(h) {
      var m = h.x, C = h.y, O = l();
      if (O) {
        var le = O.getBoundingClientRect();
        return {
          x: m - le.left - window.scrollX,
          y: C - le.top - window.scrollY
        };
      }
    };
  };
})(Point || (Point = {}));
var isViewportScrollBlocked = !1, isBrowser$1$1 = typeof window < "u";
isBrowser$1$1 && document.addEventListener("touchmove", function(o) {
  isViewportScrollBlocked && o.preventDefault();
}, {
  passive: !1
});
var blockViewportScroll = function() {
  return isViewportScrollBlocked = !0;
}, unblockViewportScroll = function() {
  return isViewportScrollBlocked = !1;
}, PanSession = (
  /** @class */
  function() {
    function o(s, u, l) {
      var h = this, m = (l === void 0 ? {} : l).transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (h.lastMoveEvent && h.lastMoveEventInfo) {
          var Le = getPanInfo(h.lastMoveEventInfo, h.history), Ze = h.startEvent !== null, Xe = distance(Le.offset, {
            x: 0,
            y: 0
          }) >= 3;
          if (!(!Ze && !Xe)) {
            var Je = Le.point, it = getFrameData().timestamp;
            h.history.push(__assign$1(__assign$1({}, Je), {
              timestamp: it
            }));
            var et = h.handlers, at = et.onStart, $e = et.onMove;
            Ze || (at && at(h.lastMoveEvent, Le), h.startEvent = h.lastMoveEvent), $e && $e(h.lastMoveEvent, Le);
          }
        }
      }, !(isTouchEvent(s) && s.touches.length > 1)) {
        this.handlers = u, this.transformPagePoint = m;
        var C = extractEventInfo(s), O = transformPoint(C, this.transformPagePoint), le = O.point, We = getFrameData().timestamp;
        this.history = [__assign$1(__assign$1({}, le), {
          timestamp: We
        })];
        var ye = u.onSessionStart;
        ye && ye(s, getPanInfo(O, this.history));
        var Fe = addPointerEvent(window, "pointermove", function(Le, Ze) {
          return h.handlePointerMove(Le, Ze);
        }), Ue = addPointerEvent(window, "pointerup", function(Le, Ze) {
          return h.handlePointerUp(Le, Ze);
        });
        this.removeListeners = function() {
          Fe && Fe(), Ue && Ue();
        };
      }
    }
    return o.prototype.handlePointerMove = function(s, u) {
      if (this.lastMoveEvent = s, this.lastMoveEventInfo = transformPoint(u, this.transformPagePoint), isMouseEvent(s) && s.buttons === 0) {
        this.handlePointerUp(s, u);
        return;
      }
      sync.update(this.updatePoint, !0);
    }, o.prototype.handlePointerUp = function(s, u) {
      this.end();
      var l = this.handlers.onEnd;
      if (l) {
        var h = getPanInfo(transformPoint(u, this.transformPagePoint), this.history);
        l && l(s, h);
      }
    }, o.prototype.updateHandlers = function(s) {
      this.handlers = s;
    }, o.prototype.end = function() {
      this.removeListeners && this.removeListeners(), cancelSync.update(this.updatePoint), unblockViewportScroll();
    }, o;
  }()
);
function transformPoint(o, s) {
  return s ? {
    point: s(o.point)
  } : o;
}
function getPanInfo(o, s) {
  var u = o.point;
  return {
    point: u,
    delta: Point.subtract(u, lastDevicePoint(s)),
    offset: Point.subtract(u, startDevicePoint(s)),
    velocity: getVelocity$1(s, 0.1)
  };
}
function startDevicePoint(o) {
  return o[0];
}
function lastDevicePoint(o) {
  return o[o.length - 1];
}
function getVelocity$1(o, s) {
  if (o.length < 2)
    return {
      x: 0,
      y: 0
    };
  for (var u = o.length - 1, l = null, h = lastDevicePoint(o); u >= 0 && (l = o[u], !(h.timestamp - l.timestamp > secondsToMilliseconds(s))); )
    u--;
  if (!l)
    return {
      x: 0,
      y: 0
    };
  var m = (h.timestamp - l.timestamp) / 1e3;
  if (m === 0)
    return {
      x: 0,
      y: 0
    };
  var C = {
    x: (h.x - l.x) / m,
    y: (h.y - l.y) / m
  };
  return C.x === 1 / 0 && (C.x = 0), C.y === 1 / 0 && (C.y = 0), C;
}
function usePanGesture(o, s) {
  var u = o.onPan, l = o.onPanStart, h = o.onPanEnd, m = o.onPanSessionStart, C = u || l || h || m, O = useRef(null), le = useContext(MotionPluginContext).transformPagePoint, We = {
    onSessionStart: m,
    onStart: l,
    onMove: u,
    onEnd: function(Fe, Ue) {
      O.current = null, h && h(Fe, Ue);
    }
  };
  useEffect(function() {
    O.current !== null && O.current.updateHandlers(We);
  });
  function ye(Fe) {
    O.current = new PanSession(Fe, We, {
      transformPagePoint: le
    });
  }
  usePointerEvent(s, "pointerdown", C && ye), useUnmountEffect(function() {
    return O.current && O.current.end();
  });
}
var isNodeOrChild = function(o, s) {
  return s ? o === s ? !0 : isNodeOrChild(o, s.parentElement) : !1;
}, order = ["whileHover", "whileTap", "whileDrag"], getGesturePriority = function(o) {
  return order.indexOf(o) + 1;
};
function createLock(o) {
  var s = null;
  return function() {
    var u = function() {
      s = null;
    };
    return s === null ? (s = o, u) : !1;
  };
}
var globalHorizontalLock = createLock("dragHorizontal"), globalVerticalLock = createLock("dragVertical");
function getGlobalLock(o) {
  var s = !1;
  if (o === "y")
    s = globalVerticalLock();
  else if (o === "x")
    s = globalHorizontalLock();
  else {
    var u = globalHorizontalLock(), l = globalVerticalLock();
    u && l ? s = function() {
      u(), l();
    } : (u && u(), l && l());
  }
  return s;
}
var tapGesturePriority = getGesturePriority("whileTap");
function useTapGesture(o, s) {
  var u = o.onTap, l = o.onTapStart, h = o.onTapCancel, m = o.whileTap, C = o.controls, O = u || l || h || m, le = useRef(!1), We = useRef(null);
  function ye() {
    We.current && We.current(), We.current = null;
  }
  m && C && C.setOverride(m, tapGesturePriority);
  var Fe = useRef(null);
  Fe.current = function(Le, Ze) {
    var Xe = s.current;
    if (ye(), !(!le.current || !Xe)) {
      le.current = !1, C && m && C.clearOverride(tapGesturePriority);
      var Je = getGlobalLock(!0);
      Je && (Je(), isNodeOrChild(Xe, Le.target) ? u && u(Le, Ze) : h && h(Le, Ze));
    }
  };
  function Ue(Le, Ze) {
    ye(), We.current = addPointerEvent(window, "pointerup", function(Je, it) {
      return Fe.current(Je, it);
    });
    var Xe = s.current;
    !Xe || le.current || (le.current = !0, l && l(Le, Ze), C && m && C.startOverride(tapGesturePriority));
  }
  usePointerEvent(s, "pointerdown", O ? Ue : void 0), useUnmountEffect(ye);
}
var hoverPriority = getGesturePriority("whileHover"), filterTouch = function(o) {
  return function(s, u) {
    isMouseEvent(s) && o(s, u);
  };
};
function useHoverGesture(o, s) {
  var u = o.whileHover, l = o.onHoverStart, h = o.onHoverEnd, m = o.controls;
  u && m && m.setOverride(u, hoverPriority), usePointerEvent(s, "pointerenter", filterTouch(function(C, O) {
    l && l(C, O), u && m && m.startOverride(hoverPriority);
  })), usePointerEvent(s, "pointerleave", filterTouch(function(C, O) {
    h && h(C, O), u && m && m.clearOverride(hoverPriority);
  }));
}
function useGestures(o, s) {
  usePanGesture(o, s), useTapGesture(o, s), useHoverGesture(o, s);
}
var makeRenderlessComponent = function(o) {
  return function(s) {
    return o(s), null;
  };
}, gestureProps = ["onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileTap", "whileHover", "onHoverStart", "onHoverEnd"], Gestures = {
  key: "gestures",
  shouldRender: function(o) {
    return gestureProps.some(function(s) {
      return o.hasOwnProperty(s);
    });
  },
  Component: makeRenderlessComponent(function(o) {
    var s = o.innerRef, u = __rest(o, ["innerRef"]);
    useGestures(u, s);
  })
}, isRefObject = function(o) {
  return typeof o == "object" && o.hasOwnProperty("current");
}, noop$3 = function(o) {
  return o;
}, ComponentDragControls = (
  /** @class */
  function() {
    function o(s) {
      var u = s.ref, l = s.values, h = s.controls;
      this.isDragging = !1, this.currentDirection = null, this.constraints = !1, this.props = {
        transformPagePoint: noop$3
      }, this.point = {}, this.origin = {
        x: motionValue(0),
        y: motionValue(0)
      }, this.openGlobalLock = null, this.panSession = null, this.prevConstraintsBox = {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, this.ref = u, this.values = l, this.controls = h;
    }
    return o.prototype.start = function(s, u) {
      var l = this, h = (u === void 0 ? {} : u).snapToCursor, m = h === void 0 ? !1 : h;
      m && this.snapToCursor(s);
      var C = function() {
        blockViewportScroll(), bothAxis(function(Fe) {
          var Ue = l.point[Fe];
          Ue && Ue.stop();
        });
      }, O = function(Fe, Ue) {
        if (l.constraintsNeedResolution) {
          var Le = l.props, Ze = Le.dragConstraints, Xe = Le.transformPagePoint;
          l.constraints = calculateConstraintsFromDom(Ze, l.ref, l.point, Xe), l.applyConstraintsToPoint();
        }
        bothAxis(function($e) {
          var Ke = l.point[$e];
          Ke && l.origin[$e].set(Ke.get());
        });
        var Je = l.props, it = Je.drag, et = Je.dragPropagation;
        if (!(it && !et && (l.openGlobalLock && l.openGlobalLock(), l.openGlobalLock = getGlobalLock(it), !l.openGlobalLock))) {
          l.isDragging = !0, l.currentDirection = null;
          var at = l.props.onDragStart;
          at && at(Fe, convertPanToDrag(Ue, l.point));
        }
      }, le = function(Fe, Ue) {
        var Le = l.props, Ze = Le.dragPropagation, Xe = Le.dragDirectionLock;
        if (!(!Ze && !l.openGlobalLock)) {
          var Je = Ue.offset;
          if (Xe && l.currentDirection === null) {
            if (l.currentDirection = getCurrentDirection(Je), l.currentDirection !== null) {
              var it = l.props.onDirectionLock;
              it && it(l.currentDirection);
            }
            return;
          }
          l.updatePoint("x", Je), l.updatePoint("y", Je);
          var et = l.props.onDrag;
          et && et(Fe, convertPanToDrag(Ue, l.point));
        }
      }, We = function(Fe, Ue) {
        l.stop(Fe, Ue);
      }, ye = this.props.transformPagePoint;
      this.panSession = new PanSession(s, {
        onSessionStart: C,
        onStart: O,
        onMove: le,
        onEnd: We
      }, {
        transformPagePoint: ye
      });
    }, o.prototype.cancelDrag = function() {
      unblockViewportScroll(), this.isDragging = !1, this.panSession && this.panSession.end(), this.panSession = null, !this.props.dragPropagation && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null);
    }, o.prototype.stop = function(s, u) {
      var l;
      (l = this.panSession) === null || l === void 0 || l.end(), this.panSession = null;
      var h = this.isDragging;
      if (this.cancelDrag(), !!h) {
        var m = this.props, C = m.dragMomentum, O = m.dragElastic, le = m.onDragEnd;
        if (C || O) {
          var We = u.velocity;
          this.animateDragEnd(We);
        } else
          this.recordBoxInfo(this.constraints);
        le && le(s, convertPanToDrag(u, this.point));
      }
    }, o.prototype.recordBoxInfo = function(s) {
      if (s) {
        var u = s.right, l = s.left, h = s.bottom, m = s.top;
        this.prevConstraintsBox.width = (u || 0) - (l || 0), this.prevConstraintsBox.height = (h || 0) - (m || 0);
      }
      this.point.x && (this.prevConstraintsBox.x = this.point.x.get()), this.point.y && (this.prevConstraintsBox.y = this.point.y.get());
    }, o.prototype.snapToCursor = function(s) {
      var u = this, l = this.props.transformPagePoint, h = extractEventInfo(s).point, m = getBoundingBox(this.ref, l), C = {
        x: m.width / 2 + m.left + window.scrollX,
        y: m.height / 2 + m.top + window.scrollY
      }, O = {
        x: h.x - C.x,
        y: h.y - C.y
      };
      bothAxis(function(le) {
        var We = u.point[le];
        We && u.origin[le].set(We.get());
      }), this.updatePoint("x", O), this.updatePoint("y", O);
    }, o.prototype.setPoint = function(s, u) {
      this.point[s] = u;
    }, o.prototype.updatePoint = function(s, u) {
      var l = this.props, h = l.drag, m = l.dragElastic, C = this.point[s];
      if (!(!shouldDrag(s, h, this.currentDirection) || !C)) {
        var O = applyConstraints(s, this.origin[s].get() + u[s], this.constraints, m);
        C.set(O);
      }
    }, o.prototype.updateProps = function(s) {
      var u = this, l = s.drag, h = l === void 0 ? !1 : l, m = s.dragDirectionLock, C = m === void 0 ? !1 : m, O = s.dragPropagation, le = O === void 0 ? !1 : O, We = s.dragConstraints, ye = We === void 0 ? !1 : We, Fe = s.dragElastic, Ue = Fe === void 0 ? !0 : Fe, Le = s.dragMomentum, Ze = Le === void 0 ? !0 : Le, Xe = __rest(s, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
      this.props = __assign$1({
        drag: h,
        dragDirectionLock: C,
        dragPropagation: le,
        dragConstraints: ye,
        dragElastic: Ue,
        dragMomentum: Ze
      }, Xe);
      var Je = Xe._dragValueX, it = Xe._dragValueY, et = Xe.dragOriginX, at = Xe.dragOriginY;
      et && (this.origin.x = et), at && (this.origin.y = at), bothAxis(function($e) {
        if (shouldDrag($e, h, u.currentDirection)) {
          var Ke = $e === "x" ? Je : it;
          u.setPoint($e, Ke || u.values.get($e, 0));
        }
      }), this.constraintsNeedResolution = isRefObject(ye), this.constraints = this.constraintsNeedResolution ? this.constraints || !1 : ye;
    }, o.prototype.applyConstraintsToPoint = function(s) {
      var u = this;
      return s === void 0 && (s = this.constraints), bothAxis(function(l) {
        var h = u.point[l];
        h && !h.isAnimating() && applyConstraints(l, h, s, 0);
      });
    }, o.prototype.animateDragEnd = function(s) {
      var u = this, l = this.props, h = l.drag, m = l.dragMomentum, C = l.dragElastic, O = l.dragTransition, le = l._dragValueX, We = l._dragValueY, ye = l._dragTransitionControls, Fe = bothAxis(function(Ue) {
        var Le;
        if (shouldDrag(Ue, h, u.currentDirection)) {
          var Ze = u.constraints ? getConstraints(Ue, u.constraints) : {}, Xe = C ? 200 : 1e6, Je = C ? 40 : 1e7, it = ye || u.controls, et = __assign$1(__assign$1({
            type: "inertia",
            velocity: m ? s[Ue] : 0,
            bounceStiffness: Xe,
            bounceDamping: Je,
            timeConstant: 750,
            restDelta: 1
          }, O), Ze), at = Ue === "x" ? le : We;
          return at ? startAnimation(Ue, at, 0, et) : it.start((Le = {}, Le[Ue] = 0, Le.transition = et, Le));
        }
      });
      return Promise.all(Fe).then(function() {
        u.recordBoxInfo(u.constraints), u.scalePoint();
        var Ue = u.props.onDragTransitionEnd;
        Ue && Ue();
      });
    }, o.prototype.scalePoint = function() {
      var s = this, u = this.props, l = u.dragConstraints, h = u.transformPagePoint;
      if (isRefObject(l)) {
        var m = getBoundingBox(l, h), C = getBoundingBox(this.ref, h), O = function(le, We) {
          var ye = s.point[le];
          if (ye) {
            if (ye.isAnimating()) {
              ye.stop(), s.recordBoxInfo();
              return;
            }
            var Fe = s.prevConstraintsBox[We] ? (m[We] - C[We]) / s.prevConstraintsBox[We] : 1;
            ye.set(s.prevConstraintsBox[le] * Fe);
          }
        };
        O("x", "width"), O("y", "height");
      }
    }, o.prototype.mount = function(s) {
      var u = this, l = addPointerEvent(s, "pointerdown", function(We) {
        var ye = u.props, Fe = ye.drag, Ue = ye.dragListener, Le = Ue === void 0 ? !0 : Ue;
        Fe && Le && u.start(We);
      }), h = addDomEvent(window, "resize", function() {
        return u.scalePoint();
      });
      if (this.constraintsNeedResolution) {
        var m = this.props, C = m.dragConstraints, O = m.transformPagePoint, le = calculateConstraintsFromDom(C, this.ref, this.point, O);
        this.applyConstraintsToPoint(le), this.recordBoxInfo(le);
      } else
        !this.isDragging && this.constraints && this.applyConstraintsToPoint();
      return function() {
        l && l(), h && h(), u.cancelDrag();
      };
    }, o;
  }()
);
function bothAxis(o) {
  return [o("x"), o("y")];
}
function convertPanToDrag(o, s) {
  return __assign$1(__assign$1({}, o), {
    point: {
      x: s.x ? s.x.get() : 0,
      y: s.y ? s.y.get() : 0
    }
  });
}
function getConstraints(o, s) {
  var u = s.top, l = s.right, h = s.bottom, m = s.left;
  return o === "x" ? {
    min: m,
    max: l
  } : {
    min: u,
    max: h
  };
}
function shouldDrag(o, s, u) {
  return (s === !0 || s === o) && (u === null || u === o);
}
function getCurrentDirection(o, s) {
  s === void 0 && (s = 10);
  var u = null;
  return Math.abs(o.y) > s ? u = "y" : Math.abs(o.x) > s && (u = "x"), u;
}
function calculateConstraintsFromDom(o, s, u, l) {
  invariant(o.current !== null && s.current !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
  var h = getBoundingBox(o, l), m = getBoundingBox(s, l), C = h.left - m.left + getCurrentOffset(u.x), O = h.top - m.top + getCurrentOffset(u.y), le = h.width - m.width + C, We = h.height - m.height + O;
  return {
    top: O,
    left: C,
    right: le,
    bottom: We
  };
}
function getBoundingBox(o, s) {
  var u = o.current.getBoundingClientRect(), l = s({
    x: u.left,
    y: u.top
  }), h = l.x, m = l.y, C = s({
    x: u.width,
    y: u.height
  }), O = C.x, le = C.y;
  return {
    left: h,
    top: m,
    width: O,
    height: le
  };
}
function getCurrentOffset(o) {
  return o ? o.get() : 0;
}
function applyConstraints(o, s, u, l) {
  var h = s instanceof MotionValue ? s.get() : s;
  if (!u)
    return h;
  var m = getConstraints(o, u), C = m.min, O = m.max;
  return C !== void 0 && h < C ? h = l ? applyOverdrag(C, h, l) : Math.max(C, h) : O !== void 0 && h > O && (h = l ? applyOverdrag(O, h, l) : Math.min(O, h)), s instanceof MotionValue && s.set(h), h;
}
function applyOverdrag(o, s, u) {
  var l = typeof u == "number" ? u : 0.35;
  return mix(o, s, l);
}
function useDrag(o, s, u, l) {
  var h = o.dragControls, m = useContext(MotionPluginContext).transformPagePoint, C = useConstant(function() {
    return new ComponentDragControls({
      ref: s,
      values: u,
      controls: l
    });
  });
  C.updateProps(__assign$1(__assign$1({}, o), {
    transformPagePoint: m
  })), useEffect(function() {
    return h && h.subscribe(C);
  }, [C]), useEffect(function() {
    return C.mount(s.current);
  }, []);
}
var Drag = {
  key: "drag",
  shouldRender: function(o) {
    return !!o.drag;
  },
  Component: makeRenderlessComponent(function(o) {
    var s = o.innerRef, u = o.values, l = o.controls, h = __rest(o, ["innerRef", "values", "controls"]);
    return useDrag(h, s, u, l);
  })
};
function isCSSVariable(o) {
  return typeof o == "string" && o.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(o) {
  var s = cssVariableRegex.exec(o);
  if (!s)
    return [,];
  var u = s[1], l = s[2];
  return [u, l];
}
var maxDepth = 4;
function getVariableValue(o, s, u) {
  u === void 0 && (u = 1), invariant(u <= maxDepth, 'Max CSS variable fallback depth detected in property "' + o + '". This may indicate a circular fallback dependency.');
  var l = parseCSSVariable(o), h = l[0], m = l[1];
  if (h) {
    var C = window.getComputedStyle(s).getPropertyValue(h);
    return C || (isCSSVariable(m) ? getVariableValue(m, s, u + 1) : m);
  }
}
function resolveCSSVariables(o, s, u, l) {
  var h = __rest(u, []), m = s.current;
  if (!(m instanceof HTMLElement))
    return {
      target: h,
      transitionEnd: l
    };
  l && (l = __assign$1({}, l)), o.forEach(function(We) {
    var ye = We.get();
    if (isCSSVariable(ye)) {
      var Fe = getVariableValue(ye, m);
      Fe && We.set(Fe);
    }
  });
  for (var C in h) {
    var O = h[C];
    if (isCSSVariable(O)) {
      var le = getVariableValue(O, m);
      le && (h[C] = le, l && l[C] === void 0 && (l[C] = O));
    }
  }
  return {
    target: h,
    transitionEnd: l
  };
}
var positionalKeys = /* @__PURE__ */ new Set(["width", "height", "top", "left", "right", "bottom", "x", "y"]), isPositionalKey = function(o) {
  return positionalKeys.has(o);
}, hasPositionalKey = function(o) {
  return Object.keys(o).some(isPositionalKey);
}, setAndResetVelocity = function(o, s) {
  o.set(s, !1), o.set(s);
}, isNumOrPxType = function(o) {
  return o === number || o === px;
}, BoundingBoxDimension;
(function(o) {
  o.width = "width", o.height = "height", o.left = "left", o.right = "right", o.top = "top", o.bottom = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(o, s) {
  return parseFloat(o.split(", ")[s]);
}, getTranslateFromMatrix = function(o, s) {
  return function(u, l) {
    var h = l.transform;
    if (h === "none" || !h)
      return 0;
    var m = h.match(/^matrix3d\((.+)\)$/);
    if (m)
      return getPosFromMatrix(m[1], s);
    var C = h.match(/^matrix\((.+)\)$/);
    return C ? getPosFromMatrix(C[1], o) : 0;
  };
}, transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformProps.filter(function(o) {
  return !transformKeys.has(o);
});
function removeNonTranslationalTransform(o, s) {
  var u = [];
  return nonTranslationalTransformKeys.forEach(function(l) {
    var h = o.get(l);
    h !== void 0 && (u.push([l, h.get()]), h.set(l.startsWith("scale") ? 1 : 0));
  }), u.length && s.render(), u;
}
var positionalValues = {
  // Dimensions
  width: function(o) {
    var s = o.width;
    return s;
  },
  height: function(o) {
    var s = o.height;
    return s;
  },
  top: function(o, s) {
    var u = s.top;
    return parseFloat(u);
  },
  left: function(o, s) {
    var u = s.left;
    return parseFloat(u);
  },
  bottom: function(o, s) {
    var u = o.height, l = s.top;
    return parseFloat(l) + u;
  },
  right: function(o, s) {
    var u = o.width, l = s.left;
    return parseFloat(l) + u;
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
}, convertChangedValueTypes = function(o, s, u, l, h) {
  var m = u.getBoundingClientRect(), C = getComputedStyle(u), O = C.display, le = C.top, We = C.left, ye = C.bottom, Fe = C.right, Ue = C.transform, Le = {
    top: le,
    left: We,
    bottom: ye,
    right: Fe,
    transform: Ue
  };
  O === "none" && l.set("display", o.display || "block"), l.render();
  var Ze = u.getBoundingClientRect();
  return h.forEach(function(Xe) {
    var Je = s.get(Xe);
    setAndResetVelocity(Je, positionalValues[Xe](m, Le)), o[Xe] = positionalValues[Xe](Ze, C);
  }), o;
}, checkAndConvertChangedValueTypes = function(o, s, u, l) {
  l === void 0 && (l = {}), u = __assign$1({}, u), l = __assign$1({}, l);
  var h = s.current, m = index$1(h), C = Object.keys(u).filter(isPositionalKey), O = [], le = !1, We = C.reduce(function(Fe, Ue) {
    var Le = o.get(Ue);
    if (!Le)
      return Fe;
    var Ze = Le.get(), Xe = u[Ue], Je = getDimensionValueType(Ze), it;
    if (isKeyframesTarget(Xe))
      for (var et = Xe.length, at = Xe[0] === null ? 1 : 0; at < et; at++)
        it ? invariant(getDimensionValueType(Xe[at]) === it, "All keyframes must be of the same type") : (it = getDimensionValueType(Xe[at]), invariant(it === Je || isNumOrPxType(Je) && isNumOrPxType(it), "Keyframes must be of the same dimension as the current value"));
    else
      it = getDimensionValueType(Xe);
    if (Je !== it)
      if (isNumOrPxType(Je) && isNumOrPxType(it)) {
        var $e = Le.get();
        typeof $e == "string" && Le.set(parseFloat($e)), typeof Xe == "string" ? u[Ue] = parseFloat(Xe) : Array.isArray(Xe) && it === px && (u[Ue] = Xe.map(parseFloat));
      } else
        le || (O = removeNonTranslationalTransform(o, m), le = !0), Fe.push(Ue), l[Ue] = l[Ue] !== void 0 ? l[Ue] : u[Ue], setAndResetVelocity(Le, Xe);
    return Fe;
  }, []);
  if (We.length) {
    var ye = convertChangedValueTypes(u, o, h, m, We);
    return O.length && O.forEach(function(Fe) {
      var Ue = Fe[0], Le = Fe[1];
      o.get(Ue).set(Le);
    }), m.render(), {
      target: ye,
      transitionEnd: l
    };
  } else
    return {
      target: u,
      transitionEnd: l
    };
};
function unitConversion(o, s, u, l) {
  return hasPositionalKey(u) ? checkAndConvertChangedValueTypes(o, s, u, l) : {
    target: u,
    transitionEnd: l
  };
}
var parseDomVariant = function(o, s) {
  return function(u, l) {
    var h = resolveCSSVariables(o, s, u, l);
    return u = h.target, l = h.transitionEnd, unitConversion(o, s, u, l);
  };
};
function useForceUpdate() {
  var o = useState(0), s = o[0], u = o[1];
  return useCallback(function() {
    return u(s + 1);
  }, [s]);
}
var SyncLayoutContext = createContext(null), _a, StepName;
(function(o) {
  o.Prepare = "prepare", o.Read = "read", o.Render = "render";
})(StepName || (StepName = {}));
var stepOrder = [StepName.Prepare, StepName.Read, StepName.Render], jobs = stepOrder.reduce(function(o, s) {
  return o[s] = [], o;
}, {}), jobsNeedProcessing = !1;
function flushCallbackList(o) {
  for (var s = o.length, u = 0; u < s; u++)
    o[u]();
  o.length = 0;
}
function flushAllJobs() {
  jobsNeedProcessing && (flushCallbackList(jobs.prepare), flushCallbackList(jobs.read), flushCallbackList(jobs.render), jobsNeedProcessing = !1);
}
var createUseSyncEffect = function(o) {
  return function(s) {
    s && (jobsNeedProcessing = !0, jobs[o].push(s));
  };
}, layoutSync = (_a = {}, _a[StepName.Prepare] = createUseSyncEffect(StepName.Prepare), _a[StepName.Read] = createUseSyncEffect(StepName.Read), _a[StepName.Render] = createUseSyncEffect(StepName.Render), _a.flush = flushAllJobs, _a);
function isHTMLElement(o) {
  return o instanceof HTMLElement;
}
var defaultLayoutTransition = {
  duration: 0.8,
  ease: [0.45, 0.05, 0.19, 1]
}, defaultPositionTransition = underDampedSpring();
function getDefaultLayoutTransition(o) {
  return o ? defaultPositionTransition : defaultLayoutTransition;
}
function isResolver(o) {
  return typeof o == "function";
}
var axisLabels = {
  x: {
    id: "x",
    size: "width",
    min: "left",
    max: "right",
    origin: "originX"
  },
  y: {
    id: "y",
    size: "height",
    min: "top",
    max: "bottom",
    origin: "originY"
  }
};
function centerOf(o, s) {
  return (o + s) / 2;
}
function calcAxisDelta(o, s, u) {
  var l, h = o[u.size] - s[u.size], m = 0.5;
  h && (o[u.min] === s[u.min] ? m = 0 : o[u.max] === s[u.max] && (m = 1));
  var C = (l = {}, l[u.size] = h, l[u.origin] = m, l[u.id] = // Only measure a position delta if we haven't anchored to one side
  m === 0.5 ? centerOf(o[u.min], o[u.max]) - centerOf(s[u.min], s[u.max]) : 0, l);
  return C;
}
function calcDelta(o, s) {
  var u = __assign$1(__assign$1({}, calcAxisDelta(o, s, axisLabels.x)), calcAxisDelta(o, s, axisLabels.y));
  return u;
}
var offset = {
  getLayout: function(o) {
    var s = o.offset;
    return s;
  },
  measure: function(o) {
    var s = o.offsetLeft, u = o.offsetTop, l = o.offsetWidth, h = o.offsetHeight;
    return {
      left: s,
      top: u,
      right: s + l,
      bottom: u + h,
      width: l,
      height: h
    };
  }
}, boundingBox = {
  getLayout: function(o) {
    var s = o.boundingBox;
    return s;
  },
  measure: function(o) {
    var s = o.getBoundingClientRect(), u = s.left, l = s.top, h = s.width, m = s.height, C = s.right, O = s.bottom;
    return {
      left: u,
      top: l,
      width: h,
      height: m,
      right: C,
      bottom: O
    };
  }
};
function readPositionStyle(o) {
  return window.getComputedStyle(o).position;
}
function getLayoutType(o, s, u) {
  return u && o === s ? offset : boundingBox;
}
function isSizeKey(o) {
  return o === "width" || o === "height";
}
function getTransition(o) {
  var s = o.layoutTransition, u = o.positionTransition;
  return s || u;
}
var LayoutAnimation = (
  /** @class */
  function(o) {
    __extends(s, o);
    function s() {
      return o !== null && o.apply(this, arguments) || this;
    }
    return s.prototype.getSnapshotBeforeUpdate = function() {
      var u = this.props, l = u.innerRef, h = u.positionTransition, m = u.values, C = u.controls, O = l.current;
      if (isHTMLElement(O)) {
        var le = getTransition(this.props), We = !!h, ye = readPositionStyle(O), Fe = {
          offset: offset.measure(O),
          boundingBox: boundingBox.measure(O)
        }, Ue, Le, Ze;
        return layoutSync.prepare(function() {
          Ue = O.style.transform, O.style.transform = "";
        }), layoutSync.read(function() {
          Le = {
            offset: offset.measure(O),
            boundingBox: boundingBox.measure(O)
          };
          var Xe = readPositionStyle(O);
          Ze = getLayoutType(ye, Xe, We);
        }), layoutSync.render(function() {
          var Xe = Ze.getLayout(Fe), Je = Ze.getLayout(Le), it = calcDelta(Xe, Je), et = it.x || it.y || it.width || it.height;
          if (!et) {
            Ue && (O.style.transform = Ue);
            return;
          }
          index$1(O).set({
            originX: it.originX,
            originY: it.originY
          }), syncRenderSession.open();
          var at = {}, $e = {}, Ke = isResolver(le) ? le({
            delta: it
          }) : le;
          function tt(ut, st, ot, ht) {
            var vt = isSizeKey(ut) ? ut : st;
            if (it[vt]) {
              var At = typeof Ke == "boolean" ? __assign$1({}, getDefaultLayoutTransition(We)) : Ke, gt = m.get(st, ot), bt = gt.getVelocity();
              $e[st] = At[st] ? __assign$1({}, At[st]) : __assign$1({}, At), $e[st].velocity === void 0 && ($e[st].velocity = bt || 0), at[st] = ot;
              var wt = !isSizeKey(ut) && Ze === offset ? gt.get() : 0;
              gt.set(ht + wt);
            }
          }
          tt("left", "x", 0, it.x), tt("top", "y", 0, it.y), We || (tt("width", "scaleX", 1, Fe.boundingBox.width / Le.boundingBox.width), tt("height", "scaleY", 1, Fe.boundingBox.height / Le.boundingBox.height)), at.transition = $e, Ke && C.start(at), syncRenderSession.flush();
        }), null;
      }
    }, s.prototype.componentDidUpdate = function() {
      layoutSync.flush();
    }, s.prototype.render = function() {
      return null;
    }, s.contextType = SyncLayoutContext, s;
  }(Component)
), Layout = {
  key: "layout",
  shouldRender: function(o) {
    var s = o.positionTransition, u = o.layoutTransition;
    return invariant(!(s && u), "Don't set both positionTransition and layoutTransition on the same component"), typeof window < "u" && !!(s || u);
  },
  Component: LayoutAnimation
}, validMotionProps = /* @__PURE__ */ new Set(["initial", "animate", "exit", "style", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "static", "positionTransition", "layoutTransition", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onDirectionLock", "onDragTransitionEnd", "drag", "dragControls", "dragListener", "dragConstraints", "dragDirectionLock", "dragElastic", "dragMomentum", "dragPropagation", "dragTransition", "_dragValueX", "_dragValueY", "_dragTransitionControls", "dragOriginX", "dragOriginY", "onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileHover", "whileTap", "onHoverEnd", "onHoverStart"]);
function isValidMotionProp(o) {
  return validMotionProps.has(o);
}
var AnimatePropType;
(function(o) {
  o.Target = "Target", o.VariantLabel = "VariantLabel", o.AnimationSubscription = "AnimationSubscription";
})(AnimatePropType || (AnimatePropType = {}));
function shallowCompare(o, s) {
  if (s === null)
    return !1;
  var u = s.length;
  if (u !== o.length)
    return !1;
  for (var l = 0; l < u; l++)
    if (s[l] !== o[l])
      return !1;
  return !0;
}
var hasUpdated = function(o, s) {
  return s !== void 0 && (Array.isArray(o) && Array.isArray(s) ? !shallowCompare(s, o) : o !== s);
};
function targetWithoutTransition(o, s) {
  s === void 0 && (s = !1), o.transition;
  var u = o.transitionEnd, l = __rest(o, ["transition", "transitionEnd"]);
  return s ? __assign$1(__assign$1({}, l), u) : l;
}
function useAnimateProp(o, s, u, l) {
  var h = useRef(!0), m = useRef(null);
  m.current || (m.current = targetWithoutTransition(o, !0)), useEffect(function() {
    var C = {}, O = targetWithoutTransition(o), le = targetWithoutTransition(o, !0);
    for (var We in O) {
      var ye = h.current && (!u.has(We) || u.get(We).get() !== le[We]), Fe = le[We] !== null, Ue = hasUpdated(m.current[We], le[We]);
      Fe && (Ue || ye) && (C[We] = O[We]);
    }
    h.current = !1, m.current = __assign$1(__assign$1({}, m.current), le), Object.keys(C).length && s.start(__assign$1(__assign$1({}, C), {
      transition: o.transition || l,
      transitionEnd: o.transitionEnd
    }));
  }, [o]);
}
var labelsToArray = function(o) {
  return o ? Array.isArray(o) ? o : [o] : [];
}, resolveVariantLabels = function(o) {
  var s = o instanceof MotionValue ? o.get() : o;
  return Array.from(new Set(labelsToArray(s)));
}, asDependencyList = function(o) {
  return [o.join(",")];
}, hasVariantChanged = function(o, s) {
  return o.join(",") !== s.join(",");
};
function useVariants(o, s, u, l) {
  var h = resolveVariantLabels(s), m = useContext(MotionContext), C = m.hasMounted && m.hasMounted.current, O = useRef(!1);
  useEffect(function() {
    var le = !1;
    u ? (le = !!C, h = resolveVariantLabels(m.animate)) : le = O.current || hasVariantChanged(resolveVariantLabels(o), h), le && l.start(h), O.current = !0;
  }, asDependencyList(h));
}
function useAnimationGroupSubscription(o, s) {
  var u = useMemo(function() {
    return o.subscribe(s);
  }, [o]);
  useEffect(function() {
    return function() {
      u && u();
    };
  }, [u]);
}
var _a$1, _b, AnimatePropComponents = (_a$1 = {}, _a$1[AnimatePropType.Target] = makeRenderlessComponent(function(o) {
  var s = o.animate, u = o.controls, l = o.values, h = o.transition;
  return useAnimateProp(s, u, l, h);
}), _a$1[AnimatePropType.VariantLabel] = makeRenderlessComponent(function(o) {
  var s = o.animate, u = o.inherit, l = u === void 0 ? !0 : u, h = o.controls, m = o.initial;
  return useVariants(m, s, l, h);
}), _a$1[AnimatePropType.AnimationSubscription] = makeRenderlessComponent(function(o) {
  var s = o.animate, u = o.controls;
  return useAnimationGroupSubscription(s, u);
}), _a$1), isVariantLabel$1 = function(o) {
  return Array.isArray(o) || typeof o == "string";
}, isAnimationSubscription = function(o) {
  var s = o.animate;
  return s instanceof AnimationControls;
}, animationProps = ["initial", "animate", "whileTap", "whileHover"], animatePropTypeTests = (_b = {}, _b[AnimatePropType.Target] = function(o) {
  return o.animate !== void 0 && !isVariantLabel$1(o.animate) && !isAnimationSubscription(o);
}, _b[AnimatePropType.VariantLabel] = function(o) {
  return o.variants !== void 0 || animationProps.some(function(s) {
    return typeof o[s] == "string";
  });
}, _b[AnimatePropType.AnimationSubscription] = isAnimationSubscription, _b), getAnimationComponent = function(o) {
  var s = void 0;
  for (var u in AnimatePropType)
    animatePropTypeTests[u](o) && (s = u);
  return s ? AnimatePropComponents[s] : void 0;
};
function usePresence() {
  var o = useContext(PresenceContext);
  if (o === null)
    return [!0];
  var s = o.isPresent, u = o.onExitComplete, l = o.register;
  return useEffect(l, []), !s && u ? [!1, u] : [!0];
}
var Exit = {
  key: "exit",
  shouldRender: function(o) {
    return !!o.exit && !checkShouldInheritVariant(o);
  },
  Component: makeRenderlessComponent(function(o) {
    var s, u = o.animate, l = o.controls, h = o.exit, m = usePresence(), C = m[0], O = m[1], le = useContext(PresenceContext), We = useRef(!1), ye = ((s = le) === null || s === void 0 ? void 0 : s.custom) !== void 0 ? le.custom : o.custom;
    useEffect(function() {
      C ? We.current && u && !(u instanceof AnimationControls) && l.start(u) : (!We.current && h && (l.setProps(__assign$1(__assign$1({}, o), {
        custom: ye
      })), l.start(h).then(O)), We.current = !0), C && (We.current = !1);
    }, [C]);
  })
}, isPropValid$1 = function(o) {
  return !isValidMotionProp(o);
};
try {
  var emotionIsPropValid_1 = require$$0.default;
  isPropValid$1 = function(o) {
    return o.startsWith("on") ? !isValidMotionProp(o) : emotionIsPropValid_1(o);
  };
} catch {
}
function filterValidProps(o) {
  var s = {};
  for (var u in o)
    isPropValid$1(u) && (s[u] = o[u]);
  return s;
}
var buildHTMLProps = function(o, s, u, l) {
  var h = {
    style: buildStyleAttr(o, s, u)
  };
  return l && (h.style.userSelect = "none", h.draggable = !1), h;
}, buildSVGProps = function(o, s) {
  var u = resolveCurrent(o), l = buildSVGAttrs(u, void 0, void 0, void 0, void 0, !1);
  return l.style = __assign$1(__assign$1({}, s), l.style), l;
}, functionalityComponents = [Layout, Drag, Gestures, Exit], numFunctionalityComponents = functionalityComponents.length;
function createDomMotionConfig(o) {
  var s = typeof o == "string", u = s && svgElements.indexOf(o) !== -1;
  return {
    renderComponent: function(l, h, m, C, O) {
      var le = s ? filterValidProps(C) : C, We = u ? buildSVGProps(m, h) : buildHTMLProps(m, h, O, !!C.drag);
      return createElement$1(o, __assign$1(__assign$1(__assign$1({}, le), {
        ref: l
      }), We));
    },
    /**
     * loadFunctionalityComponents gets used by the `motion` component
     *
     * Each functionality component gets provided the `ref`, animation controls and the `MotionValuesMap`
     * generated for that component, as well as all the `props` passed to it by the user.
     *
     * The pattern used to determine whether to load and use each piece of functionality is
     * consistent (should render? Then push component) and could be used to extend functionality.
     *
     * By exposing a mutable piece of memory via an API like `extendMotionComponent` we could
     * allow users to add `FunctionalComponentDefinition`s. This would allow us to offer file size
     * reductions by shipping an entry point that doesn't load gesture and drag functionality, and
     * also offer a way for users to develop plugins/other functionality. Because these functionalities
     * are loaded as components, we can look into using Suspense for this purpose.
     *
     * For user-defined functionality we'd need to allow
     *  1) User-defined prop typing (extending `P`)
     *  2) User-defined "clean props" function that removes their plugin's props before being passed to the DOM.
     */
    loadFunctionalityComponents: function(l, h, m, C, O, le) {
      var We = [], ye = getAnimationComponent(m);
      ye && We.push(createElement$1(ye, {
        key: "animation",
        initial: m.initial,
        animate: m.animate,
        variants: m.variants,
        transition: m.transition,
        controls: O,
        inherit: le,
        values: h
      }));
      for (var Fe = 0; Fe < numFunctionalityComponents; Fe++) {
        var Ue = functionalityComponents[Fe], Le = Ue.shouldRender, Ze = Ue.key, Xe = Ue.Component;
        Le(m, C) && We.push(createElement$1(Xe, __assign$1({
          key: Ze
        }, m, {
          parentContext: C,
          values: h,
          controls: O,
          innerRef: l
        })));
      }
      return We;
    },
    getValueControlsConfig: function(l, h) {
      return {
        values: h,
        readValueFromSource: function(m) {
          return index$1(l.current).get(m);
        },
        // TODO: This is a good second source of plugins. This function contains the CSS variable
        // and unit conversion support. These functions share a common signature. We could make another
        // API for adding these.
        makeTargetAnimatable: parseDomVariant(h, l)
      };
    }
  };
}
var htmlMotionComponents = htmlElements.reduce(function(o, s) {
  var u = createDomMotionConfig(s);
  return o[s] = createMotionComponent(u), o;
}, {}), svgMotionComponents = svgElements.reduce(function(o, s) {
  return o[s] = createMotionComponent(createDomMotionConfig(s)), o;
}, {}), motion = __assign$1(__assign$1({
  /**
   * Convert a custom React component into a `motion` component.
   *
   * It can also accept a string, to create [custom DOM elements](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements).
   *
   * ```jsx
   * const Component = React.forwardRef((props: Props, ref) => {
   *   return <div ref={ref} />
   * })
   *
   * const MotionComponent = motion.custom<Props>(Component)
   * ```
   *
   * @param Component -
   */
  custom: function(s) {
    return createMotionComponent(createDomMotionConfig(s));
  }
}, htmlMotionComponents), svgMotionComponents);
function createScrollMotionValues() {
  return {
    scrollX: motionValue(0),
    scrollY: motionValue(0),
    scrollXProgress: motionValue(0),
    scrollYProgress: motionValue(0)
  };
}
createScrollMotionValues();
var PresenceChild = function(o) {
  var s = o.children, u = o.initial, l = o.isPresent, h = o.onExitComplete, m = o.custom, C = useRef(0), O = useRef(0), le = {
    initial: u,
    isPresent: l,
    custom: m,
    onExitComplete: function() {
      O.current++;
      var ye = O.current >= C.current;
      h && ye && h();
    }
  }, We = useMemo(function() {
    return O.current = 0, function() {
      return C.current++, function() {
        return C.current--;
      };
    };
  }, [l]);
  return createElement$1(PresenceContext.Provider, {
    value: __assign$1(__assign$1({}, le), {
      register: We
    })
  }, s);
};
function getChildKey(o) {
  return o.key || "";
}
function updateChildLookup(o, s) {
  var u = process.env.NODE_ENV !== "production" ? /* @__PURE__ */ new Set() : null;
  o.forEach(function(l) {
    var h = getChildKey(l);
    process.env.NODE_ENV !== "production" && u && (u.has(h) && console.warn('Children of AnimatePresence require unique keys. "' + h + '" is a duplicate.'), u.add(h)), s.set(h, l);
  });
}
function onlyElements(o) {
  var s = [];
  return Children$1.forEach(o, function(u) {
    isValidElement(u) && s.push(u);
  }), s;
}
var AnimatePresence = function(o) {
  var s = o.children, u = o.custom, l = o.initial, h = l === void 0 ? !0 : l, m = o.onExitComplete, C = o.exitBeforeEnter, O = useForceUpdate(), le = useContext(SyncLayoutContext), We = le || O, ye = useRef(!0), Fe = onlyElements(s), Ue = useRef(Fe), Le = useRef(/* @__PURE__ */ new Map()).current, Ze = useRef(/* @__PURE__ */ new Set()).current;
  if (updateChildLookup(Fe, Le), ye.current)
    return ye.current = !1, createElement$1(Fragment, null, Fe.map(function(Ke) {
      return createElement$1(PresenceChild, {
        key: getChildKey(Ke),
        isPresent: !0,
        initial: h ? void 0 : !1
      }, Ke);
    }));
  for (var Xe = __spreadArrays(Fe), Je = Ue.current.map(getChildKey), it = Fe.map(getChildKey), et = Je.length, at = 0; at < et; at++) {
    var $e = Je[at];
    it.indexOf($e) === -1 ? Ze.add($e) : Ze.delete($e);
  }
  return C && Ze.size && (Xe = []), Ze.forEach(function(Ke) {
    if (it.indexOf(Ke) === -1) {
      var tt = Le.get(Ke);
      if (tt) {
        var ut = Je.indexOf(Ke), st = function() {
          Ze.delete(Ke);
          var ot = Ue.current.findIndex(function(ht) {
            return ht.key === Ke;
          });
          Ue.current.splice(ot, 1), Ze.size || (Ue.current = Fe, We(), m && m());
        };
        Xe.splice(ut, 0, createElement$1(PresenceChild, {
          key: getChildKey(tt),
          isPresent: !1,
          onExitComplete: st,
          custom: u
        }, tt));
      }
    }
  }), Xe = Xe.map(function(Ke) {
    var tt = Ke.key;
    return Ze.has(tt) ? Ke : createElement$1(PresenceChild, {
      key: getChildKey(Ke),
      isPresent: !0
    }, Ke);
  }), Ue.current = Xe, process.env.NODE_ENV !== "production" && C && Xe.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), createElement$1(Fragment, null, Ze.size ? Xe : Xe.map(function(Ke) {
    return cloneElement(Ke);
  }));
}, prefersReducedMotion = motionValue(null);
if (typeof window < "u")
  if (window.matchMedia) {
    var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)"), setReducedMotionPreferences = function() {
      return prefersReducedMotion.set(motionMediaQuery_1.matches);
    };
    motionMediaQuery_1.addListener(setReducedMotionPreferences), setReducedMotionPreferences();
  } else
    prefersReducedMotion.set(!1);
/*!
 * Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys$2(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread2$2(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$2(Object(u), !0).forEach(function(l) {
      _defineProperty$2(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$2(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
function _typeof$2(o) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$2(o);
}
function _classCallCheck$1(o, s) {
  if (!(o instanceof s))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(o, s) {
  for (var u = 0; u < s.length; u++) {
    var l = s[u];
    l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(o, l.key, l);
  }
}
function _createClass$1(o, s, u) {
  return s && _defineProperties$1(o.prototype, s), u && _defineProperties$1(o, u), Object.defineProperty(o, "prototype", {
    writable: !1
  }), o;
}
function _defineProperty$2(o, s, u) {
  return s in o ? Object.defineProperty(o, s, {
    value: u,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[s] = u, o;
}
function _slicedToArray$1(o, s) {
  return _arrayWithHoles$1(o) || _iterableToArrayLimit$1(o, s) || _unsupportedIterableToArray$2(o, s) || _nonIterableRest$1();
}
function _toConsumableArray$1(o) {
  return _arrayWithoutHoles$1(o) || _iterableToArray$1(o) || _unsupportedIterableToArray$2(o) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(o) {
  if (Array.isArray(o))
    return _arrayLikeToArray$2(o);
}
function _arrayWithHoles$1(o) {
  if (Array.isArray(o))
    return o;
}
function _iterableToArray$1(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null)
    return Array.from(o);
}
function _iterableToArrayLimit$1(o, s) {
  var u = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (u != null) {
    var l = [], h = !0, m = !1, C, O;
    try {
      for (u = u.call(o); !(h = (C = u.next()).done) && (l.push(C.value), !(s && l.length === s)); h = !0)
        ;
    } catch (le) {
      m = !0, O = le;
    } finally {
      try {
        !h && u.return != null && u.return();
      } finally {
        if (m)
          throw O;
      }
    }
    return l;
  }
}
function _unsupportedIterableToArray$2(o, s) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$2(o, s);
    var u = Object.prototype.toString.call(o).slice(8, -1);
    if (u === "Object" && o.constructor && (u = o.constructor.name), u === "Map" || u === "Set")
      return Array.from(o);
    if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
      return _arrayLikeToArray$2(o, s);
  }
}
function _arrayLikeToArray$2(o, s) {
  (s == null || s > o.length) && (s = o.length);
  for (var u = 0, l = new Array(s); u < s; u++)
    l[u] = o[u];
  return l;
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var noop = function() {
}, _WINDOW = {}, _DOCUMENT = {}, _MUTATION_OBSERVER = null, _PERFORMANCE = {
  mark: noop,
  measure: noop
};
try {
  typeof window < "u" && (_WINDOW = window), typeof document < "u" && (_DOCUMENT = document), typeof MutationObserver < "u" && (_MUTATION_OBSERVER = MutationObserver), typeof performance < "u" && (_PERFORMANCE = performance);
} catch {
}
var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent, WINDOW = _WINDOW, DOCUMENT = _DOCUMENT, MUTATION_OBSERVER = _MUTATION_OBSERVER, PERFORMANCE = _PERFORMANCE;
WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener == "function" && typeof DOCUMENT.createElement == "function", IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/"), NAMESPACE_IDENTIFIER = "___FONT_AWESOME___", UNITS_IN_GRID = 16, DEFAULT_FAMILY_PREFIX = "fa", DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa", DATA_FA_I2SVG = "data-fa-i2svg", DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element", DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending", DATA_PREFIX = "data-prefix", DATA_ICON = "data-icon", HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg", MUTATION_APPROACH_ASYNC = "async", TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"], PRODUCTION$1 = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), PREFIX_TO_STYLE = {
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit",
  fa: "solid"
}, STYLE_TO_PREFIX = {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}, PREFIX_TO_LONG_STYLE = {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}, LONG_STYLE_TO_PREFIX = {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}, ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/, LAYERS_TEXT_CLASSNAME = "fa-layers-text", FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i, FONT_WEIGHT_TO_PREFIX = {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}, oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], DUOTONE_CLASSES = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, RESERVED_CLASSES = [].concat(_toConsumableArray$1(Object.keys(STYLE_TO_PREFIX)), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function(o) {
  return "".concat(o, "x");
})).concat(oneToTwenty.map(function(o) {
  return "w-".concat(o);
})), initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(o) {
  var s = DOCUMENT.querySelector("script[" + o + "]");
  if (s)
    return s.getAttribute(o);
}
function coerce(o) {
  return o === "" ? !0 : o === "false" ? !1 : o === "true" ? !0 : o;
}
if (DOCUMENT && typeof DOCUMENT.querySelector == "function") {
  var attrs = [["data-family-prefix", "familyPrefix"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  attrs.forEach(function(o) {
    var s = _slicedToArray$1(o, 2), u = s[0], l = s[1], h = coerce(getAttrConfig(u));
    h != null && (initial[l] = h);
  });
}
var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: "solid",
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
}, _config = _objectSpread2$2(_objectSpread2$2({}, _default), initial);
_config.autoReplaceSvg || (_config.observeMutations = !1);
var config = {};
Object.keys(_config).forEach(function(o) {
  Object.defineProperty(config, o, {
    enumerable: !0,
    set: function(u) {
      _config[o] = u, _onChangeCb.forEach(function(l) {
        return l(config);
      });
    },
    get: function() {
      return _config[o];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(o) {
  return _onChangeCb.push(o), function() {
    _onChangeCb.splice(_onChangeCb.indexOf(o), 1);
  };
}
var d = UNITS_IN_GRID, meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function insertCss(o) {
  if (!(!o || !IS_DOM)) {
    var s = DOCUMENT.createElement("style");
    s.setAttribute("type", "text/css"), s.innerHTML = o;
    for (var u = DOCUMENT.head.childNodes, l = null, h = u.length - 1; h > -1; h--) {
      var m = u[h], C = (m.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(C) > -1 && (l = m);
    }
    return DOCUMENT.head.insertBefore(s, l), o;
  }
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
  for (var o = 12, s = ""; o-- > 0; )
    s += idPool[Math.random() * 62 | 0];
  return s;
}
function toArray(o) {
  for (var s = [], u = (o || []).length >>> 0; u--; )
    s[u] = o[u];
  return s;
}
function classArray(o) {
  return o.classList ? toArray(o.classList) : (o.getAttribute("class") || "").split(" ").filter(function(s) {
    return s;
  });
}
function htmlEscape(o) {
  return "".concat(o).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(o) {
  return Object.keys(o || {}).reduce(function(s, u) {
    return s + "".concat(u, '="').concat(htmlEscape(o[u]), '" ');
  }, "").trim();
}
function joinStyles(o) {
  return Object.keys(o || {}).reduce(function(s, u) {
    return s + "".concat(u, ": ").concat(o[u].trim(), ";");
  }, "");
}
function transformIsMeaningful(o) {
  return o.size !== meaninglessTransform.size || o.x !== meaninglessTransform.x || o.y !== meaninglessTransform.y || o.rotate !== meaninglessTransform.rotate || o.flipX || o.flipY;
}
function transformForSvg(o) {
  var s = o.transform, u = o.containerWidth, l = o.iconWidth, h = {
    transform: "translate(".concat(u / 2, " 256)")
  }, m = "translate(".concat(s.x * 32, ", ").concat(s.y * 32, ") "), C = "scale(".concat(s.size / 16 * (s.flipX ? -1 : 1), ", ").concat(s.size / 16 * (s.flipY ? -1 : 1), ") "), O = "rotate(".concat(s.rotate, " 0 0)"), le = {
    transform: "".concat(m, " ").concat(C, " ").concat(O)
  }, We = {
    transform: "translate(".concat(l / 2 * -1, " -256)")
  };
  return {
    outer: h,
    inner: le,
    path: We
  };
}
function transformForCss(o) {
  var s = o.transform, u = o.width, l = u === void 0 ? UNITS_IN_GRID : u, h = o.height, m = h === void 0 ? UNITS_IN_GRID : h, C = o.startCentered, O = C === void 0 ? !1 : C, le = "";
  return O && IS_IE ? le += "translate(".concat(s.x / d - l / 2, "em, ").concat(s.y / d - m / 2, "em) ") : O ? le += "translate(calc(-50% + ".concat(s.x / d, "em), calc(-50% + ").concat(s.y / d, "em)) ") : le += "translate(".concat(s.x / d, "em, ").concat(s.y / d, "em) "), le += "scale(".concat(s.size / d * (s.flipX ? -1 : 1), ", ").concat(s.size / d * (s.flipY ? -1 : 1), ") "), le += "rotate(".concat(s.rotate, "deg) "), le;
}
var baseStyles = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0);
          animation-delay: var(--fa-animation-delay, 0);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function css() {
  var o = DEFAULT_FAMILY_PREFIX, s = DEFAULT_REPLACEMENT_CLASS, u = config.familyPrefix, l = config.replacementClass, h = baseStyles;
  if (u !== o || l !== s) {
    var m = new RegExp("\\.".concat(o, "\\-"), "g"), C = new RegExp("\\--".concat(o, "\\-"), "g"), O = new RegExp("\\.".concat(s), "g");
    h = h.replace(m, ".".concat(u, "-")).replace(C, "--".concat(u, "-")).replace(O, ".".concat(l));
  }
  return h;
}
var _cssInserted = !1;
function ensureCss() {
  config.autoAddCss && !_cssInserted && (insertCss(css()), _cssInserted = !0);
}
var InjectCSS = {
  mixout: function() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        ensureCss();
      },
      beforeI2svg: function() {
        ensureCss();
      }
    };
  }
}, w$1 = WINDOW || {};
w$1[NAMESPACE_IDENTIFIER] || (w$1[NAMESPACE_IDENTIFIER] = {});
w$1[NAMESPACE_IDENTIFIER].styles || (w$1[NAMESPACE_IDENTIFIER].styles = {});
w$1[NAMESPACE_IDENTIFIER].hooks || (w$1[NAMESPACE_IDENTIFIER].hooks = {});
w$1[NAMESPACE_IDENTIFIER].shims || (w$1[NAMESPACE_IDENTIFIER].shims = []);
var namespace = w$1[NAMESPACE_IDENTIFIER], functions = [], listener = function o() {
  DOCUMENT.removeEventListener("DOMContentLoaded", o), loaded = 1, functions.map(function(s) {
    return s();
  });
}, loaded = !1;
IS_DOM && (loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState), loaded || DOCUMENT.addEventListener("DOMContentLoaded", listener));
function domready(o) {
  IS_DOM && (loaded ? setTimeout(o, 0) : functions.push(o));
}
function toHtml(o) {
  var s = o.tag, u = o.attributes, l = u === void 0 ? {} : u, h = o.children, m = h === void 0 ? [] : h;
  return typeof o == "string" ? htmlEscape(o) : "<".concat(s, " ").concat(joinAttributes(l), ">").concat(m.map(toHtml).join(""), "</").concat(s, ">");
}
function iconFromMapping(o, s, u) {
  if (o && o[s] && o[s][u])
    return {
      prefix: s,
      iconName: u,
      icon: o[s][u]
    };
}
var bindInternal4 = function(s, u) {
  return function(l, h, m, C) {
    return s.call(u, l, h, m, C);
  };
}, reduce = function(s, u, l, h) {
  var m = Object.keys(s), C = m.length, O = h !== void 0 ? bindInternal4(u, h) : u, le, We, ye;
  for (l === void 0 ? (le = 1, ye = s[m[0]]) : (le = 0, ye = l); le < C; le++)
    We = m[le], ye = O(ye, s[We], We, s);
  return ye;
};
function ucs2decode(o) {
  for (var s = [], u = 0, l = o.length; u < l; ) {
    var h = o.charCodeAt(u++);
    if (h >= 55296 && h <= 56319 && u < l) {
      var m = o.charCodeAt(u++);
      (m & 64512) == 56320 ? s.push(((h & 1023) << 10) + (m & 1023) + 65536) : (s.push(h), u--);
    } else
      s.push(h);
  }
  return s;
}
function toHex(o) {
  var s = ucs2decode(o);
  return s.length === 1 ? s[0].toString(16) : null;
}
function codePointAt(o, s) {
  var u = o.length, l = o.charCodeAt(s), h;
  return l >= 55296 && l <= 56319 && u > s + 1 && (h = o.charCodeAt(s + 1), h >= 56320 && h <= 57343) ? (l - 55296) * 1024 + h - 56320 + 65536 : l;
}
function normalizeIcons(o) {
  return Object.keys(o).reduce(function(s, u) {
    var l = o[u], h = !!l.icon;
    return h ? s[l.iconName] = l.icon : s[u] = l, s;
  }, {});
}
function defineIcons(o, s) {
  var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l = u.skipHooks, h = l === void 0 ? !1 : l, m = normalizeIcons(s);
  typeof namespace.hooks.addPack == "function" && !h ? namespace.hooks.addPack(o, normalizeIcons(s)) : namespace.styles[o] = _objectSpread2$2(_objectSpread2$2({}, namespace.styles[o] || {}), m), o === "fas" && defineIcons("fa", s);
}
var styles$1 = namespace.styles, shims = namespace.shims, LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE), _defaultUsablePrefix = null, _byUnicode = {}, _byLigature = {}, _byOldName = {}, _byOldUnicode = {}, _byAlias = {}, PREFIXES = Object.keys(PREFIX_TO_STYLE);
function isReserved(o) {
  return ~RESERVED_CLASSES.indexOf(o);
}
function getIconName(o, s) {
  var u = s.split("-"), l = u[0], h = u.slice(1).join("-");
  return l === o && h !== "" && !isReserved(h) ? h : null;
}
var build = function() {
  var s = function(m) {
    return reduce(styles$1, function(C, O, le) {
      return C[le] = reduce(O, m, {}), C;
    }, {});
  };
  _byUnicode = s(function(h, m, C) {
    if (m[3] && (h[m[3]] = C), m[2]) {
      var O = m[2].filter(function(le) {
        return typeof le == "number";
      });
      O.forEach(function(le) {
        h[le.toString(16)] = C;
      });
    }
    return h;
  }), _byLigature = s(function(h, m, C) {
    if (h[C] = C, m[2]) {
      var O = m[2].filter(function(le) {
        return typeof le == "string";
      });
      O.forEach(function(le) {
        h[le] = C;
      });
    }
    return h;
  }), _byAlias = s(function(h, m, C) {
    var O = m[2];
    return h[C] = C, O.forEach(function(le) {
      h[le] = C;
    }), h;
  });
  var u = "far" in styles$1 || config.autoFetchSvg, l = reduce(shims, function(h, m) {
    var C = m[0], O = m[1], le = m[2];
    return O === "far" && !u && (O = "fas"), typeof C == "string" && (h.names[C] = {
      prefix: O,
      iconName: le
    }), typeof C == "number" && (h.unicodes[C.toString(16)] = {
      prefix: O,
      iconName: le
    }), h;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = l.names, _byOldUnicode = l.unicodes, _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function(o) {
  _defaultUsablePrefix = getCanonicalPrefix(o.styleDefault);
});
build();
function byUnicode(o, s) {
  return (_byUnicode[o] || {})[s];
}
function byLigature(o, s) {
  return (_byLigature[o] || {})[s];
}
function byAlias(o, s) {
  return (_byAlias[o] || {})[s];
}
function byOldName(o) {
  return _byOldName[o] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(o) {
  var s = _byOldUnicode[o], u = byUnicode("fas", o);
  return s || (u ? {
    prefix: "fas",
    iconName: u
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(o) {
  var s = PREFIX_TO_STYLE[o], u = STYLE_TO_PREFIX[o] || STYLE_TO_PREFIX[s], l = o in namespace.styles ? o : null;
  return u || l || null;
}
function getCanonicalIcon(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = s.skipLookups, l = u === void 0 ? !1 : u, h = null, m = o.reduce(function(C, O) {
    var le = getIconName(config.familyPrefix, O);
    if (styles$1[O] ? (O = LONG_STYLE.includes(O) ? LONG_STYLE_TO_PREFIX[O] : O, h = O, C.prefix = O) : PREFIXES.indexOf(O) > -1 ? (h = O, C.prefix = getCanonicalPrefix(O)) : le ? C.iconName = le : O !== config.replacementClass && C.rest.push(O), !l && C.prefix && C.iconName) {
      var We = h === "fa" ? byOldName(C.iconName) : {}, ye = byAlias(C.prefix, C.iconName);
      We.prefix && (h = null), C.iconName = We.iconName || ye || C.iconName, C.prefix = We.prefix || C.prefix, C.prefix === "far" && !styles$1.far && styles$1.fas && !config.autoFetchSvg && (C.prefix = "fas");
    }
    return C;
  }, emptyCanonicalIcon());
  return (m.prefix === "fa" || h === "fa") && (m.prefix = getDefaultUsablePrefix() || "fas"), m;
}
var Library = /* @__PURE__ */ function() {
  function o() {
    _classCallCheck$1(this, o), this.definitions = {};
  }
  return _createClass$1(o, [{
    key: "add",
    value: function() {
      for (var u = this, l = arguments.length, h = new Array(l), m = 0; m < l; m++)
        h[m] = arguments[m];
      var C = h.reduce(this._pullDefinitions, {});
      Object.keys(C).forEach(function(O) {
        u.definitions[O] = _objectSpread2$2(_objectSpread2$2({}, u.definitions[O] || {}), C[O]), defineIcons(O, C[O]);
        var le = PREFIX_TO_LONG_STYLE[O];
        le && defineIcons(le, C[O]), build();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(u, l) {
      var h = l.prefix && l.iconName && l.icon ? {
        0: l
      } : l;
      return Object.keys(h).map(function(m) {
        var C = h[m], O = C.prefix, le = C.iconName, We = C.icon, ye = We[2];
        u[O] || (u[O] = {}), ye.length > 0 && ye.forEach(function(Fe) {
          typeof Fe == "string" && (u[O][Fe] = We);
        }), u[O][le] = We;
      }), u;
    }
  }]), o;
}(), _plugins = [], _hooks = {}, providers = {}, defaultProviderKeys = Object.keys(providers);
function registerPlugins(o, s) {
  var u = s.mixoutsTo;
  return _plugins = o, _hooks = {}, Object.keys(providers).forEach(function(l) {
    defaultProviderKeys.indexOf(l) === -1 && delete providers[l];
  }), _plugins.forEach(function(l) {
    var h = l.mixout ? l.mixout() : {};
    if (Object.keys(h).forEach(function(C) {
      typeof h[C] == "function" && (u[C] = h[C]), _typeof$2(h[C]) === "object" && Object.keys(h[C]).forEach(function(O) {
        u[C] || (u[C] = {}), u[C][O] = h[C][O];
      });
    }), l.hooks) {
      var m = l.hooks();
      Object.keys(m).forEach(function(C) {
        _hooks[C] || (_hooks[C] = []), _hooks[C].push(m[C]);
      });
    }
    l.provides && l.provides(providers);
  }), u;
}
function chainHooks(o, s) {
  for (var u = arguments.length, l = new Array(u > 2 ? u - 2 : 0), h = 2; h < u; h++)
    l[h - 2] = arguments[h];
  var m = _hooks[o] || [];
  return m.forEach(function(C) {
    s = C.apply(null, [s].concat(l));
  }), s;
}
function callHooks(o) {
  for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
    u[l - 1] = arguments[l];
  var h = _hooks[o] || [];
  h.forEach(function(m) {
    m.apply(null, u);
  });
}
function callProvided() {
  var o = arguments[0], s = Array.prototype.slice.call(arguments, 1);
  return providers[o] ? providers[o].apply(null, s) : void 0;
}
function findIconDefinition(o) {
  o.prefix === "fa" && (o.prefix = "fas");
  var s = o.iconName, u = o.prefix || getDefaultUsablePrefix();
  if (s)
    return s = byAlias(u, s) || s, iconFromMapping(library.definitions, u, s) || iconFromMapping(namespace.styles, u, s);
}
var library = new Library(), noAuto = function() {
  config.autoReplaceSvg = !1, config.observeMutations = !1, callHooks("noAuto");
}, dom = {
  i2svg: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return IS_DOM ? (callHooks("beforeI2svg", s), callProvided("pseudoElements2svg", s), callProvided("i2svg", s)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = s.autoReplaceSvgRoot;
    config.autoReplaceSvg === !1 && (config.autoReplaceSvg = !0), config.observeMutations = !0, domready(function() {
      autoReplace({
        autoReplaceSvgRoot: u
      }), callHooks("watch", s);
    });
  }
}, parse = {
  icon: function(s) {
    if (s === null)
      return null;
    if (_typeof$2(s) === "object" && s.prefix && s.iconName)
      return {
        prefix: s.prefix,
        iconName: byAlias(s.prefix, s.iconName) || s.iconName
      };
    if (Array.isArray(s) && s.length === 2) {
      var u = s[1].indexOf("fa-") === 0 ? s[1].slice(3) : s[1], l = getCanonicalPrefix(s[0]);
      return {
        prefix: l,
        iconName: byAlias(l, u) || u
      };
    }
    if (typeof s == "string" && (s.indexOf("".concat(config.familyPrefix, "-")) > -1 || s.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var h = getCanonicalIcon(s.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: h.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(h.prefix, h.iconName) || h.iconName
      };
    }
    if (typeof s == "string") {
      var m = getDefaultUsablePrefix();
      return {
        prefix: m,
        iconName: byAlias(m, s) || s
      };
    }
  }
}, api = {
  noAuto,
  config,
  dom,
  parse,
  library,
  findIconDefinition,
  toHtml
}, autoReplace = function() {
  var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, u = s.autoReplaceSvgRoot, l = u === void 0 ? DOCUMENT : u;
  (Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg && api.dom.i2svg({
    node: l
  });
};
function domVariants(o, s) {
  return Object.defineProperty(o, "abstract", {
    get: s
  }), Object.defineProperty(o, "html", {
    get: function() {
      return o.abstract.map(function(l) {
        return toHtml(l);
      });
    }
  }), Object.defineProperty(o, "node", {
    get: function() {
      if (IS_DOM) {
        var l = DOCUMENT.createElement("div");
        return l.innerHTML = o.html, l.children;
      }
    }
  }), o;
}
function asIcon(o) {
  var s = o.children, u = o.main, l = o.mask, h = o.attributes, m = o.styles, C = o.transform;
  if (transformIsMeaningful(C) && u.found && !l.found) {
    var O = u.width, le = u.height, We = {
      x: O / le / 2,
      y: 0.5
    };
    h.style = joinStyles(_objectSpread2$2(_objectSpread2$2({}, m), {}, {
      "transform-origin": "".concat(We.x + C.x / 16, "em ").concat(We.y + C.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: h,
    children: s
  }];
}
function asSymbol(o) {
  var s = o.prefix, u = o.iconName, l = o.children, h = o.attributes, m = o.symbol, C = m === !0 ? "".concat(s, "-").concat(config.familyPrefix, "-").concat(u) : m;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$2(_objectSpread2$2({}, h), {}, {
        id: C
      }),
      children: l
    }]
  }];
}
function makeInlineSvgAbstract(o) {
  var s = o.icons, u = s.main, l = s.mask, h = o.prefix, m = o.iconName, C = o.transform, O = o.symbol, le = o.title, We = o.maskId, ye = o.titleId, Fe = o.extra, Ue = o.watchable, Le = Ue === void 0 ? !1 : Ue, Ze = l.found ? l : u, Xe = Ze.width, Je = Ze.height, it = h === "fak", et = [config.replacementClass, m ? "".concat(config.familyPrefix, "-").concat(m) : ""].filter(function(ot) {
    return Fe.classes.indexOf(ot) === -1;
  }).filter(function(ot) {
    return ot !== "" || !!ot;
  }).concat(Fe.classes).join(" "), at = {
    children: [],
    attributes: _objectSpread2$2(_objectSpread2$2({}, Fe.attributes), {}, {
      "data-prefix": h,
      "data-icon": m,
      class: et,
      role: Fe.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(Xe, " ").concat(Je)
    })
  }, $e = it && !~Fe.classes.indexOf("fa-fw") ? {
    width: "".concat(Xe / Je * 16 * 0.0625, "em")
  } : {};
  Le && (at.attributes[DATA_FA_I2SVG] = ""), le && (at.children.push({
    tag: "title",
    attributes: {
      id: at.attributes["aria-labelledby"] || "title-".concat(ye || nextUniqueId())
    },
    children: [le]
  }), delete at.attributes.title);
  var Ke = _objectSpread2$2(_objectSpread2$2({}, at), {}, {
    prefix: h,
    iconName: m,
    main: u,
    mask: l,
    maskId: We,
    transform: C,
    symbol: O,
    styles: _objectSpread2$2(_objectSpread2$2({}, $e), Fe.styles)
  }), tt = l.found && u.found ? callProvided("generateAbstractMask", Ke) || {
    children: [],
    attributes: {}
  } : callProvided("generateAbstractIcon", Ke) || {
    children: [],
    attributes: {}
  }, ut = tt.children, st = tt.attributes;
  return Ke.children = ut, Ke.attributes = st, O ? asSymbol(Ke) : asIcon(Ke);
}
function makeLayersTextAbstract(o) {
  var s = o.content, u = o.width, l = o.height, h = o.transform, m = o.title, C = o.extra, O = o.watchable, le = O === void 0 ? !1 : O, We = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, C.attributes), m ? {
    title: m
  } : {}), {}, {
    class: C.classes.join(" ")
  });
  le && (We[DATA_FA_I2SVG] = "");
  var ye = _objectSpread2$2({}, C.styles);
  transformIsMeaningful(h) && (ye.transform = transformForCss({
    transform: h,
    startCentered: !0,
    width: u,
    height: l
  }), ye["-webkit-transform"] = ye.transform);
  var Fe = joinStyles(ye);
  Fe.length > 0 && (We.style = Fe);
  var Ue = [];
  return Ue.push({
    tag: "span",
    attributes: We,
    children: [s]
  }), m && Ue.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [m]
  }), Ue;
}
function makeLayersCounterAbstract(o) {
  var s = o.content, u = o.title, l = o.extra, h = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, l.attributes), u ? {
    title: u
  } : {}), {}, {
    class: l.classes.join(" ")
  }), m = joinStyles(l.styles);
  m.length > 0 && (h.style = m);
  var C = [];
  return C.push({
    tag: "span",
    attributes: h,
    children: [s]
  }), u && C.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [u]
  }), C;
}
var styles$1$1 = namespace.styles;
function asFoundIcon(o) {
  var s = o[0], u = o[1], l = o.slice(4), h = _slicedToArray$1(l, 1), m = h[0], C = null;
  return Array.isArray(m) ? C = {
    tag: "g",
    attributes: {
      class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
        fill: "currentColor",
        d: m[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
        fill: "currentColor",
        d: m[1]
      }
    }]
  } : C = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: m
    }
  }, {
    found: !0,
    width: s,
    height: u,
    icon: C
  };
}
var missingIconResolutionMixin = {
  found: !1,
  width: 512,
  height: 512
};
function maybeNotifyMissing(o, s) {
  !PRODUCTION$1 && !config.showMissingIcons && o && console.error('Icon with name "'.concat(o, '" and prefix "').concat(s, '" is missing.'));
}
function findIcon(o, s) {
  var u = s;
  return s === "fa" && config.styleDefault !== null && (s = getDefaultUsablePrefix()), new Promise(function(l, h) {
    if (callProvided("missingIconAbstract"), u === "fa") {
      var m = byOldName(o) || {};
      o = m.iconName || o, s = m.prefix || s;
    }
    if (o && s && styles$1$1[s] && styles$1$1[s][o]) {
      var C = styles$1$1[s][o];
      return l(asFoundIcon(C));
    }
    maybeNotifyMissing(o, s), l(_objectSpread2$2(_objectSpread2$2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && o ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
var noop$1 = function() {
}, p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
}, preamble = 'FA "6.0.0"', begin = function(s) {
  return p.mark("".concat(preamble, " ").concat(s, " begins")), function() {
    return end(s);
  };
}, end = function(s) {
  p.mark("".concat(preamble, " ").concat(s, " ends")), p.measure("".concat(preamble, " ").concat(s), "".concat(preamble, " ").concat(s, " begins"), "".concat(preamble, " ").concat(s, " ends"));
}, perf = {
  begin,
  end
}, noop$2 = function() {
};
function isWatched(o) {
  var s = o.getAttribute ? o.getAttribute(DATA_FA_I2SVG) : null;
  return typeof s == "string";
}
function hasPrefixAndIcon(o) {
  var s = o.getAttribute ? o.getAttribute(DATA_PREFIX) : null, u = o.getAttribute ? o.getAttribute(DATA_ICON) : null;
  return s && u;
}
function hasBeenReplaced(o) {
  return o && o.classList && o.classList.contains && o.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === !0)
    return mutators.replace;
  var o = mutators[config.autoReplaceSvg];
  return o || mutators.replace;
}
function createElementNS(o) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", o);
}
function createElement(o) {
  return DOCUMENT.createElement(o);
}
function convertSVG(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = s.ceFn, l = u === void 0 ? o.tag === "svg" ? createElementNS : createElement : u;
  if (typeof o == "string")
    return DOCUMENT.createTextNode(o);
  var h = l(o.tag);
  Object.keys(o.attributes || []).forEach(function(C) {
    h.setAttribute(C, o.attributes[C]);
  });
  var m = o.children || [];
  return m.forEach(function(C) {
    h.appendChild(convertSVG(C, {
      ceFn: l
    }));
  }), h;
}
function nodeAsComment(o) {
  var s = " ".concat(o.outerHTML, " ");
  return s = "".concat(s, "Font Awesome fontawesome.com "), s;
}
var mutators = {
  replace: function(s) {
    var u = s[0];
    if (u.parentNode)
      if (s[1].forEach(function(h) {
        u.parentNode.insertBefore(convertSVG(h), u);
      }), u.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var l = DOCUMENT.createComment(nodeAsComment(u));
        u.parentNode.replaceChild(l, u);
      } else
        u.remove();
  },
  nest: function(s) {
    var u = s[0], l = s[1];
    if (~classArray(u).indexOf(config.replacementClass))
      return mutators.replace(s);
    var h = new RegExp("".concat(config.familyPrefix, "-.*"));
    if (delete l[0].attributes.id, l[0].attributes.class) {
      var m = l[0].attributes.class.split(" ").reduce(function(O, le) {
        return le === config.replacementClass || le.match(h) ? O.toSvg.push(le) : O.toNode.push(le), O;
      }, {
        toNode: [],
        toSvg: []
      });
      l[0].attributes.class = m.toSvg.join(" "), m.toNode.length === 0 ? u.removeAttribute("class") : u.setAttribute("class", m.toNode.join(" "));
    }
    var C = l.map(function(O) {
      return toHtml(O);
    }).join(`
`);
    u.setAttribute(DATA_FA_I2SVG, ""), u.innerHTML = C;
  }
};
function performOperationSync(o) {
  o();
}
function perform(o, s) {
  var u = typeof s == "function" ? s : noop$2;
  if (o.length === 0)
    u();
  else {
    var l = performOperationSync;
    config.mutateApproach === MUTATION_APPROACH_ASYNC && (l = WINDOW.requestAnimationFrame || performOperationSync), l(function() {
      var h = getMutator(), m = perf.begin("mutate");
      o.map(h), m(), u();
    });
  }
}
var disabled = !1;
function disableObservation() {
  disabled = !0;
}
function enableObservation() {
  disabled = !1;
}
var mo = null;
function observe(o) {
  if (MUTATION_OBSERVER && config.observeMutations) {
    var s = o.treeCallback, u = s === void 0 ? noop$2 : s, l = o.nodeCallback, h = l === void 0 ? noop$2 : l, m = o.pseudoElementsCallback, C = m === void 0 ? noop$2 : m, O = o.observeMutationsRoot, le = O === void 0 ? DOCUMENT : O;
    mo = new MUTATION_OBSERVER(function(We) {
      if (!disabled) {
        var ye = getDefaultUsablePrefix();
        toArray(We).forEach(function(Fe) {
          if (Fe.type === "childList" && Fe.addedNodes.length > 0 && !isWatched(Fe.addedNodes[0]) && (config.searchPseudoElements && C(Fe.target), u(Fe.target)), Fe.type === "attributes" && Fe.target.parentNode && config.searchPseudoElements && C(Fe.target.parentNode), Fe.type === "attributes" && isWatched(Fe.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(Fe.attributeName))
            if (Fe.attributeName === "class" && hasPrefixAndIcon(Fe.target)) {
              var Ue = getCanonicalIcon(classArray(Fe.target)), Le = Ue.prefix, Ze = Ue.iconName;
              Fe.target.setAttribute(DATA_PREFIX, Le || ye), Ze && Fe.target.setAttribute(DATA_ICON, Ze);
            } else
              hasBeenReplaced(Fe.target) && h(Fe.target);
        });
      }
    }), IS_DOM && mo.observe(le, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function disconnect() {
  mo && mo.disconnect();
}
function styleParser(o) {
  var s = o.getAttribute("style"), u = [];
  return s && (u = s.split(";").reduce(function(l, h) {
    var m = h.split(":"), C = m[0], O = m.slice(1);
    return C && O.length > 0 && (l[C] = O.join(":").trim()), l;
  }, {})), u;
}
function classParser(o) {
  var s = o.getAttribute("data-prefix"), u = o.getAttribute("data-icon"), l = o.innerText !== void 0 ? o.innerText.trim() : "", h = getCanonicalIcon(classArray(o));
  return h.prefix || (h.prefix = getDefaultUsablePrefix()), s && u && (h.prefix = s, h.iconName = u), h.iconName && h.prefix || h.prefix && l.length > 0 && (h.iconName = byLigature(h.prefix, o.innerText) || byUnicode(h.prefix, toHex(o.innerText))), h;
}
function attributesParser(o) {
  var s = toArray(o.attributes).reduce(function(h, m) {
    return h.name !== "class" && h.name !== "style" && (h[m.name] = m.value), h;
  }, {}), u = o.getAttribute("title"), l = o.getAttribute("data-fa-title-id");
  return config.autoA11y && (u ? s["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(l || nextUniqueId()) : (s["aria-hidden"] = "true", s.focusable = "false")), s;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, u = classParser(o), l = u.iconName, h = u.prefix, m = u.rest, C = attributesParser(o), O = chainHooks("parseNodeAttributes", {}, o), le = s.styleParser ? styleParser(o) : [];
  return _objectSpread2$2({
    iconName: l,
    title: o.getAttribute("title"),
    titleId: o.getAttribute("data-fa-title-id"),
    prefix: h,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: m,
      styles: le,
      attributes: C
    }
  }, O);
}
var styles$2 = namespace.styles;
function generateMutation(o) {
  var s = config.autoReplaceSvg === "nest" ? parseMeta(o, {
    styleParser: !1
  }) : parseMeta(o);
  return ~s.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME) ? callProvided("generateLayersText", o, s) : callProvided("generateSvgReplacementMutation", o, s);
}
function onTree(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM)
    return Promise.resolve();
  var u = DOCUMENT.documentElement.classList, l = function(Fe) {
    return u.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(Fe));
  }, h = function(Fe) {
    return u.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(Fe));
  }, m = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2), C = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(m.map(function(ye) {
    return ".".concat(ye, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(", ");
  if (C.length === 0)
    return Promise.resolve();
  var O = [];
  try {
    O = toArray(o.querySelectorAll(C));
  } catch {
  }
  if (O.length > 0)
    l("pending"), h("complete");
  else
    return Promise.resolve();
  var le = perf.begin("onTree"), We = O.reduce(function(ye, Fe) {
    try {
      var Ue = generateMutation(Fe);
      Ue && ye.push(Ue);
    } catch (Le) {
      PRODUCTION$1 || Le.name === "MissingIcon" && console.error(Le);
    }
    return ye;
  }, []);
  return new Promise(function(ye, Fe) {
    Promise.all(We).then(function(Ue) {
      perform(Ue, function() {
        l("active"), l("complete"), h("pending"), typeof s == "function" && s(), le(), ye();
      });
    }).catch(function(Ue) {
      le(), Fe(Ue);
    });
  });
}
function onNode(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(o).then(function(u) {
    u && perform([u], s);
  });
}
function resolveIcons(o) {
  return function(s) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = (s || {}).icon ? s : findIconDefinition(s || {}), h = u.mask;
    return h && (h = (h || {}).icon ? h : findIconDefinition(h || {})), o(l, _objectSpread2$2(_objectSpread2$2({}, u), {}, {
      mask: h
    }));
  };
}
var render = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = u.transform, h = l === void 0 ? meaninglessTransform : l, m = u.symbol, C = m === void 0 ? !1 : m, O = u.mask, le = O === void 0 ? null : O, We = u.maskId, ye = We === void 0 ? null : We, Fe = u.title, Ue = Fe === void 0 ? null : Fe, Le = u.titleId, Ze = Le === void 0 ? null : Le, Xe = u.classes, Je = Xe === void 0 ? [] : Xe, it = u.attributes, et = it === void 0 ? {} : it, at = u.styles, $e = at === void 0 ? {} : at;
  if (s) {
    var Ke = s.prefix, tt = s.iconName, ut = s.icon;
    return domVariants(_objectSpread2$2({
      type: "icon"
    }, s), function() {
      return callHooks("beforeDOMElementCreation", {
        iconDefinition: s,
        params: u
      }), config.autoA11y && (Ue ? et["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(Ze || nextUniqueId()) : (et["aria-hidden"] = "true", et.focusable = "false")), makeInlineSvgAbstract({
        icons: {
          main: asFoundIcon(ut),
          mask: le ? asFoundIcon(le.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: Ke,
        iconName: tt,
        transform: _objectSpread2$2(_objectSpread2$2({}, meaninglessTransform), h),
        symbol: C,
        title: Ue,
        maskId: ye,
        titleId: Ze,
        extra: {
          attributes: et,
          styles: $e,
          classes: Je
        }
      });
    });
  }
}, ReplaceElements = {
  mixout: function() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(u) {
        return u.treeCallback = onTree, u.nodeCallback = onNode, u;
      }
    };
  },
  provides: function(s) {
    s.i2svg = function(u) {
      var l = u.node, h = l === void 0 ? DOCUMENT : l, m = u.callback, C = m === void 0 ? function() {
      } : m;
      return onTree(h, C);
    }, s.generateSvgReplacementMutation = function(u, l) {
      var h = l.iconName, m = l.title, C = l.titleId, O = l.prefix, le = l.transform, We = l.symbol, ye = l.mask, Fe = l.maskId, Ue = l.extra;
      return new Promise(function(Le, Ze) {
        Promise.all([findIcon(h, O), ye.iconName ? findIcon(ye.iconName, ye.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(Xe) {
          var Je = _slicedToArray$1(Xe, 2), it = Je[0], et = Je[1];
          Le([u, makeInlineSvgAbstract({
            icons: {
              main: it,
              mask: et
            },
            prefix: O,
            iconName: h,
            transform: le,
            symbol: We,
            maskId: Fe,
            title: m,
            titleId: C,
            extra: Ue,
            watchable: !0
          })]);
        }).catch(Ze);
      });
    }, s.generateAbstractIcon = function(u) {
      var l = u.children, h = u.attributes, m = u.main, C = u.transform, O = u.styles, le = joinStyles(O);
      le.length > 0 && (h.style = le);
      var We;
      return transformIsMeaningful(C) && (We = callProvided("generateAbstractTransformGrouping", {
        main: m,
        transform: C,
        containerWidth: m.width,
        iconWidth: m.width
      })), l.push(We || m.icon), {
        children: l,
        attributes: h
      };
    };
  }
}, Layers = {
  mixout: function() {
    return {
      layer: function(u) {
        var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = l.classes, m = h === void 0 ? [] : h;
        return domVariants({
          type: "layer"
        }, function() {
          callHooks("beforeDOMElementCreation", {
            assembler: u,
            params: l
          });
          var C = [];
          return u(function(O) {
            Array.isArray(O) ? O.map(function(le) {
              C = C.concat(le.abstract);
            }) : C = C.concat(O.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray$1(m)).join(" ")
            },
            children: C
          }];
        });
      }
    };
  }
}, LayersCounter = {
  mixout: function() {
    return {
      counter: function(u) {
        var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = l.title, m = h === void 0 ? null : h, C = l.classes, O = C === void 0 ? [] : C, le = l.attributes, We = le === void 0 ? {} : le, ye = l.styles, Fe = ye === void 0 ? {} : ye;
        return domVariants({
          type: "counter",
          content: u
        }, function() {
          return callHooks("beforeDOMElementCreation", {
            content: u,
            params: l
          }), makeLayersCounterAbstract({
            content: u.toString(),
            title: m,
            extra: {
              attributes: We,
              styles: Fe,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray$1(O))
            }
          });
        });
      }
    };
  }
}, LayersText = {
  mixout: function() {
    return {
      text: function(u) {
        var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, h = l.transform, m = h === void 0 ? meaninglessTransform : h, C = l.title, O = C === void 0 ? null : C, le = l.classes, We = le === void 0 ? [] : le, ye = l.attributes, Fe = ye === void 0 ? {} : ye, Ue = l.styles, Le = Ue === void 0 ? {} : Ue;
        return domVariants({
          type: "text",
          content: u
        }, function() {
          return callHooks("beforeDOMElementCreation", {
            content: u,
            params: l
          }), makeLayersTextAbstract({
            content: u,
            transform: _objectSpread2$2(_objectSpread2$2({}, meaninglessTransform), m),
            title: O,
            extra: {
              attributes: Fe,
              styles: Le,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray$1(We))
            }
          });
        });
      }
    };
  },
  provides: function(s) {
    s.generateLayersText = function(u, l) {
      var h = l.title, m = l.transform, C = l.extra, O = null, le = null;
      if (IS_IE) {
        var We = parseInt(getComputedStyle(u).fontSize, 10), ye = u.getBoundingClientRect();
        O = ye.width / We, le = ye.height / We;
      }
      return config.autoA11y && !h && (C.attributes["aria-hidden"] = "true"), Promise.resolve([u, makeLayersTextAbstract({
        content: u.innerHTML,
        width: O,
        height: le,
        transform: m,
        title: h,
        extra: C,
        watchable: !0
      })]);
    };
  }
}, CLEAN_CONTENT_PATTERN = new RegExp('"', "ug"), SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(o) {
  var s = o.replace(CLEAN_CONTENT_PATTERN, ""), u = codePointAt(s, 0), l = u >= SECONDARY_UNICODE_RANGE[0] && u <= SECONDARY_UNICODE_RANGE[1], h = s.length === 2 ? s[0] === s[1] : !1;
  return {
    value: toHex(h ? s[0] : s),
    isSecondary: l || h
  };
}
function replaceForPosition(o, s) {
  var u = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(s.replace(":", "-"));
  return new Promise(function(l, h) {
    if (o.getAttribute(u) !== null)
      return l();
    var m = toArray(o.children), C = m.filter(function(tt) {
      return tt.getAttribute(DATA_FA_PSEUDO_ELEMENT) === s;
    })[0], O = WINDOW.getComputedStyle(o, s), le = O.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN), We = O.getPropertyValue("font-weight"), ye = O.getPropertyValue("content");
    if (C && !le)
      return o.removeChild(C), l();
    if (le && ye !== "none" && ye !== "") {
      var Fe = O.getPropertyValue("content"), Ue = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(le[2]) ? STYLE_TO_PREFIX[le[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[We], Le = hexValueFromContent(Fe), Ze = Le.value, Xe = Le.isSecondary, Je = le[0].startsWith("FontAwesome"), it = byUnicode(Ue, Ze), et = it;
      if (Je) {
        var at = byOldUnicode(Ze);
        at.iconName && at.prefix && (it = at.iconName, Ue = at.prefix);
      }
      if (it && !Xe && (!C || C.getAttribute(DATA_PREFIX) !== Ue || C.getAttribute(DATA_ICON) !== et)) {
        o.setAttribute(u, et), C && o.removeChild(C);
        var $e = blankMeta(), Ke = $e.extra;
        Ke.attributes[DATA_FA_PSEUDO_ELEMENT] = s, findIcon(it, Ue).then(function(tt) {
          var ut = makeInlineSvgAbstract(_objectSpread2$2(_objectSpread2$2({}, $e), {}, {
            icons: {
              main: tt,
              mask: emptyCanonicalIcon()
            },
            prefix: Ue,
            iconName: et,
            extra: Ke,
            watchable: !0
          })), st = DOCUMENT.createElement("svg");
          s === "::before" ? o.insertBefore(st, o.firstChild) : o.appendChild(st), st.outerHTML = ut.map(function(ot) {
            return toHtml(ot);
          }).join(`
`), o.removeAttribute(u), l();
        }).catch(h);
      } else
        l();
    } else
      l();
  });
}
function replace(o) {
  return Promise.all([replaceForPosition(o, "::before"), replaceForPosition(o, "::after")]);
}
function processable(o) {
  return o.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(o.tagName.toUpperCase()) && !o.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!o.parentNode || o.parentNode.tagName !== "svg");
}
function searchPseudoElements(o) {
  if (IS_DOM)
    return new Promise(function(s, u) {
      var l = toArray(o.querySelectorAll("*")).filter(processable).map(replace), h = perf.begin("searchPseudoElements");
      disableObservation(), Promise.all(l).then(function() {
        h(), enableObservation(), s();
      }).catch(function() {
        h(), enableObservation(), u();
      });
    });
}
var PseudoElements = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(u) {
        return u.pseudoElementsCallback = searchPseudoElements, u;
      }
    };
  },
  provides: function(s) {
    s.pseudoElements2svg = function(u) {
      var l = u.node, h = l === void 0 ? DOCUMENT : l;
      config.searchPseudoElements && searchPseudoElements(h);
    };
  }
}, _unwatched = !1, MutationObserver$1 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          disableObservation(), _unwatched = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        disconnect();
      },
      watch: function(u) {
        var l = u.observeMutationsRoot;
        _unwatched ? enableObservation() : observe(chainHooks("mutationObserverCallbacks", {
          observeMutationsRoot: l
        }));
      }
    };
  }
}, parseTransformString = function(s) {
  var u = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return s.toLowerCase().split(" ").reduce(function(l, h) {
    var m = h.toLowerCase().split("-"), C = m[0], O = m.slice(1).join("-");
    if (C && O === "h")
      return l.flipX = !0, l;
    if (C && O === "v")
      return l.flipY = !0, l;
    if (O = parseFloat(O), isNaN(O))
      return l;
    switch (C) {
      case "grow":
        l.size = l.size + O;
        break;
      case "shrink":
        l.size = l.size - O;
        break;
      case "left":
        l.x = l.x - O;
        break;
      case "right":
        l.x = l.x + O;
        break;
      case "up":
        l.y = l.y - O;
        break;
      case "down":
        l.y = l.y + O;
        break;
      case "rotate":
        l.rotate = l.rotate + O;
        break;
    }
    return l;
  }, u);
}, PowerTransforms = {
  mixout: function() {
    return {
      parse: {
        transform: function(u) {
          return parseTransformString(u);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(u, l) {
        var h = l.getAttribute("data-fa-transform");
        return h && (u.transform = parseTransformString(h)), u;
      }
    };
  },
  provides: function(s) {
    s.generateAbstractTransformGrouping = function(u) {
      var l = u.main, h = u.transform, m = u.containerWidth, C = u.iconWidth, O = {
        transform: "translate(".concat(m / 2, " 256)")
      }, le = "translate(".concat(h.x * 32, ", ").concat(h.y * 32, ") "), We = "scale(".concat(h.size / 16 * (h.flipX ? -1 : 1), ", ").concat(h.size / 16 * (h.flipY ? -1 : 1), ") "), ye = "rotate(".concat(h.rotate, " 0 0)"), Fe = {
        transform: "".concat(le, " ").concat(We, " ").concat(ye)
      }, Ue = {
        transform: "translate(".concat(C / 2 * -1, " -256)")
      }, Le = {
        outer: O,
        inner: Fe,
        path: Ue
      };
      return {
        tag: "g",
        attributes: _objectSpread2$2({}, Le.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$2({}, Le.inner),
          children: [{
            tag: l.icon.tag,
            children: l.icon.children,
            attributes: _objectSpread2$2(_objectSpread2$2({}, l.icon.attributes), Le.path)
          }]
        }]
      };
    };
  }
}, ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(o) {
  var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return o.attributes && (o.attributes.fill || s) && (o.attributes.fill = "black"), o;
}
function deGroup(o) {
  return o.tag === "g" ? o.children : [o];
}
var Masks = {
  hooks: function() {
    return {
      parseNodeAttributes: function(u, l) {
        var h = l.getAttribute("data-fa-mask"), m = h ? getCanonicalIcon(h.split(" ").map(function(C) {
          return C.trim();
        })) : emptyCanonicalIcon();
        return m.prefix || (m.prefix = getDefaultUsablePrefix()), u.mask = m, u.maskId = l.getAttribute("data-fa-mask-id"), u;
      }
    };
  },
  provides: function(s) {
    s.generateAbstractMask = function(u) {
      var l = u.children, h = u.attributes, m = u.main, C = u.mask, O = u.maskId, le = u.transform, We = m.width, ye = m.icon, Fe = C.width, Ue = C.icon, Le = transformForSvg({
        transform: le,
        containerWidth: Fe,
        iconWidth: We
      }), Ze = {
        tag: "rect",
        attributes: _objectSpread2$2(_objectSpread2$2({}, ALL_SPACE), {}, {
          fill: "white"
        })
      }, Xe = ye.children ? {
        children: ye.children.map(fillBlack)
      } : {}, Je = {
        tag: "g",
        attributes: _objectSpread2$2({}, Le.inner),
        children: [fillBlack(_objectSpread2$2({
          tag: ye.tag,
          attributes: _objectSpread2$2(_objectSpread2$2({}, ye.attributes), Le.path)
        }, Xe))]
      }, it = {
        tag: "g",
        attributes: _objectSpread2$2({}, Le.outer),
        children: [Je]
      }, et = "mask-".concat(O || nextUniqueId()), at = "clip-".concat(O || nextUniqueId()), $e = {
        tag: "mask",
        attributes: _objectSpread2$2(_objectSpread2$2({}, ALL_SPACE), {}, {
          id: et,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [Ze, it]
      }, Ke = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: at
          },
          children: deGroup(Ue)
        }, $e]
      };
      return l.push(Ke, {
        tag: "rect",
        attributes: _objectSpread2$2({
          fill: "currentColor",
          "clip-path": "url(#".concat(at, ")"),
          mask: "url(#".concat(et, ")")
        }, ALL_SPACE)
      }), {
        children: l,
        attributes: h
      };
    };
  }
}, MissingIconIndicator = {
  provides: function(s) {
    var u = !1;
    WINDOW.matchMedia && (u = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches), s.missingIconAbstract = function() {
      var l = [], h = {
        fill: "currentColor"
      }, m = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      l.push({
        tag: "path",
        attributes: _objectSpread2$2(_objectSpread2$2({}, h), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var C = _objectSpread2$2(_objectSpread2$2({}, m), {}, {
        attributeName: "opacity"
      }), O = {
        tag: "circle",
        attributes: _objectSpread2$2(_objectSpread2$2({}, h), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return u || O.children.push({
        tag: "animate",
        attributes: _objectSpread2$2(_objectSpread2$2({}, m), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: _objectSpread2$2(_objectSpread2$2({}, C), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), l.push(O), l.push({
        tag: "path",
        attributes: _objectSpread2$2(_objectSpread2$2({}, h), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: u ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$2(_objectSpread2$2({}, C), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), u || l.push({
        tag: "path",
        attributes: _objectSpread2$2(_objectSpread2$2({}, h), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: _objectSpread2$2(_objectSpread2$2({}, C), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: l
      };
    };
  }
}, SvgSymbols = {
  hooks: function() {
    return {
      parseNodeAttributes: function(u, l) {
        var h = l.getAttribute("data-fa-symbol"), m = h === null ? !1 : h === "" ? !0 : h;
        return u.symbol = m, u;
      }
    };
  }
}, plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
var parse$1 = api.parse;
api.findIconDefinition;
api.toHtml;
var icon = api.icon;
api.layer;
api.text;
api.counter;
var propTypes = {
  exports: {}
}, reactIs$2 = {
  exports: {}
}, reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var o = typeof Symbol == "function" && Symbol.for, s = o ? Symbol.for("react.element") : 60103, u = o ? Symbol.for("react.portal") : 60106, l = o ? Symbol.for("react.fragment") : 60107, h = o ? Symbol.for("react.strict_mode") : 60108, m = o ? Symbol.for("react.profiler") : 60114, C = o ? Symbol.for("react.provider") : 60109, O = o ? Symbol.for("react.context") : 60110, le = o ? Symbol.for("react.async_mode") : 60111, We = o ? Symbol.for("react.concurrent_mode") : 60111, ye = o ? Symbol.for("react.forward_ref") : 60112, Fe = o ? Symbol.for("react.suspense") : 60113, Ue = o ? Symbol.for("react.suspense_list") : 60120, Le = o ? Symbol.for("react.memo") : 60115, Ze = o ? Symbol.for("react.lazy") : 60116, Xe = o ? Symbol.for("react.block") : 60121, Je = o ? Symbol.for("react.fundamental") : 60117, it = o ? Symbol.for("react.responder") : 60118, et = o ? Symbol.for("react.scope") : 60119;
  function at(Ke) {
    if (typeof Ke == "object" && Ke !== null) {
      var tt = Ke.$$typeof;
      switch (tt) {
        case s:
          switch (Ke = Ke.type, Ke) {
            case le:
            case We:
            case l:
            case m:
            case h:
            case Fe:
              return Ke;
            default:
              switch (Ke = Ke && Ke.$$typeof, Ke) {
                case O:
                case ye:
                case Ze:
                case Le:
                case C:
                  return Ke;
                default:
                  return tt;
              }
          }
        case u:
          return tt;
      }
    }
  }
  function $e(Ke) {
    return at(Ke) === We;
  }
  return reactIs_production_min$1.AsyncMode = le, reactIs_production_min$1.ConcurrentMode = We, reactIs_production_min$1.ContextConsumer = O, reactIs_production_min$1.ContextProvider = C, reactIs_production_min$1.Element = s, reactIs_production_min$1.ForwardRef = ye, reactIs_production_min$1.Fragment = l, reactIs_production_min$1.Lazy = Ze, reactIs_production_min$1.Memo = Le, reactIs_production_min$1.Portal = u, reactIs_production_min$1.Profiler = m, reactIs_production_min$1.StrictMode = h, reactIs_production_min$1.Suspense = Fe, reactIs_production_min$1.isAsyncMode = function(Ke) {
    return $e(Ke) || at(Ke) === le;
  }, reactIs_production_min$1.isConcurrentMode = $e, reactIs_production_min$1.isContextConsumer = function(Ke) {
    return at(Ke) === O;
  }, reactIs_production_min$1.isContextProvider = function(Ke) {
    return at(Ke) === C;
  }, reactIs_production_min$1.isElement = function(Ke) {
    return typeof Ke == "object" && Ke !== null && Ke.$$typeof === s;
  }, reactIs_production_min$1.isForwardRef = function(Ke) {
    return at(Ke) === ye;
  }, reactIs_production_min$1.isFragment = function(Ke) {
    return at(Ke) === l;
  }, reactIs_production_min$1.isLazy = function(Ke) {
    return at(Ke) === Ze;
  }, reactIs_production_min$1.isMemo = function(Ke) {
    return at(Ke) === Le;
  }, reactIs_production_min$1.isPortal = function(Ke) {
    return at(Ke) === u;
  }, reactIs_production_min$1.isProfiler = function(Ke) {
    return at(Ke) === m;
  }, reactIs_production_min$1.isStrictMode = function(Ke) {
    return at(Ke) === h;
  }, reactIs_production_min$1.isSuspense = function(Ke) {
    return at(Ke) === Fe;
  }, reactIs_production_min$1.isValidElementType = function(Ke) {
    return typeof Ke == "string" || typeof Ke == "function" || Ke === l || Ke === We || Ke === m || Ke === h || Ke === Fe || Ke === Ue || typeof Ke == "object" && Ke !== null && (Ke.$$typeof === Ze || Ke.$$typeof === Le || Ke.$$typeof === C || Ke.$$typeof === O || Ke.$$typeof === ye || Ke.$$typeof === Je || Ke.$$typeof === it || Ke.$$typeof === et || Ke.$$typeof === Xe);
  }, reactIs_production_min$1.typeOf = at, reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && function() {
    var o = typeof Symbol == "function" && Symbol.for, s = o ? Symbol.for("react.element") : 60103, u = o ? Symbol.for("react.portal") : 60106, l = o ? Symbol.for("react.fragment") : 60107, h = o ? Symbol.for("react.strict_mode") : 60108, m = o ? Symbol.for("react.profiler") : 60114, C = o ? Symbol.for("react.provider") : 60109, O = o ? Symbol.for("react.context") : 60110, le = o ? Symbol.for("react.async_mode") : 60111, We = o ? Symbol.for("react.concurrent_mode") : 60111, ye = o ? Symbol.for("react.forward_ref") : 60112, Fe = o ? Symbol.for("react.suspense") : 60113, Ue = o ? Symbol.for("react.suspense_list") : 60120, Le = o ? Symbol.for("react.memo") : 60115, Ze = o ? Symbol.for("react.lazy") : 60116, Xe = o ? Symbol.for("react.block") : 60121, Je = o ? Symbol.for("react.fundamental") : 60117, it = o ? Symbol.for("react.responder") : 60118, et = o ? Symbol.for("react.scope") : 60119;
    function at(St) {
      return typeof St == "string" || typeof St == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      St === l || St === We || St === m || St === h || St === Fe || St === Ue || typeof St == "object" && St !== null && (St.$$typeof === Ze || St.$$typeof === Le || St.$$typeof === C || St.$$typeof === O || St.$$typeof === ye || St.$$typeof === Je || St.$$typeof === it || St.$$typeof === et || St.$$typeof === Xe);
    }
    function $e(St) {
      if (typeof St == "object" && St !== null) {
        var Mt = St.$$typeof;
        switch (Mt) {
          case s:
            var Dt = St.type;
            switch (Dt) {
              case le:
              case We:
              case l:
              case m:
              case h:
              case Fe:
                return Dt;
              default:
                var Nt = Dt && Dt.$$typeof;
                switch (Nt) {
                  case O:
                  case ye:
                  case Ze:
                  case Le:
                  case C:
                    return Nt;
                  default:
                    return Mt;
                }
            }
          case u:
            return Mt;
        }
      }
    }
    var Ke = le, tt = We, ut = O, st = C, ot = s, ht = ye, vt = l, At = Ze, gt = Le, bt = u, wt = m, Ot = h, yt = Fe, Qe = !1;
    function nt(St) {
      return Qe || (Qe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), rt(St) || $e(St) === le;
    }
    function rt(St) {
      return $e(St) === We;
    }
    function lt(St) {
      return $e(St) === O;
    }
    function ct(St) {
      return $e(St) === C;
    }
    function ft(St) {
      return typeof St == "object" && St !== null && St.$$typeof === s;
    }
    function pt(St) {
      return $e(St) === ye;
    }
    function mt(St) {
      return $e(St) === l;
    }
    function dt(St) {
      return $e(St) === Ze;
    }
    function Et(St) {
      return $e(St) === Le;
    }
    function Ct(St) {
      return $e(St) === u;
    }
    function Tt(St) {
      return $e(St) === m;
    }
    function qt(St) {
      return $e(St) === h;
    }
    function jt(St) {
      return $e(St) === Fe;
    }
    reactIs_development$1.AsyncMode = Ke, reactIs_development$1.ConcurrentMode = tt, reactIs_development$1.ContextConsumer = ut, reactIs_development$1.ContextProvider = st, reactIs_development$1.Element = ot, reactIs_development$1.ForwardRef = ht, reactIs_development$1.Fragment = vt, reactIs_development$1.Lazy = At, reactIs_development$1.Memo = gt, reactIs_development$1.Portal = bt, reactIs_development$1.Profiler = wt, reactIs_development$1.StrictMode = Ot, reactIs_development$1.Suspense = yt, reactIs_development$1.isAsyncMode = nt, reactIs_development$1.isConcurrentMode = rt, reactIs_development$1.isContextConsumer = lt, reactIs_development$1.isContextProvider = ct, reactIs_development$1.isElement = ft, reactIs_development$1.isForwardRef = pt, reactIs_development$1.isFragment = mt, reactIs_development$1.isLazy = dt, reactIs_development$1.isMemo = Et, reactIs_development$1.isPortal = Ct, reactIs_development$1.isProfiler = Tt, reactIs_development$1.isStrictMode = qt, reactIs_development$1.isSuspense = jt, reactIs_development$1.isValidElementType = at, reactIs_development$1.typeOf = $e;
  }()), reactIs_development$1;
}
process.env.NODE_ENV === "production" ? reactIs$2.exports = requireReactIs_production_min$1() : reactIs$2.exports = requireReactIs_development$1();
var reactIsExports$1 = reactIs$2.exports;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var o = Object.getOwnPropertySymbols, s = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
  function l(m) {
    if (m == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(m);
  }
  function h() {
    try {
      if (!Object.assign)
        return !1;
      var m = new String("abc");
      if (m[5] = "de", Object.getOwnPropertyNames(m)[0] === "5")
        return !1;
      for (var C = {}, O = 0; O < 10; O++)
        C["_" + String.fromCharCode(O)] = O;
      var le = Object.getOwnPropertyNames(C).map(function(ye) {
        return C[ye];
      });
      if (le.join("") !== "0123456789")
        return !1;
      var We = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(ye) {
        We[ye] = ye;
      }), Object.keys(Object.assign({}, We)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = h() ? Object.assign : function(m, C) {
    for (var O, le = l(m), We, ye = 1; ye < arguments.length; ye++) {
      O = Object(arguments[ye]);
      for (var Fe in O)
        s.call(O, Fe) && (le[Fe] = O[Fe]);
      if (o) {
        We = o(O);
        for (var Ue = 0; Ue < We.length; Ue++)
          u.call(O, We[Ue]) && (le[We[Ue]] = O[We[Ue]]);
      }
    }
    return le;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = o, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var o = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var s = requireReactPropTypesSecret(), u = {}, l = requireHas();
    o = function(m) {
      var C = "Warning: " + m;
      typeof console < "u" && console.error(C);
      try {
        throw new Error(C);
      } catch {
      }
    };
  }
  function h(m, C, O, le, We) {
    if (process.env.NODE_ENV !== "production") {
      for (var ye in m)
        if (l(m, ye)) {
          var Fe;
          try {
            if (typeof m[ye] != "function") {
              var Ue = Error((le || "React class") + ": " + O + " type `" + ye + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof m[ye] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw Ue.name = "Invariant Violation", Ue;
            }
            Fe = m[ye](C, ye, le, O, null, s);
          } catch (Ze) {
            Fe = Ze;
          }
          if (Fe && !(Fe instanceof Error) && o((le || "React class") + ": type specification of " + O + " `" + ye + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof Fe + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), Fe instanceof Error && !(Fe.message in u)) {
            u[Fe.message] = !0;
            var Le = We ? We() : "";
            o("Failed " + O + " type: " + Fe.message + (Le ?? ""));
          }
        }
    }
  }
  return h.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (u = {});
  }, checkPropTypes_1 = h, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var o = reactIsExports$1, s = requireObjectAssign(), u = requireReactPropTypesSecret(), l = requireHas(), h = requireCheckPropTypes(), m = function() {
  };
  process.env.NODE_ENV !== "production" && (m = function(O) {
    var le = "Warning: " + O;
    typeof console < "u" && console.error(le);
    try {
      throw new Error(le);
    } catch {
    }
  });
  function C() {
    return null;
  }
  return factoryWithTypeCheckers = function(O, le) {
    var We = typeof Symbol == "function" && Symbol.iterator, ye = "@@iterator";
    function Fe(rt) {
      var lt = rt && (We && rt[We] || rt[ye]);
      if (typeof lt == "function")
        return lt;
    }
    var Ue = "<<anonymous>>", Le = {
      array: it("array"),
      bigint: it("bigint"),
      bool: it("boolean"),
      func: it("function"),
      number: it("number"),
      object: it("object"),
      string: it("string"),
      symbol: it("symbol"),
      any: et(),
      arrayOf: at,
      element: $e(),
      elementType: Ke(),
      instanceOf: tt,
      node: ht(),
      objectOf: st,
      oneOf: ut,
      oneOfType: ot,
      shape: At,
      exact: gt
    };
    function Ze(rt, lt) {
      return rt === lt ? rt !== 0 || 1 / rt === 1 / lt : rt !== rt && lt !== lt;
    }
    function Xe(rt, lt) {
      this.message = rt, this.data = lt && typeof lt == "object" ? lt : {}, this.stack = "";
    }
    Xe.prototype = Error.prototype;
    function Je(rt) {
      if (process.env.NODE_ENV !== "production")
        var lt = {}, ct = 0;
      function ft(mt, dt, Et, Ct, Tt, qt, jt) {
        if (Ct = Ct || Ue, qt = qt || Et, jt !== u) {
          if (le) {
            var St = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw St.name = "Invariant Violation", St;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Mt = Ct + ":" + Et;
            !lt[Mt] && // Avoid spamming the console because they are often not actionable except for lib authors
            ct < 3 && (m("You are manually calling a React.PropTypes validation function for the `" + qt + "` prop on `" + Ct + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), lt[Mt] = !0, ct++);
          }
        }
        return dt[Et] == null ? mt ? dt[Et] === null ? new Xe("The " + Tt + " `" + qt + "` is marked as required " + ("in `" + Ct + "`, but its value is `null`.")) : new Xe("The " + Tt + " `" + qt + "` is marked as required in " + ("`" + Ct + "`, but its value is `undefined`.")) : null : rt(dt, Et, Ct, Tt, qt);
      }
      var pt = ft.bind(null, !1);
      return pt.isRequired = ft.bind(null, !0), pt;
    }
    function it(rt) {
      function lt(ct, ft, pt, mt, dt, Et) {
        var Ct = ct[ft], Tt = Ot(Ct);
        if (Tt !== rt) {
          var qt = yt(Ct);
          return new Xe("Invalid " + mt + " `" + dt + "` of type " + ("`" + qt + "` supplied to `" + pt + "`, expected ") + ("`" + rt + "`."), {
            expectedType: rt
          });
        }
        return null;
      }
      return Je(lt);
    }
    function et() {
      return Je(C);
    }
    function at(rt) {
      function lt(ct, ft, pt, mt, dt) {
        if (typeof rt != "function")
          return new Xe("Property `" + dt + "` of component `" + pt + "` has invalid PropType notation inside arrayOf.");
        var Et = ct[ft];
        if (!Array.isArray(Et)) {
          var Ct = Ot(Et);
          return new Xe("Invalid " + mt + " `" + dt + "` of type " + ("`" + Ct + "` supplied to `" + pt + "`, expected an array."));
        }
        for (var Tt = 0; Tt < Et.length; Tt++) {
          var qt = rt(Et, Tt, pt, mt, dt + "[" + Tt + "]", u);
          if (qt instanceof Error)
            return qt;
        }
        return null;
      }
      return Je(lt);
    }
    function $e() {
      function rt(lt, ct, ft, pt, mt) {
        var dt = lt[ct];
        if (!O(dt)) {
          var Et = Ot(dt);
          return new Xe("Invalid " + pt + " `" + mt + "` of type " + ("`" + Et + "` supplied to `" + ft + "`, expected a single ReactElement."));
        }
        return null;
      }
      return Je(rt);
    }
    function Ke() {
      function rt(lt, ct, ft, pt, mt) {
        var dt = lt[ct];
        if (!o.isValidElementType(dt)) {
          var Et = Ot(dt);
          return new Xe("Invalid " + pt + " `" + mt + "` of type " + ("`" + Et + "` supplied to `" + ft + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return Je(rt);
    }
    function tt(rt) {
      function lt(ct, ft, pt, mt, dt) {
        if (!(ct[ft] instanceof rt)) {
          var Et = rt.name || Ue, Ct = nt(ct[ft]);
          return new Xe("Invalid " + mt + " `" + dt + "` of type " + ("`" + Ct + "` supplied to `" + pt + "`, expected ") + ("instance of `" + Et + "`."));
        }
        return null;
      }
      return Je(lt);
    }
    function ut(rt) {
      if (!Array.isArray(rt))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? m("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : m("Invalid argument supplied to oneOf, expected an array.")), C;
      function lt(ct, ft, pt, mt, dt) {
        for (var Et = ct[ft], Ct = 0; Ct < rt.length; Ct++)
          if (Ze(Et, rt[Ct]))
            return null;
        var Tt = JSON.stringify(rt, function(jt, St) {
          var Mt = yt(St);
          return Mt === "symbol" ? String(St) : St;
        });
        return new Xe("Invalid " + mt + " `" + dt + "` of value `" + String(Et) + "` " + ("supplied to `" + pt + "`, expected one of " + Tt + "."));
      }
      return Je(lt);
    }
    function st(rt) {
      function lt(ct, ft, pt, mt, dt) {
        if (typeof rt != "function")
          return new Xe("Property `" + dt + "` of component `" + pt + "` has invalid PropType notation inside objectOf.");
        var Et = ct[ft], Ct = Ot(Et);
        if (Ct !== "object")
          return new Xe("Invalid " + mt + " `" + dt + "` of type " + ("`" + Ct + "` supplied to `" + pt + "`, expected an object."));
        for (var Tt in Et)
          if (l(Et, Tt)) {
            var qt = rt(Et, Tt, pt, mt, dt + "." + Tt, u);
            if (qt instanceof Error)
              return qt;
          }
        return null;
      }
      return Je(lt);
    }
    function ot(rt) {
      if (!Array.isArray(rt))
        return process.env.NODE_ENV !== "production" && m("Invalid argument supplied to oneOfType, expected an instance of array."), C;
      for (var lt = 0; lt < rt.length; lt++) {
        var ct = rt[lt];
        if (typeof ct != "function")
          return m("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Qe(ct) + " at index " + lt + "."), C;
      }
      function ft(pt, mt, dt, Et, Ct) {
        for (var Tt = [], qt = 0; qt < rt.length; qt++) {
          var jt = rt[qt], St = jt(pt, mt, dt, Et, Ct, u);
          if (St == null)
            return null;
          St.data && l(St.data, "expectedType") && Tt.push(St.data.expectedType);
        }
        var Mt = Tt.length > 0 ? ", expected one of type [" + Tt.join(", ") + "]" : "";
        return new Xe("Invalid " + Et + " `" + Ct + "` supplied to " + ("`" + dt + "`" + Mt + "."));
      }
      return Je(ft);
    }
    function ht() {
      function rt(lt, ct, ft, pt, mt) {
        return bt(lt[ct]) ? null : new Xe("Invalid " + pt + " `" + mt + "` supplied to " + ("`" + ft + "`, expected a ReactNode."));
      }
      return Je(rt);
    }
    function vt(rt, lt, ct, ft, pt) {
      return new Xe((rt || "React class") + ": " + lt + " type `" + ct + "." + ft + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + pt + "`.");
    }
    function At(rt) {
      function lt(ct, ft, pt, mt, dt) {
        var Et = ct[ft], Ct = Ot(Et);
        if (Ct !== "object")
          return new Xe("Invalid " + mt + " `" + dt + "` of type `" + Ct + "` " + ("supplied to `" + pt + "`, expected `object`."));
        for (var Tt in rt) {
          var qt = rt[Tt];
          if (typeof qt != "function")
            return vt(pt, mt, dt, Tt, yt(qt));
          var jt = qt(Et, Tt, pt, mt, dt + "." + Tt, u);
          if (jt)
            return jt;
        }
        return null;
      }
      return Je(lt);
    }
    function gt(rt) {
      function lt(ct, ft, pt, mt, dt) {
        var Et = ct[ft], Ct = Ot(Et);
        if (Ct !== "object")
          return new Xe("Invalid " + mt + " `" + dt + "` of type `" + Ct + "` " + ("supplied to `" + pt + "`, expected `object`."));
        var Tt = s({}, ct[ft], rt);
        for (var qt in Tt) {
          var jt = rt[qt];
          if (l(rt, qt) && typeof jt != "function")
            return vt(pt, mt, dt, qt, yt(jt));
          if (!jt)
            return new Xe("Invalid " + mt + " `" + dt + "` key `" + qt + "` supplied to `" + pt + "`.\nBad object: " + JSON.stringify(ct[ft], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(rt), null, "  "));
          var St = jt(Et, qt, pt, mt, dt + "." + qt, u);
          if (St)
            return St;
        }
        return null;
      }
      return Je(lt);
    }
    function bt(rt) {
      switch (typeof rt) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !rt;
        case "object":
          if (Array.isArray(rt))
            return rt.every(bt);
          if (rt === null || O(rt))
            return !0;
          var lt = Fe(rt);
          if (lt) {
            var ct = lt.call(rt), ft;
            if (lt !== rt.entries) {
              for (; !(ft = ct.next()).done; )
                if (!bt(ft.value))
                  return !1;
            } else
              for (; !(ft = ct.next()).done; ) {
                var pt = ft.value;
                if (pt && !bt(pt[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function wt(rt, lt) {
      return rt === "symbol" ? !0 : lt ? lt["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && lt instanceof Symbol : !1;
    }
    function Ot(rt) {
      var lt = typeof rt;
      return Array.isArray(rt) ? "array" : rt instanceof RegExp ? "object" : wt(lt, rt) ? "symbol" : lt;
    }
    function yt(rt) {
      if (typeof rt > "u" || rt === null)
        return "" + rt;
      var lt = Ot(rt);
      if (lt === "object") {
        if (rt instanceof Date)
          return "date";
        if (rt instanceof RegExp)
          return "regexp";
      }
      return lt;
    }
    function Qe(rt) {
      var lt = yt(rt);
      switch (lt) {
        case "array":
        case "object":
          return "an " + lt;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + lt;
        default:
          return lt;
      }
    }
    function nt(rt) {
      return !rt.constructor || !rt.constructor.name ? Ue : rt.constructor.name;
    }
    return Le.checkPropTypes = h, Le.resetWarningCache = h.resetWarningCache, Le.PropTypes = Le, Le;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var o = requireReactPropTypesSecret();
  function s() {
  }
  function u() {
  }
  return u.resetWarningCache = s, factoryWithThrowingShims = function() {
    function l(C, O, le, We, ye, Fe) {
      if (Fe !== o) {
        var Ue = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw Ue.name = "Invariant Violation", Ue;
      }
    }
    l.isRequired = l;
    function h() {
      return l;
    }
    var m = {
      array: l,
      bigint: l,
      bool: l,
      func: l,
      number: l,
      object: l,
      string: l,
      symbol: l,
      any: l,
      arrayOf: h,
      element: l,
      elementType: l,
      instanceOf: h,
      node: l,
      objectOf: h,
      oneOf: h,
      oneOfType: h,
      shape: h,
      exact: h,
      checkPropTypes: u,
      resetWarningCache: s
    };
    return m.PropTypes = m, m;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = reactIsExports$1, throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function ownKeys$1(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread2$1(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys$1(Object(u), !0).forEach(function(l) {
      _defineProperty$1(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys$1(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
function _typeof$1(o) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
    return typeof s;
  } : function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof$1(o);
}
function _defineProperty$1(o, s, u) {
  return s in o ? Object.defineProperty(o, s, {
    value: u,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[s] = u, o;
}
function _objectWithoutPropertiesLoose$1(o, s) {
  if (o == null)
    return {};
  var u = {}, l = Object.keys(o), h, m;
  for (m = 0; m < l.length; m++)
    h = l[m], !(s.indexOf(h) >= 0) && (u[h] = o[h]);
  return u;
}
function _objectWithoutProperties$1(o, s) {
  if (o == null)
    return {};
  var u = _objectWithoutPropertiesLoose$1(o, s), l, h;
  if (Object.getOwnPropertySymbols) {
    var m = Object.getOwnPropertySymbols(o);
    for (h = 0; h < m.length; h++)
      l = m[h], !(s.indexOf(l) >= 0) && Object.prototype.propertyIsEnumerable.call(o, l) && (u[l] = o[l]);
  }
  return u;
}
function _toConsumableArray(o) {
  return _arrayWithoutHoles(o) || _iterableToArray(o) || _unsupportedIterableToArray$1(o) || _nonIterableSpread();
}
function _arrayWithoutHoles(o) {
  if (Array.isArray(o))
    return _arrayLikeToArray$1(o);
}
function _iterableToArray(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null)
    return Array.from(o);
}
function _unsupportedIterableToArray$1(o, s) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray$1(o, s);
    var u = Object.prototype.toString.call(o).slice(8, -1);
    if (u === "Object" && o.constructor && (u = o.constructor.name), u === "Map" || u === "Set")
      return Array.from(o);
    if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
      return _arrayLikeToArray$1(o, s);
  }
}
function _arrayLikeToArray$1(o, s) {
  (s == null || s > o.length) && (s = o.length);
  for (var u = 0, l = new Array(s); u < s; u++)
    l[u] = o[u];
  return l;
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function classList(o) {
  var s, u = o.beat, l = o.fade, h = o.beatFade, m = o.bounce, C = o.shake, O = o.flash, le = o.spin, We = o.spinPulse, ye = o.spinReverse, Fe = o.pulse, Ue = o.fixedWidth, Le = o.inverse, Ze = o.border, Xe = o.listItem, Je = o.flip, it = o.size, et = o.rotation, at = o.pull, $e = (s = {
    "fa-beat": u,
    "fa-fade": l,
    "fa-beat-fade": h,
    "fa-bounce": m,
    "fa-shake": C,
    "fa-flash": O,
    "fa-spin": le,
    "fa-spin-reverse": ye,
    "fa-spin-pulse": We,
    "fa-pulse": Fe,
    "fa-fw": Ue,
    "fa-inverse": Le,
    "fa-border": Ze,
    "fa-li": Xe,
    "fa-flip": Je === !0,
    "fa-flip-horizontal": Je === "horizontal" || Je === "both",
    "fa-flip-vertical": Je === "vertical" || Je === "both"
  }, _defineProperty$1(s, "fa-".concat(it), typeof it < "u" && it !== null), _defineProperty$1(s, "fa-rotate-".concat(et), typeof et < "u" && et !== null && et !== 0), _defineProperty$1(s, "fa-pull-".concat(at), typeof at < "u" && at !== null), _defineProperty$1(s, "fa-swap-opacity", o.swapOpacity), s);
  return Object.keys($e).map(function(Ke) {
    return $e[Ke] ? Ke : null;
  }).filter(function(Ke) {
    return Ke;
  });
}
function _isNumerical(o) {
  return o = o - 0, o === o;
}
function camelize(o) {
  return _isNumerical(o) ? o : (o = o.replace(/[\-_\s]+(.)?/g, function(s, u) {
    return u ? u.toUpperCase() : "";
  }), o.substr(0, 1).toLowerCase() + o.substr(1));
}
var _excluded = ["style"];
function capitalize(o) {
  return o.charAt(0).toUpperCase() + o.slice(1);
}
function styleToObject(o) {
  return o.split(";").map(function(s) {
    return s.trim();
  }).filter(function(s) {
    return s;
  }).reduce(function(s, u) {
    var l = u.indexOf(":"), h = camelize(u.slice(0, l)), m = u.slice(l + 1).trim();
    return h.startsWith("webkit") ? s[capitalize(h)] = m : s[h] = m, s;
  }, {});
}
function convert(o, s) {
  var u = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof s == "string")
    return s;
  var l = (s.children || []).map(function(le) {
    return convert(o, le);
  }), h = Object.keys(s.attributes || {}).reduce(function(le, We) {
    var ye = s.attributes[We];
    switch (We) {
      case "class":
        le.attrs.className = ye, delete s.attributes.class;
        break;
      case "style":
        le.attrs.style = styleToObject(ye);
        break;
      default:
        We.indexOf("aria-") === 0 || We.indexOf("data-") === 0 ? le.attrs[We.toLowerCase()] = ye : le.attrs[camelize(We)] = ye;
    }
    return le;
  }, {
    attrs: {}
  }), m = u.style, C = m === void 0 ? {} : m, O = _objectWithoutProperties$1(u, _excluded);
  return h.attrs.style = _objectSpread2$1(_objectSpread2$1({}, h.attrs.style), C), o.apply(void 0, [s.tag, _objectSpread2$1(_objectSpread2$1({}, h.attrs), O)].concat(_toConsumableArray(l)));
}
var PRODUCTION = !1;
try {
  PRODUCTION = process.env.NODE_ENV === "production";
} catch {
}
function log() {
  if (!PRODUCTION && console && typeof console.error == "function") {
    var o;
    (o = console).error.apply(o, arguments);
  }
}
function normalizeIconArgs(o) {
  if (o && _typeof$1(o) === "object" && o.prefix && o.iconName && o.icon)
    return o;
  if (parse$1.icon)
    return parse$1.icon(o);
  if (o === null)
    return null;
  if (o && _typeof$1(o) === "object" && o.prefix && o.iconName)
    return o;
  if (Array.isArray(o) && o.length === 2)
    return {
      prefix: o[0],
      iconName: o[1]
    };
  if (typeof o == "string")
    return {
      prefix: "fas",
      iconName: o
    };
}
function objectWithKey(o, s) {
  return Array.isArray(s) && s.length > 0 || !Array.isArray(s) && s ? _defineProperty$1({}, o, s) : {};
}
var defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
}, FontAwesomeIcon = /* @__PURE__ */ React$1.forwardRef(function(o, s) {
  var u = _objectSpread2$1(_objectSpread2$1({}, defaultProps), o), l = u.icon, h = u.mask, m = u.symbol, C = u.className, O = u.title, le = u.titleId, We = u.maskId, ye = normalizeIconArgs(l), Fe = objectWithKey("classes", [].concat(_toConsumableArray(classList(u)), _toConsumableArray((C || "").split(" ")))), Ue = objectWithKey("transform", typeof u.transform == "string" ? parse$1.transform(u.transform) : u.transform), Le = objectWithKey("mask", normalizeIconArgs(h)), Ze = icon(ye, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, Fe), Ue), Le), {}, {
    symbol: m,
    title: O,
    titleId: le,
    maskId: We
  }));
  if (!Ze)
    return log("Could not find icon", ye), null;
  var Xe = Ze.abstract, Je = {
    ref: s
  };
  return Object.keys(u).forEach(function(it) {
    defaultProps.hasOwnProperty(it) || (Je[it] = u[it]);
  }), convertCurry(Xe[0], Je);
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  beatFade: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
var convertCurry = convert.bind(null, React$1.createElement);
const PdfLoader = ({
  description: o,
  className: s,
  color: u
}) => /* @__PURE__ */ jsxs(motion.div, {
  style: {
    height: "100%",
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  initial: {
    opacity: 1
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  className: s,
  children: [/* @__PURE__ */ jsx(FontAwesomeIcon, {
    style: {
      fontWeight: "300",
      textAlign: "center",
      color: u
    },
    icon: ["fal", "spinner"],
    pulse: !0
  }), o && /* @__PURE__ */ jsx("p", {
    style: {
      fontSize: "14px",
      textAlign: "center"
    },
    children: o
  })]
}), calculateElementSizeInContainer$1 = (o, s, u, l, h) => {
  const m = u / l;
  let C, O;
  return u > l ? (h === "fill" ? C = Math.ceil(Math.max(s * m, o)) : C = Math.ceil(Math.min(s * m, o)), O = Math.ceil(C / m)) : (h === "fill" ? O = Math.ceil(Math.max(o / m, s)) : O = Math.ceil(Math.min(o / m, s)), C = Math.ceil(O * m)), {
    idealWidth: C,
    idealHeight: O
  };
}, getBackendGeneratedHeights = () => [200, 250, 300, 400, 800, 1080, 1600, 2160];
var axios$3 = {
  exports: {}
}, bind$2 = function(s, u) {
  return function() {
    for (var h = new Array(arguments.length), m = 0; m < h.length; m++)
      h[m] = arguments[m];
    return s.apply(u, h);
  };
}, bind$1 = bind$2, toString = Object.prototype.toString;
function isArray(o) {
  return toString.call(o) === "[object Array]";
}
function isUndefined(o) {
  return typeof o > "u";
}
function isBuffer(o) {
  return o !== null && !isUndefined(o) && o.constructor !== null && !isUndefined(o.constructor) && typeof o.constructor.isBuffer == "function" && o.constructor.isBuffer(o);
}
function isArrayBuffer(o) {
  return toString.call(o) === "[object ArrayBuffer]";
}
function isFormData(o) {
  return typeof FormData < "u" && o instanceof FormData;
}
function isArrayBufferView(o) {
  var s;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? s = ArrayBuffer.isView(o) : s = o && o.buffer && o.buffer instanceof ArrayBuffer, s;
}
function isString(o) {
  return typeof o == "string";
}
function isNumber(o) {
  return typeof o == "number";
}
function isObject(o) {
  return o !== null && typeof o == "object";
}
function isDate(o) {
  return toString.call(o) === "[object Date]";
}
function isFile(o) {
  return toString.call(o) === "[object File]";
}
function isBlob(o) {
  return toString.call(o) === "[object Blob]";
}
function isFunction(o) {
  return toString.call(o) === "[object Function]";
}
function isStream(o) {
  return isObject(o) && isFunction(o.pipe);
}
function isURLSearchParams(o) {
  return typeof URLSearchParams < "u" && o instanceof URLSearchParams;
}
function trim(o) {
  return o.replace(/^\s*/, "").replace(/\s*$/, "");
}
function isStandardBrowserEnv() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function forEach(o, s) {
  if (!(o === null || typeof o > "u"))
    if (typeof o != "object" && (o = [o]), isArray(o))
      for (var u = 0, l = o.length; u < l; u++)
        s.call(null, o[u], u, o);
    else
      for (var h in o)
        Object.prototype.hasOwnProperty.call(o, h) && s.call(null, o[h], h, o);
}
function merge() {
  var o = {};
  function s(h, m) {
    typeof o[m] == "object" && typeof h == "object" ? o[m] = merge(o[m], h) : o[m] = h;
  }
  for (var u = 0, l = arguments.length; u < l; u++)
    forEach(arguments[u], s);
  return o;
}
function deepMerge() {
  var o = {};
  function s(h, m) {
    typeof o[m] == "object" && typeof h == "object" ? o[m] = deepMerge(o[m], h) : typeof h == "object" ? o[m] = deepMerge({}, h) : o[m] = h;
  }
  for (var u = 0, l = arguments.length; u < l; u++)
    forEach(arguments[u], s);
  return o;
}
function extend(o, s, u) {
  return forEach(s, function(h, m) {
    u && typeof h == "function" ? o[m] = bind$1(h, u) : o[m] = h;
  }), o;
}
var utils$9 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  deepMerge,
  extend,
  trim
}, utils$8 = utils$9;
function encode(o) {
  return encodeURIComponent(o).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function(s, u, l) {
  if (!u)
    return s;
  var h;
  if (l)
    h = l(u);
  else if (utils$8.isURLSearchParams(u))
    h = u.toString();
  else {
    var m = [];
    utils$8.forEach(u, function(le, We) {
      le === null || typeof le > "u" || (utils$8.isArray(le) ? We = We + "[]" : le = [le], utils$8.forEach(le, function(Fe) {
        utils$8.isDate(Fe) ? Fe = Fe.toISOString() : utils$8.isObject(Fe) && (Fe = JSON.stringify(Fe)), m.push(encode(We) + "=" + encode(Fe));
      }));
    }), h = m.join("&");
  }
  if (h) {
    var C = s.indexOf("#");
    C !== -1 && (s = s.slice(0, C)), s += (s.indexOf("?") === -1 ? "?" : "&") + h;
  }
  return s;
}, utils$7 = utils$9;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function(s, u) {
  return this.handlers.push({
    fulfilled: s,
    rejected: u
  }), this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function(s) {
  this.handlers[s] && (this.handlers[s] = null);
};
InterceptorManager$1.prototype.forEach = function(s) {
  utils$7.forEach(this.handlers, function(l) {
    l !== null && s(l);
  });
};
var InterceptorManager_1 = InterceptorManager$1, utils$6 = utils$9, transformData$1 = function(s, u, l) {
  return utils$6.forEach(l, function(m) {
    s = m(s, u);
  }), s;
}, isCancel$1, hasRequiredIsCancel;
function requireIsCancel() {
  return hasRequiredIsCancel || (hasRequiredIsCancel = 1, isCancel$1 = function(s) {
    return !!(s && s.__CANCEL__);
  }), isCancel$1;
}
var utils$5 = utils$9, normalizeHeaderName$1 = function(s, u) {
  utils$5.forEach(s, function(h, m) {
    m !== u && m.toUpperCase() === u.toUpperCase() && (s[u] = h, delete s[m]);
  });
}, enhanceError, hasRequiredEnhanceError;
function requireEnhanceError() {
  return hasRequiredEnhanceError || (hasRequiredEnhanceError = 1, enhanceError = function(s, u, l, h, m) {
    return s.config = u, l && (s.code = l), s.request = h, s.response = m, s.isAxiosError = !0, s.toJSON = function() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code
      };
    }, s;
  }), enhanceError;
}
var createError, hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var o = requireEnhanceError();
  return createError = function(u, l, h, m, C) {
    var O = new Error(u);
    return o(O, l, h, m, C);
  }, createError;
}
var settle, hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var o = requireCreateError();
  return settle = function(u, l, h) {
    var m = h.config.validateStatus;
    !m || m(h.status) ? u(h) : l(o("Request failed with status code " + h.status, h.config, null, h.request, h));
  }, settle;
}
var isAbsoluteURL, hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  return hasRequiredIsAbsoluteURL || (hasRequiredIsAbsoluteURL = 1, isAbsoluteURL = function(s) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(s);
  }), isAbsoluteURL;
}
var combineURLs, hasRequiredCombineURLs;
function requireCombineURLs() {
  return hasRequiredCombineURLs || (hasRequiredCombineURLs = 1, combineURLs = function(s, u) {
    return u ? s.replace(/\/+$/, "") + "/" + u.replace(/^\/+/, "") : s;
  }), combineURLs;
}
var buildFullPath, hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var o = requireIsAbsoluteURL(), s = requireCombineURLs();
  return buildFullPath = function(l, h) {
    return l && !o(h) ? s(l, h) : h;
  }, buildFullPath;
}
var parseHeaders, hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var o = utils$9, s = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];
  return parseHeaders = function(l) {
    var h = {}, m, C, O;
    return l && o.forEach(l.split(`
`), function(We) {
      if (O = We.indexOf(":"), m = o.trim(We.substr(0, O)).toLowerCase(), C = o.trim(We.substr(O + 1)), m) {
        if (h[m] && s.indexOf(m) >= 0)
          return;
        m === "set-cookie" ? h[m] = (h[m] ? h[m] : []).concat([C]) : h[m] = h[m] ? h[m] + ", " + C : C;
      }
    }), h;
  }, parseHeaders;
}
var isURLSameOrigin, hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var o = utils$9;
  return isURLSameOrigin = o.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var u = /(msie|trident)/i.test(navigator.userAgent), l = document.createElement("a"), h;
      function m(C) {
        var O = C;
        return u && (l.setAttribute("href", O), O = l.href), l.setAttribute("href", O), {
          href: l.href,
          protocol: l.protocol ? l.protocol.replace(/:$/, "") : "",
          host: l.host,
          search: l.search ? l.search.replace(/^\?/, "") : "",
          hash: l.hash ? l.hash.replace(/^#/, "") : "",
          hostname: l.hostname,
          port: l.port,
          pathname: l.pathname.charAt(0) === "/" ? l.pathname : "/" + l.pathname
        };
      }
      return h = m(window.location.href), function(O) {
        var le = o.isString(O) ? m(O) : O;
        return le.protocol === h.protocol && le.host === h.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), isURLSameOrigin;
}
var cookies, hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var o = utils$9;
  return cookies = o.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(l, h, m, C, O, le) {
          var We = [];
          We.push(l + "=" + encodeURIComponent(h)), o.isNumber(m) && We.push("expires=" + new Date(m).toGMTString()), o.isString(C) && We.push("path=" + C), o.isString(O) && We.push("domain=" + O), le === !0 && We.push("secure"), document.cookie = We.join("; ");
        },
        read: function(l) {
          var h = document.cookie.match(new RegExp("(^|;\\s*)(" + l + ")=([^;]*)"));
          return h ? decodeURIComponent(h[3]) : null;
        },
        remove: function(l) {
          this.write(l, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cookies;
}
var xhr, hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var o = utils$9, s = requireSettle(), u = buildURL$1, l = requireBuildFullPath(), h = requireParseHeaders(), m = requireIsURLSameOrigin(), C = requireCreateError();
  return xhr = function(le) {
    return new Promise(function(ye, Fe) {
      var Ue = le.data, Le = le.headers;
      o.isFormData(Ue) && delete Le["Content-Type"];
      var Ze = new XMLHttpRequest();
      if (le.auth) {
        var Xe = le.auth.username || "", Je = le.auth.password || "";
        Le.Authorization = "Basic " + btoa(Xe + ":" + Je);
      }
      var it = l(le.baseURL, le.url);
      if (Ze.open(le.method.toUpperCase(), u(it, le.params, le.paramsSerializer), !0), Ze.timeout = le.timeout, Ze.onreadystatechange = function() {
        if (!(!Ze || Ze.readyState !== 4) && !(Ze.status === 0 && !(Ze.responseURL && Ze.responseURL.indexOf("file:") === 0))) {
          var Ke = "getAllResponseHeaders" in Ze ? h(Ze.getAllResponseHeaders()) : null, tt = !le.responseType || le.responseType === "text" ? Ze.responseText : Ze.response, ut = {
            data: tt,
            status: Ze.status,
            statusText: Ze.statusText,
            headers: Ke,
            config: le,
            request: Ze
          };
          s(ye, Fe, ut), Ze = null;
        }
      }, Ze.onabort = function() {
        Ze && (Fe(C("Request aborted", le, "ECONNABORTED", Ze)), Ze = null);
      }, Ze.onerror = function() {
        Fe(C("Network Error", le, null, Ze)), Ze = null;
      }, Ze.ontimeout = function() {
        var Ke = "timeout of " + le.timeout + "ms exceeded";
        le.timeoutErrorMessage && (Ke = le.timeoutErrorMessage), Fe(C(Ke, le, "ECONNABORTED", Ze)), Ze = null;
      }, o.isStandardBrowserEnv()) {
        var et = requireCookies(), at = (le.withCredentials || m(it)) && le.xsrfCookieName ? et.read(le.xsrfCookieName) : void 0;
        at && (Le[le.xsrfHeaderName] = at);
      }
      if ("setRequestHeader" in Ze && o.forEach(Le, function(Ke, tt) {
        typeof Ue > "u" && tt.toLowerCase() === "content-type" ? delete Le[tt] : Ze.setRequestHeader(tt, Ke);
      }), o.isUndefined(le.withCredentials) || (Ze.withCredentials = !!le.withCredentials), le.responseType)
        try {
          Ze.responseType = le.responseType;
        } catch ($e) {
          if (le.responseType !== "json")
            throw $e;
        }
      typeof le.onDownloadProgress == "function" && Ze.addEventListener("progress", le.onDownloadProgress), typeof le.onUploadProgress == "function" && Ze.upload && Ze.upload.addEventListener("progress", le.onUploadProgress), le.cancelToken && le.cancelToken.promise.then(function(Ke) {
        Ze && (Ze.abort(), Fe(Ke), Ze = null);
      }), Ue === void 0 && (Ue = null), Ze.send(Ue);
    });
  }, xhr;
}
var utils$4 = utils$9, normalizeHeaderName = normalizeHeaderName$1, DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(o, s) {
  !utils$4.isUndefined(o) && utils$4.isUndefined(o["Content-Type"]) && (o["Content-Type"] = s);
}
function getDefaultAdapter() {
  var o;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (o = requireXhr()), o;
}
var defaults$2 = {
  adapter: getDefaultAdapter(),
  transformRequest: [function(s, u) {
    return normalizeHeaderName(u, "Accept"), normalizeHeaderName(u, "Content-Type"), utils$4.isFormData(s) || utils$4.isArrayBuffer(s) || utils$4.isBuffer(s) || utils$4.isStream(s) || utils$4.isFile(s) || utils$4.isBlob(s) ? s : utils$4.isArrayBufferView(s) ? s.buffer : utils$4.isURLSearchParams(s) ? (setContentTypeIfUnset(u, "application/x-www-form-urlencoded;charset=utf-8"), s.toString()) : utils$4.isObject(s) ? (setContentTypeIfUnset(u, "application/json;charset=utf-8"), JSON.stringify(s)) : s;
  }],
  transformResponse: [function(s) {
    if (typeof s == "string")
      try {
        s = JSON.parse(s);
      } catch {
      }
    return s;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  validateStatus: function(s) {
    return s >= 200 && s < 300;
  }
};
defaults$2.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
utils$4.forEach(["delete", "get", "head"], function(s) {
  defaults$2.headers[s] = {};
});
utils$4.forEach(["post", "put", "patch"], function(s) {
  defaults$2.headers[s] = utils$4.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$2, utils$3 = utils$9, transformData = transformData$1, isCancel = requireIsCancel(), defaults$1 = defaults_1;
function throwIfCancellationRequested(o) {
  o.cancelToken && o.cancelToken.throwIfRequested();
}
var dispatchRequest$1 = function(s) {
  throwIfCancellationRequested(s), s.headers = s.headers || {}, s.data = transformData(s.data, s.headers, s.transformRequest), s.headers = utils$3.merge(s.headers.common || {}, s.headers[s.method] || {}, s.headers), utils$3.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function(h) {
    delete s.headers[h];
  });
  var u = s.adapter || defaults$1.adapter;
  return u(s).then(function(h) {
    return throwIfCancellationRequested(s), h.data = transformData(h.data, h.headers, s.transformResponse), h;
  }, function(h) {
    return isCancel(h) || (throwIfCancellationRequested(s), h && h.response && (h.response.data = transformData(h.response.data, h.response.headers, s.transformResponse))), Promise.reject(h);
  });
}, utils$2 = utils$9, mergeConfig$2 = function(s, u) {
  u = u || {};
  var l = {}, h = ["url", "method", "params", "data"], m = ["headers", "auth", "proxy"], C = ["baseURL", "url", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"];
  utils$2.forEach(h, function(ye) {
    typeof u[ye] < "u" && (l[ye] = u[ye]);
  }), utils$2.forEach(m, function(ye) {
    utils$2.isObject(u[ye]) ? l[ye] = utils$2.deepMerge(s[ye], u[ye]) : typeof u[ye] < "u" ? l[ye] = u[ye] : utils$2.isObject(s[ye]) ? l[ye] = utils$2.deepMerge(s[ye]) : typeof s[ye] < "u" && (l[ye] = s[ye]);
  }), utils$2.forEach(C, function(ye) {
    typeof u[ye] < "u" ? l[ye] = u[ye] : typeof s[ye] < "u" && (l[ye] = s[ye]);
  });
  var O = h.concat(m).concat(C), le = Object.keys(u).filter(function(ye) {
    return O.indexOf(ye) === -1;
  });
  return utils$2.forEach(le, function(ye) {
    typeof u[ye] < "u" ? l[ye] = u[ye] : typeof s[ye] < "u" && (l[ye] = s[ye]);
  }), l;
}, utils$1 = utils$9, buildURL = buildURL$1, InterceptorManager = InterceptorManager_1, dispatchRequest = dispatchRequest$1, mergeConfig$1 = mergeConfig$2;
function Axios$1(o) {
  this.defaults = o, this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function(s) {
  typeof s == "string" ? (s = arguments[1] || {}, s.url = arguments[0]) : s = s || {}, s = mergeConfig$1(this.defaults, s), s.method ? s.method = s.method.toLowerCase() : this.defaults.method ? s.method = this.defaults.method.toLowerCase() : s.method = "get";
  var u = [dispatchRequest, void 0], l = Promise.resolve(s);
  for (this.interceptors.request.forEach(function(m) {
    u.unshift(m.fulfilled, m.rejected);
  }), this.interceptors.response.forEach(function(m) {
    u.push(m.fulfilled, m.rejected);
  }); u.length; )
    l = l.then(u.shift(), u.shift());
  return l;
};
Axios$1.prototype.getUri = function(s) {
  return s = mergeConfig$1(this.defaults, s), buildURL(s.url, s.params, s.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function(s) {
  Axios$1.prototype[s] = function(u, l) {
    return this.request(utils$1.merge(l || {}, {
      method: s,
      url: u
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function(s) {
  Axios$1.prototype[s] = function(u, l, h) {
    return this.request(utils$1.merge(h || {}, {
      method: s,
      url: u,
      data: l
    }));
  };
});
var Axios_1 = Axios$1, Cancel_1, hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function o(s) {
    this.message = s;
  }
  return o.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, o.prototype.__CANCEL__ = !0, Cancel_1 = o, Cancel_1;
}
var CancelToken_1, hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var o = requireCancel();
  function s(u) {
    if (typeof u != "function")
      throw new TypeError("executor must be a function.");
    var l;
    this.promise = new Promise(function(C) {
      l = C;
    });
    var h = this;
    u(function(C) {
      h.reason || (h.reason = new o(C), l(h.reason));
    });
  }
  return s.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, s.source = function() {
    var l, h = new s(function(C) {
      l = C;
    });
    return {
      token: h,
      cancel: l
    };
  }, CancelToken_1 = s, CancelToken_1;
}
var spread, hasRequiredSpread;
function requireSpread() {
  return hasRequiredSpread || (hasRequiredSpread = 1, spread = function(s) {
    return function(l) {
      return s.apply(null, l);
    };
  }), spread;
}
var utils = utils$9, bind = bind$2, Axios = Axios_1, mergeConfig = mergeConfig$2, defaults = defaults_1;
function createInstance(o) {
  var s = new Axios(o), u = bind(Axios.prototype.request, s);
  return utils.extend(u, Axios.prototype, s), utils.extend(u, s), u;
}
var axios$2 = createInstance(defaults);
axios$2.Axios = Axios;
axios$2.create = function(s) {
  return createInstance(mergeConfig(axios$2.defaults, s));
};
axios$2.Cancel = requireCancel();
axios$2.CancelToken = requireCancelToken();
axios$2.isCancel = requireIsCancel();
axios$2.all = function(s) {
  return Promise.all(s);
};
axios$2.spread = requireSpread();
axios$3.exports = axios$2;
axios$3.exports.default = axios$2;
var axiosExports = axios$3.exports, axios = axiosExports;
const axios$1 = /* @__PURE__ */ getDefaultExportFromCjs(axios), clamp = (o, s, u) => Math.max(Math.min(o, u), s), calculateElementSizeInContainer = (o, s, u, l, h) => {
  const m = u / l;
  let C, O;
  return u > l ? (h === "fill" ? C = Math.ceil(Math.max(s * m, o)) : C = Math.ceil(Math.min(s * m, o)), O = Math.ceil(C / m)) : (h === "fill" ? O = Math.ceil(Math.max(o / m, s)) : O = Math.ceil(Math.min(o / m, s)), C = Math.ceil(O * m)), {
    idealWidth: C,
    idealHeight: O
  };
}, downloadBinaryWithProvidedFileName = (o, s) => {
  o && axios$1({
    url: o,
    method: "GET",
    responseType: "blob"
  }).then((u) => {
    const l = window.URL.createObjectURL(new Blob([u.data])), h = document.createElement("a");
    h.href = l, h.setAttribute("download", s ?? ""), document.body.appendChild(h), h.click(), document.body.removeChild(h);
  });
};
var lib = {}, uaParser_min = {
  exports: {}
};
(function(o, s) {
  (function(u, l) {
    var h = "1.0.40", m = "", C = "?", O = "function", le = "undefined", We = "object", ye = "string", Fe = "major", Ue = "model", Le = "name", Ze = "type", Xe = "vendor", Je = "version", it = "architecture", et = "console", at = "mobile", $e = "tablet", Ke = "smarttv", tt = "wearable", ut = "embedded", st = 500, ot = "Amazon", ht = "Apple", vt = "ASUS", At = "BlackBerry", gt = "Browser", bt = "Chrome", wt = "Edge", Ot = "Firefox", yt = "Google", Qe = "Huawei", nt = "LG", rt = "Microsoft", lt = "Motorola", ct = "Opera", ft = "Samsung", pt = "Sharp", mt = "Sony", dt = "Xiaomi", Et = "Zebra", Ct = "Facebook", Tt = "Chromium OS", qt = "Mac OS", jt = " Browser", St = function(Vt, Yt) {
      var Rt = {};
      for (var kt in Vt)
        Yt[kt] && Yt[kt].length % 2 === 0 ? Rt[kt] = Yt[kt].concat(Vt[kt]) : Rt[kt] = Vt[kt];
      return Rt;
    }, Mt = function(Vt) {
      for (var Yt = {}, Rt = 0; Rt < Vt.length; Rt++)
        Yt[Vt[Rt].toUpperCase()] = Vt[Rt];
      return Yt;
    }, Dt = function(Vt, Yt) {
      return typeof Vt === ye ? Nt(Yt).indexOf(Nt(Vt)) !== -1 : !1;
    }, Nt = function(Vt) {
      return Vt.toLowerCase();
    }, Kt = function(Vt) {
      return typeof Vt === ye ? Vt.replace(/[^\d\.]/g, m).split(".")[0] : l;
    }, Ft = function(Vt, Yt) {
      if (typeof Vt === ye)
        return Vt = Vt.replace(/^\s\s*/, m), typeof Yt === le ? Vt : Vt.substring(0, st);
    }, Bt = function(Vt, Yt) {
      for (var Rt = 0, kt, Zt, Wt, xt, It, Pt; Rt < Yt.length && !It; ) {
        var Lt = Yt[Rt], Ut = Yt[Rt + 1];
        for (kt = Zt = 0; kt < Lt.length && !It && Lt[kt]; )
          if (It = Lt[kt++].exec(Vt), It)
            for (Wt = 0; Wt < Ut.length; Wt++)
              Pt = It[++Zt], xt = Ut[Wt], typeof xt === We && xt.length > 0 ? xt.length === 2 ? typeof xt[1] == O ? this[xt[0]] = xt[1].call(this, Pt) : this[xt[0]] = xt[1] : xt.length === 3 ? typeof xt[1] === O && !(xt[1].exec && xt[1].test) ? this[xt[0]] = Pt ? xt[1].call(this, Pt, xt[2]) : l : this[xt[0]] = Pt ? Pt.replace(xt[1], xt[2]) : l : xt.length === 4 && (this[xt[0]] = Pt ? xt[3].call(this, Pt.replace(xt[1], xt[2])) : l) : this[xt] = Pt || l;
        Rt += 2;
      }
    }, $t = function(Vt, Yt) {
      for (var Rt in Yt)
        if (typeof Yt[Rt] === We && Yt[Rt].length > 0) {
          for (var kt = 0; kt < Yt[Rt].length; kt++)
            if (Dt(Yt[Rt][kt], Vt))
              return Rt === C ? l : Rt;
        } else if (Dt(Yt[Rt], Vt))
          return Rt === C ? l : Rt;
      return Yt.hasOwnProperty("*") ? Yt["*"] : Vt;
    }, Gt = {
      "1.0": "/8",
      1.2: "/1",
      1.3: "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, Jt = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      8.1: "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, er = {
      browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [Je, [Le, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [Je, [Le, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [Le, Je], [/opios[\/ ]+([\w\.]+)/i], [Je, [Le, ct + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [Je, [Le, ct + " GX"]], [/\bopr\/([\w\.]+)/i], [Je, [Le, ct]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [Je, [Le, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i], [Je, [Le, "Maxthon"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i, /(heytap|ovi|115)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [Le, Je], [/quark(?:pc)?\/([-\w\.]+)/i], [Je, [Le, "Quark"]], [/\bddg\/([\w\.]+)/i], [Je, [Le, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [Je, [Le, "UC" + gt]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [Je, [Le, "WeChat"]], [/konqueror\/([\w\.]+)/i], [Je, [Le, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [Je, [Le, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [Je, [Le, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [Je, [Le, "Smart Lenovo " + gt]], [/(avast|avg)\/([\w\.]+)/i], [[Le, /(.+)/, "$1 Secure " + gt], Je], [/\bfocus\/([\w\.]+)/i], [Je, [Le, Ot + " Focus"]], [/\bopt\/([\w\.]+)/i], [Je, [Le, ct + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [Je, [Le, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [Je, [Le, "Dolphin"]], [/coast\/([\w\.]+)/i], [Je, [Le, ct + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [Je, [Le, "MIUI" + jt]], [/fxios\/([\w\.-]+)/i], [Je, [Le, Ot]], [/\bqihoobrowser\/?([\w\.]*)/i], [Je, [Le, "360"]], [/\b(qq)\/([\w\.]+)/i], [[Le, /(.+)/, "$1Browser"], Je], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[Le, /(.+)/, "$1" + jt], Je], [/samsungbrowser\/([\w\.]+)/i], [Je, [Le, ft + " Internet"]], [/metasr[\/ ]?([\d\.]+)/i], [Je, [Le, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[Le, "Sogou Mobile"], Je], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i], [Le, Je], [/(lbbrowser|rekonq)/i, /\[(linkedin)app\]/i], [Le], [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i], [Je, Le], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[Le, Ct], Je], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [Le, Je], [/\bgsa\/([\w\.]+) .*safari\//i], [Je, [Le, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [Je, [Le, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [Je, [Le, bt + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[Le, bt + " WebView"], Je], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [Je, [Le, "Android " + gt]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [Le, Je], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [Je, [Le, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [Je, Le], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [Le, [Je, $t, Gt]], [/(webkit|khtml)\/([\w\.]+)/i], [Le, Je], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[Le, "Netscape"], Je], [/(wolvic|librewolf)\/([\w\.]+)/i], [Le, Je], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [Je, [Le, Ot + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [Le, [Je, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i], [Le, [Je, /master.|lts./, ""]]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[it, "amd64"]], [/(ia32(?=;))/i], [[it, Nt]], [/((?:i[346]|x)86)[;\)]/i], [[it, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[it, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[it, "armhf"]], [/windows (ce|mobile); ppc;/i], [[it, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[it, /ower/, m, Nt]], [/(sun4\w)[;\)]/i], [[it, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[it, Nt]]],
      device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [Ue, [Xe, ft], [Ze, $e]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [Ue, [Xe, ft], [Ze, at]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [Ue, [Xe, ht], [Ze, at]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [Ue, [Xe, ht], [Ze, $e]], [/(macintosh);/i], [Ue, [Xe, ht]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [Ue, [Xe, pt], [Ze, at]], [/(?:honor)([-\w ]+)[;\)]/i], [Ue, [Xe, "Honor"], [Ze, at]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [Ue, [Xe, Qe], [Ze, $e]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [Ue, [Xe, Qe], [Ze, at]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i], [[Ue, /_/g, " "], [Xe, dt], [Ze, at]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[Ue, /_/g, " "], [Xe, dt], [Ze, $e]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [Ue, [Xe, "OPPO"], [Ze, at]], [/\b(opd2\d{3}a?) bui/i], [Ue, [Xe, "OPPO"], [Ze, $e]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [Ue, [Xe, "Vivo"], [Ze, at]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [Ue, [Xe, "Realme"], [Ze, at]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [Ue, [Xe, lt], [Ze, at]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [Ue, [Xe, lt], [Ze, $e]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [Ue, [Xe, nt], [Ze, $e]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [Ue, [Xe, nt], [Ze, at]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [Ue, [Xe, "Lenovo"], [Ze, $e]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[Ue, /_/g, " "], [Xe, "Nokia"], [Ze, at]], [/(pixel c)\b/i], [Ue, [Xe, yt], [Ze, $e]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [Ue, [Xe, yt], [Ze, at]], [/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [Ue, [Xe, mt], [Ze, at]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[Ue, "Xperia Tablet"], [Xe, mt], [Ze, $e]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [Ue, [Xe, "OnePlus"], [Ze, at]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [Ue, [Xe, ot], [Ze, $e]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[Ue, /(.+)/g, "Fire Phone $1"], [Xe, ot], [Ze, at]], [/(playbook);[-\w\),; ]+(rim)/i], [Ue, Xe, [Ze, $e]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [Ue, [Xe, At], [Ze, at]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [Ue, [Xe, vt], [Ze, $e]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [Ue, [Xe, vt], [Ze, at]], [/(nexus 9)/i], [Ue, [Xe, "HTC"], [Ze, $e]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [Xe, [Ue, /_/g, " "], [Ze, at]], [/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i], [Ue, [Xe, "TCL"], [Ze, $e]], [/(itel) ((\w+))/i], [[Xe, Nt], Ue, [Ze, $t, {
        tablet: ["p10001l", "w7001"],
        "*": "mobile"
      }]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [Ue, [Xe, "Acer"], [Ze, $e]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [Ue, [Xe, "Meizu"], [Ze, at]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [Ue, [Xe, "Ulefone"], [Ze, at]], [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [Ue, [Xe, "Energizer"], [Ze, at]], [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [Ue, [Xe, "Cat"], [Ze, at]], [/((?:new )?andromax[\w- ]+)(?: bui|\))/i], [Ue, [Xe, "Smartfren"], [Ze, at]], [/droid.+; (a(?:015|06[35]|142p?))/i], [Ue, [Xe, "Nothing"], [Ze, at]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i, /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [Xe, Ue, [Ze, at]], [/(imo) (tab \w+)/i, /(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [Xe, Ue, [Ze, $e]], [/(surface duo)/i], [Ue, [Xe, rt], [Ze, $e]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [Ue, [Xe, "Fairphone"], [Ze, at]], [/(u304aa)/i], [Ue, [Xe, "AT&T"], [Ze, at]], [/\bsie-(\w*)/i], [Ue, [Xe, "Siemens"], [Ze, at]], [/\b(rct\w+) b/i], [Ue, [Xe, "RCA"], [Ze, $e]], [/\b(venue[\d ]{2,7}) b/i], [Ue, [Xe, "Dell"], [Ze, $e]], [/\b(q(?:mv|ta)\w+) b/i], [Ue, [Xe, "Verizon"], [Ze, $e]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [Ue, [Xe, "Barnes & Noble"], [Ze, $e]], [/\b(tm\d{3}\w+) b/i], [Ue, [Xe, "NuVision"], [Ze, $e]], [/\b(k88) b/i], [Ue, [Xe, "ZTE"], [Ze, $e]], [/\b(nx\d{3}j) b/i], [Ue, [Xe, "ZTE"], [Ze, at]], [/\b(gen\d{3}) b.+49h/i], [Ue, [Xe, "Swiss"], [Ze, at]], [/\b(zur\d{3}) b/i], [Ue, [Xe, "Swiss"], [Ze, $e]], [/\b((zeki)?tb.*\b) b/i], [Ue, [Xe, "Zeki"], [Ze, $e]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[Xe, "Dragon Touch"], Ue, [Ze, $e]], [/\b(ns-?\w{0,9}) b/i], [Ue, [Xe, "Insignia"], [Ze, $e]], [/\b((nxa|next)-?\w{0,9}) b/i], [Ue, [Xe, "NextBook"], [Ze, $e]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[Xe, "Voice"], Ue, [Ze, at]], [/\b(lvtel\-)?(v1[12]) b/i], [[Xe, "LvTel"], Ue, [Ze, at]], [/\b(ph-1) /i], [Ue, [Xe, "Essential"], [Ze, at]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [Ue, [Xe, "Envizen"], [Ze, $e]], [/\b(trio[-\w\. ]+) b/i], [Ue, [Xe, "MachSpeed"], [Ze, $e]], [/\btu_(1491) b/i], [Ue, [Xe, "Rotor"], [Ze, $e]], [/(shield[\w ]+) b/i], [Ue, [Xe, "Nvidia"], [Ze, $e]], [/(sprint) (\w+)/i], [Xe, Ue, [Ze, at]], [/(kin\.[onetw]{3})/i], [[Ue, /\./g, " "], [Xe, rt], [Ze, at]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [Ue, [Xe, Et], [Ze, $e]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [Ue, [Xe, Et], [Ze, at]], [/smart-tv.+(samsung)/i], [Xe, [Ze, Ke]], [/hbbtv.+maple;(\d+)/i], [[Ue, /^/, "SmartTV"], [Xe, ft], [Ze, Ke]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[Xe, nt], [Ze, Ke]], [/(apple) ?tv/i], [Xe, [Ue, ht + " TV"], [Ze, Ke]], [/crkey/i], [[Ue, bt + "cast"], [Xe, yt], [Ze, Ke]], [/droid.+aft(\w+)( bui|\))/i], [Ue, [Xe, ot], [Ze, Ke]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [Ue, [Xe, pt], [Ze, Ke]], [/(bravia[\w ]+)( bui|\))/i], [Ue, [Xe, mt], [Ze, Ke]], [/(mitv-\w{5}) bui/i], [Ue, [Xe, dt], [Ze, Ke]], [/Hbbtv.*(technisat) (.*);/i], [Xe, Ue, [Ze, Ke]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[Xe, Ft], [Ue, Ft], [Ze, Ke]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[Ze, Ke]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [Xe, Ue, [Ze, et]], [/droid.+; (shield) bui/i], [Ue, [Xe, "Nvidia"], [Ze, et]], [/(playstation [345portablevi]+)/i], [Ue, [Xe, mt], [Ze, et]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [Ue, [Xe, rt], [Ze, et]], [/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i], [Ue, [Xe, ft], [Ze, tt]], [/((pebble))app/i], [Xe, Ue, [Ze, tt]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [Ue, [Xe, ht], [Ze, tt]], [/droid.+; (glass) \d/i], [Ue, [Xe, yt], [Ze, tt]], [/droid.+; (wt63?0{2,3})\)/i], [Ue, [Xe, Et], [Ze, tt]], [/droid.+; (glass) \d/i], [Ue, [Xe, yt], [Ze, tt]], [/(pico) (4|neo3(?: link|pro)?)/i], [Xe, Ue, [Ze, tt]], [/; (quest( \d| pro)?)/i], [Ue, [Xe, Ct], [Ze, tt]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [Xe, [Ze, ut]], [/(aeobc)\b/i], [Ue, [Xe, ot], [Ze, ut]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [Ue, [Ze, at]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [Ue, [Ze, $e]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[Ze, $e]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[Ze, at]], [/(android[-\w\. ]{0,9});.+buil/i], [Ue, [Xe, "Generic"]]],
      engine: [[/windows.+ edge\/([\w\.]+)/i], [Je, [Le, wt + "HTML"]], [/(arkweb)\/([\w\.]+)/i], [Le, Je], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [Je, [Le, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [Le, Je], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [Je, Le]],
      os: [[/microsoft (windows) (vista|xp)/i], [Le, Je], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [Le, [Je, $t, Jt]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[Je, $t, Jt], [Le, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[Je, /_/g, "."], [Le, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[Le, qt], [Je, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [Je, Le], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [Le, Je], [/\(bb(10);/i], [Je, [Le, At]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [Je, [Le, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [Je, [Le, Ot + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [Je, [Le, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [Je, [Le, "watchOS"]], [/crkey\/([\d\.]+)/i], [Je, [Le, bt + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[Le, Tt], Je], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [Le, Je], [/(sunos) ?([\w\.\d]*)/i], [[Le, "Solaris"], Je], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [Le, Je]]
    }, Ht = function(Vt, Yt) {
      if (typeof Vt === We && (Yt = Vt, Vt = l), !(this instanceof Ht))
        return new Ht(Vt, Yt).getResult();
      var Rt = typeof u !== le && u.navigator ? u.navigator : l, kt = Vt || (Rt && Rt.userAgent ? Rt.userAgent : m), Zt = Rt && Rt.userAgentData ? Rt.userAgentData : l, Wt = Yt ? St(er, Yt) : er, xt = Rt && Rt.userAgent == kt;
      return this.getBrowser = function() {
        var It = {};
        return It[Le] = l, It[Je] = l, Bt.call(It, kt, Wt.browser), It[Fe] = Kt(It[Je]), xt && Rt && Rt.brave && typeof Rt.brave.isBrave == O && (It[Le] = "Brave"), It;
      }, this.getCPU = function() {
        var It = {};
        return It[it] = l, Bt.call(It, kt, Wt.cpu), It;
      }, this.getDevice = function() {
        var It = {};
        return It[Xe] = l, It[Ue] = l, It[Ze] = l, Bt.call(It, kt, Wt.device), xt && !It[Ze] && Zt && Zt.mobile && (It[Ze] = at), xt && It[Ue] == "Macintosh" && Rt && typeof Rt.standalone !== le && Rt.maxTouchPoints && Rt.maxTouchPoints > 2 && (It[Ue] = "iPad", It[Ze] = $e), It;
      }, this.getEngine = function() {
        var It = {};
        return It[Le] = l, It[Je] = l, Bt.call(It, kt, Wt.engine), It;
      }, this.getOS = function() {
        var It = {};
        return It[Le] = l, It[Je] = l, Bt.call(It, kt, Wt.os), xt && !It[Le] && Zt && Zt.platform && Zt.platform != "Unknown" && (It[Le] = Zt.platform.replace(/chrome os/i, Tt).replace(/macos/i, qt)), It;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return kt;
      }, this.setUA = function(It) {
        return kt = typeof It === ye && It.length > st ? Ft(It, st) : It, this;
      }, this.setUA(kt), this;
    };
    Ht.VERSION = h, Ht.BROWSER = Mt([Le, Je, Fe]), Ht.CPU = Mt([it]), Ht.DEVICE = Mt([Ue, Xe, Ze, et, at, Ke, $e, tt, ut]), Ht.ENGINE = Ht.OS = Mt([Le, Je]), o.exports && (s = o.exports = Ht), s.UAParser = Ht;
    var zt = typeof u !== le && (u.jQuery || u.Zepto);
    if (zt && !zt.ua) {
      var Xt = new Ht();
      zt.ua = Xt.getResult(), zt.ua.get = function() {
        return Xt.getUA();
      }, zt.ua.set = function(Vt) {
        Xt.setUA(Vt);
        var Yt = Xt.getResult();
        for (var Rt in Yt)
          zt.ua[Rt] = Yt[Rt];
      };
    }
  })(typeof window == "object" ? window : commonjsGlobal);
})(uaParser_min, uaParser_min.exports);
var uaParser_minExports = uaParser_min.exports;
Object.defineProperty(lib, "__esModule", {
  value: !0
});
function _interopDefault(o) {
  return o && typeof o == "object" && "default" in o ? o.default : o;
}
var React = React$1, React__default = _interopDefault(React), UAParser = uaParser_minExports, ClientUAInstance = new UAParser(), browser = ClientUAInstance.getBrowser(), cpu = ClientUAInstance.getCPU(), device = ClientUAInstance.getDevice(), engine = ClientUAInstance.getEngine(), os$1 = ClientUAInstance.getOS(), ua = ClientUAInstance.getUA(), setUa = function(s) {
  return ClientUAInstance.setUA(s);
}, parseUserAgent = function(s) {
  if (!s) {
    console.error("No userAgent string was provided");
    return;
  }
  var u = new UAParser(s);
  return {
    UA: u,
    browser: u.getBrowser(),
    cpu: u.getCPU(),
    device: u.getDevice(),
    engine: u.getEngine(),
    os: u.getOS(),
    ua: u.getUA(),
    setUserAgent: function(h) {
      return u.setUA(h);
    }
  };
}, UAHelper = /* @__PURE__ */ Object.freeze({
  ClientUAInstance,
  browser,
  cpu,
  device,
  engine,
  os: os$1,
  ua,
  setUa,
  parseUserAgent
});
function ownKeys(o, s) {
  var u = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(o);
    s && (l = l.filter(function(h) {
      return Object.getOwnPropertyDescriptor(o, h).enumerable;
    })), u.push.apply(u, l);
  }
  return u;
}
function _objectSpread2(o) {
  for (var s = 1; s < arguments.length; s++) {
    var u = arguments[s] != null ? arguments[s] : {};
    s % 2 ? ownKeys(Object(u), !0).forEach(function(l) {
      _defineProperty(o, l, u[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(u)) : ownKeys(Object(u)).forEach(function(l) {
      Object.defineProperty(o, l, Object.getOwnPropertyDescriptor(u, l));
    });
  }
  return o;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(s) {
    return typeof s;
  } : _typeof = function(s) {
    return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
  }, _typeof(o);
}
function _classCallCheck(o, s) {
  if (!(o instanceof s))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(o, s) {
  for (var u = 0; u < s.length; u++) {
    var l = s[u];
    l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(o, l.key, l);
  }
}
function _createClass(o, s, u) {
  return s && _defineProperties(o.prototype, s), u && _defineProperties(o, u), o;
}
function _defineProperty(o, s, u) {
  return s in o ? Object.defineProperty(o, s, {
    value: u,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[s] = u, o;
}
function _extends() {
  return _extends = Object.assign || function(o) {
    for (var s = 1; s < arguments.length; s++) {
      var u = arguments[s];
      for (var l in u)
        Object.prototype.hasOwnProperty.call(u, l) && (o[l] = u[l]);
    }
    return o;
  }, _extends.apply(this, arguments);
}
function _inherits(o, s) {
  if (typeof s != "function" && s !== null)
    throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(s && s.prototype, {
    constructor: {
      value: o,
      writable: !0,
      configurable: !0
    }
  }), s && _setPrototypeOf(o, s);
}
function _getPrototypeOf(o) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(u) {
    return u.__proto__ || Object.getPrototypeOf(u);
  }, _getPrototypeOf(o);
}
function _setPrototypeOf(o, s) {
  return _setPrototypeOf = Object.setPrototypeOf || function(l, h) {
    return l.__proto__ = h, l;
  }, _setPrototypeOf(o, s);
}
function _objectWithoutPropertiesLoose(o, s) {
  if (o == null)
    return {};
  var u = {}, l = Object.keys(o), h, m;
  for (m = 0; m < l.length; m++)
    h = l[m], !(s.indexOf(h) >= 0) && (u[h] = o[h]);
  return u;
}
function _objectWithoutProperties(o, s) {
  if (o == null)
    return {};
  var u = _objectWithoutPropertiesLoose(o, s), l, h;
  if (Object.getOwnPropertySymbols) {
    var m = Object.getOwnPropertySymbols(o);
    for (h = 0; h < m.length; h++)
      l = m[h], !(s.indexOf(l) >= 0) && Object.prototype.propertyIsEnumerable.call(o, l) && (u[l] = o[l]);
  }
  return u;
}
function _assertThisInitialized(o) {
  if (o === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function _possibleConstructorReturn(o, s) {
  if (s && (typeof s == "object" || typeof s == "function"))
    return s;
  if (s !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(o);
}
function _slicedToArray(o, s) {
  return _arrayWithHoles(o) || _iterableToArrayLimit(o, s) || _unsupportedIterableToArray(o, s) || _nonIterableRest();
}
function _arrayWithHoles(o) {
  if (Array.isArray(o))
    return o;
}
function _iterableToArrayLimit(o, s) {
  var u = o == null ? null : typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (u != null) {
    var l = [], h = !0, m = !1, C, O;
    try {
      for (u = u.call(o); !(h = (C = u.next()).done) && (l.push(C.value), !(s && l.length === s)); h = !0)
        ;
    } catch (le) {
      m = !0, O = le;
    } finally {
      try {
        !h && u.return != null && u.return();
      } finally {
        if (m)
          throw O;
      }
    }
    return l;
  }
}
function _unsupportedIterableToArray(o, s) {
  if (o) {
    if (typeof o == "string")
      return _arrayLikeToArray(o, s);
    var u = Object.prototype.toString.call(o).slice(8, -1);
    if (u === "Object" && o.constructor && (u = o.constructor.name), u === "Map" || u === "Set")
      return Array.from(o);
    if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u))
      return _arrayLikeToArray(o, s);
  }
}
function _arrayLikeToArray(o, s) {
  (s == null || s > o.length) && (s = o.length);
  for (var u = 0, l = new Array(s); u < s; u++)
    l[u] = o[u];
  return l;
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var DeviceTypes = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, BrowserTypes = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, OsTypes = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, InitialDeviceTypes = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, checkDeviceType = function(s) {
  switch (s) {
    case DeviceTypes.Mobile:
      return {
        isMobile: !0
      };
    case DeviceTypes.Tablet:
      return {
        isTablet: !0
      };
    case DeviceTypes.SmartTv:
      return {
        isSmartTV: !0
      };
    case DeviceTypes.Console:
      return {
        isConsole: !0
      };
    case DeviceTypes.Wearable:
      return {
        isWearable: !0
      };
    case DeviceTypes.Browser:
      return {
        isBrowser: !0
      };
    case DeviceTypes.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return InitialDeviceTypes;
  }
}, setUserAgent = function(s) {
  return setUa(s);
}, setDefaults = function(s) {
  var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return s || u;
}, getNavigatorInstance = function() {
  return typeof window < "u" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, isIOS13Check = function(s) {
  var u = getNavigatorInstance();
  return u && u.platform && (u.platform.indexOf(s) !== -1 || u.platform === "MacIntel" && u.maxTouchPoints > 1 && !window.MSStream);
}, browserPayload = function(s, u, l, h, m) {
  return {
    isBrowser: s,
    browserMajorVersion: setDefaults(u.major),
    browserFullVersion: setDefaults(u.version),
    browserName: setDefaults(u.name),
    engineName: setDefaults(l.name),
    engineVersion: setDefaults(l.version),
    osName: setDefaults(h.name),
    osVersion: setDefaults(h.version),
    userAgent: setDefaults(m)
  };
}, mobilePayload = function(s, u, l, h) {
  return _objectSpread2({}, s, {
    vendor: setDefaults(u.vendor),
    model: setDefaults(u.model),
    os: setDefaults(l.name),
    osVersion: setDefaults(l.version),
    ua: setDefaults(h)
  });
}, smartTvPayload = function(s, u, l, h) {
  return {
    isSmartTV: s,
    engineName: setDefaults(u.name),
    engineVersion: setDefaults(u.version),
    osName: setDefaults(l.name),
    osVersion: setDefaults(l.version),
    userAgent: setDefaults(h)
  };
}, consolePayload = function(s, u, l, h) {
  return {
    isConsole: s,
    engineName: setDefaults(u.name),
    engineVersion: setDefaults(u.version),
    osName: setDefaults(l.name),
    osVersion: setDefaults(l.version),
    userAgent: setDefaults(h)
  };
}, wearablePayload = function(s, u, l, h) {
  return {
    isWearable: s,
    engineName: setDefaults(u.name),
    engineVersion: setDefaults(u.version),
    osName: setDefaults(l.name),
    osVersion: setDefaults(l.version),
    userAgent: setDefaults(h)
  };
}, embeddedPayload = function(s, u, l, h, m) {
  return {
    isEmbedded: s,
    vendor: setDefaults(u.vendor),
    model: setDefaults(u.model),
    engineName: setDefaults(l.name),
    engineVersion: setDefaults(l.version),
    osName: setDefaults(h.name),
    osVersion: setDefaults(h.version),
    userAgent: setDefaults(m)
  };
};
function deviceDetect(o) {
  var s = o ? parseUserAgent(o) : UAHelper, u = s.device, l = s.browser, h = s.engine, m = s.os, C = s.ua, O = checkDeviceType(u.type), le = O.isBrowser, We = O.isMobile, ye = O.isTablet, Fe = O.isSmartTV, Ue = O.isConsole, Le = O.isWearable, Ze = O.isEmbedded;
  if (le)
    return browserPayload(le, l, h, m, C);
  if (Fe)
    return smartTvPayload(Fe, h, m, C);
  if (Ue)
    return consolePayload(Ue, h, m, C);
  if (We || ye)
    return mobilePayload(O, u, m, C);
  if (Le)
    return wearablePayload(Le, h, m, C);
  if (Ze)
    return embeddedPayload(Ze, u, h, m, C);
}
var isMobileType = function(s) {
  var u = s.type;
  return u === DeviceTypes.Mobile;
}, isTabletType = function(s) {
  var u = s.type;
  return u === DeviceTypes.Tablet;
}, isMobileAndTabletType = function(s) {
  var u = s.type;
  return u === DeviceTypes.Mobile || u === DeviceTypes.Tablet;
}, isSmartTVType = function(s) {
  var u = s.type;
  return u === DeviceTypes.SmartTv;
}, isBrowserType = function(s) {
  var u = s.type;
  return u === DeviceTypes.Browser;
}, isWearableType = function(s) {
  var u = s.type;
  return u === DeviceTypes.Wearable;
}, isConsoleType = function(s) {
  var u = s.type;
  return u === DeviceTypes.Console;
}, isEmbeddedType = function(s) {
  var u = s.type;
  return u === DeviceTypes.Embedded;
}, getMobileVendor = function(s) {
  var u = s.vendor;
  return setDefaults(u);
}, getMobileModel = function(s) {
  var u = s.model;
  return setDefaults(u);
}, getDeviceType = function(s) {
  var u = s.type;
  return setDefaults(u, "browser");
}, isAndroidType = function(s) {
  var u = s.name;
  return u === OsTypes.Android;
}, isWindowsType = function(s) {
  var u = s.name;
  return u === OsTypes.Windows;
}, isMacOsType = function(s) {
  var u = s.name;
  return u === OsTypes.MAC_OS;
}, isWinPhoneType = function(s) {
  var u = s.name;
  return u === OsTypes.WindowsPhone;
}, isIOSType = function(s) {
  var u = s.name;
  return u === OsTypes.IOS;
}, getOsVersion = function(s) {
  var u = s.version;
  return setDefaults(u);
}, getOsName = function(s) {
  var u = s.name;
  return setDefaults(u);
}, isChromeType = function(s) {
  var u = s.name;
  return u === BrowserTypes.Chrome;
}, isFirefoxType = function(s) {
  var u = s.name;
  return u === BrowserTypes.Firefox;
}, isChromiumType = function(s) {
  var u = s.name;
  return u === BrowserTypes.Chromium;
}, isEdgeType = function(s) {
  var u = s.name;
  return u === BrowserTypes.Edge;
}, isYandexType = function(s) {
  var u = s.name;
  return u === BrowserTypes.Yandex;
}, isSafariType = function(s) {
  var u = s.name;
  return u === BrowserTypes.Safari || u === BrowserTypes.MobileSafari;
}, isMobileSafariType = function(s) {
  var u = s.name;
  return u === BrowserTypes.MobileSafari;
}, isOperaType = function(s) {
  var u = s.name;
  return u === BrowserTypes.Opera;
}, isIEType = function(s) {
  var u = s.name;
  return u === BrowserTypes.InternetExplorer || u === BrowserTypes.Ie;
}, isMIUIType = function(s) {
  var u = s.name;
  return u === BrowserTypes.MIUI;
}, isSamsungBrowserType = function(s) {
  var u = s.name;
  return u === BrowserTypes.SamsungBrowser;
}, getBrowserFullVersion = function(s) {
  var u = s.version;
  return setDefaults(u);
}, getBrowserVersion = function(s) {
  var u = s.major;
  return setDefaults(u);
}, getBrowserName = function(s) {
  var u = s.name;
  return setDefaults(u);
}, getEngineName = function(s) {
  var u = s.name;
  return setDefaults(u);
}, getEngineVersion = function(s) {
  var u = s.version;
  return setDefaults(u);
}, isElectronType = function() {
  var s = getNavigatorInstance(), u = s && s.userAgent && s.userAgent.toLowerCase();
  return typeof u == "string" ? /electron/.test(u) : !1;
}, isEdgeChromiumType = function(s) {
  return typeof s == "string" && s.indexOf("Edg/") !== -1;
}, getIOS13 = function() {
  var s = getNavigatorInstance();
  return s && (/iPad|iPhone|iPod/.test(s.platform) || s.platform === "MacIntel" && s.maxTouchPoints > 1) && !window.MSStream;
}, getIPad13 = function() {
  return isIOS13Check("iPad");
}, getIphone13 = function() {
  return isIOS13Check("iPhone");
}, getIPod13 = function() {
  return isIOS13Check("iPod");
}, getUseragent = function(s) {
  return setDefaults(s);
};
function buildSelectorsObject(o) {
  var s = o || UAHelper, u = s.device, l = s.browser, h = s.os, m = s.engine, C = s.ua;
  return {
    isSmartTV: isSmartTVType(u),
    isConsole: isConsoleType(u),
    isWearable: isWearableType(u),
    isEmbedded: isEmbeddedType(u),
    isMobileSafari: isMobileSafariType(l) || getIPad13(),
    isChromium: isChromiumType(l),
    isMobile: isMobileAndTabletType(u) || getIPad13(),
    isMobileOnly: isMobileType(u),
    isTablet: isTabletType(u) || getIPad13(),
    isBrowser: isBrowserType(u),
    isDesktop: isBrowserType(u),
    isAndroid: isAndroidType(h),
    isWinPhone: isWinPhoneType(h),
    isIOS: isIOSType(h) || getIPad13(),
    isChrome: isChromeType(l),
    isFirefox: isFirefoxType(l),
    isSafari: isSafariType(l),
    isOpera: isOperaType(l),
    isIE: isIEType(l),
    osVersion: getOsVersion(h),
    osName: getOsName(h),
    fullBrowserVersion: getBrowserFullVersion(l),
    browserVersion: getBrowserVersion(l),
    browserName: getBrowserName(l),
    mobileVendor: getMobileVendor(u),
    mobileModel: getMobileModel(u),
    engineName: getEngineName(m),
    engineVersion: getEngineVersion(m),
    getUA: getUseragent(C),
    isEdge: isEdgeType(l) || isEdgeChromiumType(C),
    isYandex: isYandexType(l),
    deviceType: getDeviceType(u),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(C),
    isLegacyEdge: isEdgeType(l) && !isEdgeChromiumType(C),
    isWindows: isWindowsType(h),
    isMacOs: isMacOsType(h),
    isMIUI: isMIUIType(l),
    isSamsungBrowser: isSamsungBrowserType(l)
  };
}
var isSmartTV = isSmartTVType(device), isConsole = isConsoleType(device), isWearable = isWearableType(device), isEmbedded = isEmbeddedType(device), isMobileSafari = isMobileSafariType(browser) || getIPad13(), isChromium = isChromiumType(browser), isMobile = isMobileAndTabletType(device) || getIPad13(), isMobileOnly = isMobileType(device), isTablet = isTabletType(device) || getIPad13(), isBrowser = isBrowserType(device), isDesktop = isBrowserType(device), isAndroid = isAndroidType(os$1), isWinPhone = isWinPhoneType(os$1), isIOS = isIOSType(os$1) || getIPad13(), isChrome = isChromeType(browser), isFirefox = isFirefoxType(browser), isSafari = isSafariType(browser), isOpera = isOperaType(browser), isIE = isIEType(browser), osVersion = getOsVersion(os$1), osName = getOsName(os$1), fullBrowserVersion = getBrowserFullVersion(browser), browserVersion = getBrowserVersion(browser), browserName = getBrowserName(browser), mobileVendor = getMobileVendor(device), mobileModel = getMobileModel(device), engineName = getEngineName(engine), engineVersion = getEngineVersion(engine), getUA = getUseragent(ua), isEdge = isEdgeType(browser) || isEdgeChromiumType(ua), isYandex = isYandexType(browser), deviceType = getDeviceType(device), isIOS13 = getIOS13(), isIPad13 = getIPad13(), isIPhone13 = getIphone13(), isIPod13 = getIPod13(), isElectron = isElectronType(), isEdgeChromium = isEdgeChromiumType(ua), isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua), isWindows = isWindowsType(os$1), isMacOs = isMacOsType(os$1), isMIUI = isMIUIType(browser), isSamsungBrowser = isSamsungBrowserType(browser), getSelectorsByUserAgent = function(s) {
  if (!s || typeof s != "string") {
    console.error("No valid user agent string was provided");
    return;
  }
  var u = parseUserAgent(s), l = u.device, h = u.browser, m = u.os, C = u.engine, O = u.ua;
  return buildSelectorsObject({
    device: l,
    browser: h,
    os: m,
    engine: C,
    ua: O
  });
}, AndroidView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isAndroid ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, BrowserView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isBrowser ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, IEView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isIE ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, IOSView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isIOS ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, MobileView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isMobile ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, TabletView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isTablet ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, WinPhoneView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isWinPhone ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, MobileOnlyView = function(s) {
  var u = s.renderWithFragment, l = s.children;
  s.viewClassName, s.style;
  var h = _objectWithoutProperties(s, ["renderWithFragment", "children", "viewClassName", "style"]);
  return isMobileOnly ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, SmartTVView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isSmartTV ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, ConsoleView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isConsole ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, WearableView = function(s) {
  var u = s.renderWithFragment, l = s.children, h = _objectWithoutProperties(s, ["renderWithFragment", "children"]);
  return isWearable ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", h, l) : null;
}, CustomView = function(s) {
  var u = s.renderWithFragment, l = s.children;
  s.viewClassName, s.style;
  var h = s.condition, m = _objectWithoutProperties(s, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return h ? u ? React__default.createElement(React.Fragment, null, l) : React__default.createElement("div", m, l) : null;
};
function withOrientationChange(o) {
  return /* @__PURE__ */ function(s) {
    _inherits(u, s);
    function u(l) {
      var h;
      return _classCallCheck(this, u), h = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, l)), h.isEventListenerAdded = !1, h.handleOrientationChange = h.handleOrientationChange.bind(_assertThisInitialized(h)), h.onOrientationChange = h.onOrientationChange.bind(_assertThisInitialized(h)), h.onPageLoad = h.onPageLoad.bind(_assertThisInitialized(h)), h.state = {
        isLandscape: !1,
        isPortrait: !1
      }, h;
    }
    return _createClass(u, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var h = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: h === 0,
          isLandscape: h === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window > "u" ? "undefined" : _typeof(window)) !== void 0 && isMobile && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return React__default.createElement(o, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), u;
  }(React__default.Component);
}
function useMobileOrientation() {
  var o = React.useState(function() {
    var m = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: m === 0,
      isLandscape: m === 90,
      orientation: m === 0 ? "portrait" : "landscape"
    };
  }), s = _slicedToArray(o, 2), u = s[0], l = s[1], h = React.useCallback(function() {
    var m = window.innerWidth > window.innerHeight ? 90 : 0, C = {
      isPortrait: m === 0,
      isLandscape: m === 90,
      orientation: m === 0 ? "portrait" : "landscape"
    };
    u.orientation !== C.orientation && l(C);
  }, [u.orientation]);
  return React.useEffect(function() {
    return (typeof window > "u" ? "undefined" : _typeof(window)) !== void 0 && isMobile && (h(), window.addEventListener("load", h, !1), window.addEventListener("resize", h, !1)), function() {
      window.removeEventListener("resize", h, !1), window.removeEventListener("load", h, !1);
    };
  }, [h]), u;
}
function useDeviceData(o) {
  var s = o || window.navigator.userAgent;
  return parseUserAgent(s);
}
function useDeviceSelectors(o) {
  var s = o || window.navigator.userAgent, u = useDeviceData(s), l = buildSelectorsObject(u);
  return [l, u];
}
lib.AndroidView = AndroidView;
lib.BrowserTypes = BrowserTypes;
lib.BrowserView = BrowserView;
lib.ConsoleView = ConsoleView;
lib.CustomView = CustomView;
lib.IEView = IEView;
lib.IOSView = IOSView;
lib.MobileOnlyView = MobileOnlyView;
lib.MobileView = MobileView;
lib.OsTypes = OsTypes;
lib.SmartTVView = SmartTVView;
lib.TabletView = TabletView;
lib.WearableView = WearableView;
lib.WinPhoneView = WinPhoneView;
lib.browserName = browserName;
lib.browserVersion = browserVersion;
lib.deviceDetect = deviceDetect;
lib.deviceType = deviceType;
lib.engineName = engineName;
lib.engineVersion = engineVersion;
lib.fullBrowserVersion = fullBrowserVersion;
lib.getSelectorsByUserAgent = getSelectorsByUserAgent;
lib.getUA = getUA;
lib.isAndroid = isAndroid;
lib.isBrowser = isBrowser;
lib.isChrome = isChrome;
lib.isChromium = isChromium;
lib.isConsole = isConsole;
lib.isDesktop = isDesktop;
var isEdge_1 = lib.isEdge = isEdge;
lib.isEdgeChromium = isEdgeChromium;
lib.isElectron = isElectron;
lib.isEmbedded = isEmbedded;
var isFirefox_1 = lib.isFirefox = isFirefox, isIE_1 = lib.isIE = isIE;
lib.isIOS = isIOS;
lib.isIOS13 = isIOS13;
lib.isIPad13 = isIPad13;
lib.isIPhone13 = isIPhone13;
lib.isIPod13 = isIPod13;
lib.isLegacyEdge = isLegacyEdge;
lib.isMIUI = isMIUI;
lib.isMacOs = isMacOs;
lib.isMobile = isMobile;
var isMobileOnly_1 = lib.isMobileOnly = isMobileOnly;
lib.isMobileSafari = isMobileSafari;
lib.isOpera = isOpera;
lib.isSafari = isSafari;
lib.isSamsungBrowser = isSamsungBrowser;
lib.isSmartTV = isSmartTV;
lib.isTablet = isTablet;
lib.isWearable = isWearable;
lib.isWinPhone = isWinPhone;
lib.isWindows = isWindows;
lib.isYandex = isYandex;
lib.mobileModel = mobileModel;
lib.mobileVendor = mobileVendor;
lib.osName = osName;
lib.osVersion = osVersion;
lib.parseUserAgent = parseUserAgent;
lib.setUserAgent = setUserAgent;
lib.useDeviceData = useDeviceData;
lib.useDeviceSelectors = useDeviceSelectors;
lib.useMobileOrientation = useMobileOrientation;
lib.withOrientationChange = withOrientationChange;
const printPdf = (o) => {
  const s = {
    printable: null,
    fallbackPrintable: null,
    type: "pdf",
    onLoadingEnd: null,
    onPrintDialogClose: () => {
    },
    onError: (m) => {
      throw m;
    },
    frameId: "print-pdf-file",
    printableElement: null
  };
  s.printable = o.printable, s.fallbackPrintable = typeof o.fallbackPrintable < "u" ? o.fallbackPrintable : s.printable;
  let u;
  for (u in s)
    u === "printable" || u === "fallbackPrintable" || (s[u] = typeof o[u] < "u" ? o[u] : s[u]);
  const l = document.createElement("iframe"), h = isFirefox_1 ? "width: 1px; height: 100px; position: fixed; left: 0; top: 0; opacity: 0; border-width: 0; margin: 0; padding: 0" : "visibility: hidden; height: 0; width: 0; position: absolute; border: 0";
  l.setAttribute("style", h), l.setAttribute("id", s.frameId), printFile(s, l);
};
function cleanUp(o) {
  o.onLoadingEnd && o.onLoadingEnd();
  const s = () => {
    window.removeEventListener("focus", s), o.onPrintDialogClose();
    const u = document.getElementById(o.frameId);
    u && u.remove();
  };
  window.addEventListener("focus", s);
}
const printFile = (o, s) => {
  o.printable = /^(blob|http|\/\/)/i.test(o.printable) ? o.printable : window.location.origin + (o.printable.charAt(0) !== "/" ? "/" + o.printable : o.printable);
  const u = new window.XMLHttpRequest();
  u.responseType = "arraybuffer", u.addEventListener("error", () => {
    cleanUp(o), o.onError(u.statusText, u);
  }), u.addEventListener("load", () => {
    if ([200, 201].indexOf(u.status) === -1) {
      cleanUp(o), o.onError(u.statusText, u);
      return;
    }
    createBlobAndPrint(o, s, u.response);
  }), u.open("GET", o.printable, !0), u.send();
};
function createBlobAndPrint(o, s, u) {
  let l = new window.Blob([u], {
    type: "application/pdf"
  });
  l = window.URL.createObjectURL(l), s.setAttribute("src", l), printSend(o, s);
}
function performPrint(o, s) {
  var u, l, h;
  try {
    if (isFirefox_1 || o.focus(), isEdge_1 || isIE_1)
      try {
        (u = o.contentWindow) == null || u.document.execCommand("print", !1);
      } catch {
        (l = o.contentWindow) == null || l.print();
      }
    else
      (h = o.contentWindow) == null || h.print();
  } catch (m) {
    s.onError(m);
  } finally {
    isFirefox_1 && (o.style.visibility = "hidden", o.style.left = "-1px"), cleanUp(s);
  }
}
function printSend(o, s) {
  document.getElementsByTagName("body")[0].appendChild(s);
  const u = document.getElementById(o.frameId);
  u.onload = () => {
    if (o.type === "pdf") {
      if (isFirefox_1) {
        const h = setTimeout(() => {
          performPrint(u, o), clearTimeout(h);
        }, 1e3);
      } else
        performPrint(u, o);
      return;
    }
    let l = u.contentWindow || u.contentDocument;
    l != null && l.document && (l = l.document), l.body.appendChild(o.printableElement), performPrint(u, o);
  };
}
const usePrevious = (o) => {
  const s = useRef();
  return useEffect(() => {
    s.current = o;
  }), s.current;
};
function commonjsRequire(o) {
  throw new Error('Could not dynamically require "' + o + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var uniqid$1 = {
  exports: {}
};
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var pid = typeof process < "u" && process.pid ? process.pid.toString(36) : "", address = "";
if (typeof __webpack_require__ != "function" && typeof commonjsRequire < "u") {
  var mac = "", os = require$$5;
  if (os.networkInterfaces)
    var networkInterfaces = os.networkInterfaces();
  if (networkInterfaces) {
    e:
      for (let o in networkInterfaces) {
        const s = networkInterfaces[o], u = s.length;
        for (var i = 0; i < u; i++)
          if (s[i] !== void 0 && s[i].mac && s[i].mac != "00:00:00:00:00:00") {
            mac = s[i].mac;
            break e;
          }
      }
    address = mac ? parseInt(mac.replace(/\:|\D+/gi, "")).toString(36) : "";
  }
}
uniqid$1.exports = uniqid$1.exports.default = function(o, s) {
  return (o || "") + address + pid + now().toString(36) + (s || "");
};
uniqid$1.exports.process = function(o, s) {
  return (o || "") + pid + now().toString(36) + (s || "");
};
uniqid$1.exports.time = function(o, s) {
  return (o || "") + now().toString(36) + (s || "");
};
function now() {
  var o = Date.now(), s = now.last || o;
  return now.last = o > s ? o : s + 1;
}
var uniqidExports = uniqid$1.exports;
const uniqid = /* @__PURE__ */ getDefaultExportFromCjs(uniqidExports);
inject_1(".x17fnjtu{width:var(--width,revert)}", 4e3);
inject_1(".x1jwls1v{height:var(--height,revert)}", 4e3);
inject_1(".x78zum5{display:flex}", 3e3);
inject_1(".xl56j7k{justify-content:center}", 3e3);
inject_1(".x6s0dn4{align-items:center}", 3e3);
inject_1(".x1n2onr6{position:relative}", 3e3);
inject_1(".x10l6tqk{position:absolute}", 3e3);
inject_1(".xu96u03{left:0}", 4e3);
inject_1(".x13vifvy{top:0}", 4e3);
inject_1(".x3m8u43{right:0}", 4e3);
inject_1(".x1ey2m1c{bottom:0}", 4e3);
inject_1(".xjxbwdb{z-index:var(--zIndex,revert)}", 3e3);
inject_1(".xh8yej3{width:100%}", 4e3);
inject_1(".x5yr21d{height:100%}", 4e3);
inject_1(".x47corl{pointer-events:none}", 3e3);
inject_1(".x1da6vqk{object-fit:var(--objectFit,revert)}", 3e3);
inject_1(".xl853tq{filter:var(--filter,revert)}", 3e3);
const styles = {
  baseWrapper: (o, s) => [{
    width: "x17fnjtu",
    height: "x1jwls1v",
    display: "x78zum5",
    justifyContent: "xl56j7k",
    alignItems: "x6s0dn4",
    position: "x1n2onr6",
    $$css: !0
  }, {
    "--width": ((u) => typeof u == "number" ? u + "px" : u ?? "initial")(s ? `${s}px` : "100%"),
    "--height": ((u) => typeof u == "number" ? u + "px" : u ?? "initial")(o ? `${o}px` : "100%")
  }],
  baseOverlay: (o) => [{
    position: "x10l6tqk",
    left: "xu96u03",
    insetInlineStart: null,
    insetInlineEnd: null,
    top: "x13vifvy",
    right: "x3m8u43",
    bottom: "x1ey2m1c",
    zIndex: "xjxbwdb",
    $$css: !0
  }, {
    "--zIndex": o ?? "initial"
  }],
  placeholder: (o, s) => [{
    width: "xh8yej3",
    height: "x5yr21d",
    pointerEvents: "x47corl",
    objectFit: "x1da6vqk",
    filter: "xl853tq",
    $$css: !0
  }, {
    "--objectFit": (o ? "contain" : "cover") ?? "initial",
    "--filter": `blur(${s ? "15px" : "0"})` != null ? `blur(${s ? "15px" : "0"})` : "initial"
  }]
}, IdealImage = ({
  parentType: o,
  imageFitFillType: s = "fill",
  contentUri: u,
  fallbackUri: l,
  imageSize: h = {
    width: 0,
    height: 0
  },
  containerSize: m,
  onLoad: C = () => {
  },
  enableTracking: O,
  vaultId: le,
  projectId: We,
  forceOriginalSize: ye,
  mustFillParent: Fe,
  disableFade: Ue,
  blur: Le,
  shouldExpandImage: Ze,
  onImageExpanded: Xe,
  onImageCollapsed: Je,
  shouldFit: it,
  displayOnDemand: et,
  displayDemanded: at,
  baseImageUrl: $e
}) => {
  const [Ke, tt] = useState(!1), [ut, st] = useState(!1), [ot, ht] = useState(), [vt, At] = useState(), [gt, bt] = useState(), [wt, Ot] = useState(), yt = `${$e}/o=true/${u || l}`, [Qe] = useState(uniqid("image-")), [nt, rt] = useState(!1), [lt, ct] = useState(!et), ft = useCallback(() => {
  }, [O, le, We]), pt = (dt, Et) => {
    C(gt, wt, dt.target, Et);
  };
  useEffect(() => {
    at && setTimeout(() => ct(!0), 400);
  }, [at]), useEffect(() => {
    const dt = m.width, Et = m.height, Ct = h.width, Tt = h.height, {
      idealWidth: qt,
      idealHeight: jt
    } = calculateElementSizeInContainer(dt, Et, Ct, Tt, s);
    bt(qt), Ot(jt);
    const St = getBackendGeneratedHeights();
    let Mt = St.findIndex((Ft) => Ft >= jt);
    Mt === -1 && (Mt = St.length - 1);
    const Dt = Math.min(Math.max(Mt - 3, 0), 3), Nt = `q=80:h=${St[Dt]}`, Kt = `h=${St[Mt]}`;
    ht(`${$e}/${Nt}/${u || l}`), At(`${$e}/${Kt}/${u || l}`);
  }, [u, l, m.width, m.height, h == null ? void 0 : h.width, h == null ? void 0 : h.height, s]), useEffect(() => {
    Ze ? nt || (rt(!0), Xe && Xe()) : rt(!1);
  }, [Ze, Xe, nt]), useEffect(() => {
    Ze ? rt(!0) : nt && (rt(!1), Je && Je());
  }, [Ze, Je, nt]), useEffect(() => {
    ot && ft(), vt && ft();
  }, [ft, ot, vt]);
  const mt = {
    variants: fadeVariant,
    initial: Ue ? "visible" : "hidden",
    animate: lt ? "visible" : "hidden",
    exit: Ue ? "visible" : "hidden"
  };
  return Fe || (mt.width = gt, mt.height = wt), !gt || !wt ? null : /* @__PURE__ */ jsxs(motion.div, {
    id: "test",
    ...mt,
    ...props_1(styles.baseWrapper(mt.height, mt.width)),
    children: [(!Ke || !lt) && !ut && /* @__PURE__ */ jsx(motion.div, {
      id: "loader",
      ...mt,
      ...props_1(styles.baseWrapper(mt.height, mt.width), styles.baseOverlay(0)),
      children: /* @__PURE__ */ jsx(PdfLoader, {})
    }), /* @__PURE__ */ jsxs(motion.div, {
      id: `${Qe}_placeholder`,
      ...mt,
      ...props_1(styles.baseWrapper(mt.height, mt.width), styles.baseOverlay(1)),
      animate: Ke || ut ? "visible" : "hidden",
      children: [!ut && /* @__PURE__ */ jsx("img", {
        alt: "Placeholder",
        src: ot,
        onLoad: (dt) => {
          pt(dt, !0), tt(!0);
        },
        ...props_1(styles.placeholder(it, Le))
      }), /* @__PURE__ */ jsx(motion.div, {
        id: `${Qe}_image`,
        ...mt,
        animate: ut ? "visible" : "hidden",
        ...props_1(styles.baseWrapper(mt.height, mt.width), styles.baseOverlay(2)),
        children: /* @__PURE__ */ jsx("img", {
          alt: "high_res image",
          src: ye ? yt : vt,
          onLoadStart: ft,
          onLoad: (dt) => {
            ye || (pt(dt, !1), st(!0));
          },
          ...props_1(styles.placeholder(it, Le))
        })
      })]
    })]
  }, u);
}, fadeVariant = {
  visible: {
    opacity: 1
  },
  hidden: {
    opacity: 0
  }
};
var pdf = {
  exports: {}
};
(function(module, exports) {
  (function(s, u) {
    module.exports = u();
  })(commonjsGlobal, function() {
    return (
      /******/
      function(o) {
        var s = {};
        function u(l) {
          if (s[l])
            return s[l].exports;
          var h = s[l] = {
            /******/
            i: l,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return o[l].call(h.exports, h, h.exports, u), h.l = !0, h.exports;
        }
        return u.m = o, u.c = s, u.d = function(l, h, m) {
          u.o(l, h) || Object.defineProperty(l, h, {
            enumerable: !0,
            get: m
          });
        }, u.r = function(l) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(l, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(l, "__esModule", {
            value: !0
          });
        }, u.t = function(l, h) {
          if (h & 1 && (l = u(l)), h & 8 || h & 4 && typeof l == "object" && l && l.__esModule)
            return l;
          var m = /* @__PURE__ */ Object.create(null);
          if (u.r(m), Object.defineProperty(m, "default", {
            enumerable: !0,
            value: l
          }), h & 2 && typeof l != "string")
            for (var C in l)
              u.d(m, C, (function(O) {
                return l[O];
              }).bind(null, C));
          return m;
        }, u.n = function(l) {
          var h = l && l.__esModule ? (
            /******/
            function() {
              return l.default;
            }
          ) : (
            /******/
            function() {
              return l;
            }
          );
          return u.d(h, "a", h), h;
        }, u.o = function(l, h) {
          return Object.prototype.hasOwnProperty.call(l, h);
        }, u.p = "", u(u.s = 0);
      }([
        /* 0 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), Object.defineProperty(s, "addLinkAttributes", {
            enumerable: !0,
            get: function() {
              return l.addLinkAttributes;
            }
          }), Object.defineProperty(s, "getFilenameFromUrl", {
            enumerable: !0,
            get: function() {
              return l.getFilenameFromUrl;
            }
          }), Object.defineProperty(s, "LinkTarget", {
            enumerable: !0,
            get: function() {
              return l.LinkTarget;
            }
          }), Object.defineProperty(s, "loadScript", {
            enumerable: !0,
            get: function() {
              return l.loadScript;
            }
          }), Object.defineProperty(s, "PDFDateString", {
            enumerable: !0,
            get: function() {
              return l.PDFDateString;
            }
          }), Object.defineProperty(s, "RenderingCancelledException", {
            enumerable: !0,
            get: function() {
              return l.RenderingCancelledException;
            }
          }), Object.defineProperty(s, "build", {
            enumerable: !0,
            get: function() {
              return h.build;
            }
          }), Object.defineProperty(s, "getDocument", {
            enumerable: !0,
            get: function() {
              return h.getDocument;
            }
          }), Object.defineProperty(s, "LoopbackPort", {
            enumerable: !0,
            get: function() {
              return h.LoopbackPort;
            }
          }), Object.defineProperty(s, "PDFDataRangeTransport", {
            enumerable: !0,
            get: function() {
              return h.PDFDataRangeTransport;
            }
          }), Object.defineProperty(s, "PDFWorker", {
            enumerable: !0,
            get: function() {
              return h.PDFWorker;
            }
          }), Object.defineProperty(s, "version", {
            enumerable: !0,
            get: function() {
              return h.version;
            }
          }), Object.defineProperty(s, "CMapCompressionType", {
            enumerable: !0,
            get: function() {
              return m.CMapCompressionType;
            }
          }), Object.defineProperty(s, "createObjectURL", {
            enumerable: !0,
            get: function() {
              return m.createObjectURL;
            }
          }), Object.defineProperty(s, "createPromiseCapability", {
            enumerable: !0,
            get: function() {
              return m.createPromiseCapability;
            }
          }), Object.defineProperty(s, "createValidAbsoluteUrl", {
            enumerable: !0,
            get: function() {
              return m.createValidAbsoluteUrl;
            }
          }), Object.defineProperty(s, "InvalidPDFException", {
            enumerable: !0,
            get: function() {
              return m.InvalidPDFException;
            }
          }), Object.defineProperty(s, "MissingPDFException", {
            enumerable: !0,
            get: function() {
              return m.MissingPDFException;
            }
          }), Object.defineProperty(s, "OPS", {
            enumerable: !0,
            get: function() {
              return m.OPS;
            }
          }), Object.defineProperty(s, "PasswordResponses", {
            enumerable: !0,
            get: function() {
              return m.PasswordResponses;
            }
          }), Object.defineProperty(s, "PermissionFlag", {
            enumerable: !0,
            get: function() {
              return m.PermissionFlag;
            }
          }), Object.defineProperty(s, "removeNullCharacters", {
            enumerable: !0,
            get: function() {
              return m.removeNullCharacters;
            }
          }), Object.defineProperty(s, "shadow", {
            enumerable: !0,
            get: function() {
              return m.shadow;
            }
          }), Object.defineProperty(s, "UnexpectedResponseException", {
            enumerable: !0,
            get: function() {
              return m.UnexpectedResponseException;
            }
          }), Object.defineProperty(s, "UNSUPPORTED_FEATURES", {
            enumerable: !0,
            get: function() {
              return m.UNSUPPORTED_FEATURES;
            }
          }), Object.defineProperty(s, "Util", {
            enumerable: !0,
            get: function() {
              return m.Util;
            }
          }), Object.defineProperty(s, "VerbosityLevel", {
            enumerable: !0,
            get: function() {
              return m.VerbosityLevel;
            }
          }), Object.defineProperty(s, "AnnotationLayer", {
            enumerable: !0,
            get: function() {
              return C.AnnotationLayer;
            }
          }), Object.defineProperty(s, "apiCompatibilityParams", {
            enumerable: !0,
            get: function() {
              return O.apiCompatibilityParams;
            }
          }), Object.defineProperty(s, "GlobalWorkerOptions", {
            enumerable: !0,
            get: function() {
              return le.GlobalWorkerOptions;
            }
          }), Object.defineProperty(s, "renderTextLayer", {
            enumerable: !0,
            get: function() {
              return We.renderTextLayer;
            }
          }), Object.defineProperty(s, "SVGGraphics", {
            enumerable: !0,
            get: function() {
              return ye.SVGGraphics;
            }
          });
          var l = u(1), h = u(5), m = u(2), C = u(19), O = u(9), le = u(12), We = u(20), ye = u(21);
          {
            const {
              isNodeJS: Fe
            } = u(4);
            if (Fe) {
              const Ue = u(22).PDFNodeStream;
              (0, h.setPDFNetworkStreamFactory)((Le) => new Ue(Le));
            } else {
              const Ue = u(25).PDFNetworkStream;
              let Le;
              (0, l.isFetchSupported)() && (Le = u(26).PDFFetchStream), (0, h.setPDFNetworkStreamFactory)((Ze) => Le && (0, l.isValidFetchUrl)(Ze.url) ? new Le(Ze) : new Ue(Ze));
            }
          }
        },
        /* 1 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.addLinkAttributes = Ze, s.getFilenameFromUrl = Xe, s.isFetchSupported = it, s.isValidFetchUrl = et, s.loadScript = at, s.deprecated = $e, s.PDFDateString = s.StatTimer = s.DOMSVGFactory = s.DOMCMapReaderFactory = s.BaseCMapReaderFactory = s.DOMCanvasFactory = s.BaseCanvasFactory = s.DEFAULT_LINK_REL = s.LinkTarget = s.RenderingCancelledException = s.PageViewport = void 0;
          var l = u(2);
          const h = "noopener noreferrer nofollow";
          s.DEFAULT_LINK_REL = h;
          const m = "http://www.w3.org/2000/svg";
          class C {
            constructor() {
              this.constructor === C && (0, l.unreachable)("Cannot initialize BaseCanvasFactory.");
            }
            create(st, ot) {
              (0, l.unreachable)("Abstract method `create` called.");
            }
            reset(st, ot, ht) {
              if (!st.canvas)
                throw new Error("Canvas is not specified");
              if (ot <= 0 || ht <= 0)
                throw new Error("Invalid canvas size");
              st.canvas.width = ot, st.canvas.height = ht;
            }
            destroy(st) {
              if (!st.canvas)
                throw new Error("Canvas is not specified");
              st.canvas.width = 0, st.canvas.height = 0, st.canvas = null, st.context = null;
            }
          }
          s.BaseCanvasFactory = C;
          class O extends C {
            constructor({
              ownerDocument: st = globalThis.document
            } = {}) {
              super(), this._document = st;
            }
            create(st, ot) {
              if (st <= 0 || ot <= 0)
                throw new Error("Invalid canvas size");
              const ht = this._document.createElement("canvas"), vt = ht.getContext("2d");
              return ht.width = st, ht.height = ot, {
                canvas: ht,
                context: vt
              };
            }
          }
          s.DOMCanvasFactory = O;
          class le {
            constructor({
              baseUrl: st = null,
              isCompressed: ot = !1
            }) {
              this.constructor === le && (0, l.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = st, this.isCompressed = ot;
            }
            async fetch({
              name: st
            }) {
              if (!this.baseUrl)
                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
              if (!st)
                throw new Error("CMap name must be specified.");
              const ot = this.baseUrl + st + (this.isCompressed ? ".bcmap" : ""), ht = this.isCompressed ? l.CMapCompressionType.BINARY : l.CMapCompressionType.NONE;
              return this._fetchData(ot, ht).catch((vt) => {
                throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${ot}`);
              });
            }
            _fetchData(st, ot) {
              (0, l.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          s.BaseCMapReaderFactory = le;
          class We extends le {
            _fetchData(st, ot) {
              return it() && et(st, document.baseURI) ? fetch(st).then(async (ht) => {
                if (!ht.ok)
                  throw new Error(ht.statusText);
                let vt;
                return this.isCompressed ? vt = new Uint8Array(await ht.arrayBuffer()) : vt = (0, l.stringToBytes)(await ht.text()), {
                  cMapData: vt,
                  compressionType: ot
                };
              }) : new Promise((ht, vt) => {
                const At = new XMLHttpRequest();
                At.open("GET", st, !0), this.isCompressed && (At.responseType = "arraybuffer"), At.onreadystatechange = () => {
                  if (At.readyState === XMLHttpRequest.DONE) {
                    if (At.status === 200 || At.status === 0) {
                      let gt;
                      if (this.isCompressed && At.response ? gt = new Uint8Array(At.response) : !this.isCompressed && At.responseText && (gt = (0, l.stringToBytes)(At.responseText)), gt) {
                        ht({
                          cMapData: gt,
                          compressionType: ot
                        });
                        return;
                      }
                    }
                    vt(new Error(At.statusText));
                  }
                }, At.send(null);
              });
            }
          }
          s.DOMCMapReaderFactory = We;
          class ye {
            create(st, ot) {
              (0, l.assert)(st > 0 && ot > 0, "Invalid SVG dimensions");
              const ht = document.createElementNS(m, "svg:svg");
              return ht.setAttribute("version", "1.1"), ht.setAttribute("width", st + "px"), ht.setAttribute("height", ot + "px"), ht.setAttribute("preserveAspectRatio", "none"), ht.setAttribute("viewBox", "0 0 " + st + " " + ot), ht;
            }
            createElement(st) {
              return (0, l.assert)(typeof st == "string", "Invalid SVG element type"), document.createElementNS(m, st);
            }
          }
          s.DOMSVGFactory = ye;
          class Fe {
            constructor({
              viewBox: st,
              scale: ot,
              rotation: ht,
              offsetX: vt = 0,
              offsetY: At = 0,
              dontFlip: gt = !1
            }) {
              this.viewBox = st, this.scale = ot, this.rotation = ht, this.offsetX = vt, this.offsetY = At;
              const bt = (st[2] + st[0]) / 2, wt = (st[3] + st[1]) / 2;
              let Ot, yt, Qe, nt;
              switch (ht = ht % 360, ht = ht < 0 ? ht + 360 : ht, ht) {
                case 180:
                  Ot = -1, yt = 0, Qe = 0, nt = 1;
                  break;
                case 90:
                  Ot = 0, yt = 1, Qe = 1, nt = 0;
                  break;
                case 270:
                  Ot = 0, yt = -1, Qe = -1, nt = 0;
                  break;
                case 0:
                  Ot = 1, yt = 0, Qe = 0, nt = -1;
                  break;
                default:
                  throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
              }
              gt && (Qe = -Qe, nt = -nt);
              let rt, lt, ct, ft;
              Ot === 0 ? (rt = Math.abs(wt - st[1]) * ot + vt, lt = Math.abs(bt - st[0]) * ot + At, ct = Math.abs(st[3] - st[1]) * ot, ft = Math.abs(st[2] - st[0]) * ot) : (rt = Math.abs(bt - st[0]) * ot + vt, lt = Math.abs(wt - st[1]) * ot + At, ct = Math.abs(st[2] - st[0]) * ot, ft = Math.abs(st[3] - st[1]) * ot), this.transform = [Ot * ot, yt * ot, Qe * ot, nt * ot, rt - Ot * ot * bt - Qe * ot * wt, lt - yt * ot * bt - nt * ot * wt], this.width = ct, this.height = ft;
            }
            clone({
              scale: st = this.scale,
              rotation: ot = this.rotation,
              offsetX: ht = this.offsetX,
              offsetY: vt = this.offsetY,
              dontFlip: At = !1
            } = {}) {
              return new Fe({
                viewBox: this.viewBox.slice(),
                scale: st,
                rotation: ot,
                offsetX: ht,
                offsetY: vt,
                dontFlip: At
              });
            }
            convertToViewportPoint(st, ot) {
              return l.Util.applyTransform([st, ot], this.transform);
            }
            convertToViewportRectangle(st) {
              const ot = l.Util.applyTransform([st[0], st[1]], this.transform), ht = l.Util.applyTransform([st[2], st[3]], this.transform);
              return [ot[0], ot[1], ht[0], ht[1]];
            }
            convertToPdfPoint(st, ot) {
              return l.Util.applyInverseTransform([st, ot], this.transform);
            }
          }
          s.PageViewport = Fe;
          class Ue extends l.BaseException {
            constructor(st, ot) {
              super(st), this.type = ot;
            }
          }
          s.RenderingCancelledException = Ue;
          const Le = {
            NONE: 0,
            SELF: 1,
            BLANK: 2,
            PARENT: 3,
            TOP: 4
          };
          s.LinkTarget = Le;
          function Ze(ut, {
            url: st,
            target: ot,
            rel: ht,
            enabled: vt = !0
          } = {}) {
            (0, l.assert)(st && typeof st == "string", 'addLinkAttributes: A valid "url" parameter must provided.');
            const At = (0, l.removeNullCharacters)(st);
            vt ? ut.href = ut.title = At : (ut.href = "", ut.title = `Disabled: ${At}`, ut.onclick = () => !1);
            let gt = "";
            switch (ot) {
              case Le.NONE:
                break;
              case Le.SELF:
                gt = "_self";
                break;
              case Le.BLANK:
                gt = "_blank";
                break;
              case Le.PARENT:
                gt = "_parent";
                break;
              case Le.TOP:
                gt = "_top";
                break;
            }
            ut.target = gt, ut.rel = typeof ht == "string" ? ht : h;
          }
          function Xe(ut) {
            const st = ut.indexOf("#"), ot = ut.indexOf("?"), ht = Math.min(st > 0 ? st : ut.length, ot > 0 ? ot : ut.length);
            return ut.substring(ut.lastIndexOf("/", ht) + 1, ht);
          }
          class Je {
            constructor() {
              this.started = /* @__PURE__ */ Object.create(null), this.times = [];
            }
            time(st) {
              st in this.started && (0, l.warn)(`Timer is already running for ${st}`), this.started[st] = Date.now();
            }
            timeEnd(st) {
              st in this.started || (0, l.warn)(`Timer has not been started for ${st}`), this.times.push({
                name: st,
                start: this.started[st],
                end: Date.now()
              }), delete this.started[st];
            }
            toString() {
              const st = [];
              let ot = 0;
              for (const ht of this.times) {
                const vt = ht.name;
                vt.length > ot && (ot = vt.length);
              }
              for (const ht of this.times) {
                const vt = ht.end - ht.start;
                st.push(`${ht.name.padEnd(ot)} ${vt}ms
`);
              }
              return st.join("");
            }
          }
          s.StatTimer = Je;
          function it() {
            return typeof fetch < "u" && typeof Response < "u" && "body" in Response.prototype && typeof ReadableStream < "u";
          }
          function et(ut, st) {
            try {
              const {
                protocol: ot
              } = st ? new URL(ut, st) : new URL(ut);
              return ot === "http:" || ot === "https:";
            } catch {
              return !1;
            }
          }
          function at(ut) {
            return new Promise((st, ot) => {
              const ht = document.createElement("script");
              ht.src = ut, ht.onload = st, ht.onerror = function() {
                ot(new Error(`Cannot load script at: ${ht.src}`));
              }, (document.head || document.documentElement).appendChild(ht);
            });
          }
          function $e(ut) {
            console.log("Deprecated API usage: " + ut);
          }
          let Ke;
          class tt {
            static toDateObject(st) {
              if (!st || !(0, l.isString)(st))
                return null;
              Ke || (Ke = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
              const ot = Ke.exec(st);
              if (!ot)
                return null;
              const ht = parseInt(ot[1], 10);
              let vt = parseInt(ot[2], 10);
              vt = vt >= 1 && vt <= 12 ? vt - 1 : 0;
              let At = parseInt(ot[3], 10);
              At = At >= 1 && At <= 31 ? At : 1;
              let gt = parseInt(ot[4], 10);
              gt = gt >= 0 && gt <= 23 ? gt : 0;
              let bt = parseInt(ot[5], 10);
              bt = bt >= 0 && bt <= 59 ? bt : 0;
              let wt = parseInt(ot[6], 10);
              wt = wt >= 0 && wt <= 59 ? wt : 0;
              const Ot = ot[7] || "Z";
              let yt = parseInt(ot[8], 10);
              yt = yt >= 0 && yt <= 23 ? yt : 0;
              let Qe = parseInt(ot[9], 10) || 0;
              return Qe = Qe >= 0 && Qe <= 59 ? Qe : 0, Ot === "-" ? (gt += yt, bt += Qe) : Ot === "+" && (gt -= yt, bt -= Qe), new Date(Date.UTC(ht, vt, At, gt, bt, wt));
            }
          }
          s.PDFDateString = tt;
        },
        /* 2 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.arrayByteLength = qt, s.arraysToBytes = jt, s.assert = gt, s.bytesToString = Ct, s.createPromiseCapability = Zt, s.escapeString = Jt, s.getModificationDate = kt, s.getVerbosityLevel = ot, s.info = ht, s.isArrayBuffer = Yt, s.isArrayEqual = Rt, s.isBool = zt, s.isNum = Xt, s.isString = Vt, s.isSameOrigin = bt, s.createValidAbsoluteUrl = Ot, s.removeNullCharacters = Et, s.setVerbosityLevel = st, s.shadow = yt, s.string32 = St, s.stringToBytes = Tt, s.stringToPDFString = Gt, s.stringToUTF8String = er, s.utf8StringToString = Ht, s.warn = vt, s.unreachable = At, s.IsEvalSupportedCached = s.IsLittleEndianCached = s.createObjectURL = s.FormatError = s.Util = s.UnknownErrorException = s.UnexpectedResponseException = s.TextRenderingMode = s.StreamType = s.PermissionFlag = s.PasswordResponses = s.PasswordException = s.MissingPDFException = s.InvalidPDFException = s.AbortException = s.CMapCompressionType = s.ImageKind = s.FontType = s.AnnotationType = s.AnnotationStateModelType = s.AnnotationReviewState = s.AnnotationReplyType = s.AnnotationMarkedState = s.AnnotationFlag = s.AnnotationFieldFlag = s.AnnotationBorderStyleType = s.UNSUPPORTED_FEATURES = s.VerbosityLevel = s.OPS = s.IDENTITY_MATRIX = s.FONT_IDENTITY_MATRIX = s.BaseException = void 0, u(3);
          const l = [1, 0, 0, 1, 0, 0];
          s.IDENTITY_MATRIX = l;
          const h = [1e-3, 0, 0, 1e-3, 0, 0];
          s.FONT_IDENTITY_MATRIX = h;
          const m = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          s.PermissionFlag = m;
          const C = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          s.TextRenderingMode = C;
          const O = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          s.ImageKind = O;
          const le = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          s.AnnotationType = le;
          const We = {
            MARKED: "Marked",
            REVIEW: "Review"
          };
          s.AnnotationStateModelType = We;
          const ye = {
            MARKED: "Marked",
            UNMARKED: "Unmarked"
          };
          s.AnnotationMarkedState = ye;
          const Fe = {
            ACCEPTED: "Accepted",
            REJECTED: "Rejected",
            CANCELLED: "Cancelled",
            COMPLETED: "Completed",
            NONE: "None"
          };
          s.AnnotationReviewState = Fe;
          const Ue = {
            GROUP: "Group",
            REPLY: "R"
          };
          s.AnnotationReplyType = Ue;
          const Le = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          s.AnnotationFlag = Le;
          const Ze = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          s.AnnotationFieldFlag = Ze;
          const Xe = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          s.AnnotationBorderStyleType = Xe;
          const Je = {
            UNKNOWN: "UNKNOWN",
            FLATE: "FLATE",
            LZW: "LZW",
            DCT: "DCT",
            JPX: "JPX",
            JBIG: "JBIG",
            A85: "A85",
            AHX: "AHX",
            CCF: "CCF",
            RLX: "RLX"
          };
          s.StreamType = Je;
          const it = {
            UNKNOWN: "UNKNOWN",
            TYPE1: "TYPE1",
            TYPE1C: "TYPE1C",
            CIDFONTTYPE0: "CIDFONTTYPE0",
            CIDFONTTYPE0C: "CIDFONTTYPE0C",
            TRUETYPE: "TRUETYPE",
            CIDFONTTYPE2: "CIDFONTTYPE2",
            TYPE3: "TYPE3",
            OPENTYPE: "OPENTYPE",
            TYPE0: "TYPE0",
            MMTYPE1: "MMTYPE1"
          };
          s.FontType = it;
          const et = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          s.VerbosityLevel = et;
          const at = {
            NONE: 0,
            BINARY: 1,
            STREAM: 2
          };
          s.CMapCompressionType = at;
          const $e = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotations: 78,
            endAnnotations: 79,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintJpegXObject: 82,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          s.OPS = $e;
          const Ke = {
            unknown: "unknown",
            forms: "forms",
            javaScript: "javaScript",
            smask: "smask",
            shadingPattern: "shadingPattern",
            font: "font",
            errorTilingPattern: "errorTilingPattern",
            errorExtGState: "errorExtGState",
            errorXObject: "errorXObject",
            errorFontLoadType3: "errorFontLoadType3",
            errorFontState: "errorFontState",
            errorFontMissing: "errorFontMissing",
            errorFontTranslate: "errorFontTranslate",
            errorColorSpace: "errorColorSpace",
            errorOperatorList: "errorOperatorList",
            errorFontToUnicode: "errorFontToUnicode",
            errorFontLoadNative: "errorFontLoadNative",
            errorFontGetPath: "errorFontGetPath",
            errorMarkedContent: "errorMarkedContent"
          };
          s.UNSUPPORTED_FEATURES = Ke;
          const tt = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          s.PasswordResponses = tt;
          let ut = et.WARNINGS;
          function st(xt) {
            Number.isInteger(xt) && (ut = xt);
          }
          function ot() {
            return ut;
          }
          function ht(xt) {
            ut >= et.INFOS && console.log(`Info: ${xt}`);
          }
          function vt(xt) {
            ut >= et.WARNINGS && console.log(`Warning: ${xt}`);
          }
          function At(xt) {
            throw new Error(xt);
          }
          function gt(xt, It) {
            xt || At(It);
          }
          function bt(xt, It) {
            let Pt;
            try {
              if (Pt = new URL(xt), !Pt.origin || Pt.origin === "null")
                return !1;
            } catch {
              return !1;
            }
            const Lt = new URL(It, Pt);
            return Pt.origin === Lt.origin;
          }
          function wt(xt) {
            if (!xt)
              return !1;
            switch (xt.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }
          function Ot(xt, It) {
            if (!xt)
              return null;
            try {
              const Pt = It ? new URL(xt, It) : new URL(xt);
              if (wt(Pt))
                return Pt;
            } catch {
            }
            return null;
          }
          function yt(xt, It, Pt) {
            return Object.defineProperty(xt, It, {
              value: Pt,
              enumerable: !0,
              configurable: !0,
              writable: !1
            }), Pt;
          }
          const Qe = function() {
            function It(Pt) {
              this.constructor === It && At("Cannot initialize BaseException."), this.message = Pt, this.name = this.constructor.name;
            }
            return It.prototype = new Error(), It.constructor = It, It;
          }();
          s.BaseException = Qe;
          class nt extends Qe {
            constructor(It, Pt) {
              super(It), this.code = Pt;
            }
          }
          s.PasswordException = nt;
          class rt extends Qe {
            constructor(It, Pt) {
              super(It), this.details = Pt;
            }
          }
          s.UnknownErrorException = rt;
          class lt extends Qe {
          }
          s.InvalidPDFException = lt;
          class ct extends Qe {
          }
          s.MissingPDFException = ct;
          class ft extends Qe {
            constructor(It, Pt) {
              super(It), this.status = Pt;
            }
          }
          s.UnexpectedResponseException = ft;
          class pt extends Qe {
          }
          s.FormatError = pt;
          class mt extends Qe {
          }
          s.AbortException = mt;
          const dt = /\x00/g;
          function Et(xt) {
            return typeof xt != "string" ? (vt("The argument for removeNullCharacters must be a string."), xt) : xt.replace(dt, "");
          }
          function Ct(xt) {
            gt(xt !== null && typeof xt == "object" && xt.length !== void 0, "Invalid argument for bytesToString");
            const It = xt.length, Pt = 8192;
            if (It < Pt)
              return String.fromCharCode.apply(null, xt);
            const Lt = [];
            for (let Ut = 0; Ut < It; Ut += Pt) {
              const Qt = Math.min(Ut + Pt, It), _t = xt.subarray(Ut, Qt);
              Lt.push(String.fromCharCode.apply(null, _t));
            }
            return Lt.join("");
          }
          function Tt(xt) {
            gt(typeof xt == "string", "Invalid argument for stringToBytes");
            const It = xt.length, Pt = new Uint8Array(It);
            for (let Lt = 0; Lt < It; ++Lt)
              Pt[Lt] = xt.charCodeAt(Lt) & 255;
            return Pt;
          }
          function qt(xt) {
            return xt.length !== void 0 ? xt.length : (gt(xt.byteLength !== void 0, "arrayByteLength - invalid argument."), xt.byteLength);
          }
          function jt(xt) {
            const It = xt.length;
            if (It === 1 && xt[0] instanceof Uint8Array)
              return xt[0];
            let Pt = 0;
            for (let Qt = 0; Qt < It; Qt++)
              Pt += qt(xt[Qt]);
            let Lt = 0;
            const Ut = new Uint8Array(Pt);
            for (let Qt = 0; Qt < It; Qt++) {
              let _t = xt[Qt];
              _t instanceof Uint8Array || (typeof _t == "string" ? _t = Tt(_t) : _t = new Uint8Array(_t));
              const tr = _t.byteLength;
              Ut.set(_t, Lt), Lt += tr;
            }
            return Ut;
          }
          function St(xt) {
            return String.fromCharCode(xt >> 24 & 255, xt >> 16 & 255, xt >> 8 & 255, xt & 255);
          }
          function Mt() {
            const xt = new Uint8Array(4);
            return xt[0] = 1, new Uint32Array(xt.buffer, 0, 1)[0] === 1;
          }
          const Dt = {
            get value() {
              return yt(this, "value", Mt());
            }
          };
          s.IsLittleEndianCached = Dt;
          function Nt() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }
          const Kt = {
            get value() {
              return yt(this, "value", Nt());
            }
          };
          s.IsEvalSupportedCached = Kt;
          const Ft = ["rgb(", 0, ",", 0, ",", 0, ")"];
          class Bt {
            static makeCssRgb(It, Pt, Lt) {
              return Ft[1] = It, Ft[3] = Pt, Ft[5] = Lt, Ft.join("");
            }
            static transform(It, Pt) {
              return [It[0] * Pt[0] + It[2] * Pt[1], It[1] * Pt[0] + It[3] * Pt[1], It[0] * Pt[2] + It[2] * Pt[3], It[1] * Pt[2] + It[3] * Pt[3], It[0] * Pt[4] + It[2] * Pt[5] + It[4], It[1] * Pt[4] + It[3] * Pt[5] + It[5]];
            }
            static applyTransform(It, Pt) {
              const Lt = It[0] * Pt[0] + It[1] * Pt[2] + Pt[4], Ut = It[0] * Pt[1] + It[1] * Pt[3] + Pt[5];
              return [Lt, Ut];
            }
            static applyInverseTransform(It, Pt) {
              const Lt = Pt[0] * Pt[3] - Pt[1] * Pt[2], Ut = (It[0] * Pt[3] - It[1] * Pt[2] + Pt[2] * Pt[5] - Pt[4] * Pt[3]) / Lt, Qt = (-It[0] * Pt[1] + It[1] * Pt[0] + Pt[4] * Pt[1] - Pt[5] * Pt[0]) / Lt;
              return [Ut, Qt];
            }
            static getAxialAlignedBoundingBox(It, Pt) {
              const Lt = Bt.applyTransform(It, Pt), Ut = Bt.applyTransform(It.slice(2, 4), Pt), Qt = Bt.applyTransform([It[0], It[3]], Pt), _t = Bt.applyTransform([It[2], It[1]], Pt);
              return [Math.min(Lt[0], Ut[0], Qt[0], _t[0]), Math.min(Lt[1], Ut[1], Qt[1], _t[1]), Math.max(Lt[0], Ut[0], Qt[0], _t[0]), Math.max(Lt[1], Ut[1], Qt[1], _t[1])];
            }
            static inverseTransform(It) {
              const Pt = It[0] * It[3] - It[1] * It[2];
              return [It[3] / Pt, -It[1] / Pt, -It[2] / Pt, It[0] / Pt, (It[2] * It[5] - It[4] * It[3]) / Pt, (It[4] * It[1] - It[5] * It[0]) / Pt];
            }
            static apply3dTransform(It, Pt) {
              return [It[0] * Pt[0] + It[1] * Pt[1] + It[2] * Pt[2], It[3] * Pt[0] + It[4] * Pt[1] + It[5] * Pt[2], It[6] * Pt[0] + It[7] * Pt[1] + It[8] * Pt[2]];
            }
            static singularValueDecompose2dScale(It) {
              const Pt = [It[0], It[2], It[1], It[3]], Lt = It[0] * Pt[0] + It[1] * Pt[2], Ut = It[0] * Pt[1] + It[1] * Pt[3], Qt = It[2] * Pt[0] + It[3] * Pt[2], _t = It[2] * Pt[1] + It[3] * Pt[3], tr = (Lt + _t) / 2, rr = Math.sqrt((Lt + _t) * (Lt + _t) - 4 * (Lt * _t - Qt * Ut)) / 2, nr = tr + rr || 1, ar = tr - rr || 1;
              return [Math.sqrt(nr), Math.sqrt(ar)];
            }
            static normalizeRect(It) {
              const Pt = It.slice(0);
              return It[0] > It[2] && (Pt[0] = It[2], Pt[2] = It[0]), It[1] > It[3] && (Pt[1] = It[3], Pt[3] = It[1]), Pt;
            }
            static intersect(It, Pt) {
              function Lt(tr, rr) {
                return tr - rr;
              }
              const Ut = [It[0], It[2], Pt[0], Pt[2]].sort(Lt), Qt = [It[1], It[3], Pt[1], Pt[3]].sort(Lt), _t = [];
              if (It = Bt.normalizeRect(It), Pt = Bt.normalizeRect(Pt), Ut[0] === It[0] && Ut[1] === Pt[0] || Ut[0] === Pt[0] && Ut[1] === It[0])
                _t[0] = Ut[1], _t[2] = Ut[2];
              else
                return null;
              if (Qt[0] === It[1] && Qt[1] === Pt[1] || Qt[0] === Pt[1] && Qt[1] === It[1])
                _t[1] = Qt[1], _t[3] = Qt[2];
              else
                return null;
              return _t;
            }
          }
          s.Util = Bt;
          const $t = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function Gt(xt) {
            const It = xt.length, Pt = [];
            if (xt[0] === "þ" && xt[1] === "ÿ")
              for (let Lt = 2; Lt < It; Lt += 2)
                Pt.push(String.fromCharCode(xt.charCodeAt(Lt) << 8 | xt.charCodeAt(Lt + 1)));
            else if (xt[0] === "ÿ" && xt[1] === "þ")
              for (let Lt = 2; Lt < It; Lt += 2)
                Pt.push(String.fromCharCode(xt.charCodeAt(Lt + 1) << 8 | xt.charCodeAt(Lt)));
            else
              for (let Lt = 0; Lt < It; ++Lt) {
                const Ut = $t[xt.charCodeAt(Lt)];
                Pt.push(Ut ? String.fromCharCode(Ut) : xt.charAt(Lt));
              }
            return Pt.join("");
          }
          function Jt(xt) {
            return xt.replace(/([\(\)\\])/g, "\\$1");
          }
          function er(xt) {
            return decodeURIComponent(escape(xt));
          }
          function Ht(xt) {
            return unescape(encodeURIComponent(xt));
          }
          function zt(xt) {
            return typeof xt == "boolean";
          }
          function Xt(xt) {
            return typeof xt == "number";
          }
          function Vt(xt) {
            return typeof xt == "string";
          }
          function Yt(xt) {
            return typeof xt == "object" && xt !== null && xt.byteLength !== void 0;
          }
          function Rt(xt, It) {
            return xt.length !== It.length ? !1 : xt.every(function(Pt, Lt) {
              return Pt === It[Lt];
            });
          }
          function kt(xt = new Date(Date.now())) {
            return [xt.getUTCFullYear().toString(), (xt.getUTCMonth() + 1).toString().padStart(2, "0"), (xt.getUTCDate() + 1).toString().padStart(2, "0"), xt.getUTCHours().toString().padStart(2, "0"), xt.getUTCMinutes().toString().padStart(2, "0"), xt.getUTCSeconds().toString().padStart(2, "0")].join("");
          }
          function Zt() {
            const xt = /* @__PURE__ */ Object.create(null);
            let It = !1;
            return Object.defineProperty(xt, "settled", {
              get() {
                return It;
              }
            }), xt.promise = new Promise(function(Pt, Lt) {
              xt.resolve = function(Ut) {
                It = !0, Pt(Ut);
              }, xt.reject = function(Ut) {
                It = !0, Lt(Ut);
              };
            }), xt;
          }
          const Wt = function() {
            const It = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            return function(Lt, Ut, Qt = !1) {
              if (!Qt && URL.createObjectURL) {
                const tr = new Blob([Lt], {
                  type: Ut
                });
                return URL.createObjectURL(tr);
              }
              let _t = `data:${Ut};base64,`;
              for (let tr = 0, rr = Lt.length; tr < rr; tr += 3) {
                const nr = Lt[tr] & 255, ar = Lt[tr + 1] & 255, or = Lt[tr + 2] & 255, sr = nr >> 2, ur = (nr & 3) << 4 | ar >> 4, lr = tr + 1 < rr ? (ar & 15) << 2 | or >> 6 : 64, cr = tr + 2 < rr ? or & 63 : 64;
                _t += It[sr] + It[ur] + It[lr] + It[cr];
              }
              return _t;
            };
          }();
          s.createObjectURL = Wt;
        },
        /* 3 */
        /***/
        function(o, s, u) {
          u(4);
        },
        /* 4 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.isNodeJS = void 0;
          const l = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          s.isNodeJS = l;
        },
        /* 5 */
        /***/
        function(module, exports, __w_pdfjs_require__) {
          Object.defineProperty(exports, "__esModule", {
            value: !0
          }), exports.getDocument = getDocument, exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory, exports.build = exports.version = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFWorker = exports.PDFDataRangeTransport = exports.LoopbackPort = void 0;
          var _util = __w_pdfjs_require__(2), _display_utils = __w_pdfjs_require__(1), _font_loader = __w_pdfjs_require__(6), _node_utils = __w_pdfjs_require__(7), _annotation_storage = __w_pdfjs_require__(8), _api_compatibility = __w_pdfjs_require__(9), _canvas = __w_pdfjs_require__(10), _worker_options = __w_pdfjs_require__(12), _is_node = __w_pdfjs_require__(4), _message_handler = __w_pdfjs_require__(13), _metadata = __w_pdfjs_require__(14), _optional_content_config = __w_pdfjs_require__(16), _transport_stream = __w_pdfjs_require__(17), _webgl = __w_pdfjs_require__(18);
          const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100, DefaultCanvasFactory = _is_node.isNodeJS ? _node_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory, DefaultCMapReaderFactory = _is_node.isNodeJS ? _node_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
          let createPDFNetworkStream;
          function setPDFNetworkStreamFactory(o) {
            createPDFNetworkStream = o;
          }
          function getDocument(o) {
            const s = new PDFDocumentLoadingTask();
            let u;
            if (typeof o == "string")
              u = {
                url: o
              };
            else if ((0, _util.isArrayBuffer)(o))
              u = {
                data: o
              };
            else if (o instanceof PDFDataRangeTransport)
              u = {
                range: o
              };
            else {
              if (typeof o != "object")
                throw new Error("Invalid parameter in getDocument, need either Uint8Array, string or a parameter object");
              if (!o.url && !o.data && !o.range)
                throw new Error("Invalid parameter object: need either .data, .range or .url");
              u = o;
            }
            const l = /* @__PURE__ */ Object.create(null);
            let h = null, m = null;
            for (const O in u) {
              if (O === "url" && typeof window < "u") {
                l[O] = new URL(u[O], window.location).href;
                continue;
              } else if (O === "range") {
                h = u[O];
                continue;
              } else if (O === "worker") {
                m = u[O];
                continue;
              } else if (O === "data" && !(u[O] instanceof Uint8Array)) {
                const le = u[O];
                if (typeof le == "string")
                  l[O] = (0, _util.stringToBytes)(le);
                else if (typeof le == "object" && le !== null && !isNaN(le.length))
                  l[O] = new Uint8Array(le);
                else if ((0, _util.isArrayBuffer)(le))
                  l[O] = new Uint8Array(le);
                else
                  throw new Error("Invalid PDF binary data: either typed array, string or array-like object is expected in the data property.");
                continue;
              }
              l[O] = u[O];
            }
            if (l.rangeChunkSize = l.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE, l.CMapReaderFactory = l.CMapReaderFactory || DefaultCMapReaderFactory, l.ignoreErrors = l.stopAtErrors !== !0, l.fontExtraProperties = l.fontExtraProperties === !0, l.pdfBug = l.pdfBug === !0, Number.isInteger(l.maxImageSize) || (l.maxImageSize = -1), typeof l.isEvalSupported != "boolean" && (l.isEvalSupported = !0), typeof l.disableFontFace != "boolean" && (l.disableFontFace = _api_compatibility.apiCompatibilityParams.disableFontFace || !1), typeof l.ownerDocument > "u" && (l.ownerDocument = globalThis.document), typeof l.disableRange != "boolean" && (l.disableRange = !1), typeof l.disableStream != "boolean" && (l.disableStream = !1), typeof l.disableAutoFetch != "boolean" && (l.disableAutoFetch = !1), (0, _util.setVerbosityLevel)(l.verbosity), !m) {
              const O = {
                verbosity: l.verbosity,
                port: _worker_options.GlobalWorkerOptions.workerPort
              };
              m = O.port ? PDFWorker.fromPort(O) : new PDFWorker(O), s._worker = m;
            }
            const C = s.docId;
            return m.promise.then(function() {
              if (s.destroyed)
                throw new Error("Loading aborted");
              const O = _fetchDocument(m, l, h, C), le = new Promise(function(We) {
                let ye;
                h ? ye = new _transport_stream.PDFDataTransportStream({
                  length: l.length,
                  initialData: l.initialData,
                  progressiveDone: l.progressiveDone,
                  disableRange: l.disableRange,
                  disableStream: l.disableStream
                }, h) : l.data || (ye = createPDFNetworkStream({
                  url: l.url,
                  length: l.length,
                  httpHeaders: l.httpHeaders,
                  withCredentials: l.withCredentials,
                  rangeChunkSize: l.rangeChunkSize,
                  disableRange: l.disableRange,
                  disableStream: l.disableStream
                })), We(ye);
              });
              return Promise.all([O, le]).then(function([We, ye]) {
                if (s.destroyed)
                  throw new Error("Loading aborted");
                const Fe = new _message_handler.MessageHandler(C, We, m.port);
                Fe.postMessageTransfers = m.postMessageTransfers;
                const Ue = new WorkerTransport(Fe, s, ye, l);
                s._transport = Ue, Fe.send("Ready", null);
              });
            }).catch(s._capability.reject), s;
          }
          function _fetchDocument(o, s, u, l) {
            return o.destroyed ? Promise.reject(new Error("Worker was destroyed")) : (u && (s.length = u.length, s.initialData = u.initialData, s.progressiveDone = u.progressiveDone), o.messageHandler.sendWithPromise("GetDocRequest", {
              docId: l,
              apiVersion: "2.6.347",
              source: {
                data: s.data,
                url: s.url,
                password: s.password,
                disableAutoFetch: s.disableAutoFetch,
                rangeChunkSize: s.rangeChunkSize,
                length: s.length
              },
              maxImageSize: s.maxImageSize,
              disableFontFace: s.disableFontFace,
              postMessageTransfers: o.postMessageTransfers,
              docBaseUrl: s.docBaseUrl,
              ignoreErrors: s.ignoreErrors,
              isEvalSupported: s.isEvalSupported,
              fontExtraProperties: s.fontExtraProperties
            }).then(function(h) {
              if (o.destroyed)
                throw new Error("Worker was destroyed");
              return h;
            }));
          }
          const PDFDocumentLoadingTask = function() {
            let s = 0;
            class u {
              constructor() {
                this._capability = (0, _util.createPromiseCapability)(), this._transport = null, this._worker = null, this.docId = "d" + s++, this.destroyed = !1, this.onPassword = null, this.onProgress = null, this.onUnsupportedFeature = null;
              }
              get promise() {
                return this._capability.promise;
              }
              destroy() {
                return this.destroyed = !0, (this._transport ? this._transport.destroy() : Promise.resolve()).then(() => {
                  this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
                });
              }
            }
            return u;
          }();
          class PDFDataRangeTransport {
            constructor(s, u, l = !1) {
              this.length = s, this.initialData = u, this.progressiveDone = l, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = (0, _util.createPromiseCapability)();
            }
            addRangeListener(s) {
              this._rangeListeners.push(s);
            }
            addProgressListener(s) {
              this._progressListeners.push(s);
            }
            addProgressiveReadListener(s) {
              this._progressiveReadListeners.push(s);
            }
            addProgressiveDoneListener(s) {
              this._progressiveDoneListeners.push(s);
            }
            onDataRange(s, u) {
              for (const l of this._rangeListeners)
                l(s, u);
            }
            onDataProgress(s, u) {
              this._readyCapability.promise.then(() => {
                for (const l of this._progressListeners)
                  l(s, u);
              });
            }
            onDataProgressiveRead(s) {
              this._readyCapability.promise.then(() => {
                for (const u of this._progressiveReadListeners)
                  u(s);
              });
            }
            onDataProgressiveDone() {
              this._readyCapability.promise.then(() => {
                for (const s of this._progressiveDoneListeners)
                  s();
              });
            }
            transportReady() {
              this._readyCapability.resolve();
            }
            requestDataRange(s, u) {
              (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
            }
            abort() {
            }
          }
          exports.PDFDataRangeTransport = PDFDataRangeTransport;
          class PDFDocumentProxy {
            constructor(s, u) {
              this._pdfInfo = s, this._transport = u;
            }
            get annotationStorage() {
              return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
            }
            get numPages() {
              return this._pdfInfo.numPages;
            }
            get fingerprint() {
              return this._pdfInfo.fingerprint;
            }
            getPage(s) {
              return this._transport.getPage(s);
            }
            getPageIndex(s) {
              return this._transport.getPageIndex(s);
            }
            getDestinations() {
              return this._transport.getDestinations();
            }
            getDestination(s) {
              return this._transport.getDestination(s);
            }
            getPageLabels() {
              return this._transport.getPageLabels();
            }
            getPageLayout() {
              return this._transport.getPageLayout();
            }
            getPageMode() {
              return this._transport.getPageMode();
            }
            getViewerPreferences() {
              return this._transport.getViewerPreferences();
            }
            getOpenAction() {
              return this._transport.getOpenAction();
            }
            getAttachments() {
              return this._transport.getAttachments();
            }
            getJavaScript() {
              return this._transport.getJavaScript();
            }
            getOutline() {
              return this._transport.getOutline();
            }
            getOptionalContentConfig() {
              return this._transport.getOptionalContentConfig();
            }
            getPermissions() {
              return this._transport.getPermissions();
            }
            getMetadata() {
              return this._transport.getMetadata();
            }
            getData() {
              return this._transport.getData();
            }
            getDownloadInfo() {
              return this._transport.downloadInfoCapability.promise;
            }
            getStats() {
              return this._transport.getStats();
            }
            cleanup() {
              return this._transport.startCleanup();
            }
            destroy() {
              return this.loadingTask.destroy();
            }
            get loadingParams() {
              return this._transport.loadingParams;
            }
            get loadingTask() {
              return this._transport.loadingTask;
            }
            saveDocument(s) {
              return this._transport.saveDocument(s);
            }
          }
          exports.PDFDocumentProxy = PDFDocumentProxy;
          class PDFPageProxy {
            constructor(s, u, l, h, m = !1) {
              this._pageIndex = s, this._pageInfo = u, this._ownerDocument = h, this._transport = l, this._stats = m ? new _display_utils.StatTimer() : null, this._pdfBug = m, this.commonObjs = l.commonObjs, this.objs = new PDFObjects(), this.cleanupAfterRender = !1, this.pendingCleanup = !1, this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
            }
            get pageNumber() {
              return this._pageIndex + 1;
            }
            get rotate() {
              return this._pageInfo.rotate;
            }
            get ref() {
              return this._pageInfo.ref;
            }
            get userUnit() {
              return this._pageInfo.userUnit;
            }
            get view() {
              return this._pageInfo.view;
            }
            getViewport({
              scale: s,
              rotation: u = this.rotate,
              offsetX: l = 0,
              offsetY: h = 0,
              dontFlip: m = !1
            } = {}) {
              return new _display_utils.PageViewport({
                viewBox: this.view,
                scale: s,
                rotation: u,
                offsetX: l,
                offsetY: h,
                dontFlip: m
              });
            }
            getAnnotations({
              intent: s = null
            } = {}) {
              return (!this.annotationsPromise || this.annotationsIntent !== s) && (this.annotationsPromise = this._transport.getAnnotations(this._pageIndex, s), this.annotationsIntent = s), this.annotationsPromise;
            }
            render({
              canvasContext: s,
              viewport: u,
              intent: l = "display",
              enableWebGL: h = !1,
              renderInteractiveForms: m = !1,
              transform: C = null,
              imageLayer: O = null,
              canvasFactory: le = null,
              background: We = null,
              annotationStorage: ye = null,
              optionalContentConfigPromise: Fe = null
            }) {
              this._stats && this._stats.time("Overall");
              const Ue = l === "print" ? "print" : "display";
              this.pendingCleanup = !1, Fe || (Fe = this._transport.getOptionalContentConfig());
              let Le = this._intentStates.get(Ue);
              Le || (Le = /* @__PURE__ */ Object.create(null), this._intentStates.set(Ue, Le)), Le.streamReaderCancelTimeout && (clearTimeout(Le.streamReaderCancelTimeout), Le.streamReaderCancelTimeout = null);
              const Ze = le || new DefaultCanvasFactory({
                ownerDocument: this._ownerDocument
              }), Xe = new _webgl.WebGLContext({
                enable: h
              });
              Le.displayReadyCapability || (Le.displayReadyCapability = (0, _util.createPromiseCapability)(), Le.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1
              }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList({
                pageIndex: this._pageIndex,
                intent: Ue,
                renderInteractiveForms: m === !0,
                annotationStorage: ye && ye.getAll() || null
              }));
              const Je = (at) => {
                const $e = Le.renderTasks.indexOf(it);
                $e >= 0 && Le.renderTasks.splice($e, 1), (this.cleanupAfterRender || Ue === "print") && (this.pendingCleanup = !0), this._tryCleanup(), at ? (it.capability.reject(at), this._abortOperatorList({
                  intentState: Le,
                  reason: at
                })) : it.capability.resolve(), this._stats && (this._stats.timeEnd("Rendering"), this._stats.timeEnd("Overall"));
              }, it = new InternalRenderTask({
                callback: Je,
                params: {
                  canvasContext: s,
                  viewport: u,
                  transform: C,
                  imageLayer: O,
                  background: We
                },
                objs: this.objs,
                commonObjs: this.commonObjs,
                operatorList: Le.operatorList,
                pageIndex: this._pageIndex,
                canvasFactory: Ze,
                webGLContext: Xe,
                useRequestAnimationFrame: Ue !== "print",
                pdfBug: this._pdfBug
              });
              Le.renderTasks || (Le.renderTasks = []), Le.renderTasks.push(it);
              const et = it.task;
              return Promise.all([Le.displayReadyCapability.promise, Fe]).then(([at, $e]) => {
                if (this.pendingCleanup) {
                  Je();
                  return;
                }
                this._stats && this._stats.time("Rendering"), it.initializeGraphics({
                  transparency: at,
                  optionalContentConfig: $e
                }), it.operatorListChanged();
              }).catch(Je), et;
            }
            getOperatorList() {
              function s() {
                if (l.operatorList.lastChunk) {
                  l.opListReadCapability.resolve(l.operatorList);
                  const m = l.renderTasks.indexOf(h);
                  m >= 0 && l.renderTasks.splice(m, 1);
                }
              }
              const u = "oplist";
              let l = this._intentStates.get(u);
              l || (l = /* @__PURE__ */ Object.create(null), this._intentStates.set(u, l));
              let h;
              return l.opListReadCapability || (h = /* @__PURE__ */ Object.create(null), h.operatorListChanged = s, l.opListReadCapability = (0, _util.createPromiseCapability)(), l.renderTasks = [], l.renderTasks.push(h), l.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1
              }, this._stats && this._stats.time("Page Request"), this._pumpOperatorList({
                pageIndex: this._pageIndex,
                intent: u
              })), l.opListReadCapability.promise;
            }
            streamTextContent({
              normalizeWhitespace: s = !1,
              disableCombineTextItems: u = !1
            } = {}) {
              return this._transport.messageHandler.sendWithStream("GetTextContent", {
                pageIndex: this._pageIndex,
                normalizeWhitespace: s === !0,
                combineTextItems: u !== !0
              }, {
                highWaterMark: 100,
                size(h) {
                  return h.items.length;
                }
              });
            }
            getTextContent(s = {}) {
              const u = this.streamTextContent(s);
              return new Promise(function(l, h) {
                function m() {
                  C.read().then(function({
                    value: le,
                    done: We
                  }) {
                    if (We) {
                      l(O);
                      return;
                    }
                    Object.assign(O.styles, le.styles), O.items.push(...le.items), m();
                  }, h);
                }
                const C = u.getReader(), O = {
                  items: [],
                  styles: /* @__PURE__ */ Object.create(null)
                };
                m();
              });
            }
            _destroy() {
              this.destroyed = !0, this._transport.pageCache[this._pageIndex] = null;
              const s = [];
              for (const [u, l] of this._intentStates)
                if (this._abortOperatorList({
                  intentState: l,
                  reason: new Error("Page was destroyed."),
                  force: !0
                }), u !== "oplist")
                  for (const h of l.renderTasks)
                    s.push(h.completed), h.cancel();
              return this.objs.clear(), this.annotationsPromise = null, this.pendingCleanup = !1, Promise.all(s);
            }
            cleanup(s = !1) {
              return this.pendingCleanup = !0, this._tryCleanup(s);
            }
            _tryCleanup(s = !1) {
              if (!this.pendingCleanup)
                return !1;
              for (const {
                renderTasks: u,
                operatorList: l
              } of this._intentStates.values())
                if (u.length !== 0 || !l.lastChunk)
                  return !1;
              return this._intentStates.clear(), this.objs.clear(), this.annotationsPromise = null, s && this._stats && (this._stats = new _display_utils.StatTimer()), this.pendingCleanup = !1, !0;
            }
            _startRenderPage(s, u) {
              const l = this._intentStates.get(u);
              l && (this._stats && this._stats.timeEnd("Page Request"), l.displayReadyCapability && l.displayReadyCapability.resolve(s));
            }
            _renderPageChunk(s, u) {
              for (let l = 0, h = s.length; l < h; l++)
                u.operatorList.fnArray.push(s.fnArray[l]), u.operatorList.argsArray.push(s.argsArray[l]);
              u.operatorList.lastChunk = s.lastChunk;
              for (let l = 0; l < u.renderTasks.length; l++)
                u.renderTasks[l].operatorListChanged();
              s.lastChunk && this._tryCleanup();
            }
            _pumpOperatorList(s) {
              (0, _util.assert)(s.intent, 'PDFPageProxy._pumpOperatorList: Expected "intent" argument.');
              const l = this._transport.messageHandler.sendWithStream("GetOperatorList", s).getReader(), h = this._intentStates.get(s.intent);
              h.streamReader = l;
              const m = () => {
                l.read().then(({
                  value: C,
                  done: O
                }) => {
                  if (O) {
                    h.streamReader = null;
                    return;
                  }
                  this._transport.destroyed || (this._renderPageChunk(C, h), m());
                }, (C) => {
                  if (h.streamReader = null, !this._transport.destroyed) {
                    if (h.operatorList) {
                      h.operatorList.lastChunk = !0;
                      for (let O = 0; O < h.renderTasks.length; O++)
                        h.renderTasks[O].operatorListChanged();
                      this._tryCleanup();
                    }
                    if (h.displayReadyCapability)
                      h.displayReadyCapability.reject(C);
                    else if (h.opListReadCapability)
                      h.opListReadCapability.reject(C);
                    else
                      throw C;
                  }
                });
              };
              m();
            }
            _abortOperatorList({
              intentState: s,
              reason: u,
              force: l = !1
            }) {
              if ((0, _util.assert)(u instanceof Error || typeof u == "object" && u !== null, 'PDFPageProxy._abortOperatorList: Expected "reason" argument.'), !!s.streamReader) {
                if (!l) {
                  if (s.renderTasks.length !== 0)
                    return;
                  if (u instanceof _display_utils.RenderingCancelledException) {
                    s.streamReaderCancelTimeout = setTimeout(() => {
                      this._abortOperatorList({
                        intentState: s,
                        reason: u,
                        force: !0
                      }), s.streamReaderCancelTimeout = null;
                    }, RENDERING_CANCELLED_TIMEOUT);
                    return;
                  }
                }
                if (s.streamReader.cancel(new _util.AbortException(u && u.message)), s.streamReader = null, !this._transport.destroyed) {
                  for (const [h, m] of this._intentStates)
                    if (m === s) {
                      this._intentStates.delete(h);
                      break;
                    }
                  this.cleanup();
                }
              }
            }
            get stats() {
              return this._stats;
            }
          }
          exports.PDFPageProxy = PDFPageProxy;
          class LoopbackPort {
            constructor(s = !0) {
              this._listeners = [], this._defer = s, this._deferred = Promise.resolve(void 0);
            }
            postMessage(s, u) {
              function l(C) {
                if (typeof C != "object" || C === null)
                  return C;
                if (h.has(C))
                  return h.get(C);
                let O, le;
                if ((O = C.buffer) && (0, _util.isArrayBuffer)(O))
                  return u && u.includes(O) ? le = new C.constructor(O, C.byteOffset, C.byteLength) : le = new C.constructor(C), h.set(C, le), le;
                le = Array.isArray(C) ? [] : {}, h.set(C, le);
                for (const We in C) {
                  let ye, Fe = C;
                  for (; !(ye = Object.getOwnPropertyDescriptor(Fe, We)); )
                    Fe = Object.getPrototypeOf(Fe);
                  if (!(typeof ye.value > "u")) {
                    if (typeof ye.value == "function") {
                      if (C.hasOwnProperty && C.hasOwnProperty(We))
                        throw new Error(`LoopbackPort.postMessage - cannot clone: ${C[We]}`);
                      continue;
                    }
                    le[We] = l(ye.value);
                  }
                }
                return le;
              }
              if (!this._defer) {
                this._listeners.forEach((C) => {
                  C.call(this, {
                    data: s
                  });
                });
                return;
              }
              const h = /* @__PURE__ */ new WeakMap(), m = {
                data: l(s)
              };
              this._deferred.then(() => {
                this._listeners.forEach((C) => {
                  C.call(this, m);
                });
              });
            }
            addEventListener(s, u) {
              this._listeners.push(u);
            }
            removeEventListener(s, u) {
              const l = this._listeners.indexOf(u);
              this._listeners.splice(l, 1);
            }
            terminate() {
              this._listeners.length = 0;
            }
          }
          exports.LoopbackPort = LoopbackPort;
          const PDFWorker = function PDFWorkerClosure() {
            const pdfWorkerPorts = /* @__PURE__ */ new WeakMap();
            let isWorkerDisabled = !1, fallbackWorkerSrc, nextFakeWorkerId = 0, fakeWorkerCapability;
            if (_is_node.isNodeJS && typeof commonjsRequire == "function")
              isWorkerDisabled = !0, fallbackWorkerSrc = "./pdf.worker.js";
            else if (typeof document == "object" && "currentScript" in document) {
              const o = document.currentScript && document.currentScript.src;
              o && (fallbackWorkerSrc = o.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
            }
            function getWorkerSrc() {
              if (_worker_options.GlobalWorkerOptions.workerSrc)
                return _worker_options.GlobalWorkerOptions.workerSrc;
              if (typeof fallbackWorkerSrc < "u")
                return _is_node.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), fallbackWorkerSrc;
              throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
            }
            function getMainThreadWorkerMessageHandler() {
              let o;
              try {
                o = globalThis.pdfjsWorker && globalThis.pdfjsWorker.WorkerMessageHandler;
              } catch {
              }
              return o || null;
            }
            function setupFakeWorkerGlobal() {
              if (fakeWorkerCapability)
                return fakeWorkerCapability.promise;
              fakeWorkerCapability = (0, _util.createPromiseCapability)();
              const loader = async function() {
                const mainWorkerMessageHandler = getMainThreadWorkerMessageHandler();
                if (mainWorkerMessageHandler)
                  return mainWorkerMessageHandler;
                if (_is_node.isNodeJS && typeof commonjsRequire == "function") {
                  const worker = eval("require")(getWorkerSrc());
                  return worker.WorkerMessageHandler;
                }
                return await (0, _display_utils.loadScript)(getWorkerSrc()), window.pdfjsWorker.WorkerMessageHandler;
              };
              return loader().then(fakeWorkerCapability.resolve, fakeWorkerCapability.reject), fakeWorkerCapability.promise;
            }
            function createCDNWrapper(o) {
              const s = "importScripts('" + o + "');";
              return URL.createObjectURL(new Blob([s]));
            }
            class PDFWorker {
              constructor({
                name: s = null,
                port: u = null,
                verbosity: l = (0, _util.getVerbosityLevel)()
              } = {}) {
                if (u && pdfWorkerPorts.has(u))
                  throw new Error("Cannot use more than one PDFWorker per port");
                if (this.name = s, this.destroyed = !1, this.postMessageTransfers = !0, this.verbosity = l, this._readyCapability = (0, _util.createPromiseCapability)(), this._port = null, this._webWorker = null, this._messageHandler = null, u) {
                  pdfWorkerPorts.set(u, this), this._initializeFromPort(u);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(s) {
                this._port = s, this._messageHandler = new _message_handler.MessageHandler("main", "worker", s), this._messageHandler.on("ready", function() {
                }), this._readyCapability.resolve();
              }
              _initialize() {
                if (typeof Worker < "u" && !isWorkerDisabled && !getMainThreadWorkerMessageHandler()) {
                  let s = getWorkerSrc();
                  try {
                    (0, _util.isSameOrigin)(window.location.href, s) || (s = createCDNWrapper(new URL(s, window.location).href));
                    const u = new Worker(s), l = new _message_handler.MessageHandler("main", "worker", u), h = () => {
                      u.removeEventListener("error", m), l.destroy(), u.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                    }, m = () => {
                      this._webWorker || h();
                    };
                    u.addEventListener("error", m), l.on("test", (O) => {
                      if (u.removeEventListener("error", m), this.destroyed) {
                        h();
                        return;
                      }
                      O ? (this._messageHandler = l, this._port = u, this._webWorker = u, O.supportTransfers || (this.postMessageTransfers = !1), this._readyCapability.resolve(), l.send("configure", {
                        verbosity: this.verbosity
                      })) : (this._setupFakeWorker(), l.destroy(), u.terminate());
                    }), l.on("ready", (O) => {
                      if (u.removeEventListener("error", m), this.destroyed) {
                        h();
                        return;
                      }
                      try {
                        C();
                      } catch {
                        this._setupFakeWorker();
                      }
                    });
                    const C = () => {
                      const O = new Uint8Array([this.postMessageTransfers ? 255 : 0]);
                      try {
                        l.send("test", O, [O.buffer]);
                      } catch {
                        (0, _util.warn)("Cannot use postMessage transfers."), O[0] = 0, l.send("test", O);
                      }
                    };
                    C();
                    return;
                  } catch {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), isWorkerDisabled = !0), setupFakeWorkerGlobal().then((s) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const u = new LoopbackPort();
                  this._port = u;
                  const l = "fake" + nextFakeWorkerId++, h = new _message_handler.MessageHandler(l + "_worker", l, u);
                  s.setup(h, u);
                  const m = new _message_handler.MessageHandler(l, l + "_worker", u);
                  this._messageHandler = m, this._readyCapability.resolve(), m.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((s) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${s.message}".`));
                });
              }
              destroy() {
                this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), pdfWorkerPorts.delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
              }
              static fromPort(s) {
                if (!s || !s.port)
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                return pdfWorkerPorts.has(s.port) ? pdfWorkerPorts.get(s.port) : new PDFWorker(s);
              }
              static getWorkerSrc() {
                return getWorkerSrc();
              }
            }
            return PDFWorker;
          }();
          exports.PDFWorker = PDFWorker;
          class WorkerTransport {
            constructor(s, u, l, h) {
              this.messageHandler = s, this.loadingTask = u, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                docId: u.docId,
                onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                ownerDocument: h.ownerDocument
              }), this._params = h, this.CMapReaderFactory = new h.CMapReaderFactory({
                baseUrl: h.cMapUrl,
                isCompressed: h.cMapPacked
              }), this.destroyed = !1, this.destroyCapability = null, this._passwordCapability = null, this._networkStream = l, this._fullReader = null, this._lastProgress = null, this.pageCache = [], this.pagePromises = [], this.downloadInfoCapability = (0, _util.createPromiseCapability)(), this.setupMessageHandler();
            }
            destroy() {
              if (this.destroyCapability)
                return this.destroyCapability.promise;
              this.destroyed = !0, this.destroyCapability = (0, _util.createPromiseCapability)(), this._passwordCapability && this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
              const s = [];
              this.pageCache.forEach(function(l) {
                l && s.push(l._destroy());
              }), this.pageCache.length = 0, this.pagePromises.length = 0;
              const u = this.messageHandler.sendWithPromise("Terminate", null);
              return s.push(u), Promise.all(s).then(() => {
                this.fontLoader.clear(), this._networkStream && this._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
              }, this.destroyCapability.reject), this.destroyCapability.promise;
            }
            setupMessageHandler() {
              const {
                messageHandler: s,
                loadingTask: u
              } = this;
              s.on("GetReader", (l, h) => {
                (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (m) => {
                  this._lastProgress = {
                    loaded: m.loaded,
                    total: m.total
                  };
                }, h.onPull = () => {
                  this._fullReader.read().then(function({
                    value: m,
                    done: C
                  }) {
                    if (C) {
                      h.close();
                      return;
                    }
                    (0, _util.assert)((0, _util.isArrayBuffer)(m), "GetReader - expected an ArrayBuffer."), h.enqueue(new Uint8Array(m), 1, [m]);
                  }).catch((m) => {
                    h.error(m);
                  });
                }, h.onCancel = (m) => {
                  this._fullReader.cancel(m), h.ready.catch((C) => {
                    if (!this.destroyed)
                      throw C;
                  });
                };
              }), s.on("ReaderHeadersReady", (l) => {
                const h = (0, _util.createPromiseCapability)(), m = this._fullReader;
                return m.headersReady.then(() => {
                  (!m.isStreamingSupported || !m.isRangeSupported) && (this._lastProgress && u.onProgress && u.onProgress(this._lastProgress), m.onProgress = (C) => {
                    u.onProgress && u.onProgress({
                      loaded: C.loaded,
                      total: C.total
                    });
                  }), h.resolve({
                    isStreamingSupported: m.isStreamingSupported,
                    isRangeSupported: m.isRangeSupported,
                    contentLength: m.contentLength
                  });
                }, h.reject), h.promise;
              }), s.on("GetRangeReader", (l, h) => {
                (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                const m = this._networkStream.getRangeReader(l.begin, l.end);
                if (!m) {
                  h.close();
                  return;
                }
                h.onPull = () => {
                  m.read().then(function({
                    value: C,
                    done: O
                  }) {
                    if (O) {
                      h.close();
                      return;
                    }
                    (0, _util.assert)((0, _util.isArrayBuffer)(C), "GetRangeReader - expected an ArrayBuffer."), h.enqueue(new Uint8Array(C), 1, [C]);
                  }).catch((C) => {
                    h.error(C);
                  });
                }, h.onCancel = (C) => {
                  m.cancel(C), h.ready.catch((O) => {
                    if (!this.destroyed)
                      throw O;
                  });
                };
              }), s.on("GetDoc", ({
                pdfInfo: l
              }) => {
                this._numPages = l.numPages, u._capability.resolve(new PDFDocumentProxy(l, this));
              }), s.on("DocException", function(l) {
                let h;
                switch (l.name) {
                  case "PasswordException":
                    h = new _util.PasswordException(l.message, l.code);
                    break;
                  case "InvalidPDFException":
                    h = new _util.InvalidPDFException(l.message);
                    break;
                  case "MissingPDFException":
                    h = new _util.MissingPDFException(l.message);
                    break;
                  case "UnexpectedResponseException":
                    h = new _util.UnexpectedResponseException(l.message, l.status);
                    break;
                  case "UnknownErrorException":
                    h = new _util.UnknownErrorException(l.message, l.details);
                    break;
                }
                if (!(h instanceof Error)) {
                  const m = "DocException - expected a valid Error.";
                  (0, _util.warn)(m);
                }
                u._capability.reject(h);
              }), s.on("PasswordRequest", (l) => {
                if (this._passwordCapability = (0, _util.createPromiseCapability)(), u.onPassword) {
                  const h = (m) => {
                    this._passwordCapability.resolve({
                      password: m
                    });
                  };
                  try {
                    u.onPassword(h, l.code);
                  } catch (m) {
                    this._passwordCapability.reject(m);
                  }
                } else
                  this._passwordCapability.reject(new _util.PasswordException(l.message, l.code));
                return this._passwordCapability.promise;
              }), s.on("DataLoaded", (l) => {
                u.onProgress && u.onProgress({
                  loaded: l.length,
                  total: l.length
                }), this.downloadInfoCapability.resolve(l);
              }), s.on("StartRenderPage", (l) => {
                if (this.destroyed)
                  return;
                this.pageCache[l.pageIndex]._startRenderPage(l.transparency, l.intent);
              }), s.on("commonobj", (l) => {
                if (this.destroyed)
                  return;
                const [h, m, C] = l;
                if (!this.commonObjs.has(h))
                  switch (m) {
                    case "Font":
                      const O = this._params;
                      if ("error" in C) {
                        const ye = C.error;
                        (0, _util.warn)(`Error during font loading: ${ye}`), this.commonObjs.resolve(h, ye);
                        break;
                      }
                      let le = null;
                      O.pdfBug && globalThis.FontInspector && globalThis.FontInspector.enabled && (le = {
                        registerFont(ye, Fe) {
                          globalThis.FontInspector.fontAdded(ye, Fe);
                        }
                      });
                      const We = new _font_loader.FontFaceObject(C, {
                        isEvalSupported: O.isEvalSupported,
                        disableFontFace: O.disableFontFace,
                        ignoreErrors: O.ignoreErrors,
                        onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                        fontRegistry: le
                      });
                      this.fontLoader.bind(We).catch((ye) => s.sendWithPromise("FontFallback", {
                        id: h
                      })).finally(() => {
                        !O.fontExtraProperties && We.data && (We.data = null), this.commonObjs.resolve(h, We);
                      });
                      break;
                    case "FontPath":
                    case "Image":
                      this.commonObjs.resolve(h, C);
                      break;
                    default:
                      throw new Error(`Got unknown common object type ${m}`);
                  }
              }), s.on("obj", (l) => {
                if (this.destroyed)
                  return;
                const [h, m, C, O] = l, le = this.pageCache[m];
                if (!le.objs.has(h))
                  switch (C) {
                    case "Image":
                      le.objs.resolve(h, O);
                      const We = 8e6;
                      O && "data" in O && O.data.length > We && (le.cleanupAfterRender = !0);
                      break;
                    default:
                      throw new Error(`Got unknown object type ${C}`);
                  }
              }), s.on("DocProgress", (l) => {
                this.destroyed || u.onProgress && u.onProgress({
                  loaded: l.loaded,
                  total: l.total
                });
              }), s.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this)), s.on("FetchBuiltInCMap", (l, h) => {
                if (this.destroyed) {
                  h.error(new Error("Worker was destroyed"));
                  return;
                }
                let m = !1;
                h.onPull = () => {
                  if (m) {
                    h.close();
                    return;
                  }
                  m = !0, this.CMapReaderFactory.fetch(l).then(function(C) {
                    h.enqueue(C, 1, [C.cMapData.buffer]);
                  }).catch(function(C) {
                    h.error(C);
                  });
                };
              });
            }
            _onUnsupportedFeature({
              featureId: s
            }) {
              this.destroyed || this.loadingTask.onUnsupportedFeature && this.loadingTask.onUnsupportedFeature(s);
            }
            getData() {
              return this.messageHandler.sendWithPromise("GetData", null);
            }
            getPage(s) {
              if (!Number.isInteger(s) || s <= 0 || s > this._numPages)
                return Promise.reject(new Error("Invalid page request"));
              const u = s - 1;
              if (u in this.pagePromises)
                return this.pagePromises[u];
              const l = this.messageHandler.sendWithPromise("GetPage", {
                pageIndex: u
              }).then((h) => {
                if (this.destroyed)
                  throw new Error("Transport destroyed");
                const m = new PDFPageProxy(u, h, this, this._params.ownerDocument, this._params.pdfBug);
                return this.pageCache[u] = m, m;
              });
              return this.pagePromises[u] = l, l;
            }
            getPageIndex(s) {
              return this.messageHandler.sendWithPromise("GetPageIndex", {
                ref: s
              }).catch(function(u) {
                return Promise.reject(new Error(u));
              });
            }
            getAnnotations(s, u) {
              return this.messageHandler.sendWithPromise("GetAnnotations", {
                pageIndex: s,
                intent: u
              });
            }
            saveDocument(s) {
              return this.messageHandler.sendWithPromise("SaveDocument", {
                numPages: this._numPages,
                annotationStorage: s && s.getAll() || null,
                filename: this._fullReader ? this._fullReader.filename : null
              }).finally(() => {
                s && s.resetModified();
              });
            }
            getDestinations() {
              return this.messageHandler.sendWithPromise("GetDestinations", null);
            }
            getDestination(s) {
              return typeof s != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                id: s
              });
            }
            getPageLabels() {
              return this.messageHandler.sendWithPromise("GetPageLabels", null);
            }
            getPageLayout() {
              return this.messageHandler.sendWithPromise("GetPageLayout", null);
            }
            getPageMode() {
              return this.messageHandler.sendWithPromise("GetPageMode", null);
            }
            getViewerPreferences() {
              return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
            }
            getOpenAction() {
              return this.messageHandler.sendWithPromise("GetOpenAction", null);
            }
            getAttachments() {
              return this.messageHandler.sendWithPromise("GetAttachments", null);
            }
            getJavaScript() {
              return this.messageHandler.sendWithPromise("GetJavaScript", null);
            }
            getOutline() {
              return this.messageHandler.sendWithPromise("GetOutline", null);
            }
            getOptionalContentConfig() {
              return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((s) => new _optional_content_config.OptionalContentConfig(s));
            }
            getPermissions() {
              return this.messageHandler.sendWithPromise("GetPermissions", null);
            }
            getMetadata() {
              return this.messageHandler.sendWithPromise("GetMetadata", null).then((s) => ({
                info: s[0],
                metadata: s[1] ? new _metadata.Metadata(s[1]) : null,
                contentDispositionFilename: this._fullReader ? this._fullReader.filename : null
              }));
            }
            getStats() {
              return this.messageHandler.sendWithPromise("GetStats", null);
            }
            startCleanup() {
              return this.messageHandler.sendWithPromise("Cleanup", null).then(() => {
                for (let s = 0, u = this.pageCache.length; s < u; s++) {
                  const l = this.pageCache[s];
                  if (l && !l.cleanup())
                    throw new Error(`startCleanup: Page ${s + 1} is currently rendering.`);
                }
                this.commonObjs.clear(), this.fontLoader.clear();
              });
            }
            get loadingParams() {
              const s = this._params;
              return (0, _util.shadow)(this, "loadingParams", {
                disableAutoFetch: s.disableAutoFetch,
                disableFontFace: s.disableFontFace
              });
            }
          }
          class PDFObjects {
            constructor() {
              this._objs = /* @__PURE__ */ Object.create(null);
            }
            _ensureObj(s) {
              return this._objs[s] ? this._objs[s] : this._objs[s] = {
                capability: (0, _util.createPromiseCapability)(),
                data: null,
                resolved: !1
              };
            }
            get(s, u = null) {
              if (u)
                return this._ensureObj(s).capability.promise.then(u), null;
              const l = this._objs[s];
              if (!l || !l.resolved)
                throw new Error(`Requesting object that isn't resolved yet ${s}.`);
              return l.data;
            }
            has(s) {
              const u = this._objs[s];
              return u ? u.resolved : !1;
            }
            resolve(s, u) {
              const l = this._ensureObj(s);
              l.resolved = !0, l.data = u, l.capability.resolve(u);
            }
            clear() {
              this._objs = /* @__PURE__ */ Object.create(null);
            }
          }
          class RenderTask {
            constructor(s) {
              this._internalRenderTask = s, this.onContinue = null;
            }
            get promise() {
              return this._internalRenderTask.capability.promise;
            }
            cancel() {
              this._internalRenderTask.cancel();
            }
          }
          const InternalRenderTask = function o() {
            const s = /* @__PURE__ */ new WeakSet();
            class u {
              constructor({
                callback: h,
                params: m,
                objs: C,
                commonObjs: O,
                operatorList: le,
                pageIndex: We,
                canvasFactory: ye,
                webGLContext: Fe,
                useRequestAnimationFrame: Ue = !1,
                pdfBug: Le = !1
              }) {
                this.callback = h, this.params = m, this.objs = C, this.commonObjs = O, this.operatorListIdx = null, this.operatorList = le, this._pageIndex = We, this.canvasFactory = ye, this.webGLContext = Fe, this._pdfBug = Le, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = Ue === !0 && typeof window < "u", this.cancelled = !1, this.capability = (0, _util.createPromiseCapability)(), this.task = new RenderTask(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = m.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics({
                transparency: h = !1,
                optionalContentConfig: m
              }) {
                if (this.cancelled)
                  return;
                if (this._canvas) {
                  if (s.has(this._canvas))
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  s.add(this._canvas);
                }
                this._pdfBug && globalThis.StepperManager && globalThis.StepperManager.enabled && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                const {
                  canvasContext: C,
                  viewport: O,
                  transform: le,
                  imageLayer: We,
                  background: ye
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(C, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, We, m), this.gfx.beginDrawing({
                  transform: le,
                  viewport: O,
                  transparency: h,
                  background: ye
                }), this.operatorListIdx = 0, this.graphicsReady = !0, this.graphicsReadyCallback && this.graphicsReadyCallback();
              }
              cancel(h = null) {
                this.running = !1, this.cancelled = !0, this.gfx && this.gfx.endDrawing(), this._canvas && s.delete(this._canvas), this.callback(h || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, "canvas"));
              }
              operatorListChanged() {
                if (!this.graphicsReady) {
                  this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                  return;
                }
                this.stepper && this.stepper.updateOperatorList(this.operatorList), !this.running && this._continue();
              }
              _continue() {
                this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
              }
              _scheduleNext() {
                this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                  this._nextBound().catch(this.cancel.bind(this));
                }) : Promise.resolve().then(this._nextBound).catch(this.cancel.bind(this));
              }
              async _next() {
                this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), this._canvas && s.delete(this._canvas), this.callback())));
              }
            }
            return u;
          }(), version = "2.6.347";
          exports.version = version;
          const build = "3be9c65f";
          exports.build = build;
        },
        /* 6 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.FontLoader = s.FontFaceObject = void 0;
          var l = u(2);
          class h {
            constructor({
              docId: le,
              onUnsupportedFeature: We,
              ownerDocument: ye = globalThis.document
            }) {
              this.constructor === h && (0, l.unreachable)("Cannot initialize BaseFontLoader."), this.docId = le, this._onUnsupportedFeature = We, this._document = ye, this.nativeFontFaces = [], this.styleElement = null;
            }
            addNativeFontFace(le) {
              this.nativeFontFaces.push(le), this._document.fonts.add(le);
            }
            insertRule(le) {
              let We = this.styleElement;
              We || (We = this.styleElement = this._document.createElement("style"), We.id = `PDFJS_FONT_STYLE_TAG_${this.docId}`, this._document.documentElement.getElementsByTagName("head")[0].appendChild(We));
              const ye = We.sheet;
              ye.insertRule(le, ye.cssRules.length);
            }
            clear() {
              this.nativeFontFaces.forEach((le) => {
                this._document.fonts.delete(le);
              }), this.nativeFontFaces.length = 0, this.styleElement && (this.styleElement.remove(), this.styleElement = null);
            }
            async bind(le) {
              if (le.attached || le.missingFile)
                return;
              if (le.attached = !0, this.isFontLoadingAPISupported) {
                const ye = le.createNativeFontFace();
                if (ye) {
                  this.addNativeFontFace(ye);
                  try {
                    await ye.loaded;
                  } catch (Fe) {
                    throw this._onUnsupportedFeature({
                      featureId: l.UNSUPPORTED_FEATURES.errorFontLoadNative
                    }), (0, l.warn)(`Failed to load font '${ye.family}': '${Fe}'.`), le.disableFontFace = !0, Fe;
                  }
                }
                return;
              }
              const We = le.createFontFaceRule();
              if (We) {
                if (this.insertRule(We), this.isSyncFontLoadingSupported)
                  return;
                await new Promise((ye) => {
                  const Fe = this._queueLoadingCallback(ye);
                  this._prepareFontLoadEvent([We], [le], Fe);
                });
              }
            }
            _queueLoadingCallback(le) {
              (0, l.unreachable)("Abstract method `_queueLoadingCallback`.");
            }
            get isFontLoadingAPISupported() {
              const le = typeof this._document < "u" && !!this._document.fonts;
              return (0, l.shadow)(this, "isFontLoadingAPISupported", le);
            }
            get isSyncFontLoadingSupported() {
              (0, l.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
            }
            get _loadTestFont() {
              (0, l.unreachable)("Abstract method `_loadTestFont`.");
            }
            _prepareFontLoadEvent(le, We, ye) {
              (0, l.unreachable)("Abstract method `_prepareFontLoadEvent`.");
            }
          }
          let m;
          s.FontLoader = m, s.FontLoader = m = class extends h {
            constructor(le) {
              super(le), this.loadingContext = {
                requests: [],
                nextRequestId: 0
              }, this.loadTestFontId = 0;
            }
            get isSyncFontLoadingSupported() {
              let le = !1;
              if (typeof navigator > "u")
                le = !0;
              else {
                const We = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
                We && We[1] >= 14 && (le = !0);
              }
              return (0, l.shadow)(this, "isSyncFontLoadingSupported", le);
            }
            _queueLoadingCallback(le) {
              function We() {
                for ((0, l.assert)(!Fe.done, "completeRequest() cannot be called twice."), Fe.done = !0; ye.requests.length > 0 && ye.requests[0].done; ) {
                  const Ue = ye.requests.shift();
                  setTimeout(Ue.callback, 0);
                }
              }
              const ye = this.loadingContext, Fe = {
                id: `pdfjs-font-loading-${ye.nextRequestId++}`,
                done: !1,
                complete: We,
                callback: le
              };
              return ye.requests.push(Fe), Fe;
            }
            get _loadTestFont() {
              const le = function() {
                return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
              };
              return (0, l.shadow)(this, "_loadTestFont", le());
            }
            _prepareFontLoadEvent(le, We, ye) {
              function Fe(gt, bt) {
                return gt.charCodeAt(bt) << 24 | gt.charCodeAt(bt + 1) << 16 | gt.charCodeAt(bt + 2) << 8 | gt.charCodeAt(bt + 3) & 255;
              }
              function Ue(gt, bt, wt, Ot) {
                const yt = gt.substring(0, bt), Qe = gt.substring(bt + wt);
                return yt + Ot + Qe;
              }
              let Le, Ze;
              const Xe = this._document.createElement("canvas");
              Xe.width = 1, Xe.height = 1;
              const Je = Xe.getContext("2d");
              let it = 0;
              function et(gt, bt) {
                if (it++, it > 30) {
                  (0, l.warn)("Load test font never loaded."), bt();
                  return;
                }
                if (Je.font = "30px " + gt, Je.fillText(".", 0, 20), Je.getImageData(0, 0, 1, 1).data[3] > 0) {
                  bt();
                  return;
                }
                setTimeout(et.bind(null, gt, bt));
              }
              const at = `lt${Date.now()}${this.loadTestFontId++}`;
              let $e = this._loadTestFont;
              $e = Ue($e, 976, at.length, at);
              const tt = 16, ut = 1482184792;
              let st = Fe($e, tt);
              for (Le = 0, Ze = at.length - 3; Le < Ze; Le += 4)
                st = st - ut + Fe(at, Le) | 0;
              Le < at.length && (st = st - ut + Fe(at + "XXX", Le) | 0), $e = Ue($e, tt, 4, (0, l.string32)(st));
              const ot = `url(data:font/opentype;base64,${btoa($e)});`, ht = `@font-face {font-family:"${at}";src:${ot}}`;
              this.insertRule(ht);
              const vt = [];
              for (Le = 0, Ze = We.length; Le < Ze; Le++)
                vt.push(We[Le].loadedName);
              vt.push(at);
              const At = this._document.createElement("div");
              for (At.style.visibility = "hidden", At.style.width = At.style.height = "10px", At.style.position = "absolute", At.style.top = At.style.left = "0px", Le = 0, Ze = vt.length; Le < Ze; ++Le) {
                const gt = this._document.createElement("span");
                gt.textContent = "Hi", gt.style.fontFamily = vt[Le], At.appendChild(gt);
              }
              this._document.body.appendChild(At), et(at, () => {
                this._document.body.removeChild(At), ye.complete();
              });
            }
          };
          class C {
            constructor(le, {
              isEvalSupported: We = !0,
              disableFontFace: ye = !1,
              ignoreErrors: Fe = !1,
              onUnsupportedFeature: Ue = null,
              fontRegistry: Le = null
            }) {
              this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
              for (const Ze in le)
                this[Ze] = le[Ze];
              this.isEvalSupported = We !== !1, this.disableFontFace = ye === !0, this.ignoreErrors = Fe === !0, this._onUnsupportedFeature = Ue, this.fontRegistry = Le;
            }
            createNativeFontFace() {
              if (!this.data || this.disableFontFace)
                return null;
              const le = new FontFace(this.loadedName, this.data, {});
              return this.fontRegistry && this.fontRegistry.registerFont(this), le;
            }
            createFontFaceRule() {
              if (!this.data || this.disableFontFace)
                return null;
              const le = (0, l.bytesToString)(new Uint8Array(this.data)), We = `url(data:${this.mimetype};base64,${btoa(le)});`, ye = `@font-face {font-family:"${this.loadedName}";src:${We}}`;
              return this.fontRegistry && this.fontRegistry.registerFont(this, We), ye;
            }
            getPathGenerator(le, We) {
              if (this.compiledGlyphs[We] !== void 0)
                return this.compiledGlyphs[We];
              let ye, Fe;
              try {
                ye = le.get(this.loadedName + "_path_" + We);
              } catch (Ue) {
                if (!this.ignoreErrors)
                  throw Ue;
                return this._onUnsupportedFeature && this._onUnsupportedFeature({
                  featureId: l.UNSUPPORTED_FEATURES.errorFontGetPath
                }), (0, l.warn)(`getPathGenerator - ignoring character: "${Ue}".`), this.compiledGlyphs[We] = function(Le, Ze) {
                };
              }
              if (this.isEvalSupported && l.IsEvalSupportedCached.value) {
                let Ue, Le = "";
                for (let Ze = 0, Xe = ye.length; Ze < Xe; Ze++)
                  Fe = ye[Ze], Fe.args !== void 0 ? Ue = Fe.args.join(",") : Ue = "", Le += "c." + Fe.cmd + "(" + Ue + `);
`;
                return this.compiledGlyphs[We] = new Function("c", "size", Le);
              }
              return this.compiledGlyphs[We] = function(Ue, Le) {
                for (let Ze = 0, Xe = ye.length; Ze < Xe; Ze++)
                  Fe = ye[Ze], Fe.cmd === "scale" && (Fe.args = [Le, -Le]), Ue[Fe.cmd].apply(Ue, Fe.args);
              };
            }
          }
          s.FontFaceObject = C;
        },
        /* 7 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.NodeCMapReaderFactory = s.NodeCanvasFactory = void 0;
          var l = u(1), h = u(4), m = u(2);
          let C = class {
            constructor() {
              (0, m.unreachable)("Not implemented: NodeCanvasFactory");
            }
          };
          s.NodeCanvasFactory = C;
          let O = class {
            constructor() {
              (0, m.unreachable)("Not implemented: NodeCMapReaderFactory");
            }
          };
          s.NodeCMapReaderFactory = O, h.isNodeJS && (s.NodeCanvasFactory = C = class extends l.BaseCanvasFactory {
            create(le, We) {
              if (le <= 0 || We <= 0)
                throw new Error("Invalid canvas size");
              const Fe = require$$5.createCanvas(le, We);
              return {
                canvas: Fe,
                context: Fe.getContext("2d")
              };
            }
          }, s.NodeCMapReaderFactory = O = class extends l.BaseCMapReaderFactory {
            _fetchData(le, We) {
              return new Promise((ye, Fe) => {
                require$$5.readFile(le, (Le, Ze) => {
                  if (Le || !Ze) {
                    Fe(new Error(Le));
                    return;
                  }
                  ye({
                    cMapData: new Uint8Array(Ze),
                    compressionType: We
                  });
                });
              });
            }
          });
        },
        /* 8 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.AnnotationStorage = void 0;
          class l {
            constructor() {
              this._storage = /* @__PURE__ */ new Map(), this._modified = !1, this.onSetModified = null, this.onResetModified = null;
            }
            getOrCreateValue(m, C) {
              return this._storage.has(m) ? this._storage.get(m) : (this._storage.set(m, C), C);
            }
            setValue(m, C) {
              this._storage.get(m) !== C && this._setModified(), this._storage.set(m, C);
            }
            getAll() {
              return this._storage.size === 0 ? null : Object.fromEntries(this._storage);
            }
            get size() {
              return this._storage.size;
            }
            _setModified() {
              this._modified || (this._modified = !0, typeof this.onSetModified == "function" && this.onSetModified());
            }
            resetModified() {
              this._modified && (this._modified = !1, typeof this.onResetModified == "function" && this.onResetModified());
            }
          }
          s.AnnotationStorage = l;
        },
        /* 9 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.apiCompatibilityParams = void 0;
          var l = u(4);
          const h = /* @__PURE__ */ Object.create(null);
          (function() {
            l.isNodeJS && (h.disableFontFace = !0);
          })();
          const m = Object.freeze(h);
          s.apiCompatibilityParams = m;
        },
        /* 10 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.CanvasGraphics = void 0;
          var l = u(2), h = u(11), m = 16, C = 100, O = 4096, le = 0.65, We = 1e3, ye = 16;
          function Fe(Je) {
            Je.mozCurrentTransform || (Je._originalSave = Je.save, Je._originalRestore = Je.restore, Je._originalRotate = Je.rotate, Je._originalScale = Je.scale, Je._originalTranslate = Je.translate, Je._originalTransform = Je.transform, Je._originalSetTransform = Je.setTransform, Je._transformMatrix = Je._transformMatrix || [1, 0, 0, 1, 0, 0], Je._transformStack = [], Object.defineProperty(Je, "mozCurrentTransform", {
              get: function() {
                return this._transformMatrix;
              }
            }), Object.defineProperty(Je, "mozCurrentTransformInverse", {
              get: function() {
                var et = this._transformMatrix, at = et[0], $e = et[1], Ke = et[2], tt = et[3], ut = et[4], st = et[5], ot = at * tt - $e * Ke, ht = $e * Ke - at * tt;
                return [tt / ot, $e / ht, Ke / ht, at / ot, (tt * ut - Ke * st) / ht, ($e * ut - at * st) / ot];
              }
            }), Je.save = function() {
              var et = this._transformMatrix;
              this._transformStack.push(et), this._transformMatrix = et.slice(0, 6), this._originalSave();
            }, Je.restore = function() {
              var et = this._transformStack.pop();
              et && (this._transformMatrix = et, this._originalRestore());
            }, Je.translate = function(et, at) {
              var $e = this._transformMatrix;
              $e[4] = $e[0] * et + $e[2] * at + $e[4], $e[5] = $e[1] * et + $e[3] * at + $e[5], this._originalTranslate(et, at);
            }, Je.scale = function(et, at) {
              var $e = this._transformMatrix;
              $e[0] = $e[0] * et, $e[1] = $e[1] * et, $e[2] = $e[2] * at, $e[3] = $e[3] * at, this._originalScale(et, at);
            }, Je.transform = function(et, at, $e, Ke, tt, ut) {
              var st = this._transformMatrix;
              this._transformMatrix = [st[0] * et + st[2] * at, st[1] * et + st[3] * at, st[0] * $e + st[2] * Ke, st[1] * $e + st[3] * Ke, st[0] * tt + st[2] * ut + st[4], st[1] * tt + st[3] * ut + st[5]], Je._originalTransform(et, at, $e, Ke, tt, ut);
            }, Je.setTransform = function(et, at, $e, Ke, tt, ut) {
              this._transformMatrix = [et, at, $e, Ke, tt, ut], Je._originalSetTransform(et, at, $e, Ke, tt, ut);
            }, Je.rotate = function(et) {
              var at = Math.cos(et), $e = Math.sin(et), Ke = this._transformMatrix;
              this._transformMatrix = [Ke[0] * at + Ke[2] * $e, Ke[1] * at + Ke[3] * $e, Ke[0] * -$e + Ke[2] * at, Ke[1] * -$e + Ke[3] * at, Ke[4], Ke[5]], this._originalRotate(et);
            });
          }
          var Ue = function() {
            function it(et) {
              this.canvasFactory = et, this.cache = /* @__PURE__ */ Object.create(null);
            }
            return it.prototype = {
              getCanvas: function(at, $e, Ke, tt) {
                var ut;
                return this.cache[at] !== void 0 ? (ut = this.cache[at], this.canvasFactory.reset(ut, $e, Ke), ut.context.setTransform(1, 0, 0, 1, 0, 0)) : (ut = this.canvasFactory.create($e, Ke), this.cache[at] = ut), tt && Fe(ut.context), ut;
              },
              clear() {
                for (var et in this.cache) {
                  var at = this.cache[et];
                  this.canvasFactory.destroy(at), delete this.cache[et];
                }
              }
            }, it;
          }();
          function Le(Je) {
            var it = 1e3, et = Je.width, at = Je.height, $e, Ke, tt, ut = et + 1, st = new Uint8Array(ut * (at + 1)), ot = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), ht = et + 7 & -8, vt = Je.data, At = new Uint8Array(ht * at), gt = 0, bt;
            for ($e = 0, bt = vt.length; $e < bt; $e++)
              for (var wt = 128, Ot = vt[$e]; wt > 0; )
                At[gt++] = Ot & wt ? 0 : 255, wt >>= 1;
            var yt = 0;
            for (gt = 0, At[gt] !== 0 && (st[0] = 1, ++yt), Ke = 1; Ke < et; Ke++)
              At[gt] !== At[gt + 1] && (st[Ke] = At[gt] ? 2 : 1, ++yt), gt++;
            for (At[gt] !== 0 && (st[Ke] = 2, ++yt), $e = 1; $e < at; $e++) {
              gt = $e * ht, tt = $e * ut, At[gt - ht] !== At[gt] && (st[tt] = At[gt] ? 1 : 8, ++yt);
              var Qe = (At[gt] ? 4 : 0) + (At[gt - ht] ? 8 : 0);
              for (Ke = 1; Ke < et; Ke++)
                Qe = (Qe >> 2) + (At[gt + 1] ? 4 : 0) + (At[gt - ht + 1] ? 8 : 0), ot[Qe] && (st[tt + Ke] = ot[Qe], ++yt), gt++;
              if (At[gt - ht] !== At[gt] && (st[tt + Ke] = At[gt] ? 2 : 4, ++yt), yt > it)
                return null;
            }
            for (gt = ht * (at - 1), tt = $e * ut, At[gt] !== 0 && (st[tt] = 8, ++yt), Ke = 1; Ke < et; Ke++)
              At[gt] !== At[gt + 1] && (st[tt + Ke] = At[gt] ? 4 : 8, ++yt), gt++;
            if (At[gt] !== 0 && (st[tt + Ke] = 4, ++yt), yt > it)
              return null;
            var nt = new Int32Array([0, ut, -1, 0, -ut, 0, 0, 0, 1]), rt = [];
            for ($e = 0; yt && $e <= at; $e++) {
              for (var lt = $e * ut, ct = lt + et; lt < ct && !st[lt]; )
                lt++;
              if (lt !== ct) {
                var ft = [lt % ut, $e], pt = st[lt], mt = lt, dt;
                do {
                  var Et = nt[pt];
                  do
                    lt += Et;
                  while (!st[lt]);
                  dt = st[lt], dt !== 5 && dt !== 10 ? (pt = dt, st[lt] = 0) : (pt = dt & 51 * pt >> 4, st[lt] &= pt >> 2 | pt << 2), ft.push(lt % ut), ft.push(lt / ut | 0), st[lt] || --yt;
                } while (mt !== lt);
                rt.push(ft), --$e;
              }
            }
            var Ct = function(Tt) {
              Tt.save(), Tt.scale(1 / et, -1 / at), Tt.translate(0, -at), Tt.beginPath();
              for (let jt = 0, St = rt.length; jt < St; jt++) {
                var qt = rt[jt];
                Tt.moveTo(qt[0], qt[1]);
                for (let Mt = 2, Dt = qt.length; Mt < Dt; Mt += 2)
                  Tt.lineTo(qt[Mt], qt[Mt + 1]);
              }
              Tt.fill(), Tt.beginPath(), Tt.restore();
            };
            return Ct;
          }
          var Ze = function() {
            function it() {
              this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = l.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = l.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = l.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.resumeSMaskCtx = null, this.transferMaps = null;
            }
            return it.prototype = {
              clone: function() {
                return Object.create(this);
              },
              setCurrentPoint: function(at, $e) {
                this.x = at, this.y = $e;
              }
            }, it;
          }(), Xe = function() {
            var it = 15, et = 10;
            function at(Qe, nt, rt, lt, ct, ft, pt) {
              this.ctx = Qe, this.current = new Ze(), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = nt, this.objs = rt, this.canvasFactory = lt, this.webGLContext = ct, this.imageLayer = ft, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.contentVisible = !0, this.markedContentStack = [], this.optionalContentConfig = pt, this.cachedCanvases = new Ue(this.canvasFactory), Qe && Fe(Qe), this._cachedGetSinglePixelWidth = null;
            }
            function $e(Qe, nt, rt = null) {
              if (typeof ImageData < "u" && nt instanceof ImageData) {
                Qe.putImageData(nt, 0, 0);
                return;
              }
              var lt = nt.height, ct = nt.width, ft = lt % ye, pt = (lt - ft) / ye, mt = ft === 0 ? pt : pt + 1, dt = Qe.createImageData(ct, ye), Et = 0, Ct, Tt = nt.data, qt = dt.data, jt, St, Mt, Dt;
              let Nt, Kt, Ft, Bt;
              if (rt)
                switch (rt.length) {
                  case 1:
                    Nt = rt[0], Kt = rt[0], Ft = rt[0], Bt = rt[0];
                    break;
                  case 4:
                    Nt = rt[0], Kt = rt[1], Ft = rt[2], Bt = rt[3];
                    break;
                }
              if (nt.kind === l.ImageKind.GRAYSCALE_1BPP) {
                var $t = Tt.byteLength, Gt = new Uint32Array(qt.buffer, 0, qt.byteLength >> 2), Jt = Gt.length, er = ct + 7 >> 3, Ht = 4294967295, zt = l.IsLittleEndianCached.value ? 4278190080 : 255;
                for (Bt && Bt[0] === 255 && Bt[255] === 0 && ([Ht, zt] = [zt, Ht]), jt = 0; jt < mt; jt++) {
                  for (Mt = jt < pt ? ye : ft, Ct = 0, St = 0; St < Mt; St++) {
                    var Xt = $t - Et;
                    let Zt = 0;
                    for (var Vt = Xt > er ? ct : Xt * 8 - 7, Yt = Vt & -8, Rt = 0, kt = 0; Zt < Yt; Zt += 8)
                      kt = Tt[Et++], Gt[Ct++] = kt & 128 ? Ht : zt, Gt[Ct++] = kt & 64 ? Ht : zt, Gt[Ct++] = kt & 32 ? Ht : zt, Gt[Ct++] = kt & 16 ? Ht : zt, Gt[Ct++] = kt & 8 ? Ht : zt, Gt[Ct++] = kt & 4 ? Ht : zt, Gt[Ct++] = kt & 2 ? Ht : zt, Gt[Ct++] = kt & 1 ? Ht : zt;
                    for (; Zt < Vt; Zt++)
                      Rt === 0 && (kt = Tt[Et++], Rt = 128), Gt[Ct++] = kt & Rt ? Ht : zt, Rt >>= 1;
                  }
                  for (; Ct < Jt; )
                    Gt[Ct++] = 0;
                  Qe.putImageData(dt, 0, jt * ye);
                }
              } else if (nt.kind === l.ImageKind.RGBA_32BPP) {
                const Zt = !!(Nt || Kt || Ft);
                for (St = 0, Dt = ct * ye * 4, jt = 0; jt < pt; jt++) {
                  if (qt.set(Tt.subarray(Et, Et + Dt)), Et += Dt, Zt)
                    for (let Wt = 0; Wt < Dt; Wt += 4)
                      Nt && (qt[Wt + 0] = Nt[qt[Wt + 0]]), Kt && (qt[Wt + 1] = Kt[qt[Wt + 1]]), Ft && (qt[Wt + 2] = Ft[qt[Wt + 2]]);
                  Qe.putImageData(dt, 0, St), St += ye;
                }
                if (jt < mt) {
                  if (Dt = ct * ft * 4, qt.set(Tt.subarray(Et, Et + Dt)), Zt)
                    for (let Wt = 0; Wt < Dt; Wt += 4)
                      Nt && (qt[Wt + 0] = Nt[qt[Wt + 0]]), Kt && (qt[Wt + 1] = Kt[qt[Wt + 1]]), Ft && (qt[Wt + 2] = Ft[qt[Wt + 2]]);
                  Qe.putImageData(dt, 0, St);
                }
              } else if (nt.kind === l.ImageKind.RGB_24BPP) {
                const Zt = !!(Nt || Kt || Ft);
                for (Mt = ye, Dt = ct * Mt, jt = 0; jt < mt; jt++) {
                  for (jt >= pt && (Mt = ft, Dt = ct * Mt), Ct = 0, St = Dt; St--; )
                    qt[Ct++] = Tt[Et++], qt[Ct++] = Tt[Et++], qt[Ct++] = Tt[Et++], qt[Ct++] = 255;
                  if (Zt)
                    for (let Wt = 0; Wt < Ct; Wt += 4)
                      Nt && (qt[Wt + 0] = Nt[qt[Wt + 0]]), Kt && (qt[Wt + 1] = Kt[qt[Wt + 1]]), Ft && (qt[Wt + 2] = Ft[qt[Wt + 2]]);
                  Qe.putImageData(dt, 0, jt * ye);
                }
              } else
                throw new Error(`bad image kind: ${nt.kind}`);
            }
            function Ke(Qe, nt) {
              for (var rt = nt.height, lt = nt.width, ct = rt % ye, ft = (rt - ct) / ye, pt = ct === 0 ? ft : ft + 1, mt = Qe.createImageData(lt, ye), dt = 0, Et = nt.data, Ct = mt.data, Tt = 0; Tt < pt; Tt++) {
                for (var qt = Tt < ft ? ye : ct, jt = 3, St = 0; St < qt; St++)
                  for (var Mt = 0, Dt = 0; Dt < lt; Dt++) {
                    if (!Mt) {
                      var Nt = Et[dt++];
                      Mt = 128;
                    }
                    Ct[jt] = Nt & Mt ? 0 : 255, jt += 4, Mt >>= 1;
                  }
                Qe.putImageData(mt, 0, Tt * ye);
              }
            }
            function tt(Qe, nt) {
              for (var rt = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"], lt = 0, ct = rt.length; lt < ct; lt++) {
                var ft = rt[lt];
                Qe[ft] !== void 0 && (nt[ft] = Qe[ft]);
              }
              Qe.setLineDash !== void 0 && (nt.setLineDash(Qe.getLineDash()), nt.lineDashOffset = Qe.lineDashOffset);
            }
            function ut(Qe) {
              Qe.strokeStyle = "#000000", Qe.fillStyle = "#000000", Qe.fillRule = "nonzero", Qe.globalAlpha = 1, Qe.lineWidth = 1, Qe.lineCap = "butt", Qe.lineJoin = "miter", Qe.miterLimit = 10, Qe.globalCompositeOperation = "source-over", Qe.font = "10px sans-serif", Qe.setLineDash !== void 0 && (Qe.setLineDash([]), Qe.lineDashOffset = 0);
            }
            function st(Qe, nt, rt, lt) {
              for (var ct = Qe.length, ft = 3; ft < ct; ft += 4) {
                var pt = Qe[ft];
                if (pt === 0)
                  Qe[ft - 3] = nt, Qe[ft - 2] = rt, Qe[ft - 1] = lt;
                else if (pt < 255) {
                  var mt = 255 - pt;
                  Qe[ft - 3] = Qe[ft - 3] * pt + nt * mt >> 8, Qe[ft - 2] = Qe[ft - 2] * pt + rt * mt >> 8, Qe[ft - 1] = Qe[ft - 1] * pt + lt * mt >> 8;
                }
              }
            }
            function ot(Qe, nt, rt) {
              for (var lt = Qe.length, ct = 1 / 255, ft = 3; ft < lt; ft += 4) {
                var pt = rt ? rt[Qe[ft]] : Qe[ft];
                nt[ft] = nt[ft] * pt * ct | 0;
              }
            }
            function ht(Qe, nt, rt) {
              for (var lt = Qe.length, ct = 3; ct < lt; ct += 4) {
                var ft = Qe[ct - 3] * 77 + Qe[ct - 2] * 152 + Qe[ct - 1] * 28;
                nt[ct] = rt ? nt[ct] * rt[ft >> 8] >> 8 : nt[ct] * ft >> 16;
              }
            }
            function vt(Qe, nt, rt, lt, ct, ft, pt) {
              var mt = !!ft, dt = mt ? ft[0] : 0, Et = mt ? ft[1] : 0, Ct = mt ? ft[2] : 0, Tt;
              ct === "Luminosity" ? Tt = ht : Tt = ot;
              for (var qt = 1048576, jt = Math.min(lt, Math.ceil(qt / rt)), St = 0; St < lt; St += jt) {
                var Mt = Math.min(jt, lt - St), Dt = Qe.getImageData(0, St, rt, Mt), Nt = nt.getImageData(0, St, rt, Mt);
                mt && st(Dt.data, dt, Et, Ct), Tt(Dt.data, Nt.data, pt), Qe.putImageData(Nt, 0, St);
              }
            }
            function At(Qe, nt, rt, lt) {
              var ct = nt.canvas, ft = nt.context;
              Qe.setTransform(nt.scaleX, 0, 0, nt.scaleY, nt.offsetX, nt.offsetY);
              var pt = nt.backdrop || null;
              if (!nt.transferMap && lt.isEnabled) {
                const mt = lt.composeSMask({
                  layer: rt.canvas,
                  mask: ct,
                  properties: {
                    subtype: nt.subtype,
                    backdrop: pt
                  }
                });
                Qe.setTransform(1, 0, 0, 1, 0, 0), Qe.drawImage(mt, nt.offsetX, nt.offsetY);
                return;
              }
              vt(ft, rt, ct.width, ct.height, nt.subtype, pt, nt.transferMap), Qe.drawImage(ct, 0, 0);
            }
            var gt = ["butt", "round", "square"], bt = ["miter", "round", "bevel"], wt = {}, Ot = {};
            at.prototype = {
              beginDrawing({
                transform: Qe,
                viewport: nt,
                transparency: rt = !1,
                background: lt = null
              }) {
                var ct = this.ctx.canvas.width, ft = this.ctx.canvas.height;
                if (this.ctx.save(), this.ctx.fillStyle = lt || "rgb(255, 255, 255)", this.ctx.fillRect(0, 0, ct, ft), this.ctx.restore(), rt) {
                  var pt = this.cachedCanvases.getCanvas("transparent", ct, ft, !0);
                  this.compositeCtx = this.ctx, this.transparentCanvas = pt.canvas, this.ctx = pt.context, this.ctx.save(), this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                }
                this.ctx.save(), ut(this.ctx), Qe && this.ctx.transform.apply(this.ctx, Qe), this.ctx.transform.apply(this.ctx, nt.transform), this.baseTransform = this.ctx.mozCurrentTransform.slice(), this.imageLayer && this.imageLayer.beginLayout();
              },
              executeOperatorList: function(nt, rt, lt, ct) {
                var ft = nt.argsArray, pt = nt.fnArray, mt = rt || 0, dt = ft.length;
                if (dt === mt)
                  return mt;
                for (var Et = dt - mt > et && typeof lt == "function", Ct = Et ? Date.now() + it : 0, Tt = 0, qt = this.commonObjs, jt = this.objs, St; ; ) {
                  if (ct !== void 0 && mt === ct.nextBreakPoint)
                    return ct.breakIt(mt, lt), mt;
                  if (St = pt[mt], St !== l.OPS.dependency)
                    this[St].apply(this, ft[mt]);
                  else
                    for (const Mt of ft[mt]) {
                      const Dt = Mt.startsWith("g_") ? qt : jt;
                      if (!Dt.has(Mt))
                        return Dt.get(Mt, lt), mt;
                    }
                  if (mt++, mt === dt)
                    return mt;
                  if (Et && ++Tt > et) {
                    if (Date.now() > Ct)
                      return lt(), mt;
                    Tt = 0;
                  }
                }
              },
              endDrawing: function() {
                this.current.activeSMask !== null && this.endSMaskGroup(), this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null), this.cachedCanvases.clear(), this.webGLContext.clear(), this.imageLayer && this.imageLayer.endLayout();
              },
              setLineWidth: function(nt) {
                this.current.lineWidth = nt, this.ctx.lineWidth = nt;
              },
              setLineCap: function(nt) {
                this.ctx.lineCap = gt[nt];
              },
              setLineJoin: function(nt) {
                this.ctx.lineJoin = bt[nt];
              },
              setMiterLimit: function(nt) {
                this.ctx.miterLimit = nt;
              },
              setDash: function(nt, rt) {
                var lt = this.ctx;
                lt.setLineDash !== void 0 && (lt.setLineDash(nt), lt.lineDashOffset = rt);
              },
              setRenderingIntent(Qe) {
              },
              setFlatness(Qe) {
              },
              setGState: function(nt) {
                for (var rt = 0, lt = nt.length; rt < lt; rt++) {
                  var ct = nt[rt], ft = ct[0], pt = ct[1];
                  switch (ft) {
                    case "LW":
                      this.setLineWidth(pt);
                      break;
                    case "LC":
                      this.setLineCap(pt);
                      break;
                    case "LJ":
                      this.setLineJoin(pt);
                      break;
                    case "ML":
                      this.setMiterLimit(pt);
                      break;
                    case "D":
                      this.setDash(pt[0], pt[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(pt);
                      break;
                    case "FL":
                      this.setFlatness(pt);
                      break;
                    case "Font":
                      this.setFont(pt[0], pt[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = ct[1];
                      break;
                    case "ca":
                      this.current.fillAlpha = ct[1], this.ctx.globalAlpha = ct[1];
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = pt;
                      break;
                    case "SMask":
                      this.current.activeSMask && (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask ? this.suspendSMaskGroup() : this.endSMaskGroup()), this.current.activeSMask = pt ? this.tempSMask : null, this.current.activeSMask && this.beginSMaskGroup(), this.tempSMask = null;
                      break;
                    case "TR":
                      this.current.transferMaps = pt;
                  }
                }
              },
              beginSMaskGroup: function() {
                var nt = this.current.activeSMask, rt = nt.canvas.width, lt = nt.canvas.height, ct = "smaskGroupAt" + this.groupLevel, ft = this.cachedCanvases.getCanvas(ct, rt, lt, !0), pt = this.ctx, mt = pt.mozCurrentTransform;
                this.ctx.save();
                var dt = ft.context;
                dt.scale(1 / nt.scaleX, 1 / nt.scaleY), dt.translate(-nt.offsetX, -nt.offsetY), dt.transform.apply(dt, mt), nt.startTransformInverse = dt.mozCurrentTransformInverse, tt(pt, dt), this.ctx = dt, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(pt), this.groupLevel++;
              },
              suspendSMaskGroup: function() {
                var nt = this.ctx;
                this.groupLevel--, this.ctx = this.groupStack.pop(), At(this.ctx, this.current.activeSMask, nt, this.webGLContext), this.ctx.restore(), this.ctx.save(), tt(nt, this.ctx), this.current.resumeSMaskCtx = nt;
                var rt = l.Util.transform(this.current.activeSMask.startTransformInverse, nt.mozCurrentTransform);
                this.ctx.transform.apply(this.ctx, rt), nt.save(), nt.setTransform(1, 0, 0, 1, 0, 0), nt.clearRect(0, 0, nt.canvas.width, nt.canvas.height), nt.restore();
              },
              resumeSMaskGroup: function() {
                var nt = this.current.resumeSMaskCtx, rt = this.ctx;
                this.ctx = nt, this.groupStack.push(rt), this.groupLevel++;
              },
              endSMaskGroup: function() {
                var nt = this.ctx;
                this.groupLevel--, this.ctx = this.groupStack.pop(), At(this.ctx, this.current.activeSMask, nt, this.webGLContext), this.ctx.restore(), tt(nt, this.ctx);
                var rt = l.Util.transform(this.current.activeSMask.startTransformInverse, nt.mozCurrentTransform);
                this.ctx.transform.apply(this.ctx, rt);
              },
              save: function() {
                this.ctx.save();
                var nt = this.current;
                this.stateStack.push(nt), this.current = nt.clone(), this.current.resumeSMaskCtx = null;
              },
              restore: function() {
                this.current.resumeSMaskCtx && this.resumeSMaskGroup(), this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask) && this.endSMaskGroup(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.ctx.restore(), this.pendingClip = null, this._cachedGetSinglePixelWidth = null);
              },
              transform: function(nt, rt, lt, ct, ft, pt) {
                this.ctx.transform(nt, rt, lt, ct, ft, pt), this._cachedGetSinglePixelWidth = null;
              },
              constructPath: function(nt, rt) {
                for (var lt = this.ctx, ct = this.current, ft = ct.x, pt = ct.y, mt = 0, dt = 0, Et = nt.length; mt < Et; mt++)
                  switch (nt[mt] | 0) {
                    case l.OPS.rectangle:
                      ft = rt[dt++], pt = rt[dt++];
                      var Ct = rt[dt++], Tt = rt[dt++];
                      Ct === 0 && lt.lineWidth < this.getSinglePixelWidth() && (Ct = this.getSinglePixelWidth()), Tt === 0 && lt.lineWidth < this.getSinglePixelWidth() && (Tt = this.getSinglePixelWidth());
                      var qt = ft + Ct, jt = pt + Tt;
                      lt.moveTo(ft, pt), lt.lineTo(qt, pt), lt.lineTo(qt, jt), lt.lineTo(ft, jt), lt.lineTo(ft, pt), lt.closePath();
                      break;
                    case l.OPS.moveTo:
                      ft = rt[dt++], pt = rt[dt++], lt.moveTo(ft, pt);
                      break;
                    case l.OPS.lineTo:
                      ft = rt[dt++], pt = rt[dt++], lt.lineTo(ft, pt);
                      break;
                    case l.OPS.curveTo:
                      ft = rt[dt + 4], pt = rt[dt + 5], lt.bezierCurveTo(rt[dt], rt[dt + 1], rt[dt + 2], rt[dt + 3], ft, pt), dt += 6;
                      break;
                    case l.OPS.curveTo2:
                      lt.bezierCurveTo(ft, pt, rt[dt], rt[dt + 1], rt[dt + 2], rt[dt + 3]), ft = rt[dt + 2], pt = rt[dt + 3], dt += 4;
                      break;
                    case l.OPS.curveTo3:
                      ft = rt[dt + 2], pt = rt[dt + 3], lt.bezierCurveTo(rt[dt], rt[dt + 1], ft, pt, ft, pt), dt += 4;
                      break;
                    case l.OPS.closePath:
                      lt.closePath();
                      break;
                  }
                ct.setCurrentPoint(ft, pt);
              },
              closePath: function() {
                this.ctx.closePath();
              },
              stroke: function(nt) {
                nt = typeof nt < "u" ? nt : !0;
                var rt = this.ctx, lt = this.current.strokeColor;
                if (rt.globalAlpha = this.current.strokeAlpha, this.contentVisible)
                  if (lt && lt.hasOwnProperty("type") && lt.type === "Pattern") {
                    rt.save();
                    const ct = rt.mozCurrentTransform, ft = l.Util.singularValueDecompose2dScale(ct)[0];
                    rt.strokeStyle = lt.getPattern(rt, this), rt.lineWidth = Math.max(this.getSinglePixelWidth() * le, this.current.lineWidth * ft), rt.stroke(), rt.restore();
                  } else
                    rt.lineWidth = Math.max(this.getSinglePixelWidth() * le, this.current.lineWidth), rt.stroke();
                nt && this.consumePath(), rt.globalAlpha = this.current.fillAlpha;
              },
              closeStroke: function() {
                this.closePath(), this.stroke();
              },
              fill: function(nt) {
                nt = typeof nt < "u" ? nt : !0;
                var rt = this.ctx, lt = this.current.fillColor, ct = this.current.patternFill, ft = !1;
                ct && (rt.save(), this.baseTransform && rt.setTransform.apply(rt, this.baseTransform), rt.fillStyle = lt.getPattern(rt, this), ft = !0), this.contentVisible && (this.pendingEOFill ? (rt.fill("evenodd"), this.pendingEOFill = !1) : rt.fill()), ft && rt.restore(), nt && this.consumePath();
              },
              eoFill: function() {
                this.pendingEOFill = !0, this.fill();
              },
              fillStroke: function() {
                this.fill(!1), this.stroke(!1), this.consumePath();
              },
              eoFillStroke: function() {
                this.pendingEOFill = !0, this.fillStroke();
              },
              closeFillStroke: function() {
                this.closePath(), this.fillStroke();
              },
              closeEOFillStroke: function() {
                this.pendingEOFill = !0, this.closePath(), this.fillStroke();
              },
              endPath: function() {
                this.consumePath();
              },
              clip: function() {
                this.pendingClip = wt;
              },
              eoClip: function() {
                this.pendingClip = Ot;
              },
              beginText: function() {
                this.current.textMatrix = l.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              },
              endText: function() {
                var nt = this.pendingTextPaths, rt = this.ctx;
                if (nt === void 0) {
                  rt.beginPath();
                  return;
                }
                rt.save(), rt.beginPath();
                for (var lt = 0; lt < nt.length; lt++) {
                  var ct = nt[lt];
                  rt.setTransform.apply(rt, ct.transform), rt.translate(ct.x, ct.y), ct.addToPath(rt, ct.fontSize);
                }
                rt.restore(), rt.clip(), rt.beginPath(), delete this.pendingTextPaths;
              },
              setCharSpacing: function(nt) {
                this.current.charSpacing = nt;
              },
              setWordSpacing: function(nt) {
                this.current.wordSpacing = nt;
              },
              setHScale: function(nt) {
                this.current.textHScale = nt / 100;
              },
              setLeading: function(nt) {
                this.current.leading = -nt;
              },
              setFont: function(nt, rt) {
                var lt = this.commonObjs.get(nt), ct = this.current;
                if (!lt)
                  throw new Error(`Can't find font for ${nt}`);
                if (ct.fontMatrix = lt.fontMatrix ? lt.fontMatrix : l.FONT_IDENTITY_MATRIX, (ct.fontMatrix[0] === 0 || ct.fontMatrix[3] === 0) && (0, l.warn)("Invalid font matrix for font " + nt), rt < 0 ? (rt = -rt, ct.fontDirection = -1) : ct.fontDirection = 1, this.current.font = lt, this.current.fontSize = rt, lt.isType3Font)
                  return;
                var ft = lt.loadedName || "sans-serif";
                let pt = "normal";
                lt.black ? pt = "900" : lt.bold && (pt = "bold");
                var mt = lt.italic ? "italic" : "normal", dt = `"${ft}", ${lt.fallbackName}`;
                let Et = rt;
                rt < m ? Et = m : rt > C && (Et = C), this.current.fontSizeScale = rt / Et, this.ctx.font = `${mt} ${pt} ${Et}px ${dt}`;
              },
              setTextRenderingMode: function(nt) {
                this.current.textRenderingMode = nt;
              },
              setTextRise: function(nt) {
                this.current.textRise = nt;
              },
              moveText: function(nt, rt) {
                this.current.x = this.current.lineX += nt, this.current.y = this.current.lineY += rt;
              },
              setLeadingMoveText: function(nt, rt) {
                this.setLeading(-rt), this.moveText(nt, rt);
              },
              setTextMatrix: function(nt, rt, lt, ct, ft, pt) {
                this.current.textMatrix = [nt, rt, lt, ct, ft, pt], this.current.textMatrixScale = Math.sqrt(nt * nt + rt * rt), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
              },
              nextLine: function() {
                this.moveText(0, this.current.leading);
              },
              paintChar(Qe, nt, rt, lt) {
                var ct = this.ctx, ft = this.current, pt = ft.font, mt = ft.textRenderingMode, dt = ft.fontSize / ft.fontSizeScale, Et = mt & l.TextRenderingMode.FILL_STROKE_MASK, Ct = !!(mt & l.TextRenderingMode.ADD_TO_PATH_FLAG);
                const Tt = ft.patternFill && !pt.missingFile;
                var qt;
                if ((pt.disableFontFace || Ct || Tt) && (qt = pt.getPathGenerator(this.commonObjs, Qe)), pt.disableFontFace || Tt ? (ct.save(), ct.translate(nt, rt), ct.beginPath(), qt(ct, dt), lt && ct.setTransform.apply(ct, lt), (Et === l.TextRenderingMode.FILL || Et === l.TextRenderingMode.FILL_STROKE) && ct.fill(), (Et === l.TextRenderingMode.STROKE || Et === l.TextRenderingMode.FILL_STROKE) && ct.stroke(), ct.restore()) : ((Et === l.TextRenderingMode.FILL || Et === l.TextRenderingMode.FILL_STROKE) && ct.fillText(Qe, nt, rt), (Et === l.TextRenderingMode.STROKE || Et === l.TextRenderingMode.FILL_STROKE) && ct.strokeText(Qe, nt, rt)), Ct) {
                  var jt = this.pendingTextPaths || (this.pendingTextPaths = []);
                  jt.push({
                    transform: ct.mozCurrentTransform,
                    x: nt,
                    y: rt,
                    fontSize: dt,
                    addToPath: qt
                  });
                }
              },
              get isFontSubpixelAAEnabled() {
                const {
                  context: Qe
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                Qe.scale(1.5, 1), Qe.fillText("I", 0, 10);
                for (var nt = Qe.getImageData(0, 0, 10, 10).data, rt = !1, lt = 3; lt < nt.length; lt += 4)
                  if (nt[lt] > 0 && nt[lt] < 255) {
                    rt = !0;
                    break;
                  }
                return (0, l.shadow)(this, "isFontSubpixelAAEnabled", rt);
              },
              showText: function(nt) {
                var rt = this.current, lt = rt.font;
                if (lt.isType3Font)
                  return this.showType3Text(nt);
                var ct = rt.fontSize;
                if (ct === 0)
                  return;
                var ft = this.ctx, pt = rt.fontSizeScale, mt = rt.charSpacing, dt = rt.wordSpacing, Et = rt.fontDirection, Ct = rt.textHScale * Et, Tt = nt.length, qt = lt.vertical, jt = qt ? 1 : -1, St = lt.defaultVMetrics, Mt = ct * rt.fontMatrix[0], Dt = rt.textRenderingMode === l.TextRenderingMode.FILL && !lt.disableFontFace && !rt.patternFill;
                ft.save();
                let Nt;
                if (rt.patternFill) {
                  ft.save();
                  const Qt = rt.fillColor.getPattern(ft, this);
                  Nt = ft.mozCurrentTransform, ft.restore(), ft.fillStyle = Qt;
                }
                ft.transform.apply(ft, rt.textMatrix), ft.translate(rt.x, rt.y + rt.textRise), Et > 0 ? ft.scale(Ct, -1) : ft.scale(Ct, 1);
                var Kt = rt.lineWidth, Ft = rt.textMatrixScale;
                if (Ft === 0 || Kt === 0) {
                  var Bt = rt.textRenderingMode & l.TextRenderingMode.FILL_STROKE_MASK;
                  (Bt === l.TextRenderingMode.STROKE || Bt === l.TextRenderingMode.FILL_STROKE) && (this._cachedGetSinglePixelWidth = null, Kt = this.getSinglePixelWidth() * le);
                } else
                  Kt /= Ft;
                pt !== 1 && (ft.scale(pt, pt), Kt /= pt), ft.lineWidth = Kt;
                var $t = 0, Gt;
                for (Gt = 0; Gt < Tt; ++Gt) {
                  var Jt = nt[Gt];
                  if ((0, l.isNum)(Jt)) {
                    $t += jt * Jt * ct / 1e3;
                    continue;
                  }
                  var er = !1, Ht = (Jt.isSpace ? dt : 0) + mt, zt = Jt.fontChar, Xt = Jt.accent, Vt, Yt, Rt, kt, Zt = Jt.width;
                  if (qt) {
                    var Wt, xt, It;
                    Wt = Jt.vmetric || St, xt = Jt.vmetric ? Wt[1] : Zt * 0.5, xt = -xt * Mt, It = Wt[2] * Mt, Zt = Wt ? -Wt[0] : Zt, Vt = xt / pt, Yt = ($t + It) / pt;
                  } else
                    Vt = $t / pt, Yt = 0;
                  if (lt.remeasure && Zt > 0) {
                    var Pt = ft.measureText(zt).width * 1e3 / ct * pt;
                    if (Zt < Pt && this.isFontSubpixelAAEnabled) {
                      var Lt = Zt / Pt;
                      er = !0, ft.save(), ft.scale(Lt, 1), Vt /= Lt;
                    } else
                      Zt !== Pt && (Vt += (Zt - Pt) / 2e3 * ct / pt);
                  }
                  this.contentVisible && (Jt.isInFont || lt.missingFile) && (Dt && !Xt ? ft.fillText(zt, Vt, Yt) : (this.paintChar(zt, Vt, Yt, Nt), Xt && (Rt = Vt + ct * Xt.offset.x / pt, kt = Yt - ct * Xt.offset.y / pt, this.paintChar(Xt.fontChar, Rt, kt, Nt))));
                  var Ut;
                  qt ? Ut = Zt * Mt - Ht * Et : Ut = Zt * Mt + Ht * Et, $t += Ut, er && ft.restore();
                }
                qt ? rt.y -= $t : rt.x += $t * Ct, ft.restore();
              },
              showType3Text: function(nt) {
                var rt = this.ctx, lt = this.current, ct = lt.font, ft = lt.fontSize, pt = lt.fontDirection, mt = ct.vertical ? 1 : -1, dt = lt.charSpacing, Et = lt.wordSpacing, Ct = lt.textHScale * pt, Tt = lt.fontMatrix || l.FONT_IDENTITY_MATRIX, qt = nt.length, jt = lt.textRenderingMode === l.TextRenderingMode.INVISIBLE, St, Mt, Dt, Nt;
                if (!(jt || ft === 0)) {
                  for (this._cachedGetSinglePixelWidth = null, rt.save(), rt.transform.apply(rt, lt.textMatrix), rt.translate(lt.x, lt.y), rt.scale(Ct, pt), St = 0; St < qt; ++St) {
                    if (Mt = nt[St], (0, l.isNum)(Mt)) {
                      Nt = mt * Mt * ft / 1e3, this.ctx.translate(Nt, 0), lt.x += Nt * Ct;
                      continue;
                    }
                    var Kt = (Mt.isSpace ? Et : 0) + dt, Ft = ct.charProcOperatorList[Mt.operatorListId];
                    if (!Ft) {
                      (0, l.warn)(`Type3 character "${Mt.operatorListId}" is not available.`);
                      continue;
                    }
                    this.contentVisible && (this.processingType3 = Mt, this.save(), rt.scale(ft, ft), rt.transform.apply(rt, Tt), this.executeOperatorList(Ft), this.restore());
                    var Bt = l.Util.applyTransform([Mt.width, 0], Tt);
                    Dt = Bt[0] * ft + Kt, rt.translate(Dt, 0), lt.x += Dt * Ct;
                  }
                  rt.restore(), this.processingType3 = null;
                }
              },
              setCharWidth: function(nt, rt) {
              },
              setCharWidthAndBounds: function(nt, rt, lt, ct, ft, pt) {
                this.ctx.rect(lt, ct, ft - lt, pt - ct), this.clip(), this.endPath();
              },
              getColorN_Pattern: function(nt) {
                var rt;
                if (nt[0] === "TilingPattern") {
                  var lt = nt[1], ct = this.baseTransform || this.ctx.mozCurrentTransform.slice(), ft = {
                    createCanvasGraphics: (pt) => new at(pt, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext)
                  };
                  rt = new h.TilingPattern(nt, lt, this.ctx, ft, ct);
                } else
                  rt = (0, h.getShadingPatternFromIR)(nt);
                return rt;
              },
              setStrokeColorN: function() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              },
              setFillColorN: function() {
                this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
              },
              setStrokeRGBColor: function(nt, rt, lt) {
                var ct = l.Util.makeCssRgb(nt, rt, lt);
                this.ctx.strokeStyle = ct, this.current.strokeColor = ct;
              },
              setFillRGBColor: function(nt, rt, lt) {
                var ct = l.Util.makeCssRgb(nt, rt, lt);
                this.ctx.fillStyle = ct, this.current.fillColor = ct, this.current.patternFill = !1;
              },
              shadingFill: function(nt) {
                if (this.contentVisible) {
                  var rt = this.ctx;
                  this.save();
                  var lt = (0, h.getShadingPatternFromIR)(nt);
                  rt.fillStyle = lt.getPattern(rt, this, !0);
                  var ct = rt.mozCurrentTransformInverse;
                  if (ct) {
                    var ft = rt.canvas, pt = ft.width, mt = ft.height, dt = l.Util.applyTransform([0, 0], ct), Et = l.Util.applyTransform([0, mt], ct), Ct = l.Util.applyTransform([pt, 0], ct), Tt = l.Util.applyTransform([pt, mt], ct), qt = Math.min(dt[0], Et[0], Ct[0], Tt[0]), jt = Math.min(dt[1], Et[1], Ct[1], Tt[1]), St = Math.max(dt[0], Et[0], Ct[0], Tt[0]), Mt = Math.max(dt[1], Et[1], Ct[1], Tt[1]);
                    this.ctx.fillRect(qt, jt, St - qt, Mt - jt);
                  } else
                    this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                  this.restore();
                }
              },
              beginInlineImage: function() {
                (0, l.unreachable)("Should not call beginInlineImage");
              },
              beginImageData: function() {
                (0, l.unreachable)("Should not call beginImageData");
              },
              paintFormXObjectBegin: function(nt, rt) {
                if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(nt) && nt.length === 6 && this.transform.apply(this, nt), this.baseTransform = this.ctx.mozCurrentTransform, rt)) {
                  var lt = rt[2] - rt[0], ct = rt[3] - rt[1];
                  this.ctx.rect(rt[0], rt[1], lt, ct), this.clip(), this.endPath();
                }
              },
              paintFormXObjectEnd: function() {
                this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
              },
              beginGroup: function(nt) {
                if (this.contentVisible) {
                  this.save();
                  var rt = this.ctx;
                  nt.isolated || (0, l.info)("TODO: Support non-isolated groups."), nt.knockout && (0, l.warn)("Knockout groups not supported.");
                  var lt = rt.mozCurrentTransform;
                  if (nt.matrix && rt.transform.apply(rt, nt.matrix), !nt.bbox)
                    throw new Error("Bounding box is required.");
                  var ct = l.Util.getAxialAlignedBoundingBox(nt.bbox, rt.mozCurrentTransform), ft = [0, 0, rt.canvas.width, rt.canvas.height];
                  ct = l.Util.intersect(ct, ft) || [0, 0, 0, 0];
                  var pt = Math.floor(ct[0]), mt = Math.floor(ct[1]), dt = Math.max(Math.ceil(ct[2]) - pt, 1), Et = Math.max(Math.ceil(ct[3]) - mt, 1), Ct = 1, Tt = 1;
                  dt > O && (Ct = dt / O, dt = O), Et > O && (Tt = Et / O, Et = O);
                  var qt = "groupAt" + this.groupLevel;
                  nt.smask && (qt += "_smask_" + this.smaskCounter++ % 2);
                  var jt = this.cachedCanvases.getCanvas(qt, dt, Et, !0), St = jt.context;
                  St.scale(1 / Ct, 1 / Tt), St.translate(-pt, -mt), St.transform.apply(St, lt), nt.smask ? this.smaskStack.push({
                    canvas: jt.canvas,
                    context: St,
                    offsetX: pt,
                    offsetY: mt,
                    scaleX: Ct,
                    scaleY: Tt,
                    subtype: nt.smask.subtype,
                    backdrop: nt.smask.backdrop,
                    transferMap: nt.smask.transferMap || null,
                    startTransformInverse: null
                  }) : (rt.setTransform(1, 0, 0, 1, 0, 0), rt.translate(pt, mt), rt.scale(Ct, Tt)), tt(rt, St), this.ctx = St, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(rt), this.groupLevel++, this.current.activeSMask = null;
                }
              },
              endGroup: function(nt) {
                if (this.contentVisible) {
                  this.groupLevel--;
                  var rt = this.ctx;
                  this.ctx = this.groupStack.pop(), this.ctx.imageSmoothingEnabled !== void 0 ? this.ctx.imageSmoothingEnabled = !1 : this.ctx.mozImageSmoothingEnabled = !1, nt.smask ? this.tempSMask = this.smaskStack.pop() : this.ctx.drawImage(rt.canvas, 0, 0), this.restore();
                }
              },
              beginAnnotations: function() {
                this.save(), this.baseTransform && this.ctx.setTransform.apply(this.ctx, this.baseTransform);
              },
              endAnnotations: function() {
                this.restore();
              },
              beginAnnotation: function(nt, rt, lt) {
                if (this.save(), ut(this.ctx), this.current = new Ze(), Array.isArray(nt) && nt.length === 4) {
                  var ct = nt[2] - nt[0], ft = nt[3] - nt[1];
                  this.ctx.rect(nt[0], nt[1], ct, ft), this.clip(), this.endPath();
                }
                this.transform.apply(this, rt), this.transform.apply(this, lt);
              },
              endAnnotation: function() {
                this.restore();
              },
              paintImageMaskXObject: function(nt) {
                if (this.contentVisible) {
                  var rt = this.ctx, lt = nt.width, ct = nt.height, ft = this.current.fillColor, pt = this.current.patternFill, mt = this.processingType3;
                  if (mt && mt.compiled === void 0 && (lt <= We && ct <= We ? mt.compiled = Le({
                    data: nt.data,
                    width: lt,
                    height: ct
                  }) : mt.compiled = null), mt && mt.compiled) {
                    mt.compiled(rt);
                    return;
                  }
                  var dt = this.cachedCanvases.getCanvas("maskCanvas", lt, ct), Et = dt.context;
                  Et.save(), Ke(Et, nt), Et.globalCompositeOperation = "source-in", Et.fillStyle = pt ? ft.getPattern(Et, this) : ft, Et.fillRect(0, 0, lt, ct), Et.restore(), this.paintInlineImageXObject(dt.canvas);
                }
              },
              paintImageMaskXObjectRepeat(Qe, nt, rt = 0, lt = 0, ct, ft) {
                if (this.contentVisible) {
                  var pt = Qe.width, mt = Qe.height, dt = this.current.fillColor, Et = this.current.patternFill, Ct = this.cachedCanvases.getCanvas("maskCanvas", pt, mt), Tt = Ct.context;
                  Tt.save(), Ke(Tt, Qe), Tt.globalCompositeOperation = "source-in", Tt.fillStyle = Et ? dt.getPattern(Tt, this) : dt, Tt.fillRect(0, 0, pt, mt), Tt.restore();
                  for (var qt = this.ctx, jt = 0, St = ft.length; jt < St; jt += 2)
                    qt.save(), qt.transform(nt, rt, lt, ct, ft[jt], ft[jt + 1]), qt.scale(1, -1), qt.drawImage(Ct.canvas, 0, 0, pt, mt, 0, -1, 1, 1), qt.restore();
                }
              },
              paintImageMaskXObjectGroup: function(nt) {
                if (this.contentVisible)
                  for (var rt = this.ctx, lt = this.current.fillColor, ct = this.current.patternFill, ft = 0, pt = nt.length; ft < pt; ft++) {
                    var mt = nt[ft], dt = mt.width, Et = mt.height, Ct = this.cachedCanvases.getCanvas("maskCanvas", dt, Et), Tt = Ct.context;
                    Tt.save(), Ke(Tt, mt), Tt.globalCompositeOperation = "source-in", Tt.fillStyle = ct ? lt.getPattern(Tt, this) : lt, Tt.fillRect(0, 0, dt, Et), Tt.restore(), rt.save(), rt.transform.apply(rt, mt.transform), rt.scale(1, -1), rt.drawImage(Ct.canvas, 0, 0, dt, Et, 0, -1, 1, 1), rt.restore();
                  }
              },
              paintImageXObject: function(nt) {
                if (!this.contentVisible)
                  return;
                const rt = nt.startsWith("g_") ? this.commonObjs.get(nt) : this.objs.get(nt);
                if (!rt) {
                  (0, l.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(rt);
              },
              paintImageXObjectRepeat: function(nt, rt, lt, ct) {
                if (!this.contentVisible)
                  return;
                const ft = nt.startsWith("g_") ? this.commonObjs.get(nt) : this.objs.get(nt);
                if (!ft) {
                  (0, l.warn)("Dependent image isn't ready yet");
                  return;
                }
                for (var pt = ft.width, mt = ft.height, dt = [], Et = 0, Ct = ct.length; Et < Ct; Et += 2)
                  dt.push({
                    transform: [rt, 0, 0, lt, ct[Et], ct[Et + 1]],
                    x: 0,
                    y: 0,
                    w: pt,
                    h: mt
                  });
                this.paintInlineImageXObjectGroup(ft, dt);
              },
              paintInlineImageXObject: function(nt) {
                if (this.contentVisible) {
                  var rt = nt.width, lt = nt.height, ct = this.ctx;
                  this.save(), ct.scale(1 / rt, -1 / lt);
                  var ft = ct.mozCurrentTransformInverse, pt = ft[0], mt = ft[1], dt = Math.max(Math.sqrt(pt * pt + mt * mt), 1), Et = ft[2], Ct = ft[3], Tt = Math.max(Math.sqrt(Et * Et + Ct * Ct), 1), qt, jt;
                  if (typeof HTMLElement == "function" && nt instanceof HTMLElement || !nt.data)
                    qt = nt;
                  else {
                    jt = this.cachedCanvases.getCanvas("inlineImage", rt, lt);
                    var St = jt.context;
                    $e(St, nt, this.current.transferMaps), qt = jt.canvas;
                  }
                  for (var Mt = rt, Dt = lt, Nt = "prescale1"; dt > 2 && Mt > 1 || Tt > 2 && Dt > 1; ) {
                    var Kt = Mt, Ft = Dt;
                    dt > 2 && Mt > 1 && (Kt = Math.ceil(Mt / 2), dt /= Mt / Kt), Tt > 2 && Dt > 1 && (Ft = Math.ceil(Dt / 2), Tt /= Dt / Ft), jt = this.cachedCanvases.getCanvas(Nt, Kt, Ft), St = jt.context, St.clearRect(0, 0, Kt, Ft), St.drawImage(qt, 0, 0, Mt, Dt, 0, 0, Kt, Ft), qt = jt.canvas, Mt = Kt, Dt = Ft, Nt = Nt === "prescale1" ? "prescale2" : "prescale1";
                  }
                  if (ct.drawImage(qt, 0, 0, Mt, Dt, 0, -lt, rt, lt), this.imageLayer) {
                    var Bt = this.getCanvasPosition(0, -lt);
                    this.imageLayer.appendImage({
                      imgData: nt,
                      left: Bt[0],
                      top: Bt[1],
                      width: rt / ft[0],
                      height: lt / ft[3]
                    });
                  }
                  this.restore();
                }
              },
              paintInlineImageXObjectGroup: function(nt, rt) {
                if (this.contentVisible) {
                  var lt = this.ctx, ct = nt.width, ft = nt.height, pt = this.cachedCanvases.getCanvas("inlineImage", ct, ft), mt = pt.context;
                  $e(mt, nt, this.current.transferMaps);
                  for (var dt = 0, Et = rt.length; dt < Et; dt++) {
                    var Ct = rt[dt];
                    if (lt.save(), lt.transform.apply(lt, Ct.transform), lt.scale(1, -1), lt.drawImage(pt.canvas, Ct.x, Ct.y, Ct.w, Ct.h, 0, -1, 1, 1), this.imageLayer) {
                      var Tt = this.getCanvasPosition(Ct.x, Ct.y);
                      this.imageLayer.appendImage({
                        imgData: nt,
                        left: Tt[0],
                        top: Tt[1],
                        width: ct,
                        height: ft
                      });
                    }
                    lt.restore();
                  }
                }
              },
              paintSolidColorImageMask: function() {
                this.contentVisible && this.ctx.fillRect(0, 0, 1, 1);
              },
              markPoint: function(nt) {
              },
              markPointProps: function(nt, rt) {
              },
              beginMarkedContent: function(nt) {
                this.markedContentStack.push({
                  visible: !0
                });
              },
              beginMarkedContentProps: function(nt, rt) {
                nt === "OC" ? this.markedContentStack.push({
                  visible: this.optionalContentConfig.isVisible(rt)
                }) : this.markedContentStack.push({
                  visible: !0
                }), this.contentVisible = this.isContentVisible();
              },
              endMarkedContent: function() {
                this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
              },
              beginCompat: function() {
              },
              endCompat: function() {
              },
              consumePath: function() {
                var nt = this.ctx;
                this.pendingClip && (this.pendingClip === Ot ? nt.clip("evenodd") : nt.clip(), this.pendingClip = null), nt.beginPath();
              },
              getSinglePixelWidth(Qe) {
                if (this._cachedGetSinglePixelWidth === null) {
                  const nt = this.ctx.mozCurrentTransformInverse;
                  this._cachedGetSinglePixelWidth = Math.sqrt(Math.max(nt[0] * nt[0] + nt[1] * nt[1], nt[2] * nt[2] + nt[3] * nt[3]));
                }
                return this._cachedGetSinglePixelWidth;
              },
              getCanvasPosition: function(nt, rt) {
                var lt = this.ctx.mozCurrentTransform;
                return [lt[0] * nt + lt[2] * rt + lt[4], lt[1] * nt + lt[3] * rt + lt[5]];
              },
              isContentVisible: function() {
                for (let nt = this.markedContentStack.length - 1; nt >= 0; nt--)
                  if (!this.markedContentStack[nt].visible)
                    return !1;
                return !0;
              }
            };
            for (var yt in l.OPS)
              at.prototype[l.OPS[yt]] = at.prototype[yt];
            return at;
          }();
          s.CanvasGraphics = Xe;
        },
        /* 11 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.getShadingPatternFromIR = O, s.TilingPattern = void 0;
          var l = u(2), h = {};
          function m(We, ye) {
            if (!ye || typeof Path2D > "u")
              return;
            const Fe = ye[2] - ye[0], Ue = ye[3] - ye[1], Le = new Path2D();
            Le.rect(ye[0], ye[1], Fe, Ue), We.clip(Le);
          }
          h.RadialAxial = {
            fromIR: function(ye) {
              var Fe = ye[1], Ue = ye[2], Le = ye[3], Ze = ye[4], Xe = ye[5], Je = ye[6], it = ye[7];
              return {
                type: "Pattern",
                getPattern: function(at) {
                  m(at, Ue);
                  var $e;
                  Fe === "axial" ? $e = at.createLinearGradient(Ze[0], Ze[1], Xe[0], Xe[1]) : Fe === "radial" && ($e = at.createRadialGradient(Ze[0], Ze[1], Je, Xe[0], Xe[1], it));
                  for (var Ke = 0, tt = Le.length; Ke < tt; ++Ke) {
                    var ut = Le[Ke];
                    $e.addColorStop(ut[0], ut[1]);
                  }
                  return $e;
                }
              };
            }
          };
          var C = function() {
            function ye(Le, Ze, Xe, Je, it, et, at, $e) {
              var Ke = Ze.coords, tt = Ze.colors, ut = Le.data, st = Le.width * 4, ot;
              Ke[Xe + 1] > Ke[Je + 1] && (ot = Xe, Xe = Je, Je = ot, ot = et, et = at, at = ot), Ke[Je + 1] > Ke[it + 1] && (ot = Je, Je = it, it = ot, ot = at, at = $e, $e = ot), Ke[Xe + 1] > Ke[Je + 1] && (ot = Xe, Xe = Je, Je = ot, ot = et, et = at, at = ot);
              var ht = (Ke[Xe] + Ze.offsetX) * Ze.scaleX, vt = (Ke[Xe + 1] + Ze.offsetY) * Ze.scaleY, At = (Ke[Je] + Ze.offsetX) * Ze.scaleX, gt = (Ke[Je + 1] + Ze.offsetY) * Ze.scaleY, bt = (Ke[it] + Ze.offsetX) * Ze.scaleX, wt = (Ke[it + 1] + Ze.offsetY) * Ze.scaleY;
              if (!(vt >= wt))
                for (var Ot = tt[et], yt = tt[et + 1], Qe = tt[et + 2], nt = tt[at], rt = tt[at + 1], lt = tt[at + 2], ct = tt[$e], ft = tt[$e + 1], pt = tt[$e + 2], mt = Math.round(vt), dt = Math.round(wt), Et, Ct, Tt, qt, jt, St, Mt, Dt, Nt = mt; Nt <= dt; Nt++) {
                  if (Nt < gt) {
                    let Jt;
                    Nt < vt ? Jt = 0 : vt === gt ? Jt = 1 : Jt = (vt - Nt) / (vt - gt), Et = ht - (ht - At) * Jt, Ct = Ot - (Ot - nt) * Jt, Tt = yt - (yt - rt) * Jt, qt = Qe - (Qe - lt) * Jt;
                  } else {
                    let Jt;
                    Nt > wt ? Jt = 1 : gt === wt ? Jt = 0 : Jt = (gt - Nt) / (gt - wt), Et = At - (At - bt) * Jt, Ct = nt - (nt - ct) * Jt, Tt = rt - (rt - ft) * Jt, qt = lt - (lt - pt) * Jt;
                  }
                  let Gt;
                  Nt < vt ? Gt = 0 : Nt > wt ? Gt = 1 : Gt = (vt - Nt) / (vt - wt), jt = ht - (ht - bt) * Gt, St = Ot - (Ot - ct) * Gt, Mt = yt - (yt - ft) * Gt, Dt = Qe - (Qe - pt) * Gt;
                  for (var Kt = Math.round(Math.min(Et, jt)), Ft = Math.round(Math.max(Et, jt)), Bt = st * Nt + Kt * 4, $t = Kt; $t <= Ft; $t++)
                    Gt = (Et - $t) / (Et - jt), Gt < 0 ? Gt = 0 : Gt > 1 && (Gt = 1), ut[Bt++] = Ct - (Ct - St) * Gt | 0, ut[Bt++] = Tt - (Tt - Mt) * Gt | 0, ut[Bt++] = qt - (qt - Dt) * Gt | 0, ut[Bt++] = 255;
                }
            }
            function Fe(Le, Ze, Xe) {
              var Je = Ze.coords, it = Ze.colors, et, at;
              switch (Ze.type) {
                case "lattice":
                  var $e = Ze.verticesPerRow, Ke = Math.floor(Je.length / $e) - 1, tt = $e - 1;
                  for (et = 0; et < Ke; et++)
                    for (var ut = et * $e, st = 0; st < tt; st++, ut++)
                      ye(Le, Xe, Je[ut], Je[ut + 1], Je[ut + $e], it[ut], it[ut + 1], it[ut + $e]), ye(Le, Xe, Je[ut + $e + 1], Je[ut + 1], Je[ut + $e], it[ut + $e + 1], it[ut + 1], it[ut + $e]);
                  break;
                case "triangles":
                  for (et = 0, at = Je.length; et < at; et += 3)
                    ye(Le, Xe, Je[et], Je[et + 1], Je[et + 2], it[et], it[et + 1], it[et + 2]);
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            function Ue(Le, Ze, Xe, Je, it, et, at, $e) {
              var Ke = 1.1, tt = 3e3, ut = 2, st = Math.floor(Le[0]), ot = Math.floor(Le[1]), ht = Math.ceil(Le[2]) - st, vt = Math.ceil(Le[3]) - ot, At = Math.min(Math.ceil(Math.abs(ht * Ze[0] * Ke)), tt), gt = Math.min(Math.ceil(Math.abs(vt * Ze[1] * Ke)), tt), bt = ht / At, wt = vt / gt, Ot = {
                coords: Xe,
                colors: Je,
                offsetX: -st,
                offsetY: -ot,
                scaleX: 1 / bt,
                scaleY: 1 / wt
              }, yt = At + ut * 2, Qe = gt + ut * 2, nt, rt, lt, ct;
              if ($e.isEnabled)
                nt = $e.drawFigures({
                  width: At,
                  height: gt,
                  backgroundColor: et,
                  figures: it,
                  context: Ot
                }), rt = at.getCanvas("mesh", yt, Qe, !1), rt.context.drawImage(nt, ut, ut), nt = rt.canvas;
              else {
                rt = at.getCanvas("mesh", yt, Qe, !1);
                var ft = rt.context, pt = ft.createImageData(At, gt);
                if (et) {
                  var mt = pt.data;
                  for (lt = 0, ct = mt.length; lt < ct; lt += 4)
                    mt[lt] = et[0], mt[lt + 1] = et[1], mt[lt + 2] = et[2], mt[lt + 3] = 255;
                }
                for (lt = 0; lt < it.length; lt++)
                  Fe(pt, it[lt], Ot);
                ft.putImageData(pt, ut, ut), nt = rt.canvas;
              }
              return {
                canvas: nt,
                offsetX: st - ut * bt,
                offsetY: ot - ut * wt,
                scaleX: bt,
                scaleY: wt
              };
            }
            return Ue;
          }();
          h.Mesh = {
            fromIR: function(ye) {
              var Fe = ye[2], Ue = ye[3], Le = ye[4], Ze = ye[5], Xe = ye[6], Je = ye[7], it = ye[8];
              return {
                type: "Pattern",
                getPattern: function(at, $e, Ke) {
                  m(at, Je);
                  var tt;
                  if (Ke)
                    tt = l.Util.singularValueDecompose2dScale(at.mozCurrentTransform);
                  else if (tt = l.Util.singularValueDecompose2dScale($e.baseTransform), Xe) {
                    var ut = l.Util.singularValueDecompose2dScale(Xe);
                    tt = [tt[0] * ut[0], tt[1] * ut[1]];
                  }
                  var st = C(Ze, tt, Fe, Ue, Le, Ke ? null : it, $e.cachedCanvases, $e.webGLContext);
                  return Ke || (at.setTransform.apply(at, $e.baseTransform), Xe && at.transform.apply(at, Xe)), at.translate(st.offsetX, st.offsetY), at.scale(st.scaleX, st.scaleY), at.createPattern(st.canvas, "no-repeat");
                }
              };
            }
          }, h.Dummy = {
            fromIR: function() {
              return {
                type: "Pattern",
                getPattern: function() {
                  return "hotpink";
                }
              };
            }
          };
          function O(We) {
            var ye = h[We[0]];
            if (!ye)
              throw new Error(`Unknown IR type: ${We[0]}`);
            return ye.fromIR(We);
          }
          var le = function() {
            var ye = {
              COLORED: 1,
              UNCOLORED: 2
            }, Fe = 3e3;
            function Ue(Le, Ze, Xe, Je, it) {
              this.operatorList = Le[2], this.matrix = Le[3] || [1, 0, 0, 1, 0, 0], this.bbox = Le[4], this.xstep = Le[5], this.ystep = Le[6], this.paintType = Le[7], this.tilingType = Le[8], this.color = Ze, this.canvasGraphicsFactory = Je, this.baseTransform = it, this.type = "Pattern", this.ctx = Xe;
            }
            return Ue.prototype = {
              createPatternCanvas: function(Ze) {
                var Xe = this.operatorList, Je = this.bbox, it = this.xstep, et = this.ystep, at = this.paintType, $e = this.tilingType, Ke = this.color, tt = this.canvasGraphicsFactory;
                (0, l.info)("TilingType: " + $e);
                var ut = Je[0], st = Je[1], ot = Je[2], ht = Je[3], vt = l.Util.singularValueDecompose2dScale(this.matrix), At = l.Util.singularValueDecompose2dScale(this.baseTransform), gt = [vt[0] * At[0], vt[1] * At[1]], bt = this.getSizeAndScale(it, this.ctx.canvas.width, gt[0]), wt = this.getSizeAndScale(et, this.ctx.canvas.height, gt[1]), Ot = Ze.cachedCanvases.getCanvas("pattern", bt.size, wt.size, !0), yt = Ot.context, Qe = tt.createCanvasGraphics(yt);
                return Qe.groupLevel = Ze.groupLevel, this.setFillAndStrokeStyleToContext(Qe, at, Ke), Qe.transform(bt.scale, 0, 0, wt.scale, 0, 0), Qe.transform(1, 0, 0, 1, -ut, -st), this.clipBbox(Qe, Je, ut, st, ot, ht), Qe.executeOperatorList(Xe), this.ctx.transform(1, 0, 0, 1, ut, st), this.ctx.scale(1 / bt.scale, 1 / wt.scale), Ot.canvas;
              },
              getSizeAndScale: function(Ze, Xe, Je) {
                Ze = Math.abs(Ze);
                var it = Math.max(Fe, Xe), et = Math.ceil(Ze * Je);
                return et >= it ? et = it : Je = et / Ze, {
                  scale: Je,
                  size: et
                };
              },
              clipBbox: function(Ze, Xe, Je, it, et, at) {
                if (Array.isArray(Xe) && Xe.length === 4) {
                  var $e = et - Je, Ke = at - it;
                  Ze.ctx.rect(Je, it, $e, Ke), Ze.clip(), Ze.endPath();
                }
              },
              setFillAndStrokeStyleToContext: function(Ze, Xe, Je) {
                const it = Ze.ctx, et = Ze.current;
                switch (Xe) {
                  case ye.COLORED:
                    var at = this.ctx;
                    it.fillStyle = at.fillStyle, it.strokeStyle = at.strokeStyle, et.fillColor = at.fillStyle, et.strokeColor = at.strokeStyle;
                    break;
                  case ye.UNCOLORED:
                    var $e = l.Util.makeCssRgb(Je[0], Je[1], Je[2]);
                    it.fillStyle = $e, it.strokeStyle = $e, et.fillColor = $e, et.strokeColor = $e;
                    break;
                  default:
                    throw new l.FormatError(`Unsupported paint type: ${Xe}`);
                }
              },
              getPattern: function(Ze, Xe) {
                Ze = this.ctx, Ze.setTransform.apply(Ze, this.baseTransform), Ze.transform.apply(Ze, this.matrix);
                var Je = this.createPatternCanvas(Xe);
                return Ze.createPattern(Je, "repeat");
              }
            }, Ue;
          }();
          s.TilingPattern = le;
        },
        /* 12 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.GlobalWorkerOptions = void 0;
          const l = /* @__PURE__ */ Object.create(null);
          s.GlobalWorkerOptions = l, l.workerPort = l.workerPort === void 0 ? null : l.workerPort, l.workerSrc = l.workerSrc === void 0 ? "" : l.workerSrc;
        },
        /* 13 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.MessageHandler = void 0;
          var l = u(2);
          const h = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          }, m = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function C(le) {
            if (typeof le != "object" || le === null)
              return le;
            switch (le.name) {
              case "AbortException":
                return new l.AbortException(le.message);
              case "MissingPDFException":
                return new l.MissingPDFException(le.message);
              case "UnexpectedResponseException":
                return new l.UnexpectedResponseException(le.message, le.status);
              case "UnknownErrorException":
                return new l.UnknownErrorException(le.message, le.details);
              default:
                return new l.UnknownErrorException(le.message, le.toString());
            }
          }
          class O {
            constructor(We, ye, Fe) {
              this.sourceName = We, this.targetName = ye, this.comObj = Fe, this.callbackId = 1, this.streamId = 1, this.postMessageTransfers = !0, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (Ue) => {
                const Le = Ue.data;
                if (Le.targetName !== this.sourceName)
                  return;
                if (Le.stream) {
                  this._processStreamMessage(Le);
                  return;
                }
                if (Le.callback) {
                  const Xe = Le.callbackId, Je = this.callbackCapabilities[Xe];
                  if (!Je)
                    throw new Error(`Cannot resolve callback ${Xe}`);
                  if (delete this.callbackCapabilities[Xe], Le.callback === h.DATA)
                    Je.resolve(Le.data);
                  else if (Le.callback === h.ERROR)
                    Je.reject(C(Le.reason));
                  else
                    throw new Error("Unexpected callback case");
                  return;
                }
                const Ze = this.actionHandler[Le.action];
                if (!Ze)
                  throw new Error(`Unknown action from worker: ${Le.action}`);
                if (Le.callbackId) {
                  const Xe = this.sourceName, Je = Le.sourceName;
                  new Promise(function(it) {
                    it(Ze(Le.data));
                  }).then(function(it) {
                    Fe.postMessage({
                      sourceName: Xe,
                      targetName: Je,
                      callback: h.DATA,
                      callbackId: Le.callbackId,
                      data: it
                    });
                  }, function(it) {
                    Fe.postMessage({
                      sourceName: Xe,
                      targetName: Je,
                      callback: h.ERROR,
                      callbackId: Le.callbackId,
                      reason: C(it)
                    });
                  });
                  return;
                }
                if (Le.streamId) {
                  this._createStreamSink(Le);
                  return;
                }
                Ze(Le.data);
              }, Fe.addEventListener("message", this._onComObjOnMessage);
            }
            on(We, ye) {
              const Fe = this.actionHandler;
              if (Fe[We])
                throw new Error(`There is already an actionName called "${We}"`);
              Fe[We] = ye;
            }
            send(We, ye, Fe) {
              this._postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: We,
                data: ye
              }, Fe);
            }
            sendWithPromise(We, ye, Fe) {
              const Ue = this.callbackId++, Le = (0, l.createPromiseCapability)();
              this.callbackCapabilities[Ue] = Le;
              try {
                this._postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: We,
                  callbackId: Ue,
                  data: ye
                }, Fe);
              } catch (Ze) {
                Le.reject(Ze);
              }
              return Le.promise;
            }
            sendWithStream(We, ye, Fe, Ue) {
              const Le = this.streamId++, Ze = this.sourceName, Xe = this.targetName, Je = this.comObj;
              return new ReadableStream({
                start: (it) => {
                  const et = (0, l.createPromiseCapability)();
                  return this.streamControllers[Le] = {
                    controller: it,
                    startCall: et,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: !1
                  }, this._postMessage({
                    sourceName: Ze,
                    targetName: Xe,
                    action: We,
                    streamId: Le,
                    data: ye,
                    desiredSize: it.desiredSize
                  }, Ue), et.promise;
                },
                pull: (it) => {
                  const et = (0, l.createPromiseCapability)();
                  return this.streamControllers[Le].pullCall = et, Je.postMessage({
                    sourceName: Ze,
                    targetName: Xe,
                    stream: m.PULL,
                    streamId: Le,
                    desiredSize: it.desiredSize
                  }), et.promise;
                },
                cancel: (it) => {
                  (0, l.assert)(it instanceof Error, "cancel must have a valid reason");
                  const et = (0, l.createPromiseCapability)();
                  return this.streamControllers[Le].cancelCall = et, this.streamControllers[Le].isClosed = !0, Je.postMessage({
                    sourceName: Ze,
                    targetName: Xe,
                    stream: m.CANCEL,
                    streamId: Le,
                    reason: C(it)
                  }), et.promise;
                }
              }, Fe);
            }
            _createStreamSink(We) {
              const ye = this, Fe = this.actionHandler[We.action], Ue = We.streamId, Le = this.sourceName, Ze = We.sourceName, Xe = this.comObj, Je = {
                enqueue(it, et = 1, at) {
                  if (this.isCancelled)
                    return;
                  const $e = this.desiredSize;
                  this.desiredSize -= et, $e > 0 && this.desiredSize <= 0 && (this.sinkCapability = (0, l.createPromiseCapability)(), this.ready = this.sinkCapability.promise), ye._postMessage({
                    sourceName: Le,
                    targetName: Ze,
                    stream: m.ENQUEUE,
                    streamId: Ue,
                    chunk: it
                  }, at);
                },
                close() {
                  this.isCancelled || (this.isCancelled = !0, Xe.postMessage({
                    sourceName: Le,
                    targetName: Ze,
                    stream: m.CLOSE,
                    streamId: Ue
                  }), delete ye.streamSinks[Ue]);
                },
                error(it) {
                  (0, l.assert)(it instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, Xe.postMessage({
                    sourceName: Le,
                    targetName: Ze,
                    stream: m.ERROR,
                    streamId: Ue,
                    reason: C(it)
                  }));
                },
                sinkCapability: (0, l.createPromiseCapability)(),
                onPull: null,
                onCancel: null,
                isCancelled: !1,
                desiredSize: We.desiredSize,
                ready: null
              };
              Je.sinkCapability.resolve(), Je.ready = Je.sinkCapability.promise, this.streamSinks[Ue] = Je, new Promise(function(it) {
                it(Fe(We.data, Je));
              }).then(function() {
                Xe.postMessage({
                  sourceName: Le,
                  targetName: Ze,
                  stream: m.START_COMPLETE,
                  streamId: Ue,
                  success: !0
                });
              }, function(it) {
                Xe.postMessage({
                  sourceName: Le,
                  targetName: Ze,
                  stream: m.START_COMPLETE,
                  streamId: Ue,
                  reason: C(it)
                });
              });
            }
            _processStreamMessage(We) {
              const ye = We.streamId, Fe = this.sourceName, Ue = We.sourceName, Le = this.comObj;
              switch (We.stream) {
                case m.START_COMPLETE:
                  We.success ? this.streamControllers[ye].startCall.resolve() : this.streamControllers[ye].startCall.reject(C(We.reason));
                  break;
                case m.PULL_COMPLETE:
                  We.success ? this.streamControllers[ye].pullCall.resolve() : this.streamControllers[ye].pullCall.reject(C(We.reason));
                  break;
                case m.PULL:
                  if (!this.streamSinks[ye]) {
                    Le.postMessage({
                      sourceName: Fe,
                      targetName: Ue,
                      stream: m.PULL_COMPLETE,
                      streamId: ye,
                      success: !0
                    });
                    break;
                  }
                  this.streamSinks[ye].desiredSize <= 0 && We.desiredSize > 0 && this.streamSinks[ye].sinkCapability.resolve(), this.streamSinks[ye].desiredSize = We.desiredSize;
                  const {
                    onPull: Ze
                  } = this.streamSinks[We.streamId];
                  new Promise(function(Je) {
                    Je(Ze && Ze());
                  }).then(function() {
                    Le.postMessage({
                      sourceName: Fe,
                      targetName: Ue,
                      stream: m.PULL_COMPLETE,
                      streamId: ye,
                      success: !0
                    });
                  }, function(Je) {
                    Le.postMessage({
                      sourceName: Fe,
                      targetName: Ue,
                      stream: m.PULL_COMPLETE,
                      streamId: ye,
                      reason: C(Je)
                    });
                  });
                  break;
                case m.ENQUEUE:
                  if ((0, l.assert)(this.streamControllers[ye], "enqueue should have stream controller"), this.streamControllers[ye].isClosed)
                    break;
                  this.streamControllers[ye].controller.enqueue(We.chunk);
                  break;
                case m.CLOSE:
                  if ((0, l.assert)(this.streamControllers[ye], "close should have stream controller"), this.streamControllers[ye].isClosed)
                    break;
                  this.streamControllers[ye].isClosed = !0, this.streamControllers[ye].controller.close(), this._deleteStreamController(ye);
                  break;
                case m.ERROR:
                  (0, l.assert)(this.streamControllers[ye], "error should have stream controller"), this.streamControllers[ye].controller.error(C(We.reason)), this._deleteStreamController(ye);
                  break;
                case m.CANCEL_COMPLETE:
                  We.success ? this.streamControllers[ye].cancelCall.resolve() : this.streamControllers[ye].cancelCall.reject(C(We.reason)), this._deleteStreamController(ye);
                  break;
                case m.CANCEL:
                  if (!this.streamSinks[ye])
                    break;
                  const {
                    onCancel: Xe
                  } = this.streamSinks[We.streamId];
                  new Promise(function(Je) {
                    Je(Xe && Xe(C(We.reason)));
                  }).then(function() {
                    Le.postMessage({
                      sourceName: Fe,
                      targetName: Ue,
                      stream: m.CANCEL_COMPLETE,
                      streamId: ye,
                      success: !0
                    });
                  }, function(Je) {
                    Le.postMessage({
                      sourceName: Fe,
                      targetName: Ue,
                      stream: m.CANCEL_COMPLETE,
                      streamId: ye,
                      reason: C(Je)
                    });
                  }), this.streamSinks[ye].sinkCapability.reject(C(We.reason)), this.streamSinks[ye].isCancelled = !0, delete this.streamSinks[ye];
                  break;
                default:
                  throw new Error("Unexpected stream case");
              }
            }
            async _deleteStreamController(We) {
              await Promise.allSettled([this.streamControllers[We].startCall, this.streamControllers[We].pullCall, this.streamControllers[We].cancelCall].map(function(ye) {
                return ye && ye.promise;
              })), delete this.streamControllers[We];
            }
            _postMessage(We, ye) {
              ye && this.postMessageTransfers ? this.comObj.postMessage(We, ye) : this.comObj.postMessage(We);
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          s.MessageHandler = O;
        },
        /* 14 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.Metadata = void 0;
          var l = u(2), h = u(15);
          class m {
            constructor(O) {
              (0, l.assert)(typeof O == "string", "Metadata: input is not a string"), O = this._repair(O);
              const We = new h.SimpleXMLParser().parseFromString(O);
              this._metadataMap = /* @__PURE__ */ new Map(), We && this._parse(We);
            }
            _repair(O) {
              return O.replace(/^[^<]+/, "").replace(/>\\376\\377([^<]+)/g, function(le, We) {
                const ye = We.replace(/\\([0-3])([0-7])([0-7])/g, function(Ue, Le, Ze, Xe) {
                  return String.fromCharCode(Le * 64 + Ze * 8 + Xe * 1);
                }).replace(/&(amp|apos|gt|lt|quot);/g, function(Ue, Le) {
                  switch (Le) {
                    case "amp":
                      return "&";
                    case "apos":
                      return "'";
                    case "gt":
                      return ">";
                    case "lt":
                      return "<";
                    case "quot":
                      return '"';
                  }
                  throw new Error(`_repair: ${Le} isn't defined.`);
                });
                let Fe = "";
                for (let Ue = 0, Le = ye.length; Ue < Le; Ue += 2) {
                  const Ze = ye.charCodeAt(Ue) * 256 + ye.charCodeAt(Ue + 1);
                  Ze >= 32 && Ze < 127 && Ze !== 60 && Ze !== 62 && Ze !== 38 ? Fe += String.fromCharCode(Ze) : Fe += "&#x" + (65536 + Ze).toString(16).substring(1) + ";";
                }
                return ">" + Fe;
              });
            }
            _parse(O) {
              let le = O.documentElement;
              if (le.nodeName.toLowerCase() !== "rdf:rdf")
                for (le = le.firstChild; le && le.nodeName.toLowerCase() !== "rdf:rdf"; )
                  le = le.nextSibling;
              const We = le ? le.nodeName.toLowerCase() : null;
              if (!le || We !== "rdf:rdf" || !le.hasChildNodes())
                return;
              const ye = le.childNodes;
              for (let Fe = 0, Ue = ye.length; Fe < Ue; Fe++) {
                const Le = ye[Fe];
                if (Le.nodeName.toLowerCase() === "rdf:description") {
                  for (let Ze = 0, Xe = Le.childNodes.length; Ze < Xe; Ze++)
                    if (Le.childNodes[Ze].nodeName.toLowerCase() !== "#text") {
                      const Je = Le.childNodes[Ze], it = Je.nodeName.toLowerCase();
                      this._metadataMap.set(it, Je.textContent.trim());
                    }
                }
              }
            }
            get(O) {
              return this._metadataMap.has(O) ? this._metadataMap.get(O) : null;
            }
            getAll() {
              return Object.fromEntries(this._metadataMap);
            }
            has(O) {
              return this._metadataMap.has(O);
            }
          }
          s.Metadata = m;
        },
        /* 15 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.SimpleXMLParser = void 0;
          const l = {
            NoError: 0,
            EndOfDocument: -1,
            UnterminatedCdat: -2,
            UnterminatedXmlDeclaration: -3,
            UnterminatedDoctypeDeclaration: -4,
            UnterminatedComment: -5,
            MalformedElement: -6,
            OutOfMemory: -7,
            UnterminatedAttributeValue: -8,
            UnterminatedElement: -9,
            ElementNeverBegun: -10
          };
          function h(We, ye) {
            const Fe = We[ye];
            return Fe === " " || Fe === `
` || Fe === "\r" || Fe === "	";
          }
          function m(We) {
            for (let ye = 0, Fe = We.length; ye < Fe; ye++)
              if (!h(We, ye))
                return !1;
            return !0;
          }
          class C {
            _resolveEntities(ye) {
              return ye.replace(/&([^;]+);/g, (Fe, Ue) => {
                if (Ue.substring(0, 2) === "#x")
                  return String.fromCharCode(parseInt(Ue.substring(2), 16));
                if (Ue.substring(0, 1) === "#")
                  return String.fromCharCode(parseInt(Ue.substring(1), 10));
                switch (Ue) {
                  case "lt":
                    return "<";
                  case "gt":
                    return ">";
                  case "amp":
                    return "&";
                  case "quot":
                    return '"';
                }
                return this.onResolveEntity(Ue);
              });
            }
            _parseContent(ye, Fe) {
              const Ue = [];
              let Le = Fe;
              function Ze() {
                for (; Le < ye.length && h(ye, Le); )
                  ++Le;
              }
              for (; Le < ye.length && !h(ye, Le) && ye[Le] !== ">" && ye[Le] !== "/"; )
                ++Le;
              const Xe = ye.substring(Fe, Le);
              for (Ze(); Le < ye.length && ye[Le] !== ">" && ye[Le] !== "/" && ye[Le] !== "?"; ) {
                Ze();
                let Je = "", it = "";
                for (; Le < ye.length && !h(ye, Le) && ye[Le] !== "="; )
                  Je += ye[Le], ++Le;
                if (Ze(), ye[Le] !== "=")
                  return null;
                ++Le, Ze();
                const et = ye[Le];
                if (et !== '"' && et !== "'")
                  return null;
                const at = ye.indexOf(et, ++Le);
                if (at < 0)
                  return null;
                it = ye.substring(Le, at), Ue.push({
                  name: Je,
                  value: this._resolveEntities(it)
                }), Le = at + 1, Ze();
              }
              return {
                name: Xe,
                attributes: Ue,
                parsed: Le - Fe
              };
            }
            _parseProcessingInstruction(ye, Fe) {
              let Ue = Fe;
              function Le() {
                for (; Ue < ye.length && h(ye, Ue); )
                  ++Ue;
              }
              for (; Ue < ye.length && !h(ye, Ue) && ye[Ue] !== ">" && ye[Ue] !== "/"; )
                ++Ue;
              const Ze = ye.substring(Fe, Ue);
              Le();
              const Xe = Ue;
              for (; Ue < ye.length && (ye[Ue] !== "?" || ye[Ue + 1] !== ">"); )
                ++Ue;
              const Je = ye.substring(Xe, Ue);
              return {
                name: Ze,
                value: Je,
                parsed: Ue - Fe
              };
            }
            parseXml(ye) {
              let Fe = 0;
              for (; Fe < ye.length; ) {
                const Ue = ye[Fe];
                let Le = Fe;
                if (Ue === "<") {
                  ++Le;
                  const Ze = ye[Le];
                  let Xe;
                  switch (Ze) {
                    case "/":
                      if (++Le, Xe = ye.indexOf(">", Le), Xe < 0) {
                        this.onError(l.UnterminatedElement);
                        return;
                      }
                      this.onEndElement(ye.substring(Le, Xe)), Le = Xe + 1;
                      break;
                    case "?":
                      ++Le;
                      const Je = this._parseProcessingInstruction(ye, Le);
                      if (ye.substring(Le + Je.parsed, Le + Je.parsed + 2) !== "?>") {
                        this.onError(l.UnterminatedXmlDeclaration);
                        return;
                      }
                      this.onPi(Je.name, Je.value), Le += Je.parsed + 2;
                      break;
                    case "!":
                      if (ye.substring(Le + 1, Le + 3) === "--") {
                        if (Xe = ye.indexOf("-->", Le + 3), Xe < 0) {
                          this.onError(l.UnterminatedComment);
                          return;
                        }
                        this.onComment(ye.substring(Le + 3, Xe)), Le = Xe + 3;
                      } else if (ye.substring(Le + 1, Le + 8) === "[CDATA[") {
                        if (Xe = ye.indexOf("]]>", Le + 8), Xe < 0) {
                          this.onError(l.UnterminatedCdat);
                          return;
                        }
                        this.onCdata(ye.substring(Le + 8, Xe)), Le = Xe + 3;
                      } else if (ye.substring(Le + 1, Le + 8) === "DOCTYPE") {
                        const at = ye.indexOf("[", Le + 8);
                        let $e = !1;
                        if (Xe = ye.indexOf(">", Le + 8), Xe < 0) {
                          this.onError(l.UnterminatedDoctypeDeclaration);
                          return;
                        }
                        if (at > 0 && Xe > at) {
                          if (Xe = ye.indexOf("]>", Le + 8), Xe < 0) {
                            this.onError(l.UnterminatedDoctypeDeclaration);
                            return;
                          }
                          $e = !0;
                        }
                        const Ke = ye.substring(Le + 8, Xe + ($e ? 1 : 0));
                        this.onDoctype(Ke), Le = Xe + ($e ? 2 : 1);
                      } else {
                        this.onError(l.MalformedElement);
                        return;
                      }
                      break;
                    default:
                      const it = this._parseContent(ye, Le);
                      if (it === null) {
                        this.onError(l.MalformedElement);
                        return;
                      }
                      let et = !1;
                      if (ye.substring(Le + it.parsed, Le + it.parsed + 2) === "/>")
                        et = !0;
                      else if (ye.substring(Le + it.parsed, Le + it.parsed + 1) !== ">") {
                        this.onError(l.UnterminatedElement);
                        return;
                      }
                      this.onBeginElement(it.name, it.attributes, et), Le += it.parsed + (et ? 2 : 1);
                      break;
                  }
                } else {
                  for (; Le < ye.length && ye[Le] !== "<"; )
                    Le++;
                  const Ze = ye.substring(Fe, Le);
                  this.onText(this._resolveEntities(Ze));
                }
                Fe = Le;
              }
            }
            onResolveEntity(ye) {
              return `&${ye};`;
            }
            onPi(ye, Fe) {
            }
            onComment(ye) {
            }
            onCdata(ye) {
            }
            onDoctype(ye) {
            }
            onText(ye) {
            }
            onBeginElement(ye, Fe, Ue) {
            }
            onEndElement(ye) {
            }
            onError(ye) {
            }
          }
          class O {
            constructor(ye, Fe) {
              this.nodeName = ye, this.nodeValue = Fe, Object.defineProperty(this, "parentNode", {
                value: null,
                writable: !0
              });
            }
            get firstChild() {
              return this.childNodes && this.childNodes[0];
            }
            get nextSibling() {
              const ye = this.parentNode.childNodes;
              if (!ye)
                return;
              const Fe = ye.indexOf(this);
              if (Fe !== -1)
                return ye[Fe + 1];
            }
            get textContent() {
              return this.childNodes ? this.childNodes.map(function(ye) {
                return ye.textContent;
              }).join("") : this.nodeValue || "";
            }
            hasChildNodes() {
              return this.childNodes && this.childNodes.length > 0;
            }
          }
          class le extends C {
            constructor() {
              super(), this._currentFragment = null, this._stack = null, this._errorCode = l.NoError;
            }
            parseFromString(ye) {
              if (this._currentFragment = [], this._stack = [], this._errorCode = l.NoError, this.parseXml(ye), this._errorCode !== l.NoError)
                return;
              const [Fe] = this._currentFragment;
              if (Fe)
                return {
                  documentElement: Fe
                };
            }
            onResolveEntity(ye) {
              switch (ye) {
                case "apos":
                  return "'";
              }
              return super.onResolveEntity(ye);
            }
            onText(ye) {
              if (m(ye))
                return;
              const Fe = new O("#text", ye);
              this._currentFragment.push(Fe);
            }
            onCdata(ye) {
              const Fe = new O("#text", ye);
              this._currentFragment.push(Fe);
            }
            onBeginElement(ye, Fe, Ue) {
              const Le = new O(ye);
              Le.childNodes = [], this._currentFragment.push(Le), !Ue && (this._stack.push(this._currentFragment), this._currentFragment = Le.childNodes);
            }
            onEndElement(ye) {
              this._currentFragment = this._stack.pop() || [];
              const Fe = this._currentFragment[this._currentFragment.length - 1];
              if (Fe)
                for (let Ue = 0, Le = Fe.childNodes.length; Ue < Le; Ue++)
                  Fe.childNodes[Ue].parentNode = Fe;
            }
            onError(ye) {
              this._errorCode = ye;
            }
          }
          s.SimpleXMLParser = le;
        },
        /* 16 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.OptionalContentConfig = void 0;
          var l = u(2);
          class h {
            constructor(O, le) {
              this.visible = !0, this.name = O, this.intent = le;
            }
          }
          class m {
            constructor(O) {
              if (this.name = null, this.creator = null, this._order = null, this._groups = /* @__PURE__ */ new Map(), O !== null) {
                this.name = O.name, this.creator = O.creator, this._order = O.order;
                for (const le of O.groups)
                  this._groups.set(le.id, new h(le.name, le.intent));
                if (O.baseState === "OFF")
                  for (const le of this._groups)
                    le.visible = !1;
                for (const le of O.on)
                  this._groups.get(le).visible = !0;
                for (const le of O.off)
                  this._groups.get(le).visible = !1;
              }
            }
            isVisible(O) {
              if (O.type === "OCG")
                return this._groups.has(O.id) ? this._groups.get(O.id).visible : ((0, l.warn)(`Optional content group not found: ${O.id}`), !0);
              if (O.type === "OCMD") {
                if (O.expression && (0, l.warn)("Visibility expression not supported yet."), !O.policy || O.policy === "AnyOn") {
                  for (const le of O.ids) {
                    if (!this._groups.has(le))
                      return (0, l.warn)(`Optional content group not found: ${le}`), !0;
                    if (this._groups.get(le).visible)
                      return !0;
                  }
                  return !1;
                } else if (O.policy === "AllOn") {
                  for (const le of O.ids) {
                    if (!this._groups.has(le))
                      return (0, l.warn)(`Optional content group not found: ${le}`), !0;
                    if (!this._groups.get(le).visible)
                      return !1;
                  }
                  return !0;
                } else if (O.policy === "AnyOff") {
                  for (const le of O.ids) {
                    if (!this._groups.has(le))
                      return (0, l.warn)(`Optional content group not found: ${le}`), !0;
                    if (!this._groups.get(le).visible)
                      return !0;
                  }
                  return !1;
                } else if (O.policy === "AllOff") {
                  for (const le of O.ids) {
                    if (!this._groups.has(le))
                      return (0, l.warn)(`Optional content group not found: ${le}`), !0;
                    if (this._groups.get(le).visible)
                      return !1;
                  }
                  return !0;
                }
                return (0, l.warn)(`Unknown optional content policy ${O.policy}.`), !0;
              }
              return (0, l.warn)(`Unknown group type ${O.type}.`), !0;
            }
            setVisibility(O, le = !0) {
              if (!this._groups.has(O)) {
                (0, l.warn)(`Optional content group not found: ${O}`);
                return;
              }
              this._groups.get(O).visible = !!le;
            }
            getOrder() {
              return this._groups.size ? this._order ? this._order.slice() : Array.from(this._groups.keys()) : null;
            }
            getGroups() {
              return this._groups.size ? Object.fromEntries(this._groups) : null;
            }
            getGroup(O) {
              return this._groups.get(O) || null;
            }
          }
          s.OptionalContentConfig = m;
        },
        /* 17 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFDataTransportStream = void 0;
          var l = u(2);
          class h {
            constructor(le, We) {
              (0, l.assert)(We, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = le.progressiveDone || !1;
              const ye = le.initialData;
              if (ye && ye.length > 0) {
                const Fe = new Uint8Array(ye).buffer;
                this._queuedChunks.push(Fe);
              }
              this._pdfDataRangeTransport = We, this._isStreamingSupported = !le.disableStream, this._isRangeSupported = !le.disableRange, this._contentLength = le.length, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((Fe, Ue) => {
                this._onReceiveData({
                  begin: Fe,
                  chunk: Ue
                });
              }), this._pdfDataRangeTransport.addProgressListener((Fe, Ue) => {
                this._onProgress({
                  loaded: Fe,
                  total: Ue
                });
              }), this._pdfDataRangeTransport.addProgressiveReadListener((Fe) => {
                this._onReceiveData({
                  chunk: Fe
                });
              }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                this._onProgressiveDone();
              }), this._pdfDataRangeTransport.transportReady();
            }
            _onReceiveData(le) {
              const We = new Uint8Array(le.chunk).buffer;
              if (le.begin === void 0)
                this._fullRequestReader ? this._fullRequestReader._enqueue(We) : this._queuedChunks.push(We);
              else {
                const ye = this._rangeReaders.some(function(Fe) {
                  return Fe._begin !== le.begin ? !1 : (Fe._enqueue(We), !0);
                });
                (0, l.assert)(ye, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
              }
            }
            get _progressiveDataLength() {
              return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
            }
            _onProgress(le) {
              if (le.total === void 0) {
                const We = this._rangeReaders[0];
                We && We.onProgress && We.onProgress({
                  loaded: le.loaded
                });
              } else {
                const We = this._fullRequestReader;
                We && We.onProgress && We.onProgress({
                  loaded: le.loaded,
                  total: le.total
                });
              }
            }
            _onProgressiveDone() {
              this._fullRequestReader && this._fullRequestReader.progressiveDone(), this._progressiveDone = !0;
            }
            _removeRangeReader(le) {
              const We = this._rangeReaders.indexOf(le);
              We >= 0 && this._rangeReaders.splice(We, 1);
            }
            getFullReader() {
              (0, l.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
              const le = this._queuedChunks;
              return this._queuedChunks = null, new m(this, le, this._progressiveDone);
            }
            getRangeReader(le, We) {
              if (We <= this._progressiveDataLength)
                return null;
              const ye = new C(this, le, We);
              return this._pdfDataRangeTransport.requestDataRange(le, We), this._rangeReaders.push(ye), ye;
            }
            cancelAllRequests(le) {
              this._fullRequestReader && this._fullRequestReader.cancel(le), this._rangeReaders.slice(0).forEach(function(ye) {
                ye.cancel(le);
              }), this._pdfDataRangeTransport.abort();
            }
          }
          s.PDFDataTransportStream = h;
          class m {
            constructor(le, We, ye = !1) {
              this._stream = le, this._done = ye || !1, this._filename = null, this._queuedChunks = We || [], this._loaded = 0;
              for (const Fe of this._queuedChunks)
                this._loaded += Fe.byteLength;
              this._requests = [], this._headersReady = Promise.resolve(), le._fullRequestReader = this, this.onProgress = null;
            }
            _enqueue(le) {
              this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                value: le,
                done: !1
              }) : this._queuedChunks.push(le), this._loaded += le.byteLength);
            }
            get headersReady() {
              return this._headersReady;
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._stream._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._stream._isStreamingSupported;
            }
            get contentLength() {
              return this._stream._contentLength;
            }
            async read() {
              if (this._queuedChunks.length > 0)
                return {
                  value: this._queuedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const le = (0, l.createPromiseCapability)();
              return this._requests.push(le), le.promise;
            }
            cancel(le) {
              this._done = !0, this._requests.forEach(function(We) {
                We.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [];
            }
            progressiveDone() {
              this._done || (this._done = !0);
            }
          }
          class C {
            constructor(le, We, ye) {
              this._stream = le, this._begin = We, this._end = ye, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
            }
            _enqueue(le) {
              this._done || (this._requests.length === 0 ? this._queuedChunk = le : (this._requests.shift().resolve({
                value: le,
                done: !1
              }), this._requests.forEach(function(ye) {
                ye.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = []), this._done = !0, this._stream._removeRangeReader(this));
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._queuedChunk) {
                const We = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: We,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const le = (0, l.createPromiseCapability)();
              return this._requests.push(le), le.promise;
            }
            cancel(le) {
              this._done = !0, this._requests.forEach(function(We) {
                We.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [], this._stream._removeRangeReader(this);
            }
          }
        },
        /* 18 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.WebGLContext = void 0;
          var l = u(2);
          class h {
            constructor({
              enable: O = !1
            }) {
              this._enabled = O === !0;
            }
            get isEnabled() {
              let O = this._enabled;
              return O && (O = m.tryInitGL()), (0, l.shadow)(this, "isEnabled", O);
            }
            composeSMask({
              layer: O,
              mask: le,
              properties: We
            }) {
              return m.composeSMask(O, le, We);
            }
            drawFigures({
              width: O,
              height: le,
              backgroundColor: We,
              figures: ye,
              context: Fe
            }) {
              return m.drawFigures(O, le, We, ye, Fe);
            }
            clear() {
              m.cleanup();
            }
          }
          s.WebGLContext = h;
          var m = function() {
            function O(ot, ht, vt) {
              var At = ot.createShader(vt);
              ot.shaderSource(At, ht), ot.compileShader(At);
              var gt = ot.getShaderParameter(At, ot.COMPILE_STATUS);
              if (!gt) {
                var bt = ot.getShaderInfoLog(At);
                throw new Error("Error during shader compilation: " + bt);
              }
              return At;
            }
            function le(ot, ht) {
              return O(ot, ht, ot.VERTEX_SHADER);
            }
            function We(ot, ht) {
              return O(ot, ht, ot.FRAGMENT_SHADER);
            }
            function ye(ot, ht) {
              for (var vt = ot.createProgram(), At = 0, gt = ht.length; At < gt; ++At)
                ot.attachShader(vt, ht[At]);
              ot.linkProgram(vt);
              var bt = ot.getProgramParameter(vt, ot.LINK_STATUS);
              if (!bt) {
                var wt = ot.getProgramInfoLog(vt);
                throw new Error("Error during program linking: " + wt);
              }
              return vt;
            }
            function Fe(ot, ht, vt) {
              ot.activeTexture(vt);
              var At = ot.createTexture();
              return ot.bindTexture(ot.TEXTURE_2D, At), ot.texParameteri(ot.TEXTURE_2D, ot.TEXTURE_WRAP_S, ot.CLAMP_TO_EDGE), ot.texParameteri(ot.TEXTURE_2D, ot.TEXTURE_WRAP_T, ot.CLAMP_TO_EDGE), ot.texParameteri(ot.TEXTURE_2D, ot.TEXTURE_MIN_FILTER, ot.NEAREST), ot.texParameteri(ot.TEXTURE_2D, ot.TEXTURE_MAG_FILTER, ot.NEAREST), ot.texImage2D(ot.TEXTURE_2D, 0, ot.RGBA, ot.RGBA, ot.UNSIGNED_BYTE, ht), At;
            }
            var Ue, Le;
            function Ze() {
              Ue || (Le = document.createElement("canvas"), Ue = Le.getContext("webgl", {
                premultipliedalpha: !1
              }));
            }
            var Xe = "	  attribute vec2 a_position;                                    	  attribute vec2 a_texCoord;                                    	                                                                	  uniform vec2 u_resolution;                                    	                                                                	  varying vec2 v_texCoord;                                      	                                                                	  void main() {                                                 	    vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;   	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          	                                                                	    v_texCoord = a_texCoord;                                    	  }                                                             ", Je = "	  precision mediump float;                                      	                                                                	  uniform vec4 u_backdrop;                                      	  uniform int u_subtype;                                        	  uniform sampler2D u_image;                                    	  uniform sampler2D u_mask;                                     	                                                                	  varying vec2 v_texCoord;                                      	                                                                	  void main() {                                                 	    vec4 imageColor = texture2D(u_image, v_texCoord);           	    vec4 maskColor = texture2D(u_mask, v_texCoord);             	    if (u_backdrop.a > 0.0) {                                   	      maskColor.rgb = maskColor.rgb * maskColor.a +             	                      u_backdrop.rgb * (1.0 - maskColor.a);     	    }                                                           	    float lum;                                                  	    if (u_subtype == 0) {                                       	      lum = maskColor.a;                                        	    } else {                                                    	      lum = maskColor.r * 0.3 + maskColor.g * 0.59 +            	            maskColor.b * 0.11;                                 	    }                                                           	    imageColor.a *= lum;                                        	    imageColor.rgb *= imageColor.a;                             	    gl_FragColor = imageColor;                                  	  }                                                             ", it = null;
            function et() {
              var ot, ht;
              Ze(), ot = Le, Le = null, ht = Ue, Ue = null;
              var vt = le(ht, Xe), At = We(ht, Je), gt = ye(ht, [vt, At]);
              ht.useProgram(gt);
              var bt = {};
              bt.gl = ht, bt.canvas = ot, bt.resolutionLocation = ht.getUniformLocation(gt, "u_resolution"), bt.positionLocation = ht.getAttribLocation(gt, "a_position"), bt.backdropLocation = ht.getUniformLocation(gt, "u_backdrop"), bt.subtypeLocation = ht.getUniformLocation(gt, "u_subtype");
              var wt = ht.getAttribLocation(gt, "a_texCoord"), Ot = ht.getUniformLocation(gt, "u_image"), yt = ht.getUniformLocation(gt, "u_mask"), Qe = ht.createBuffer();
              ht.bindBuffer(ht.ARRAY_BUFFER, Qe), ht.bufferData(ht.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]), ht.STATIC_DRAW), ht.enableVertexAttribArray(wt), ht.vertexAttribPointer(wt, 2, ht.FLOAT, !1, 0, 0), ht.uniform1i(Ot, 0), ht.uniform1i(yt, 1), it = bt;
            }
            function at(ot, ht, vt) {
              var At = ot.width, gt = ot.height;
              it || et();
              var bt = it, wt = bt.canvas, Ot = bt.gl;
              wt.width = At, wt.height = gt, Ot.viewport(0, 0, Ot.drawingBufferWidth, Ot.drawingBufferHeight), Ot.uniform2f(bt.resolutionLocation, At, gt), vt.backdrop ? Ot.uniform4f(bt.resolutionLocation, vt.backdrop[0], vt.backdrop[1], vt.backdrop[2], 1) : Ot.uniform4f(bt.resolutionLocation, 0, 0, 0, 0), Ot.uniform1i(bt.subtypeLocation, vt.subtype === "Luminosity" ? 1 : 0);
              var yt = Fe(Ot, ot, Ot.TEXTURE0), Qe = Fe(Ot, ht, Ot.TEXTURE1), nt = Ot.createBuffer();
              return Ot.bindBuffer(Ot.ARRAY_BUFFER, nt), Ot.bufferData(Ot.ARRAY_BUFFER, new Float32Array([0, 0, At, 0, 0, gt, 0, gt, At, 0, At, gt]), Ot.STATIC_DRAW), Ot.enableVertexAttribArray(bt.positionLocation), Ot.vertexAttribPointer(bt.positionLocation, 2, Ot.FLOAT, !1, 0, 0), Ot.clearColor(0, 0, 0, 0), Ot.enable(Ot.BLEND), Ot.blendFunc(Ot.ONE, Ot.ONE_MINUS_SRC_ALPHA), Ot.clear(Ot.COLOR_BUFFER_BIT), Ot.drawArrays(Ot.TRIANGLES, 0, 6), Ot.flush(), Ot.deleteTexture(yt), Ot.deleteTexture(Qe), Ot.deleteBuffer(nt), wt;
            }
            var $e = "	  attribute vec2 a_position;                                    	  attribute vec3 a_color;                                       	                                                                	  uniform vec2 u_resolution;                                    	  uniform vec2 u_scale;                                         	  uniform vec2 u_offset;                                        	                                                                	  varying vec4 v_color;                                         	                                                                	  void main() {                                                 	    vec2 position = (a_position + u_offset) * u_scale;          	    vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;     	    gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);          	                                                                	    v_color = vec4(a_color / 255.0, 1.0);                       	  }                                                             ", Ke = "	  precision mediump float;                                      	                                                                	  varying vec4 v_color;                                         	                                                                	  void main() {                                                 	    gl_FragColor = v_color;                                     	  }                                                             ", tt = null;
            function ut() {
              var ot, ht;
              Ze(), ot = Le, Le = null, ht = Ue, Ue = null;
              var vt = le(ht, $e), At = We(ht, Ke), gt = ye(ht, [vt, At]);
              ht.useProgram(gt);
              var bt = {};
              bt.gl = ht, bt.canvas = ot, bt.resolutionLocation = ht.getUniformLocation(gt, "u_resolution"), bt.scaleLocation = ht.getUniformLocation(gt, "u_scale"), bt.offsetLocation = ht.getUniformLocation(gt, "u_offset"), bt.positionLocation = ht.getAttribLocation(gt, "a_position"), bt.colorLocation = ht.getAttribLocation(gt, "a_color"), tt = bt;
            }
            function st(ot, ht, vt, At, gt) {
              tt || ut();
              var bt = tt, wt = bt.canvas, Ot = bt.gl;
              wt.width = ot, wt.height = ht, Ot.viewport(0, 0, Ot.drawingBufferWidth, Ot.drawingBufferHeight), Ot.uniform2f(bt.resolutionLocation, ot, ht);
              var yt = 0, Qe, nt, rt;
              for (Qe = 0, nt = At.length; Qe < nt; Qe++)
                switch (At[Qe].type) {
                  case "lattice":
                    rt = At[Qe].coords.length / At[Qe].verticesPerRow | 0, yt += (rt - 1) * (At[Qe].verticesPerRow - 1) * 6;
                    break;
                  case "triangles":
                    yt += At[Qe].coords.length;
                    break;
                }
              var lt = new Float32Array(yt * 2), ct = new Uint8Array(yt * 3), ft = gt.coords, pt = gt.colors, mt = 0, dt = 0;
              for (Qe = 0, nt = At.length; Qe < nt; Qe++) {
                var Et = At[Qe], Ct = Et.coords, Tt = Et.colors;
                switch (Et.type) {
                  case "lattice":
                    var qt = Et.verticesPerRow;
                    rt = Ct.length / qt | 0;
                    for (var jt = 1; jt < rt; jt++)
                      for (var St = jt * qt + 1, Mt = 1; Mt < qt; Mt++, St++)
                        lt[mt] = ft[Ct[St - qt - 1]], lt[mt + 1] = ft[Ct[St - qt - 1] + 1], lt[mt + 2] = ft[Ct[St - qt]], lt[mt + 3] = ft[Ct[St - qt] + 1], lt[mt + 4] = ft[Ct[St - 1]], lt[mt + 5] = ft[Ct[St - 1] + 1], ct[dt] = pt[Tt[St - qt - 1]], ct[dt + 1] = pt[Tt[St - qt - 1] + 1], ct[dt + 2] = pt[Tt[St - qt - 1] + 2], ct[dt + 3] = pt[Tt[St - qt]], ct[dt + 4] = pt[Tt[St - qt] + 1], ct[dt + 5] = pt[Tt[St - qt] + 2], ct[dt + 6] = pt[Tt[St - 1]], ct[dt + 7] = pt[Tt[St - 1] + 1], ct[dt + 8] = pt[Tt[St - 1] + 2], lt[mt + 6] = lt[mt + 2], lt[mt + 7] = lt[mt + 3], lt[mt + 8] = lt[mt + 4], lt[mt + 9] = lt[mt + 5], lt[mt + 10] = ft[Ct[St]], lt[mt + 11] = ft[Ct[St] + 1], ct[dt + 9] = ct[dt + 3], ct[dt + 10] = ct[dt + 4], ct[dt + 11] = ct[dt + 5], ct[dt + 12] = ct[dt + 6], ct[dt + 13] = ct[dt + 7], ct[dt + 14] = ct[dt + 8], ct[dt + 15] = pt[Tt[St]], ct[dt + 16] = pt[Tt[St] + 1], ct[dt + 17] = pt[Tt[St] + 2], mt += 12, dt += 18;
                    break;
                  case "triangles":
                    for (var Dt = 0, Nt = Ct.length; Dt < Nt; Dt++)
                      lt[mt] = ft[Ct[Dt]], lt[mt + 1] = ft[Ct[Dt] + 1], ct[dt] = pt[Tt[Dt]], ct[dt + 1] = pt[Tt[Dt] + 1], ct[dt + 2] = pt[Tt[Dt] + 2], mt += 2, dt += 3;
                    break;
                }
              }
              vt ? Ot.clearColor(vt[0] / 255, vt[1] / 255, vt[2] / 255, 1) : Ot.clearColor(0, 0, 0, 0), Ot.clear(Ot.COLOR_BUFFER_BIT);
              var Kt = Ot.createBuffer();
              Ot.bindBuffer(Ot.ARRAY_BUFFER, Kt), Ot.bufferData(Ot.ARRAY_BUFFER, lt, Ot.STATIC_DRAW), Ot.enableVertexAttribArray(bt.positionLocation), Ot.vertexAttribPointer(bt.positionLocation, 2, Ot.FLOAT, !1, 0, 0);
              var Ft = Ot.createBuffer();
              return Ot.bindBuffer(Ot.ARRAY_BUFFER, Ft), Ot.bufferData(Ot.ARRAY_BUFFER, ct, Ot.STATIC_DRAW), Ot.enableVertexAttribArray(bt.colorLocation), Ot.vertexAttribPointer(bt.colorLocation, 3, Ot.UNSIGNED_BYTE, !1, 0, 0), Ot.uniform2f(bt.scaleLocation, gt.scaleX, gt.scaleY), Ot.uniform2f(bt.offsetLocation, gt.offsetX, gt.offsetY), Ot.drawArrays(Ot.TRIANGLES, 0, yt), Ot.flush(), Ot.deleteBuffer(Kt), Ot.deleteBuffer(Ft), wt;
            }
            return {
              tryInitGL() {
                try {
                  return Ze(), !!Ue;
                } catch {
                }
                return !1;
              },
              composeSMask: at,
              drawFigures: st,
              cleanup() {
                it && it.canvas && (it.canvas.width = 0, it.canvas.height = 0), tt && tt.canvas && (tt.canvas.width = 0, tt.canvas.height = 0), it = null, tt = null;
              }
            };
          }();
        },
        /* 19 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.AnnotationLayer = void 0;
          var l = u(1), h = u(2), m = u(8);
          class C {
            static create(Qe) {
              switch (Qe.data.annotationType) {
                case h.AnnotationType.LINK:
                  return new le(Qe);
                case h.AnnotationType.TEXT:
                  return new We(Qe);
                case h.AnnotationType.WIDGET:
                  switch (Qe.data.fieldType) {
                    case "Tx":
                      return new Fe(Qe);
                    case "Btn":
                      return Qe.data.radioButton ? new Le(Qe) : Qe.data.checkBox ? new Ue(Qe) : new Ze(Qe);
                    case "Ch":
                      return new Xe(Qe);
                  }
                  return new ye(Qe);
                case h.AnnotationType.POPUP:
                  return new Je(Qe);
                case h.AnnotationType.FREETEXT:
                  return new et(Qe);
                case h.AnnotationType.LINE:
                  return new at(Qe);
                case h.AnnotationType.SQUARE:
                  return new $e(Qe);
                case h.AnnotationType.CIRCLE:
                  return new Ke(Qe);
                case h.AnnotationType.POLYLINE:
                  return new tt(Qe);
                case h.AnnotationType.CARET:
                  return new st(Qe);
                case h.AnnotationType.INK:
                  return new ot(Qe);
                case h.AnnotationType.POLYGON:
                  return new ut(Qe);
                case h.AnnotationType.HIGHLIGHT:
                  return new ht(Qe);
                case h.AnnotationType.UNDERLINE:
                  return new vt(Qe);
                case h.AnnotationType.SQUIGGLY:
                  return new At(Qe);
                case h.AnnotationType.STRIKEOUT:
                  return new gt(Qe);
                case h.AnnotationType.STAMP:
                  return new bt(Qe);
                case h.AnnotationType.FILEATTACHMENT:
                  return new wt(Qe);
                default:
                  return new O(Qe);
              }
            }
          }
          class O {
            constructor(Qe, nt = !1, rt = !1) {
              this.isRenderable = nt, this.data = Qe.data, this.layer = Qe.layer, this.page = Qe.page, this.viewport = Qe.viewport, this.linkService = Qe.linkService, this.downloadManager = Qe.downloadManager, this.imageResourcesPath = Qe.imageResourcesPath, this.renderInteractiveForms = Qe.renderInteractiveForms, this.svgFactory = Qe.svgFactory, this.annotationStorage = Qe.annotationStorage, nt && (this.container = this._createContainer(rt));
            }
            _createContainer(Qe = !1) {
              const nt = this.data, rt = this.page, lt = this.viewport, ct = document.createElement("section");
              let ft = nt.rect[2] - nt.rect[0], pt = nt.rect[3] - nt.rect[1];
              ct.setAttribute("data-annotation-id", nt.id);
              const mt = h.Util.normalizeRect([nt.rect[0], rt.view[3] - nt.rect[1] + rt.view[1], nt.rect[2], rt.view[3] - nt.rect[3] + rt.view[1]]);
              if (ct.style.transform = `matrix(${lt.transform.join(",")})`, ct.style.transformOrigin = `-${mt[0]}px -${mt[1]}px`, !Qe && nt.borderStyle.width > 0) {
                ct.style.borderWidth = `${nt.borderStyle.width}px`, nt.borderStyle.style !== h.AnnotationBorderStyleType.UNDERLINE && (ft = ft - 2 * nt.borderStyle.width, pt = pt - 2 * nt.borderStyle.width);
                const dt = nt.borderStyle.horizontalCornerRadius, Et = nt.borderStyle.verticalCornerRadius;
                if (dt > 0 || Et > 0) {
                  const Ct = `${dt}px / ${Et}px`;
                  ct.style.borderRadius = Ct;
                }
                switch (nt.borderStyle.style) {
                  case h.AnnotationBorderStyleType.SOLID:
                    ct.style.borderStyle = "solid";
                    break;
                  case h.AnnotationBorderStyleType.DASHED:
                    ct.style.borderStyle = "dashed";
                    break;
                  case h.AnnotationBorderStyleType.BEVELED:
                    (0, h.warn)("Unimplemented border style: beveled");
                    break;
                  case h.AnnotationBorderStyleType.INSET:
                    (0, h.warn)("Unimplemented border style: inset");
                    break;
                  case h.AnnotationBorderStyleType.UNDERLINE:
                    ct.style.borderBottomStyle = "solid";
                    break;
                }
                nt.color ? ct.style.borderColor = h.Util.makeCssRgb(nt.color[0] | 0, nt.color[1] | 0, nt.color[2] | 0) : ct.style.borderWidth = 0;
              }
              return ct.style.left = `${mt[0]}px`, ct.style.top = `${mt[1]}px`, ct.style.width = `${ft}px`, ct.style.height = `${pt}px`, ct;
            }
            _createPopup(Qe, nt, rt) {
              nt || (nt = document.createElement("div"), nt.style.height = Qe.style.height, nt.style.width = Qe.style.width, Qe.appendChild(nt));
              const ct = new it({
                container: Qe,
                trigger: nt,
                color: rt.color,
                title: rt.title,
                modificationDate: rt.modificationDate,
                contents: rt.contents,
                hideWrapper: !0
              }).render();
              ct.style.left = Qe.style.width, Qe.appendChild(ct);
            }
            render() {
              (0, h.unreachable)("Abstract method `AnnotationElement.render` called");
            }
          }
          class le extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.url || Qe.data.dest || Qe.data.action);
              super(Qe, nt);
            }
            render() {
              this.container.className = "linkAnnotation";
              const {
                data: Qe,
                linkService: nt
              } = this, rt = document.createElement("a");
              return Qe.url ? (0, l.addLinkAttributes)(rt, {
                url: Qe.url,
                target: Qe.newWindow ? l.LinkTarget.BLANK : nt.externalLinkTarget,
                rel: nt.externalLinkRel,
                enabled: nt.externalLinkEnabled
              }) : Qe.action ? this._bindNamedAction(rt, Qe.action) : this._bindLink(rt, Qe.dest), this.container.appendChild(rt), this.container;
            }
            _bindLink(Qe, nt) {
              Qe.href = this.linkService.getDestinationHash(nt), Qe.onclick = () => (nt && this.linkService.navigateTo(nt), !1), nt && (Qe.className = "internalLink");
            }
            _bindNamedAction(Qe, nt) {
              Qe.href = this.linkService.getAnchorUrl(""), Qe.onclick = () => (this.linkService.executeNamedAction(nt), !1), Qe.className = "internalLink";
            }
          }
          class We extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt);
            }
            render() {
              this.container.className = "textAnnotation";
              const Qe = document.createElement("img");
              return Qe.style.height = this.container.style.height, Qe.style.width = this.container.style.width, Qe.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", Qe.alt = "[{{type}} Annotation]", Qe.dataset.l10nId = "text_annotation_type", Qe.dataset.l10nArgs = JSON.stringify({
                type: this.data.name
              }), this.data.hasPopup || this._createPopup(this.container, Qe, this.data), this.container.appendChild(Qe), this.container;
            }
          }
          class ye extends O {
            render() {
              return this.container;
            }
          }
          class Fe extends ye {
            constructor(Qe) {
              const nt = Qe.renderInteractiveForms || !Qe.data.hasAppearance && !!Qe.data.fieldValue;
              super(Qe, nt);
            }
            render() {
              const Qe = ["left", "center", "right"], nt = this.annotationStorage, rt = this.data.id;
              this.container.className = "textWidgetAnnotation";
              let lt = null;
              if (this.renderInteractiveForms) {
                const ct = nt.getOrCreateValue(rt, this.data.fieldValue);
                if (this.data.multiLine ? (lt = document.createElement("textarea"), lt.textContent = ct) : (lt = document.createElement("input"), lt.type = "text", lt.setAttribute("value", ct)), lt.addEventListener("input", function(ft) {
                  nt.setValue(rt, ft.target.value);
                }), lt.disabled = this.data.readOnly, lt.name = this.data.fieldName, this.data.maxLen !== null && (lt.maxLength = this.data.maxLen), this.data.comb) {
                  const pt = (this.data.rect[2] - this.data.rect[0]) / this.data.maxLen;
                  lt.classList.add("comb"), lt.style.letterSpacing = `calc(${pt}px - 1ch)`;
                }
              } else {
                lt = document.createElement("div"), lt.textContent = this.data.fieldValue, lt.style.verticalAlign = "middle", lt.style.display = "table-cell";
                let ct = null;
                this.data.fontRefName && this.page.commonObjs.has(this.data.fontRefName) && (ct = this.page.commonObjs.get(this.data.fontRefName)), this._setTextStyle(lt, ct);
              }
              return this.data.textAlignment !== null && (lt.style.textAlign = Qe[this.data.textAlignment]), this.container.appendChild(lt), this.container;
            }
            _setTextStyle(Qe, nt) {
              const rt = Qe.style;
              if (rt.fontSize = `${this.data.fontSize}px`, rt.direction = this.data.fontDirection < 0 ? "rtl" : "ltr", !nt)
                return;
              let lt = "normal";
              nt.black ? lt = "900" : nt.bold && (lt = "bold"), rt.fontWeight = lt, rt.fontStyle = nt.italic ? "italic" : "normal";
              const ct = nt.loadedName ? `"${nt.loadedName}", ` : "", ft = nt.fallbackName || "Helvetica, sans-serif";
              rt.fontFamily = ct + ft;
            }
          }
          class Ue extends ye {
            constructor(Qe) {
              super(Qe, Qe.renderInteractiveForms);
            }
            render() {
              const Qe = this.annotationStorage, nt = this.data, rt = nt.id, lt = Qe.getOrCreateValue(rt, nt.fieldValue && nt.fieldValue !== "Off");
              this.container.className = "buttonWidgetAnnotation checkBox";
              const ct = document.createElement("input");
              return ct.disabled = nt.readOnly, ct.type = "checkbox", ct.name = this.data.fieldName, lt && ct.setAttribute("checked", !0), ct.addEventListener("change", function(ft) {
                Qe.setValue(rt, ft.target.checked);
              }), this.container.appendChild(ct), this.container;
            }
          }
          class Le extends ye {
            constructor(Qe) {
              super(Qe, Qe.renderInteractiveForms);
            }
            render() {
              this.container.className = "buttonWidgetAnnotation radioButton";
              const Qe = this.annotationStorage, nt = this.data, rt = nt.id, lt = Qe.getOrCreateValue(rt, nt.fieldValue === nt.buttonValue), ct = document.createElement("input");
              return ct.disabled = nt.readOnly, ct.type = "radio", ct.name = nt.fieldName, lt && ct.setAttribute("checked", !0), ct.addEventListener("change", function(ft) {
                const pt = ft.target.name;
                for (const mt of document.getElementsByName(pt))
                  mt !== ft.target && Qe.setValue(mt.parentNode.getAttribute("data-annotation-id"), !1);
                Qe.setValue(rt, ft.target.checked);
              }), this.container.appendChild(ct), this.container;
            }
          }
          class Ze extends le {
            render() {
              const Qe = super.render();
              return Qe.className = "buttonWidgetAnnotation pushButton", Qe;
            }
          }
          class Xe extends ye {
            constructor(Qe) {
              super(Qe, Qe.renderInteractiveForms);
            }
            render() {
              this.container.className = "choiceWidgetAnnotation";
              const Qe = this.annotationStorage, nt = this.data.id;
              Qe.getOrCreateValue(nt, this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null);
              const rt = document.createElement("select");
              rt.disabled = this.data.readOnly, rt.name = this.data.fieldName, this.data.combo || (rt.size = this.data.options.length, this.data.multiSelect && (rt.multiple = !0));
              for (const lt of this.data.options) {
                const ct = document.createElement("option");
                ct.textContent = lt.displayValue, ct.value = lt.exportValue, this.data.fieldValue.includes(lt.exportValue) && ct.setAttribute("selected", !0), rt.appendChild(ct);
              }
              return rt.addEventListener("input", function(lt) {
                const ct = lt.target.options, ft = ct[ct.selectedIndex].value;
                Qe.setValue(nt, ft);
              }), this.container.appendChild(rt), this.container;
            }
          }
          class Je extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.title || Qe.data.contents);
              super(Qe, nt);
            }
            render() {
              const Qe = ["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"];
              if (this.container.className = "popupAnnotation", Qe.includes(this.data.parentType))
                return this.container;
              const nt = `[data-annotation-id="${this.data.parentId}"]`, rt = this.layer.querySelector(nt);
              if (!rt)
                return this.container;
              const lt = new it({
                container: this.container,
                trigger: rt,
                color: this.data.color,
                title: this.data.title,
                modificationDate: this.data.modificationDate,
                contents: this.data.contents
              }), ct = parseFloat(rt.style.left), ft = parseFloat(rt.style.width);
              return this.container.style.transformOrigin = `-${ct + ft}px -${rt.style.top}`, this.container.style.left = `${ct + ft}px`, this.container.appendChild(lt.render()), this.container;
            }
          }
          class it {
            constructor(Qe) {
              this.container = Qe.container, this.trigger = Qe.trigger, this.color = Qe.color, this.title = Qe.title, this.modificationDate = Qe.modificationDate, this.contents = Qe.contents, this.hideWrapper = Qe.hideWrapper || !1, this.pinned = !1;
            }
            render() {
              const nt = document.createElement("div");
              nt.className = "popupWrapper", this.hideElement = this.hideWrapper ? nt : this.container, this.hideElement.setAttribute("hidden", !0);
              const rt = document.createElement("div");
              rt.className = "popup";
              const lt = this.color;
              if (lt) {
                const mt = 0.7 * (255 - lt[0]) + lt[0], dt = 0.7 * (255 - lt[1]) + lt[1], Et = 0.7 * (255 - lt[2]) + lt[2];
                rt.style.backgroundColor = h.Util.makeCssRgb(mt | 0, dt | 0, Et | 0);
              }
              const ct = document.createElement("h1");
              ct.textContent = this.title, rt.appendChild(ct);
              const ft = l.PDFDateString.toDateObject(this.modificationDate);
              if (ft) {
                const mt = document.createElement("span");
                mt.textContent = "{{date}}, {{time}}", mt.dataset.l10nId = "annotation_date_string", mt.dataset.l10nArgs = JSON.stringify({
                  date: ft.toLocaleDateString(),
                  time: ft.toLocaleTimeString()
                }), rt.appendChild(mt);
              }
              const pt = this._formatContents(this.contents);
              return rt.appendChild(pt), this.trigger.addEventListener("click", this._toggle.bind(this)), this.trigger.addEventListener("mouseover", this._show.bind(this, !1)), this.trigger.addEventListener("mouseout", this._hide.bind(this, !1)), rt.addEventListener("click", this._hide.bind(this, !0)), nt.appendChild(rt), nt;
            }
            _formatContents(Qe) {
              const nt = document.createElement("p"), rt = Qe.split(/(?:\r\n?|\n)/);
              for (let lt = 0, ct = rt.length; lt < ct; ++lt) {
                const ft = rt[lt];
                nt.appendChild(document.createTextNode(ft)), lt < ct - 1 && nt.appendChild(document.createElement("br"));
              }
              return nt;
            }
            _toggle() {
              this.pinned ? this._hide(!0) : this._show(!0);
            }
            _show(Qe = !1) {
              Qe && (this.pinned = !0), this.hideElement.hasAttribute("hidden") && (this.hideElement.removeAttribute("hidden"), this.container.style.zIndex += 1);
            }
            _hide(Qe = !0) {
              Qe && (this.pinned = !1), !this.hideElement.hasAttribute("hidden") && !this.pinned && (this.hideElement.setAttribute("hidden", !0), this.container.style.zIndex -= 1);
            }
          }
          class et extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              return this.container.className = "freeTextAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
            }
          }
          class at extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              this.container.className = "lineAnnotation";
              const Qe = this.data, nt = Qe.rect[2] - Qe.rect[0], rt = Qe.rect[3] - Qe.rect[1], lt = this.svgFactory.create(nt, rt), ct = this.svgFactory.createElement("svg:line");
              return ct.setAttribute("x1", Qe.rect[2] - Qe.lineCoordinates[0]), ct.setAttribute("y1", Qe.rect[3] - Qe.lineCoordinates[1]), ct.setAttribute("x2", Qe.rect[2] - Qe.lineCoordinates[2]), ct.setAttribute("y2", Qe.rect[3] - Qe.lineCoordinates[3]), ct.setAttribute("stroke-width", Qe.borderStyle.width || 1), ct.setAttribute("stroke", "transparent"), lt.appendChild(ct), this.container.append(lt), this._createPopup(this.container, ct, Qe), this.container;
            }
          }
          class $e extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              this.container.className = "squareAnnotation";
              const Qe = this.data, nt = Qe.rect[2] - Qe.rect[0], rt = Qe.rect[3] - Qe.rect[1], lt = this.svgFactory.create(nt, rt), ct = Qe.borderStyle.width, ft = this.svgFactory.createElement("svg:rect");
              return ft.setAttribute("x", ct / 2), ft.setAttribute("y", ct / 2), ft.setAttribute("width", nt - ct), ft.setAttribute("height", rt - ct), ft.setAttribute("stroke-width", ct || 1), ft.setAttribute("stroke", "transparent"), ft.setAttribute("fill", "none"), lt.appendChild(ft), this.container.append(lt), this._createPopup(this.container, ft, Qe), this.container;
            }
          }
          class Ke extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              this.container.className = "circleAnnotation";
              const Qe = this.data, nt = Qe.rect[2] - Qe.rect[0], rt = Qe.rect[3] - Qe.rect[1], lt = this.svgFactory.create(nt, rt), ct = Qe.borderStyle.width, ft = this.svgFactory.createElement("svg:ellipse");
              return ft.setAttribute("cx", nt / 2), ft.setAttribute("cy", rt / 2), ft.setAttribute("rx", nt / 2 - ct / 2), ft.setAttribute("ry", rt / 2 - ct / 2), ft.setAttribute("stroke-width", ct || 1), ft.setAttribute("stroke", "transparent"), ft.setAttribute("fill", "none"), lt.appendChild(ft), this.container.append(lt), this._createPopup(this.container, ft, Qe), this.container;
            }
          }
          class tt extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0), this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.className = this.containerClassName;
              const Qe = this.data, nt = Qe.rect[2] - Qe.rect[0], rt = Qe.rect[3] - Qe.rect[1], lt = this.svgFactory.create(nt, rt);
              let ct = [];
              for (const pt of Qe.vertices) {
                const mt = pt.x - Qe.rect[0], dt = Qe.rect[3] - pt.y;
                ct.push(mt + "," + dt);
              }
              ct = ct.join(" ");
              const ft = this.svgFactory.createElement(this.svgElementName);
              return ft.setAttribute("points", ct), ft.setAttribute("stroke-width", Qe.borderStyle.width || 1), ft.setAttribute("stroke", "transparent"), ft.setAttribute("fill", "none"), lt.appendChild(ft), this.container.append(lt), this._createPopup(this.container, ft, Qe), this.container;
            }
          }
          class ut extends tt {
            constructor(Qe) {
              super(Qe), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
            }
          }
          class st extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              return this.container.className = "caretAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
            }
          }
          class ot extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0), this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.className = this.containerClassName;
              const Qe = this.data, nt = Qe.rect[2] - Qe.rect[0], rt = Qe.rect[3] - Qe.rect[1], lt = this.svgFactory.create(nt, rt);
              for (const ct of Qe.inkLists) {
                let ft = [];
                for (const mt of ct) {
                  const dt = mt.x - Qe.rect[0], Et = Qe.rect[3] - mt.y;
                  ft.push(`${dt},${Et}`);
                }
                ft = ft.join(" ");
                const pt = this.svgFactory.createElement(this.svgElementName);
                pt.setAttribute("points", ft), pt.setAttribute("stroke-width", Qe.borderStyle.width || 1), pt.setAttribute("stroke", "transparent"), pt.setAttribute("fill", "none"), this._createPopup(this.container, pt, Qe), lt.appendChild(pt);
              }
              return this.container.append(lt), this.container;
            }
          }
          class ht extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              return this.container.className = "highlightAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
            }
          }
          class vt extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              return this.container.className = "underlineAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
            }
          }
          class At extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              return this.container.className = "squigglyAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
            }
          }
          class gt extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              return this.container.className = "strikeoutAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
            }
          }
          class bt extends O {
            constructor(Qe) {
              const nt = !!(Qe.data.hasPopup || Qe.data.title || Qe.data.contents);
              super(Qe, nt, !0);
            }
            render() {
              return this.container.className = "stampAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
            }
          }
          class wt extends O {
            constructor(Qe) {
              super(Qe, !0);
              const {
                filename: nt,
                content: rt
              } = this.data.file;
              this.filename = (0, l.getFilenameFromUrl)(nt), this.content = rt, this.linkService.eventBus && this.linkService.eventBus.dispatch("fileattachmentannotation", {
                source: this,
                id: (0, h.stringToPDFString)(nt),
                filename: nt,
                content: rt
              });
            }
            render() {
              this.container.className = "fileAttachmentAnnotation";
              const Qe = document.createElement("div");
              return Qe.style.height = this.container.style.height, Qe.style.width = this.container.style.width, Qe.addEventListener("dblclick", this._download.bind(this)), !this.data.hasPopup && (this.data.title || this.data.contents) && this._createPopup(this.container, Qe, this.data), this.container.appendChild(Qe), this.container;
            }
            _download() {
              if (!this.downloadManager) {
                (0, h.warn)("Download cannot be started due to unavailable download manager");
                return;
              }
              this.downloadManager.downloadData(this.content, this.filename, "");
            }
          }
          class Ot {
            static render(Qe) {
              const nt = [], rt = [];
              for (const lt of Qe.annotations)
                if (lt) {
                  if (lt.annotationType === h.AnnotationType.POPUP) {
                    rt.push(lt);
                    continue;
                  }
                  nt.push(lt);
                }
              rt.length && nt.push(...rt);
              for (const lt of nt) {
                const ct = C.create({
                  data: lt,
                  layer: Qe.div,
                  page: Qe.page,
                  viewport: Qe.viewport,
                  linkService: Qe.linkService,
                  downloadManager: Qe.downloadManager,
                  imageResourcesPath: Qe.imageResourcesPath || "",
                  renderInteractiveForms: typeof Qe.renderInteractiveForms == "boolean" ? Qe.renderInteractiveForms : !0,
                  svgFactory: new l.DOMSVGFactory(),
                  annotationStorage: Qe.annotationStorage || new m.AnnotationStorage()
                });
                ct.isRenderable && Qe.div.appendChild(ct.render());
              }
            }
            static update(Qe) {
              for (const nt of Qe.annotations) {
                const rt = Qe.div.querySelector(`[data-annotation-id="${nt.id}"]`);
                rt && (rt.style.transform = `matrix(${Qe.viewport.transform.join(",")})`);
              }
              Qe.div.removeAttribute("hidden");
            }
          }
          s.AnnotationLayer = Ot;
        },
        /* 20 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.renderTextLayer = void 0;
          var l = u(2), h = function() {
            var C = 1e5, O = /\S/;
            function le(it) {
              return !O.test(it);
            }
            function We(it, et, at) {
              var $e = document.createElement("span"), Ke = {
                angle: 0,
                canvasWidth: 0,
                isWhitespace: !1,
                originalTransform: null,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                scale: 1
              };
              if (it._textDivs.push($e), le(et.str)) {
                Ke.isWhitespace = !0, it._textDivProperties.set($e, Ke);
                return;
              }
              var tt = l.Util.transform(it._viewport.transform, et.transform), ut = Math.atan2(tt[1], tt[0]), st = at[et.fontName];
              st.vertical && (ut += Math.PI / 2);
              var ot = Math.sqrt(tt[2] * tt[2] + tt[3] * tt[3]), ht = ot;
              st.ascent ? ht = st.ascent * ht : st.descent && (ht = (1 + st.descent) * ht);
              let vt, At;
              ut === 0 ? (vt = tt[4], At = tt[5] - ht) : (vt = tt[4] + ht * Math.sin(ut), At = tt[5] - ht * Math.cos(ut)), $e.style.left = `${vt}px`, $e.style.top = `${At}px`, $e.style.fontSize = `${ot}px`, $e.style.fontFamily = st.fontFamily, $e.textContent = et.str, it._fontInspectorEnabled && ($e.dataset.fontName = et.fontName), ut !== 0 && (Ke.angle = ut * (180 / Math.PI));
              let gt = !1;
              if (et.str.length > 1)
                gt = !0;
              else if (et.transform[0] !== et.transform[3]) {
                const rt = Math.abs(et.transform[0]), lt = Math.abs(et.transform[3]);
                rt !== lt && Math.max(rt, lt) / Math.min(rt, lt) > 1.5 && (gt = !0);
              }
              if (gt && (st.vertical ? Ke.canvasWidth = et.height * it._viewport.scale : Ke.canvasWidth = et.width * it._viewport.scale), it._textDivProperties.set($e, Ke), it._textContentStream && it._layoutText($e), it._enhanceTextSelection) {
                var bt = 1, wt = 0;
                ut !== 0 && (bt = Math.cos(ut), wt = Math.sin(ut));
                var Ot = (st.vertical ? et.height : et.width) * it._viewport.scale, yt = ot, Qe, nt;
                ut !== 0 ? (Qe = [bt, wt, -wt, bt, vt, At], nt = l.Util.getAxialAlignedBoundingBox([0, 0, Ot, yt], Qe)) : nt = [vt, At, vt + Ot, At + yt], it._bounds.push({
                  left: nt[0],
                  top: nt[1],
                  right: nt[2],
                  bottom: nt[3],
                  div: $e,
                  size: [Ot, yt],
                  m: Qe
                });
              }
            }
            function ye(it) {
              if (!it._canceled) {
                var et = it._textDivs, at = it._capability, $e = et.length;
                if ($e > C) {
                  it._renderingDone = !0, at.resolve();
                  return;
                }
                if (!it._textContentStream)
                  for (var Ke = 0; Ke < $e; Ke++)
                    it._layoutText(et[Ke]);
                it._renderingDone = !0, at.resolve();
              }
            }
            function Fe(it, et, at) {
              let $e = 0;
              for (let Ke = 0; Ke < at; Ke++) {
                const tt = it[et++];
                tt > 0 && ($e = $e ? Math.min(tt, $e) : tt);
              }
              return $e;
            }
            function Ue(it) {
              for (var et = it._bounds, at = it._viewport, $e = Le(at.width, at.height, et), Ke = 0; Ke < $e.length; Ke++) {
                var tt = et[Ke].div, ut = it._textDivProperties.get(tt);
                if (ut.angle === 0) {
                  ut.paddingLeft = et[Ke].left - $e[Ke].left, ut.paddingTop = et[Ke].top - $e[Ke].top, ut.paddingRight = $e[Ke].right - et[Ke].right, ut.paddingBottom = $e[Ke].bottom - et[Ke].bottom, it._textDivProperties.set(tt, ut);
                  continue;
                }
                var st = $e[Ke], ot = et[Ke], ht = ot.m, vt = ht[0], At = ht[1], gt = [[0, 0], [0, ot.size[1]], [ot.size[0], 0], ot.size], bt = new Float64Array(64);
                gt.forEach(function(Ot, yt) {
                  var Qe = l.Util.applyTransform(Ot, ht);
                  bt[yt + 0] = vt && (st.left - Qe[0]) / vt, bt[yt + 4] = At && (st.top - Qe[1]) / At, bt[yt + 8] = vt && (st.right - Qe[0]) / vt, bt[yt + 12] = At && (st.bottom - Qe[1]) / At, bt[yt + 16] = At && (st.left - Qe[0]) / -At, bt[yt + 20] = vt && (st.top - Qe[1]) / vt, bt[yt + 24] = At && (st.right - Qe[0]) / -At, bt[yt + 28] = vt && (st.bottom - Qe[1]) / vt, bt[yt + 32] = vt && (st.left - Qe[0]) / -vt, bt[yt + 36] = At && (st.top - Qe[1]) / -At, bt[yt + 40] = vt && (st.right - Qe[0]) / -vt, bt[yt + 44] = At && (st.bottom - Qe[1]) / -At, bt[yt + 48] = At && (st.left - Qe[0]) / At, bt[yt + 52] = vt && (st.top - Qe[1]) / -vt, bt[yt + 56] = At && (st.right - Qe[0]) / At, bt[yt + 60] = vt && (st.bottom - Qe[1]) / -vt;
                });
                var wt = 1 + Math.min(Math.abs(vt), Math.abs(At));
                ut.paddingLeft = Fe(bt, 32, 16) / wt, ut.paddingTop = Fe(bt, 48, 16) / wt, ut.paddingRight = Fe(bt, 0, 16) / wt, ut.paddingBottom = Fe(bt, 16, 16) / wt, it._textDivProperties.set(tt, ut);
              }
            }
            function Le(it, et, at) {
              var $e = at.map(function(tt, ut) {
                return {
                  x1: tt.left,
                  y1: tt.top,
                  x2: tt.right,
                  y2: tt.bottom,
                  index: ut,
                  x1New: void 0,
                  x2New: void 0
                };
              });
              Ze(it, $e);
              var Ke = new Array(at.length);
              return $e.forEach(function(tt) {
                var ut = tt.index;
                Ke[ut] = {
                  left: tt.x1New,
                  top: 0,
                  right: tt.x2New,
                  bottom: 0
                };
              }), at.map(function(tt, ut) {
                var st = Ke[ut], ot = $e[ut];
                ot.x1 = tt.top, ot.y1 = it - st.right, ot.x2 = tt.bottom, ot.y2 = it - st.left, ot.index = ut, ot.x1New = void 0, ot.x2New = void 0;
              }), Ze(et, $e), $e.forEach(function(tt) {
                var ut = tt.index;
                Ke[ut].top = tt.x1New, Ke[ut].bottom = tt.x2New;
              }), Ke;
            }
            function Ze(it, et) {
              et.sort(function(Ke, tt) {
                return Ke.x1 - tt.x1 || Ke.index - tt.index;
              });
              var at = {
                x1: -1 / 0,
                y1: -1 / 0,
                x2: 0,
                y2: 1 / 0,
                index: -1,
                x1New: 0,
                x2New: 0
              }, $e = [{
                start: -1 / 0,
                end: 1 / 0,
                boundary: at
              }];
              et.forEach(function(Ke) {
                for (var tt = 0; tt < $e.length && $e[tt].end <= Ke.y1; )
                  tt++;
                for (var ut = $e.length - 1; ut >= 0 && $e[ut].start >= Ke.y2; )
                  ut--;
                var st, ot, ht, vt, At = -1 / 0;
                for (ht = tt; ht <= ut; ht++) {
                  st = $e[ht], ot = st.boundary;
                  var gt;
                  ot.x2 > Ke.x1 ? gt = ot.index > Ke.index ? ot.x1New : Ke.x1 : ot.x2New === void 0 ? gt = (ot.x2 + Ke.x1) / 2 : gt = ot.x2New, gt > At && (At = gt);
                }
                for (Ke.x1New = At, ht = tt; ht <= ut; ht++)
                  st = $e[ht], ot = st.boundary, ot.x2New === void 0 ? ot.x2 > Ke.x1 ? ot.index > Ke.index && (ot.x2New = ot.x2) : ot.x2New = At : ot.x2New > At && (ot.x2New = Math.max(At, ot.x2));
                var bt = [], wt = null;
                for (ht = tt; ht <= ut; ht++) {
                  st = $e[ht], ot = st.boundary;
                  var Ot = ot.x2 > Ke.x2 ? ot : Ke;
                  wt === Ot ? bt[bt.length - 1].end = st.end : (bt.push({
                    start: st.start,
                    end: st.end,
                    boundary: Ot
                  }), wt = Ot);
                }
                for ($e[tt].start < Ke.y1 && (bt[0].start = Ke.y1, bt.unshift({
                  start: $e[tt].start,
                  end: Ke.y1,
                  boundary: $e[tt].boundary
                })), Ke.y2 < $e[ut].end && (bt[bt.length - 1].end = Ke.y2, bt.push({
                  start: Ke.y2,
                  end: $e[ut].end,
                  boundary: $e[ut].boundary
                })), ht = tt; ht <= ut; ht++)
                  if (st = $e[ht], ot = st.boundary, ot.x2New === void 0) {
                    var yt = !1;
                    for (vt = tt - 1; !yt && vt >= 0 && $e[vt].start >= ot.y1; vt--)
                      yt = $e[vt].boundary === ot;
                    for (vt = ut + 1; !yt && vt < $e.length && $e[vt].end <= ot.y2; vt++)
                      yt = $e[vt].boundary === ot;
                    for (vt = 0; !yt && vt < bt.length; vt++)
                      yt = bt[vt].boundary === ot;
                    yt || (ot.x2New = At);
                  }
                Array.prototype.splice.apply($e, [tt, ut - tt + 1].concat(bt));
              }), $e.forEach(function(Ke) {
                var tt = Ke.boundary;
                tt.x2New === void 0 && (tt.x2New = Math.max(it, tt.x2));
              });
            }
            function Xe({
              textContent: it,
              textContentStream: et,
              container: at,
              viewport: $e,
              textDivs: Ke,
              textContentItemsStr: tt,
              enhanceTextSelection: ut
            }) {
              this._textContent = it, this._textContentStream = et, this._container = at, this._document = at.ownerDocument, this._viewport = $e, this._textDivs = Ke || [], this._textContentItemsStr = tt || [], this._enhanceTextSelection = !!ut, this._fontInspectorEnabled = !!(globalThis.FontInspector && globalThis.FontInspector.enabled), this._reader = null, this._layoutTextLastFontSize = null, this._layoutTextLastFontFamily = null, this._layoutTextCtx = null, this._textDivProperties = /* @__PURE__ */ new WeakMap(), this._renderingDone = !1, this._canceled = !1, this._capability = (0, l.createPromiseCapability)(), this._renderTimer = null, this._bounds = [], this._capability.promise.finally(() => {
                this._layoutTextCtx && (this._layoutTextCtx.canvas.width = 0, this._layoutTextCtx.canvas.height = 0, this._layoutTextCtx = null);
              }).catch(() => {
              });
            }
            Xe.prototype = {
              get promise() {
                return this._capability.promise;
              },
              cancel: function() {
                this._canceled = !0, this._reader && (this._reader.cancel(new l.AbortException("TextLayer task cancelled.")), this._reader = null), this._renderTimer !== null && (clearTimeout(this._renderTimer), this._renderTimer = null), this._capability.reject(new Error("TextLayer task cancelled."));
              },
              _processItems(it, et) {
                for (let at = 0, $e = it.length; at < $e; at++)
                  this._textContentItemsStr.push(it[at].str), We(this, it[at], et);
              },
              _layoutText(it) {
                const et = this._textDivProperties.get(it);
                if (et.isWhitespace)
                  return;
                let at = "";
                if (et.canvasWidth !== 0) {
                  const {
                    fontSize: $e,
                    fontFamily: Ke
                  } = it.style;
                  ($e !== this._layoutTextLastFontSize || Ke !== this._layoutTextLastFontFamily) && (this._layoutTextCtx.font = `${$e} ${Ke}`, this._layoutTextLastFontSize = $e, this._layoutTextLastFontFamily = Ke);
                  const {
                    width: tt
                  } = this._layoutTextCtx.measureText(it.textContent);
                  tt > 0 && (et.scale = et.canvasWidth / tt, at = `scaleX(${et.scale})`);
                }
                et.angle !== 0 && (at = `rotate(${et.angle}deg) ${at}`), at.length > 0 && (this._enhanceTextSelection && (et.originalTransform = at), it.style.transform = at), this._textDivProperties.set(it, et), this._container.appendChild(it);
              },
              _render: function(et) {
                const at = (0, l.createPromiseCapability)();
                let $e = /* @__PURE__ */ Object.create(null);
                const Ke = this._document.createElement("canvas");
                if (Ke.mozOpaque = !0, this._layoutTextCtx = Ke.getContext("2d", {
                  alpha: !1
                }), this._textContent) {
                  const tt = this._textContent.items, ut = this._textContent.styles;
                  this._processItems(tt, ut), at.resolve();
                } else if (this._textContentStream) {
                  const tt = () => {
                    this._reader.read().then(({
                      value: ut,
                      done: st
                    }) => {
                      if (st) {
                        at.resolve();
                        return;
                      }
                      Object.assign($e, ut.styles), this._processItems(ut.items, $e), tt();
                    }, at.reject);
                  };
                  this._reader = this._textContentStream.getReader(), tt();
                } else
                  throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                at.promise.then(() => {
                  $e = null, et ? this._renderTimer = setTimeout(() => {
                    ye(this), this._renderTimer = null;
                  }, et) : ye(this);
                }, this._capability.reject);
              },
              expandTextDivs: function(et) {
                if (!this._enhanceTextSelection || !this._renderingDone)
                  return;
                this._bounds !== null && (Ue(this), this._bounds = null);
                const at = [], $e = [];
                for (var Ke = 0, tt = this._textDivs.length; Ke < tt; Ke++) {
                  const ut = this._textDivs[Ke], st = this._textDivProperties.get(ut);
                  st.isWhitespace || (et ? (at.length = 0, $e.length = 0, st.originalTransform && at.push(st.originalTransform), st.paddingTop > 0 ? ($e.push(`${st.paddingTop}px`), at.push(`translateY(${-st.paddingTop}px)`)) : $e.push(0), st.paddingRight > 0 ? $e.push(`${st.paddingRight / st.scale}px`) : $e.push(0), st.paddingBottom > 0 ? $e.push(`${st.paddingBottom}px`) : $e.push(0), st.paddingLeft > 0 ? ($e.push(`${st.paddingLeft / st.scale}px`), at.push(`translateX(${-st.paddingLeft / st.scale}px)`)) : $e.push(0), ut.style.padding = $e.join(" "), at.length && (ut.style.transform = at.join(" "))) : (ut.style.padding = null, ut.style.transform = st.originalTransform));
                }
              }
            };
            function Je(it) {
              var et = new Xe({
                textContent: it.textContent,
                textContentStream: it.textContentStream,
                container: it.container,
                viewport: it.viewport,
                textDivs: it.textDivs,
                textContentItemsStr: it.textContentItemsStr,
                enhanceTextSelection: it.enhanceTextSelection
              });
              return et._render(it.timeout), et;
            }
            return Je;
          }();
          s.renderTextLayer = h;
        },
        /* 21 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.SVGGraphics = void 0;
          var l = u(2), h = u(1), m = u(4);
          let C = function() {
            throw new Error("Not implemented: SVGGraphics");
          };
          s.SVGGraphics = C;
          {
            let Ze = function($e) {
              let Ke = [];
              const tt = [];
              for (const ut of $e) {
                if (ut.fn === "save") {
                  Ke.push({
                    fnId: 92,
                    fn: "group",
                    items: []
                  }), tt.push(Ke), Ke = Ke[Ke.length - 1].items;
                  continue;
                }
                ut.fn === "restore" ? Ke = tt.pop() : Ke.push(ut);
              }
              return Ke;
            }, Xe = function($e) {
              if (Number.isInteger($e))
                return $e.toString();
              const Ke = $e.toFixed(10);
              let tt = Ke.length - 1;
              if (Ke[tt] !== "0")
                return Ke;
              do
                tt--;
              while (Ke[tt] === "0");
              return Ke.substring(0, Ke[tt] === "." ? tt : tt + 1);
            }, Je = function($e) {
              if ($e[4] === 0 && $e[5] === 0) {
                if ($e[1] === 0 && $e[2] === 0)
                  return $e[0] === 1 && $e[3] === 1 ? "" : `scale(${Xe($e[0])} ${Xe($e[3])})`;
                if ($e[0] === $e[3] && $e[1] === -$e[2]) {
                  const Ke = Math.acos($e[0]) * 180 / Math.PI;
                  return `rotate(${Xe(Ke)})`;
                }
              } else if ($e[0] === 1 && $e[1] === 0 && $e[2] === 0 && $e[3] === 1)
                return `translate(${Xe($e[4])} ${Xe($e[5])})`;
              return `matrix(${Xe($e[0])} ${Xe($e[1])} ${Xe($e[2])} ${Xe($e[3])} ${Xe($e[4])} ${Xe($e[5])})`;
            };
            const O = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            }, le = "http://www.w3.org/XML/1998/namespace", We = "http://www.w3.org/1999/xlink", ye = ["butt", "round", "square"], Fe = ["miter", "round", "bevel"], Ue = function() {
              const $e = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), Ke = 12, tt = new Int32Array(256);
              for (let gt = 0; gt < 256; gt++) {
                let bt = gt;
                for (let wt = 0; wt < 8; wt++)
                  bt & 1 ? bt = 3988292384 ^ bt >> 1 & 2147483647 : bt = bt >> 1 & 2147483647;
                tt[gt] = bt;
              }
              function ut(gt, bt, wt) {
                let Ot = -1;
                for (let yt = bt; yt < wt; yt++) {
                  const Qe = (Ot ^ gt[yt]) & 255, nt = tt[Qe];
                  Ot = Ot >>> 8 ^ nt;
                }
                return Ot ^ -1;
              }
              function st(gt, bt, wt, Ot) {
                let yt = Ot;
                const Qe = bt.length;
                wt[yt] = Qe >> 24 & 255, wt[yt + 1] = Qe >> 16 & 255, wt[yt + 2] = Qe >> 8 & 255, wt[yt + 3] = Qe & 255, yt += 4, wt[yt] = gt.charCodeAt(0) & 255, wt[yt + 1] = gt.charCodeAt(1) & 255, wt[yt + 2] = gt.charCodeAt(2) & 255, wt[yt + 3] = gt.charCodeAt(3) & 255, yt += 4, wt.set(bt, yt), yt += bt.length;
                const nt = ut(wt, Ot + 4, yt);
                wt[yt] = nt >> 24 & 255, wt[yt + 1] = nt >> 16 & 255, wt[yt + 2] = nt >> 8 & 255, wt[yt + 3] = nt & 255;
              }
              function ot(gt, bt, wt) {
                let Ot = 1, yt = 0;
                for (let Qe = bt; Qe < wt; ++Qe)
                  Ot = (Ot + (gt[Qe] & 255)) % 65521, yt = (yt + Ot) % 65521;
                return yt << 16 | Ot;
              }
              function ht(gt) {
                if (!m.isNodeJS)
                  return vt(gt);
                try {
                  let bt;
                  parseInt(process.versions.node) >= 8 ? bt = gt : bt = Buffer.from(gt);
                  const wt = require$$5.deflateSync(bt, {
                    level: 9
                  });
                  return wt instanceof Uint8Array ? wt : new Uint8Array(wt);
                } catch (bt) {
                  (0, l.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + bt);
                }
                return vt(gt);
              }
              function vt(gt) {
                let bt = gt.length;
                const wt = 65535, Ot = Math.ceil(bt / wt), yt = new Uint8Array(2 + bt + Ot * 5 + 4);
                let Qe = 0;
                yt[Qe++] = 120, yt[Qe++] = 156;
                let nt = 0;
                for (; bt > wt; )
                  yt[Qe++] = 0, yt[Qe++] = 255, yt[Qe++] = 255, yt[Qe++] = 0, yt[Qe++] = 0, yt.set(gt.subarray(nt, nt + wt), Qe), Qe += wt, nt += wt, bt -= wt;
                yt[Qe++] = 1, yt[Qe++] = bt & 255, yt[Qe++] = bt >> 8 & 255, yt[Qe++] = ~bt & 65535 & 255, yt[Qe++] = (~bt & 65535) >> 8 & 255, yt.set(gt.subarray(nt), Qe), Qe += gt.length - nt;
                const rt = ot(gt, 0, gt.length);
                return yt[Qe++] = rt >> 24 & 255, yt[Qe++] = rt >> 16 & 255, yt[Qe++] = rt >> 8 & 255, yt[Qe++] = rt & 255, yt;
              }
              function At(gt, bt, wt, Ot) {
                const yt = gt.width, Qe = gt.height;
                let nt, rt, lt;
                const ct = gt.data;
                switch (bt) {
                  case l.ImageKind.GRAYSCALE_1BPP:
                    rt = 0, nt = 1, lt = yt + 7 >> 3;
                    break;
                  case l.ImageKind.RGB_24BPP:
                    rt = 2, nt = 8, lt = yt * 3;
                    break;
                  case l.ImageKind.RGBA_32BPP:
                    rt = 6, nt = 8, lt = yt * 4;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                const ft = new Uint8Array((1 + lt) * Qe);
                let pt = 0, mt = 0;
                for (let jt = 0; jt < Qe; ++jt)
                  ft[pt++] = 0, ft.set(ct.subarray(mt, mt + lt), pt), mt += lt, pt += lt;
                if (bt === l.ImageKind.GRAYSCALE_1BPP && Ot) {
                  pt = 0;
                  for (let jt = 0; jt < Qe; jt++) {
                    pt++;
                    for (let St = 0; St < lt; St++)
                      ft[pt++] ^= 255;
                  }
                }
                const dt = new Uint8Array([yt >> 24 & 255, yt >> 16 & 255, yt >> 8 & 255, yt & 255, Qe >> 24 & 255, Qe >> 16 & 255, Qe >> 8 & 255, Qe & 255, nt, rt, 0, 0, 0]), Et = ht(ft), Ct = $e.length + Ke * 3 + dt.length + Et.length, Tt = new Uint8Array(Ct);
                let qt = 0;
                return Tt.set($e, qt), qt += $e.length, st("IHDR", dt, Tt, qt), qt += Ke + dt.length, st("IDATA", Et, Tt, qt), qt += Ke + Et.length, st("IEND", new Uint8Array(0), Tt, qt), (0, l.createObjectURL)(Tt, "image/png", wt);
              }
              return function(bt, wt, Ot) {
                const yt = bt.kind === void 0 ? l.ImageKind.GRAYSCALE_1BPP : bt.kind;
                return At(bt, yt, wt, Ot);
              };
            }();
            class Le {
              constructor() {
                this.fontSizeScale = 1, this.fontWeight = O.fontWeight, this.fontSize = 0, this.textMatrix = l.IDENTITY_MATRIX, this.fontMatrix = l.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = l.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = O.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
              }
              clone() {
                return Object.create(this);
              }
              setCurrentPoint(Ke, tt) {
                this.x = Ke, this.y = tt;
              }
            }
            let it = 0, et = 0, at = 0;
            s.SVGGraphics = C = class {
              constructor(Ke, tt, ut = !1) {
                this.svgFactory = new h.DOMSVGFactory(), this.current = new Le(), this.transformMatrix = l.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = Ke, this.objs = tt, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!ut, this._operatorIdMapping = [];
                for (const st in l.OPS)
                  this._operatorIdMapping[l.OPS[st]] = st;
              }
              save() {
                this.transformStack.push(this.transformMatrix);
                const Ke = this.current;
                this.extraStack.push(Ke), this.current = Ke.clone();
              }
              restore() {
                this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
              }
              group(Ke) {
                this.save(), this.executeOpTree(Ke), this.restore();
              }
              loadDependencies(Ke) {
                const tt = Ke.fnArray, ut = Ke.argsArray;
                for (let st = 0, ot = tt.length; st < ot; st++)
                  if (tt[st] === l.OPS.dependency)
                    for (const ht of ut[st]) {
                      const vt = ht.startsWith("g_") ? this.commonObjs : this.objs, At = new Promise((gt) => {
                        vt.get(ht, gt);
                      });
                      this.current.dependencies.push(At);
                    }
                return Promise.all(this.current.dependencies);
              }
              transform(Ke, tt, ut, st, ot, ht) {
                const vt = [Ke, tt, ut, st, ot, ht];
                this.transformMatrix = l.Util.transform(this.transformMatrix, vt), this.tgrp = null;
              }
              getSVG(Ke, tt) {
                this.viewport = tt;
                const ut = this._initialize(tt);
                return this.loadDependencies(Ke).then(() => (this.transformMatrix = l.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(Ke)), ut));
              }
              convertOpList(Ke) {
                const tt = this._operatorIdMapping, ut = Ke.argsArray, st = Ke.fnArray, ot = [];
                for (let ht = 0, vt = st.length; ht < vt; ht++) {
                  const At = st[ht];
                  ot.push({
                    fnId: At,
                    fn: tt[At],
                    args: ut[ht]
                  });
                }
                return Ze(ot);
              }
              executeOpTree(Ke) {
                for (const tt of Ke) {
                  const ut = tt.fn, st = tt.fnId, ot = tt.args;
                  switch (st | 0) {
                    case l.OPS.beginText:
                      this.beginText();
                      break;
                    case l.OPS.dependency:
                      break;
                    case l.OPS.setLeading:
                      this.setLeading(ot);
                      break;
                    case l.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(ot[0], ot[1]);
                      break;
                    case l.OPS.setFont:
                      this.setFont(ot);
                      break;
                    case l.OPS.showText:
                      this.showText(ot[0]);
                      break;
                    case l.OPS.showSpacedText:
                      this.showText(ot[0]);
                      break;
                    case l.OPS.endText:
                      this.endText();
                      break;
                    case l.OPS.moveText:
                      this.moveText(ot[0], ot[1]);
                      break;
                    case l.OPS.setCharSpacing:
                      this.setCharSpacing(ot[0]);
                      break;
                    case l.OPS.setWordSpacing:
                      this.setWordSpacing(ot[0]);
                      break;
                    case l.OPS.setHScale:
                      this.setHScale(ot[0]);
                      break;
                    case l.OPS.setTextMatrix:
                      this.setTextMatrix(ot[0], ot[1], ot[2], ot[3], ot[4], ot[5]);
                      break;
                    case l.OPS.setTextRise:
                      this.setTextRise(ot[0]);
                      break;
                    case l.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(ot[0]);
                      break;
                    case l.OPS.setLineWidth:
                      this.setLineWidth(ot[0]);
                      break;
                    case l.OPS.setLineJoin:
                      this.setLineJoin(ot[0]);
                      break;
                    case l.OPS.setLineCap:
                      this.setLineCap(ot[0]);
                      break;
                    case l.OPS.setMiterLimit:
                      this.setMiterLimit(ot[0]);
                      break;
                    case l.OPS.setFillRGBColor:
                      this.setFillRGBColor(ot[0], ot[1], ot[2]);
                      break;
                    case l.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(ot[0], ot[1], ot[2]);
                      break;
                    case l.OPS.setStrokeColorN:
                      this.setStrokeColorN(ot);
                      break;
                    case l.OPS.setFillColorN:
                      this.setFillColorN(ot);
                      break;
                    case l.OPS.shadingFill:
                      this.shadingFill(ot[0]);
                      break;
                    case l.OPS.setDash:
                      this.setDash(ot[0], ot[1]);
                      break;
                    case l.OPS.setRenderingIntent:
                      this.setRenderingIntent(ot[0]);
                      break;
                    case l.OPS.setFlatness:
                      this.setFlatness(ot[0]);
                      break;
                    case l.OPS.setGState:
                      this.setGState(ot[0]);
                      break;
                    case l.OPS.fill:
                      this.fill();
                      break;
                    case l.OPS.eoFill:
                      this.eoFill();
                      break;
                    case l.OPS.stroke:
                      this.stroke();
                      break;
                    case l.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case l.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case l.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case l.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case l.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case l.OPS.paintImageXObject:
                      this.paintImageXObject(ot[0]);
                      break;
                    case l.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(ot[0]);
                      break;
                    case l.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(ot[0]);
                      break;
                    case l.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(ot[0], ot[1]);
                      break;
                    case l.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case l.OPS.closePath:
                      this.closePath();
                      break;
                    case l.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case l.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case l.OPS.closeEOFillStroke:
                      this.closeEOFillStroke();
                      break;
                    case l.OPS.nextLine:
                      this.nextLine();
                      break;
                    case l.OPS.transform:
                      this.transform(ot[0], ot[1], ot[2], ot[3], ot[4], ot[5]);
                      break;
                    case l.OPS.constructPath:
                      this.constructPath(ot[0], ot[1]);
                      break;
                    case l.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(tt.items);
                      break;
                    default:
                      (0, l.warn)(`Unimplemented operator ${ut}`);
                      break;
                  }
                }
              }
              setWordSpacing(Ke) {
                this.current.wordSpacing = Ke;
              }
              setCharSpacing(Ke) {
                this.current.charSpacing = Ke;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              setTextMatrix(Ke, tt, ut, st, ot, ht) {
                const vt = this.current;
                vt.textMatrix = vt.lineMatrix = [Ke, tt, ut, st, ot, ht], vt.textMatrixScale = Math.sqrt(Ke * Ke + tt * tt), vt.x = vt.lineX = 0, vt.y = vt.lineY = 0, vt.xcoords = [], vt.ycoords = [], vt.tspan = this.svgFactory.createElement("svg:tspan"), vt.tspan.setAttributeNS(null, "font-family", vt.fontFamily), vt.tspan.setAttributeNS(null, "font-size", `${Xe(vt.fontSize)}px`), vt.tspan.setAttributeNS(null, "y", Xe(-vt.y)), vt.txtElement = this.svgFactory.createElement("svg:text"), vt.txtElement.appendChild(vt.tspan);
              }
              beginText() {
                const Ke = this.current;
                Ke.x = Ke.lineX = 0, Ke.y = Ke.lineY = 0, Ke.textMatrix = l.IDENTITY_MATRIX, Ke.lineMatrix = l.IDENTITY_MATRIX, Ke.textMatrixScale = 1, Ke.tspan = this.svgFactory.createElement("svg:tspan"), Ke.txtElement = this.svgFactory.createElement("svg:text"), Ke.txtgrp = this.svgFactory.createElement("svg:g"), Ke.xcoords = [], Ke.ycoords = [];
              }
              moveText(Ke, tt) {
                const ut = this.current;
                ut.x = ut.lineX += Ke, ut.y = ut.lineY += tt, ut.xcoords = [], ut.ycoords = [], ut.tspan = this.svgFactory.createElement("svg:tspan"), ut.tspan.setAttributeNS(null, "font-family", ut.fontFamily), ut.tspan.setAttributeNS(null, "font-size", `${Xe(ut.fontSize)}px`), ut.tspan.setAttributeNS(null, "y", Xe(-ut.y));
              }
              showText(Ke) {
                const tt = this.current, ut = tt.font, st = tt.fontSize;
                if (st === 0)
                  return;
                const ot = tt.fontSizeScale, ht = tt.charSpacing, vt = tt.wordSpacing, At = tt.fontDirection, gt = tt.textHScale * At, bt = ut.vertical, wt = bt ? 1 : -1, Ot = ut.defaultVMetrics, yt = st * tt.fontMatrix[0];
                let Qe = 0;
                for (const lt of Ke) {
                  if (lt === null) {
                    Qe += At * vt;
                    continue;
                  } else if ((0, l.isNum)(lt)) {
                    Qe += wt * lt * st / 1e3;
                    continue;
                  }
                  const ct = (lt.isSpace ? vt : 0) + ht, ft = lt.fontChar;
                  let pt, mt, dt = lt.width;
                  if (bt) {
                    let Ct;
                    const Tt = lt.vmetric || Ot;
                    Ct = lt.vmetric ? Tt[1] : dt * 0.5, Ct = -Ct * yt;
                    const qt = Tt[2] * yt;
                    dt = Tt ? -Tt[0] : dt, pt = Ct / ot, mt = (Qe + qt) / ot;
                  } else
                    pt = Qe / ot, mt = 0;
                  (lt.isInFont || ut.missingFile) && (tt.xcoords.push(tt.x + pt), bt && tt.ycoords.push(-tt.y + mt), tt.tspan.textContent += ft);
                  let Et;
                  bt ? Et = dt * yt - ct * At : Et = dt * yt + ct * At, Qe += Et;
                }
                tt.tspan.setAttributeNS(null, "x", tt.xcoords.map(Xe).join(" ")), bt ? tt.tspan.setAttributeNS(null, "y", tt.ycoords.map(Xe).join(" ")) : tt.tspan.setAttributeNS(null, "y", Xe(-tt.y)), bt ? tt.y -= Qe : tt.x += Qe * gt, tt.tspan.setAttributeNS(null, "font-family", tt.fontFamily), tt.tspan.setAttributeNS(null, "font-size", `${Xe(tt.fontSize)}px`), tt.fontStyle !== O.fontStyle && tt.tspan.setAttributeNS(null, "font-style", tt.fontStyle), tt.fontWeight !== O.fontWeight && tt.tspan.setAttributeNS(null, "font-weight", tt.fontWeight);
                const nt = tt.textRenderingMode & l.TextRenderingMode.FILL_STROKE_MASK;
                if (nt === l.TextRenderingMode.FILL || nt === l.TextRenderingMode.FILL_STROKE ? (tt.fillColor !== O.fillColor && tt.tspan.setAttributeNS(null, "fill", tt.fillColor), tt.fillAlpha < 1 && tt.tspan.setAttributeNS(null, "fill-opacity", tt.fillAlpha)) : tt.textRenderingMode === l.TextRenderingMode.ADD_TO_PATH ? tt.tspan.setAttributeNS(null, "fill", "transparent") : tt.tspan.setAttributeNS(null, "fill", "none"), nt === l.TextRenderingMode.STROKE || nt === l.TextRenderingMode.FILL_STROKE) {
                  const lt = 1 / (tt.textMatrixScale || 1);
                  this._setStrokeAttributes(tt.tspan, lt);
                }
                let rt = tt.textMatrix;
                tt.textRise !== 0 && (rt = rt.slice(), rt[5] += tt.textRise), tt.txtElement.setAttributeNS(null, "transform", `${Je(rt)} scale(${Xe(gt)}, -1)`), tt.txtElement.setAttributeNS(le, "xml:space", "preserve"), tt.txtElement.appendChild(tt.tspan), tt.txtgrp.appendChild(tt.txtElement), this._ensureTransformGroup().appendChild(tt.txtElement);
              }
              setLeadingMoveText(Ke, tt) {
                this.setLeading(-tt), this.moveText(Ke, tt);
              }
              addFontStyle(Ke) {
                if (!Ke.data)
                  throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.appendChild(this.cssStyle));
                const tt = (0, l.createObjectURL)(Ke.data, Ke.mimetype, this.forceDataSchema);
                this.cssStyle.textContent += `@font-face { font-family: "${Ke.loadedName}"; src: url(${tt}); }
`;
              }
              setFont(Ke) {
                const tt = this.current, ut = this.commonObjs.get(Ke[0]);
                let st = Ke[1];
                tt.font = ut, this.embedFonts && !ut.missingFile && !this.embeddedFonts[ut.loadedName] && (this.addFontStyle(ut), this.embeddedFonts[ut.loadedName] = ut), tt.fontMatrix = ut.fontMatrix ? ut.fontMatrix : l.FONT_IDENTITY_MATRIX;
                let ot = "normal";
                ut.black ? ot = "900" : ut.bold && (ot = "bold");
                const ht = ut.italic ? "italic" : "normal";
                st < 0 ? (st = -st, tt.fontDirection = -1) : tt.fontDirection = 1, tt.fontSize = st, tt.fontFamily = ut.loadedName, tt.fontWeight = ot, tt.fontStyle = ht, tt.tspan = this.svgFactory.createElement("svg:tspan"), tt.tspan.setAttributeNS(null, "y", Xe(-tt.y)), tt.xcoords = [], tt.ycoords = [];
              }
              endText() {
                const Ke = this.current;
                Ke.textRenderingMode & l.TextRenderingMode.ADD_TO_PATH_FLAG && Ke.txtElement && Ke.txtElement.hasChildNodes() && (Ke.element = Ke.txtElement, this.clip("nonzero"), this.endPath());
              }
              setLineWidth(Ke) {
                Ke > 0 && (this.current.lineWidth = Ke);
              }
              setLineCap(Ke) {
                this.current.lineCap = ye[Ke];
              }
              setLineJoin(Ke) {
                this.current.lineJoin = Fe[Ke];
              }
              setMiterLimit(Ke) {
                this.current.miterLimit = Ke;
              }
              setStrokeAlpha(Ke) {
                this.current.strokeAlpha = Ke;
              }
              setStrokeRGBColor(Ke, tt, ut) {
                this.current.strokeColor = l.Util.makeCssRgb(Ke, tt, ut);
              }
              setFillAlpha(Ke) {
                this.current.fillAlpha = Ke;
              }
              setFillRGBColor(Ke, tt, ut) {
                this.current.fillColor = l.Util.makeCssRgb(Ke, tt, ut), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
              }
              setStrokeColorN(Ke) {
                this.current.strokeColor = this._makeColorN_Pattern(Ke);
              }
              setFillColorN(Ke) {
                this.current.fillColor = this._makeColorN_Pattern(Ke);
              }
              shadingFill(Ke) {
                const tt = this.viewport.width, ut = this.viewport.height, st = l.Util.inverseTransform(this.transformMatrix), ot = l.Util.applyTransform([0, 0], st), ht = l.Util.applyTransform([0, ut], st), vt = l.Util.applyTransform([tt, 0], st), At = l.Util.applyTransform([tt, ut], st), gt = Math.min(ot[0], ht[0], vt[0], At[0]), bt = Math.min(ot[1], ht[1], vt[1], At[1]), wt = Math.max(ot[0], ht[0], vt[0], At[0]), Ot = Math.max(ot[1], ht[1], vt[1], At[1]), yt = this.svgFactory.createElement("svg:rect");
                yt.setAttributeNS(null, "x", gt), yt.setAttributeNS(null, "y", bt), yt.setAttributeNS(null, "width", wt - gt), yt.setAttributeNS(null, "height", Ot - bt), yt.setAttributeNS(null, "fill", this._makeShadingPattern(Ke)), this.current.fillAlpha < 1 && yt.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().appendChild(yt);
              }
              _makeColorN_Pattern(Ke) {
                return Ke[0] === "TilingPattern" ? this._makeTilingPattern(Ke) : this._makeShadingPattern(Ke);
              }
              _makeTilingPattern(Ke) {
                const tt = Ke[1], ut = Ke[2], st = Ke[3] || l.IDENTITY_MATRIX, [ot, ht, vt, At] = Ke[4], gt = Ke[5], bt = Ke[6], wt = Ke[7], Ot = `shading${at++}`, [yt, Qe] = l.Util.applyTransform([ot, ht], st), [nt, rt] = l.Util.applyTransform([vt, At], st), [lt, ct] = l.Util.singularValueDecompose2dScale(st), ft = gt * lt, pt = bt * ct, mt = this.svgFactory.createElement("svg:pattern");
                mt.setAttributeNS(null, "id", Ot), mt.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), mt.setAttributeNS(null, "width", ft), mt.setAttributeNS(null, "height", pt), mt.setAttributeNS(null, "x", `${yt}`), mt.setAttributeNS(null, "y", `${Qe}`);
                const dt = this.svg, Et = this.transformMatrix, Ct = this.current.fillColor, Tt = this.current.strokeColor, qt = this.svgFactory.create(nt - yt, rt - Qe);
                if (this.svg = qt, this.transformMatrix = st, wt === 2) {
                  const jt = l.Util.makeCssRgb(...tt);
                  this.current.fillColor = jt, this.current.strokeColor = jt;
                }
                return this.executeOpTree(this.convertOpList(ut)), this.svg = dt, this.transformMatrix = Et, this.current.fillColor = Ct, this.current.strokeColor = Tt, mt.appendChild(qt.childNodes[0]), this.defs.appendChild(mt), `url(#${Ot})`;
              }
              _makeShadingPattern(Ke) {
                switch (Ke[0]) {
                  case "RadialAxial":
                    const tt = `shading${at++}`, ut = Ke[3];
                    let st;
                    switch (Ke[1]) {
                      case "axial":
                        const ot = Ke[4], ht = Ke[5];
                        st = this.svgFactory.createElement("svg:linearGradient"), st.setAttributeNS(null, "id", tt), st.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), st.setAttributeNS(null, "x1", ot[0]), st.setAttributeNS(null, "y1", ot[1]), st.setAttributeNS(null, "x2", ht[0]), st.setAttributeNS(null, "y2", ht[1]);
                        break;
                      case "radial":
                        const vt = Ke[4], At = Ke[5], gt = Ke[6], bt = Ke[7];
                        st = this.svgFactory.createElement("svg:radialGradient"), st.setAttributeNS(null, "id", tt), st.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), st.setAttributeNS(null, "cx", At[0]), st.setAttributeNS(null, "cy", At[1]), st.setAttributeNS(null, "r", bt), st.setAttributeNS(null, "fx", vt[0]), st.setAttributeNS(null, "fy", vt[1]), st.setAttributeNS(null, "fr", gt);
                        break;
                      default:
                        throw new Error(`Unknown RadialAxial type: ${Ke[1]}`);
                    }
                    for (const ot of ut) {
                      const ht = this.svgFactory.createElement("svg:stop");
                      ht.setAttributeNS(null, "offset", ot[0]), ht.setAttributeNS(null, "stop-color", ot[1]), st.appendChild(ht);
                    }
                    return this.defs.appendChild(st), `url(#${tt})`;
                  case "Mesh":
                    return (0, l.warn)("Unimplemented pattern Mesh"), null;
                  case "Dummy":
                    return "hotpink";
                  default:
                    throw new Error(`Unknown IR type: ${Ke[0]}`);
                }
              }
              setDash(Ke, tt) {
                this.current.dashArray = Ke, this.current.dashPhase = tt;
              }
              constructPath(Ke, tt) {
                const ut = this.current;
                let st = ut.x, ot = ut.y, ht = [], vt = 0;
                for (const At of Ke)
                  switch (At | 0) {
                    case l.OPS.rectangle:
                      st = tt[vt++], ot = tt[vt++];
                      const gt = tt[vt++], bt = tt[vt++], wt = st + gt, Ot = ot + bt;
                      ht.push("M", Xe(st), Xe(ot), "L", Xe(wt), Xe(ot), "L", Xe(wt), Xe(Ot), "L", Xe(st), Xe(Ot), "Z");
                      break;
                    case l.OPS.moveTo:
                      st = tt[vt++], ot = tt[vt++], ht.push("M", Xe(st), Xe(ot));
                      break;
                    case l.OPS.lineTo:
                      st = tt[vt++], ot = tt[vt++], ht.push("L", Xe(st), Xe(ot));
                      break;
                    case l.OPS.curveTo:
                      st = tt[vt + 4], ot = tt[vt + 5], ht.push("C", Xe(tt[vt]), Xe(tt[vt + 1]), Xe(tt[vt + 2]), Xe(tt[vt + 3]), Xe(st), Xe(ot)), vt += 6;
                      break;
                    case l.OPS.curveTo2:
                      ht.push("C", Xe(st), Xe(ot), Xe(tt[vt]), Xe(tt[vt + 1]), Xe(tt[vt + 2]), Xe(tt[vt + 3])), st = tt[vt + 2], ot = tt[vt + 3], vt += 4;
                      break;
                    case l.OPS.curveTo3:
                      st = tt[vt + 2], ot = tt[vt + 3], ht.push("C", Xe(tt[vt]), Xe(tt[vt + 1]), Xe(st), Xe(ot), Xe(st), Xe(ot)), vt += 4;
                      break;
                    case l.OPS.closePath:
                      ht.push("Z");
                      break;
                  }
                ht = ht.join(" "), ut.path && Ke.length > 0 && Ke[0] !== l.OPS.rectangle && Ke[0] !== l.OPS.moveTo ? ht = ut.path.getAttributeNS(null, "d") + ht : (ut.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().appendChild(ut.path)), ut.path.setAttributeNS(null, "d", ht), ut.path.setAttributeNS(null, "fill", "none"), ut.element = ut.path, ut.setCurrentPoint(st, ot);
              }
              endPath() {
                const Ke = this.current;
                if (Ke.path = null, !this.pendingClip)
                  return;
                if (!Ke.element) {
                  this.pendingClip = null;
                  return;
                }
                const tt = `clippath${it++}`, ut = this.svgFactory.createElement("svg:clipPath");
                ut.setAttributeNS(null, "id", tt), ut.setAttributeNS(null, "transform", Je(this.transformMatrix));
                const st = Ke.element.cloneNode(!0);
                this.pendingClip === "evenodd" ? st.setAttributeNS(null, "clip-rule", "evenodd") : st.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, ut.appendChild(st), this.defs.appendChild(ut), Ke.activeClipUrl && (Ke.clipGroup = null, this.extraStack.forEach(function(ot) {
                  ot.clipGroup = null;
                }), ut.setAttributeNS(null, "clip-path", Ke.activeClipUrl)), Ke.activeClipUrl = `url(#${tt})`, this.tgrp = null;
              }
              clip(Ke) {
                this.pendingClip = Ke;
              }
              closePath() {
                const Ke = this.current;
                if (Ke.path) {
                  const tt = `${Ke.path.getAttributeNS(null, "d")}Z`;
                  Ke.path.setAttributeNS(null, "d", tt);
                }
              }
              setLeading(Ke) {
                this.current.leading = -Ke;
              }
              setTextRise(Ke) {
                this.current.textRise = Ke;
              }
              setTextRenderingMode(Ke) {
                this.current.textRenderingMode = Ke;
              }
              setHScale(Ke) {
                this.current.textHScale = Ke / 100;
              }
              setRenderingIntent(Ke) {
              }
              setFlatness(Ke) {
              }
              setGState(Ke) {
                for (const [tt, ut] of Ke)
                  switch (tt) {
                    case "LW":
                      this.setLineWidth(ut);
                      break;
                    case "LC":
                      this.setLineCap(ut);
                      break;
                    case "LJ":
                      this.setLineJoin(ut);
                      break;
                    case "ML":
                      this.setMiterLimit(ut);
                      break;
                    case "D":
                      this.setDash(ut[0], ut[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(ut);
                      break;
                    case "FL":
                      this.setFlatness(ut);
                      break;
                    case "Font":
                      this.setFont(ut);
                      break;
                    case "CA":
                      this.setStrokeAlpha(ut);
                      break;
                    case "ca":
                      this.setFillAlpha(ut);
                      break;
                    default:
                      (0, l.warn)(`Unimplemented graphic state operator ${tt}`);
                      break;
                  }
              }
              fill() {
                const Ke = this.current;
                Ke.element && (Ke.element.setAttributeNS(null, "fill", Ke.fillColor), Ke.element.setAttributeNS(null, "fill-opacity", Ke.fillAlpha), this.endPath());
              }
              stroke() {
                const Ke = this.current;
                Ke.element && (this._setStrokeAttributes(Ke.element), Ke.element.setAttributeNS(null, "fill", "none"), this.endPath());
              }
              _setStrokeAttributes(Ke, tt = 1) {
                const ut = this.current;
                let st = ut.dashArray;
                tt !== 1 && st.length > 0 && (st = st.map(function(ot) {
                  return tt * ot;
                })), Ke.setAttributeNS(null, "stroke", ut.strokeColor), Ke.setAttributeNS(null, "stroke-opacity", ut.strokeAlpha), Ke.setAttributeNS(null, "stroke-miterlimit", Xe(ut.miterLimit)), Ke.setAttributeNS(null, "stroke-linecap", ut.lineCap), Ke.setAttributeNS(null, "stroke-linejoin", ut.lineJoin), Ke.setAttributeNS(null, "stroke-width", Xe(tt * ut.lineWidth) + "px"), Ke.setAttributeNS(null, "stroke-dasharray", st.map(Xe).join(" ")), Ke.setAttributeNS(null, "stroke-dashoffset", Xe(tt * ut.dashPhase) + "px");
              }
              eoFill() {
                this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
              }
              fillStroke() {
                this.stroke(), this.fill();
              }
              eoFillStroke() {
                this.current.element && this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.closePath(), this.eoFillStroke();
              }
              paintSolidColorImageMask() {
                const Ke = this.svgFactory.createElement("svg:rect");
                Ke.setAttributeNS(null, "x", "0"), Ke.setAttributeNS(null, "y", "0"), Ke.setAttributeNS(null, "width", "1px"), Ke.setAttributeNS(null, "height", "1px"), Ke.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().appendChild(Ke);
              }
              paintImageXObject(Ke) {
                const tt = Ke.startsWith("g_") ? this.commonObjs.get(Ke) : this.objs.get(Ke);
                if (!tt) {
                  (0, l.warn)(`Dependent image with object ID ${Ke} is not ready yet`);
                  return;
                }
                this.paintInlineImageXObject(tt);
              }
              paintInlineImageXObject(Ke, tt) {
                const ut = Ke.width, st = Ke.height, ot = Ue(Ke, this.forceDataSchema, !!tt), ht = this.svgFactory.createElement("svg:rect");
                ht.setAttributeNS(null, "x", "0"), ht.setAttributeNS(null, "y", "0"), ht.setAttributeNS(null, "width", Xe(ut)), ht.setAttributeNS(null, "height", Xe(st)), this.current.element = ht, this.clip("nonzero");
                const vt = this.svgFactory.createElement("svg:image");
                vt.setAttributeNS(We, "xlink:href", ot), vt.setAttributeNS(null, "x", "0"), vt.setAttributeNS(null, "y", Xe(-st)), vt.setAttributeNS(null, "width", Xe(ut) + "px"), vt.setAttributeNS(null, "height", Xe(st) + "px"), vt.setAttributeNS(null, "transform", `scale(${Xe(1 / ut)} ${Xe(-1 / st)})`), tt ? tt.appendChild(vt) : this._ensureTransformGroup().appendChild(vt);
              }
              paintImageMaskXObject(Ke) {
                const tt = this.current, ut = Ke.width, st = Ke.height, ot = tt.fillColor;
                tt.maskId = `mask${et++}`;
                const ht = this.svgFactory.createElement("svg:mask");
                ht.setAttributeNS(null, "id", tt.maskId);
                const vt = this.svgFactory.createElement("svg:rect");
                vt.setAttributeNS(null, "x", "0"), vt.setAttributeNS(null, "y", "0"), vt.setAttributeNS(null, "width", Xe(ut)), vt.setAttributeNS(null, "height", Xe(st)), vt.setAttributeNS(null, "fill", ot), vt.setAttributeNS(null, "mask", `url(#${tt.maskId})`), this.defs.appendChild(ht), this._ensureTransformGroup().appendChild(vt), this.paintInlineImageXObject(Ke, ht);
              }
              paintFormXObjectBegin(Ke, tt) {
                if (Array.isArray(Ke) && Ke.length === 6 && this.transform(Ke[0], Ke[1], Ke[2], Ke[3], Ke[4], Ke[5]), tt) {
                  const ut = tt[2] - tt[0], st = tt[3] - tt[1], ot = this.svgFactory.createElement("svg:rect");
                  ot.setAttributeNS(null, "x", tt[0]), ot.setAttributeNS(null, "y", tt[1]), ot.setAttributeNS(null, "width", Xe(ut)), ot.setAttributeNS(null, "height", Xe(st)), this.current.element = ot, this.clip("nonzero"), this.endPath();
                }
              }
              paintFormXObjectEnd() {
              }
              _initialize(Ke) {
                const tt = this.svgFactory.create(Ke.width, Ke.height), ut = this.svgFactory.createElement("svg:defs");
                tt.appendChild(ut), this.defs = ut;
                const st = this.svgFactory.createElement("svg:g");
                return st.setAttributeNS(null, "transform", Je(Ke.transform)), tt.appendChild(st), this.svg = st, tt;
              }
              _ensureClipGroup() {
                if (!this.current.clipGroup) {
                  const Ke = this.svgFactory.createElement("svg:g");
                  Ke.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.appendChild(Ke), this.current.clipGroup = Ke;
                }
                return this.current.clipGroup;
              }
              _ensureTransformGroup() {
                return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", Je(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().appendChild(this.tgrp) : this.svg.appendChild(this.tgrp)), this.tgrp;
              }
            };
          }
        },
        /* 22 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFNodeStream = void 0;
          var l = u(2), h = u(23);
          const m = require$$5, C = require$$5, O = require$$5, le = require$$5, We = /^file:\/\/\/[a-zA-Z]:\//;
          function ye(at) {
            const $e = le.parse(at);
            return $e.protocol === "file:" || $e.host ? $e : /^[a-z]:[/\\]/i.test(at) ? le.parse(`file:///${at}`) : ($e.host || ($e.protocol = "file:"), $e);
          }
          class Fe {
            constructor($e) {
              this.source = $e, this.url = ye($e.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && $e.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
            }
            getFullReader() {
              return (0, l.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new it(this) : new Xe(this), this._fullRequestReader;
            }
            getRangeReader($e, Ke) {
              if (Ke <= this._progressiveDataLength)
                return null;
              const tt = this.isFsUrl ? new et(this, $e, Ke) : new Je(this, $e, Ke);
              return this._rangeRequestReaders.push(tt), tt;
            }
            cancelAllRequests($e) {
              this._fullRequestReader && this._fullRequestReader.cancel($e), this._rangeRequestReaders.slice(0).forEach(function(tt) {
                tt.cancel($e);
              });
            }
          }
          s.PDFNodeStream = Fe;
          class Ue {
            constructor($e) {
              this._url = $e.url, this._done = !1, this._storedError = null, this.onProgress = null;
              const Ke = $e.source;
              this._contentLength = Ke.length, this._loaded = 0, this._filename = null, this._disableRange = Ke.disableRange || !1, this._rangeChunkSize = Ke.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !Ke.disableStream, this._isRangeSupported = !Ke.disableRange, this._readableStream = null, this._readCapability = (0, l.createPromiseCapability)(), this._headersCapability = (0, l.createPromiseCapability)();
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const $e = this._readableStream.read();
              return $e === null ? (this._readCapability = (0, l.createPromiseCapability)(), this.read()) : (this._loaded += $e.length, this.onProgress && this.onProgress({
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: new Uint8Array($e).buffer,
                done: !1
              });
            }
            cancel($e) {
              if (!this._readableStream) {
                this._error($e);
                return;
              }
              this._readableStream.destroy($e);
            }
            _error($e) {
              this._storedError = $e, this._readCapability.resolve();
            }
            _setReadableStream($e) {
              this._readableStream = $e, $e.on("readable", () => {
                this._readCapability.resolve();
              }), $e.on("end", () => {
                $e.destroy(), this._done = !0, this._readCapability.resolve();
              }), $e.on("error", (Ke) => {
                this._error(Ke);
              }), !this._isStreamingSupported && this._isRangeSupported && this._error(new l.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          class Le {
            constructor($e) {
              this._url = $e.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = (0, l.createPromiseCapability)();
              const Ke = $e.source;
              this._isStreamingSupported = !Ke.disableStream;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const $e = this._readableStream.read();
              return $e === null ? (this._readCapability = (0, l.createPromiseCapability)(), this.read()) : (this._loaded += $e.length, this.onProgress && this.onProgress({
                loaded: this._loaded
              }), {
                value: new Uint8Array($e).buffer,
                done: !1
              });
            }
            cancel($e) {
              if (!this._readableStream) {
                this._error($e);
                return;
              }
              this._readableStream.destroy($e);
            }
            _error($e) {
              this._storedError = $e, this._readCapability.resolve();
            }
            _setReadableStream($e) {
              this._readableStream = $e, $e.on("readable", () => {
                this._readCapability.resolve();
              }), $e.on("end", () => {
                $e.destroy(), this._done = !0, this._readCapability.resolve();
              }), $e.on("error", (Ke) => {
                this._error(Ke);
              }), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          function Ze(at, $e) {
            return {
              protocol: at.protocol,
              auth: at.auth,
              host: at.hostname,
              port: at.port,
              path: at.path,
              method: "GET",
              headers: $e
            };
          }
          class Xe extends Ue {
            constructor($e) {
              super($e);
              const Ke = (tt) => {
                if (tt.statusCode === 404) {
                  const ht = new l.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = ht, this._headersCapability.reject(ht);
                  return;
                }
                this._headersCapability.resolve(), this._setReadableStream(tt);
                const ut = (ht) => this._readableStream.headers[ht.toLowerCase()], {
                  allowRangeRequests: st,
                  suggestedLength: ot
                } = (0, h.validateRangeRequestCapabilities)({
                  getResponseHeader: ut,
                  isHttp: $e.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = st, this._contentLength = ot || this._contentLength, this._filename = (0, h.extractFilenameFromHeader)(ut);
              };
              this._request = null, this._url.protocol === "http:" ? this._request = C.request(Ze(this._url, $e.httpHeaders), Ke) : this._request = O.request(Ze(this._url, $e.httpHeaders), Ke), this._request.on("error", (tt) => {
                this._storedError = tt, this._headersCapability.reject(tt);
              }), this._request.end();
            }
          }
          class Je extends Le {
            constructor($e, Ke, tt) {
              super($e), this._httpHeaders = {};
              for (const st in $e.httpHeaders) {
                const ot = $e.httpHeaders[st];
                typeof ot > "u" || (this._httpHeaders[st] = ot);
              }
              this._httpHeaders.Range = `bytes=${Ke}-${tt - 1}`;
              const ut = (st) => {
                if (st.statusCode === 404) {
                  const ot = new l.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = ot;
                  return;
                }
                this._setReadableStream(st);
              };
              this._request = null, this._url.protocol === "http:" ? this._request = C.request(Ze(this._url, this._httpHeaders), ut) : this._request = O.request(Ze(this._url, this._httpHeaders), ut), this._request.on("error", (st) => {
                this._storedError = st;
              }), this._request.end();
            }
          }
          class it extends Ue {
            constructor($e) {
              super($e);
              let Ke = decodeURIComponent(this._url.path);
              We.test(this._url.href) && (Ke = Ke.replace(/^\//, "")), m.lstat(Ke, (tt, ut) => {
                if (tt) {
                  tt.code === "ENOENT" && (tt = new l.MissingPDFException(`Missing PDF "${Ke}".`)), this._storedError = tt, this._headersCapability.reject(tt);
                  return;
                }
                this._contentLength = ut.size, this._setReadableStream(m.createReadStream(Ke)), this._headersCapability.resolve();
              });
            }
          }
          class et extends Le {
            constructor($e, Ke, tt) {
              super($e);
              let ut = decodeURIComponent(this._url.path);
              We.test(this._url.href) && (ut = ut.replace(/^\//, "")), this._setReadableStream(m.createReadStream(ut, {
                start: Ke,
                end: tt - 1
              }));
            }
          }
        },
        /* 23 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.createResponseStatusError = O, s.extractFilenameFromHeader = C, s.validateRangeRequestCapabilities = m, s.validateResponseStatus = le;
          var l = u(2), h = u(24);
          function m({
            getResponseHeader: We,
            isHttp: ye,
            rangeChunkSize: Fe,
            disableRange: Ue
          }) {
            (0, l.assert)(Fe > 0, "Range chunk size must be larger than zero");
            const Le = {
              allowRangeRequests: !1,
              suggestedLength: void 0
            }, Ze = parseInt(We("Content-Length"), 10);
            return !Number.isInteger(Ze) || (Le.suggestedLength = Ze, Ze <= 2 * Fe) || Ue || !ye || We("Accept-Ranges") !== "bytes" || (We("Content-Encoding") || "identity") !== "identity" || (Le.allowRangeRequests = !0), Le;
          }
          function C(We) {
            const ye = We("Content-Disposition");
            if (ye) {
              let Fe = (0, h.getFilenameFromContentDispositionHeader)(ye);
              if (Fe.includes("%"))
                try {
                  Fe = decodeURIComponent(Fe);
                } catch {
                }
              if (/\.pdf$/i.test(Fe))
                return Fe;
            }
            return null;
          }
          function O(We, ye) {
            return We === 404 || We === 0 && ye.startsWith("file:") ? new l.MissingPDFException('Missing PDF "' + ye + '".') : new l.UnexpectedResponseException("Unexpected server response (" + We + ') while retrieving PDF "' + ye + '".', We);
          }
          function le(We) {
            return We === 200 || We === 206;
          }
        },
        /* 24 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.getFilenameFromContentDispositionHeader = l;
          function l(h) {
            let m = !0, C = O("filename\\*", "i").exec(h);
            if (C) {
              C = C[1];
              let Ze = Fe(C);
              return Ze = unescape(Ze), Ze = Ue(Ze), Ze = Le(Ze), We(Ze);
            }
            if (C = ye(h), C) {
              const Ze = Le(C);
              return We(Ze);
            }
            if (C = O("filename", "i").exec(h), C) {
              C = C[1];
              let Ze = Fe(C);
              return Ze = Le(Ze), We(Ze);
            }
            function O(Ze, Xe) {
              return new RegExp("(?:^|;)\\s*" + Ze + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', Xe);
            }
            function le(Ze, Xe) {
              if (Ze) {
                if (!/^[\x00-\xFF]+$/.test(Xe))
                  return Xe;
                try {
                  const Je = new TextDecoder(Ze, {
                    fatal: !0
                  }), it = Array.from(Xe, function(et) {
                    return et.charCodeAt(0) & 255;
                  });
                  Xe = Je.decode(new Uint8Array(it)), m = !1;
                } catch {
                  if (/^utf-?8$/i.test(Ze))
                    try {
                      Xe = decodeURIComponent(escape(Xe)), m = !1;
                    } catch {
                    }
                }
              }
              return Xe;
            }
            function We(Ze) {
              return m && /[\x80-\xff]/.test(Ze) && (Ze = le("utf-8", Ze), m && (Ze = le("iso-8859-1", Ze))), Ze;
            }
            function ye(Ze) {
              const Xe = [];
              let Je;
              const it = O("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
              for (; (Je = it.exec(Ze)) !== null; ) {
                let [, at, $e, Ke] = Je;
                if (at = parseInt(at, 10), at in Xe) {
                  if (at === 0)
                    break;
                  continue;
                }
                Xe[at] = [$e, Ke];
              }
              const et = [];
              for (let at = 0; at < Xe.length && at in Xe; ++at) {
                let [$e, Ke] = Xe[at];
                Ke = Fe(Ke), $e && (Ke = unescape(Ke), at === 0 && (Ke = Ue(Ke))), et.push(Ke);
              }
              return et.join("");
            }
            function Fe(Ze) {
              if (Ze.startsWith('"')) {
                const Xe = Ze.slice(1).split('\\"');
                for (let Je = 0; Je < Xe.length; ++Je) {
                  const it = Xe[Je].indexOf('"');
                  it !== -1 && (Xe[Je] = Xe[Je].slice(0, it), Xe.length = Je + 1), Xe[Je] = Xe[Je].replace(/\\(.)/g, "$1");
                }
                Ze = Xe.join('"');
              }
              return Ze;
            }
            function Ue(Ze) {
              const Xe = Ze.indexOf("'");
              if (Xe === -1)
                return Ze;
              const Je = Ze.slice(0, Xe), et = Ze.slice(Xe + 1).replace(/^[^']*'/, "");
              return le(Je, et);
            }
            function Le(Ze) {
              return !Ze.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(Ze) ? Ze : Ze.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(Xe, Je, it, et) {
                if (it === "q" || it === "Q")
                  return et = et.replace(/_/g, " "), et = et.replace(/=([0-9a-fA-F]{2})/g, function(at, $e) {
                    return String.fromCharCode(parseInt($e, 16));
                  }), le(Je, et);
                try {
                  et = atob(et);
                } catch {
                }
                return le(Je, et);
              });
            }
            return "";
          }
        },
        /* 25 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFNetworkStream = void 0;
          var l = u(2), h = u(23);
          const m = 200, C = 206;
          function O(Ue) {
            const Le = Ue.response;
            return typeof Le != "string" ? Le : (0, l.stringToBytes)(Le).buffer;
          }
          class le {
            constructor(Le, Ze) {
              this.url = Le, Ze = Ze || {}, this.isHttp = /^https?:/i.test(Le), this.httpHeaders = this.isHttp && Ze.httpHeaders || {}, this.withCredentials = Ze.withCredentials || !1, this.getXhr = Ze.getXhr || function() {
                return new XMLHttpRequest();
              }, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
            }
            requestRange(Le, Ze, Xe) {
              const Je = {
                begin: Le,
                end: Ze
              };
              for (const it in Xe)
                Je[it] = Xe[it];
              return this.request(Je);
            }
            requestFull(Le) {
              return this.request(Le);
            }
            request(Le) {
              const Ze = this.getXhr(), Xe = this.currXhrId++, Je = this.pendingRequests[Xe] = {
                xhr: Ze
              };
              Ze.open("GET", this.url), Ze.withCredentials = this.withCredentials;
              for (const it in this.httpHeaders) {
                const et = this.httpHeaders[it];
                typeof et > "u" || Ze.setRequestHeader(it, et);
              }
              return this.isHttp && "begin" in Le && "end" in Le ? (Ze.setRequestHeader("Range", `bytes=${Le.begin}-${Le.end - 1}`), Je.expectedStatus = C) : Je.expectedStatus = m, Ze.responseType = "arraybuffer", Le.onError && (Ze.onerror = function(it) {
                Le.onError(Ze.status);
              }), Ze.onreadystatechange = this.onStateChange.bind(this, Xe), Ze.onprogress = this.onProgress.bind(this, Xe), Je.onHeadersReceived = Le.onHeadersReceived, Je.onDone = Le.onDone, Je.onError = Le.onError, Je.onProgress = Le.onProgress, Ze.send(null), Xe;
            }
            onProgress(Le, Ze) {
              const Xe = this.pendingRequests[Le];
              Xe && Xe.onProgress && Xe.onProgress(Ze);
            }
            onStateChange(Le, Ze) {
              const Xe = this.pendingRequests[Le];
              if (!Xe)
                return;
              const Je = Xe.xhr;
              if (Je.readyState >= 2 && Xe.onHeadersReceived && (Xe.onHeadersReceived(), delete Xe.onHeadersReceived), Je.readyState !== 4 || !(Le in this.pendingRequests))
                return;
              if (delete this.pendingRequests[Le], Je.status === 0 && this.isHttp) {
                Xe.onError && Xe.onError(Je.status);
                return;
              }
              const it = Je.status || m;
              if (!(it === m && Xe.expectedStatus === C) && it !== Xe.expectedStatus) {
                Xe.onError && Xe.onError(Je.status);
                return;
              }
              const at = O(Je);
              if (it === C) {
                const $e = Je.getResponseHeader("Content-Range"), Ke = /bytes (\d+)-(\d+)\/(\d+)/.exec($e);
                Xe.onDone({
                  begin: parseInt(Ke[1], 10),
                  chunk: at
                });
              } else
                at ? Xe.onDone({
                  begin: 0,
                  chunk: at
                }) : Xe.onError && Xe.onError(Je.status);
            }
            getRequestXhr(Le) {
              return this.pendingRequests[Le].xhr;
            }
            isPendingRequest(Le) {
              return Le in this.pendingRequests;
            }
            abortRequest(Le) {
              const Ze = this.pendingRequests[Le].xhr;
              delete this.pendingRequests[Le], Ze.abort();
            }
          }
          class We {
            constructor(Le) {
              this._source = Le, this._manager = new le(Le.url, {
                httpHeaders: Le.httpHeaders,
                withCredentials: Le.withCredentials
              }), this._rangeChunkSize = Le.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            _onRangeRequestReaderClosed(Le) {
              const Ze = this._rangeRequestReaders.indexOf(Le);
              Ze >= 0 && this._rangeRequestReaders.splice(Ze, 1);
            }
            getFullReader() {
              return (0, l.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new ye(this._manager, this._source), this._fullRequestReader;
            }
            getRangeReader(Le, Ze) {
              const Xe = new Fe(this._manager, Le, Ze);
              return Xe.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(Xe), Xe;
            }
            cancelAllRequests(Le) {
              this._fullRequestReader && this._fullRequestReader.cancel(Le), this._rangeRequestReaders.slice(0).forEach(function(Xe) {
                Xe.cancel(Le);
              });
            }
          }
          s.PDFNetworkStream = We;
          class ye {
            constructor(Le, Ze) {
              this._manager = Le;
              const Xe = {
                onHeadersReceived: this._onHeadersReceived.bind(this),
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = Ze.url, this._fullRequestId = Le.requestFull(Xe), this._headersReceivedCapability = (0, l.createPromiseCapability)(), this._disableRange = Ze.disableRange || !1, this._contentLength = Ze.length, this._rangeChunkSize = Ze.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
            }
            _onHeadersReceived() {
              const Le = this._fullRequestId, Ze = this._manager.getRequestXhr(Le), Xe = (et) => Ze.getResponseHeader(et), {
                allowRangeRequests: Je,
                suggestedLength: it
              } = (0, h.validateRangeRequestCapabilities)({
                getResponseHeader: Xe,
                isHttp: this._manager.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
              });
              Je && (this._isRangeSupported = !0), this._contentLength = it || this._contentLength, this._filename = (0, h.extractFilenameFromHeader)(Xe), this._isRangeSupported && this._manager.abortRequest(Le), this._headersReceivedCapability.resolve();
            }
            _onDone(Le) {
              Le && (this._requests.length > 0 ? this._requests.shift().resolve({
                value: Le.chunk,
                done: !1
              }) : this._cachedChunks.push(Le.chunk)), this._done = !0, !(this._cachedChunks.length > 0) && (this._requests.forEach(function(Ze) {
                Ze.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = []);
            }
            _onError(Le) {
              const Ze = this._url, Xe = (0, h.createResponseStatusError)(Le, Ze);
              this._storedError = Xe, this._headersReceivedCapability.reject(Xe), this._requests.forEach(function(Je) {
                Je.reject(Xe);
              }), this._requests = [], this._cachedChunks = [];
            }
            _onProgress(Le) {
              this.onProgress && this.onProgress({
                loaded: Le.loaded,
                total: Le.lengthComputable ? Le.total : this._contentLength
              });
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get contentLength() {
              return this._contentLength;
            }
            get headersReady() {
              return this._headersReceivedCapability.promise;
            }
            async read() {
              if (this._storedError)
                throw this._storedError;
              if (this._cachedChunks.length > 0)
                return {
                  value: this._cachedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const Le = (0, l.createPromiseCapability)();
              return this._requests.push(Le), Le.promise;
            }
            cancel(Le) {
              this._done = !0, this._headersReceivedCapability.reject(Le), this._requests.forEach(function(Ze) {
                Ze.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [], this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
            }
          }
          class Fe {
            constructor(Le, Ze, Xe) {
              this._manager = Le;
              const Je = {
                onDone: this._onDone.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._requestId = Le.requestRange(Ze, Xe, Je), this._requests = [], this._queuedChunk = null, this._done = !1, this.onProgress = null, this.onClosed = null;
            }
            _close() {
              this.onClosed && this.onClosed(this);
            }
            _onDone(Le) {
              const Ze = Le.chunk;
              this._requests.length > 0 ? this._requests.shift().resolve({
                value: Ze,
                done: !1
              }) : this._queuedChunk = Ze, this._done = !0, this._requests.forEach(function(Xe) {
                Xe.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [], this._close();
            }
            _onProgress(Le) {
              !this.isStreamingSupported && this.onProgress && this.onProgress({
                loaded: Le.loaded
              });
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._queuedChunk !== null) {
                const Ze = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: Ze,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const Le = (0, l.createPromiseCapability)();
              return this._requests.push(Le), Le.promise;
            }
            cancel(Le) {
              this._done = !0, this._requests.forEach(function(Ze) {
                Ze.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [], this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
            }
          }
        },
        /* 26 */
        /***/
        function(o, s, u) {
          Object.defineProperty(s, "__esModule", {
            value: !0
          }), s.PDFFetchStream = void 0;
          var l = u(2), h = u(23);
          function m(ye, Fe, Ue) {
            return {
              method: "GET",
              headers: ye,
              signal: Ue && Ue.signal,
              mode: "cors",
              credentials: Fe ? "include" : "same-origin",
              redirect: "follow"
            };
          }
          function C(ye) {
            const Fe = new Headers();
            for (const Ue in ye) {
              const Le = ye[Ue];
              typeof Le > "u" || Fe.append(Ue, Le);
            }
            return Fe;
          }
          class O {
            constructor(Fe) {
              this.source = Fe, this.isHttp = /^https?:/i.test(Fe.url), this.httpHeaders = this.isHttp && Fe.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              return this._fullRequestReader ? this._fullRequestReader._loaded : 0;
            }
            getFullReader() {
              return (0, l.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new le(this), this._fullRequestReader;
            }
            getRangeReader(Fe, Ue) {
              if (Ue <= this._progressiveDataLength)
                return null;
              const Le = new We(this, Fe, Ue);
              return this._rangeRequestReaders.push(Le), Le;
            }
            cancelAllRequests(Fe) {
              this._fullRequestReader && this._fullRequestReader.cancel(Fe), this._rangeRequestReaders.slice(0).forEach(function(Le) {
                Le.cancel(Fe);
              });
            }
          }
          s.PDFFetchStream = O;
          class le {
            constructor(Fe) {
              this._stream = Fe, this._reader = null, this._loaded = 0, this._filename = null;
              const Ue = Fe.source;
              this._withCredentials = Ue.withCredentials || !1, this._contentLength = Ue.length, this._headersCapability = (0, l.createPromiseCapability)(), this._disableRange = Ue.disableRange || !1, this._rangeChunkSize = Ue.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), typeof AbortController < "u" && (this._abortController = new AbortController()), this._isStreamingSupported = !Ue.disableStream, this._isRangeSupported = !Ue.disableRange, this._headers = C(this._stream.httpHeaders);
              const Le = Ue.url;
              fetch(Le, m(this._headers, this._withCredentials, this._abortController)).then((Ze) => {
                if (!(0, h.validateResponseStatus)(Ze.status))
                  throw (0, h.createResponseStatusError)(Ze.status, Le);
                this._reader = Ze.body.getReader(), this._headersCapability.resolve();
                const Xe = (et) => Ze.headers.get(et), {
                  allowRangeRequests: Je,
                  suggestedLength: it
                } = (0, h.validateRangeRequestCapabilities)({
                  getResponseHeader: Xe,
                  isHttp: this._stream.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = Je, this._contentLength = it || this._contentLength, this._filename = (0, h.extractFilenameFromHeader)(Xe), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new l.AbortException("Streaming is disabled."));
              }).catch(this._headersCapability.reject), this.onProgress = null;
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              await this._headersCapability.promise;
              const {
                value: Fe,
                done: Ue
              } = await this._reader.read();
              return Ue ? {
                value: Fe,
                done: Ue
              } : (this._loaded += Fe.byteLength, this.onProgress && this.onProgress({
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: new Uint8Array(Fe).buffer,
                done: !1
              });
            }
            cancel(Fe) {
              this._reader && this._reader.cancel(Fe), this._abortController && this._abortController.abort();
            }
          }
          class We {
            constructor(Fe, Ue, Le) {
              this._stream = Fe, this._reader = null, this._loaded = 0;
              const Ze = Fe.source;
              this._withCredentials = Ze.withCredentials || !1, this._readCapability = (0, l.createPromiseCapability)(), this._isStreamingSupported = !Ze.disableStream, typeof AbortController < "u" && (this._abortController = new AbortController()), this._headers = C(this._stream.httpHeaders), this._headers.append("Range", `bytes=${Ue}-${Le - 1}`);
              const Xe = Ze.url;
              fetch(Xe, m(this._headers, this._withCredentials, this._abortController)).then((Je) => {
                if (!(0, h.validateResponseStatus)(Je.status))
                  throw (0, h.createResponseStatusError)(Je.status, Xe);
                this._readCapability.resolve(), this._reader = Je.body.getReader();
              }).catch((Je) => {
                if (!(Je && Je.name === "AbortError"))
                  throw Je;
              }), this.onProgress = null;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              await this._readCapability.promise;
              const {
                value: Fe,
                done: Ue
              } = await this._reader.read();
              return Ue ? {
                value: Fe,
                done: Ue
              } : (this._loaded += Fe.byteLength, this.onProgress && this.onProgress({
                loaded: this._loaded
              }), {
                value: new Uint8Array(Fe).buffer,
                done: !1
              });
            }
            cancel(Fe) {
              this._reader && this._reader.cancel(Fe), this._abortController && this._abortController.abort();
            }
          }
        }
      ])
    );
  });
})(pdf);
var pdfExports = pdf.exports;
const PdfViewerNavbarItem = ({
  page: o,
  pageNumber: s,
  objectId: u,
  currentPageNumber: l,
  onSetCurrentPage: h
}) => {
  useEffect(() => {
    const C = o.getViewport({
      scale: 1
    }), O = document.getElementById(`previewCanvas${u + s}`);
    O && (O.height = C.height, O.width = C.width), o.render({
      canvasContext: O.getContext("2d"),
      viewport: C
    });
  }, [o, s, u]);
  const m = s === l;
  return /* @__PURE__ */ jsx(motion.canvas, {
    style: {
      display: "block",
      margin: "10px auto",
      width: "200px",
      border: `${m ? "3px solid #4236a1" : "none"}`,
      boxSizing: "border-box",
      cursor: "pointer"
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    transition: {
      duration: 0.5
    },
    exit: {
      opacity: 0
    },
    onClick: () => {
      h(s);
    },
    id: `previewCanvas${u + s}`
  });
}, PdfViewerNavbar = ({
  pages: o,
  currentPage: s,
  arePagesRenderedOnce: u,
  onSetCurrentPage: l,
  objectId: h
}) => {
  const [m, C] = useState(!1);
  return useEffect(() => {
    m || setTimeout(() => {
      C(!0);
    }, 200);
  }, [m]), /* @__PURE__ */ jsx(motion.div, {
    style: {
      overflow: "auto",
      background: "rgba(0, 0, 0, 0.75)",
      paddingTop: "25px"
    },
    initial: {
      width: 0
    },
    animate: {
      width: 350
    },
    transition: {
      duration: 0.2
    },
    exit: {
      width: 0
    },
    children: u && m ? o.map((O, le) => /* @__PURE__ */ jsx(PdfViewerNavbarItem, {
      page: O,
      pageNumber: le,
      objectId: h,
      currentPageNumber: s,
      onSetCurrentPage: l
    }, `navBarItem${h + le}`)) : /* @__PURE__ */ jsx(PdfLoader, {
      color: "white"
    })
  });
}, Loader = ({
  description: o,
  className: s,
  color: u,
  style: l
}) => /* @__PURE__ */ jsxs(motion.div, {
  style: {
    ...l,
    height: "100%",
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  initial: {
    opacity: 1
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  className: s,
  children: [/* @__PURE__ */ jsx(FontAwesomeIcon, {
    icon: ["fal", "spinner"],
    pulse: !0,
    size: "1x",
    style: {
      fontWeight: "300",
      textAlign: "center",
      color: u
    }
  }), o && /* @__PURE__ */ jsx("p", {
    style: {
      fontSize: "14px",
      textAlign: "center"
    },
    children: o
  })]
});
var screenfull$1 = {
  exports: {}
};
/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/
(function(o) {
  (function() {
    var s = typeof window < "u" && typeof window.document < "u" ? window.document : {}, u = o.exports, l = function() {
      for (var C, O = [
        ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
        // New WebKit
        ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
        // Old WebKit
        ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
        ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
        ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
      ], le = 0, We = O.length, ye = {}; le < We; le++)
        if (C = O[le], C && C[1] in s) {
          for (le = 0; le < C.length; le++)
            ye[O[0][le]] = C[le];
          return ye;
        }
      return !1;
    }(), h = {
      change: l.fullscreenchange,
      error: l.fullscreenerror
    }, m = {
      request: function(C, O) {
        return new Promise((function(le, We) {
          var ye = (function() {
            this.off("change", ye), le();
          }).bind(this);
          this.on("change", ye), C = C || s.documentElement;
          var Fe = C[l.requestFullscreen](O);
          Fe instanceof Promise && Fe.then(ye).catch(We);
        }).bind(this));
      },
      exit: function() {
        return new Promise((function(C, O) {
          if (!this.isFullscreen) {
            C();
            return;
          }
          var le = (function() {
            this.off("change", le), C();
          }).bind(this);
          this.on("change", le);
          var We = s[l.exitFullscreen]();
          We instanceof Promise && We.then(le).catch(O);
        }).bind(this));
      },
      toggle: function(C, O) {
        return this.isFullscreen ? this.exit() : this.request(C, O);
      },
      onchange: function(C) {
        this.on("change", C);
      },
      onerror: function(C) {
        this.on("error", C);
      },
      on: function(C, O) {
        var le = h[C];
        le && s.addEventListener(le, O, !1);
      },
      off: function(C, O) {
        var le = h[C];
        le && s.removeEventListener(le, O, !1);
      },
      raw: l
    };
    if (!l) {
      u ? o.exports = {
        isEnabled: !1
      } : window.screenfull = {
        isEnabled: !1
      };
      return;
    }
    Object.defineProperties(m, {
      isFullscreen: {
        get: function() {
          return !!s[l.fullscreenElement];
        }
      },
      element: {
        enumerable: !0,
        get: function() {
          return s[l.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: !0,
        get: function() {
          return !!s[l.fullscreenEnabled];
        }
      }
    }), u ? o.exports = m : window.screenfull = m;
  })();
})(screenfull$1);
var screenfullExports = screenfull$1.exports;
const screenfull = /* @__PURE__ */ getDefaultExportFromCjs(screenfullExports), MENU_BAR_HEIGHT = 40, minZoom = 0.2, maxZoom = 5, zoomStep = 0.05, PdfViewer = ({
  url: o,
  onLoad: s,
  objectId: u,
  onToggleSidebar: l,
  shouldLiftToolbar: h,
  fileTitle: m = "",
  isDownloadable: C = !0,
  isPrintable: O = !0,
  onToggleFullscreen: le
}) => {
  pdfExports.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js";
  const We = useRef(), [ye, Fe] = useState(), [Ue, Le] = useState(!1), [Ze, Xe] = useState(!1), [Je, it] = useState(!0), [et, at] = useState(!0), [$e, Ke] = useState([]), [tt, ut] = useState([]), [st, ot] = useState(0), [ht, vt] = useState([]), [At, gt] = useState(0), [bt, wt] = useState(1), [Ot, yt] = useState(!1), [Qe, nt] = useState(!1), [rt, lt] = useState(!1), [ct, ft] = useState(!1), [pt, mt] = useState(!1), [dt, Et] = useState(!1), [Ct, Tt] = useState([]), [qt, jt] = useState(!1);
  screenfull.isEnabled && screenfull.on("change", () => {
    ft(screenfull.isFullscreen);
  });
  const St = usePrevious(ct), Mt = useRef(), Dt = useCallback((Rt) => {
    Rt.ctrlKey ? (Rt.preventDefault(), Rt.stopPropagation(), Rt.deltaY >= 3 ? bt > minZoom + zoomStep && Je && wt(bt - zoomStep) : Rt.deltaY <= -3 && bt < maxZoom - zoomStep && Je && wt(bt + zoomStep)) : Rt.altKey && (Rt.preventDefault(), Rt.stopPropagation(), Rt.deltaY < 100 && Rt.deltaY > -100 && We.current && (We.current.scrollLeft += Rt.deltaY * 50), We.current && (We.current.scrollLeft += Rt.deltaY));
  }, [bt, Je]);
  useEffect(() => {
    ct !== St && at(!0);
  }, [ct, St]), useEffect(() => (window.addEventListener("wheel", Dt, {
    passive: !1
  }), () => {
    window.removeEventListener("wheel", Dt);
  }), [Dt]), useEffect(() => {
    if (!ye)
      try {
        pdfExports.getDocument(o).promise.then((kt) => {
          Fe(kt), mt(!0);
        }).catch((kt) => {
          Et(!1), jt(!0), s();
        });
      } catch {
        Et(!1), jt(!0), s();
      }
  }, [o, ye, s]), useEffect(() => {
    if (ye && !Ue) {
      gt(ye.numPages), Le(!0);
      const Rt = [];
      for (let kt = 1; kt <= ye.numPages; kt++)
        Rt.push(ye.getPage(kt));
      Promise.all(Rt).then((kt) => {
        vt(kt);
      });
    }
  }, [ye, Ue]);
  const Nt = (Rt) => {
    var xt, It;
    const kt = ((xt = We.current) == null ? void 0 : xt.offsetWidth) - 5, Zt = ((It = We.current) == null ? void 0 : It.offsetHeight) - 5, {
      idealWidth: Wt
    } = calculateElementSizeInContainer(kt, Zt, Rt.width, Rt.height, "fit");
    return Wt / Rt.width;
  }, Kt = useCallback(() => {
    ht.forEach((Rt, kt) => {
      let Zt = Rt.getViewport({
        scale: 1 / bt
      });
      const Wt = Nt(Zt);
      Zt = Rt.getViewport({
        scale: Wt
      });
      const xt = document.getElementById(`canvas${u + kt}`);
      xt && (xt.height = Zt.height, xt.width = Zt.width);
    });
  }, [ht, u, bt]), Ft = useCallback(() => {
    it(!1);
    const Rt = [], kt = [];
    let Zt = 0;
    const Wt = [];
    ht.forEach((It, Pt) => {
      let Lt = It.getViewport({
        scale: 1 / bt
      });
      const Ut = Nt(Lt);
      Lt = It.getViewport({
        scale: Ut
      });
      const Qt = document.getElementById(`canvas${u + Pt}`), _t = document.getElementById(`pdfContent${u + Pt}`);
      Qt && (Qt.height = Lt.height, Qt.width = Lt.width, Qt.style.border = "1px solid rgba(0, 0, 0, 0.2)"), kt.push({
        top: Zt,
        left: Qt == null ? void 0 : Qt.offsetLeft
      }), _t && (Rt.push(Zt - _t.offsetHeight / 2), Zt += _t.offsetHeight), Wt.push(It.render({
        canvasContext: Qt.getContext("2d"),
        viewport: Lt
      }).promise);
    }), ut(kt), Ke(Rt);
    const xt = (It) => {
      setTimeout(() => {
        Wt[It].then(() => {
          if (!Ze) {
            const Lt = document.getElementById(`canvas${u + It}`);
            if (Lt) {
              const Ut = Lt.toDataURL();
              Tt((Qt) => [...Qt, Ut]);
            }
          }
          const Pt = It + 1;
          Pt < Wt.length ? xt(Pt) : (at(!1), Xe(!0), it(!0), setTimeout(() => {
            Et(!1);
          }, 100));
        });
      }, It ? 0 : 300);
    };
    xt(0);
  }, [ht, bt, u, Ze]), Bt = () => {
    Mt.current && clearTimeout(Mt.current), Mt.current = setTimeout(() => {
      Ft();
    }, 1e3);
  };
  useEffect(() => {
    (ht == null ? void 0 : ht.length) === At && (ht == null ? void 0 : ht.length) > 0 && Je && et && (Kt(), setTimeout(() => {
      Et(!0);
    }, 100), Bt());
  }, [ht, At, Kt, Ft, Je, et, Ze, Bt]), useEffect(() => {
    at(!0);
  }, [bt, Qe]), useEffect(() => {
    tt && tt.length > 0 && $e && $e.length > 0 && s();
  }, [tt, $e, s]);
  const $t = (Rt) => {
    const kt = document.getElementById(`pdfContent${u + Rt}`);
    kt != null && kt.parentNode && (kt.parentNode.scrollTop = kt.offsetTop);
  }, Gt = (Rt) => {
    const kt = document.getElementById(`previewCanvas${u + Rt}`);
    kt != null && kt.parentNode && (kt.parentNode.scrollTop = kt.offsetTop - kt.parentNode.offsetHeight / 2 + kt.offsetHeight / 2);
  }, Jt = useCallback((Rt) => {
    const kt = document.getElementById(`zoomInput${u}`);
    kt && (kt.value = `${Math.round(Rt * 100)}%`);
  }, [u]), er = useCallback((Rt) => {
    const kt = document.getElementById(`pageInput${u}`);
    kt && (kt.value = Rt);
  }, [u]), Ht = () => {
    st > 0 && (ot(st - 1), $t(st - 1), Gt(st - 1));
  }, zt = () => {
    st < At - 1 && (ot(st + 1), $t(st + 1), Gt(st + 1));
  };
  useEffect(() => {
    Jt(bt);
  }, [bt, Jt]), useEffect(() => {
    er((st + 1).toString());
  }, [st, er]);
  const Xt = (Rt) => {
    if (($e == null ? void 0 : $e.length) !== 0 && !Rt.ctrlKey && !Rt.altKey) {
      const kt = Rt.target.scrollTop;
      let Zt;
      for (let Wt = 0; Wt < $e.length; Wt++)
        if ($e[Wt + 1]) {
          if (kt >= $e[Wt] && kt < $e[Wt + 1]) {
            Zt = Wt;
            break;
          }
        } else
          Zt = Wt;
      Zt !== st && (ot(Zt), Gt(Zt));
    }
  };
  let Vt;
  const Yt = Ct[0];
  return Yt ? Vt = /* @__PURE__ */ jsx(motion.img, {
    initial: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    src: Yt,
    style: {
      position: "absolute",
      zIndex: 3,
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "auto",
      height: "calc(100% - 5px)",
      objectPosition: "center",
      objectFit: "contain"
    }
  }) : Vt = /* @__PURE__ */ jsx(motion.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.5
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.15
    },
    style: {
      position: "absolute",
      zIndex: 4,
      top: 0,
      left: 0,
      right: 0,
      height: "100%",
      display: "flex"
    },
    children: /* @__PURE__ */ jsx(Loader, {
      style: {
        marginRight: "25px",
        opacity: "1",
        fontSize: "2rem",
        margin: "auto",
        color: "#574f6b"
      }
    })
  }), qt ? /* @__PURE__ */ jsx(Fragment$1, {
    children: /* @__PURE__ */ jsx("div", {
      style: {
        display: "flex",
        flexFlow: "column",
        width: "100%",
        height: "100%"
      },
      children: /* @__PURE__ */ jsx("div", {
        style: {
          display: "flex",
          flexFlow: "row",
          width: "100%",
          height: "100%",
          transition: "height 200ms linear"
        },
        children: /* @__PURE__ */ jsx("div", {
          style: {
            position: "relative",
            width: "100%",
            height: "100%",
            overflow: "auto",
            display: "flex",
            flexFlow: "column",
            background: "rgba(0, 0, 0, 0.02)",
            alignItems: "center",
            justifyContent: "center",
            color: "#000000",
            fontSize: "1.125rem",
            letterSpacing: "0.03rem"
          },
          children: "We couldn't load this file"
        })
      })
    })
  }) : /* @__PURE__ */ jsxs("div", {
    style: {
      height: "100%",
      width: "100%"
    },
    children: [/* @__PURE__ */ jsxs("div", {
      style: {
        display: "flex",
        flexFlow: "column",
        width: "100%",
        height: `${h ? "calc(100% - 80px)" : "100%"}`
      },
      children: [/* @__PURE__ */ jsxs("div", {
        style: {
          display: "flex",
          flexFlow: "row",
          width: "100%",
          height: isMobileOnly_1 ? "100%" : `calc(100% - ${Qe ? MENU_BAR_HEIGHT : 0}px)`,
          transition: "height 200ms linear"
        },
        children: [/* @__PURE__ */ jsxs("div", {
          ref: We,
          onScroll: Xt,
          style: {
            position: "relative",
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.2)",
            overflow: "auto",
            display: "flex",
            flexFlow: "column"
          },
          children: [/* @__PURE__ */ jsx(AnimatePresence, {
            children: (Ct == null ? void 0 : Ct.length) === 0 && Vt
          }), (ht == null ? void 0 : ht.length) > 0 && ht.map((Rt, kt) => /* @__PURE__ */ jsxs(motion.div, {
            style: {
              marginLeft: "auto",
              marginRight: "auto",
              position: "relative",
              zIndex: 3
            },
            id: `pdfContent${u + kt}`,
            onWheel: (Zt) => {
              !Zt.ctrlKey && !Zt.altKey && (Zt.deltaY < 100 && Zt.deltaY > -100 && (We.current.scrollTop += Zt.deltaY * 50), We.current.scrollTop += Zt.deltaY);
            },
            initial: {
              opacity: 0
            },
            animate: {
              opacity: Rt ? 1 : 0
            },
            children: [/* @__PURE__ */ jsx("img", {
              src: Ct[kt],
              style: {
                position: "absolute",
                zIndex: 1,
                width: "100%",
                height: "calc(100% - 4px)",
                background: "#ffffff",
                transition: "all 250ms ease",
                objectPosition: "center",
                objectFit: "cover",
                transformOrigin: "top left",
                marginTop: "auto"
              }
            }), /* @__PURE__ */ jsx(motion.canvas, {
              id: `canvas${u + kt}`,
              style: {
                background: "#ffffff",
                opacity: dt ? 0 : 1,
                position: "relative",
                zIndex: 2,
                marginBottom: "auto"
              }
            }, `canvas${u + kt}`)]
          }, `pdfContent${u + kt}`))]
        }), rt && /* @__PURE__ */ jsx(PdfViewerNavbar, {
          pages: ht,
          currentPage: st,
          arePagesRenderedOnce: Ze,
          objectId: u,
          onSetCurrentPage: (Rt) => {
            $t(Rt), Gt(Rt), ot(Rt);
          }
        }, `navbar${u}`)]
      }), /* @__PURE__ */ jsxs("div", {
        style: {
          position: "absolute",
          zIndex: 5,
          bottom: `${Qe ? 55 : 15}px`,
          right: "17px",
          display: "flex",
          alignItems: "center",
          flexFlow: "column",
          justifyContent: "flex-end",
          transition: "bottom 200ms linear"
        },
        children: [/* @__PURE__ */ jsxs("div", {
          style: {
            display: "flex",
            flexFlow: "column"
          },
          children: [/* @__PURE__ */ jsx("button", {
            onClick: () => wt((Rt) => Rt < maxZoom - 0.1 ? Rt + 0.1 : Rt),
            style: {
              height: "50px",
              minWidth: "50px",
              borderRadius: "3px",
              backdropFilter: "blur(4px)",
              border: "solid 1px rgba(255, 255, 255, 0.1)",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "0.875rem",
              fontFamily: "'DM Sans', sans-serif",
              letterSpacing: "0.03rem",
              marginLeft: "20px",
              opacity: 1,
              cursor: "pointer"
            },
            title: "Zoom in",
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "plus"],
              size: "1x"
            })
          }), /* @__PURE__ */ jsx("button", {
            onClick: () => wt((Rt) => Rt > minZoom + 0.1 ? Rt - 0.1 : Rt),
            style: {
              height: "50px",
              minWidth: "50px",
              borderRadius: "3px",
              backdropFilter: "blur(4px)",
              border: "solid 1px rgba(255, 255, 255, 0.1)",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#ffffff",
              fontSize: "0.875rem",
              fontFamily: "'DM Sans', sans-serif",
              letterSpacing: "0.03rem",
              marginLeft: "20px",
              opacity: 1,
              cursor: "pointer"
            },
            title: "Zoom out",
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "minus"],
              size: "1x"
            })
          })]
        }), /* @__PURE__ */ jsx("button", {
          onClick: () => nt((Rt) => !Rt),
          style: {
            height: "50px",
            minWidth: "50px",
            padding: "0 15px",
            borderRadius: "3px",
            backdropFilter: "blur(4px)",
            border: "solid 1px rgba(255, 255, 255, 0.1)",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontSize: "0.875rem",
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: "0.03rem",
            marginLeft: "20px",
            opacity: 1,
            cursor: "pointer"
          },
          children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
            icon: ["fal", "bars"],
            size: "1x",
            style: {
              fontSize: "1rem"
            }
          })
        }), le && /* @__PURE__ */ jsxs("button", {
          onClick: () => {
            Je && le();
          },
          style: {
            height: "50px",
            minWidth: "50px",
            padding: "0 15px",
            borderRadius: "3px",
            backdropFilter: "blur(4px)",
            border: "solid 1px rgba(255, 255, 255, 0.1)",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ffffff",
            fontSize: "0.875rem",
            fontFamily: "'DM Sans', sans-serif",
            letterSpacing: "0.03rem",
            marginLeft: "20px",
            opacity: Je ? 1 : 0.3,
            cursor: Je ? "pointer" : "default"
          },
          children: [/* @__PURE__ */ jsx(FontAwesomeIcon, {
            icon: ["fal", ct ? "compress" : "expand"],
            size: "1x",
            style: {
              fontSize: "1rem"
            }
          }), /* @__PURE__ */ jsx("span", {
            style: {
              marginLeft: "10px"
            },
            children: "Fullscreen"
          })]
        })]
      }), /* @__PURE__ */ jsxs(motion.div, {
        style: {
          backgroundColor: "#ffffff",
          border: Qe ? "1px solid rgba(0, 0, 0, 0.2)" : "none",
          boxShadow: Qe ? "0px -5px 5px 0px rgba(0, 0, 0, 0.3)" : "none",
          zIndex: 6,
          display: isMobileOnly_1 ? "none" : "flex",
          justifyContent: "center",
          alignItems: "center",
          height: Qe ? `${MENU_BAR_HEIGHT}px` : "0px",
          overflow: "hidden",
          transition: "all 200ms linear",
          pointerEvents: Je ? "auto" : "none"
        },
        children: [Je ? /* @__PURE__ */ jsx("div", {
          style: {
            width: "18px",
            height: "25px",
            marginRight: "25px"
          }
        }) : /* @__PURE__ */ jsx(Loader, {
          style: {
            color: "#000000",
            fontSize: "1.125rem",
            marginRight: "25px",
            opacity: Je ? "0" : "1"
          }
        }), /* @__PURE__ */ jsxs("div", {
          style: {
            display: "flex",
            flexFlow: "row",
            alignItems: "center",
            height: "100%",
            opacity: Je ? "1" : "0.5",
            flexShrink: 0
          },
          children: [/* @__PURE__ */ jsx("div", {
            onClick: Ht,
            style: {
              display: "flex",
              alignItems: "center",
              color: "#4D4D4D",
              cursor: "pointer",
              padding: "5px 10px",
              marginRight: "10px"
            },
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "chevron-left"],
              size: "1x"
            })
          }), /* @__PURE__ */ jsx("input", {
            id: `pageInput${u}`,
            onKeyDown: (Rt) => {
              if (Rt.key === "Enter") {
                const kt = Rt.target.value.replace(/\D/g, "");
                let Zt = clamp(Number(kt), 1, At);
                Zt -= 1, $t(Zt), Gt(Zt), ot(Zt);
              }
              return !1;
            },
            style: {
              width: "20px",
              height: "50%",
              marginRight: "5px",
              textAlign: "center",
              border: "none",
              background: "#f3f2f4",
              outline: "none"
            }
          }), /* @__PURE__ */ jsx("div", {
            style: {
              color: "#4D4D4D"
            },
            children: `/ ${At}`
          }), /* @__PURE__ */ jsx("div", {
            onClick: zt,
            style: {
              display: "flex",
              alignItems: "center",
              color: "#4D4D4D",
              cursor: "pointer",
              padding: "5px 10px",
              marginLeft: "10px"
            },
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "chevron-right"],
              size: "1x"
            })
          })]
        }), /* @__PURE__ */ jsx("div", {
          style: {
            width: "1px",
            height: "50%",
            marginLeft: isMobileOnly_1 ? "5px" : "35px",
            marginRight: isMobileOnly_1 ? "5px" : "35px",
            backgroundColor: "#c3c2ca"
          }
        }), /* @__PURE__ */ jsxs("div", {
          style: {
            display: "flex",
            flexFlow: "row",
            alignItems: "center",
            userSelect: "none",
            height: "100%",
            opacity: Je ? "1" : "0.5"
          },
          children: [/* @__PURE__ */ jsx("div", {
            onClick: () => {
              wt((Rt) => Rt > minZoom + 0.1 ? Rt - 0.1 : Rt);
            },
            style: {
              display: "flex",
              alignItems: "center",
              color: "#4D4D4D",
              cursor: "pointer",
              padding: "5px 10px",
              marginRight: "5px"
            },
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "minus"],
              size: "1x"
            })
          }), /* @__PURE__ */ jsx("input", {
            id: `zoomInput${u}`,
            onKeyDown: (Rt) => {
              if (Rt.key === "Enter") {
                const kt = Rt.target.value.replace(/\D/g, ""), Zt = clamp(Number(kt / 100), minZoom, maxZoom);
                Jt(Zt), wt(Zt);
              }
              return !1;
            },
            style: {
              width: "40px",
              height: "50%",
              border: "none",
              background: "#f3f2f4",
              textAlign: "center",
              outline: "none"
            }
          }), /* @__PURE__ */ jsx("div", {
            onClick: () => {
              wt((Rt) => Rt < maxZoom - 0.1 ? Rt + 0.1 : Rt);
            },
            style: {
              display: "flex",
              alignItems: "center",
              color: "#4D4D4D",
              cursor: "pointer",
              padding: "5px 10px",
              marginRight: "5px"
            },
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "plus"],
              size: "1x"
            })
          })]
        }), /* @__PURE__ */ jsx("div", {
          style: {
            width: "1px",
            height: "50%",
            marginLeft: isMobileOnly_1 ? "5px" : "35px",
            marginRight: isMobileOnly_1 ? "5px" : "35px",
            backgroundColor: "#c3c2ca"
          }
        }), /* @__PURE__ */ jsx("div", {
          onClick: () => {
            wt(1);
          },
          style: {
            display: "flex",
            fontSize: "0.875rem",
            alignItems: "center",
            color: "#4D4D4D",
            userSelect: "none",
            cursor: "pointer",
            marginRight: "25px",
            opacity: Je ? "1" : "0.5"
          },
          children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
            icon: ["far", "expand-alt"],
            size: "1x"
          })
        }), /* @__PURE__ */ jsx("div", {
          onClick: () => {
            l(!rt), lt(!rt);
          },
          style: {
            display: "flex",
            fontSize: "1rem",
            alignItems: "center",
            color: "#4D4D4D",
            userSelect: "none",
            cursor: "pointer",
            opacity: Je ? "1" : "0.5"
          },
          children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
            icon: ["fas", "list"],
            size: "1x"
          })
        }), /* @__PURE__ */ jsxs(Fragment$1, {
          children: [/* @__PURE__ */ jsx("div", {
            style: {
              width: "1px",
              height: "50%",
              marginLeft: isMobileOnly_1 ? "5px" : "35px",
              marginRight: isMobileOnly_1 ? "5px" : "35px",
              backgroundColor: "#c3c2ca"
            }
          }), O && /* @__PURE__ */ jsx("div", {
            onClick: () => {
              yt(!0), printPdf({
                printable: o,
                onPrintDialogClose: () => yt(!1),
                onLoadingEnd: () => yt(!1)
              });
            },
            style: {
              display: "flex",
              fontSize: "1rem",
              alignItems: "center",
              color: "#4D4D4D",
              userSelect: "none",
              cursor: "pointer",
              opacity: Je ? "1" : "0.5",
              marginRight: "25px"
            },
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "print"],
              size: "1x"
            })
          }), C && /* @__PURE__ */ jsx("div", {
            onClick: () => {
              Je && downloadBinaryWithProvidedFileName(o, m);
            },
            style: {
              display: "flex",
              fontSize: "1rem",
              alignItems: "center",
              color: "#4D4D4D",
              userSelect: "none",
              cursor: "pointer",
              opacity: Je ? "1" : "0.5",
              marginRight: "25px"
            },
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: ["far", "file-download"],
              size: "1x"
            })
          })]
        })]
      })]
    }), /* @__PURE__ */ jsx(AnimatePresence, {
      children: Ot && /* @__PURE__ */ jsx(motion.div, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        style: {
          position: "fixed",
          zIndex: 1200,
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.6)"
        },
        children: /* @__PURE__ */ jsx(Loader, {
          style: {
            color: "#000000",
            fontSize: "1.125rem",
            marginRight: "25px",
            opacity: Ot ? "1" : "0"
          }
        })
      })
    })]
  });
}, ShowcaseBuilderNavigationSpotIcons = [{
  id: "defaultLongArrowLeft",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white",
  rotation: -90
}, {
  id: "defaultLongArrowUpLeft",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white",
  rotation: -45
}, {
  id: "defaultLongArrowUp",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white"
}, {
  id: "defaultLongArrowUpRight",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white",
  rotation: 45
}, {
  id: "defaultLongArrowRight",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white",
  rotation: 90
}, {
  id: "defaultLongArrowDownRight",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white",
  rotation: 135
}, {
  id: "defaultLongArrowDown",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white",
  rotation: 180
}, {
  id: "defaultLongArrowDownLeft",
  type: "fontAwesome",
  library: "far",
  iconId: "long-arrow-up",
  color: "white",
  rotation: -135
}, {
  id: "defaultLongArrowLevelLeft",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white",
  rotation: -90
}, {
  id: "defaultLongArrowLevelUpLeft",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white",
  rotation: -45
}, {
  id: "defaultLongArrowLevelUp",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white"
}, {
  id: "defaultLongArrowLevelUpRight",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white",
  rotation: 45
}, {
  id: "defaultLongArrowLevelRight",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white",
  rotation: 90
}, {
  id: "defaultLongArrowLevelDownRight",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white",
  rotation: 135
}, {
  id: "defaultLongArrowLevelDown",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white",
  rotation: 180
}, {
  id: "defaultLongArrowLevelDownLeft",
  type: "fontAwesome",
  library: "far",
  iconId: "level-up",
  color: "white",
  rotation: -135
}, {
  id: "defaultShoePrintsUp",
  type: "fontAwesome",
  library: "fas",
  iconId: "shoe-prints",
  color: "white",
  rotation: -90
}, {
  id: "defaultMale",
  type: "fontAwesome",
  library: "fas",
  iconId: "male",
  color: "white"
}, {
  id: "defaultWalking",
  type: "fontAwesome",
  library: "fas",
  iconId: "walking",
  color: "white"
}, {
  id: "defaultStreetView",
  type: "fontAwesome",
  library: "fas",
  iconId: "street-view",
  color: "white"
}, {
  id: "defaultEye",
  type: "fontAwesome",
  library: "fas",
  iconId: "eye",
  color: "white"
}, {
  id: "defaultMapMarkerAlt",
  type: "fontAwesome",
  library: "fas",
  iconId: "map-marker-alt",
  color: "white"
}, {
  id: "defaultMapPin",
  type: "fontAwesome",
  library: "fas",
  iconId: "map-pin",
  color: "white"
}, {
  id: "defaultBinoculars",
  type: "fontAwesome",
  library: "fas",
  iconId: "binoculars",
  color: "white"
}, {
  id: "defaultCube",
  type: "fontAwesome",
  library: "far",
  iconId: "cube",
  color: "white"
}, {
  id: "threeSixty",
  type: "custom",
  library: "far",
  iconId: "threeSixty",
  color: "white"
}, {
  id: "defaultHome",
  type: "fontAwesome",
  library: "fas",
  iconId: "home",
  color: "white"
}, {
  id: "defaultBuilding",
  type: "fontAwesome",
  library: "fas",
  iconId: "building",
  color: "white"
}, {
  id: "couch",
  type: "fontAwesome",
  library: "far",
  iconId: "couch",
  color: "white"
}, {
  id: "bed",
  type: "fontAwesome",
  library: "far",
  iconId: "bed",
  color: "white"
}, {
  id: "bed-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "bed-alt",
  color: "white"
}, {
  id: "shower",
  type: "fontAwesome",
  library: "far",
  iconId: "shower",
  color: "white"
}, {
  id: "bath",
  type: "fontAwesome",
  library: "far",
  iconId: "bath",
  color: "white"
}, {
  id: "washer",
  type: "fontAwesome",
  library: "far",
  iconId: "washer",
  color: "white"
}, {
  id: "chair-office",
  type: "fontAwesome",
  library: "far",
  iconId: "chair-office",
  color: "white"
}, {
  id: "tree-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "tree-alt",
  color: "white"
}, {
  id: "seedling",
  type: "fontAwesome",
  library: "far",
  iconId: "seedling",
  color: "white"
}, {
  id: "telescope",
  type: "fontAwesome",
  library: "far",
  iconId: "telescope",
  color: "white"
}, {
  id: "sort-circle-up",
  type: "fontAwesome",
  library: "far",
  iconId: "sort-circle-up",
  color: "white"
}, {
  id: "sort-circle-down",
  type: "fontAwesome",
  library: "far",
  iconId: "sort-circle-down",
  color: "white"
}, {
  id: "swimming-pool",
  type: "fontAwesome",
  library: "far",
  iconId: "swimming-pool",
  color: "white"
}, {
  id: "truck",
  type: "fontAwesome",
  library: "far",
  iconId: "truck",
  color: "white"
}, {
  id: "parking",
  type: "fontAwesome",
  library: "far",
  iconId: "parking",
  color: "white"
}, {
  id: "car-side",
  type: "fontAwesome",
  library: "far",
  iconId: "car-side",
  color: "white"
}, {
  id: "umbrella-beach",
  type: "fontAwesome",
  library: "far",
  iconId: "umbrella-beach",
  color: "white"
}, {
  id: "inventory",
  type: "fontAwesome",
  library: "far",
  iconId: "inventory",
  color: "white"
}, {
  id: "utensils",
  type: "fontAwesome",
  library: "far",
  iconId: "utensils",
  color: "white"
}], ShowcaseBuilderInfoSpotIcons = [{
  id: "infoCircle",
  type: "fontAwesome",
  library: "far",
  iconId: "info-circle",
  color: "white"
}, {
  id: "award",
  type: "fontAwesome",
  library: "far",
  iconId: "award",
  color: "white"
}, {
  id: "babyCarriage",
  type: "fontAwesome",
  library: "far",
  iconId: "baby-carriage",
  color: "white"
}, {
  id: "basketBall",
  type: "fontAwesome",
  library: "far",
  iconId: "basketball-ball",
  color: "white"
}, {
  id: "batteryBolt",
  type: "fontAwesome",
  library: "far",
  iconId: "battery-bolt",
  color: "white"
}, {
  id: "bicycle",
  type: "fontAwesome",
  library: "far",
  iconId: "bicycle",
  color: "white"
}, {
  id: "medkit",
  type: "fontAwesome",
  library: "far",
  iconId: "medkit",
  color: "white"
}, {
  id: "burgerSoda",
  type: "fontAwesome",
  library: "far",
  iconId: "burger-soda",
  color: "white"
}, {
  id: "bus",
  type: "fontAwesome",
  library: "far",
  iconId: "bus",
  color: "white"
}, {
  id: "flag",
  type: "fontAwesome",
  library: "far",
  iconId: "flag",
  color: "white"
}, {
  id: "fire-extinguisher",
  type: "fontAwesome",
  library: "far",
  iconId: "fire-extinguisher",
  color: "white"
}, {
  id: "eye",
  type: "fontAwesome",
  library: "far",
  iconId: "eye",
  color: "white"
}, {
  id: "map-signs",
  type: "fontAwesome",
  library: "far",
  iconId: "map-signs",
  color: "white"
}, {
  id: "map-marker-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "map-marker-alt",
  color: "white"
}, {
  id: "binoculars",
  type: "fontAwesome",
  library: "far",
  iconId: "binoculars",
  color: "white"
}, {
  id: "cctv",
  type: "fontAwesome",
  library: "far",
  iconId: "cctv",
  color: "white"
}, {
  id: "construction",
  type: "fontAwesome",
  library: "far",
  iconId: "construction",
  color: "white"
}, {
  id: "grin",
  type: "fontAwesome",
  library: "far",
  iconId: "grin",
  color: "white"
}, {
  id: "wheelchair",
  type: "fontAwesome",
  library: "far",
  iconId: "wheelchair",
  color: "white"
}, {
  id: "hospital",
  type: "fontAwesome",
  library: "far",
  iconId: "hospital",
  color: "white"
}, {
  id: "church",
  type: "fontAwesome",
  library: "far",
  iconId: "church",
  color: "white"
}, {
  id: "mosque",
  type: "fontAwesome",
  library: "far",
  iconId: "mosque",
  color: "white"
}, {
  id: "school",
  type: "fontAwesome",
  library: "far",
  iconId: "school",
  color: "white"
}, {
  id: "archway",
  type: "fontAwesome",
  library: "far",
  iconId: "archway",
  color: "white"
}, {
  id: "university",
  type: "fontAwesome",
  library: "far",
  iconId: "university",
  color: "white"
}, {
  id: "bed",
  type: "fontAwesome",
  library: "far",
  iconId: "bed",
  color: "white"
}, {
  id: "city",
  type: "fontAwesome",
  library: "far",
  iconId: "city",
  color: "white"
}, {
  id: "industry-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "industry-alt",
  color: "white"
}, {
  id: "campground",
  type: "fontAwesome",
  library: "far",
  iconId: "campground",
  color: "white"
}, {
  id: "route-highway",
  type: "fontAwesome",
  library: "far",
  iconId: "route-highway",
  color: "white"
}, {
  id: "graduation-cap",
  type: "fontAwesome",
  library: "far",
  iconId: "graduation-cap",
  color: "white"
}, {
  id: "money-bill-wave",
  type: "fontAwesome",
  library: "far",
  iconId: "money-bill-wave",
  color: "white"
}, {
  id: "wallet",
  type: "fontAwesome",
  library: "far",
  iconId: "wallet",
  color: "white"
}, {
  id: "shopping-cart",
  type: "fontAwesome",
  library: "far",
  iconId: "shopping-cart",
  color: "white"
}, {
  id: "croissant",
  type: "fontAwesome",
  library: "far",
  iconId: "croissant",
  color: "white"
}, {
  id: "cocktail",
  type: "fontAwesome",
  library: "far",
  iconId: "cocktail",
  color: "white"
}, {
  id: "coffee-togo",
  type: "fontAwesome",
  library: "far",
  iconId: "coffee-togo",
  color: "white"
}, {
  id: "beer",
  type: "fontAwesome",
  library: "far",
  iconId: "beer",
  color: "white"
}, {
  id: "utensils-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "utensils-alt",
  color: "white"
}, {
  id: "apple-crate",
  type: "fontAwesome",
  library: "far",
  iconId: "apple-crate",
  color: "white"
}, {
  id: "store-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "store-alt",
  color: "white"
}, {
  id: "bags-shopping",
  type: "fontAwesome",
  library: "far",
  iconId: "bags-shopping",
  color: "white"
}, {
  id: "warehouse-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "warehouse-alt",
  color: "white"
}, {
  id: "washer",
  type: "fontAwesome",
  library: "far",
  iconId: "washer",
  color: "white"
}, {
  id: "gas-pump",
  type: "fontAwesome",
  library: "far",
  iconId: "gas-pump",
  color: "white"
}, {
  id: "charging-station",
  type: "fontAwesome",
  library: "far",
  iconId: "charging-station",
  color: "white"
}, {
  id: "car-garage",
  type: "fontAwesome",
  library: "far",
  iconId: "car-garage",
  color: "white"
}, {
  id: "car-mechanic",
  type: "fontAwesome",
  library: "far",
  iconId: "car-mechanic",
  color: "white"
}, {
  id: "subway",
  type: "fontAwesome",
  library: "far",
  iconId: "subway",
  color: "white"
}, {
  id: "helicopter",
  type: "fontAwesome",
  library: "far",
  iconId: "helicopter",
  color: "white"
}, {
  id: "anchor",
  type: "fontAwesome",
  library: "far",
  iconId: "anchor",
  color: "white"
}, {
  id: "caravan",
  type: "fontAwesome",
  library: "far",
  iconId: "caravan",
  color: "white"
}, {
  id: "tram",
  type: "fontAwesome",
  library: "far",
  iconId: "tram",
  color: "white"
}, {
  id: "trees",
  type: "fontAwesome",
  library: "far",
  iconId: "trees",
  color: "white"
}, {
  id: "flower-daffodil",
  type: "fontAwesome",
  library: "far",
  iconId: "flower-daffodil",
  color: "white"
}, {
  id: "umbrella-beach",
  type: "fontAwesome",
  library: "far",
  iconId: "umbrella-beach",
  color: "white"
}, {
  id: "island-tropical",
  type: "fontAwesome",
  library: "far",
  iconId: "island-tropical",
  color: "white"
}, {
  id: "water",
  type: "fontAwesome",
  library: "far",
  iconId: "water",
  color: "white"
}, {
  id: "swimming-pool",
  type: "fontAwesome",
  library: "far",
  iconId: "swimming-pool",
  color: "white"
}, {
  id: "sun-cloud",
  type: "fontAwesome",
  library: "far",
  iconId: "sun-cloud",
  color: "white"
}, {
  id: "hiking",
  type: "fontAwesome",
  library: "far",
  iconId: "hiking",
  color: "white"
}, {
  id: "dog-leashed",
  type: "fontAwesome",
  library: "far",
  iconId: "dog-leashed",
  color: "white"
}, {
  id: "dumbbell",
  type: "fontAwesome",
  library: "far",
  iconId: "dumbbell",
  color: "white"
}, {
  id: "futbol",
  type: "fontAwesome",
  library: "far",
  iconId: "futbol",
  color: "white"
}, {
  id: "racquet",
  type: "fontAwesome",
  library: "far",
  iconId: "racquet",
  color: "white"
}, {
  id: "golf-club",
  type: "fontAwesome",
  library: "far",
  iconId: "golf-club",
  color: "white"
}, {
  id: "video",
  type: "fontAwesome",
  library: "far",
  iconId: "video",
  color: "white"
}, {
  id: "photo-video",
  type: "fontAwesome",
  library: "far",
  iconId: "photo-video",
  color: "white"
}, {
  id: "film",
  type: "fontAwesome",
  library: "far",
  iconId: "film",
  color: "white"
}, {
  id: "image",
  type: "fontAwesome",
  library: "far",
  iconId: "image",
  color: "white"
}, {
  id: "clinic-medical",
  type: "fontAwesome",
  library: "far",
  iconId: "clinic-medical",
  color: "white"
}, {
  id: "couch",
  type: "fontAwesome",
  library: "far",
  iconId: "couch",
  color: "white"
}, {
  id: "bed-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "bed-alt",
  color: "white"
}, {
  id: "oven",
  type: "fontAwesome",
  library: "far",
  iconId: "oven",
  color: "white"
}, {
  id: "shower",
  type: "fontAwesome",
  library: "far",
  iconId: "shower",
  color: "white"
}, {
  id: "bath",
  type: "fontAwesome",
  library: "far",
  iconId: "bath",
  color: "white"
}, {
  id: "chair-office",
  type: "fontAwesome",
  library: "far",
  iconId: "chair-office",
  color: "white"
}, {
  id: "tree-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "tree-alt",
  color: "white"
}, {
  id: "seedling",
  type: "fontAwesome",
  library: "far",
  iconId: "seedling",
  color: "white"
}, {
  id: "telescope",
  type: "fontAwesome",
  library: "far",
  iconId: "telescope",
  color: "white"
}, {
  id: "sort-circle-up",
  type: "fontAwesome",
  library: "far",
  iconId: "sort-circle-up",
  color: "white"
}, {
  id: "sort-circle-down",
  type: "fontAwesome",
  library: "far",
  iconId: "sort-circle-down",
  color: "white"
}, {
  id: "faucet",
  type: "fontAwesome",
  library: "far",
  iconId: "faucet",
  color: "white"
}, {
  id: "stroopwafel",
  type: "fontAwesome",
  library: "far",
  iconId: "stroopwafel",
  color: "white"
}, {
  id: "solar-panel",
  type: "fontAwesome",
  library: "far",
  iconId: "solar-panel",
  color: "white"
}, {
  id: "tv",
  type: "fontAwesome",
  library: "far",
  iconId: "tv",
  color: "white"
}, {
  id: "ruler-vertical",
  type: "fontAwesome",
  library: "far",
  iconId: "ruler-vertical",
  color: "white"
}, {
  id: "ruler-horizontal",
  type: "fontAwesome",
  library: "far",
  iconId: "ruler-horizontal",
  color: "white"
}, {
  id: "ruler-combined",
  type: "fontAwesome",
  library: "far",
  iconId: "ruler-combined",
  color: "white"
}, {
  id: "dolly-flatbed",
  type: "fontAwesome",
  library: "far",
  iconId: "dolly-flatbed",
  color: "white"
}, {
  id: "forklift",
  type: "fontAwesome",
  library: "far",
  iconId: "forklift",
  color: "white"
}, {
  id: "pallet-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "pallet-alt",
  color: "white"
}, {
  id: "conveyor-belt",
  type: "fontAwesome",
  library: "far",
  iconId: "conveyor-belt",
  color: "white"
}, {
  id: "calendar-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "calendar-alt",
  color: "white"
}, {
  id: "chevron-down",
  type: "fontAwesome",
  library: "far",
  iconId: "chevron-down",
  color: "white"
}, {
  id: "fire",
  type: "fontAwesome",
  library: "far",
  iconId: "fire",
  color: "white"
}, {
  id: "plug",
  type: "fontAwesome",
  library: "far",
  iconId: "plug",
  color: "white"
}, {
  id: "bolt",
  type: "fontAwesome",
  library: "far",
  iconId: "bolt",
  color: "white"
}, {
  id: "wifi",
  type: "fontAwesome",
  library: "far",
  iconId: "wifi",
  color: "white"
}, {
  id: "dumpster",
  type: "fontAwesome",
  library: "far",
  iconId: "dumpster",
  color: "white"
}, {
  id: "truck",
  type: "fontAwesome",
  library: "far",
  iconId: "truck",
  color: "white"
}, {
  id: "weight-hanging",
  type: "fontAwesome",
  library: "far",
  iconId: "weight-hanging",
  color: "white"
}, {
  id: "parking",
  type: "fontAwesome",
  library: "far",
  iconId: "parking",
  color: "white"
}, {
  id: "car-side",
  type: "fontAwesome",
  library: "far",
  iconId: "car-side",
  color: "white"
}, {
  id: "wrench",
  type: "fontAwesome",
  library: "far",
  iconId: "wrench",
  color: "white"
}, {
  id: "hammer",
  type: "fontAwesome",
  library: "far",
  iconId: "hammer",
  color: "white"
}, {
  id: "paint-roller",
  type: "fontAwesome",
  library: "far",
  iconId: "paint-roller",
  color: "white"
}, {
  id: "wind-turbine",
  type: "fontAwesome",
  library: "far",
  iconId: "wind-turbine",
  color: "white"
}, {
  id: "router",
  type: "fontAwesome",
  library: "far",
  iconId: "router",
  color: "white"
}, {
  id: "plane-alt",
  type: "fontAwesome",
  library: "far",
  iconId: "plane-alt",
  color: "white"
}, {
  id: "inventory",
  type: "fontAwesome",
  library: "far",
  iconId: "inventory",
  color: "white"
}], Animation = "data:image/gif;base64,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";
var reactIs$1 = {
  exports: {}
}, reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var o = Symbol.for("react.element"), s = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), C = Symbol.for("react.context"), O = Symbol.for("react.server_context"), le = Symbol.for("react.forward_ref"), We = Symbol.for("react.suspense"), ye = Symbol.for("react.suspense_list"), Fe = Symbol.for("react.memo"), Ue = Symbol.for("react.lazy"), Le = Symbol.for("react.offscreen"), Ze;
  Ze = Symbol.for("react.module.reference");
  function Xe(Je) {
    if (typeof Je == "object" && Je !== null) {
      var it = Je.$$typeof;
      switch (it) {
        case o:
          switch (Je = Je.type, Je) {
            case u:
            case h:
            case l:
            case We:
            case ye:
              return Je;
            default:
              switch (Je = Je && Je.$$typeof, Je) {
                case O:
                case C:
                case le:
                case Ue:
                case Fe:
                case m:
                  return Je;
                default:
                  return it;
              }
          }
        case s:
          return it;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = C, reactIs_production_min.ContextProvider = m, reactIs_production_min.Element = o, reactIs_production_min.ForwardRef = le, reactIs_production_min.Fragment = u, reactIs_production_min.Lazy = Ue, reactIs_production_min.Memo = Fe, reactIs_production_min.Portal = s, reactIs_production_min.Profiler = h, reactIs_production_min.StrictMode = l, reactIs_production_min.Suspense = We, reactIs_production_min.SuspenseList = ye, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(Je) {
    return Xe(Je) === C;
  }, reactIs_production_min.isContextProvider = function(Je) {
    return Xe(Je) === m;
  }, reactIs_production_min.isElement = function(Je) {
    return typeof Je == "object" && Je !== null && Je.$$typeof === o;
  }, reactIs_production_min.isForwardRef = function(Je) {
    return Xe(Je) === le;
  }, reactIs_production_min.isFragment = function(Je) {
    return Xe(Je) === u;
  }, reactIs_production_min.isLazy = function(Je) {
    return Xe(Je) === Ue;
  }, reactIs_production_min.isMemo = function(Je) {
    return Xe(Je) === Fe;
  }, reactIs_production_min.isPortal = function(Je) {
    return Xe(Je) === s;
  }, reactIs_production_min.isProfiler = function(Je) {
    return Xe(Je) === h;
  }, reactIs_production_min.isStrictMode = function(Je) {
    return Xe(Je) === l;
  }, reactIs_production_min.isSuspense = function(Je) {
    return Xe(Je) === We;
  }, reactIs_production_min.isSuspenseList = function(Je) {
    return Xe(Je) === ye;
  }, reactIs_production_min.isValidElementType = function(Je) {
    return typeof Je == "string" || typeof Je == "function" || Je === u || Je === h || Je === l || Je === We || Je === ye || Je === Le || typeof Je == "object" && Je !== null && (Je.$$typeof === Ue || Je.$$typeof === Fe || Je.$$typeof === m || Je.$$typeof === C || Je.$$typeof === le || Je.$$typeof === Ze || Je.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = Xe, reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var o = Symbol.for("react.element"), s = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), l = Symbol.for("react.strict_mode"), h = Symbol.for("react.profiler"), m = Symbol.for("react.provider"), C = Symbol.for("react.context"), O = Symbol.for("react.server_context"), le = Symbol.for("react.forward_ref"), We = Symbol.for("react.suspense"), ye = Symbol.for("react.suspense_list"), Fe = Symbol.for("react.memo"), Ue = Symbol.for("react.lazy"), Le = Symbol.for("react.offscreen"), Ze = !1, Xe = !1, Je = !1, it = !1, et = !1, at;
    at = Symbol.for("react.module.reference");
    function $e(Dt) {
      return !!(typeof Dt == "string" || typeof Dt == "function" || Dt === u || Dt === h || et || Dt === l || Dt === We || Dt === ye || it || Dt === Le || Ze || Xe || Je || typeof Dt == "object" && Dt !== null && (Dt.$$typeof === Ue || Dt.$$typeof === Fe || Dt.$$typeof === m || Dt.$$typeof === C || Dt.$$typeof === le || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Dt.$$typeof === at || Dt.getModuleId !== void 0));
    }
    function Ke(Dt) {
      if (typeof Dt == "object" && Dt !== null) {
        var Nt = Dt.$$typeof;
        switch (Nt) {
          case o:
            var Kt = Dt.type;
            switch (Kt) {
              case u:
              case h:
              case l:
              case We:
              case ye:
                return Kt;
              default:
                var Ft = Kt && Kt.$$typeof;
                switch (Ft) {
                  case O:
                  case C:
                  case le:
                  case Ue:
                  case Fe:
                  case m:
                    return Ft;
                  default:
                    return Nt;
                }
            }
          case s:
            return Nt;
        }
      }
    }
    var tt = C, ut = m, st = o, ot = le, ht = u, vt = Ue, At = Fe, gt = s, bt = h, wt = l, Ot = We, yt = ye, Qe = !1, nt = !1;
    function rt(Dt) {
      return Qe || (Qe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function lt(Dt) {
      return nt || (nt = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ct(Dt) {
      return Ke(Dt) === C;
    }
    function ft(Dt) {
      return Ke(Dt) === m;
    }
    function pt(Dt) {
      return typeof Dt == "object" && Dt !== null && Dt.$$typeof === o;
    }
    function mt(Dt) {
      return Ke(Dt) === le;
    }
    function dt(Dt) {
      return Ke(Dt) === u;
    }
    function Et(Dt) {
      return Ke(Dt) === Ue;
    }
    function Ct(Dt) {
      return Ke(Dt) === Fe;
    }
    function Tt(Dt) {
      return Ke(Dt) === s;
    }
    function qt(Dt) {
      return Ke(Dt) === h;
    }
    function jt(Dt) {
      return Ke(Dt) === l;
    }
    function St(Dt) {
      return Ke(Dt) === We;
    }
    function Mt(Dt) {
      return Ke(Dt) === ye;
    }
    reactIs_development.ContextConsumer = tt, reactIs_development.ContextProvider = ut, reactIs_development.Element = st, reactIs_development.ForwardRef = ot, reactIs_development.Fragment = ht, reactIs_development.Lazy = vt, reactIs_development.Memo = At, reactIs_development.Portal = gt, reactIs_development.Profiler = bt, reactIs_development.StrictMode = wt, reactIs_development.Suspense = Ot, reactIs_development.SuspenseList = yt, reactIs_development.isAsyncMode = rt, reactIs_development.isConcurrentMode = lt, reactIs_development.isContextConsumer = ct, reactIs_development.isContextProvider = ft, reactIs_development.isElement = pt, reactIs_development.isForwardRef = mt, reactIs_development.isFragment = dt, reactIs_development.isLazy = Et, reactIs_development.isMemo = Ct, reactIs_development.isPortal = Tt, reactIs_development.isProfiler = qt, reactIs_development.isStrictMode = jt, reactIs_development.isSuspense = St, reactIs_development.isSuspenseList = Mt, reactIs_development.isValidElementType = $e, reactIs_development.typeOf = Ke;
  }()), reactIs_development;
}
process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min() : reactIs$1.exports = requireReactIs_development();
var reactIsExports = reactIs$1.exports;
function stylis_min(o) {
  function s(ct, ft, pt, mt, dt) {
    for (var Et = 0, Ct = 0, Tt = 0, qt = 0, jt, St, Mt = 0, Dt = 0, Nt, Kt = Nt = jt = 0, Ft = 0, Bt = 0, $t = 0, Gt = 0, Jt = pt.length, er = Jt - 1, Ht, zt = "", Xt = "", Vt = "", Yt = "", Rt; Ft < Jt; ) {
      if (St = pt.charCodeAt(Ft), Ft === er && Ct + qt + Tt + Et !== 0 && (Ct !== 0 && (St = Ct === 47 ? 10 : 47), qt = Tt = Et = 0, Jt++, er++), Ct + qt + Tt + Et === 0) {
        if (Ft === er && (0 < Bt && (zt = zt.replace(Ue, "")), 0 < zt.trim().length)) {
          switch (St) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              zt += pt.charAt(Ft);
          }
          St = 59;
        }
        switch (St) {
          case 123:
            for (zt = zt.trim(), jt = zt.charCodeAt(0), Nt = 1, Gt = ++Ft; Ft < Jt; ) {
              switch (St = pt.charCodeAt(Ft)) {
                case 123:
                  Nt++;
                  break;
                case 125:
                  Nt--;
                  break;
                case 47:
                  switch (St = pt.charCodeAt(Ft + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (Kt = Ft + 1; Kt < er; ++Kt)
                          switch (pt.charCodeAt(Kt)) {
                            case 47:
                              if (St === 42 && pt.charCodeAt(Kt - 1) === 42 && Ft + 2 !== Kt) {
                                Ft = Kt + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (St === 47) {
                                Ft = Kt + 1;
                                break e;
                              }
                          }
                        Ft = Kt;
                      }
                  }
                  break;
                case 91:
                  St++;
                case 40:
                  St++;
                case 34:
                case 39:
                  for (; Ft++ < er && pt.charCodeAt(Ft) !== St; )
                    ;
              }
              if (Nt === 0)
                break;
              Ft++;
            }
            switch (Nt = pt.substring(Gt, Ft), jt === 0 && (jt = (zt = zt.replace(Fe, "").trim()).charCodeAt(0)), jt) {
              case 64:
                switch (0 < Bt && (zt = zt.replace(Ue, "")), St = zt.charCodeAt(1), St) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Bt = ft;
                    break;
                  default:
                    Bt = Ot;
                }
                if (Nt = s(ft, Bt, Nt, St, dt + 1), Gt = Nt.length, 0 < Qe && (Bt = u(Ot, zt, $t), Rt = O(3, Nt, Bt, ft, gt, At, Gt, St, dt, mt), zt = Bt.join(""), Rt !== void 0 && (Gt = (Nt = Rt.trim()).length) === 0 && (St = 0, Nt = "")), 0 < Gt)
                  switch (St) {
                    case 115:
                      zt = zt.replace(tt, C);
                    case 100:
                    case 109:
                    case 45:
                      Nt = zt + "{" + Nt + "}";
                      break;
                    case 107:
                      zt = zt.replace(et, "$1 $2"), Nt = zt + "{" + Nt + "}", Nt = wt === 1 || wt === 2 && m("@" + Nt, 3) ? "@-webkit-" + Nt + "@" + Nt : "@" + Nt;
                      break;
                    default:
                      Nt = zt + Nt, mt === 112 && (Nt = (Xt += Nt, ""));
                  }
                else
                  Nt = "";
                break;
              default:
                Nt = s(ft, u(ft, zt, $t), Nt, mt, dt + 1);
            }
            Vt += Nt, Nt = $t = Bt = Kt = jt = 0, zt = "", St = pt.charCodeAt(++Ft);
            break;
          case 125:
          case 59:
            if (zt = (0 < Bt ? zt.replace(Ue, "") : zt).trim(), 1 < (Gt = zt.length))
              switch (Kt === 0 && (jt = zt.charCodeAt(0), jt === 45 || 96 < jt && 123 > jt) && (Gt = (zt = zt.replace(" ", ":")).length), 0 < Qe && (Rt = O(1, zt, ft, ct, gt, At, Xt.length, mt, dt, mt)) !== void 0 && (Gt = (zt = Rt.trim()).length) === 0 && (zt = "\0\0"), jt = zt.charCodeAt(0), St = zt.charCodeAt(1), jt) {
                case 0:
                  break;
                case 64:
                  if (St === 105 || St === 99) {
                    Yt += zt + pt.charAt(Ft);
                    break;
                  }
                default:
                  zt.charCodeAt(Gt - 1) !== 58 && (Xt += h(zt, jt, St, zt.charCodeAt(2)));
              }
            $t = Bt = Kt = jt = 0, zt = "", St = pt.charCodeAt(++Ft);
        }
      }
      switch (St) {
        case 13:
        case 10:
          Ct === 47 ? Ct = 0 : 1 + jt === 0 && mt !== 107 && 0 < zt.length && (Bt = 1, zt += "\0"), 0 < Qe * rt && O(0, zt, ft, ct, gt, At, Xt.length, mt, dt, mt), At = 1, gt++;
          break;
        case 59:
        case 125:
          if (Ct + qt + Tt + Et === 0) {
            At++;
            break;
          }
        default:
          switch (At++, Ht = pt.charAt(Ft), St) {
            case 9:
            case 32:
              if (qt + Et + Ct === 0)
                switch (Mt) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    Ht = "";
                    break;
                  default:
                    St !== 32 && (Ht = " ");
                }
              break;
            case 0:
              Ht = "\\0";
              break;
            case 12:
              Ht = "\\f";
              break;
            case 11:
              Ht = "\\v";
              break;
            case 38:
              qt + Ct + Et === 0 && (Bt = $t = 1, Ht = "\f" + Ht);
              break;
            case 108:
              if (qt + Ct + Et + bt === 0 && 0 < Kt)
                switch (Ft - Kt) {
                  case 2:
                    Mt === 112 && pt.charCodeAt(Ft - 3) === 58 && (bt = Mt);
                  case 8:
                    Dt === 111 && (bt = Dt);
                }
              break;
            case 58:
              qt + Ct + Et === 0 && (Kt = Ft);
              break;
            case 44:
              Ct + Tt + qt + Et === 0 && (Bt = 1, Ht += "\r");
              break;
            case 34:
            case 39:
              Ct === 0 && (qt = qt === St ? 0 : qt === 0 ? St : qt);
              break;
            case 91:
              qt + Ct + Tt === 0 && Et++;
              break;
            case 93:
              qt + Ct + Tt === 0 && Et--;
              break;
            case 41:
              qt + Ct + Et === 0 && Tt--;
              break;
            case 40:
              if (qt + Ct + Et === 0) {
                if (jt === 0)
                  switch (2 * Mt + 3 * Dt) {
                    case 533:
                      break;
                    default:
                      jt = 1;
                  }
                Tt++;
              }
              break;
            case 64:
              Ct + Tt + qt + Et + Kt + Nt === 0 && (Nt = 1);
              break;
            case 42:
            case 47:
              if (!(0 < qt + Et + Tt))
                switch (Ct) {
                  case 0:
                    switch (2 * St + 3 * pt.charCodeAt(Ft + 1)) {
                      case 235:
                        Ct = 47;
                        break;
                      case 220:
                        Gt = Ft, Ct = 42;
                    }
                    break;
                  case 42:
                    St === 47 && Mt === 42 && Gt + 2 !== Ft && (pt.charCodeAt(Gt + 2) === 33 && (Xt += pt.substring(Gt, Ft + 1)), Ht = "", Ct = 0);
                }
          }
          Ct === 0 && (zt += Ht);
      }
      Dt = Mt, Mt = St, Ft++;
    }
    if (Gt = Xt.length, 0 < Gt) {
      if (Bt = ft, 0 < Qe && (Rt = O(2, Xt, Bt, ct, gt, At, Gt, mt, dt, mt), Rt !== void 0 && (Xt = Rt).length === 0))
        return Yt + Xt + Vt;
      if (Xt = Bt.join(",") + "{" + Xt + "}", wt * bt !== 0) {
        switch (wt !== 2 || m(Xt, 2) || (bt = 0), bt) {
          case 111:
            Xt = Xt.replace($e, ":-moz-$1") + Xt;
            break;
          case 112:
            Xt = Xt.replace(at, "::-webkit-input-$1") + Xt.replace(at, "::-moz-$1") + Xt.replace(at, ":-ms-input-$1") + Xt;
        }
        bt = 0;
      }
    }
    return Yt + Xt + Vt;
  }
  function u(ct, ft, pt) {
    var mt = ft.trim().split(Je);
    ft = mt;
    var dt = mt.length, Et = ct.length;
    switch (Et) {
      case 0:
      case 1:
        var Ct = 0;
        for (ct = Et === 0 ? "" : ct[0] + " "; Ct < dt; ++Ct)
          ft[Ct] = l(ct, ft[Ct], pt).trim();
        break;
      default:
        var Tt = Ct = 0;
        for (ft = []; Ct < dt; ++Ct)
          for (var qt = 0; qt < Et; ++qt)
            ft[Tt++] = l(ct[qt] + " ", mt[Ct], pt).trim();
    }
    return ft;
  }
  function l(ct, ft, pt) {
    var mt = ft.charCodeAt(0);
    switch (33 > mt && (mt = (ft = ft.trim()).charCodeAt(0)), mt) {
      case 38:
        return ft.replace(it, "$1" + ct.trim());
      case 58:
        return ct.trim() + ft.replace(it, "$1" + ct.trim());
      default:
        if (0 < 1 * pt && 0 < ft.indexOf("\f"))
          return ft.replace(it, (ct.charCodeAt(0) === 58 ? "" : "$1") + ct.trim());
    }
    return ct + ft;
  }
  function h(ct, ft, pt, mt) {
    var dt = ct + ";", Et = 2 * ft + 3 * pt + 4 * mt;
    if (Et === 944) {
      ct = dt.indexOf(":", 9) + 1;
      var Ct = dt.substring(ct, dt.length - 1).trim();
      return Ct = dt.substring(0, ct).trim() + Ct + ";", wt === 1 || wt === 2 && m(Ct, 1) ? "-webkit-" + Ct + Ct : Ct;
    }
    if (wt === 0 || wt === 2 && !m(dt, 1))
      return dt;
    switch (Et) {
      case 1015:
        return dt.charCodeAt(10) === 97 ? "-webkit-" + dt + dt : dt;
      case 951:
        return dt.charCodeAt(3) === 116 ? "-webkit-" + dt + dt : dt;
      case 963:
        return dt.charCodeAt(5) === 110 ? "-webkit-" + dt + dt : dt;
      case 1009:
        if (dt.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + dt + dt;
      case 978:
        return "-webkit-" + dt + "-moz-" + dt + dt;
      case 1019:
      case 983:
        return "-webkit-" + dt + "-moz-" + dt + "-ms-" + dt + dt;
      case 883:
        if (dt.charCodeAt(8) === 45)
          return "-webkit-" + dt + dt;
        if (0 < dt.indexOf("image-set(", 11))
          return dt.replace(vt, "$1-webkit-$2") + dt;
        break;
      case 932:
        if (dt.charCodeAt(4) === 45)
          switch (dt.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + dt.replace("-grow", "") + "-webkit-" + dt + "-ms-" + dt.replace("grow", "positive") + dt;
            case 115:
              return "-webkit-" + dt + "-ms-" + dt.replace("shrink", "negative") + dt;
            case 98:
              return "-webkit-" + dt + "-ms-" + dt.replace("basis", "preferred-size") + dt;
          }
        return "-webkit-" + dt + "-ms-" + dt + dt;
      case 964:
        return "-webkit-" + dt + "-ms-flex-" + dt + dt;
      case 1023:
        if (dt.charCodeAt(8) !== 99)
          break;
        return Ct = dt.substring(dt.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + Ct + "-webkit-" + dt + "-ms-flex-pack" + Ct + dt;
      case 1005:
        return Ze.test(dt) ? dt.replace(Le, ":-webkit-") + dt.replace(Le, ":-moz-") + dt : dt;
      case 1e3:
        switch (Ct = dt.substring(13).trim(), ft = Ct.indexOf("-") + 1, Ct.charCodeAt(0) + Ct.charCodeAt(ft)) {
          case 226:
            Ct = dt.replace(Ke, "tb");
            break;
          case 232:
            Ct = dt.replace(Ke, "tb-rl");
            break;
          case 220:
            Ct = dt.replace(Ke, "lr");
            break;
          default:
            return dt;
        }
        return "-webkit-" + dt + "-ms-" + Ct + dt;
      case 1017:
        if (dt.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (ft = (dt = ct).length - 10, Ct = (dt.charCodeAt(ft) === 33 ? dt.substring(0, ft) : dt).substring(ct.indexOf(":", 7) + 1).trim(), Et = Ct.charCodeAt(0) + (Ct.charCodeAt(7) | 0)) {
          case 203:
            if (111 > Ct.charCodeAt(8))
              break;
          case 115:
            dt = dt.replace(Ct, "-webkit-" + Ct) + ";" + dt;
            break;
          case 207:
          case 102:
            dt = dt.replace(Ct, "-webkit-" + (102 < Et ? "inline-" : "") + "box") + ";" + dt.replace(Ct, "-webkit-" + Ct) + ";" + dt.replace(Ct, "-ms-" + Ct + "box") + ";" + dt;
        }
        return dt + ";";
      case 938:
        if (dt.charCodeAt(5) === 45)
          switch (dt.charCodeAt(6)) {
            case 105:
              return Ct = dt.replace("-items", ""), "-webkit-" + dt + "-webkit-box-" + Ct + "-ms-flex-" + Ct + dt;
            case 115:
              return "-webkit-" + dt + "-ms-flex-item-" + dt.replace(st, "") + dt;
            default:
              return "-webkit-" + dt + "-ms-flex-line-pack" + dt.replace("align-content", "").replace(st, "") + dt;
          }
        break;
      case 973:
      case 989:
        if (dt.charCodeAt(3) !== 45 || dt.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (ht.test(ct) === !0)
          return (Ct = ct.substring(ct.indexOf(":") + 1)).charCodeAt(0) === 115 ? h(ct.replace("stretch", "fill-available"), ft, pt, mt).replace(":fill-available", ":stretch") : dt.replace(Ct, "-webkit-" + Ct) + dt.replace(Ct, "-moz-" + Ct.replace("fill-", "")) + dt;
        break;
      case 962:
        if (dt = "-webkit-" + dt + (dt.charCodeAt(5) === 102 ? "-ms-" + dt : "") + dt, pt + mt === 211 && dt.charCodeAt(13) === 105 && 0 < dt.indexOf("transform", 10))
          return dt.substring(0, dt.indexOf(";", 27) + 1).replace(Xe, "$1-webkit-$2") + dt;
    }
    return dt;
  }
  function m(ct, ft) {
    var pt = ct.indexOf(ft === 1 ? ":" : "{"), mt = ct.substring(0, ft !== 3 ? pt : 10);
    return pt = ct.substring(pt + 1, ct.length - 1), nt(ft !== 2 ? mt : mt.replace(ot, "$1"), pt, ft);
  }
  function C(ct, ft) {
    var pt = h(ft, ft.charCodeAt(0), ft.charCodeAt(1), ft.charCodeAt(2));
    return pt !== ft + ";" ? pt.replace(ut, " or ($1)").substring(4) : "(" + ft + ")";
  }
  function O(ct, ft, pt, mt, dt, Et, Ct, Tt, qt, jt) {
    for (var St = 0, Mt = ft, Dt; St < Qe; ++St)
      switch (Dt = yt[St].call(ye, ct, Mt, pt, mt, dt, Et, Ct, Tt, qt, jt)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          Mt = Dt;
      }
    if (Mt !== ft)
      return Mt;
  }
  function le(ct) {
    switch (ct) {
      case void 0:
      case null:
        Qe = yt.length = 0;
        break;
      default:
        if (typeof ct == "function")
          yt[Qe++] = ct;
        else if (typeof ct == "object")
          for (var ft = 0, pt = ct.length; ft < pt; ++ft)
            le(ct[ft]);
        else
          rt = !!ct | 0;
    }
    return le;
  }
  function We(ct) {
    return ct = ct.prefix, ct !== void 0 && (nt = null, ct ? typeof ct != "function" ? wt = 1 : (wt = 2, nt = ct) : wt = 0), We;
  }
  function ye(ct, ft) {
    var pt = ct;
    if (33 > pt.charCodeAt(0) && (pt = pt.trim()), lt = pt, pt = [lt], 0 < Qe) {
      var mt = O(-1, ft, pt, pt, gt, At, 0, 0, 0, 0);
      mt !== void 0 && typeof mt == "string" && (ft = mt);
    }
    var dt = s(Ot, pt, ft, 0, 0);
    return 0 < Qe && (mt = O(-2, dt, pt, pt, gt, At, dt.length, 0, 0, 0), mt !== void 0 && (dt = mt)), lt = "", bt = 0, At = gt = 1, dt;
  }
  var Fe = /^\0+/g, Ue = /[\0\r\f]/g, Le = /: */g, Ze = /zoo|gra/, Xe = /([,: ])(transform)/g, Je = /,\r+?/g, it = /([\t\r\n ])*\f?&/g, et = /@(k\w+)\s*(\S*)\s*/, at = /::(place)/g, $e = /:(read-only)/g, Ke = /[svh]\w+-[tblr]{2}/, tt = /\(\s*(.*)\s*\)/g, ut = /([\s\S]*?);/g, st = /-self|flex-/g, ot = /[^]*?(:[rp][el]a[\w-]+)[^]*/, ht = /stretch|:\s*\w+\-(?:conte|avail)/, vt = /([^-])(image-set\()/, At = 1, gt = 1, bt = 0, wt = 1, Ot = [], yt = [], Qe = 0, nt = null, rt = 0, lt = "";
  return ye.use = le, ye.set = We, o !== void 0 && We(o), ye;
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(o) {
  var s = /* @__PURE__ */ Object.create(null);
  return function(u) {
    return s[u] === void 0 && (s[u] = o(u)), s[u];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize(
  function(o) {
    return reactPropsRegex.test(o) || o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o.charCodeAt(2) < 91;
  }
  /* Z+1 */
), reactIs = reactIsExports$1, REACT_STATICS = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, KNOWN_STATICS = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(o) {
  return reactIs.isMemo(o) ? MEMO_STATICS : TYPE_STATICS[o.$$typeof] || REACT_STATICS;
}
var defineProperty = Object.defineProperty, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getPrototypeOf = Object.getPrototypeOf, objectPrototype = Object.prototype;
function hoistNonReactStatics(o, s, u) {
  if (typeof s != "string") {
    if (objectPrototype) {
      var l = getPrototypeOf(s);
      l && l !== objectPrototype && hoistNonReactStatics(o, l, u);
    }
    var h = getOwnPropertyNames(s);
    getOwnPropertySymbols && (h = h.concat(getOwnPropertySymbols(s)));
    for (var m = getStatics(o), C = getStatics(s), O = 0; O < h.length; ++O) {
      var le = h[O];
      if (!KNOWN_STATICS[le] && !(u && u[le]) && !(C && C[le]) && !(m && m[le])) {
        var We = getOwnPropertyDescriptor(s, le);
        try {
          defineProperty(o, le, We);
        } catch {
        }
      }
    }
  }
  return o;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
const y = /* @__PURE__ */ getDefaultExportFromCjs(hoistNonReactStatics_cjs);
function v() {
  return (v = Object.assign || function(o) {
    for (var s = 1; s < arguments.length; s++) {
      var u = arguments[s];
      for (var l in u)
        Object.prototype.hasOwnProperty.call(u, l) && (o[l] = u[l]);
    }
    return o;
  }).apply(this, arguments);
}
var g = function(o, s) {
  for (var u = [o[0]], l = 0, h = s.length; l < h; l += 1)
    u.push(s[l], o[l + 1]);
  return u;
}, S = function(o) {
  return o !== null && typeof o == "object" && (o.toString ? o.toString() : Object.prototype.toString.call(o)) === "[object Object]" && !reactIsExports.typeOf(o);
}, w = Object.freeze([]), E = Object.freeze({});
function b(o) {
  return typeof o == "function";
}
function _(o) {
  return process.env.NODE_ENV !== "production" && typeof o == "string" && o || o.displayName || o.name || "Component";
}
function N(o) {
  return o && typeof o.styledComponentId == "string";
}
var A = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", I = typeof window < "u" && "HTMLElement" in window, P = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), R = process.env.NODE_ENV !== "production" ? {
  1: `Cannot create styled-component for component: %s.

`,
  2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`,
  3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`,
  4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`,
  5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`,
  6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`,
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: `ThemeProvider: Please make your "theme" prop an object.

`,
  9: "Missing document `<head>`\n\n",
  10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`,
  11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`,
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`,
  14: `ThemeProvider: "theme" prop is required.

`,
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`,
  17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`
} : {};
function D() {
  for (var o = arguments.length <= 0 ? void 0 : arguments[0], s = [], u = 1, l = arguments.length; u < l; u += 1)
    s.push(u < 0 || arguments.length <= u ? void 0 : arguments[u]);
  return s.forEach(function(h) {
    o = o.replace(/%[a-z]/, h);
  }), o;
}
function j(o) {
  for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
    u[l - 1] = arguments[l];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + o + " for more information." + (u.length > 0 ? " Args: " + u.join(", ") : "")) : new Error(D.apply(void 0, [R[o]].concat(u)).trim());
}
var T = function() {
  function o(u) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = u;
  }
  var s = o.prototype;
  return s.indexOfGroup = function(u) {
    for (var l = 0, h = 0; h < u; h++)
      l += this.groupSizes[h];
    return l;
  }, s.insertRules = function(u, l) {
    if (u >= this.groupSizes.length) {
      for (var h = this.groupSizes, m = h.length, C = m; u >= C; )
        (C <<= 1) < 0 && j(16, "" + u);
      this.groupSizes = new Uint32Array(C), this.groupSizes.set(h), this.length = C;
      for (var O = m; O < C; O++)
        this.groupSizes[O] = 0;
    }
    for (var le = this.indexOfGroup(u + 1), We = 0, ye = l.length; We < ye; We++)
      this.tag.insertRule(le, l[We]) && (this.groupSizes[u]++, le++);
  }, s.clearGroup = function(u) {
    if (u < this.length) {
      var l = this.groupSizes[u], h = this.indexOfGroup(u), m = h + l;
      this.groupSizes[u] = 0;
      for (var C = h; C < m; C++)
        this.tag.deleteRule(h);
    }
  }, s.getGroup = function(u) {
    var l = "";
    if (u >= this.length || this.groupSizes[u] === 0)
      return l;
    for (var h = this.groupSizes[u], m = this.indexOfGroup(u), C = m + h, O = m; O < C; O++)
      l += this.tag.getRule(O) + `/*!sc*/
`;
    return l;
  }, o;
}(), x = /* @__PURE__ */ new Map(), k = /* @__PURE__ */ new Map(), V = 1, B = function(o) {
  if (x.has(o))
    return x.get(o);
  for (; k.has(V); )
    V++;
  var s = V++;
  return process.env.NODE_ENV !== "production" && ((0 | s) < 0 || s > 1 << 30) && j(16, "" + s), x.set(o, s), k.set(s, o), s;
}, z = function(o) {
  return k.get(o);
}, M = function(o, s) {
  s >= V && (V = s + 1), x.set(o, s), k.set(s, o);
}, G = "style[" + A + '][data-styled-version="5.3.6"]', L = new RegExp("^" + A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), F = function(o, s, u) {
  for (var l, h = u.split(","), m = 0, C = h.length; m < C; m++)
    (l = h[m]) && o.registerName(s, l);
}, Y = function(o, s) {
  for (var u = (s.textContent || "").split(`/*!sc*/
`), l = [], h = 0, m = u.length; h < m; h++) {
    var C = u[h].trim();
    if (C) {
      var O = C.match(L);
      if (O) {
        var le = 0 | parseInt(O[1], 10), We = O[2];
        le !== 0 && (M(We, le), F(o, We, O[3]), o.getTag().insertRules(le, l)), l.length = 0;
      } else
        l.push(C);
    }
  }
}, q = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, H = function(o) {
  var s = document.head, u = o || s, l = document.createElement("style"), h = function(O) {
    for (var le = O.childNodes, We = le.length; We >= 0; We--) {
      var ye = le[We];
      if (ye && ye.nodeType === 1 && ye.hasAttribute(A))
        return ye;
    }
  }(u), m = h !== void 0 ? h.nextSibling : null;
  l.setAttribute(A, "active"), l.setAttribute("data-styled-version", "5.3.6");
  var C = q();
  return C && l.setAttribute("nonce", C), u.insertBefore(l, m), l;
}, $ = function() {
  function o(u) {
    var l = this.element = H(u);
    l.appendChild(document.createTextNode("")), this.sheet = function(h) {
      if (h.sheet)
        return h.sheet;
      for (var m = document.styleSheets, C = 0, O = m.length; C < O; C++) {
        var le = m[C];
        if (le.ownerNode === h)
          return le;
      }
      j(17);
    }(l), this.length = 0;
  }
  var s = o.prototype;
  return s.insertRule = function(u, l) {
    try {
      return this.sheet.insertRule(l, u), this.length++, !0;
    } catch {
      return !1;
    }
  }, s.deleteRule = function(u) {
    this.sheet.deleteRule(u), this.length--;
  }, s.getRule = function(u) {
    var l = this.sheet.cssRules[u];
    return l !== void 0 && typeof l.cssText == "string" ? l.cssText : "";
  }, o;
}(), W = function() {
  function o(u) {
    var l = this.element = H(u);
    this.nodes = l.childNodes, this.length = 0;
  }
  var s = o.prototype;
  return s.insertRule = function(u, l) {
    if (u <= this.length && u >= 0) {
      var h = document.createTextNode(l), m = this.nodes[u];
      return this.element.insertBefore(h, m || null), this.length++, !0;
    }
    return !1;
  }, s.deleteRule = function(u) {
    this.element.removeChild(this.nodes[u]), this.length--;
  }, s.getRule = function(u) {
    return u < this.length ? this.nodes[u].textContent : "";
  }, o;
}(), U = function() {
  function o(u) {
    this.rules = [], this.length = 0;
  }
  var s = o.prototype;
  return s.insertRule = function(u, l) {
    return u <= this.length && (this.rules.splice(u, 0, l), this.length++, !0);
  }, s.deleteRule = function(u) {
    this.rules.splice(u, 1), this.length--;
  }, s.getRule = function(u) {
    return u < this.length ? this.rules[u] : "";
  }, o;
}(), J = I, X = {
  isServer: !I,
  useCSSOMInjection: !P
}, Z = function() {
  function o(u, l, h) {
    u === void 0 && (u = E), l === void 0 && (l = {}), this.options = v({}, X, {}, u), this.gs = l, this.names = new Map(h), this.server = !!u.isServer, !this.server && I && J && (J = !1, function(m) {
      for (var C = document.querySelectorAll(G), O = 0, le = C.length; O < le; O++) {
        var We = C[O];
        We && We.getAttribute(A) !== "active" && (Y(m, We), We.parentNode && We.parentNode.removeChild(We));
      }
    }(this));
  }
  o.registerId = function(u) {
    return B(u);
  };
  var s = o.prototype;
  return s.reconstructWithOptions = function(u, l) {
    return l === void 0 && (l = !0), new o(v({}, this.options, {}, u), this.gs, l && this.names || void 0);
  }, s.allocateGSInstance = function(u) {
    return this.gs[u] = (this.gs[u] || 0) + 1;
  }, s.getTag = function() {
    return this.tag || (this.tag = (h = (l = this.options).isServer, m = l.useCSSOMInjection, C = l.target, u = h ? new U(C) : m ? new $(C) : new W(C), new T(u)));
    var u, l, h, m, C;
  }, s.hasNameForId = function(u, l) {
    return this.names.has(u) && this.names.get(u).has(l);
  }, s.registerName = function(u, l) {
    if (B(u), this.names.has(u))
      this.names.get(u).add(l);
    else {
      var h = /* @__PURE__ */ new Set();
      h.add(l), this.names.set(u, h);
    }
  }, s.insertRules = function(u, l, h) {
    this.registerName(u, l), this.getTag().insertRules(B(u), h);
  }, s.clearNames = function(u) {
    this.names.has(u) && this.names.get(u).clear();
  }, s.clearRules = function(u) {
    this.getTag().clearGroup(B(u)), this.clearNames(u);
  }, s.clearTag = function() {
    this.tag = void 0;
  }, s.toString = function() {
    return function(u) {
      for (var l = u.getTag(), h = l.length, m = "", C = 0; C < h; C++) {
        var O = z(C);
        if (O !== void 0) {
          var le = u.names.get(O), We = l.getGroup(C);
          if (le && We && le.size) {
            var ye = A + ".g" + C + '[id="' + O + '"]', Fe = "";
            le !== void 0 && le.forEach(function(Ue) {
              Ue.length > 0 && (Fe += Ue + ",");
            }), m += "" + We + ye + '{content:"' + Fe + `"}/*!sc*/
`;
          }
        }
      }
      return m;
    }(this);
  }, o;
}(), K = /(a)(d)/gi, Q = function(o) {
  return String.fromCharCode(o + (o > 25 ? 39 : 97));
};
function ee(o) {
  var s, u = "";
  for (s = Math.abs(o); s > 52; s = s / 52 | 0)
    u = Q(s % 52) + u;
  return (Q(s % 52) + u).replace(K, "$1-$2");
}
var te = function(o, s) {
  for (var u = s.length; u; )
    o = 33 * o ^ s.charCodeAt(--u);
  return o;
}, ne = function(o) {
  return te(5381, o);
};
function re(o) {
  for (var s = 0; s < o.length; s += 1) {
    var u = o[s];
    if (b(u) && !N(u))
      return !1;
  }
  return !0;
}
var oe = ne("5.3.6"), se = function() {
  function o(s, u, l) {
    this.rules = s, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (l === void 0 || l.isStatic) && re(s), this.componentId = u, this.baseHash = te(oe, u), this.baseStyle = l, Z.registerId(u);
  }
  return o.prototype.generateAndInjectStyles = function(s, u, l) {
    var h = this.componentId, m = [];
    if (this.baseStyle && m.push(this.baseStyle.generateAndInjectStyles(s, u, l)), this.isStatic && !l.hash)
      if (this.staticRulesId && u.hasNameForId(h, this.staticRulesId))
        m.push(this.staticRulesId);
      else {
        var C = Ne(this.rules, s, u, l).join(""), O = ee(te(this.baseHash, C) >>> 0);
        if (!u.hasNameForId(h, O)) {
          var le = l(C, "." + O, void 0, h);
          u.insertRules(h, O, le);
        }
        m.push(O), this.staticRulesId = O;
      }
    else {
      for (var We = this.rules.length, ye = te(this.baseHash, l.hash), Fe = "", Ue = 0; Ue < We; Ue++) {
        var Le = this.rules[Ue];
        if (typeof Le == "string")
          Fe += Le, process.env.NODE_ENV !== "production" && (ye = te(ye, Le + Ue));
        else if (Le) {
          var Ze = Ne(Le, s, u, l), Xe = Array.isArray(Ze) ? Ze.join("") : Ze;
          ye = te(ye, Xe + Ue), Fe += Xe;
        }
      }
      if (Fe) {
        var Je = ee(ye >>> 0);
        if (!u.hasNameForId(h, Je)) {
          var it = l(Fe, "." + Je, void 0, h);
          u.insertRules(h, Je, it);
        }
        m.push(Je);
      }
    }
    return m.join(" ");
  }, o;
}(), ie = /^\s*\/\/.*$/gm, ae = [":", "[", ".", "#"];
function ce(o) {
  var s, u, l, h, m = o === void 0 ? E : o, C = m.options, O = C === void 0 ? E : C, le = m.plugins, We = le === void 0 ? w : le, ye = new stylis_min(O), Fe = [], Ue = function(Xe) {
    function Je(it) {
      if (it)
        try {
          Xe(it + "}");
        } catch {
        }
    }
    return function(it, et, at, $e, Ke, tt, ut, st, ot, ht) {
      switch (it) {
        case 1:
          if (ot === 0 && et.charCodeAt(0) === 64)
            return Xe(et + ";"), "";
          break;
        case 2:
          if (st === 0)
            return et + "/*|*/";
          break;
        case 3:
          switch (st) {
            case 102:
            case 112:
              return Xe(at[0] + et), "";
            default:
              return et + (ht === 0 ? "/*|*/" : "");
          }
        case -2:
          et.split("/*|*/}").forEach(Je);
      }
    };
  }(function(Xe) {
    Fe.push(Xe);
  }), Le = function(Xe, Je, it) {
    return Je === 0 && ae.indexOf(it[u.length]) !== -1 || it.match(h) ? Xe : "." + s;
  };
  function Ze(Xe, Je, it, et) {
    et === void 0 && (et = "&");
    var at = Xe.replace(ie, ""), $e = Je && it ? it + " " + Je + " { " + at + " }" : at;
    return s = et, u = Je, l = new RegExp("\\" + u + "\\b", "g"), h = new RegExp("(\\" + u + "\\b){2,}"), ye(it || !Je ? "" : Je, $e);
  }
  return ye.use([].concat(We, [function(Xe, Je, it) {
    Xe === 2 && it.length && it[0].lastIndexOf(u) > 0 && (it[0] = it[0].replace(l, Le));
  }, Ue, function(Xe) {
    if (Xe === -2) {
      var Je = Fe;
      return Fe = [], Je;
    }
  }])), Ze.hash = We.length ? We.reduce(function(Xe, Je) {
    return Je.name || j(15), te(Xe, Je.name);
  }, 5381).toString() : "", Ze;
}
var ue = React$1.createContext();
ue.Consumer;
var de = React$1.createContext(), he = (de.Consumer, new Z()), pe = ce();
function fe() {
  return useContext(ue) || he;
}
function me() {
  return useContext(de) || pe;
}
var ve = function() {
  function o(s, u) {
    var l = this;
    this.inject = function(h, m) {
      m === void 0 && (m = pe);
      var C = l.name + m.hash;
      h.hasNameForId(l.id, C) || h.insertRules(l.id, C, m(l.rules, C, "@keyframes"));
    }, this.toString = function() {
      return j(12, String(l.name));
    }, this.name = s, this.id = "sc-keyframes-" + s, this.rules = u;
  }
  return o.prototype.getName = function(s) {
    return s === void 0 && (s = pe), this.name + s.hash;
  }, o;
}(), ge = /([A-Z])/, Se = /([A-Z])/g, we = /^ms-/, Ee = function(o) {
  return "-" + o.toLowerCase();
};
function be(o) {
  return ge.test(o) ? o.replace(Se, Ee).replace(we, "-ms-") : o;
}
var _e = function(o) {
  return o == null || o === !1 || o === "";
};
function Ne(o, s, u, l) {
  if (Array.isArray(o)) {
    for (var h, m = [], C = 0, O = o.length; C < O; C += 1)
      (h = Ne(o[C], s, u, l)) !== "" && (Array.isArray(h) ? m.push.apply(m, h) : m.push(h));
    return m;
  }
  if (_e(o))
    return "";
  if (N(o))
    return "." + o.styledComponentId;
  if (b(o)) {
    if (typeof (We = o) != "function" || We.prototype && We.prototype.isReactComponent || !s)
      return o;
    var le = o(s);
    return process.env.NODE_ENV !== "production" && reactIsExports.isElement(le) && console.warn(_(o) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Ne(le, s, u, l);
  }
  var We;
  return o instanceof ve ? u ? (o.inject(u, l), o.getName(l)) : o : S(o) ? function ye(Fe, Ue) {
    var Le, Ze, Xe = [];
    for (var Je in Fe)
      Fe.hasOwnProperty(Je) && !_e(Fe[Je]) && (Array.isArray(Fe[Je]) && Fe[Je].isCss || b(Fe[Je]) ? Xe.push(be(Je) + ":", Fe[Je], ";") : S(Fe[Je]) ? Xe.push.apply(Xe, ye(Fe[Je], Je)) : Xe.push(be(Je) + ": " + (Le = Je, (Ze = Fe[Je]) == null || typeof Ze == "boolean" || Ze === "" ? "" : typeof Ze != "number" || Ze === 0 || Le in unitlessKeys ? String(Ze).trim() : Ze + "px") + ";"));
    return Ue ? [Ue + " {"].concat(Xe, ["}"]) : Xe;
  }(o) : o.toString();
}
var Ae = function(o) {
  return Array.isArray(o) && (o.isCss = !0), o;
};
function Ce(o) {
  for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
    u[l - 1] = arguments[l];
  return b(o) || S(o) ? Ae(Ne(g(w, [o].concat(u)))) : u.length === 0 && o.length === 1 && typeof o[0] == "string" ? o : Ae(Ne(g(o, u)));
}
var Ie = /invalid hook call/i, Pe = /* @__PURE__ */ new Set(), Oe = function(o, s) {
  if (process.env.NODE_ENV !== "production") {
    var u = "The component " + o + (s ? ' with the id of "' + s + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, l = console.error;
    try {
      var h = !0;
      console.error = function(m) {
        if (Ie.test(m))
          h = !1, Pe.delete(u);
        else {
          for (var C = arguments.length, O = new Array(C > 1 ? C - 1 : 0), le = 1; le < C; le++)
            O[le - 1] = arguments[le];
          l.apply(void 0, [m].concat(O));
        }
      }, useRef(), h && !Pe.has(u) && (console.warn(u), Pe.add(u));
    } catch (m) {
      Ie.test(m.message) && Pe.delete(u);
    } finally {
      console.error = l;
    }
  }
}, Re = function(o, s, u) {
  return u === void 0 && (u = E), o.theme !== u.theme && o.theme || s || u.theme;
}, De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, je = /(^-|-$)/g;
function Te(o) {
  return o.replace(De, "-").replace(je, "");
}
var xe = function(o) {
  return ee(ne(o) >>> 0);
};
function ke(o) {
  return typeof o == "string" && (process.env.NODE_ENV === "production" || o.charAt(0) === o.charAt(0).toLowerCase());
}
var Ve = function(o) {
  return typeof o == "function" || typeof o == "object" && o !== null && !Array.isArray(o);
}, Be = function(o) {
  return o !== "__proto__" && o !== "constructor" && o !== "prototype";
};
function ze(o, s, u) {
  var l = o[u];
  Ve(s) && Ve(l) ? Me(l, s) : o[u] = s;
}
function Me(o) {
  for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
    u[l - 1] = arguments[l];
  for (var h = 0, m = u; h < m.length; h++) {
    var C = m[h];
    if (Ve(C))
      for (var O in C)
        Be(O) && ze(o, C[O], O);
  }
  return o;
}
var Ge = React$1.createContext();
Ge.Consumer;
var Ye = {};
function qe(o, s, u) {
  var l = N(o), h = !ke(o), m = s.attrs, C = m === void 0 ? w : m, O = s.componentId, le = O === void 0 ? function(et, at) {
    var $e = typeof et != "string" ? "sc" : Te(et);
    Ye[$e] = (Ye[$e] || 0) + 1;
    var Ke = $e + "-" + xe("5.3.6" + $e + Ye[$e]);
    return at ? at + "-" + Ke : Ke;
  }(s.displayName, s.parentComponentId) : O, We = s.displayName, ye = We === void 0 ? function(et) {
    return ke(et) ? "styled." + et : "Styled(" + _(et) + ")";
  }(o) : We, Fe = s.displayName && s.componentId ? Te(s.displayName) + "-" + s.componentId : s.componentId || le, Ue = l && o.attrs ? Array.prototype.concat(o.attrs, C).filter(Boolean) : C, Le = s.shouldForwardProp;
  l && o.shouldForwardProp && (Le = s.shouldForwardProp ? function(et, at, $e) {
    return o.shouldForwardProp(et, at, $e) && s.shouldForwardProp(et, at, $e);
  } : o.shouldForwardProp);
  var Ze, Xe = new se(u, Fe, l ? o.componentStyle : void 0), Je = Xe.isStatic && C.length === 0, it = function(et, at) {
    return function($e, Ke, tt, ut) {
      var st = $e.attrs, ot = $e.componentStyle, ht = $e.defaultProps, vt = $e.foldedComponentIds, At = $e.shouldForwardProp, gt = $e.styledComponentId, bt = $e.target;
      process.env.NODE_ENV !== "production" && useDebugValue(gt);
      var wt = function(mt, dt, Et) {
        mt === void 0 && (mt = E);
        var Ct = v({}, dt, {
          theme: mt
        }), Tt = {};
        return Et.forEach(function(qt) {
          var jt, St, Mt, Dt = qt;
          for (jt in b(Dt) && (Dt = Dt(Ct)), Dt)
            Ct[jt] = Tt[jt] = jt === "className" ? (St = Tt[jt], Mt = Dt[jt], St && Mt ? St + " " + Mt : St || Mt) : Dt[jt];
        }), [Ct, Tt];
      }(Re(Ke, useContext(Ge), ht) || E, Ke, st), Ot = wt[0], yt = wt[1], Qe = function(mt, dt, Et, Ct) {
        var Tt = fe(), qt = me(), jt = dt ? mt.generateAndInjectStyles(E, Tt, qt) : mt.generateAndInjectStyles(Et, Tt, qt);
        return process.env.NODE_ENV !== "production" && useDebugValue(jt), process.env.NODE_ENV !== "production" && !dt && Ct && Ct(jt), jt;
      }(ot, ut, Ot, process.env.NODE_ENV !== "production" ? $e.warnTooManyClasses : void 0), nt = tt, rt = yt.$as || Ke.$as || yt.as || Ke.as || bt, lt = ke(rt), ct = yt !== Ke ? v({}, Ke, {}, yt) : Ke, ft = {};
      for (var pt in ct)
        pt[0] !== "$" && pt !== "as" && (pt === "forwardedAs" ? ft.as = ct[pt] : (At ? At(pt, isPropValid, rt) : !lt || isPropValid(pt)) && (ft[pt] = ct[pt]));
      return Ke.style && yt.style !== Ke.style && (ft.style = v({}, Ke.style, {}, yt.style)), ft.className = Array.prototype.concat(vt, gt, Qe !== gt ? Qe : null, Ke.className, yt.className).filter(Boolean).join(" "), ft.ref = nt, createElement$1(rt, ft);
    }(Ze, et, at, Je);
  };
  return it.displayName = ye, (Ze = React$1.forwardRef(it)).attrs = Ue, Ze.componentStyle = Xe, Ze.displayName = ye, Ze.shouldForwardProp = Le, Ze.foldedComponentIds = l ? Array.prototype.concat(o.foldedComponentIds, o.styledComponentId) : w, Ze.styledComponentId = Fe, Ze.target = l ? o.target : o, Ze.withComponent = function(et) {
    var at = s.componentId, $e = function(tt, ut) {
      if (tt == null)
        return {};
      var st, ot, ht = {}, vt = Object.keys(tt);
      for (ot = 0; ot < vt.length; ot++)
        st = vt[ot], ut.indexOf(st) >= 0 || (ht[st] = tt[st]);
      return ht;
    }(s, ["componentId"]), Ke = at && at + "-" + (ke(et) ? et : Te(_(et)));
    return qe(et, v({}, $e, {
      attrs: Ue,
      componentId: Ke
    }), u);
  }, Object.defineProperty(Ze, "defaultProps", {
    get: function() {
      return this._foldedDefaultProps;
    },
    set: function(et) {
      this._foldedDefaultProps = l ? Me({}, o.defaultProps, et) : et;
    }
  }), process.env.NODE_ENV !== "production" && (Oe(ye, Fe), Ze.warnTooManyClasses = function(et, at) {
    var $e = {}, Ke = !1;
    return function(tt) {
      if (!Ke && ($e[tt] = !0, Object.keys($e).length >= 200)) {
        var ut = at ? ' with the id of "' + at + '"' : "";
        console.warn("Over 200 classes were generated for component " + et + ut + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), Ke = !0, $e = {};
      }
    };
  }(ye, Fe)), Ze.toString = function() {
    return "." + Ze.styledComponentId;
  }, h && y(Ze, o, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), Ze;
}
var He = function(o) {
  return function s(u, l, h) {
    if (h === void 0 && (h = E), !reactIsExports.isValidElementType(l))
      return j(1, String(l));
    var m = function() {
      return u(l, h, Ce.apply(void 0, arguments));
    };
    return m.withConfig = function(C) {
      return s(u, l, v({}, h, {}, C));
    }, m.attrs = function(C) {
      return s(u, l, v({}, h, {
        attrs: Array.prototype.concat(h.attrs, C).filter(Boolean)
      }));
    }, m;
  }(qe, o);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(o) {
  He[o] = He(o);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const styled = He, Wrapper = styled.div`
  width: ${({
  useFullSize: o
}) => o ? "100%" : "auto"};
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`, LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`, PromptoLoader = ({
  width: o = 80,
  height: s = 80,
  className: u,
  dataTestId: l,
  useFullSize: h = !0
}) => /* @__PURE__ */ jsx(Wrapper, {
  "data-testid": l,
  className: u,
  useFullSize: h,
  children: /* @__PURE__ */ jsx(LoaderWrapper, {
    children: /* @__PURE__ */ jsx("img", {
      src: Animation,
      width: o,
      height: s,
      alt: ""
    })
  })
});
export {
  IdealImage,
  PdfLoader,
  PdfViewer,
  PromptoLoader,
  RichTextRenderer,
  ShowcaseBuilderInfoSpotIcons,
  ShowcaseBuilderNavigationSpotIcons,
  calculateElementSizeInContainer$1 as calculateElementSizeInContainer,
  getBackendGeneratedHeights
};
